import React, { forwardRef, useRef, useState, useImperativeHandle, useEffect, useMemo, Component, createRef, useLayoutEffect, useCallback, useContext, memo } from 'react';
import BootstrapButton from 'react-bootstrap/Button';
import styled, { createGlobalStyle, ThemeContext, css } from 'styled-components';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import IcomoonReact from 'icomoon-react';
import dayjs from 'dayjs';
import { get as get$2, set } from 'dot-prop-immutable';
import Highcharts, { dateFormat } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import histogram from 'highcharts/modules/histogram-bellcurve';
import './images/inf-accuracy2b.jpg';
import './images/inf-accuracy3b.jpg';
import './images/inf-accuracySS.jpg';
import infAccuracy2bGrayscale from './images/inf-accuracy2b-grayscale.jpg';
import infAccuracy3bGrayscale from './images/inf-accuracy3b-grayscale.jpg';
import infAccuracySSGrayscale from './images/inf-accuracySS-grayscale.jpg';
import baseballDirt from './images/baseballdirt.jpg';
import baseballWLogo from './images/baseballwlogo.jpg';
import blankHeatMap from './images/blankheatmapstrikezone.png';
import blueSky from './images/bluesky.jpg';
import lhbImgFront from './images/generic_nobkgrd_tight_lhb_cutoff.gif';
import rhbImgFront from './images/generic_nobkgrd_tight_rhb_cutoff.gif';
import lhbImgRear from './images/generic_nobkgrd_tight_lhb_cutoff_rear.gif';
import rhbImgRear from './images/generic_nobkgrd_tight_rhb_cutoff_rear.gif';
import headshotEmptyImg from './images/headshot_empty.png';
import ifGrassZoomOutNoStripe from './images/ifgrass_zoomoutnostripe.jpg';
import ifGrass from './images/ifgrass.jpg';
import './images/search.png';
import spinnerImg from './images/search_spinner.svg';
import searchReset from './images/search_reset.svg';
import catcherThrows2B from './images/catcherThrows_2B.png';
import catcherThrows3B from './images/catcherThrows_3B.png';
import sprayChartOF from './images/3313_500x404.png';
import sprayChartIF from './images/infield_450x404.png';
import sprayChartOfGrayscale from './images/3313_500x404_grayscale.png';
import sprayChartIfGrayscale from './images/infield_450x404_grayscale.png';
import fullFieldOutlineGrayscale from './images/fullfield.png';
import sprayChartIFBW from './images/infield_134.png';
import bb18x18 from './images/bb_18x18.png';
import evLaActual from './images/ev_la_actual.png';
import evLaDifference from './images/ev_la_difference.png';
import evLaHitFx from './images/ev_la_hitfx.png';
import homeplate from './images/homeplate.png';
import batimpactlhh from './images/batimpactlhh.png';
import batimpactrhh from './images/batimpactrhh.png';
import batimpactlhhzoom from './images/batimpactlhhzoom.png';
import batimpactrhhzoom from './images/batimpactrhhzoom.png';
import battersBoxOverheadCatcher from './images/batters-box-overhead-catcher.png';
import battersBoxOverheadPitcher from './images/batters-box-overhead-pitcher.png';
import feetPointingLeft from './images/feet_pointing_left.png';
import feetPointingRight from './images/feet_pointing_right.png';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useTranslation, withTranslation, initReactI18next } from 'react-i18next';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import Image from 'react-bootstrap/Image';
import HighchartsMore from 'highcharts/highcharts-more';
import { OverlayTrigger, Tooltip, Dropdown as Dropdown$1, Form as Form$1, Row, Col, Card as Card$3, Button as Button$1, ToggleButtonGroup as ToggleButtonGroup$1, ToggleButton as ToggleButton$1, ButtonGroup } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import Highcharts$1, { isNumber as isNumber$3 } from 'highcharts/highcharts';
import Annotation from 'highcharts/modules/annotations';
import Spinner from 'react-bootstrap/Spinner';
import OverlayTrigger$1 from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import ReactDatePicker from 'react-datepicker';
import FormControl from 'react-bootstrap/FormControl';
import noUiSlider from 'nouislider';
import { CKEditor } from 'ckeditor4-react';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import timingLegendImg from './images/timing-legend.png';
import Bowser from 'bowser';
import PropTypes from 'prop-types';
import Toast from 'react-bootstrap/Toast';
import Overlay from 'react-bootstrap/Overlay';
import normalizeWheel from 'normalize-wheel';
import Badge from 'react-bootstrap/Badge';
import Row$1 from 'react-bootstrap/Row';
import Col$1 from 'react-bootstrap/Col';
import ModalDialog from 'react-bootstrap/ModalDialog';
import Container$m from 'react-bootstrap/Container';
import Card$2 from 'react-bootstrap/Card';
import searchMagnifier from './images/search_magnifier.svg';
import BrokenAxis from 'highcharts/modules/broken-axis';
import { Rect, Transformer, Ellipse as Ellipse$1, Line as Line$1, Text as Text$1, Arrow as Arrow$1, Stage as Stage$1, Layer, Image as Image$1 } from 'react-konva';
import useImage from 'use-image';
import { ReactSortable } from 'react-sortablejs';
import movementChartLeft from './images/FBMovement_chart_LHP.png';
import movementChartRight from './images/FBMovement_chart_RHP.png';
import movementMarkerTwoSeam from './images/FBMovement_marker_2S.png';
import movementMarkerFourSeam from './images/FBMovement_marker_4S.png';
import i18next from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const Button = (_a) => {
    var { children, variant = 'default', size = 'sm' } = _a, rest = __rest(_a, ["children", "variant", "size"]);
    return (React.createElement(BootstrapButton, Object.assign({ variant: variant, size: size }, rest), children));
};
const DefaultButtonAlt = (_a) => {
    var { children, size = 'sm' } = _a, rest = __rest(_a, ["children", "size"]);
    return (React.createElement(BootstrapButton, Object.assign({ size: size, style: { backgroundColor: '#C6D3DC', borderColor: 'darkgray', color: 'black' } }, rest), children));
};

/* eslint-disable */
// INSPIRED / CONVERTED FROM:
// pSBC - Shade Blend Convert - Version 4.0 - 02/18/2019
// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
// TODO: this file is very sloppy and I (BG) have done the bare minimum here to have TS stop throwing errors in this file.
// I did write pSBCr in TS, but wasn't 100% conffident on it so need someone to double check my work at some point
const pSBC = (p, c0, c1, l) => {
    let r, g, b, P, f, t, h, m = Math.round, a = typeof (c1) == "string";
    if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a))
        return null;
    h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = pSBC.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? pSBC.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
    if (!f || !t)
        return null;
    if (l)
        r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
    else
        r = m(Math.pow((P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2)), 0.5)), g = m(Math.pow((P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2)), 0.5)), b = m(Math.pow((P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2)), 0.5));
    a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
    if (h)
        return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
    else
        return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
};
pSBC.pSBCr = (d) => {
    const i = parseInt, m = Math.round;
    let n = d.length, x = { r: 0, g: 0, b: 0, a: 0 };
    if (n > 9) {
        const [r, g, b, a] = (d = d.split(','));
        n = d.length;
        if (n < 3 || n > 4)
            return null;
        x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1;
    }
    else {
        if (n == 8 || n == 6 || n < 4)
            return null;
        if (n < 6)
            d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
        d = i(d.slice(1), 16);
        if (n == 9 || n == 5)
            x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
        else
            x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
    }
    return x;
};

const buttonColor = (font, background) => `
    color: ${font};
    background-color: ${background};
    border-color: ${pSBC(-0.1, background)};
    &:hover {
        background-color: ${pSBC(-0.1, background)};
        border-color: ${pSBC(-0.2, background)};
    }
    &:active {
        background-color: ${pSBC(-0.2, background)};
        border-color: ${pSBC(-0.3, background)};
    }
`;

// color names from http://chir.ag/projects/name-that-color
var theme = {
    font: {
        body: "'Amble', sans-serif !important",
        header: "'Aleo', serif",
    },
    fontSize: {
        nav: '13px',
    },
    fontColors: {
        mineShaft: '#333333',
        tundora: '#454545',
        doveGray: '#737373',
        dodgerBlue: '#3292FF',
        sanMarino: '#3A6A9C',
        anakiwa: '#98CBFF',
        silverChalice: '#A6A6A6',
        silver: '#C6C6C6',
        darkBlue: '#154488',
        cerulean: '#0077d9',
        metallicBlue: '#204b76',
    },
    spacing: {
        body: '0.425px',
        header: '0.2px',
    },
    margin: {
        body: '1em',
    },
    border: {
        alto: '#CECECE',
        bombay: '#ADB0B2',
        paleSky: '#637785',
        mercury: '#E1E1E1',
    },
    background: {
        concrete: '#F3F3F3',
        geyser: '#C6D3DC',
        gallery: '#EDEDED',
        solitude: '#E5F4FF',
        mariner: '#2877D9',
        astronaut: '#244C74',
        codGray: '#111111',
        success: '#28A745',
        boulder: '#767676',
        blueZodiac: '#132448',
        firefly: '#0D1932',
        cerulean: '#0077d9',
        cello: '#1C3B5C',
        endeavour: '#005A9C',
        red: '#FF0000',
        tangerine: '#F78D00',
        darkblue: '#274D74',
        lightblue: '#98CBFD',
        white: '#FFFFFF',
    },
};
const bootstrapSm = 576;
const bootstrapMd = 768;
const bootstrapLg = 992;
const bootstrapXl = 1200;

var constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': theme,
    bootstrapSm: bootstrapSm,
    bootstrapMd: bootstrapMd,
    bootstrapLg: bootstrapLg,
    bootstrapXl: bootstrapXl
});

const StyledToggleButton$1 = styled(ToggleButton) `
    &&&.btn { 
        &&&.active {
            ${buttonColor('white', theme.background.mariner)};
        }
        &&&.disabled {
            ${buttonColor(theme.background.codGray, theme.background.concrete)};
        }
        ${buttonColor('black', theme.background.geyser)};
    }
`;
const StyledButtonGroup$1 = styled(ToggleButtonGroup) `
    ${(props) => (props.$separated ? `
        &&&& {
            > ${StyledToggleButton$1} {
                &:not(:last-child) {
                    border-top-right-radius: 0.25rem;
                    border-bottom-right-radius: 0.25rem;
                    margin-right: 7px;
                }
                &:not(:first-child) {
                    border-top-left-radius: 0.25rem;
                    border-bottom-left-radius: 0.25rem;
                }
            }
        }
    ` : '')}
    .btn-check:checked + .btn {
        ${buttonColor('white', theme.background.mariner)};
    }
`;
const ToggleButtons = (_a) => {
    var { options, onChange, separated = false, type = 'radio', name } = _a, rest = __rest(_a, ["options", "onChange", "separated", "type", "name"]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onToggleChange = onChange ? (newVal, event) => onChange(newVal, event.currentTarget.name, event) : undefined;
    return (React.createElement(StyledButtonGroup$1, Object.assign({ "$separated": separated, onChange: onToggleChange, type: type, name: name }, rest), options.map((o) => (React.createElement(StyledToggleButton$1, { key: o.value.toString(), id: `${name}-${o.value.toString()}`, value: o.value, disabled: o.disabled }, o.name)))));
};

const boxShadow = (shadow) => `
    -webkit-box-shadow: ${shadow};
    -moz-box-shadow: ${shadow};
    box-shadow: ${shadow};
`;
const borderRadiuses = (topright = 0, bottomright = 0, bottomleft = 0, topleft = 0) => `
    -webkit-border-top-right-radius: ${topright};
    -webkit-border-bottom-right-radius: ${bottomright};
    -webkit-border-bottom-left-radius: ${bottomleft};
    -webkit-border-top-left-radius: ${topleft};
    -moz-border-radius-topright: ${topright};
    -moz-border-radius-bottomright: ${bottomright};
    -moz-border-radius-bottomleft: ${bottomleft};
    -moz-border-radius-topleft: ${topleft};
    border-top-right-radius: ${topright};
    border-bottom-right-radius: ${bottomright};
    border-bottom-left-radius: ${bottomleft};
    border-top-left-radius: ${topleft};
    -moz-background-clip: padding;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
`;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#Tagged_templates
const mediaTaggedLiteral = (size) => (rawStrings, ...interpolatedStrings) => `
    @media (min-width: ${size}px) {
        ${rawStrings.map((value, idx) => `${value}${interpolatedStrings[idx] || ''}`).join('')}
    }
`;
const media = (minWidthPx) => mediaTaggedLiteral(minWidthPx);
media.sm = mediaTaggedLiteral(bootstrapSm);
media.md = mediaTaggedLiteral(bootstrapMd);
media.lg = mediaTaggedLiteral(bootstrapLg);
media.xl = mediaTaggedLiteral(bootstrapXl);

var mixins = /*#__PURE__*/Object.freeze({
    __proto__: null,
    boxShadow: boxShadow,
    borderRadiuses: borderRadiuses,
    media: media
});

var IcoMoonType = "selection";
var icons = [
	{
		icon: {
			paths: [
				"M914.856 1024c-282.128 0-510.713-229.1-510.713-511.743s228.585-512.257 510.713-512.257 510.713 229.1 510.713 511.743-228.585 511.743-510.713 511.743zM1687.618 511.743c0 186.884-89.581 353.174-228.585 458.2v-916.4c139.005 105.026 228.585 271.316 228.585 458.2zM1720.052 807.256c66.928-79.799 107.085-182.765 107.085-294.998s-40.157-215.2-107.085-294.998v589.997zM107.085 807.256c-66.928-80.314-107.085-183.28-107.085-295.513s40.157-215.2 107.085-294.998v589.997zM363.986 969.943c-138.49-105.026-228.070-271.316-228.070-458.2s89.066-353.174 228.070-458.2v916.4z"
			],
			attrs: [
				{
				}
			],
			width: 1827,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 0,
			tags: [
				"yakkertech"
			]
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 2,
			id: 0,
			name: "yakkertech",
			prevSize: 32,
			code: 59681
		},
		setIdx: 0,
		setId: 5,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M128 128h768v86h-768v-86zM128 384v-86h768v86h-768zM128 554v-84h768v84h-768zM128 726v-86h768v86h-768zM128 896v-86h768v86h-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"format_align_justify"
			],
			grid: 24,
			defaultCode: 59648
		},
		attrs: [
		],
		properties: {
			id: 58,
			ligatures: "format_align_justify",
			name: "format_align_justify",
			order: 5,
			prevSize: 24,
			code: 59648
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M682 854v-172h172v172h-172zM682 598v-172h172v172h-172zM426 342v-172h172v172h-172zM682 170h172v172h-172v-172zM426 598v-172h172v172h-172zM170 598v-172h172v172h-172zM170 854v-172h172v172h-172zM426 854v-172h172v172h-172zM170 342v-172h172v172h-172z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"apps"
			],
			grid: 24,
			defaultCode: 59649
		},
		attrs: [
		],
		properties: {
			id: 59,
			ligatures: "apps",
			name: "apps",
			order: 6,
			prevSize: 24,
			code: 59649
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 1
	},
	{
		icon: {
			paths: [
				"M854 128q18 0 30 12t12 30v256q0 18-12 31t-30 13h-726q-18 0-30-13t-12-31v-256q0-18 12-30t30-12h726zM854 554q18 0 30 13t12 31v256q0 18-12 30t-30 12h-726q-18 0-30-12t-12-30v-256q0-18 12-31t30-13h726z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"view_agenda"
			],
			grid: 24,
			defaultCode: 59650
		},
		attrs: [
		],
		properties: {
			id: 60,
			ligatures: "view_agenda",
			name: "view_agenda",
			order: 7,
			prevSize: 24,
			code: 59650
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 2
	},
	{
		icon: {
			paths: [
				"M422 826l-298-58 16-86 210 42 68-346-78 30v146h-84v-200l222-94q6 0 17-2t17-2q42 0 72 42l42 68q58 102 184 102v86q-142 0-234-106l-26 128 90 84v320h-86v-256l-90-84zM576 234q-34 0-60-26t-26-60 26-59 60-25 59 25 25 59-25 60-59 26z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"running_man"
			],
			grid: 24,
			defaultCode: 59652
		},
		attrs: [
		],
		properties: {
			ligatures: "running_man",
			id: 61,
			order: 8,
			prevSize: 24,
			name: "running_man",
			code: 59652
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 3
	},
	{
		icon: {
			paths: [
				"M598 640v128h128l-214 214-214-214h128v-128h172zM982 512l-214 214v-128h-128v-172h128v-128zM384 426v172h-128v128l-214-214 214-214v128h128zM426 384v-128h-128l214-214 214 214h-128v128h-172z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"open_with"
			],
			grid: 24,
			defaultCode: 59648
		},
		attrs: [
		],
		properties: {
			ligatures: "open_with",
			id: 62,
			order: 9,
			prevSize: 24,
			name: "open_with",
			code: 59651
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 4
	},
	{
		icon: {
			paths: [
				"M768 704h-101.49l-160-160 160-160h101.49v160l224-224-224-224v160h-128c-16.974 0-33.252 6.744-45.254 18.746l-178.746 178.744-178.746-178.746c-12-12-28.28-18.744-45.254-18.744h-192v128h165.49l160 160-160 160h-165.49v128h192c16.974 0 33.252-6.742 45.254-18.746l178.746-178.744 178.746 178.744c12.002 12.004 28.28 18.746 45.254 18.746h128v160l224-224-224-224v160z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"shuffle",
				"random",
				"player"
			],
			grid: 16
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 10,
			id: 63,
			name: "shuffle",
			prevSize: 32,
			code: 59653
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 5
	},
	{
		icon: {
			paths: [
				"M128 320h640v192l256-256-256-256v192h-768v384h128zM896 704h-640v-192l-256 256 256 256v-192h768v-384h-128z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"loop",
				"repeat"
			],
			grid: 16
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 11,
			id: 64,
			name: "loop1",
			prevSize: 32,
			code: 59654
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 6
	},
	{
		icon: {
			paths: [
				"M1023.556 343.672v-229.726c0-62.708-51.016-113.726-113.726-113.726h-796.104c-62.71 0-113.726 51.018-113.726 113.726v796.106c0 62.708 51.016 113.726 113.726 113.726h796.106c62.708 0 113.726-51.016 113.726-113.726v-556.084c0.29-1.674 0.442-3.394 0.442-5.15s-0.154-3.474-0.444-5.148zM696.87 60.19h212.964c29.642 0 53.758 24.116 53.758 53.758v204.892h-266.72v-258.648zM310.67 963.812h-196.946c-29.644 0-53.758-24.116-53.758-53.758v-205.018h250.704v258.774zM310.67 645.070h-250.704v-266.262h250.704v266.262zM310.672 318.838h-250.706v-204.892c0-29.642 24.114-53.758 53.758-53.758h196.948v258.648zM636.902 963.812h-266.264v-258.774h266.264v258.774zM636.902 645.070h-266.264v-266.262h266.264v266.262zM636.902 318.838h-266.264v-258.648h266.264v258.648zM963.59 910.054c0 29.642-24.116 53.758-53.758 53.758h-212.964v-258.774h266.72v205.018zM963.59 645.070h-266.72v-266.262h266.72v266.262z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"grid"
			],
			grid: 16,
			defaultCode: 59672
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 12,
			id: 65,
			name: "grid",
			prevSize: 32,
			code: 59672
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 7
	},
	{
		icon: {
			paths: [
				"M926.89 779.781c22.217 22.217 58.239 22.217 80.45 0s22.217-58.239 0-80.45l-455.114-455.114c-22.217-22.217-58.239-22.217-80.45 0l-455.114 455.114c-22.217 22.217-22.217 58.239 0 80.45s58.239 22.217 80.45 0l414.883-414.883 414.883 414.883z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"chevron-up"
			],
			grid: 16,
			defaultCode: 59669
		},
		attrs: [
		],
		properties: {
			order: 13,
			id: 66,
			name: "chevron-up",
			prevSize: 32,
			code: 59669
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 8
	},
	{
		icon: {
			paths: [
				"M97.115 244.218c-22.217-22.217-58.237-22.217-80.453 0s-22.217 58.237 0 80.453l455.111 455.111c22.217 22.217 58.237 22.217 80.453 0l455.111-455.111c22.217-22.217 22.217-58.237 0-80.453s-58.237-22.217-80.453 0l-414.885 414.885-414.885-414.885z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"chevron-down"
			],
			grid: 16,
			defaultCode: 59670
		},
		attrs: [
		],
		properties: {
			order: 14,
			id: 67,
			name: "chevron-down",
			prevSize: 32,
			code: 59670
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 9
	},
	{
		icon: {
			paths: [
				"M362.666 128v369.15l426.666-369.15v768l-426.71-369.235 0.042 369.235h-127.998v-768h127.998z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"back"
			],
			grid: 16,
			defaultCode: 59649
		},
		attrs: [
		],
		properties: {
			order: 15,
			id: 68,
			name: "step-backward2",
			prevSize: 32,
			code: 59655
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 10
	},
	{
		icon: {
			paths: [
				"M401.631 75.38l-94.566 94.566-165.516-165.516-141.869 141.869 165.516 165.516-94.578 94.578 331.027 0.002z",
				"M614.587 948.004l94.566-94.566 165.516 165.516 141.869-141.869-165.516-165.516 94.578-94.578-331.027-0.002z",
				"M945.599 401.644l-94.566-94.566 165.516-165.516-141.869-141.869-165.516 165.516-94.578-94.578-0.002 331.027z",
				"M70.619 621.742l94.566 94.566-165.516 165.516 141.869 141.869 165.516-165.516 94.578 94.578 0.002-331.027z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"condense"
			],
			grid: 16,
			defaultCode: 59650
		},
		attrs: [
		],
		properties: {
			order: 16,
			id: 69,
			name: "shrink",
			prevSize: 32,
			code: 59656
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 11
	},
	{
		icon: {
			paths: [
				"M938.667 341.334c23.552 0 42.667 21.845 42.667 48.762v633.905h-170.667v-633.905c0-26.917 19.115-48.762 42.667-48.762h85.333zM682.667 554.668c23.552 0 42.667 21.026 42.667 46.933v422.4h-170.667v-422.4c0-25.907 19.115-46.933 42.667-46.933h85.333zM426.667 426.668c23.552 0 42.667 22.3 42.667 49.778v547.556h-170.667v-547.556c0-27.477 19.115-49.778 42.667-49.778h85.333zM170.667 640.001c23.552 0 42.667 21.504 42.667 48v336h-170.667v-336c0-26.496 19.115-48 42.667-48h85.333zM896 0.001c47.128 0 85.333 38.205 85.333 85.333s-38.205 85.333-85.333 85.333c-10.346 0-20.262-1.841-29.438-5.214l-142.456 118.712c0.807 4.713 1.227 9.559 1.227 14.502 0 47.128-38.205 85.333-85.333 85.333s-85.333-38.205-85.333-85.333l0.171 5.12-123.846-61.88c-11.814 7.808-25.683 12.757-40.623 13.859l-6.369 0.234c-13.573 0-26.406-3.169-37.799-8.807l-133.081 88.636 0.213 5.504c0 44.986-34.811 81.842-78.965 85.099l-6.369 0.234c-47.128 0-85.333-38.205-85.333-85.333s38.205-85.333 85.333-85.333c13.573 0 26.406 3.169 37.799 8.807l133.038-88.722-0.171-5.419c0-44.986 34.811-81.842 78.965-85.099l6.369-0.234c47.128 0 85.333 38.205 85.333 85.333l-0.213-5.163 123.889 61.922c11.814-7.808 25.683-12.757 40.623-13.859l6.369-0.234c10.362 0 20.292 1.847 29.48 5.229l142.414-118.727c-0.807-4.713-1.227-9.559-1.227-14.502 0-47.128 38.205-85.333 85.333-85.333z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"data"
			],
			grid: 16,
			defaultCode: 59651
		},
		attrs: [
		],
		properties: {
			order: 17,
			id: 70,
			name: "stats",
			prevSize: 32,
			code: 59657
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 12
	},
	{
		icon: {
			paths: [
				"M64 896h896v128h-896v-128zM128 512h768l-384 384-384-384zM384 512v-512h256v512h-256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"download"
			],
			grid: 16,
			defaultCode: 59653
		},
		attrs: [
		],
		properties: {
			order: 18,
			id: 71,
			name: "download",
			prevSize: 32,
			code: 59658
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 13
	},
	{
		icon: {
			paths: [
				"M742.763 589.351l178.968 178.968 102.253-102.253 0.016 357.921-357.933-0.003 102.266-102.266-178.968-178.968 153.399-153.399zM281.25 589.364l153.399 153.399-178.968 178.968 102.253 102.253-357.921 0.016 0.003-357.933 102.266 102.266 178.968-178.968zM357.934 0.017l-102.266 102.266 178.968 178.968-153.399 153.399-178.968-178.968-102.253 102.253-0.016-357.921 357.934 0.003zM1023.986 0.001l-0.003 357.933-102.266-102.266-178.968 178.968-153.399-153.399 178.968-178.968-102.253-102.253 357.921-0.016z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"expand"
			],
			grid: 16,
			defaultCode: 59654
		},
		attrs: [
		],
		properties: {
			order: 19,
			id: 72,
			name: "enlarge",
			prevSize: 32,
			code: 59659
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 14
	},
	{
		icon: {
			paths: [
				"M512 165.818l400.841 346.182-400.841 346.182v-317.322l-400.841 317.322v-692.364l400.841 317.322v-317.322z"
			],
			width: 1024,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"fast-forward"
			],
			grid: 16,
			defaultCode: 59655
		},
		attrs: [
		],
		properties: {
			order: 20,
			id: 73,
			name: "forward",
			prevSize: 32,
			code: 59660
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 15
	},
	{
		icon: {
			paths: [
				"M1024 57.297h-1024l393.967 452.415 0.004 456.992 236.062-152.896-0.076-304.060 394.042-452.452zM161.919 130.999h700.161l-305.786 351.112 0.034 291.626-88.656 57.422-0.003-349.086-305.749-351.076z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"filter-hollow"
			],
			grid: 16,
			defaultCode: 59656
		},
		attrs: [
		],
		properties: {
			order: 21,
			id: 74,
			name: "filter-hollow",
			prevSize: 32,
			code: 59661
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 16
	},
	{
		icon: {
			paths: [
				"M1024 57.296h-1024l393.967 452.415 0.004 456.992 236.062-152.896-0.076-304.060z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"filter-solid"
			],
			grid: 16,
			defaultCode: 59657
		},
		attrs: [
		],
		properties: {
			order: 22,
			id: 75,
			name: "filter-solid",
			prevSize: 32,
			code: 59662
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 17
	},
	{
		icon: {
			paths: [
				"M224.742 281.6l100.686 90.044-12.759 16.539c-30.855 40.427-47.327 88.206-47.094 138.511 0.232 15.85 1.856 31.239 5.104 46.17 0.232 1.378 0.696 2.297 0.928 3.215 0.464 1.148 0.928 2.297 1.16 3.675 3.711 15.161 7.656 26.646 12.063 36.753 0.232 0.689 0.696 1.378 1.16 2.067 0.464 0.919 1.16 2.067 1.624 3.215 6.263 13.093 12.528 24.349 19.487 34.226 0.464 0.919 1.16 1.378 1.624 2.067 0.696 0.689 1.392 1.608 1.856 2.297 8.352 11.255 16.704 21.132 25.751 29.861 0.928 0.689 1.856 1.608 3.016 2.526v0l2.552 2.067c9.511 8.729 19.024 16.309 28.999 22.97 2.087 1.378 4.408 2.526 6.496 3.905v0l3.248 1.837c9.744 5.743 19.487 10.796 29.231 15.161 4.872 2.067 9.976 3.905 15.080 5.743 9.28 3.215 18.328 5.973 27.375 8.040 6.496 1.378 13.224 2.756 19.952 3.675 1.856 0.459 3.711 0.459 5.568 0.689v0l-0.696-145.402 239.649 205.814-238.721 206.733-0.232-133.228c-6.032-0.689-12.063-1.148-18.328-2.067-6.496-0.689-13.224-1.608-19.72-2.756-4.176-0.689-8.352-1.608-12.296-2.526-9.976-2.067-18.791-4.364-27.375-6.662v0l-5.568-1.608c-159.148-47.549-266.328-187.438-266.562-348-0.231-82.693 27.608-160.792 80.503-225.798v0l16.239-19.754zM546.109-0l0.232 133.228c6.037 0.459 12.305 1.148 18.342 2.067 6.733 0.689 13.234 1.608 19.735 2.756 4.179 0.919 8.359 1.608 12.305 2.526 9.984 2.067 18.806 4.364 27.397 6.662v0l5.572 1.608c159.041 47.549 266.308 187.438 266.308 348 0.231 82.693-27.631 160.563-80.566 225.798v0l-16.252 19.754-100.765-90.044 12.77-16.539c31.111-40.427 47.364-88.435 47.132-138.511 0-15.85-1.625-31.469-4.876-46.4-0.232-1.378-0.696-2.297-0.929-3.215-0.464-1.148-0.929-2.526-1.161-3.675-3.714-14.701-7.43-26.416-12.073-36.753-0.232-0.919-0.696-1.837-1.161-2.526-0.464-0.919-0.929-1.837-1.393-2.756-6.268-13.322-12.77-24.579-19.502-34.226-0.696-0.919-1.161-1.608-1.858-2.297v0l-1.625-1.837c-7.894-11.026-16.485-20.903-25.772-30.091-0.929-0.689-1.858-1.608-3.018-2.526v0l-2.554-2.067c-9.519-8.729-19.039-16.309-29.022-22.97v0l-6.966-4.134-2.786-1.608c-9.519-5.743-19.271-10.796-29.255-15.161-4.876-2.067-9.984-3.905-15.092-5.743-8.822-3.215-17.877-5.743-27.397-8.040-6.501-1.378-13.234-2.756-19.967-3.675-1.625-0.459-3.483-0.459-5.341-0.689v0l0.464 145.631-239.838-205.814 238.909-206.733z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"loop"
			],
			grid: 16,
			defaultCode: 59658
		},
		attrs: [
		],
		properties: {
			order: 23,
			id: 76,
			name: "loop",
			prevSize: 32,
			code: 59663
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 18
	},
	{
		icon: {
			paths: [
				"M-0 64h170.666v128h-170.666v-128z",
				"M298.667 64h725.333v128h-725.332v-128z",
				"M-0 320h170.666v128h-170.666v-128z",
				"M298.667 320h725.333v128h-725.332v-128z",
				"M-0 576h170.666v128h-170.666v-128z",
				"M298.667 576h725.333v128h-725.332v-128z",
				"M-0 832h170.666v128h-170.666v-128z",
				"M298.667 832h725.333v128h-725.332v-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"menu"
			],
			grid: 16,
			defaultCode: 59659
		},
		attrs: [
		],
		properties: {
			order: 24,
			id: 77,
			name: "list2",
			prevSize: 32,
			code: 59664
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 19
	},
	{
		icon: {
			paths: [
				"M84.48 512l422.397-464.636v929.272z",
				"M0 343.041h295.677v337.917h-295.677v-337.917z",
				"M725.321 332.792l298.679 298.679-59.736 59.736-298.679-298.679 59.736-59.736z",
				"M665.585 631.471l298.679-298.679 59.736 59.736-298.679 298.679-59.736-59.736z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"mute"
			],
			grid: 16,
			defaultCode: 59660
		},
		attrs: [
		],
		properties: {
			order: 25,
			id: 78,
			name: "mute",
			prevSize: 32,
			code: 59665
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 20
	},
	{
		icon: {
			paths: [
				"M472.614 0v78.77h-315.076c-41.525 0-75.546 32.132-78.553 72.891l-0.215 5.878v708.923c0 41.525 32.132 75.546 72.891 78.553l5.878 0.215h708.923c41.525 0 75.546-32.132 78.553-72.891l0.215-5.878v-315.076h78.77v315.076c0 87.006-70.532 157.538-157.538 157.538h-708.923c-87.006 0-157.538-70.532-157.538-157.538v-708.923c0-87.006 70.532-157.538 157.538-157.538h315.076z",
				"M1008.505 443.608l-158.35-158.35-359.248 359.231-111.396-111.396 359.276-359.259-148.018-147.963 431.662-13.925-13.925 431.662z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"open-menu"
			],
			grid: 16,
			defaultCode: 59661
		},
		attrs: [
		],
		properties: {
			order: 26,
			id: 79,
			name: "open-menu",
			prevSize: 32,
			code: 59666
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 21
	},
	{
		icon: {
			paths: [
				"M855.578 512l-687.159 384v-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"play"
			],
			grid: 16,
			defaultCode: 59662
		},
		attrs: [
		],
		properties: {
			order: 27,
			id: 80,
			name: "play",
			prevSize: 32,
			code: 59667
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 22
	},
	{
		icon: {
			paths: [
				"M850.748 1024.001c79.975 0 144.808-53.937 144.808-120.471v-783.059c0-66.534-64.833-120.471-144.808-120.471h-506.828c-79.975 0-144.808 53.937-144.808 120.471l0.057 220.863h113.778l-0.057-227.556h568.889v796.444h-568.889l0.057-227.556h-113.778l-0.057 220.863c0 66.534 64.833 120.471 144.808 120.471h506.828zM426.667 739.557l341.333-227.556-341.333-227.556-0.057 170.667h-398.165v113.778h398.165l0.057 170.667z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"send-to-phone"
			],
			grid: 16,
			defaultCode: 59663
		},
		attrs: [
		],
		properties: {
			order: 28,
			id: 81,
			name: "send-to-phone",
			prevSize: 32,
			code: 59668
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 23
	},
	{
		icon: {
			paths: [
				"M732.969 76.799c47.625 0 86.232 39.733 86.232 88.747v488.107c0 49.014-38.607 88.747-86.232 88.747h-646.737c-47.625 0-86.232-39.733-86.232-88.747v-488.107c0-49.014 38.607-88.747 86.232-88.747h646.737zM716.8 179.199h-614.4v460.8h614.4v-460.8z",
				"M937.768 281.599c47.625 0 86.232 39.733 86.232 88.747v488.107c0 49.014-38.607 88.747-86.232 88.747h-646.737c-47.625 0-86.232-39.733-86.232-88.747v-488.107c0-49.014 38.607-88.747 86.232-88.747h646.737zM921.6 383.999h-614.4v460.8h614.4v-460.8z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"share"
			],
			grid: 16,
			defaultCode: 59664
		},
		attrs: [
		],
		properties: {
			order: 29,
			id: 82,
			name: "share2",
			prevSize: 32,
			code: 59671
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 24
	},
	{
		icon: {
			paths: [
				"M489.74 934.957l-489.739-422.957 489.739-422.957v845.913zM623.305 934.957v-845.913h133.565v845.913h-133.565zM890.435 934.957v-845.913h133.565v845.913h-133.565z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"step-back"
			],
			grid: 16,
			defaultCode: 59665
		},
		attrs: [
		],
		properties: {
			order: 30,
			id: 83,
			name: "step-backward",
			prevSize: 32,
			code: 59673
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 25
	},
	{
		icon: {
			paths: [
				"M534.261 89.043l489.739 422.957-489.739 422.957v-845.913zM400.696 89.043v845.913h-133.565v-845.913h133.565zM133.566 89.043v845.913h-133.565v-845.913h133.565z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"step-forward"
			],
			grid: 16,
			defaultCode: 59666
		},
		attrs: [
		],
		properties: {
			order: 31,
			id: 84,
			name: "step-forward",
			prevSize: 32,
			code: 59674
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 26
	},
	{
		icon: {
			paths: [
				"M558.545 0l0.009 130.793c174.878 21.134 313.545 159.815 334.658 334.699l130.788-0.038v93.091l-130.793 0.009c-21.132 174.862-159.79 313.52-334.653 334.653l-0.009 130.793h-93.091l0.038-130.788c-174.9-21.115-313.59-159.805-334.705-334.705l-130.788 0.038v-93.091l130.793-0.009c21.134-174.878 159.815-313.545 334.699-334.658l-0.038-130.788h93.091zM558.559 201.244l-0.014 124.574h-93.091l0.033-124.581c-136.284 20.224-244.026 127.966-264.25 264.25l124.581-0.033v93.091l-124.574 0.014c20.242 136.262 127.975 243.982 264.243 264.204l-0.033-124.581h93.091l0.014 124.574c136.262-20.242 243.982-127.975 264.204-264.243l-124.581 0.033v-93.091l124.574-0.014c-20.24-136.247-127.95-243.957-264.197-264.197z"
			],
			attrs: [
				{
					strokeLinejoin: "miter",
					strokeLinecap: "butt",
					strokeMiterlimit: "4",
					strokeWidth: 46.54545454545455
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"target"
			],
			grid: 16,
			defaultCode: 59667
		},
		attrs: [
			{
				strokeLinejoin: "miter",
				strokeLinecap: "butt",
				strokeMiterlimit: "4",
				strokeWidth: 46.54545454545455
			}
		],
		properties: {
			order: 32,
			id: 85,
			name: "target",
			prevSize: 32,
			code: 59675
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 27
	},
	{
		icon: {
			paths: [
				"M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"home",
				"house"
			],
			defaultCode: 59648,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "home, house",
			name: "home",
			order: 33,
			id: 86,
			prevSize: 32,
			code: 59676
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 28
	},
	{
		icon: {
			paths: [
				"M896 256v-128h-896v704c0 35.346 28.654 64 64 64h864c53.022 0 96-42.978 96-96v-544h-128zM832 832h-768v-640h768v640zM128 320h640v64h-640zM512 448h256v64h-256zM512 576h256v64h-256zM512 704h192v64h-192zM128 448h320v320h-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"newspaper",
				"news",
				"paper"
			],
			defaultCode: 59652,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "newspaper, news",
			name: "newspaper",
			order: 34,
			id: 87,
			prevSize: 32,
			code: 59677
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 29
	},
	{
		icon: {
			paths: [
				"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 448h448v64h-448zM256 576h448v64h-448zM256 704h448v64h-448zM256 320h448v64h-448z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-text",
				"file",
				"document",
				"list",
				"paper"
			],
			defaultCode: 59682,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "file-text, file",
			name: "file-text",
			order: 35,
			id: 88,
			prevSize: 32,
			code: 59682
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 30
	},
	{
		icon: {
			paths: [
				"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 576h448v64h-448zM256 704h448v64h-448zM320 288c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM480 384h-128c-52.8 0-96 28.8-96 64v64h320v-64c0-35.2-43.2-64-96-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"profile",
				"file",
				"document",
				"page",
				"user",
				"paper"
			],
			defaultCode: 59683,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "profile, file2",
			name: "profile",
			order: 36,
			id: 89,
			prevSize: 32,
			code: 59683
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 31
	},
	{
		icon: {
			paths: [
				"M917.806 357.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-368c-44.114 0-80 35.888-80 80v736c0 44.112 35.886 80 80 80h608c44.112 0 80-35.888 80-80v-496c0-14.332-4.372-39.35-42.194-90.924zM785.374 302.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-608c-8.672 0-16-7.328-16-16v-736c0-8.672 7.328-16 16-16 0 0 367.956-0.002 368 0v224c0 17.672 14.324 32 32 32h224v496z",
				"M602.924 42.196c-51.574-37.822-76.592-42.196-90.924-42.196h-368c-44.112 0-80 35.888-80 80v736c0 38.632 27.528 70.958 64 78.39v-814.39c0-8.672 7.328-16 16-16h486.876c-9.646-7.92-19.028-15.26-27.952-21.804z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"files-empty",
				"files",
				"documents",
				"papers",
				"pages"
			],
			defaultCode: 59685,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "files-empty, files",
			name: "files-empty",
			order: 37,
			id: 90,
			prevSize: 32,
			code: 59685
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 32
	},
	{
		icon: {
			paths: [
				"M640 256v-256h-448l-192 192v576h384v256h640v-768h-384zM192 90.51v101.49h-101.49l101.49-101.49zM64 704v-448h192v-192h320v192l-192 192v256h-320zM576 346.51v101.49h-101.49l101.49-101.49zM960 960h-512v-448h192v-192h320v640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"copy",
				"duplicate",
				"files",
				"pages",
				"papers",
				"documents"
			],
			defaultCode: 59692,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "copy, duplicate",
			name: "copy",
			order: 38,
			id: 91,
			prevSize: 32,
			code: 59692
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 33
	},
	{
		icon: {
			paths: [
				"M448 128l128 128h448v704h-1024v-832z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"folder",
				"directory",
				"category",
				"browse"
			],
			defaultCode: 59695,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "folder, directory",
			name: "folder",
			order: 39,
			id: 92,
			prevSize: 32,
			code: 59695
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 34
	},
	{
		icon: {
			paths: [
				"M832 960l192-512h-832l-192 512zM128 384l-128 576v-832h288l128 128h416v128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"folder-open",
				"directory",
				"category",
				"browse"
			],
			defaultCode: 59696,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "folder-open, directory2",
			name: "folder-open",
			order: 40,
			id: 93,
			prevSize: 32,
			code: 59696
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 35
	},
	{
		icon: {
			paths: [
				"M320 384h128v128h-128zM512 384h128v128h-128zM704 384h128v128h-128zM128 768h128v128h-128zM320 768h128v128h-128zM512 768h128v128h-128zM320 576h128v128h-128zM512 576h128v128h-128zM704 576h128v128h-128zM128 576h128v128h-128zM832 0v64h-128v-64h-448v64h-128v-64h-128v1024h960v-1024h-128zM896 960h-832v-704h832v704z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"calendar",
				"date",
				"schedule",
				"time",
				"day"
			],
			defaultCode: 59731,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "calendar, date",
			name: "calendar",
			order: 41,
			id: 94,
			prevSize: 32,
			code: 59731
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 36
	},
	{
		icon: {
			paths: [
				"M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"user",
				"profile",
				"avatar",
				"person",
				"member"
			],
			defaultCode: 59761,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "user, profile2",
			name: "user",
			order: 42,
			id: 95,
			prevSize: 32,
			code: 59761
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 37
	},
	{
		icon: {
			paths: [
				"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
				"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM896 768h-128v128h-64v-128h-128v-64h128v-128h64v128h128v64z"
			],
			width: 1024,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"user-plus",
				"user",
				"user-add",
				"profile",
				"avatar",
				"person",
				"member"
			],
			defaultCode: 59763,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "user-plus, user2",
			name: "user-plus",
			order: 43,
			id: 96,
			prevSize: 32,
			code: 59763
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 38
	},
	{
		icon: {
			paths: [
				"M64 0h384v64h-384zM576 0h384v64h-384zM952 320h-56v-256h-256v256h-256v-256h-256v256h-56c-39.6 0-72 32.4-72 72v560c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-376h128v376c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-560c0-39.6-32.4-72-72-72zM348 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32zM544 512h-64c-17.6 0-32-14.4-32-32s14.4-32 32-32h64c17.6 0 32 14.4 32 32s-14.4 32-32 32zM924 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"binoculars",
				"lookup",
				"search",
				"find"
			],
			defaultCode: 59781,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "binoculars, lookup",
			name: "binoculars",
			order: 44,
			id: 97,
			prevSize: 32,
			code: 59781
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 39
	},
	{
		icon: {
			paths: [
				"M64 192h896v192h-896zM64 448h896v192h-896zM64 704h896v192h-896z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"menu",
				"list",
				"options",
				"lines",
				"hamburger"
			],
			defaultCode: 59837,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "menu, list3",
			name: "menu",
			order: 45,
			id: 98,
			prevSize: 32,
			code: 59837
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 40
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-full",
				"rate",
				"star",
				"favorite",
				"bookmark"
			],
			defaultCode: 59865,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "star-full, rate3",
			name: "star-full",
			order: 46,
			id: 99,
			prevSize: 32,
			code: 59865
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 41
	},
	{
		icon: {
			paths: [
				"M794.317 329.694c0-56.525-45.841-102.4-102.4-102.4h-589.517c-56.559 0-102.4 45.875-102.4 102.4 0 95.744 0 268.868 0 364.612 0 56.525 45.841 102.4 102.4 102.4h589.517c56.559 0 102.4-45.875 102.4-102.4 0-95.744 0-268.868 0-364.612zM828.45 329.011l111.753-26.112c20.275-4.745 41.643 0.034 57.958 13.005 16.316 12.937 25.839 32.631 25.839 53.487v283.682c0 20.821-9.523 40.516-25.839 53.487-16.316 12.937-37.683 17.715-57.958 12.971l-111.753-26.112v-364.407z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"video-camera",
				"video",
				"media",
				"film",
				"movie"
			],
			defaultCode: 59668,
			grid: 16
		},
		attrs: [
			{
			}
		],
		properties: {
			ligatures: "video-camera, video3",
			name: "video-camera",
			order: 47,
			id: 100,
			prevSize: 32,
			code: 59678
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 42
	},
	{
		icon: {
			paths: [
				"M768 640v-128h-320v-128h320v-128l192 192zM704 576v256h-320v192l-384-192v-832h704v320h-64v-256h-512l256 128v576h256v-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"exit",
				"signout",
				"logout",
				"quit",
				"close"
			],
			defaultCode: 59924,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "exit, signout",
			name: "exit",
			order: 48,
			id: 101,
			prevSize: 32,
			code: 59924
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 43
	},
	{
		icon: {
			paths: [
				"M128 128h320v768h-320zM576 128h320v768h-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pause",
				"player"
			],
			defaultCode: 59933,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "pause2, player9",
			name: "pause",
			order: 49,
			id: 102,
			prevSize: 32,
			code: 59933
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 44
	},
	{
		icon: {
			paths: [
				"M128 896v-768h128v352l320-320v320l320-320v704l-320-320v320l-320-320v352z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"first",
				"player"
			],
			defaultCode: 59937,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "first, player13",
			name: "previous",
			order: 50,
			id: 103,
			prevSize: 32,
			code: 59937
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 45
	},
	{
		icon: {
			paths: [
				"M896 128v768h-128v-352l-320 320v-320l-320 320v-704l320 320v-320l320 320v-352z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"last",
				"player"
			],
			defaultCode: 59938,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "last, player14",
			name: "next",
			order: 51,
			id: 104,
			prevSize: 32,
			code: 59938
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 46
	},
	{
		icon: {
			paths: [
				"M864 704c-45.16 0-85.92 18.738-115.012 48.83l-431.004-215.502c1.314-8.252 2.016-16.706 2.016-25.328s-0.702-17.076-2.016-25.326l431.004-215.502c29.092 30.090 69.852 48.828 115.012 48.828 88.366 0 160-71.634 160-160s-71.634-160-160-160-160 71.634-160 160c0 8.622 0.704 17.076 2.016 25.326l-431.004 215.504c-29.092-30.090-69.852-48.83-115.012-48.83-88.366 0-160 71.636-160 160 0 88.368 71.634 160 160 160 45.16 0 85.92-18.738 115.012-48.828l431.004 215.502c-1.312 8.25-2.016 16.704-2.016 25.326 0 88.368 71.634 160 160 160s160-71.632 160-160c0-88.364-71.634-160-160-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"share",
				"social"
			],
			defaultCode: 60034,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "share2, social",
			name: "share",
			order: 52,
			id: 105,
			prevSize: 32,
			code: 60034
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 47
	},
	{
		icon: {
			paths: [
				"M440.236 635.766c-13.31 0-26.616-5.076-36.77-15.23-95.134-95.136-95.134-249.934 0-345.070l192-192c46.088-46.086 107.36-71.466 172.534-71.466s126.448 25.38 172.536 71.464c95.132 95.136 95.132 249.934 0 345.070l-87.766 87.766c-20.308 20.308-53.23 20.308-73.54 0-20.306-20.306-20.306-53.232 0-73.54l87.766-87.766c54.584-54.586 54.584-143.404 0-197.99-26.442-26.442-61.6-41.004-98.996-41.004s-72.552 14.562-98.996 41.006l-192 191.998c-54.586 54.586-54.586 143.406 0 197.992 20.308 20.306 20.306 53.232 0 73.54-10.15 10.152-23.462 15.23-36.768 15.23z",
				"M256 1012c-65.176 0-126.45-25.38-172.534-71.464-95.134-95.136-95.134-249.934 0-345.070l87.764-87.764c20.308-20.306 53.234-20.306 73.54 0 20.308 20.306 20.308 53.232 0 73.54l-87.764 87.764c-54.586 54.586-54.586 143.406 0 197.992 26.44 26.44 61.598 41.002 98.994 41.002s72.552-14.562 98.998-41.006l192-191.998c54.584-54.586 54.584-143.406 0-197.992-20.308-20.308-20.306-53.232 0-73.54 20.306-20.306 53.232-20.306 73.54 0.002 95.132 95.134 95.132 249.932 0.002 345.068l-192.002 192c-46.090 46.088-107.364 71.466-172.538 71.466z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"link",
				"chain",
				"url",
				"uri",
				"anchor"
			],
			defaultCode: 59851,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "link, chain",
			name: "link",
			order: 53,
			id: 106,
			prevSize: 32,
			code: 59851
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 48
	},
	{
		icon: {
			paths: [
				"M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pencil",
				"write",
				"edit"
			],
			defaultCode: 59671,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "pencil, write",
			name: "pencil",
			order: 54,
			id: 107,
			prevSize: 32,
			code: 59679
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 49
	},
	{
		icon: {
			paths: [
				"M665.832 327.048l-64.952-64.922-324.81 324.742c-53.814 53.792-53.814 141.048 0 194.844 53.804 53.792 141.060 53.792 194.874 0l389.772-389.708c89.714-89.662 89.714-235.062 0-324.726-89.666-89.704-235.112-89.704-324.782 0l-409.23 409.178c-0.29 0.304-0.612 0.576-0.876 0.846-125.102 125.096-125.102 327.856 0 452.906 125.054 125.056 327.868 125.056 452.988 0 0.274-0.274 0.516-0.568 0.82-0.876l0.032 0.034 279.332-279.292-64.986-64.92-279.33 279.262c-0.296 0.268-0.564 0.57-0.846 0.844-89.074 89.058-233.98 89.058-323.076 0-89.062-89.042-89.062-233.922 0-322.978 0.304-0.304 0.604-0.582 0.888-0.846l-0.046-0.060 409.28-409.166c53.712-53.738 141.144-53.738 194.886 0 53.712 53.734 53.712 141.148 0 194.84l-389.772 389.7c-17.936 17.922-47.054 17.922-64.972 0-17.894-17.886-17.894-47.032 0-64.92l324.806-324.782z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"attachment",
				"paperclip"
			],
			defaultCode: 59853,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "attachment, paperclip",
			name: "attachment",
			order: 55,
			id: 108,
			prevSize: 32,
			code: 59853
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 50
	},
	{
		icon: {
			paths: [
				"M992 384h-352v-352c0-17.672-14.328-32-32-32h-192c-17.672 0-32 14.328-32 32v352h-352c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h352v352c0 17.672 14.328 32 32 32h192c17.672 0 32-14.328 32-32v-352h352c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"plus",
				"add",
				"sum"
			],
			defaultCode: 59914,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "plus, add",
			name: "plus",
			order: 56,
			id: 109,
			prevSize: 32,
			code: 59914
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 51
	},
	{
		icon: {
			paths: [
				"M0 416v192c0 17.672 14.328 32 32 32h960c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32h-960c-17.672 0-32 14.328-32 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus",
				"subtract",
				"minimize",
				"line"
			],
			defaultCode: 59915,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "minus, subtract",
			name: "minus",
			order: 57,
			id: 110,
			prevSize: 32,
			code: 59915
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 52
	},
	{
		icon: {
			paths: [
				"M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cross",
				"cancel",
				"close",
				"quit",
				"remove"
			],
			defaultCode: 59919,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "cross, cancel",
			name: "cross",
			order: 58,
			id: 111,
			prevSize: 32,
			code: 59919
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 53
	},
	{
		icon: {
			paths: [
				"M0 0h128v1024h-128v-1024z",
				"M832 643.002c82.624 0 154.57-19.984 192-49.5v-512c-37.43 29.518-109.376 49.502-192 49.502s-154.57-19.984-192-49.502v512c37.43 29.516 109.376 49.5 192 49.5z",
				"M608 32.528c-46.906-19.94-115.52-32.528-192-32.528-96.396 0-180.334 19.984-224 49.502v512c43.666-29.518 127.604-49.502 224-49.502 76.48 0 145.094 12.588 192 32.528v-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"flag",
				"report",
				"mark"
			],
			defaultCode: 59852,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "flag, report",
			name: "flag",
			order: 59,
			id: 112,
			prevSize: 32,
			code: 59852
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 54
	},
	{
		icon: {
			paths: [
				"M321.008 1024c-68.246-142.008-31.902-223.378 20.55-300.044 57.44-83.956 72.244-167.066 72.244-167.066s45.154 58.7 27.092 150.508c79.772-88.8 94.824-230.28 82.782-284.464 180.314 126.012 257.376 398.856 153.522 601.066 552.372-312.532 137.398-780.172 65.154-832.85 24.082 52.676 28.648 141.85-20 185.126-82.352-312.276-285.972-376.276-285.972-376.276 24.082 161.044-87.296 337.144-194.696 468.73-3.774-64.216-7.782-108.528-41.55-169.98-7.58 116.656-96.732 211.748-120.874 328.628-32.702 158.286 24.496 274.18 241.748 396.622z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"fire",
				"flame",
				"hot",
				"popular"
			],
			defaultCode: 59817,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "fire, flame",
			name: "fire",
			order: 60,
			id: 113,
			prevSize: 32,
			code: 59817
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 55
	},
	{
		icon: {
			paths: [
				"M448 704h128v128h-128zM704 256c35.346 0 64 28.654 64 64v192l-192 128h-128v-64l192-128v-64h-320v-128h384zM512 96c-111.118 0-215.584 43.272-294.156 121.844s-121.844 183.038-121.844 294.156c0 111.118 43.272 215.584 121.844 294.156s183.038 121.844 294.156 121.844c111.118 0 215.584-43.272 294.156-121.844s121.844-183.038 121.844-294.156c0-111.118-43.272-215.584-121.844-294.156s-183.038-121.844-294.156-121.844zM512 0v0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"question",
				"help",
				"support"
			],
			defaultCode: 59913,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "question, help",
			name: "question",
			order: 61,
			id: 114,
			prevSize: 32,
			code: 59913
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 56
	},
	{
		icon: {
			paths: [
				"M448 304c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32z",
				"M640 768h-256v-64h64v-192h-64v-64h192v256h64z",
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"info",
				"information"
			],
			defaultCode: 59916,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "info, information",
			name: "info",
			order: 62,
			id: 115,
			prevSize: 32,
			code: 59916
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 57
	},
	{
		icon: {
			paths: [
				"M1088 128h-1024c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h1024c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM640 256h128v128h-128v-128zM832 448v128h-128v-128h128zM448 256h128v128h-128v-128zM640 448v128h-128v-128h128zM256 256h128v128h-128v-128zM448 448v128h-128v-128h128zM128 256h64v128h-64v-128zM128 448h128v128h-128v-128zM192 768h-64v-128h64v128zM768 768h-512v-128h512v128zM1024 768h-192v-128h192v128zM1024 576h-128v-128h128v128zM1024 384h-192v-128h192v128z"
			],
			width: 1152,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"keyboard",
				"typing",
				"type"
			],
			defaultCode: 59733,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "keyboard, typing",
			name: "keyboard",
			order: 63,
			id: 116,
			prevSize: 32,
			code: 59733
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 58
	},
	{
		icon: {
			paths: [
				"M864 128l-480 480-224-224-160 160 384 384 640-640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkmark",
				"tick",
				"correct",
				"accept",
				"ok"
			],
			defaultCode: 59920,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "checkmark, tick",
			name: "checkmark",
			order: 64,
			id: 117,
			prevSize: 32,
			code: 59920
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 59
	},
	{
		icon: {
			paths: [
				"M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cog",
				"gear",
				"preferences",
				"settings",
				"generate",
				"control",
				"options"
			],
			defaultCode: 59796,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "cog, gear",
			name: "cog",
			order: 65,
			id: 118,
			prevSize: 32,
			code: 59796
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 60
	},
	{
		icon: {
			paths: [
				"M576 736l96 96 320-320-320-320-96 96 224 224z",
				"M448 288l-96-96-320 320 320 320 96-96-224-224z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"embed",
				"code",
				"html",
				"xml"
			],
			defaultCode: 60031,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "embed, code",
			name: "embed",
			order: 66,
			id: 119,
			prevSize: 32,
			code: 60031
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 61
	},
	{
		icon: {
			paths: [
				"M832 736l96 96 320-320-320-320-96 96 224 224z",
				"M448 288l-96-96-320 320 320 320 96-96-224-224z",
				"M701.298 150.519l69.468 18.944-191.987 704.026-69.468-18.944 191.987-704.026z"
			],
			width: 1280,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"embed",
				"code",
				"html",
				"xml"
			],
			defaultCode: 60032,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "embed2, code2",
			name: "embed2",
			order: 67,
			id: 120,
			prevSize: 32,
			code: 60032
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 62
	},
	{
		icon: {
			paths: [
				"M192 1024h640l64-704h-768zM640 128v-128h-256v128h-320v192l64-64h768l64 64v-192h-320zM576 128h-128v-64h128v64z"
			],
			tags: [
				"bin",
				"trashcan",
				"remove",
				"delete",
				"recycle",
				"dispose"
			],
			defaultCode: 59821,
			grid: 16,
			attrs: [
			]
		},
		attrs: [
		],
		properties: {
			ligatures: "bin2, trashcan2",
			name: "bin2",
			order: 68,
			id: 121,
			prevSize: 32,
			code: 59821
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 63
	},
	{
		icon: {
			paths: [
				"M786.286 512l78.857 77.143c10.857 10.286 14.857 25.714 11.429 40-4 14.286-15.429 25.714-29.714 29.143l-107.429 27.429 30.286 106.286c4 14.286 0 29.714-10.857 40-10.286 10.857-25.714 14.857-40 10.857l-106.286-30.286-27.429 107.429c-3.429 14.286-14.857 25.714-29.143 29.714-3.429 0.571-7.429 1.143-10.857 1.143-10.857 0-21.714-4.571-29.143-12.571l-77.143-78.857-77.143 78.857c-10.286 10.857-25.714 14.857-40 11.429-14.857-4-25.714-15.429-29.143-29.714l-27.429-107.429-106.286 30.286c-14.286 4-29.714 0-40-10.857-10.857-10.286-14.857-25.714-10.857-40l30.286-106.286-107.429-27.429c-14.286-3.429-25.714-14.857-29.714-29.143-3.429-14.286 0.571-29.714 11.429-40l78.857-77.143-78.857-77.143c-10.857-10.286-14.857-25.714-11.429-40 4-14.286 15.429-25.714 29.714-29.143l107.429-27.429-30.286-106.286c-4-14.286 0-29.714 10.857-40 10.286-10.857 25.714-14.857 40-10.857l106.286 30.286 27.429-107.429c3.429-14.286 14.857-25.714 29.143-29.143 14.286-4 29.714 0 40 10.857l77.143 79.429 77.143-79.429c10.286-10.857 25.143-14.857 40-10.857 14.286 3.429 25.714 14.857 29.143 29.143l27.429 107.429 106.286-30.286c14.286-4 29.714 0 40 10.857 10.857 10.286 14.857 25.714 10.857 40l-30.286 106.286 107.429 27.429c14.286 3.429 25.714 14.857 29.714 29.143 3.429 14.286-0.571 29.714-11.429 40z"
			],
			attrs: [
				{
				}
			],
			width: 878,
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"certificate"
			],
			grid: 14
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 1,
			id: 0,
			prevSize: 28,
			code: 59649,
			name: "certificate"
		},
		setIdx: 0,
		setId: 8,
		iconIdx: 0
	}
];
var height$1 = 1024;
var metadata = {
	name: "icomoon"
};
var preferences = {
	showGlyphs: true,
	showQuickUse: true,
	showQuickUse2: true,
	showSVGs: true,
	fontPref: {
		prefix: "icon-",
		metadata: {
			fontFamily: "icomoon",
			majorVersion: 1,
			minorVersion: 0
		},
		metrics: {
			emSize: 1024,
			baseline: 6.25,
			whitespace: 50
		},
		embed: false,
		showMetadata: false
	},
	imagePref: {
		prefix: "icon-",
		png: true,
		useClassSelector: true,
		color: 0,
		bgColor: 16777215,
		classSelector: ".icon",
		name: "icomoon",
		height: 32,
		columns: 16,
		margin: 16
	},
	historySize: 50,
	showCodes: true,
	gridSize: 16
};
var iconSet = {
	IcoMoonType: IcoMoonType,
	icons: icons,
	height: height$1,
	metadata: metadata,
	preferences: preferences
};

var otherIcons = [
	{
		icon: {
			paths: [
				"M465.455 93.091c25.706 0 46.545 20.839 46.545 46.545 0 23.87-17.968 43.544-41.117 46.232l-5.428 0.313h-325.818c-23.87 0-43.544 17.968-46.232 41.117l-0.313 5.428v651.636c0 23.87 17.968 43.544 41.117 46.232l5.428 0.313h651.636c23.87 0 43.544-17.968 46.232-41.117l0.313-5.428v-320.171c0-25.706 20.839-46.545 46.545-46.545 23.87 0 43.544 17.968 46.232 41.117l0.313 5.428v320.171c0 74.365-58.132 135.152-131.432 139.399l-8.205 0.237h-651.636c-74.365 0-135.152-58.132-139.399-131.432l-0.237-8.205v-651.636c0-74.365 58.132-135.152 131.432-139.399l8.205-0.237h325.818zM781.633 42.552c56.737-56.737 148.725-56.737 205.462 0s56.737 148.725 0 205.462v0l-442.182 442.182c-5.965 5.965-13.439 10.197-21.624 12.243v0l-186.182 46.545c-34.089 8.522-64.967-22.356-56.445-56.445v0l46.545-186.182c2.046-8.184 6.278-15.658 12.243-21.624v0zM921.269 108.378c-20.382-20.382-53.429-20.382-73.811-0v0l-433.064 433.039-24.623 98.444 98.397-24.623 433.1-433.049c18.926-18.927 20.278-48.772 4.056-69.259v0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-pencil"
			],
			grid: 16
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-pencil",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 2,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M128 298.667h128v-128h85.333v128h128v85.333h-128v128h-85.333v-128h-128v-85.333zM554.667 640h341.333v85.333h-341.333v-85.333zM684.373 128h98.56l-443.307 768h-98.56l443.307-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-plus-minus"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-plus-minus",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 3,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M810.667 273.493l-60.16-60.16-238.507 238.507-238.507-238.507-60.16 60.16 238.507 238.507-238.507 238.507 60.16 60.16 238.507-238.507 238.507 238.507 60.16-60.16-238.507-238.507 238.507-238.507z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-cross"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-cross",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 4,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M44.522 89.043h1068.522v133.565h-1068.522zM44.522 445.217h1068.522v133.565h-1068.522zM44.522 801.391h1068.522v133.565h-1068.522z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-menu"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-menu",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 5,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M153.6 153.6h921.6v102.4h-921.6zM153.6 358.4h921.6v102.4h-921.6zM153.6 563.2h921.6v102.4h-921.6zM153.6 768h921.6v102.4h-921.6z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-move"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-move",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 7,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M365.714 585.143h1170.286v146.286h-1170.286zM365.714 292.571h1170.286v146.286h-1170.286zM365.714 0h1170.286v146.286h-1170.286zM365.714 877.714h1170.286v146.286h-1170.286z",
				"M0 585.143h219.429v146.286h-219.429zM0 292.571h219.429v146.286h-219.429zM0 0h219.429v146.286h-219.429zM0 877.714h219.429v146.286h-219.429z"
			],
			attrs: [
			],
			width: 1536,
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-affiliates"
			],
			grid: 0
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-affiliates",
			prevSize: 48,
			code: 0
		},
		setIdx: 0,
		setId: 8,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M843.992 147.741c2.91 6.827 5.578 15.36 8.003 25.6s3.638 19.261 3.638 27.063v162.377c0 7.802-1.698 16.335-5.093 25.6s-7.518 16.823-12.369 22.674l-62.572 80.457c-4.851 5.851-7.033 13.166-6.548 21.943s3.153 15.604 8.003 20.48l59.661 73.143c4.851 5.851 9.216 13.41 13.096 22.674s5.821 17.798 5.821 25.6v172.617c0 7.802-1.213 16.579-3.638 26.331s-5.093 18.042-8.003 24.869l-133.875 134.583c-6.791 3.901-15.279 6.827-25.465 8.777s-19.16 2.926-26.92 2.926h-630.083c-18.432 0-27.648-9.265-27.648-27.794v-968.411c0-7.802 2.668-14.385 8.003-19.749s11.884-8.046 19.645-8.046h630.083c7.761 0 16.734 1.219 26.92 3.657s18.675 5.12 25.465 8.046l133.875 134.583zM215.579 377.263h377.263v-161.684h-377.263v161.684zM215.579 754.526h377.263v-161.684h-377.263v161.684z",
				"M1318.278 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z",
				"M2414.878 146.286c2.933 6.827 5.622 15.36 8.066 25.6s3.666 19.261 3.666 27.063v798.72c0 7.802-2.689 14.141-8.066 19.017s-11.977 7.314-19.798 7.314h-203.847c-7.821 0-22.976-2.438-27.864-7.314s-11.246-11.831-11.246-19.633v-263.314c0-7.802-2.348-19.408-7.726-24.284s-14.807-9.439-22.628-9.439l-257.57 0.616c-7.821 0-17.804 3.947-23.181 8.823s-12.263 17.098-12.263 24.9v263.314c0 7.802-3.061 14.141-7.95 19.017s-20.644 7.314-28.466 7.314h-203.847c-7.821 0-14.421-2.438-19.798-7.314s-8.066-11.215-8.066-19.017v-803.109c0.978-7.802 2.444-16.091 4.4-24.869s4.4-16.579 7.333-23.406l134.92-134.583c6.844-2.926 15.154-5.608 24.931-8.046s18.576-3.657 26.397-3.657h464.888c7.821 0 16.865 1.219 27.131 3.657s18.82 5.12 25.664 8.046l134.92 134.583zM2155.789 215.579h-323.368v269.474h323.368v-269.474z",
				"M2881.225 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z",
				"M4390.278 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z",
				"M3867.442 552.564c2.916 7.777 5.59 16.526 8.020 26.248s3.646 18.471 3.646 26.248v220.19c0 7.777-1.215 16.526-3.646 26.248s-5.104 17.985-8.020 24.79l-122.138 136.047c-6.805 3.889-15.311 6.805-25.519 8.749s-19.2 2.916-26.977 2.916h-539.208c-18.471 0-27.706-9.235-27.706-27.706v-159.765c0-7.777 2.673-14.339 8.020-19.686s11.909-8.020 19.686-8.020h357.262l73.126-1.020c7.777 0 14.339-2.43 19.686-7.291s8.020-11.18 8.020-18.957v-108.137c0-7.777-2.673-14.339-8.020-19.686s-11.909-8.020-19.686-8.020l-65.835-0.293h-195.401c-7.777 0-16.526-0.972-26.248-2.916s-17.985-4.375-24.79-7.291l-134.156-165.667c-3.889-7.777-6.805-16.526-8.749-26.248s-2.916-18.471-2.916-26.248v-220.19c0-7.777 0.972-16.526 2.916-26.248s4.861-17.985 8.749-24.79l134.156-134.156c6.805-2.916 15.068-5.59 24.79-8.020s18.471-3.646 26.248-3.646h530.789c7.777 0 14.339 2.673 19.686 8.020s8.020 11.909 8.020 19.686v159.415c0 7.777-2.673 14.339-8.020 19.686s-11.909 8.020-19.686 8.020h-433.045c-7.777 0-14.339 2.43-19.686 7.291s-8.020 11.18-8.020 18.957v162.38c0 7.777 2.673 14.339 8.020 19.686s11.909 8.020 19.686 8.020h272.311c7.777 0 16.769 0.972 26.977 2.916s18.714 4.375 25.519 7.291l122.138 111.195z",
				"M4911.537 215.579c-5.037 0-7.555 2.438-7.555 7.314v203.173c0 3.901 2.518 5.851 7.555 5.851h394.836c8.059 0 14.859 2.682 20.399 8.046s8.311 11.947 8.311 19.749v159.437c0 18.53-9.57 27.794-28.71 27.794h-394.836c-5.037 0-7.555 2.438-7.555 7.314v146.899c0 4.876 2.518 7.314 7.555 7.314h503.121c8.059 0 14.859 2.682 20.399 8.046s8.311 11.947 8.311 19.749v159.94c0 7.802-2.77 14.385-8.311 19.749s-12.34 8.046-20.399 8.046h-575.717c-8.059 0-17.125-0.975-27.199-2.926s-18.636-4.876-25.688-8.777l-139.018-134.583c-4.030-6.827-7.052-15.116-9.066-24.869s-3.022-18.53-3.022-26.331v-629.029c0-7.802 1.007-16.579 3.022-26.331s5.037-18.042 9.066-24.869l139.018-134.583c7.052-2.926 15.614-5.608 25.688-8.046s19.14-3.657 27.199-3.657h575.717c8.059 0 14.859 2.682 20.399 8.046s8.311 11.947 8.311 19.749v209.144c0 7.802-2.77-33.55-8.311-28.674s-12.34 7.314-20.399 7.314h-503.121z",
				"M5845.435 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z"
			],
			attrs: [
			],
			width: 5875,
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-base"
			],
			grid: 0
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-base",
			prevSize: 48,
			code: 0
		},
		setIdx: 0,
		setId: 9,
		iconIdx: 0
	},
	{
		attrs: [
		],
		icon: {
			attrs: [
			],
			grid: 24,
			isMulticolor: false,
			isMulticolor2: false,
			paths: [
				"M512 426q34 0 60 26t26 60-26 60-60 26-60-26-26-60 26-60 60-26zM768 426q34 0 60 26t26 60-26 60-60 26-60-26-26-60 26-60 60-26zM256 426q34 0 60 26t26 60-26 60-60 26-60-26-26-60 26-60 60-26z"
			],
			tags: [
				"nyy-info"
			]
		},
		iconIdx: 601,
		properties: {
			code: 59651,
			id: 601,
			ligatures: "nyy-info",
			name: "nyy-info",
			order: 5,
			prevSize: 24
		},
		setId: 2,
		setIdx: 0
	},
	{
		attrs: [
		],
		properties: {
			code: 59652,
			id: 602,
			ligatures: "nyy-circle",
			name: "nyy-circle",
			order: 5,
			prevSize: 32
		},
		icon: {
			paths: [
				"M512 938.667c235.639 0 426.667-191.027 426.667-426.667 0-235.642-191.027-426.667-426.667-426.667-235.642 0-426.667 191.025-426.667 426.667 0 235.639 191.025 426.667 426.667 426.667z"
			],
			attrs: [
				{
					fill: "none",
					strokeLinejoin: "round",
					strokeLinecap: "round",
					strokeMiterlimit: "4",
					strokeWidth: 24
				}
			],
			grid: 0,
			tags: [
				"circle(1)"
			]
		}
	},
	{
		icon: {
			paths: [
				"M210.798 435.566C210.798 311.589 311.662 210.798 435.566 210.798C559.543 210.798 660.407 311.589 660.407 435.566C660.407 559.543 559.543 660.37 435.566 660.37C311.662 660.37 210.798 559.543 210.798 435.566ZM929.17 831.817L735.781 638.464C775.058 580.498 798.062 510.683 798.062 435.566C798.062 235.703 635.429 73.143 435.566 73.143C235.739 73.143 73.143 235.703 73.143 435.566C73.143 635.429 235.739 798.025 435.566 798.025C510.683 798.025 580.535 775.022 638.464 735.744L831.817 929.134Z"
			],
			attrs: [
				{
					fillRule: "evenodd"
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-search"
			],
			grid: 14
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-search",
			prevSize: 14,
			code: 0
		},
		setIdx: 0,
		setId: 10,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M810.667 810.667H213.333V213.333h298.667V128H213.333c-47.36 0-85.333 38.4-85.333 85.333v597.333c0 46.933 37.973 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333v-298.667h-85.333v298.667zM597.333 128v85.333h153.173l-419.413 419.413 60.16 60.16L810.667 273.493V426.667h85.333V128h-298.667z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-new-window"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-new-window",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 2,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M128 128h768v512h-256l-128 160-128-160h-256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-comment"
			],
			grid: 16
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-comment",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 11,
		iconIdx: 0
	}
];

// Additional icons added by hand to the Icomoon set
// To add any svg to this set, go to https://icomoon.io/app/#/select
// Click "Import Icons" and select the svg file. The icon should appear under "Untitled Set".
// Inspect that element and copy the path data from its <path> element "d" attr.
// Copy an element in the otherIcons.json array to create a new entry; copy the svg path into its "paths" property.
// Name the new icon something like "nyy-whatever" to differentiate it from the icomoon icons?
iconSet.icons = [...iconSet.icons, ...otherIcons];
const Icon = (_a) => {
    var { color = theme.fontColors.anakiwa, size = '2em' } = _a, rest = __rest(_a, ["color", "size"]);
    return (React.createElement(IcomoonReact, Object.assign({ className: "nyy-icon", iconSet: iconSet, color: color, size: size }, rest)));
};

const isNumber$2 = (...nums) => nums.every((n) => n !== undefined && n !== null && !isNaN(n));
const mean = (nums) => ((nums === null || nums === void 0 ? void 0 : nums.length) ? (nums.reduce((acc, x) => acc + x, 0) / nums.length) : 0);
const meanMap = (arr, key) => mean(arr === null || arr === void 0 ? void 0 : arr.map((x) => x[key]));
const inRange = (val, min, max) => Math.max(Math.min(val, max), min);
const normalizeRoundedZero = (value) => {
    if (value == null)
        return null;
    return Math.abs(value) < 0.05 ? 0 : value;
};

const ratio = (numerator, denominator) => {
    const hasInvalidArgs = !denominator || numerator === null;
    return hasInvalidArgs ? null : (numerator + 0.0) / denominator;
};
const percent = (decimal, precision = 0) => {
    let formattedNum = Number(decimal * 1000 / 10).toLocaleString(undefined, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    });
    // handle edge case of a rounded negative 0
    if (formattedNum && Number(formattedNum) === 0 && (formattedNum === null || formattedNum === void 0 ? void 0 : formattedNum.startsWith('-')))
        formattedNum = formattedNum.substring(1);
    return `${formattedNum}%`;
};
// format(value, precision)
// format(value, isRateStat)
const format = (value, arg2, useGroupingFormat = false) => {
    let formattedNum;
    if (isNumber$2(value)) {
        const isRateStat = arg2 === true;
        const precision = isRateStat ? 3 : (arg2 || 0);
        formattedNum = Number(value).toLocaleString(undefined, {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
            useGrouping: useGroupingFormat,
        });
        if (isRateStat) {
            formattedNum = formattedNum.replace('0.', '.');
        }
    }
    else {
        formattedNum = null;
    }
    // handle edge case of a rounded negative 0
    if (formattedNum && Number(formattedNum) === 0 && (formattedNum === null || formattedNum === void 0 ? void 0 : formattedNum.startsWith('-')))
        formattedNum = formattedNum.substring(1);
    return formattedNum;
};
const formatWithSuffix = (value, precision, suffix) => {
    const formattedValue = format(value, precision);
    return formattedValue === null ? null : `${formattedValue}${suffix}`;
};
const ordinalRules = new Intl.PluralRules('en', { type: 'ordinal' });
const ordinal = (value, translate = null) => {
    const integer = typeof value === 'string' ? Number.parseInt(value) : value;
    if (typeof integer !== 'number' || Number.isNaN(integer))
        return null;
    if (translate) {
        return `${translate('format.number', { count: integer, ordinal: true })}`;
    }
    const suffixId = ordinalRules.select(integer);
    if (suffixId === 'one')
        return `${value}st`;
    if (suffixId === 'two')
        return `${value}nd`;
    if (suffixId === 'few')
        return `${value}rd`;
    return `${value}th`;
};
const plusMinus = (value, emptyValue = '') => {
    if (!isNumber$2(value))
        return emptyValue;
    if (value > 0)
        return `+${value}`;
    return value.toString();
};
const normalize = (stat, denom, adjdenom) => ratio(stat * adjdenom, denom);
const degreesToClock = (degrees) => {
    // Flip direction to counterclockwise, then shift so 3:00 is 0°
    const reversedDegrees = 360 - degrees + 90;
    const normalizedDegrees = ((reversedDegrees % 360) + 360) % 360;
    const totalHours = normalizedDegrees / 30;
    let hour = Math.floor(totalHours) % 12;
    hour = hour === 0 ? 12 : hour;
    let minutes = Math.round((totalHours - Math.floor(totalHours)) * 60);
    // Handle edge case where minutes == 60
    if (minutes === 60) {
        minutes = 0;
        hour = (hour % 12) + 1;
        if (hour === 13)
            hour = 1;
    }
    // Format with leading zero
    const hourStr = hour.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    return `${hourStr}:${minutesStr}`;
};

const hits = (b1, b2, b3, hr) => (b1 + b2 + b3 + hr);
// Swing productivity scales its run value to this many in-zone swings.
const SWINGS_IN_ZONE_SCALE = 743;
const walks = (ibb, ubb) => ibb + ubb;
const totalBases = (b1, b2, b3, hr) => b1 + (2 * b2) + (3 * b3) + (4 * hr);
const avg = (b1, b2, b3, hr, ab) => ratio(hits(b1, b2, b3, hr), ab);
const obp = (b1, b2, b3, hr, ibb, ubb, hbp, sf, ab) => {
    const onBase = hits(b1, b2, b3, hr) + walks(ibb, ubb) + hbp;
    const pa = ab + walks(ibb, ubb) + hbp + sf;
    return ratio(onBase, pa);
};
const slg = (b1, b2, b3, hr, ab) => ratio(totalBases(b1, b2, b3, hr), ab);
const ops = (b1, b2, b3, hr, ibb, ubb, hbp, sf, ab) => {
    const onBase = obp(b1, b2, b3, hr, ibb, ubb, hbp, sf, ab);
    const slugging = slg(b1, b2, b3, hr, ab);
    return onBase === null && slugging === null ? null : (onBase !== null && onBase !== void 0 ? onBase : 0) + (slugging !== null && slugging !== void 0 ? slugging : 0);
};
const opsRV = (rv, pa) => {
    if (pa <= 0)
        return null;
    return 0.7592 + (3.284 * rv / pa);
};
// opsRV but with numerator multiplied by 3.9 pitches per PA; used for OPS scale from run value per pitch instead of per PA
const opsRVPitch = (rv, pitches) => {
    if (pitches <= 0)
        return null;
    return opsRV(3.9 * rv, pitches);
};
const wOBA = (b1, b2, b3, hr, roe, ubb, hbp, ibb, sh, pa) => {
    // const num = (0.72 * ubb) + (0.75 * hbp) + (0.90 * b1) + (0.92 * roe) + (1.24 * b2) + (1.56 * b3) + (1.95 * hr);
    const num = (0.696 * ubb) + (0.726 * hbp) + (0.883 * b1) + (1.246 * b2) + (1.572 * b3) + (2.01 * hr);
    return ratio(num, pa - ibb - sh);
};
const gbFb = (gb, fb, pop) => ratio(gb, fb + pop);
const cBA = (b1, b2, b3, hr, ab, so) => ratio(hits(b1, b2, b3, hr), ab - so);
const babip = (b1, b2, b3, hr, ab, so, sf) => {
    const bip = b1 + b2 + b3;
    const reached = ab - so - hr + sf;
    return ratio(bip, reached);
};
const swingPct = (sw, pf, iballs, pitchouts) => ratio(sw, pf - iballs - pitchouts);
const missPct = (sw, cn) => ratio(sw - cn, sw);
const sec = (b1, b2, b3, hr, ubb, ibb, sb, cs, ab) => {
    const secondary = totalBases(b1, b2, b3, hr) - hits(b1, b2, b3, hr) + walks(ibb, ubb) + sb - cs;
    return ratio(secondary, ab);
};

const perXIP = (stat, outs, innings) => normalize(stat * 3.0, outs, innings);
const perIP = (stat, outs) => perXIP(stat, outs, 1);
const per9IP = (stat, outs) => perXIP(stat, outs, 9);
const per100IP = (stat, outs) => perXIP(stat, outs, 100);
const extraStrikesPer100 = (expstk, tkstk, tk) => {
    if (tk === 0)
        return null;
    return -1 * (100 * (expstk - tkstk) / tk);
};
const era = (er, outs) => normalize(er, outs, 27);
const whip = (b1, b2, b3, hr, ubb, outs) => perIP(b1 + b2 + b3 + hr + ubb, outs);
const rvERA = (rv) => {
    if (!rv)
        return null;
    return 4.4695 + (-136.900000 * rv);
};
const hitFxEra = (rvHitFx, pa) => {
    if (!pa)
        return null;
    const rvPerPa = rvHitFx / pa;
    return 4.6062 + (rvPerPa * 37.42133) + (rvPerPa * rvPerPa * 88.77471);
};
const rvPerN = (rv, pa, n) => {
    if (pa === 0)
        return null;
    const v = (n * rv / pa);
    if (!Number.isFinite(v))
        return null;
    return v;
};

// eslint-disable-next-line max-len
const h2hStk = (tkStk, exptkStk, opptkStk, oppexptkStk, pitches, oppPitches, adjustmentFactor = 78) => {
    if (!pitches || !tkStk || !exptkStk || pitches === 0)
        return null;
    const h2hgained = (tkStk - exptkStk) - (((opptkStk * pitches) / oppPitches) - ((oppexptkStk * pitches) / oppPitches));
    return (adjustmentFactor * h2hgained / pitches);
};
const framingStk = (tkstk, exptkstk, pitches) => {
    if (!pitches || pitches === 0)
        return null;
    return (78 * (tkstk - exptkstk) / pitches);
};
const framingRuns = (tkstk, exptkstk, pitches) => {
    const fStk = framingStk(tkstk, exptkstk, pitches);
    return fStk === null ? null : 0.113 * fStk;
};
const framingRuns120 = (tkstk, exptkstk, pitches) => {
    const fStk = framingStk(tkstk, exptkstk, pitches);
    return fStk === null ? null : fStk * 120 * 0.113;
};
const catcherAccuracyScore = (throwswLoc, greatThrows, goodThrows, precision = 2) => {
    if (throwswLoc === 0 || throwswLoc === null)
        return null;
    return (((1.0 * (goodThrows - greatThrows)) + ((2.0 * throwswLoc) - goodThrows)) / throwswLoc).toFixed(precision);
};

const lob = (b1, b2, b3, hr, ubb, ibb, hbp, r) => {
    const leftOnBase = b1 + b2 + b3 + hr + ubb + ibb + hbp - r;
    const runnersOn = b1 + b2 + b3 + ubb + ibb + hbp;
    return ratio(leftOnBase, runnersOn);
};
const xW = (rs, ra, w, l) => {
    const pct = ratio(Math.pow(rs, 1.82), (Math.pow(rs, 1.82)) + (Math.pow(ra, 1.82)));
    if (!pct)
        return null;
    return pct * (w + l);
};
const xL = (rs, ra, w, l) => {
    const pct = ratio(Math.pow(rs, 1.82), (Math.pow(rs, 1.82)) + (Math.pow(ra, 1.82)));
    if (!pct)
        return null;
    return (1 - pct) * (w + l);
};

const innings = (outs) => Math.floor(outs / 3) + (outs % 3 * 0.1);
const minInnRequirement = (currentYear) => {
    const seasonStartDate = new Date(currentYear, 3, 3);
    const diffDays = dayjs().diff(seasonStartDate, 'day', true);
    let minInn;
    if (diffDays < 0)
        minInn = 0;
    else if (diffDays > 180)
        minInn = 50;
    else
        minInn = Math.floor(diffDays / 144.0 * 50); // eslint-disable-line no-mixed-operators
    return minInn;
};

// eslint-disable-next-line max-len
const ABS_ZONE_TOP$1 = 3.22501; // our calculated average player zone top,
const ABS_ZONE_BOTTOM$1 = 1.627575; // and bottom
const ABS_ZONE_SIDE$1 = (17 / 12 / 2); // the rulebook ABS zone, half width, in feet
const BALL_RADIUS$1 = 1.45; // approx radius of a baseball in inches
const isABSStrike = (platex, platez, sztop, szbottom) => {
    if (platex === null || platex === undefined || platez === null || platez === undefined || !sztop || !szbottom)
        return null;
    const closestX = Math.max(-1 * ABS_ZONE_SIDE$1, Math.min(platex, ABS_ZONE_SIDE$1));
    const closestZ = Math.max(szbottom, Math.min(platez, sztop));
    const dx = platex - closestX;
    const dz = platez - closestZ;
    return ((Math.pow(dx, 2)) + (Math.pow(dz, 2))) <= (Math.pow((BALL_RADIUS$1 / 12), 2));
};

const BASE_STATE = [[], [1], [2], [1, 2], [3], [1, 3], [2, 3], [1, 2, 3]];
const getNewBaseStateFromSelection = (currentState, selectedBaseNum) => {
    let tempState = currentState ? [...currentState] : [];
    if (tempState.includes(selectedBaseNum))
        tempState = tempState.filter((b) => b !== selectedBaseNum);
    else
        tempState.push(selectedBaseNum);
    return BASE_STATE.findIndex((bs) => tempState.every((b) => bs.includes(b)));
};
const BaseRunners = ({ baseState, onChange, options, emptyColor = theme.background.gallery, fillColor = theme.background.cerulean, width = 60, height = 44, }) => {
    const state = isNumber$2(baseState) ? BASE_STATE[baseState] : null;
    const enabledBaseNums = [0, 1, 2, 3].reduce((acc, baseNum) => [
        ...acc, !options || options.includes(getNewBaseStateFromSelection(state, baseNum)),
    ], new Array());
    const onClick = (baseNum) => {
        if (!onChange || !enabledBaseNums[baseNum])
            return;
        const newStateIdx = getNewBaseStateFromSelection(state, baseNum);
        onChange(newStateIdx, BASE_STATE[newStateIdx]);
    };
    return (React.createElement("svg", { viewBox: "0 0 91 67", width: typeof width === 'number' ? `${width}px` : width, height: typeof height === 'number' ? `${height}px` : height },
        React.createElement("g", { id: "base-runners", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { id: "runners-on-3", onClick: () => onClick(3), fill: (state === null || state === void 0 ? void 0 : state.includes(3)) ? fillColor : emptyColor, opacity: enabledBaseNums[3] ? 1 : 0.65, transform: "translate(22.000000, 45.000000) rotate(-315.000000) translate(-22.000000, -45.000000) ", x: "7", y: "30", width: "30", height: "30", rx: "2" }),
            React.createElement("rect", { id: "runners-on-1", onClick: () => onClick(1), fill: (state === null || state === void 0 ? void 0 : state.includes(1)) ? fillColor : emptyColor, opacity: enabledBaseNums[1] ? 1 : 0.65, transform: "translate(69.000000, 45.000000) rotate(-315.000000) translate(-69.000000, -45.000000) ", x: "54", y: "30", width: "30", height: "30", rx: "2" }),
            React.createElement("rect", { id: "runners-on-2", onClick: () => onClick(2), fill: (state === null || state === void 0 ? void 0 : state.includes(2)) ? fillColor : emptyColor, opacity: enabledBaseNums[2] ? 1 : 0.65, transform: "translate(46.000000, 22.000000) rotate(-315.000000) translate(-46.000000, -22.000000) ", x: "31", y: "7", width: "30", height: "30", rx: "2" }))));
};

const optsX = [1, 2, 3, 4, 5];
const optsY = [1, 2, 3, 4, 5];
const idsInZone = ['2.2', '2.3', '2.4', '3.2', '3.3', '3.4', '4.2', '4.3', '4.4'];
const boxSize = 30;
const boxPadding = 2;
const normalizeLocations = (locs) => {
    const initNLocations = {};
    return locs === null || locs === void 0 ? void 0 : locs.reduce((acc, l) => set(acc, `${l.locationx}.${l.locationy}`, true), initNLocations);
};
const PitchLocation$1 = ({ options, onChange, locations = [], size = 158, emptyColor = theme.background.gallery, strikeZoneColor = theme.border.alto, fillColor = theme.background.cerulean, singleSelectMode = false }) => {
    const nLocs = normalizeLocations(locations);
    const nOpts = normalizeLocations(options);
    const onClick = ({ currentTarget }) => {
        const { id } = currentTarget;
        if (!onChange || (nOpts && !get$2(nOpts, id)))
            return;
        const tempLocs = set(nLocs, id, !get$2(nLocs, id));
        const newLocations = Object.keys(tempLocs).reduce((acc, x) => {
            const xVals = Object.keys(tempLocs[x])
                .filter((y) => tempLocs[x][y])
                .map((y) => ({ locationx: Number(x), locationy: Number(y) }));
            return acc.concat(xVals);
        }, new Array());
        if (singleSelectMode && locations && locations.length > 0) {
            newLocations.forEach((loc) => {
                if (locations.filter((loc2) => loc2.locationx === loc.locationx && loc2.locationy === loc.locationy).length === 0) {
                    onChange([loc]);
                }
            });
        }
        else {
            onChange(newLocations);
        }
    };
    return (React.createElement("svg", { viewBox: "0 0 158 158", width: `${size}px`, height: `${size}px` },
        React.createElement("g", { id: "pitch-location", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { id: "strike-zone", width: (boxSize * 3) + (boxPadding * 3), height: (boxSize * 3) + (boxPadding * 3), x: boxSize + (boxPadding / 2), y: boxSize + (boxPadding / 2), rx: "2", strokeWidth: boxPadding, opacity: 0.5, stroke: theme.fontColors.doveGray }),
            optsX.map((x, xIdx) => (React.createElement(React.Fragment, { key: x }, optsY.map((y, yIdx) => {
                const id = `${x}.${y}`;
                return (React.createElement("rect", { key: id, id: id, 
                    // eslint-disable-next-line no-nested-ternary
                    fill: get$2(nLocs, id) ? fillColor : idsInZone.indexOf(id) !== -1 ? strikeZoneColor : emptyColor, opacity: (!nOpts || get$2(nOpts, id)) ? 1 : 0.65, onClick: onClick, width: boxSize, height: boxSize, x: xIdx * (boxSize + boxPadding), y: yIdx * (boxSize + boxPadding), rx: "2" }));
            })))))));
};

const hasData = (x) => x !== null && x !== undefined;
const isSelectAllValue = (value) => value === -1 || !hasData(value);
const isBallInHitLocation = (data, filterVal) => {
    var _a, _b, _c, _d;
    let isInLocation = false;
    if (hasData(data.isinfieldbip) && hasData(data.angleto2b) && hasData(data.distance) && hasData(data.ishr)) {
        isInLocation = (filterVal.ishr === undefined || !!data.ishr === filterVal.ishr)
            && (((_a = filterVal.angleto2b) === null || _a === void 0 ? void 0 : _a.min) === undefined || (isNumber$2(data.angleto2b) && data.angleto2b >= filterVal.angleto2b.min))
            && (((_b = filterVal.angleto2b) === null || _b === void 0 ? void 0 : _b.max) === undefined || (isNumber$2(data.angleto2b) && data.angleto2b <= filterVal.angleto2b.max))
            && (filterVal.isinfieldbip === undefined || !!data.isinfieldbip === filterVal.isinfieldbip)
            && (((_c = filterVal.distance) === null || _c === void 0 ? void 0 : _c.min) === undefined || (isNumber$2(data.distance) && data.distance >= filterVal.distance.min))
            && (((_d = filterVal.distance) === null || _d === void 0 ? void 0 : _d.max) === undefined || (isNumber$2(data.distance) && data.distance <= filterVal.distance.max));
    }
    return isInLocation;
};
const filterPlaylistFromParams = (playlist, filter) => playlist.filter(({ data }) => {
    let meetsFilterCriteria = true;
    Object.keys(filter).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = Array.isArray(filter[key]) ? filter[key] : [filter[key]];
        if (values.length) {
            meetsFilterCriteria = meetsFilterCriteria && values.some((filterVal) => {
                var _a;
                let meetsCriteria;
                if (isSelectAllValue(filterVal)) {
                    meetsCriteria = true;
                }
                else if (key === 'pitchLocations') {
                    meetsCriteria = filterVal.locationx === data.locationx && filterVal.locationy === data.locationy;
                }
                else if (key === 'hitLocations') {
                    meetsCriteria = isBallInHitLocation(data, filterVal);
                }
                else if (key === 'inning' && filterVal === 10) { // 10+ inning
                    meetsCriteria = isNumber$2(data.inning) && data.inning >= 10;
                }
                else if (key === 'bcbefore' && filterVal === true) { // any base runners
                    meetsCriteria = !!data.bcbefore;
                }
                else if (filterVal.min || filterVal.max) {
                    const isFilterGtMin = filterVal.min === undefined || filterVal.min === null || (isNumber$2(data[key]) && data[key] >= filterVal.min);
                    const isFilterLtMax = filterVal.max === undefined || filterVal.max === null || (isNumber$2(data[key]) && data[key] <= filterVal.max);
                    meetsCriteria = isFilterGtMin && isFilterLtMax;
                }
                else if (key === 'sourceLabels') {
                    meetsCriteria = (_a = data[key]) === null || _a === void 0 ? void 0 : _a.includes(filterVal);
                }
                else {
                    meetsCriteria = data[key] === filterVal;
                }
                return meetsCriteria;
            });
        }
    });
    return meetsFilterCriteria;
});

const sections$1 = [{
        id: 'hr-center',
        ishr: true,
        angleto2b: { min: -15, max: 15 },
        path: 'M3349 5376 c-2 -2 -58 -6 -124 -9 -265 -13 -594 -73 -897 -163 -146 -43 -404 -139 -412 -152 -2 -4 32 -97 75 -207 43 -110 102 -260 131 -332 28 -73 56 -133 61 -133 5 0 73 24 151 54 233 90 486 153 766 192 178 25 633 25 815 0 71 -9 132 -19 135 -21 3 -1 26 -6 51 -9 126 -17 423 -100 597 -168 57 -22 107 -36 111 -32 10 12 261 652 261 665 0 11 -184 80 -336 128 -209 65 -464 124 -634 146 -25 3 -56 8 -70 10 -101 18 -666 44 -681 31z',
    }, {
        id: 'hr-left',
        ishr: true,
        angleto2b: { max: -15 },
        path: 'M1665 4937 c-241 -124 -417 -233 -600 -371 -360 -271 -680 -606 -928 -971 l-67 -99 237 -238 c131 -131 241 -238 245 -238 4 0 27 26 50 58 247 333 488 584 787 821 186 148 481 332 666 416 41 19 75 38 75 43 0 4 -15 46 -34 93 -18 46 -77 195 -131 332 -53 136 -102 247 -108 247 -7 -1 -93 -42 -192 -93z',
    }, {
        id: 'hr-right',
        ishr: true,
        angleto2b: { min: 15 },
        path: 'M5072 4933 c-22 -60 -81 -211 -131 -337 -50 -127 -89 -230 -88 -230 15 -4 262 -129 322 -164 462 -267 859 -622 1204 -1079 34 -46 65 -83 69 -83 4 0 114 107 245 238 l238 239 -47 69 c-331 487 -776 907 -1281 1212 -141 85 -449 242 -475 242 -9 0 -30 -39 -56 -107z',
    }, {
        id: 'center',
        isinfieldbip: false,
        angleto2b: { min: -9, max: 9 },
        path: 'M3155 4580 c-132 -17 -248 -35 -353 -56 -24 -5 -31 -11 -27 -23 2 -9 9 -38 14 -66 6 -27 37 -174 70 -325 33 -151 87 -401 121 -555 114 -524 133 -610 135 -613 1 -1 68 4 148 13 176 18 323 19 477 1 63 -7 118 -10 122 -7 7 6 39 147 139 611 22 102 55 255 74 340 19 85 52 241 75 345 22 105 44 208 50 230 5 22 6 43 2 46 -9 8 -151 34 -302 55 -178 25 -559 26 -745 4z',
    }, {
        id: 'right-center',
        isinfieldbip: false,
        angleto2b: { min: 9, max: 27 },
        path: 'M4202 4267 c-28 -133 -81 -377 -117 -542 -94 -428 -165 -758 -168 -774 -1 -10 17 -19 58 -29 290 -67 566 -178 769 -309 38 -24 72 -41 76 -36 4 4 62 109 130 233 68 124 202 369 298 545 96 176 202 369 235 430 l59 110 -34 28 c-84 70 -370 248 -524 325 -98 49 -310 137 -428 177 -110 37 -272 85 -291 85 -5 0 -34 -109 -63 -243z',
    }, {
        id: 'left-center',
        isinfieldbip: false,
        angleto2b: { min: -27, max: -9 },
        path: 'M2675 4493 c-59 -14 -286 -91 -391 -133 -138 -55 -340 -154 -470 -231 -137 -81 -363 -236 -364 -250 0 -7 62 -118 444 -794 109 -192 219 -387 245 -432 25 -46 50 -83 54 -83 5 0 52 27 106 60 191 117 436 219 651 270 128 30 122 28 116 47 -5 16 -63 281 -146 663 -40 184 -132 607 -166 763 -29 132 -29 132 -79 120z',
    }, {
        id: 'right',
        isinfieldbip: false,
        angleto2b: { min: 27 },
        path: 'M5567 3838 c-8 -13 -28 -48 -44 -78 -66 -121 -453 -827 -555 -1013 -59 -109 -108 -201 -107 -205 0 -4 47 -43 105 -87 99 -75 306 -276 406 -395 l47 -55 496 495 496 496 -67 89 c-130 174 -322 393 -451 516 -98 93 -293 259 -305 259 -4 0 -14 -10 -21 -22z',
    }, {
        id: 'left',
        isinfieldbip: false,
        angleto2b: { max: -27 },
        path: 'M1315 3774 c-121 -101 -325 -304 -443 -439 -108 -124 -272 -340 -272 -358 0 -7 221 -233 490 -502 l491 -490 27 31 c15 17 56 66 92 109 83 99 240 249 350 333 47 36 89 69 93 73 5 3 -69 143 -164 310 -568 1004 -571 1009 -573 1009 0 0 -41 -34 -91 -76z',
    }, {
        id: 'second',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { min: 0, max: 22.5 },
        path: 'M3510 2263 l0 -659 118 -13 c119 -12 275 -46 345 -76 36 -15 38 -15 46 7 5 13 26 59 46 103 20 44 82 179 137 300 56 121 124 272 153 335 29 63 83 180 119 259 36 80 66 148 66 152 0 8 -163 81 -271 120 -181 66 -431 116 -636 126 l-123 6 0 -660z',
    }, {
        id: 'short',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { min: -22.5, max: 0 },
        path: 'M3260 2909 c-195 -25 -337 -58 -498 -114 -144 -50 -312 -126 -312 -140 0 -7 63 -152 141 -321 77 -170 195 -428 261 -574 66 -146 121 -266 122 -267 1 -1 33 9 71 23 93 34 208 60 328 75 l97 11 0 659 0 659 -72 -1 c-40 -1 -102 -5 -138 -10z',
    }, {
        id: 'first',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { min: 22.5 },
        path: 'M4572 2623 c-6 -16 -65 -147 -132 -293 -119 -258 -144 -313 -304 -663 -42 -92 -76 -171 -76 -176 0 -6 28 -24 63 -41 109 -55 226 -140 324 -233 l94 -91 421 421 421 421 -39 49 c-135 169 -315 340 -485 462 -88 63 -259 171 -272 171 -3 0 -10 -12 -15 -27z',
    }, {
        id: 'third',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { max: -22.5 },
        path: 'M2298 2576 c-237 -147 -471 -357 -640 -574 l-42 -53 421 -421 420 -420 89 89 c93 92 201 174 317 237 37 21 67 39 67 41 0 4 -116 258 -284 625 -34 74 -102 224 -152 332 -49 109 -93 197 -99 198 -5 0 -49 -25 -97 -54z',
    }, {
        id: 'infield',
        isinfieldbip: true,
        distance: { max: 60 },
        path: 'M3350 1543 c-229 -36 -409 -105 -590 -226 -76 -51 -260 -222 -260 -241 0 -6 223 -234 495 -506 l495 -495 505 505 c278 278 505 509 505 513 0 18 -103 115 -200 189 -238 179 -512 270 -805 267 -66 -1 -131 -4 -145 -6z',
    }];
/* eslint-enable max-len */
const areSectionsEqual = (a, b) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return a.ishr === b.ishr && a.isinfieldbip === b.isinfieldbip
        && ((_a = a.angleto2b) === null || _a === void 0 ? void 0 : _a.min) === ((_b = b.angleto2b) === null || _b === void 0 ? void 0 : _b.min) && ((_c = a.angleto2b) === null || _c === void 0 ? void 0 : _c.max) === ((_d = b.angleto2b) === null || _d === void 0 ? void 0 : _d.max)
        && ((_e = a.distance) === null || _e === void 0 ? void 0 : _e.min) === ((_f = b.distance) === null || _f === void 0 ? void 0 : _f.min) && ((_g = a.distance) === null || _g === void 0 ? void 0 : _g.max) === ((_h = b.distance) === null || _h === void 0 ? void 0 : _h.max);
};
const HitLocationSelect = ({ onChange, data, value, width = 270, height = 209, emptyColor = theme.background.gallery, fillColor = theme.background.cerulean }) => {
    let disabledSections = {};
    if (data)
        disabledSections = sections$1.reduce((acc, s) => (Object.assign(Object.assign({}, acc), { [s.id]: data.every((x) => !isBallInHitLocation(x, s)) })), {});
    const initSelectedSections = {};
    const selectedSections = (value || []).reduce((acc, v) => {
        const section = sections$1.find((s) => areSectionsEqual(s, v));
        if (section) {
            acc[section.id] = section;
        }
        return acc;
    }, initSelectedSections);
    const onClick = (section) => {
        const selected = Object.assign(Object.assign({}, selectedSections), { [section.id]: selectedSections[section.id] ? null : section });
        const criteria = Object.keys(selected).filter((id) => selected[id]).map((id) => {
            const { ishr, isinfieldbip, angleto2b, distance } = selected[id];
            return { ishr, isinfieldbip, angleto2b, distance };
        });
        onChange(criteria);
    };
    return (React.createElement("svg", { viewBox: "0 0 700 543", width: typeof width === 'number' ? `${width}px` : width, height: typeof height === 'number' ? `${height}px` : height },
        React.createElement("g", { id: "hit-location", transform: "translate(0, 543) scale(0.1,-0.1)", fill: "none", stroke: "none" }, sections$1.map((x) => (React.createElement("path", { key: x.id, id: x.id, onClick: (disabledSections[x.id] && !selectedSections[x.id]) ? undefined : () => onClick(x), fill: selectedSections[x.id] ? fillColor : emptyColor, opacity: disabledSections[x.id] ? 0.65 : 1, d: x.path }))))));
};

/* eslint-disable max-len */
const viewBoxX = 99;
const viewBoxY = 74;
const parkRadiusX = 56;
const parkRadiusY = 64;
const ballRadius = 4;
const wallWidth = 3;
const avgWallDistanceMLB = 370.59;
const homePlateX = viewBoxX / 2;
const homePlateY = viewBoxY - 1;
const HitLocation = ({ locations, width = 99, height = 74, ballinplayx = 0, ballinplayy = 0, ishr = false }) => {
    const hitLocations = locations || [{ ballinplayx, ballinplayy, ishr }];
    return (React.createElement("svg", { viewBox: `0 0 ${viewBoxX} ${viewBoxY}`, width: typeof width === 'number' ? `${width}px` : width, height: typeof height === 'number' ? `${height}px` : height },
        React.createElement("defs", null,
            React.createElement("path", { d: "M49.5970663,0 C70.3069325,0 88.5173655,10.3479901 99.0003437,25.9885765 L49.3499162,74.0003456 L-2.08498247e-05,26.2796753 C10.4513823,10.4765151 28.7589859,0 49.5970663,0 Z", id: "path-1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-890.000000, -106.000000)" },
                React.createElement("g", { transform: "translate(0.000000, 10.000000)" },
                    React.createElement("g", { transform: "translate(12.000000, 49.000000)" },
                        React.createElement("g", { id: "chart-data" },
                            React.createElement("g", { id: "hit-location-small", transform: "translate(878.000000, 47.000000)" },
                                React.createElement("mask", { id: "mask-2", fill: "white" },
                                    React.createElement("use", { xlinkHref: "#path-1" })),
                                React.createElement("use", { fill: "#EDEDED", fillRule: "evenodd", xlinkHref: "#path-1" }),
                                React.createElement("ellipse", { stroke: theme.fontColors.silverChalice, strokeWidth: wallWidth, mask: "url(#mask-2)", cx: "50", cy: "73", rx: parkRadiusX, ry: parkRadiusY }),
                                React.createElement("ellipse", { stroke: "#737373", strokeWidth: "1", fill: theme.border.alto, fillRule: "evenodd", mask: "url(#mask-2)", cx: "50", cy: "70", rx: "31", ry: "33" }),
                                hitLocations.map(({ ballinplayx: x, ballinplayy: y, ishr: hr }) => {
                                    let scaledDistanceOfBall;
                                    const angleFrom2bRads = Math.atan2(x, y);
                                    const scaledDistanceToWall = (parkRadiusY * parkRadiusX)
                                        / Math.sqrt((Math.pow((parkRadiusY * Math.sin(angleFrom2bRads)), 2)) + (Math.pow((parkRadiusX * Math.cos(angleFrom2bRads)), 2)));
                                    if (hr) {
                                        scaledDistanceOfBall = scaledDistanceToWall + (ballRadius / 2) + wallWidth;
                                    }
                                    else {
                                        const distance = Math.sqrt((Math.pow(x, 2)) + (Math.pow(y, 2)));
                                        scaledDistanceOfBall = Math.min(distance, avgWallDistanceMLB) / avgWallDistanceMLB * scaledDistanceToWall;
                                        scaledDistanceOfBall = Math.min(scaledDistanceOfBall, scaledDistanceToWall - (ballRadius / 2) - wallWidth);
                                    }
                                    const translatedX = homePlateX + (scaledDistanceOfBall * Math.sin(angleFrom2bRads));
                                    const translatedY = homePlateY - (scaledDistanceOfBall * Math.sin((Math.PI / 2) - Math.abs(angleFrom2bRads)));
                                    return (React.createElement("g", { key: `g_${ballinplayx}_${ballinplayy}_${hr}`, strokeWidth: "1", fillRule: "evenodd", fill: theme.background.red },
                                        React.createElement("circle", { cx: translatedX, cy: translatedY, r: ballRadius })));
                                }),
                                ";"))))))));
};

var GlobalStyle = createGlobalStyle `
    .bootstrap {
        &, .form-control, .form-control:focus {
            color: ${(props) => { var _a; return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? theme.border.alto : theme.fontColors.mineShaft); }}
        }
        .form-control {
            min-height: calc(1.5em + 0.75rem + 2px);
        }

        .btn {
            &.btn-default {
                ${(props) => {
    var _a;
    return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode)
        ? buttonColor(theme.fontColors.silver, theme.fontColors.tundora)
        : buttonColor(theme.fontColors.tundora, theme.background.gallery));
}};
            }
            &.btn-primary {
                ${buttonColor('white', theme.background.mariner)};
                &.btn.dropdown-toggle::after {
                    color: white;
                }
            }
            &.btn-danger {
                ${buttonColor('white', theme.background.red)};
            }
            &.dropdown-toggle:after {
                color: ${theme.fontColors.doveGray};
            }
        }

        a {
            color: ${(props) => { var _a; return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? theme.fontColors.doveGray : theme.fontColors.cerulean); }};
            text-decoration: none;
            background-color: transparent;
        }

        a, .btn-link, .page-link {
            color: ${(props) => { var _a; return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? theme.fontColors.doveGray : theme.fontColors.cerulean); }};
            &:hover {
              color: ${(props) => {
    var _a, _b;
    return pSBC(0.45 * (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? 1 : -1), ((_b = props.theme) === null || _b === void 0 ? void 0 : _b.isDarkMode) ? theme.fontColors.doveGray : theme.fontColors.cerulean);
}};
            }
        }

        .page-item.active .page-link {
            background-color: ${theme.fontColors.dodgerBlue};
            border-color: ${theme.fontColors.dodgerBlue};
        }

        .badge {
            &.badge-primary {
                ${buttonColor('white', theme.background.endeavour)};
            }
        }

        .grid-striped {
            .row:nth-of-type(odd) {
                background-color: ${theme.background.solitude};
                padding-top: 1em;
                padding-bottom: 1em;
            }
        }

        ${(props) => {
    var _a;
    return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? `.form-control {
            border-color: ${theme.fontColors.tundora};
            &, &:focus {
                background-color: transparent;
            }
        }` : '');
}}
    }
`;

const styles = {
    pSBC,
    theme,
    mixins,
    constants,
};
// https://stackoverflow.com/a/3943023
// eslint-disable-next-line max-len
const textColorForRgbBackground = (r, g, b, lightColor, darkColor, threshold) => (((r * 0.299) + (g * 0.587) + (b * 0.114) > (threshold !== null && threshold !== void 0 ? threshold : 162)) ? (darkColor !== null && darkColor !== void 0 ? darkColor : theme.fontColors.mineShaft) : (lightColor !== null && lightColor !== void 0 ? lightColor : '#ffffff'));
// this more involved algorithm was offered as an alternative that may be more W3C compliant. but i personally preferred the results above.
// rgb = [r, g, b].map((val) => {
//     let c = val / 255.0;
//     if (c <= 0.04045) c /= 12.92; else c = ((c + 0.055) / 1.055) ** 2.4;
//     return c;
// });
// const lum = (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]);
// return lum > 0.179 ? '#000000' : '#ffffff';
const textColorForHexBackground = (hex, lightColor, darkColor, threshold) => {
    let hexval = hex !== null && hex !== void 0 ? hex : '';
    if (hexval.startsWith('#'))
        hexval = hexval.substring(1);
    if (hexval.length === 3) {
        hexval = `${hexval[0]}${hexval[0]}${hexval[1]}${hexval[1]}${hexval[2]}${hexval[2]}`;
    }
    if (hexval.length !== 6)
        return null;
    return textColorForRgbBackground(parseInt(hexval.substring(0, 2), 16), parseInt(hexval.substring(2, 4), 16), parseInt(hexval.substring(4, 6), 16), lightColor, darkColor, threshold);
};

const StyledVideoButton$1 = styled.div `
    display: inline-block;
    position: relative;
    cursor: pointer;
    > span {
        font-size: calc(${({ $size }) => (isNumber$2($size) ? `${$size}px` : $size)} * 0.33);
        color: white;
        text-transform: uppercase;
        font-weight: bold;
        position: absolute;
        top: 0;
        left: calc(${({ $size }) => (isNumber$2($size) ? `${$size}px` : $size)} * 0.12);
        height: 100%;
        display: flex;
        align-items: center;
    }
`;
const StyledTextLink = styled.div `
    color: ${({ $color }) => $color};
    cursor: pointer;
    : hover {
        text-decoration: underline;
    }
`;
const VideoButton = (_a) => {
    var _b;
    var { icon, color = styles.theme.background.astronaut, size = '2em', text, textColor, showCameraIcon = true, onClick } = _a, rest = __rest(_a, ["icon", "color", "size", "text", "textColor", "showCameraIcon", "onClick"]);
    let iconColor = color;
    if (!iconColor && (icon === null || icon === void 0 ? void 0 : icon.toUpperCase()) === 'AB')
        iconColor = styles.theme.background.astronaut;
    const tc = (_b = textColor !== null && textColor !== void 0 ? textColor : textColorForHexBackground(color)) !== null && _b !== void 0 ? _b : '#fff';
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledVideoButton$1, Object.assign({ "$size": size, onClick: onClick }, rest),
            text && React.createElement(StyledTextLink, { "$color": tc }, text),
            showCameraIcon && React.createElement(Icon, { color: iconColor, size: size, icon: "video-camera" }),
            icon && React.createElement("span", null, icon))));
};

const StyledToggleButton = styled(ToggleButton) `
    &&&.btn { 
        &&&.active {
            ${buttonColor('white', theme.background.mariner)};
        }
        &&&.disabled {
            ${buttonColor(theme.background.codGray, theme.background.concrete)};
        }
        ${buttonColor('black', theme.background.white)};
    }
`;
const StyledButtonGroup = styled(ToggleButtonGroup) `
    ${(props) => (props.$separated ? `
        &&&& {
            > ${StyledToggleButton} {
                &:not(:last-child) {
                    border-top-right-radius: 0.25rem;
                    border-bottom-right-radius: 0.25rem;
                    margin-right: 7px;                    
                }
                &:not(:first-child) {
                    border-top-left-radius: 0.25rem;
                    border-bottom-left-radius: 0.25rem;
                }
            }
        }
    ` : '')}
    .btn-check:checked + .btn {
        ${buttonColor('white', theme.background.mariner)};
    }
    .btn {
        border: 2px solid ${theme.background.concrete} !important;
    }
`;
const IconToggleButtons = (_a) => {
    var { options, onChange, separated = false, type = 'radio', name } = _a, rest = __rest(_a, ["options", "onChange", "separated", "type", "name"]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onToggleChange = onChange ? (newVal, event) => onChange(newVal, event.currentTarget.name, event) : undefined;
    return (React.createElement(StyledButtonGroup, Object.assign({ "$separated": separated, onChange: onToggleChange, type: type, name: name }, rest), options.map((o) => (React.createElement(StyledToggleButton, { key: o.value.toString(), id: `${name}-${o.value.toString()}`, value: o.value, disabled: o.disabled, variant: o.variant },
        React.createElement(Icon, { icon: o.name, size: o.size || '1em' }))))));
};

const wristband = { width: 320, height: 380, margin: 37, padding: 0 };
const strengths2 = { width: 260, height: 325, margin: 0, padding: 0 };
const HEATMAP_MODELS = [
    { id: 126, name: 'HeatMaps' },
    { id: 127, name: 'SwingMaps' },
    { id: 128, name: 'SwingMapsByPitchType' },
    { id: 129, name: 'HeatMapsByPitchType' },
    { id: 148, name: 'HeatMapsPitcher' },
    { id: 149, name: 'PitchLocationActual' },
    { id: 216, name: 'HeatMapsPitcher2' },
    { id: 217, name: 'CatcherWristband' },
    // { id: 141, name: 'PitchingPlans' }, // deprecated may 2026
    { id: 124, name: 'DefensivePositions' },
    { id: 125, name: 'DefensivePositionsIF' },
];
const heatMapModelIds = HEATMAP_MODELS.reduce((acc, m) => (Object.assign(Object.assign({}, acc), { [m.name]: m.id })), {});
const getHeatmapSizeByType = (modelId, size) => {
    let sizes = { margin: 0, padding: 0, height: size, width: size };
    let sizeConstants;
    if (modelId === heatMapModelIds.CatcherWristband)
        sizeConstants = wristband;
    else if (modelId === heatMapModelIds.HeatMapsPitcher2)
        sizeConstants = strengths2;
    if (sizeConstants) {
        const { width, height, margin } = sizeConstants;
        const padding = (size / width) * margin;
        sizes = {
            margin,
            padding,
            height: (height / width * size) - (2 * padding),
            width: size - (2 * padding),
        };
    }
    return sizes;
};

const BaseChartContainer = styled.div `
    margin-left: auto;
    margin-right: auto;
    ${({ $width }) => ($width ? `width: ${$width}px;` : '')}
    ${({ $useBodyFont }) => ($useBodyFont ? `
        svg {
            font-family: inherit !important;
        }
    ` : '')}
`;
const BaseChart = forwardRef((_a, ref) => {
    var _b;
    var { options, width, style, useBodyFont = true, useHistogramModule = false, className = null } = _a, rest = __rest(_a, ["options", "width", "style", "useBodyFont", "useHistogramModule", "className"]);
    const { credits } = options, opts = __rest(options, ["credits"]);
    const optionsWithDefault = Object.assign(Object.assign({ credits: Object.assign({ enabled: false }, credits) }, opts), { chart: Object.assign(Object.assign({}, opts.chart), { animation: false }), plotOptions: Object.assign(Object.assign({}, opts.plotOptions), { series: Object.assign(Object.assign({}, (_b = opts.plotOptions) === null || _b === void 0 ? void 0 : _b.series), { animation: false }) }) });
    const highchartsModule = useHistogramModule ? histogram(Highcharts) : Highcharts;
    return (React.createElement(BaseChartContainer, { "$width": width, "$useBodyFont": useBodyFont, style: style, className: className },
        React.createElement(HighchartsReact, Object.assign({ ref: ref, highcharts: highchartsModule, options: optionsWithDefault }, rest))));
});
BaseChart.Container = BaseChartContainer;

const ABS_ZONE_TOP = 3.22501; // our calculated average player zone top,
const ABS_ZONE_BOTTOM = 1.627575; // and bottom
const BALL_RADIUS = 1.45; // approx radius of a baseball in inches
const ABS_ZONE_SIDE = (17 / 12 / 2); // the rulebook ABS zone, half width, in feet
const EXPANDED_ZONE_SIDE$1 = ((17 + (BALL_RADIUS * 2)) / 12 / 2); // zone plus one baseball diameter, half width, in feet
const ABS_ZONE_TOP_PCT$1 = 0.535; // the rulebook %s of height used to calculate ABS zone
const sizesWidth$2 = { xs: 110, sm: 230, lg: 350, ptloc: 240, ocsheet: 192, ocsheetsm: 192 * 0.8 };
const sizesHeight$2 = { xs: 90, sm: 230, lg: 350, ptloc: 278, ocsheet: 222, ocsheetsm: 222 * 0.8 };
const sizesAxisHeight$2 = { xs: 125, sm: 200, lg: 300, ptloc: 218, ocsheet: 160, ocsheetsm: 160 * 0.8 };
const sizesBatterWidth$1 = { xs: 21, sm: 80, lg: 120, ptloc: 103, ocsheet: 64, ocsheetsm: 64 * 0.8 };
const sizesBatterHeight$1 = { xs: 57 };
const sizesLhbPosition$2 = {
    xs: { x: 0, y: 15 },
    sm: { x: -5 },
    lg: { x: -10 },
    ptloc: { x: 0 },
    ocsheet: { x: 0 },
    ocsheetsm: { x: 0 },
};
const sizesRhbPosition$2 = {
    xs: { x: 88, y: 15 },
    sm: { x: 145 },
    lg: { x: 220 },
    ptloc: { x: 134 },
    ocsheet: { x: 125 },
    ocsheetsm: { x: 125 * 0.8 },
};
const LOCAL_STORAGE_CHARTLEGEND_KEY$1 = 'chart_legend';
const sizes$2 = {
    width: sizesWidth$2,
    height: sizesHeight$2,
    axisheight: sizesAxisHeight$2,
    batterwidth: sizesBatterWidth$1,
    batterheight: sizesBatterHeight$1,
    lhbposition: sizesLhbPosition$2,
    rhbposition: sizesRhbPosition$2,
};
const StrikeZone$3 = forwardRef(({ size = 'lg', enableZoom = true, minX = -2.25, maxX = 2.25, minY = 0.25, maxY = 4.75, height, showbatter = true, showlhb = false, showlegend = false, legendposition = 'float', yopposite = false, seriesData, showSeries = true, showoffgrid = true, sztop = ABS_ZONE_TOP, szbottom = ABS_ZONE_BOTTOM, useABSRulebookZone = false, useBaseballMarkers = false, useCustomNonCircleMarkerRadius = false, contourPoints, useContours = false, pitcherView = true, pointshrinkcutoff = 250, heatMapBackground, showHeatMapBackground = true, heatMapBackground2, heatMapBackgroundOpacity, showHeatMapBackground2 = true, modalContainer, pitchVideoFn, multiVideoFn, videoPlayerModal: VideoPlayerModal, exportPlaylistCallback, onClick, hideGrid, showStrikeZone = true, hideAxis = false, legendClickFn, customLegend, preventLegendSeriesHover = false, ignoreLocalStorageChartLegend = true, tooltipFormatter, }, outerRef) => {
    const ref = useRef(null);
    const [series, updateSeries] = useState(onSeriesAssignment(seriesData));
    const [elements, setElements] = useState({});
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const getZoneSide = () => (useABSRulebookZone ? ABS_ZONE_SIDE : EXPANDED_ZONE_SIDE$1);
    const getZoneTop = () => (sztop + (useABSRulebookZone ? 0 : (BALL_RADIUS / 12)));
    const getZoneBottom = () => (szbottom - (useABSRulebookZone ? 0 : (BALL_RADIUS / 12)));
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    // Update state when prop changes through
    useEffect(() => {
        var _a;
        redraw();
        updateSeries(showSeries ? onSeriesAssignment(fixOffGridPoints(((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null, seriesData)) : []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, contourPoints, useContours, seriesData, showSeries, showHeatMapBackground, showHeatMapBackground2, pitcherView, sztop, szbottom, useABSRulebookZone]);
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (!chart)
            return;
        if (showStrikeZone)
            renderStrikeZone(chart);
        renderHeatMapBackground(chart);
        renderBatter(chart);
        if (useContours)
            showContourPoints(chart);
    }
    const legendConfig = Object.assign({ enabled: showlegend }, customLegend);
    if (customLegend === null || customLegend === undefined) {
        if (legendposition === 'float') {
            legendConfig.align = 'right';
            legendConfig.verticalAlign = 'top';
            legendConfig.layout = 'vertical';
            legendConfig.floating = true;
            legendConfig.x = -16;
            legendConfig.y = 10;
        }
        else if (legendposition === 'below') {
            legendConfig.align = 'center';
            legendConfig.floating = true;
            if (size && size !== 'lg') {
                legendConfig.itemDistance = 10;
                legendConfig.width = '100%';
            }
            if (size === 'sm') {
                legendConfig.itemWidth = 100;
                legendConfig.itemStyle = {
                    fontSize: '10px',
                };
                legendConfig.margin = 0;
            }
        }
    }
    function onSeriesAssignment(_series) {
        var _a;
        const axisHeightPx = (_a = sizesAxisHeight$2[size]) !== null && _a !== void 0 ? _a : 200;
        const pixelsPerFoot = axisHeightPx / (maxY - minY);
        const baseballRadiusPx = (BALL_RADIUS / 12) * pixelsPerFoot;
        const numScatterPoints = _series
            .filter((s) => !s.type || s.type === 'scatter')
            .map((x) => (x.data ? x.data.length : 0))
            .reduce((a, b) => a + b, 0);
        return _series.map((s) => {
            var _a, _b;
            const mappedSeries = Object.assign(Object.assign({}, s), { data: (_a = s.data) === null || _a === void 0 ? void 0 : _a.filter((d) => isNumber$2(d.x, d.y)).map((d) => (pitcherView ? d : Object.assign(Object.assign({}, d), { x: d.x * -1 }))) });
            if (!s.type || s.type === 'scatter') {
                const isCircleMarker = !((_b = mappedSeries.marker) === null || _b === void 0 ? void 0 : _b.symbol) || mappedSeries.marker.symbol === 'circle';
                if (useBaseballMarkers && (isCircleMarker || !useCustomNonCircleMarkerRadius)) {
                    mappedSeries.marker = Object.assign(Object.assign({}, mappedSeries.marker), { radius: baseballRadiusPx });
                }
                else if (numScatterPoints > pointshrinkcutoff) {
                    mappedSeries.marker = Object.assign(Object.assign({}, mappedSeries.marker), { radius: !mappedSeries.marker ? 2 : Math.max(1, mappedSeries.marker.radius - 2) });
                }
            }
            return mappedSeries;
        });
    }
    function renderBatter(chart) {
        let batterImg;
        let batterPosition;
        if (pitcherView) {
            batterImg = showlhb ? lhbImgFront : rhbImgFront;
            batterPosition = showlhb ? 'lhb' : 'rhb';
        }
        else {
            batterImg = showlhb ? lhbImgRear : rhbImgRear;
            batterPosition = showlhb ? 'rhb' : 'lhb';
        }
        let x;
        let y;
        let w;
        let h;
        if (size === 'xs') {
            x = sizes$2[`${batterPosition}position`][size].x;
            y = sizes$2[`${batterPosition}position`][size].y;
            w = sizes$2.batterwidth[size];
            h = sizes$2.batterheight[size];
        }
        else {
            x = sizes$2[`${batterPosition}position`][size].x;
            w = sizes$2.batterwidth[size];
            // assume batter is 6' tall
            h = chart.yAxis[0].toPixels(0, false) - chart.yAxis[0].toPixels(6.0, false);
            // and scale to the ratio of given zone top to default zone top
            if (sztop) {
                const scalar = (sztop * (1 / ABS_ZONE_TOP_PCT$1)) / (ABS_ZONE_TOP * (1 / ABS_ZONE_TOP_PCT$1));
                h *= scalar;
            }
            y = chart.yAxis[0].toPixels(0, false) - h;
        }
        const imgattr = {
            zIndex: 2,
            opacity: 0.4,
        };
        if (elements.batterRender) {
            elements.batterRender.element.remove();
        }
        if (showbatter) {
            elements.batterRender = chart.renderer
                .image(batterImg, x, y, w, h)
                .attr(imgattr)
                .add();
        }
        setElements(elements);
    }
    function showContourPoints(chart) {
        if (!(contourPoints === null || contourPoints === void 0 ? void 0 : contourPoints.length))
            return;
        const xmultiplier = pitcherView ? -1 : 1;
        const path = new Array();
        path.push('M');
        path.push(chart.xAxis[0].toPixels(xmultiplier * contourPoints[0].platex, false));
        path.push(chart.yAxis[0].toPixels(contourPoints[0].platez, false));
        path.push('L');
        for (let i = 1; i < contourPoints.length; i += 25) {
            path.push(chart.xAxis[0].toPixels(xmultiplier * contourPoints[i].platex, false));
            path.push(chart.yAxis[0].toPixels(contourPoints[i].platez, false));
        }
        path.push('Z');
        if (elements.szcontour) {
            elements.szcontour.element.remove();
        }
        elements.szcontour = chart.renderer.path(path)
            .attr({
            'stroke-width': 1,
            stroke: 'rgba(255,128,128,.7)',
            fill: 'rgba(255,128,128,.05)',
            zIndex: 2,
        })
            .add();
        setElements(elements);
    }
    function fixOffGridPoints(chart, _series) {
        if (!chart || !showoffgrid)
            return _series;
        const xrange = chart.xAxis[0].getExtremes();
        const yrange = chart.yAxis[0].getExtremes();
        for (let i = 0; i < _series.length; i += 1) {
            if (!isNaN(parseInt(showoffgrid.toString()))) {
                if (parseInt(showoffgrid.toString()) !== i) {
                    continue; // eslint-disable-line no-continue
                }
            }
            if (_series[i].data.length > 0) {
                for (let j = 0; j < _series[i].data.length; j += 1) {
                    const point = _series[i].data[j];
                    if (isNumber$2(point.x, point.y) && (point.x < xrange.min || xrange.max < point.x || point.y <= yrange.min || yrange.max <= point.y)) {
                        /* eslint-disable no-param-reassign, no-nested-ternary */
                        _series[i].data[j].x = (point.x <= xrange.min ? xrange.min + 0.05 : (xrange.max < point.x ? xrange.max - 0.05 : point.x));
                        _series[i].data[j].y = (point.y <= yrange.min ? yrange.min + 0.05 : (yrange.max < point.y ? yrange.max - 0.05 : point.y));
                        /* eslint-enable no-param-reassign, no-nested-ternary */
                    }
                }
            }
        }
        return _series;
    }
    function renderStrikeZone(chart) {
        if (elements.strikeZone) {
            elements.strikeZone.forEach((el) => {
                el.element.remove();
            });
        }
        const x = chart.xAxis[0].toPixels(-1 * getZoneSide(), false); // for some reason we have to add these offsets
        const y = chart.yAxis[0].toPixels(getZoneTop(), false); // for some reason we have to add these offsets
        const h = chart.yAxis[0].toPixels(getZoneBottom(), false) - chart.yAxis[0].toPixels(getZoneTop(), false);
        const w = chart.xAxis[0].toPixels(getZoneSide(), false) - chart.xAxis[0].toPixels(-1 * getZoneSide(), false);
        const rectattr = {
            'stroke-width': 1,
            stroke: '#979595',
            fill: 'none',
            zIndex: 1,
        };
        const szoverall = chart.renderer.rect(x, y, w, h, 0).attr(rectattr).add();
        const szv1 = chart.renderer.rect(x, y, (w / 3.0), h, 0).attr(rectattr).add();
        const szv2 = chart.renderer.rect(x, y, 2 * (w / 3.0), h, 0).attr(rectattr).add();
        const szh1 = chart.renderer.rect(x, y, w, (h / 3.0), 0).attr(rectattr).add();
        const szh2 = chart.renderer.rect(x, y, w, 2 * (h / 3.0), 0).attr(rectattr).add();
        elements.strikeZone = [szoverall, szv1, szv2, szh1, szh2];
        setElements(elements);
    }
    function renderHeatMapBackground(chart) {
        if (elements.heatMap) {
            elements.heatMap.element.remove();
        }
        if (elements.heatMap2) {
            elements.heatMap2.element.remove();
        }
        if (heatMapBackground || heatMapBackground2) {
            const imgattr = {
                zIndex: -1,
                opacity: heatMapBackgroundOpacity || (hideGrid ? 0.75 : 0.45),
            };
            // set position and size based on known real-world space of the heatmap images,
            // slightly less than 4' by 5'
            const x1 = chart.xAxis[0].toPixels(-2, false);
            const x2 = chart.xAxis[0].toPixels(1.979899, false);
            const yTop = chart.yAxis[0].toPixels(4.974874, false);
            const yBtm = chart.yAxis[0].toPixels(0, false);
            const heatMap = heatMapBackground && showHeatMapBackground ? chart.renderer
                .image(heatMapBackground, x1, yTop, x2 - x1, yTop - yBtm)
                .attr(imgattr)
                .add() : undefined;
            elements.heatMap = heatMap;
            if (heatMap && !pitcherView) {
                // flip heatmap image if from batter view
                const cx = x1 + ((x2 - x1) / 2);
                const cy = yTop + yTop - (yBtm / 2);
                heatMap.attr({
                    transform: `translate(${cx}, ${cy}) scale(-1, 1) translate(${-cx}, ${-cy})`,
                });
            }
            const imgattr2 = {
                zIndex: 1,
                opacity: hideGrid ? 0.5 : 0.25,
            };
            const heatMap2 = heatMapBackground2 && showHeatMapBackground2 ? chart.renderer
                .image(heatMapBackground2, x1, yTop, x2 - x1, yBtm - yTop)
                .attr(imgattr2)
                .add() : undefined;
            elements.heatMap2 = heatMap2;
            if (heatMap2 && !pitcherView) {
                // flip heatmap image if from batter view
                const cx = x1 + ((x2 - x1) / 2);
                const cy = yTop + yTop - (yBtm / 2);
                heatMap2.attr({
                    transform: `translate(${cx}, ${cy}) scale(-1, 1) translate(${-cx}, ${-cy})`,
                });
            }
            setElements(elements);
        }
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const fetchMultiVideo = (pitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const pitchIds = pitches
                .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
                .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
            const playlist = yield multiVideoFn(pitchIds);
            setVideoPlaylist(playlist);
        }
        catch (_b) {
            closePitchVideo();
        }
    });
    let margin;
    if (size === 'ptloc')
        margin = showlhb ? [45, 0, 8, 37] : [45, 0, 8, -13];
    else if (size === 'xs')
        margin = [-18, 0, 0, -7];
    else
        margin = [0, 0, 0, 17];
    const hideChartTicksAndGrids = /* hideGrid || */ ['ptloc', 'xs'].includes(size);
    if (!ignoreLocalStorageChartLegend) {
        const legendJson = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_CHARTLEGEND_KEY$1) || '[]');
        series.forEach((x) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const leg = legendJson.find((y) => y.id === x.id);
            if (leg != null)
                x.visible = leg.visible;
        });
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            height: height || sizes$2.height[size],
            width: sizes$2.width[size],
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            spacing: hideChartTicksAndGrids ? [0, 0, 0, 0] : [10, 10, 15, 10],
            margin,
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.filter((s) => s.visible).flatMap((s) => s.points.filter((point) => {
                            const { enabled, x, y } = point;
                            return enabled !== false && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            fetchMultiVideo(points.map((p) => ({
                                gameid: p.gameid,
                                pitchseq: p.pitchseq,
                                eventseq: p.eventseq,
                            })));
                        }
                    }
                    return false; // Don't zoom
                },
            },
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                turboThreshold: 0,
                dataLabels: {
                    allowOverlap: true,
                    // padding: 2,
                    crop: false,
                    overflow: 'justify',
                },
                point: {
                    events: {
                        click: function click() {
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                if (onClick)
                                    return onClick(this);
                                if (pitchVideoFn)
                                    return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                            return null;
                        },
                    },
                },
                events: {
                    legendItemClick(e) {
                        const chart = this.chart.legend.allItems;
                        if (chart !== undefined && !ignoreLocalStorageChartLegend) {
                            window.localStorage.setItem(LOCAL_STORAGE_CHARTLEGEND_KEY$1, JSON.stringify(chart.map((ch) => ({
                                id: ch.options.id,
                                visible: this.index === ch.index ? !ch.visible : ch.visible,
                                name: ch.name,
                            }))));
                        }
                        if (legendClickFn) {
                            const returnLegend = [];
                            const thisLegendItem = e.target;
                            returnLegend.push(Object.assign(Object.assign({}, thisLegendItem), { visible: !thisLegendItem.visible }));
                            this.chart.series.filter((x) => x.index !== thisLegendItem.index).forEach((x) => {
                                if (x.visible) {
                                    returnLegend.push(Object.assign({}, x));
                                }
                                else {
                                    returnLegend.push(Object.assign({}, x));
                                }
                            });
                            legendClickFn(returnLegend);
                        }
                        return this;
                    },
                },
                states: {
                    inactive: {
                        opacity: preventLegendSeriesHover ? 1 : 0.2,
                    },
                },
            },
        },
        legend: legendConfig,
        xAxis: {
            visible: !hideAxis,
            height: sizes$2.axisheight[size],
            width: sizes$2.axisheight[size],
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: hideChartTicksAndGrids ? 0 : 6,
            minorTickInterval: 0.25,
            minorTickLength: hideChartTicksAndGrids ? 0 : 4,
            minorTickWidth: hideChartTicksAndGrids ? 0 : 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            lineColor: hideChartTicksAndGrids ? 'transparent' : undefined,
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
            },
        },
        yAxis: {
            visible: !hideAxis,
            height: sizes$2.axisheight[size],
            width: sizes$2.axisheight[size],
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: hideChartTicksAndGrids ? 0 : 6,
            minorTickInterval: 0.25,
            minorTickLength: hideChartTicksAndGrids ? 0 : 4,
            minorTickWidth: hideChartTicksAndGrids ? 0 : 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: yopposite,
            lineColor: hideChartTicksAndGrids ? 'transparent' : undefined,
            title: {
                text: null,
            },
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
                x: yopposite ? 5 : -5,
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (!this.point.tooltip && !this.point.name)
                    return false;
                return `<b>${this.series.name}</b><br/>${this.point.tooltip || this.point.name}`;
            },
            outside: true,
        },
        series,
        title: {
            align: 'center',
            floating: true,
            verticalAlign: 'top',
            text: undefined,
        },
        credits: {
            enabled: false,
        },
    };
    return (React.createElement(React.Fragment, null,
        !!(pitchVideoFn || multiVideoFn) && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer, exportPlaylist: (clips) => { closePitchVideo(); if (exportPlaylistCallback)
                exportPlaylistCallback(clips); } })),
        React.createElement(BaseChart, { ref: ref, width: sizes$2.width[size], options: chartConfig, useBodyFont: false, style: { marginTop: 'auto' }, className: "strikeZoneChart" })));
});

const handedness = (batsThrowsEnum, isFullText = false, translate = null) => {
    let textValue = isFullText ? 'Unknown' : '-';
    if (!isNaN(batsThrowsEnum)) {
        const value = Number(batsThrowsEnum);
        if (translate) {
            if (value === 1)
                textValue = isFullText ? translate('baseball.right') : translate('baseball.abbr-right');
            else if (value === 2)
                textValue = isFullText ? translate('baseball.left') : translate('baseball.abbr-left');
            else if (value === 3)
                textValue = isFullText ? translate('baseball.switch') : translate('baseball.abbr-switch');
        }
        else if (value === 1)
            textValue = isFullText ? 'Right' : 'R';
        else if (value === 2)
            textValue = isFullText ? 'Left' : 'L';
        else if (value === 3)
            textValue = isFullText ? 'Switch' : 'S';
    }
    return textValue;
};
const yesNo = (value, isFullText = false, translate = null) => {
    let yesNoVal = null;
    if (value === true || value === 1 || value === 'true' || value === 'True') {
        if (translate) {
            yesNoVal = isFullText ? translate('common.yes') : translate('common.abbr-yes');
        }
        else {
            yesNoVal = isFullText ? 'Yes' : 'Y';
        }
    }
    else if (value === false || value === 0 || value === 'false' || value === 'False') {
        if (translate) {
            yesNoVal = isFullText ? translate('common.no') : translate('common.abbr-no');
        }
        else {
            yesNoVal = isFullText ? 'No' : 'N';
        }
    }
    return yesNoVal;
};
const rosterState = (stateEnum, isFullText = false, translate = null) => {
    let textValue = '';
    if (translate) {
        textValue = isFullText ? translate('common.unknown') : '--';
        if (!isNaN(stateEnum)) {
            const value = Number(stateEnum);
            if (value === 1)
                textValue = isFullText ? translate('shared.rosterstate.active') : translate('shared.rosterstate.abbr-active');
            else if (value === 2)
                textValue = isFullText ? translate('shared.rosterstate.optioned') : translate('shared.rosterstate.abbr-optioned');
            else if (value === 3)
                textValue = isFullText ? translate('shared.rosterstate.designated') : translate('shared.rosterstate.abbr-designated');
            else if (value === 4)
                textValue = isFullText ? translate('shared.rosterstate.15il') : translate('shared.rosterstate.abbr-15il');
            else if (value === 5)
                textValue = isFullText ? translate('shared.rosterstate.60il') : translate('shared.rosterstate.abbr-60il');
            else if (value === 6)
                textValue = isFullText ? translate('shared.rosterstate.free-agent') : translate('shared.rosterstate.abbr-free-agent');
            else if (value === 7)
                textValue = isFullText ? translate('shared.rosterstate.inactive') : translate('shared.rosterstate.abbr-inactive');
            else if (value === 8)
                textValue = isFullText ? translate('shared.rosterstate.restricted') : translate('shared.rosterstate.abbr-restricted');
            else if (value === 9)
                textValue = isFullText ? translate('shared.rosterstate.7il') : translate('shared.rosterstate.abbr-7il');
            else if (value === 10)
                textValue = isFullText ? translate('shared.rosterstate.60il-minor') : translate('shared.rosterstate.abbr-60il-minor');
            else if (value === 11)
                textValue = isFullText ? translate('shared.rosterstate.7concussion') : translate('shared.rosterstate.abbr-7concussion');
            else if (value === 12)
                textValue = isFullText ? translate('shared.rosterstate.suspended') : translate('shared.rosterstate.abbr-suspended');
            else if (value === 13)
                textValue = isFullText ? translate('shared.rosterstate.non-roster-invite') : translate('shared.rosterstate.abbr-non-roster-invite');
            else if (value === 14)
                textValue = isFullText ? translate('shared.rosterstate.10il') : translate('shared.rosterstate.abbr-10il');
        }
    }
    else {
        textValue = isFullText ? 'Unknown' : '--';
        if (!isNaN(stateEnum)) {
            const value = Number(stateEnum);
            if (value === 1)
                textValue = isFullText ? 'Active' : 'ACT';
            else if (value === 2)
                textValue = isFullText ? 'Optioned' : 'OPT';
            else if (value === 3)
                textValue = isFullText ? 'Designated' : 'DES';
            else if (value === 4)
                textValue = isFullText ? '15-Day DL' : '15D';
            else if (value === 5)
                textValue = isFullText ? '60-Day DL' : '60D';
            else if (value === 6)
                textValue = isFullText ? 'Free Agent' : 'FA';
            else if (value === 7)
                textValue = isFullText ? 'Inactive' : 'INACT';
            else if (value === 8)
                textValue = isFullText ? 'Restricted' : 'RES';
            else if (value === 9)
                textValue = isFullText ? '7-Day DL' : '7D';
            else if (value === 10)
                textValue = isFullText ? '60-Day Minor DL' : '60D';
            else if (value === 11)
                textValue = isFullText ? '7-Day Concussion' : '7DC';
            else if (value === 12)
                textValue = isFullText ? 'Suspended' : 'SUS';
            else if (value === 13)
                textValue = isFullText ? 'Non-Roster Invite' : 'NRI';
            else if (value === 14)
                textValue = isFullText ? '10-Day DL' : '10D';
        }
    }
    return textValue;
};
const grade = (gradeEnum, isAmateurGrade = false) => {
    let textValue = '-';
    if (!isNaN(gradeEnum)) {
        const value = Number(gradeEnum);
        if (value === 1)
            textValue = isAmateurGrade ? 'A' : '8';
        else if (value === 2)
            textValue = isAmateurGrade ? 'A-' : '7';
        else if (value === 3)
            textValue = isAmateurGrade ? 'B+' : '6+';
        else if (value === 4)
            textValue = isAmateurGrade ? 'B' : '6';
        else if (value === 5)
            textValue = isAmateurGrade ? 'B-' : '6-';
        else if (value === 6)
            textValue = isAmateurGrade ? 'C+' : '5+';
        else if (value === 7)
            textValue = isAmateurGrade ? 'C' : '5';
        else if (value === 8)
            textValue = isAmateurGrade ? 'C-' : '5-';
        else if (value === 9)
            textValue = isAmateurGrade ? 'D+' : '4+';
        else if (value === 10)
            textValue = isAmateurGrade ? 'D' : '4';
        else if (value === 11)
            textValue = isAmateurGrade ? 'D-' : '4-';
        else if (value === 12)
            textValue = isAmateurGrade ? 'E' : '3';
        else if (value === 13)
            textValue = isAmateurGrade ? 'F' : '2';
        else if (value === 14)
            textValue = 'G';
        else if (value === 15)
            textValue = isAmateurGrade ? 'H' : '1';
        else if (value === 16)
            textValue = 'P';
        else if (value === 17)
            textValue = 'R';
    }
    return textValue;
};
const hsClassName = (classEnum, isFullText = false, translate = null) => {
    if (translate) {
        let textValue = isFullText ? translate('common.unknown') : '--';
        if (!isNaN(classEnum)) {
            const value = Number(classEnum);
            if (value === 1)
                textValue = isFullText ? translate('shared.class.freshman') : translate('shared.class.abbr-freshman');
            else if (value === 2)
                textValue = isFullText ? translate('shared.class.sophomore') : translate('shared.class.abbr-sophomore');
            else if (value === 3)
                textValue = isFullText ? translate('shared.class.junior') : translate('shared.class.abbr-junior');
            else if (value === 4)
                textValue = isFullText ? translate('shared.class.senior') : translate('shared.class.abbr-senior');
            else if (value === 5)
                textValue = isFullText ? translate('shared.class.high-school') : translate('shared.class.abbr-high-school');
            else if (value === 6)
                textValue = isFullText ? translate('shared.class.jr-college-1') : translate('shared.class.abbr-jr-college-1');
            else if (value === 7)
                textValue = isFullText ? translate('shared.class.jr-college-2') : translate('shared.class.abbr-jr-college-2');
        }
        return textValue;
    }
    let textValue = isFullText ? 'Unknown' : '--';
    if (!isNaN(classEnum)) {
        const value = Number(classEnum);
        if (value === 1)
            textValue = isFullText ? 'Freshman' : 'C1';
        else if (value === 2)
            textValue = isFullText ? 'Sophomore' : 'C2';
        else if (value === 3)
            textValue = isFullText ? 'Junior' : 'C3';
        else if (value === 4)
            textValue = isFullText ? 'Senior' : 'C4';
        else if (value === 5)
            textValue = isFullText ? 'High School' : 'HS';
        else if (value === 6)
            textValue = isFullText ? '1st Yr Junior College' : 'JC1';
        else if (value === 7)
            textValue = isFullText ? '2nd Yr Junior College' : 'JC2';
    }
    return textValue;
};
const hitType = (hittype, isFullText = false, translate = null) => {
    let textValue = '';
    if (translate) {
        if (!isNaN(hittype)) {
            const value = Number(hittype);
            if (value === 0)
                textValue = isFullText ? translate('baseball.pitchresult.groundball') : translate('baseball.pitchresult.abbr-groundball');
            else if (value === 1)
                textValue = isFullText ? translate('baseball.pitchresult.flyball') : translate('baseball.pitchresult.abbr-flyball');
            else if (value === 2)
                textValue = isFullText ? translate('baseball.pitchresult.linedrive') : translate('baseball.pitchresult.abbr-linedrive');
            else if (value === 3)
                textValue = isFullText ? translate('baseball.pitchresult.popfly') : translate('baseball.pitchresult.abbr-popup');
            else if (value >= 4 && value <= 6)
                textValue = translate('baseball.pitchresult.bunt');
        }
    }
    else if (!isNaN(hittype)) {
        const value = Number(hittype);
        if (value === 0)
            textValue = isFullText ? 'Ground Ball' : 'GB';
        else if (value === 1)
            textValue = isFullText ? 'Fly Ball' : 'FB';
        else if (value === 2)
            textValue = isFullText ? 'Line Drive' : 'LD';
        else if (value === 3)
            textValue = isFullText ? 'Pop Fly' : 'Pop';
        else if (value >= 4 && value <= 6)
            textValue = 'Bunt';
    }
    return textValue;
};
const getAbsSuffix = (translate = null, hasabsreview, isoverturned) => {
    if (!hasabsreview)
        return '';
    const status = isoverturned ? translate('baseball.pitchresult.overturned') : translate('baseball.pitchresult.confirmed');
    return ` (${status})`;
};
const pitchResult = (resultid, isFullDescription = false, translate = null, hasabsreview, isoverturned) => {
    let textValue = 'Unknown';
    const absval = getAbsSuffix(translate, hasabsreview, isoverturned);
    if (translate) {
        if (!isNaN(resultid)) {
            const value = Number(resultid);
            if (isFullDescription) {
                if (value === 0)
                    textValue = translate('baseball.pitchresult.no-pitch');
                else if (value === 1)
                    textValue = translate('baseball.balls_one') + absval;
                else if (value === 2)
                    textValue = translate('baseball.pitchresult.intentional-ball');
                else if (value === 3)
                    textValue = translate('baseball.pitchresult.pitchout');
                else if (value === 4)
                    textValue = translate('baseball.pitchresult.taken-strike') + absval;
                else if (value === 5)
                    textValue = translate('baseball.pitchresult.swing-miss-pitchout');
                else if (value === 6)
                    textValue = translate('baseball.pitchresult.swing-miss');
                else if (value === 7)
                    textValue = translate('baseball.pitchresult.bunt-miss');
                else if (value === 8)
                    textValue = translate('baseball.pitchresult.foul-ball');
                else if (value === 9)
                    textValue = translate('baseball.pitchresult.foul-bunt');
                else if (value === 10)
                    textValue = translate('baseball.pitchresult.foul-ball-hit-run');
                else if (value === 11)
                    textValue = translate('baseball.pitchresult.foul-bunt-hit-run');
                else if (value === 12)
                    textValue = translate('baseball.pitchresult.foul-tip');
                else if (value === 13)
                    textValue = translate('baseball.pitchresult.foul-tip-hit-run');
                else if (value === 14)
                    textValue = translate('baseball.pitchresult.in-play');
                else if (value === 15)
                    textValue = translate('baseball.pitchresult.in-play-hit-run');
                else if (value === 16)
                    textValue = translate('baseball.pitchresult.catcher-block');
                else if (value === 17)
                    textValue = `${translate('baseball.pitchresult.pickoff')} ${translate('baseball.pitcher_one')} ${translate('common.to')} ${translate('baseball.1b')}`;
                else if (value === 18)
                    textValue = `${translate('baseball.pitchresult.pickoff')} ${translate('baseball.pitcher_one')} ${translate('common.to')} ${translate('baseball.2b')}`;
                else if (value === 19)
                    textValue = `${translate('baseball.pitchresult.pickoff')} ${translate('baseball.pitcher_one')} ${translate('common.to')} ${translate('baseball.3b')}`;
                else if (value === 20)
                    textValue = `${translate('baseball.catcher_one')} ${translate('baseball.pitchresult.pickoff')}`;
                else if (value === 21)
                    textValue = `${translate('baseball.balls_one')} - ${translate('baseball.pitchresult.no-pitch')}`;
            }
            else if (value === 1)
                textValue = translate('baseball.balls_one') + absval;
            else if (value === 2)
                textValue = `${translate('baseball.balls_one')} (Int)`;
            else if (value === 3)
                textValue = `${translate('baseball.balls_one')} (PO)`;
            else if (value === 4) {
                const base = translate('baseball.strikes_one');
                textValue = hasabsreview ? `${base}${absval}` : `${base} (${translate('baseball.looking')})`;
            }
            else if (value >= 5 && value <= 7)
                textValue = `${translate('baseball.strikes_one')} (${translate('baseball.swinging')})`;
            else if (value >= 8 && value <= 11)
                textValue = translate('baseball.pitchresult.foul');
            else if (value >= 12 && value <= 13)
                textValue = translate('baseball.pitchresult.foul-tip');
            else if (value >= 14 && value <= 15)
                textValue = translate('baseball.pitchresult.in-play');
            else if (value >= 17 && value <= 19)
                textValue = translate('baseball.pitchresult.pickoff');
        }
    }
    else if (!isNaN(resultid)) {
        const value = Number(resultid);
        if (isFullDescription) {
            if (value === 0)
                textValue = 'No Pitch';
            else if (value === 1)
                textValue = `Ball${absval}`;
            else if (value === 2)
                textValue = 'Intentional Ball';
            else if (value === 3)
                textValue = 'Pitchout';
            else if (value === 4)
                textValue = `Taken Strike${absval}`;
            else if (value === 5)
                textValue = 'Swing and Miss at Pitchout';
            else if (value === 6)
                textValue = 'Swing and Miss';
            else if (value === 7)
                textValue = 'Bunt and Miss';
            else if (value === 8)
                textValue = 'Foul Ball';
            else if (value === 9)
                textValue = 'Foul Bunt';
            else if (value === 10)
                textValue = 'Foul Ball on Hit and Run';
            else if (value === 11)
                textValue = 'Foul Bunt on Hit and Run';
            else if (value === 12)
                textValue = 'Foul Tip';
            else if (value === 13)
                textValue = 'Foul Tip on Hit and Run';
            else if (value === 14)
                textValue = 'In Play';
            else if (value === 15)
                textValue = 'In Play on Hit and Run';
            else if (value === 16)
                textValue = 'Catcher Block';
            else if (value === 17)
                textValue = 'Pickoff Pitcher to 1B';
            else if (value === 18)
                textValue = 'Pickoff Pitcher to 2B';
            else if (value === 19)
                textValue = 'Pickoff Pitcher to 3B';
            else if (value === 20)
                textValue = 'Catcher Pickoff';
            else if (value === 21)
                textValue = 'Ball - No Pitch';
        }
        else if (value === 1)
            textValue = `Ball${absval}`;
        else if (value === 2)
            textValue = 'Ball (Int)';
        else if (value === 3)
            textValue = 'Ball (PO)';
        else if (value === 4) {
            textValue = hasabsreview ? `Strike${absval}` : 'Strike (Looking)';
        }
        else if (value >= 5 && value <= 7)
            textValue = 'Strike (Swinging)';
        else if (value >= 8 && value <= 11)
            textValue = 'Foul';
        else if (value >= 12 && value <= 13)
            textValue = 'Foul Tip';
        else if (value >= 14 && value <= 15)
            textValue = 'In Play';
        else if (value >= 17 && value <= 19)
            textValue = 'Pickoff';
    }
    return textValue;
};
const LEVELS = [
    { id: 0, abbr: 'UNK', name: 'Unknown', sortorder: 99 },
    { id: 1, abbr: 'AAA', name: 'Triple A', sortorder: 3 },
    { id: 2, abbr: 'AA', name: 'Double A', sortorder: 4 },
    { id: 3, abbr: 'A+', name: 'Single A (Advanced)', sortorder: 5 },
    { id: 4, abbr: 'A', name: 'Single A (Full Season)', sortorder: 6 },
    { id: 5, abbr: 'A-', name: 'Single A (Short Season)', sortorder: 7 },
    { id: 6, abbr: 'INT', name: 'International Baseball', sortorder: 13 },
    { id: 7, abbr: 'MIN', name: 'Minor League Baseball', sortorder: 2 },
    { id: 8, abbr: 'MLB', name: 'Major League Baseball', sortorder: 1 },
    { id: 9, abbr: 'OLY', name: 'Olympic Baseball', sortorder: 12 },
    { id: 10, abbr: 'R', name: 'Rookie', sortorder: 8 },
    { id: 11, abbr: 'WIN', name: 'Winter Leagues', sortorder: 11 },
    { id: 20, abbr: 'SPR', name: 'Major League Spring Training', sortorder: 30 },
    { id: 21, abbr: 'POS', name: 'Major League Post Season', sortorder: 31 },
    { id: 22, abbr: 'NPS', name: 'Nippon Professional Post Season', sortorder: 32 },
    { id: 23, abbr: 'ASG', name: 'All-Star Exhibition', sortorder: 33 },
    { id: 24, abbr: 'EXT', name: 'Extended Spring Training', sortorder: 34 },
    { id: 25, abbr: 'INS', name: 'Instructional League', sortorder: 37 },
    { id: 26, abbr: 'MST', name: 'Minor League Spring Training', sortorder: 35 },
    { id: 27, abbr: 'DTL', name: 'DSL Parallel League ', sortorder: 36 },
    { id: 28, abbr: 'ISH', name: 'International Showcase ', sortorder: 38 },
    { id: 29, abbr: 'SIM', name: 'Simulated Games ', sortorder: 39 },
    { id: 31, abbr: 'DV1', name: 'NCAA Division I Baseball', sortorder: 50 },
    { id: 32, abbr: 'DV2', name: 'NCAA Division II Baseball', sortorder: 51 },
    { id: 33, abbr: 'DV3', name: 'NCAA Division III Baseball', sortorder: 52 },
    { id: 34, abbr: 'NJC', name: 'NJCAA Division I Baseball', sortorder: 53 },
    { id: 35, abbr: 'NJ2', name: 'NJCAA Division II Baseball', sortorder: 54 },
    { id: 36, abbr: 'NJ3', name: 'NJCAA Division III Baseball', sortorder: 55 },
    { id: 37, abbr: 'NAI', name: 'NAIA Division I Baseball', sortorder: 56 },
    { id: 38, abbr: 'SUM', name: 'Summer League Baseball', sortorder: 57 },
    { id: 39, abbr: 'HS', name: 'High School', sortorder: 58 },
    { id: 40, abbr: 'SHO', name: 'High School Showcase', sortorder: 59 },
    { id: 101, abbr: 'MEX', name: 'Mexican Leagues', sortorder: 20 },
    { id: 102, abbr: 'NPB', name: 'Nippon Professional Baseball', sortorder: 21 },
    { id: 103, abbr: 'IND', name: 'Independent League Baseball', sortorder: 22 },
    { id: 104, abbr: 'KBO', name: 'Korean Baseball Organization', sortorder: 23 },
    { id: 105, abbr: 'CUB', name: 'Cuban Baseball Leagues', sortorder: 24 },
    { id: 106, abbr: 'IWL', name: 'Indy Winter Leagues', sortorder: 40 },
    { id: 107, abbr: 'CSL', name: 'Cuban Senior Development League (U23)', sortorder: 25 },
    { id: 108, abbr: 'CYL', name: 'Cuban Youth Development League (U18-)', sortorder: 26 },
    { id: 109, abbr: 'KPS', name: 'Korean Baseball Post Season', sortorder: 27 },
];
const BASE_EVENTS = (translate = null) => {
    if (translate) {
        return [
            { id: 0, abbr: '--', name: translate('shared.events.unofficial') },
            { id: 1, abbr: '1B', name: translate('shared.events.single') },
            { id: 2, abbr: '2B', name: translate('shared.events.double') },
            { id: 3, abbr: '3B', name: translate('shared.events.triple') },
            { id: 4, abbr: 'HR', name: translate('baseball.home-run') },
            { id: 5, abbr: 'UBB', name: translate('shared.events.unintentional-walk'), altName: translate('shared.events.walk') },
            { id: 6, abbr: 'HBP', name: translate('shared.events.hit-by-pitch') },
            { id: 7, abbr: 'SO', name: translate('shared.events.strike-out') },
            { id: 8, abbr: 'Out', name: translate('shared.events.batted-out') },
            { id: 9, abbr: 'Int', name: translate('shared.events.catcher-interference') },
            { id: 10, abbr: 'IBB', name: translate('shared.events.intentional-walk'), altName: `${translate('shared.events.walk')} (Int)` },
            { id: 11, abbr: 'SH', name: translate('shared.events.sacrifice-hit') },
            { id: 12, abbr: 'SF', name: translate('shared.events.sacrifice-fly') },
            { id: 13, abbr: 'FC', name: translate('shared.events.fielders-choice') },
            { id: 14, abbr: 'RoE', name: translate('shared.events.reach-on-error') },
            { id: 15, abbr: 'BInt', name: translate('shared.events.batter-interference-out'), altName: translate('shared.events.interference-batter') },
            { id: 100, abbr: translate('common.unknown'), name: translate('common.unknown') },
            { id: 101, abbr: 'SB', name: translate('shared.events.stolen-base') },
            { id: 102, abbr: 'CS', name: translate('shared.events.caught-stealing') },
            { id: 103, abbr: 'PO', name: translate('baseball.pitchresult.pickoff') },
            { id: 104, abbr: 'WP', name: translate('shared.events.wild-pitch') },
            { id: 105, abbr: 'PB', name: translate('shared.events.passed-ball') },
            { id: 106, abbr: 'BLK', name: translate('shared.events.balk') },
            { id: 107, abbr: 'AoE', name: translate('shared.events.advance-on-error'), altName: translate('shared.events.advance-on-error-short') },
            { id: 108, abbr: 'POE', name: translate('shared.events.pickoff-error') },
            { id: 109, abbr: 'OA', name: translate('shared.events.out-advancing') },
            { id: 110, abbr: 'AoT', name: translate('shared.events.advance-on-throw') },
            { id: 111, abbr: 'BRInt', name: translate('shared.events.base-runners-interference') },
            { id: 112, abbr: 'DI', name: translate('shared.events.defensive-indifference') },
            { id: 113, abbr: 'FFE', name: translate('shared.events.foul-fly') },
            { id: 114, abbr: 'OB', name: translate('shared.events.obstruction') },
        ];
    }
    return [{ id: 0, abbr: '--', name: 'Unofficial' },
        { id: 1, abbr: '1B', name: 'Single' },
        { id: 2, abbr: '2B', name: 'Double' },
        { id: 3, abbr: '3B', name: 'Triple' },
        { id: 4, abbr: 'HR', name: 'Home Run' },
        { id: 5, abbr: 'UBB', name: 'Unintentional Walk', altName: 'Walk' },
        { id: 6, abbr: 'HBP', name: 'Hit By Pitch' },
        { id: 7, abbr: 'SO', name: 'Strike Out' },
        { id: 8, abbr: 'Out', name: 'Batted Out' },
        { id: 9, abbr: 'Int', name: 'Catcher Interference' },
        { id: 10, abbr: 'IBB', name: 'Intentional Walk', altName: 'Walk (Int)' },
        { id: 11, abbr: 'SH', name: 'Sacrifice Hit' },
        { id: 12, abbr: 'SF', name: 'Sacrifice Fly' },
        { id: 13, abbr: 'FC', name: 'Fielders Choice' },
        { id: 14, abbr: 'RoE', name: 'Reach On Error' },
        { id: 15, abbr: 'BInt', name: 'Batter Interference/Out', altName: 'Interference (Batter)' },
        { id: 100, abbr: 'Unknown', name: 'Unknown' },
        { id: 101, abbr: 'SB', name: 'Stolen Base' },
        { id: 102, abbr: 'CS', name: 'Caught Stealing' },
        { id: 103, abbr: 'PO', name: 'Pickoff' },
        { id: 104, abbr: 'WP', name: 'Wild Pitch' },
        { id: 105, abbr: 'PB', name: 'Passed Ball' },
        { id: 106, abbr: 'BLK', name: 'Balk' },
        { id: 107, abbr: 'AoE', name: 'Advance on Error', altName: 'Adv on Error' },
        { id: 108, abbr: 'POE', name: 'Pickoff/Error' },
        { id: 109, abbr: 'OA', name: 'Out Advancing' },
        { id: 110, abbr: 'AoT', name: 'Advance on Throw' },
        { id: 111, abbr: 'BRInt', name: 'Base Runners Interference' },
        { id: 112, abbr: 'DI', name: 'Defensive Indifference' },
        { id: 113, abbr: 'FFE', name: 'Foul Fly/Error' },
        { id: 114, abbr: 'OB', name: 'Obstruction' },
    ];
};
// Do not translate, these are to match DB values
const TRANSLATION_CONTEXTS = [
    { id: 0, name: 'Unknown' },
    { id: 1, name: 'Shared' },
    { id: 2, name: 'ComponentLibrary' },
    { id: 3, name: 'PlayerPortal' },
];
const baseEvent = (baseevent, isFullText = false, emptyvalue = '', translate = null) => {
    let event = emptyvalue;
    if (!isNumber$2(baseevent))
        event = baseevent.toString();
    else {
        const value = BASE_EVENTS(translate).find(({ id }) => id === baseevent);
        if (value)
            event = isFullText ? value.name : value.abbr;
    }
    return event;
};

const positionName = (positionEnum, translate = null) => {
    const position = typeof positionEnum === 'number' ? positionEnum : parseInt(positionEnum);
    switch (position) {
        case 1: return translate ? translate('baseball.positions.abbr-pitcher') : 'P';
        case 11: return translate ? translate('baseball.positions.abbr-pitcher-starting') : 'SP';
        case 12: return translate ? translate('baseball.positions.abbr-pitcher-relief') : 'RP';
        case 2: return translate ? translate('baseball.positions.abbr-catcher') : 'C';
        case 3: return translate ? translate('baseball.positions.abbr-first-base') : '1B';
        case 4: return translate ? translate('baseball.positions.abbr-second-base') : '2B';
        case 5: return translate ? translate('baseball.positions.abbr-third-base') : '3B';
        case 6: return translate ? translate('baseball.positions.abbr-shortstop') : 'SS';
        case 7: return translate ? translate('baseball.positions.abbr-leftfield') : 'LF';
        case 8: return translate ? translate('baseball.positions.abbr-centerfield') : 'CF';
        case 9: return translate ? translate('baseball.positions.abbr-rightfield') : 'RF';
        case 10: return translate ? translate('baseball.positions.abbr-designated-hitter') : 'DH';
        case 13: return translate ? translate('baseball.positions.abbr-infield') : 'INF';
        case 14: return translate ? translate('baseball.positions.abbr-outfield') : 'OF';
        default: return '--';
    }
};
const positionAbbrToInt = (positionAbbr) => {
    switch (positionAbbr) {
        case 'P': return 1;
        case 'SP': return 11;
        case 'RP': return 12;
        case 'C': return 2;
        case '1B': return 3;
        case '2B': return 4;
        case '3B': return 5;
        case 'SS': return 6;
        case 'LF': return 7;
        case 'CF': return 8;
        case 'RF': return 9;
        case 'DH': return 10;
        case 'INF': return 13;
        case 'OF': return 14;
        default: return 0;
    }
};
const positionLongName = (positionEnum, translate = null) => {
    switch (positionEnum) {
        case 0: return translate ? translate('baseball.positions.no-position') : 'No Position';
        case 1: return translate ? translate('baseball.pitcher_one') : 'Pitcher';
        case 11: return translate ? translate('baseball.positions.pitcher-starting') : 'Starting Pitcher';
        case 12: return translate ? translate('baseball.positions.pitcher-relief') : 'Relief Pitcher';
        case 2: return translate ? translate('baseball.catcher_one') : 'Catcher';
        case 3: return translate ? translate('baseball.positions.first-base') : 'First Base';
        case 4: return translate ? translate('baseball.positions.second-base') : 'Second Base';
        case 5: return translate ? translate('baseball.positions.third-base') : 'Third Base';
        case 6: return translate ? translate('baseball.positions.shortstop') : 'Shortstop';
        case 7: return translate ? translate('baseball.positions.left-field') : 'Left Field';
        case 8: return translate ? translate('baseball.positions.center-field') : 'Center Field';
        case 9: return translate ? translate('baseball.positions.right-field') : 'Right Field';
        case 10: return translate ? translate('baseball.positions.designated-hitter') : 'Designated Hitter';
        default: return undefined;
    }
};

const freeAgentYear = (faYear, isAbbrYear = false) => {
    if (!faYear)
        return null;
    return isAbbrYear
        ? `'${(faYear - 1) % 100}-'${faYear % 100}`
        : `${faYear - 1}-${faYear % 100}`;
};
const formatSalary = (salary, withDollarSign = false, precision) => {
    let formattedSalary = null;
    if (salary > 0 && salary < 1000) {
        // always show $ so that we don't mistake tiny salaries for larger ones
        formattedSalary = `$${salary.toFixed(precision || 0)}`;
    }
    else if (salary >= 1000) {
        const currencySign = withDollarSign ? '$' : '';
        if (salary < 1000000) {
            formattedSalary = `${currencySign}${(salary / 1000.00).toFixed(precision || 0)}k`;
        }
        else {
            formattedSalary = `${currencySign}${(salary / 1000000.00).toFixed(precision !== undefined ? precision : 1)}M`;
        }
    }
    return formattedSalary;
};
const formatSalaryMillions = (salary, withDollarSign = false, precision) => {
    if (salary === null)
        return null;
    const currencySign = withDollarSign ? '$' : '';
    if (salary === 0)
        return `${currencySign}0M`;
    const sign = salary < 0 ? '-' : '';
    return `${sign}${currencySign}${(Math.abs(salary) / 1000000.00).toFixed(precision !== undefined ? precision : 1)}M`;
};
const floatSafeModulus = (val, step) => {
    if (typeof val !== 'number' || !Number.isFinite(val))
        return NaN;
    const valDecCount = (val.toString().split('.')[1] || '').length;
    const stepDecCount = (step.toString().split('.')[1] || '').length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(parseFloat(val.toString()).toFixed(decCount).replace('.', ''));
    const stepInt = parseInt(step.toFixed(decCount).replace('.', ''));
    return (valInt % stepInt) / (Math.pow(10, decCount));
};
const height = (heightIn, showWithTicks = false, precision) => {
    if (typeof heightIn !== 'number' || !Number.isFinite(heightIn) || heightIn < 0)
        return null;
    let feet = Math.floor(heightIn / 12);
    let inches = format(floatSafeModulus(heightIn, 12), precision !== null && precision !== void 0 ? precision : 1);
    if (Number(inches) === 12.0) {
        feet += 1;
        inches = '0.0';
    }
    return showWithTicks ? `${Math.abs(feet) > 0 ? `${feet}'` : ''}${inches}"` : `${Math.abs(feet) > 0 ? `${feet}-` : ''}${inches}`;
};
const validAge = (years) => (years > 5 ? years : null);

/* eslint-disable max-len */
const PITCH_TYPES = (translate = null) => {
    if (translate) {
        return [
            { id: 0, name: translate('common.unknown'), abbr: '--', sortorder: 0, color: '#000000' },
            { id: 1, name: translate('baseball.pitches.fastball_one'), abbr: translate('baseball.pitches.abbr-fastball'), sortorder: 1, color: '#777777' },
            { id: 2, name: translate('baseball.pitches.curve'), abbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#a6cee3', isfxtype: true },
            { id: 3, name: translate('baseball.pitches.slider'), abbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#1f78b4', isfxtype: true },
            { id: 4, name: translate('baseball.pitches.changeup_one'), abbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#33a02c', isfxtype: true },
            { id: 5, name: translate('baseball.pitches.sinker'), abbr: translate('baseball.pitches.abbr-sinker'), sortorder: 7, color: '#b15928', isfxtype: true },
            { id: 6, name: translate('baseball.pitches.knuckleball'), abbr: translate('baseball.pitches.abbr-knuckleball'), sortorder: 8, color: '#fb9a99', isfxtype: true },
            { id: 7, name: translate('baseball.pitches.splitter'), abbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#cab2d6', isfxtype: true },
            { id: 8, name: translate('baseball.pitches.cutter'), abbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#6a3d9a', isfxtype: true },
            { id: 9, name: translate('baseball.pitches.fastball-2'), abbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#e31a1c', isfxtype: true },
            { id: 10, name: translate('baseball.pitches.fastball-4'), abbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#ff7f00', isfxtype: true },
            { id: 11, name: translate('baseball.pitches.knuckle-curve'), abbr: translate('baseball.pitches.abbr-knuckle-curve'), sortorder: 21, color: '#b2df8a' },
            { id: 12, name: translate('baseball.pitches.forkball'), abbr: translate('baseball.pitches.abbr-forkball'), sortorder: 22, color: '#ffff99' },
            { id: 13, name: translate('baseball.pitches.gyroball'), abbr: translate('baseball.pitches.abbr-gyroball'), sortorder: 23, color: '#fdbf6f' },
            { id: 14, name: translate('baseball.pitches.screwball'), abbr: translate('baseball.pitches.abbr-screwball'), sortorder: 24, color: '#440000' },
            { id: 15, name: translate('baseball.pitches.shuuto'), abbr: translate('baseball.pitches.abbr-shuuto'), sortorder: 25, color: '#cccccc' },
            { id: 16, name: translate('baseball.pitches.fastball-topspin'), abbr: translate('baseball.pitches.abbr-fastball-topspin'), sortorder: 26, color: '#006b3c', isfxtype: true },
            { id: 100, name: translate('baseball.pitches.breaking-ball_one'), abbr: translate('baseball.pitches.abbr-breaking-ball'), sortorder: 98 },
            { id: 101, name: translate('baseball.pitches.offspeed'), abbr: translate('baseball.pitches.abbr-offspeed'), sortorder: 99 },
        ];
    }
    return [
        { id: 0, name: 'Unknown', abbr: '--', sortorder: 0, color: '#000000' },
        { id: 1, name: 'Fastball', abbr: 'FB', sortorder: 1, color: '#777777' },
        { id: 2, name: 'Curve', abbr: 'CB', sortorder: 4, color: '#a6cee3', isfxtype: true },
        { id: 3, name: 'Slider', abbr: 'SL', sortorder: 5, color: '#1f78b4', isfxtype: true },
        { id: 4, name: 'Changeup', abbr: 'CH', sortorder: 6, color: '#33a02c', isfxtype: true },
        { id: 5, name: 'Sinker', abbr: 'SI', sortorder: 7, color: '#b15928', isfxtype: true },
        { id: 6, name: 'Knuckleball', abbr: 'KN', sortorder: 8, color: '#fb9a99', isfxtype: true },
        { id: 7, name: 'Splitter', abbr: 'SP', sortorder: 9, color: '#cab2d6', isfxtype: true },
        { id: 8, name: 'Cutter', abbr: 'CT', sortorder: 10, color: '#6a3d9a', isfxtype: true },
        { id: 9, name: 'Two-Seam Fastball', abbr: '2FB', sortorder: 2, color: '#e31a1c', isfxtype: true },
        { id: 10, name: 'Four-Seam Fastball', abbr: '4FB', sortorder: 3, color: '#ff7f00', isfxtype: true },
        { id: 11, name: 'Knuckle Curve', abbr: 'KNC', sortorder: 21, color: '#b2df8a' },
        { id: 12, name: 'Forkball', abbr: 'FKB', sortorder: 22, color: '#ffff99' },
        { id: 13, name: 'Gyroball', abbr: 'GYR', sortorder: 23, color: '#fdbf6f' },
        { id: 14, name: 'Screwball', abbr: 'SRW', sortorder: 24, color: '#440000' },
        { id: 15, name: 'Shuuto', abbr: 'SHU', sortorder: 25, color: '#cccccc' },
        { id: 16, name: 'Topspin Fastball', abbr: 'TFB', sortorder: 26, color: '#006b3c', isfxtype: true },
        { id: 100, name: 'Breaking Ball', abbr: 'BRK', sortorder: 98 },
        { id: 101, name: 'Offspeed', abbr: 'OFF', sortorder: 99 },
    ];
};
const PITCH_SUB_TYPES = (translate = null) => {
    if (translate) {
        return [
            { id: 20, name: translate('baseball.pitchsubtypes.curveball.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.rhp'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#1e3a8a' },
            { id: 21, name: translate('baseball.pitchsubtypes.curveball.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.lhp'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#1e3a8a' },
            { id: 22, name: translate('baseball.pitchsubtypes.curveball.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.dropdown'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#3b82f6' },
            { id: 23, name: translate('baseball.pitchsubtypes.curveball.slow'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.slow'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#1e40af' },
            { id: 30, name: translate('baseball.pitchsubtypes.slider.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-slider.rhp'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#0369a1' },
            { id: 31, name: translate('baseball.pitchsubtypes.slider.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-slider.lhp'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#0369a1' },
            { id: 32, name: translate('baseball.pitchsubtypes.slider.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-slider.dropdown'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#475569' },
            { id: 33, name: translate('baseball.pitchsubtypes.slider.gyro'), abbr: translate('baseball.pitchsubtypes.abbr-slider.gyro'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#713f12' },
            { id: 34, name: translate('baseball.pitchsubtypes.slider.sweeper'), abbr: translate('baseball.pitchsubtypes.abbr-slider.sweeper'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#06b6d4' },
            { id: 35, name: translate('baseball.pitchsubtypes.slider.whirly'), abbr: translate('baseball.pitchsubtypes.abbr-slider.whirly'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#a5f3fc' },
            { id: 40, name: translate('baseball.pitchsubtypes.changeup_one.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.rhp'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#064e3b' },
            { id: 41, name: translate('baseball.pitchsubtypes.changeup_one.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.lhp'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#064e3b' },
            { id: 42, name: translate('baseball.pitchsubtypes.changeup_one.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.dropdown'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#047857' },
            { id: 43, name: translate('baseball.pitchsubtypes.changeup_one.twoseam'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.twoseam'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#059669' },
            { id: 44, name: translate('baseball.pitchsubtypes.changeup_one.fourseam'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.fourseam'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#10b981' },
            { id: 45, name: translate('baseball.pitchsubtypes.changeup_one.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.oneseam'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#34d399' },
            { id: 46, name: translate('baseball.pitchsubtypes.changeup_one.looper'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.looper'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#6ee7b7' },
            { id: 70, name: translate('baseball.pitchsubtypes.splitter.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.rhp'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#f3e8ff' },
            { id: 71, name: translate('baseball.pitchsubtypes.splitter.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.lhp'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#f3e8ff' },
            { id: 72, name: translate('baseball.pitchsubtypes.splitter.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.dropdown'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#f5d0fe' },
            { id: 73, name: translate('baseball.pitchsubtypes.splitter.twoseam'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.twoseam'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#e9d5ff' },
            { id: 74, name: translate('baseball.pitchsubtypes.splitter.fourseam'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.fourseam'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#d8b4fe' },
            { id: 75, name: translate('baseball.pitchsubtypes.splitter.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.oneseam'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#c084fc' },
            { id: 76, name: translate('baseball.pitchsubtypes.splitter.looper'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.looper'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#9333ea' },
            { id: 80, name: translate('baseball.pitchsubtypes.cutter.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.rhp'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#581c87' },
            { id: 81, name: translate('baseball.pitchsubtypes.cutter.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.lhp'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#581c87' },
            { id: 82, name: translate('baseball.pitchsubtypes.cutter.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.dropdown'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#701a75' },
            { id: 83, name: translate('baseball.pitchsubtypes.cutter.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.oneseam'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#6b21a8' },
            { id: 84, name: translate('baseball.pitchsubtypes.cutter.fourseam'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.fourseam'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#86198f' },
            { id: 85, name: translate('baseball.pitchsubtypes.cutter.curly'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.curly'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#7e22ce' },
            { id: 90, name: translate('baseball.pitchsubtypes.fastball-2.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.rhp'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#fecaca' },
            { id: 91, name: translate('baseball.pitchsubtypes.fastball-2.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.lhp'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#fecaca' },
            { id: 92, name: translate('baseball.pitchsubtypes.fastball-2.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.dropdown'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#fca5a5' },
            { id: 93, name: translate('baseball.pitchsubtypes.fastball-2.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.oneseam'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#f87171' },
            { id: 94, name: translate('baseball.pitchsubtypes.fastball-2.looper'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.looper'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#ef4444' },
            { id: 95, name: translate('baseball.pitchsubtypes.fastball-2.cutsinker'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.cutsinker'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#b91c1c' },
            { id: 100, name: translate('baseball.pitchsubtypes.fastball-4.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.rhp'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#c2410c' },
            { id: 101, name: translate('baseball.pitchsubtypes.fastball-4.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.lhp'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#c2410c' },
            { id: 102, name: translate('baseball.pitchsubtypes.fastball-4.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.dropdown'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#fb923c' },
            { id: 103, name: translate('baseball.pitchsubtypes.fastball-4.offset'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.offset'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#fdba74' },
        ];
    }
    return [
        { id: 20, name: 'RHP', abbr: 'CB-R', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#1e3a8a' },
        { id: 21, name: 'LHP', abbr: 'CB-L', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#1e3a8a' },
        { id: 22, name: 'Drop-Down', abbr: 'DDCB', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#3b82f6' },
        { id: 23, name: 'Slow', abbr: 'SLOW', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#1e40af' },
        { id: 30, name: 'RHP', abbr: 'SL-R', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#0369a1' },
        { id: 31, name: 'LHP', abbr: 'SL-L', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#0369a1' },
        { id: 32, name: 'Drop-Down', abbr: 'DDSL', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#475569' },
        { id: 33, name: 'Gyro', abbr: 'GYRO', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#713f12' },
        { id: 34, name: 'Sweeper', abbr: 'SW', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#06b6d4' },
        { id: 35, name: 'Whirly', abbr: 'WH', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#a5f3fc' },
        { id: 40, name: 'RHP', abbr: 'CH-R', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#064e3b' },
        { id: 41, name: 'LHP', abbr: 'CH-L', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#064e3b' },
        { id: 42, name: 'Drop-Down', abbr: 'DDCH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#047857' },
        { id: 43, name: 'Two-Seam', abbr: '2CH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#059669' },
        { id: 44, name: 'Four-Seam', abbr: '4CH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#10b981' },
        { id: 45, name: 'One-Seam', abbr: '1CH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#34d399' },
        { id: 46, name: 'Looper', abbr: 'LPCH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#6ee7b7' },
        { id: 70, name: 'RHP', abbr: 'SP-R', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#f3e8ff' },
        { id: 71, name: 'LHP', abbr: 'SP-L', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#f3e8ff' },
        { id: 72, name: 'Drop-Down', abbr: 'DDSP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#f5d0fe' },
        { id: 73, name: 'Two-Seam', abbr: '2SP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#e9d5ff' },
        { id: 74, name: 'Four-Seam', abbr: '4SP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#d8b4fe' },
        { id: 75, name: 'One-Seam', abbr: '1SP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#c084fc' },
        { id: 76, name: 'Looper', abbr: 'LPSP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#9333ea' },
        { id: 80, name: 'RHP', abbr: 'CT-R', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#581c87' },
        { id: 81, name: 'LHP', abbr: 'CT-L', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#581c87' },
        { id: 82, name: 'Drop-Down', abbr: 'DDCT', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#701a75' },
        { id: 83, name: 'One-Seam', abbr: '1CT', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#6b21a8' },
        { id: 84, name: 'Four-Seam', abbr: '4CT', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#86198f' },
        { id: 85, name: 'Curly', abbr: 'CRLY', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#7e22ce' },
        { id: 90, name: 'RHP', abbr: '2S-R', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#fecaca' },
        { id: 91, name: 'LHP', abbr: '2S-L', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#fecaca' },
        { id: 92, name: 'Drop-Down', abbr: 'DD2F', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#fca5a5' },
        { id: 93, name: 'One-Seam', abbr: '1FB', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#f87171' },
        { id: 94, name: 'Looper', abbr: 'LP2F', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#ef4444' },
        { id: 95, name: 'Cut Sinker', abbr: 'CTSK', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#b91c1c' },
        { id: 100, name: 'RHP', abbr: '4S-R', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#c2410c' },
        { id: 101, name: 'LHP', abbr: '4S-L', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#c2410c' },
        { id: 102, name: 'Drop-Down', abbr: 'DD4F', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#fb923c' },
        { id: 103, name: 'Off-Set Looper', abbr: 'OFLP', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#fdba74' },
    ];
};
const getPitchType = (translate, pitchTypeVal) => {
    let pitchType = null;
    if (isNumber$2(pitchTypeVal)) {
        const intVal = typeof pitchTypeVal === 'number' ? pitchTypeVal : parseInt(pitchTypeVal);
        if (!isNaN(intVal)) {
            pitchType = PITCH_TYPES(translate).find((x) => x.id === intVal);
        }
    }
    return pitchType;
};
const getPitchTypeIdFromName = (pitchNameOrAbbr, translate = null) => {
    var _a;
    if (!pitchNameOrAbbr)
        return null;
    return ((_a = PITCH_TYPES(translate).find((x) => [x.name, x.abbr].includes(pitchNameOrAbbr))) === null || _a === void 0 ? void 0 : _a.id) || null;
};
const pitchType = (value, abbr = false, emptyvalue, translate = null) => {
    const pt = getPitchType(translate, value);
    if (pt) {
        return abbr ? pt.abbr : pt.name;
    }
    return emptyvalue !== undefined ? emptyvalue : value;
};
const pitchTypeColor = (value, translate = null) => { var _a; return ((_a = getPitchType(translate, value)) === null || _a === void 0 ? void 0 : _a.color) || PITCH_TYPES(translate)[0].color; };
const getPitchSubType = (translate, pitchSubTypeVal) => {
    let pitchSubType = null;
    if (isNumber$2(pitchSubTypeVal)) {
        const intVal = typeof pitchSubTypeVal === 'number' ? pitchSubTypeVal : parseInt(pitchSubTypeVal);
        if (!isNaN(intVal)) {
            pitchSubType = PITCH_SUB_TYPES(translate).find((x) => x.id === intVal);
        }
    }
    return pitchSubType;
};
const pitchSubType = (value, abbr = false, emptyvalue, translate = null) => {
    const pt = getPitchSubType(translate, value);
    if (pt) {
        return abbr ? pt.abbr : pt.name;
    }
    return emptyvalue !== undefined ? emptyvalue : value;
};
const pitchTypeOrSubType = (value, abbr = false, emptyvalue, translate = null) => {
    const pt = getPitchType(translate, value);
    if (pt) {
        return abbr ? pt.abbr : pt.name;
    }
    const pst = getPitchSubType(translate, value);
    if (pst) {
        return abbr ? pst.abbr : pst.name;
    }
    return emptyvalue !== undefined ? emptyvalue : value;
};
const pitchSubTypeColor = (type) => {
    var _a, _b, _c, _d;
    if (!type.fxsubtype) {
        return pitchTypeColor((_b = (_a = type.fxtype) !== null && _a !== void 0 ? _a : type.pitchtype) !== null && _b !== void 0 ? _b : type.type);
    }
    return (_d = (_c = getPitchSubType(null, type.fxsubtype)) === null || _c === void 0 ? void 0 : _c.color) !== null && _d !== void 0 ? _d : PITCH_TYPES(null)[0].color;
};
const repertoireColor = (repertoire, type) => {
    const orderedRepertoire = repertoire
        .map((r) => ({ fxtype: r.fxtype, fxsubtype: r.fxsubtype, color: undefined }))
        .sort((a, b) => (a.fxtype === b.fxtype ? (a.fxsubtype - b.fxsubtype) : (a.fxtype - b.fxtype)));
    const colors = PITCH_TYPES().filter((pt) => !!pt.id && !!pt.color).map((pt) => ({
        fxtype: pt.id,
        color: pt.color,
    })).sort((a, b) => a.fxtype - b.fxtype);
    for (let i = 0; i < orderedRepertoire.length; i++) {
        const or = orderedRepertoire[i];
        const colorIndex = colors.findIndex((c) => c.fxtype === or.fxtype);
        if (colorIndex >= 0) {
            if (or.fxtype === type.fxtype && or.fxsubtype === type.fxsubtype) {
                return colors[colorIndex].color;
            }
            or.color = colors[colorIndex].color;
            colors.splice(colorIndex, 1);
        }
    }
    for (let i = 0; i < orderedRepertoire.length; i++) {
        const or = orderedRepertoire[i];
        if (!or.color) {
            if (or.fxtype === type.fxtype && or.fxsubtype === type.fxsubtype) {
                return colors[0].color;
            }
            or.color = colors[0].color;
            colors.splice(0, 1);
        }
    }
    return undefined;
};
const pitchTypeDisplayName = (type, abbrFxType, abbrFxSubType, translate = null) => {
    var _a, _b;
    const typeDisplayName = pitchType((_b = (_a = type.fxtype) !== null && _a !== void 0 ? _a : type.pitchtype) !== null && _b !== void 0 ? _b : type.type, abbrFxType, undefined, translate);
    if (!typeDisplayName) {
        return undefined;
    }
    const subTypeDisplayName = pitchSubType(type.fxsubtype, abbrFxSubType, undefined, translate);
    return `${typeDisplayName}${subTypeDisplayName ? ` (${subTypeDisplayName})` : ''}`;
};

dayjs.extend(utc);
dayjs.extend(timezone);
const age = (date) => {
    if (!date)
        return null;
    const ageDays = dayjs().diff(date, 'days');
    return ageDays / 365.242199;
};
const internationalizeDate = (translate, val, yearLong = true, yearShort = false, month = true, day = true, hour = false, minute = false, second = false, amPm = false, isUTC = true, timeZone = 'America/New_York') => {
    let formattedDate = '';
    let dt = (isUTC && typeof val === 'string' && !val.endsWith('Z')) ? `${val}Z` : val;
    dt = dayjs(dt).tz(timeZone);
    if (dt.isValid()) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const formatObject = {};
        if (yearLong) {
            formatObject.year = 'numeric';
        }
        else if (yearShort) {
            formatObject.year = '2-digit';
        }
        if (month) {
            formatObject.month = 'numeric';
        }
        if (day) {
            formatObject.day = 'numeric';
        }
        if (hour) {
            formatObject.hour = 'numeric';
        }
        if (minute) {
            formatObject.minute = 'numeric';
        }
        if (second) {
            formatObject.second = 'numeric';
        }
        if (amPm) {
            formatObject.hour12 = true;
        }
        formattedDate = translate('format.datetime', { val: dt, formatParams: { val: formatObject }, interpolation: { escapeValue: false } });
        return formattedDate;
    }
    return '';
};
const dateTranslate = (translate, val) => internationalizeDate(translate, val, false, true, true, true, false, false, false, false);
const dateTimeTranslate = (translate, val, abbr = true, isUTC = true, timeZone = 'America/New_York') => internationalizeDate(translate, val, !abbr, abbr, true, true, true, true, false, true, isUTC, timeZone);
const militaryTimeTranslate = (translate, val, isUTC = true, timeZone = 'America/New_York') => internationalizeDate(translate, val, false, false, false, false, true, true, false, false, isUTC, timeZone);
// These are the original, non-translation-aware versions for use such as BASE
const date = (val, format = 'M/D/YY') => {
    let formattedDate = '';
    const parsedDate = dayjs(val);
    if (parsedDate.isValid()) {
        formattedDate = parsedDate.format(format);
    }
    return formattedDate;
};
const dateTime = (val, abbr = true, isUTC = true, timeZone = 'America/New_York') => {
    let dt = (isUTC && typeof val === 'string' && !val.endsWith('Z')) ? `${val}Z` : val;
    if (timeZone)
        dt = dayjs(dt).tz(timeZone);
    return date(dt, `M/D/YY${abbr ? '' : 'YY'} h:mm a`);
};

const elide = (str, len) => {
    if (str.length > len)
        return `${str.substring(0, len)}...`;
    return str;
};

const base64ToBlob = (heatmap) => {
    const { ContentType, HeatMapImg } = heatmap;
    if (!ContentType || !HeatMapImg)
        return null;
    // https://stackoverflow.com/a/12300351
    const byteString = atob(HeatMapImg);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: ContentType });
    return URL.createObjectURL(blob);
};

const strengthEvaluationTypes = new Map([
    [1, 'Preseason'],
    [2, 'In-Season'],
    [3, 'Instructional'],
    [4, 'Winter'],
    [5, 'Offseason'],
]);
const workEthics = new Map([
    [1, 'Iron Yankee'],
    [2, 'Champion'],
    [3, 'Competitor'],
    [4, 'Amateur'],
]);
const physicalStrengthEvaluationType = (value) => {
    var _a;
    return (value ? (_a = strengthEvaluationTypes.get(Number(value))) !== null && _a !== void 0 ? _a : null : null);
};
const physicalWorkEthic = (value) => {
    var _a;
    return (value ? (_a = workEthics.get(Number(value))) !== null && _a !== void 0 ? _a : null : null);
};
const weightSources = new Map([
    [1, 'Scale'],
    [2, 'DXA'],
]);
const scanLocations = new Map([
    [1, 'New York'],
    [2, 'Tampa'],
    [3, 'Other'],
]);
const mapPhysicalEnum = (lookup, value) => {
    var _a;
    if (value === null || value === undefined || value === '')
        return null;
    return (_a = lookup.get(Number(value))) !== null && _a !== void 0 ? _a : null;
};
const physicalWeightSource = (value) => (mapPhysicalEnum(weightSources, value));
const physicalScanLocation = (value) => (mapPhysicalEnum(scanLocations, value));

/* eslint-disable react/no-this-in-sfc */
const ABS_ZONE_TOP_PCT = 0.535;
const EXPANDED_ZONE_SIDE = ((17 + (BALL_RADIUS$1 * 2)) / 12 / 2);
const sizesWidth$1 = {
    sm: 230,
    md: 350,
    lg: 500,
};
const sizesHeight$1 = {
    sm: 230,
    md: 350,
    lg: 500,
};
const sizesAxisHeight$1 = {
    sm: 200,
    md: 292,
    lg: 417,
};
const sizesBatterWidth = {
    sm: 80,
    md: 117,
    lg: 167,
};
const sizesBatterHeight = {
    sm: 270,
    md: 383,
    lg: 542,
};
const sizesLhbPosition$1 = {
    sm: { x: -5, y: -40 },
    md: { x: 10, y: -46 },
    lg: { x: 25, y: -58 },
};
const sizesRhbPosition$1 = {
    sm: { x: 145, y: -40 },
    md: { x: 218, y: -46 },
    lg: { x: 317, y: -58 },
};
const sizes$1 = {
    width: sizesWidth$1,
    height: sizesHeight$1,
    axisheight: sizesAxisHeight$1,
    batterwidth: sizesBatterWidth,
    batterheight: sizesBatterHeight,
    lhbposition: sizesLhbPosition$1,
    rhbposition: sizesRhbPosition$1,
};
/** Zone top/bottom annotations scale with chart size so labels stay readable on sm. */
const ZONE_TOP_BTM_METRICS = {
    sm: {
        fontSize: '11px',
        textYOffset: 4,
        leftTextDx: -52,
        leftLineStartDx: -22,
        leftLineEndDx: -6,
        rightTextDx: 28,
        rightLineStartDx: 6,
        rightLineEndDx: 22,
    },
    md: {
        fontSize: '15px',
        textYOffset: 7,
        leftTextDx: -82,
        leftLineStartDx: -34,
        leftLineEndDx: -8,
        rightTextDx: 39,
        rightLineStartDx: 8,
        rightLineEndDx: 34,
    },
    lg: {
        fontSize: '20px',
        textYOffset: 10,
        leftTextDx: -110,
        leftLineStartDx: -45,
        leftLineEndDx: -10,
        rightTextDx: 50,
        rightLineStartDx: 10,
        rightLineEndDx: 45,
    },
};
const ZONE_TOP_BTM_LINE_STROKE = {
    sm: 0.75,
    md: 0.9,
    lg: 1,
};
function isPlateChartSize(s) {
    return typeof s === 'string' && Object.prototype.hasOwnProperty.call(sizesWidth$1, s);
}
const StrikeZonePlate = ({ size = 'lg', enableZoom = true, minX = -2.25, maxX = 2.25, minY = 0.25, maxY = 4.75, height, showbatter = true, showlhb = false, yopposite = false, seriesData, showSeries = true, sztop, szbottom, useABSRulebookZone = true, showZoneTopBtm = true, pitcherView = true, hideGrid = true, showStrikeZone = true, showStrikeZoneBuffer = true, showPlate = true, hideAxis = true, darkMode = false, colorStrikes = false, tooltipFormatter, autoSizeMarkers = true, }) => {
    const resolvedSize = isPlateChartSize(size) ? size : 'lg';
    const ref = useRef(null);
    const elementsRef = useRef({});
    const inUpdateRef = useRef(false);
    const strikeColor = useMemo(() => {
        const v = getComputedStyle(document.documentElement).getPropertyValue('--pitch-strike').trim();
        return v || '#BF0B23';
    }, []);
    const ballColor = useMemo(() => {
        const v = getComputedStyle(document.documentElement).getPropertyValue('--pitch-ball').trim();
        return v || '#3366FF';
    }, []);
    const defaultTooltipFormatter = (_series, point) => {
        if (!point || !isNumber$2(point.x, point.y))
            return false;
        const plateXIn = format(point.x * 12 * (pitcherView ? 1 : -1), 2);
        const plateZIn = format(point.y * 12, 2);
        return `PlateX = ${plateXIn}\u2033<br />PlateZ = ${plateZIn}\u2033`;
    };
    const resolvedTooltipFormatter = tooltipFormatter !== null && tooltipFormatter !== void 0 ? tooltipFormatter : defaultTooltipFormatter;
    const getZoneSide = () => (useABSRulebookZone ? ABS_ZONE_SIDE$1 : EXPANDED_ZONE_SIDE);
    const getZoneTop = () => ((sztop !== null && sztop !== void 0 ? sztop : ABS_ZONE_TOP$1) + (useABSRulebookZone ? 0 : (BALL_RADIUS$1 / 12)));
    const getZoneBtm = () => ((szbottom !== null && szbottom !== void 0 ? szbottom : ABS_ZONE_BOTTOM$1) - (useABSRulebookZone ? 0 : (BALL_RADIUS$1 / 12)));
    const chartSeries = useMemo(() => {
        var _a;
        return (showSeries
            ? ((_a = seriesData === null || seriesData === void 0 ? void 0 : seriesData.map((s) => {
                var _a, _b;
                return (Object.assign(Object.assign({}, s), { data: (_b = (_a = s.data) === null || _a === void 0 ? void 0 : _a.filter((d) => d != null && isNumber$2(d.x, d.y)).map((d) => (Object.assign(Object.assign({}, d), { x: (pitcherView ? d.x : -1 * d.x) })))) !== null && _b !== void 0 ? _b : [] }));
            })) !== null && _a !== void 0 ? _a : [])
            : []);
    }, [seriesData, showSeries, pitcherView]);
    function renderBatter(chart) {
        var _a, _b, _c, _d;
        (_b = (_a = elementsRef.current.batterRender) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.remove();
        if (!showbatter)
            return;
        let img;
        let pos;
        if (pitcherView) {
            img = showlhb ? lhbImgFront : rhbImgFront;
            pos = showlhb ? 'lhb' : 'rhb';
        }
        else {
            img = showlhb ? lhbImgRear : rhbImgRear;
            pos = showlhb ? 'rhb' : 'lhb';
        }
        const positionRow = sizes$1[`${pos}position`];
        const coords = (_c = positionRow[resolvedSize]) !== null && _c !== void 0 ? _c : positionRow.lg;
        const x = (_d = coords === null || coords === void 0 ? void 0 : coords.x) !== null && _d !== void 0 ? _d : 0;
        const w = sizes$1.batterwidth[resolvedSize];
        let h = sizes$1.batterheight[resolvedSize];
        if (sztop) {
            const scalar = (sztop * (1 / ABS_ZONE_TOP_PCT)) / (ABS_ZONE_TOP$1 * (1 / ABS_ZONE_TOP_PCT));
            h *= scalar;
        }
        const y = chart.yAxis[0].toPixels(0, false) - h;
        elementsRef.current.batterRender = chart.renderer
            .image(img, x, y, w, h)
            .attr({ zIndex: 2, opacity: 0.4 })
            .add();
    }
    function renderPlate(chart) {
        var _a, _b;
        (_b = (_a = elementsRef.current.homePlate) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.remove();
        if (!showPlate)
            return;
        const rectattr = {
            'stroke-width': 0,
            stroke: '#c0c0c0',
            fill: '#c0c0c0',
            zIndex: 1,
        };
        const platePath = new Array();
        if (pitcherView) {
            platePath.push('M');
            platePath.push(chart.xAxis[0].toPixels(getZoneSide(), false));
            platePath.push(chart.yAxis[0].toPixels(0, false));
            platePath.push('L');
            platePath.push(chart.xAxis[0].toPixels(getZoneSide() - (1 / 12), false));
            platePath.push(chart.yAxis[0].toPixels(3 / 12, false));
            platePath.push(chart.xAxis[0].toPixels(0, false));
            platePath.push(chart.yAxis[0].toPixels(5 / 12, false));
            platePath.push(chart.xAxis[0].toPixels(-1 * (getZoneSide() - (1 / 12)), false));
            platePath.push(chart.yAxis[0].toPixels(3 / 12, false));
            platePath.push(chart.xAxis[0].toPixels(-1 * getZoneSide(), false));
            platePath.push(chart.yAxis[0].toPixels(0, false));
            platePath.push('Z');
        }
        else {
            platePath.push('M');
            platePath.push(chart.xAxis[0].toPixels(0, false));
            platePath.push(chart.yAxis[0].toPixels(0 / 12, false));
            platePath.push('L');
            platePath.push(chart.xAxis[0].toPixels(getZoneSide(), false));
            platePath.push(chart.yAxis[0].toPixels(2 / 12, false));
            platePath.push(chart.xAxis[0].toPixels(8 / 12, false));
            platePath.push(chart.yAxis[0].toPixels(6 / 12, false));
            platePath.push(chart.xAxis[0].toPixels(-8 / 12, false));
            platePath.push(chart.yAxis[0].toPixels(6 / 12, false));
            platePath.push(chart.xAxis[0].toPixels(-1 * getZoneSide(), false));
            platePath.push(chart.yAxis[0].toPixels(2 / 12, false));
            platePath.push('Z');
        }
        elementsRef.current.homePlate = chart.renderer.path(platePath).attr(rectattr).add();
    }
    function renderStrikeZone(chart) {
        var _a, _b;
        (_a = elementsRef.current.strikeZone) === null || _a === void 0 ? void 0 : _a.forEach((el) => el.element.remove());
        (_b = elementsRef.current.zoneTopBtm) === null || _b === void 0 ? void 0 : _b.forEach((el) => el.element.remove());
        if (!showStrikeZone)
            return;
        const x = chart.xAxis[0].toPixels(-1 * getZoneSide(), false);
        const y = chart.yAxis[0].toPixels(getZoneTop(), false);
        const h = chart.yAxis[0].toPixels(getZoneBtm(), false)
            - chart.yAxis[0].toPixels(getZoneTop(), false);
        const w = chart.xAxis[0].toPixels(getZoneSide(), false)
            - chart.xAxis[0].toPixels(-1 * getZoneSide(), false);
        const outerBoxAttr = {
            stroke: '#000000',
            fill: 'none',
            'stroke-width': 3,
            zIndex: 1,
        };
        const dashedLineAttr = {
            stroke: '#555555',
            fill: 'none',
            'stroke-width': 1,
            dashstyle: 'Dash',
            zIndex: 1,
        };
        if (darkMode) {
            outerBoxAttr.stroke = '#ffffff';
            dashedLineAttr.stroke = '#ffffff';
        }
        elementsRef.current.strikeZone = [
            chart.renderer.rect(x, y, w, h).attr(outerBoxAttr).add(),
        ];
        const innerBoxW = w / 3;
        const innerBoxH = h / 3;
        if (showStrikeZoneBuffer) {
            elementsRef.current.strikeZone.push(chart.renderer.rect(x - innerBoxW, y - innerBoxH, w + (2 * innerBoxW), h + (2 * innerBoxH)).attr(dashedLineAttr).add());
        }
        const startTick = showStrikeZoneBuffer ? 0 : 1;
        const endTick = showStrikeZoneBuffer ? 4 : 3;
        for (let xx = startTick; xx < endTick; xx += 1) {
            elementsRef.current.strikeZone.push(chart.renderer.path([
                'M', x + (xx * innerBoxW), y - (showStrikeZoneBuffer ? innerBoxH : 0),
                'L', x + (xx * innerBoxW), y + h + (showStrikeZoneBuffer ? innerBoxH : 0),
            ]).attr(dashedLineAttr).add());
        }
        for (let yy = startTick; yy < endTick; yy += 1) {
            elementsRef.current.strikeZone.push(chart.renderer.path([
                'M', x - (showStrikeZoneBuffer ? innerBoxW : 0), y + (yy * innerBoxH),
                'L', x + w + (showStrikeZoneBuffer ? innerBoxW : 0), y + (yy * innerBoxH),
            ]).attr(dashedLineAttr).add());
        }
        if (showZoneTopBtm) {
            const zm = ZONE_TOP_BTM_METRICS[resolvedSize];
            const textAttr = {
                fontSize: zm.fontSize,
                color: '#000000',
            };
            const lineAttr = {
                'stroke-width': ZONE_TOP_BTM_LINE_STROKE[resolvedSize],
                stroke: '#555555',
                dashstyle: 'Dash',
            };
            if (darkMode) {
                textAttr.color = '#ffffff';
                lineAttr.stroke = '#ffffff';
            }
            const topTextPos = chart.yAxis[0].toPixels(getZoneTop(), false);
            const btmTextPos = chart.yAxis[0].toPixels(getZoneBtm(), false);
            const lsidepos = chart.xAxis[0].toPixels((-1 * getZoneSide()), false) - (showStrikeZoneBuffer ? innerBoxW : 0);
            let sideTextPos = lsidepos + zm.leftTextDx;
            let lineStartPos = lsidepos + zm.leftLineStartDx;
            let lineEndPos = lsidepos + zm.leftLineEndDx;
            if ((showbatter && !showlhb && !pitcherView) || (showbatter && showlhb && pitcherView)) {
                const rsidepos = chart.xAxis[0].toPixels(getZoneSide(), false) + (showStrikeZoneBuffer ? innerBoxW : 0);
                sideTextPos = rsidepos + zm.rightTextDx;
                lineStartPos = rsidepos + zm.rightLineStartDx;
                lineEndPos = rsidepos + zm.rightLineEndDx;
            }
            const topLabel = format(getZoneTop() * 12.0, 1);
            const btmLabel = format(getZoneBtm() * 12.0, 1);
            elementsRef.current.zoneTopBtm = [
                chart.renderer.text(`${topLabel}\u2033`, sideTextPos, topTextPos + zm.textYOffset).css(textAttr).add(),
                chart.renderer
                    .path(['M', lineStartPos, topTextPos, 'L', lineEndPos, topTextPos])
                    .attr(lineAttr).add(),
                chart.renderer.text(`${btmLabel}\u2033`, sideTextPos, btmTextPos + zm.textYOffset).css(textAttr).add(),
                chart.renderer
                    .path(['M', lineStartPos, btmTextPos, 'L', lineEndPos, btmTextPos])
                    .attr(lineAttr).add(),
            ];
        }
    }
    function redraw() {
        var _a, _b;
        const chart = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) !== null && _b !== void 0 ? _b : null;
        if (!chart)
            return;
        renderStrikeZone(chart);
        renderBatter(chart);
        renderPlate(chart);
    }
    function updateMarkers(chart) {
        if (inUpdateRef.current)
            return;
        inUpdateRef.current = true;
        const axis = chart.yAxis[0];
        const rPx = Math.abs(axis.toPixels(BALL_RADIUS$1 / 12, false) - axis.toPixels(0, false));
        chart.series.forEach((s) => {
            if (s.type && s.type !== 'scatter')
                return;
            const scatterOpts = s.options;
            if (!scatterOpts.marker || typeof scatterOpts.marker !== 'object')
                return;
            if (autoSizeMarkers) {
                // eslint-disable-next-line no-param-reassign
                scatterOpts.marker.radius = rPx;
            }
            if (colorStrikes) {
                s.points.forEach((point) => {
                    if (!point || !isNumber$2(point.x, point.y))
                        return;
                    const strike = isABSStrike(point.x, point.y, (sztop !== null && sztop !== void 0 ? sztop : ABS_ZONE_TOP$1), (szbottom !== null && szbottom !== void 0 ? szbottom : ABS_ZONE_BOTTOM$1));
                    if (strike) {
                        point.update({ marker: { fillColor: strikeColor } }, false);
                    }
                    else {
                        point.update({ marker: { fillColor: ballColor } }, false);
                    }
                });
            }
        });
        chart.redraw(false);
        inUpdateRef.current = false;
    }
    useEffect(() => {
        var _a, _b;
        redraw();
        const chart = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) !== null && _b !== void 0 ? _b : null;
        if (chart)
            updateMarkers(chart);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        chartSeries,
        useABSRulebookZone,
        sztop,
        szbottom,
        showStrikeZone,
        showStrikeZoneBuffer,
        showPlate,
        showbatter,
        showlhb,
        darkMode,
        showZoneTopBtm,
        colorStrikes,
        strikeColor,
        ballColor,
        resolvedSize,
        pitcherView,
    ]);
    let margin;
    if (resolvedSize === 'lg')
        margin = [50, 50, 50, 50];
    else if (resolvedSize === 'md')
        margin = [26, 26, 26, 28];
    else
        margin = [0, 0, 0, 17];
    const hideChartTicksAndGrids = false;
    const chartConfig = {
        chart: {
            type: 'scatter',
            height: height !== null && height !== void 0 ? height : sizes$1.height[resolvedSize],
            width: sizes$1.width[resolvedSize],
            zoomType: enableZoom ? 'xy' : undefined,
            spacing: [10, 10, 15, 10],
            backgroundColor: 'transparent',
            plotBackgroundColor: 'transparent',
            margin,
            events: {
                selection() {
                    return false;
                },
                load() {
                    updateMarkers(this);
                },
                redraw() {
                    updateMarkers(this);
                },
            },
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                turboThreshold: 0,
                dataLabels: {
                    allowOverlap: true,
                    crop: false,
                    overflow: 'justify',
                },
                point: {
                    events: {
                        click() {
                            return null;
                        },
                    },
                },
                states: {
                    inactive: {
                        opacity: 0.2,
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            visible: !hideAxis,
            height: sizes$1.axisheight[resolvedSize],
            width: sizes$1.axisheight[resolvedSize],
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            lineColor: undefined,
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
            },
        },
        yAxis: {
            visible: !hideAxis,
            height: sizes$1.axisheight[resolvedSize],
            width: sizes$1.axisheight[resolvedSize],
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: yopposite,
            lineColor: undefined,
            title: {
                text: null,
            },
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
                x: yopposite ? 5 : -5,
            },
        },
        tooltip: {
            formatter() {
                if (!this.point)
                    return false;
                const out = resolvedTooltipFormatter(this.series, this.point);
                if (out === false)
                    return false;
                return out;
            },
            outside: true,
        },
        series: chartSeries,
        title: {
            align: 'center',
            floating: true,
            verticalAlign: 'top',
            text: undefined,
        },
        credits: {
            enabled: false,
        },
    };
    return (React.createElement("div", { style: { height: sizes$1.height[resolvedSize] } },
        React.createElement(BaseChart, { ref: ref, width: sizes$1.width[resolvedSize], options: chartConfig, useBodyFont: false, style: { marginTop: 'auto' }, className: "strikeZonePlateChart" })));
};

const Container$l = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
function onSeriesAssignment$1(series, pointshrinkcutoff) {
    const numScatterPoints = series
        .filter((s) => !s.type || s.type === 'scatter')
        .map((x) => (x.data ? x.data.length : 0))
        .reduce((a, b) => a + b, 0);
    if (numScatterPoints <= pointshrinkcutoff) {
        return series;
    }
    const computedSeries = series.map((s) => {
        var _a;
        if (s.type && s.type !== 'scatter')
            return s;
        return Object.assign(Object.assign({}, s), { marker: Object.assign(Object.assign({}, s.marker), { radius: !((_a = s.marker) === null || _a === void 0 ? void 0 : _a.radius) ? 2 : Math.max(1, s.marker.radius - 2) }) });
    });
    return computedSeries;
}
const PitchChart = ({ titleX, titleY, maxY, minY, minRangeY, yplotbands, seriesData, dataPoints, pitchVideoFn, modalContainer, videoPlayerModal: VideoPlayerModal, width = 260, enableZoom = true, pointshrinkcutoff = 250, scaleY = 1, subscaleY = 0.25, onClick, minX = 0, xAxisType, yAxisLabels, yTooltipFormatter, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$l, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            width,
            height: width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (onClick)
                                return onClick(this);
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                            return null;
                        },
                    },
                },
            },
            spline: {
                allowPointSelect: false,
                enableMouseTracking: false,
                lineWidth: 1,
                marker: {
                    enabled: false,
                },
            },
        },
        legend: {
            enabled: true,
            x: 30,
            align: 'center',
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            min: minX,
            max: null,
            gridLineWidth: 0,
            tickInterval: 10,
            tickLength: 6,
            minorTickInterval: 5,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleX,
            },
            plotBands: seriesData.inningBreaks,
            type: xAxisType,
        },
        yAxis: {
            min: minY,
            max: maxY,
            minRange: minRangeY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: scaleY,
            tickLength: 6,
            minorTickInterval: subscaleY,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: true,
            endOnTick: true,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: titleY,
            },
            labels: yAxisLabels || {
                formatter() {
                    // hack for spinrate RPMs
                    if (this.value >= 1000)
                        return (Number(this.value) / 1000).toFixed(1);
                    return this.value.toString();
                },
            },
            plotBands: yplotbands,
        },
        tooltip: {
            formatter() {
                var _a;
                if (!this.point.tooltip)
                    return null;
                let tooltip = `<b>${this.series.name}: ${(_a = this.point.y) === null || _a === void 0 ? void 0 : _a.toFixed(2)}</b><br/>`;
                if (yTooltipFormatter != null)
                    tooltip = `<b>${this.series.name}: ${yTooltipFormatter(this.point.y)}</b><br/>`;
                tooltip += this.point.tooltip;
                return tooltip;
            },
        },
        series: onSeriesAssignment$1(seriesData, pointshrinkcutoff),
        title: {
            text: undefined,
            align: 'center',
            floating: true,
            verticalAlign: 'top',
        },
    };
    // Adjust series
    const seriesDataData = seriesData.flatMap((x) => x.data).map(({ y }) => y || 0);
    const newMinY = seriesDataData.length ? Math.min(...seriesDataData) : null;
    const newMaxY = seriesDataData.length ? Math.max(...seriesDataData) : null;
    // Adjust yAxis
    if (minRangeY && newMaxY != null && newMinY != null && (newMaxY - newMinY < minRangeY)) {
        const md = ((newMaxY - newMinY) / 2) + newMinY;
        const min = Math.floor((md - (minRangeY / 2)) * 4) / 4;
        const max = min + minRangeY;
        chartConfig.yAxis.min = min;
        chartConfig.yAxis.max = max;
    }
    // Adjust xAxis
    let xtick;
    let xsubtick;
    let labelinterval;
    if (dataPoints >= 100) {
        xtick = 5;
        xsubtick = 5;
        labelinterval = 20;
    }
    else if (dataPoints >= 40) {
        xtick = 5;
        xsubtick = 5;
        labelinterval = 10;
    }
    else if (dataPoints >= 20) {
        xtick = 5;
        xsubtick = 1;
    }
    else if (dataPoints >= 10) {
        xtick = 2;
        xsubtick = 1;
    }
    else {
        xtick = 1;
        xsubtick = 1;
    }
    chartConfig.xAxis = Object.assign(Object.assign({}, chartConfig.xAxis), { max: dataPoints, tickInterval: xtick, minorTickInterval: xsubtick, labels: {
            formatter() {
                if (xAxisType === 'datetime')
                    return internationalizeDate(translate, this.value, false, true, true, true);
                if (!labelinterval || (Number(this.value) % labelinterval === 0))
                    return this.value.toString();
                return '';
            },
        } });
    return (React.createElement(Container$l, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false, className: "pitchChart" })));
};

class WebGLPathDisplay extends Component {
    constructor(props) {
        super(props);
        this.pathDisplayContainer = React.createRef();
        this.texturesLoading = 0;
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera();
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
    }
    componentDidMount() {
        this.init(this.props);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.strikeZone !== this.props.strikeZone || nextProps.pitches !== this.props.pitches;
    }
    componentDidUpdate() {
        this.init(this.props);
    }
    setupBallpark(scene) {
        this.texturesLoading += 1;
        const ifDirtTexture = new THREE.TextureLoader().load(baseballDirt, (texture) => {
            texture.wrapT = THREE.RepeatWrapping;
            texture.wrapS = texture.wrapT;
            texture.offset.set(0, 0);
            texture.repeat.set(0.25, 0.25);
            this.texturesLoading -= 1;
        });
        this.texturesLoading += 1;
        const ifGrassTexture = new THREE.TextureLoader().load(ifGrass, (texture) => {
            texture.wrapT = THREE.RepeatWrapping;
            texture.wrapS = texture.wrapT;
            texture.offset.set(0, 0);
            texture.repeat.set(44, 44);
            this.texturesLoading -= 1;
        });
        const planeGeometry = new THREE.PlaneGeometry(440, 460);
        const planeMaterial = new THREE.MeshPhongMaterial({ color: 0x007700, specular: 0x111111, shininess: 10, map: ifGrassTexture });
        const plane = new THREE.Mesh(planeGeometry, planeMaterial);
        plane.position.y = 155;
        plane.position.x = 3.2;
        plane.position.z = 0;
        plane.receiveShadow = true;
        scene.add(plane);
        const pitchersMound = {
            x: 0,
            y: 59,
            radius: 9,
            extrudeSettings: { steps: 2, depth: 0.1, bevelEnabled: true, bevelThickness: 0.1, bevelSize: 1, bevelSegments: 1 },
            material: new THREE.MeshPhongMaterial({ color: 0xffab87, wireframe: false, specular: 0x111111, shininess: 10, map: ifDirtTexture }),
        };
        this.drawCircleExtrude(pitchersMound);
        const homeCircle = {
            x: 0,
            y: 0,
            radius: 13,
            extrudeSettings: { steps: 2, depth: 0.1, bevelEnabled: false },
            material: new THREE.MeshPhongMaterial({ color: 0xffab87, wireframe: false, specular: 0x111111, shininess: 10, map: ifDirtTexture }),
        };
        this.drawCircleExtrude(homeCircle);
        const homePlate = {
            x: 0,
            y: 0,
            points: [{ x: 0.70835, y: 0.70835 }, { x: 0, y: 0.70835 }, { x: -1.4167, y: 0 }, { x: 0, y: -0.70835 }, { x: 0.70835, y: -0.70835 }],
            extrudeSettings: { depth: 0.25, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf2f2f2, wireframe: false }),
        };
        this.drawPolygonExtrude(homePlate);
        const pitchersRubber = {
            x: -1,
            y: 60.5,
            points: [{ x: 2, y: 0 }, { x: 0, y: 0.5 }, { x: -2, y: 0 }, { x: 0, y: -0.5 }],
            extrudeSettings: { depth: 0.35, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf2f2f2, wireframe: false }),
        };
        this.drawPolygonExtrude(pitchersRubber);
        const szGeometry = new THREE.BufferGeometry().setFromPoints([
            new THREE.Vector3(-0.833, 1.4167, 1.595),
            new THREE.Vector3(-0.833, 1.4167, 3.365),
            new THREE.Vector3(0.833, 1.4167, 3.365),
            new THREE.Vector3(0.833, 1.4167, 1.595),
            new THREE.Vector3(-0.833, 1.4167, 1.595),
        ]);
        const szMaterial = new THREE.LineBasicMaterial({ color: 0xf0f0f0 });
        const szObject = new THREE.Line(szGeometry, szMaterial);
        scene.add(szObject);
        const ifDirt = {
            x: 0,
            y: 0,
            points: [{ x: 63.64, y: 63.64 }, { x: -63.64, y: 63.64 }, { x: -63.64, y: -63.64 }, { x: 63.64, y: -63.64 }],
            holex: 0,
            holey: 4.24,
            hole: [{ x: 59.4, y: 59.4 }, { x: -59.4, y: 59.4 }, { x: -59.4, y: -59.4 }, { x: 59.4, y: -59.4 }],
            extrudeSettings: { depth: 0.1, bevelEnabled: false },
            material: new THREE.MeshPhongMaterial({ color: 0xffab87, wireframe: false, specular: 0x111111, shininess: 10, map: ifDirtTexture }),
        };
        this.drawPolygonExtrude(ifDirt);
        const lhhBattersBox = {
            x: 1.2083,
            y: 3.7083,
            points: [{ x: 4, y: 0 }, { x: 0, y: -6 }, { x: -4, y: 0 }, { x: 0, y: 6 }],
            holex: 1.4166,
            holey: 3.5,
            hole: [{ x: 3.5834, y: 0 }, { x: 0, y: -5.5834 }, { x: -3.5834, y: 0 }, { x: 0, y: 5.5834 }],
            extrudeSettings: { depth: 0.25, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf0f0f0, wireframe: false }),
        };
        this.drawPolygonExtrude(lhhBattersBox);
        const rhhBattersBox = {
            x: -1.2083,
            y: 3.7083,
            points: [{ x: -4, y: 0 }, { x: 0, y: -6 }, { x: 4, y: 0 }, { x: 0, y: 6 }],
            holex: -1.4166,
            holey: 3.5,
            hole: [{ x: -3.5834, y: 0 }, { x: 0, y: -5.5834 }, { x: 3.5834, y: 0 }, { x: 0, y: 5.5834 }],
            extrudeSettings: { depth: 0.25, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf0f0f0, wireframe: false }),
        };
        this.drawPolygonExtrude(rhhBattersBox);
    }
    init({ pitches, strikeZone, width, height, view = 'catcher', disableControls = false, showBackdrop = false, showBall = true, }) {
        const container = this.pathDisplayContainer.current;
        container.innerHTML = '';
        this.scene = new THREE.Scene();
        if (showBackdrop) ;
        else {
            new THREE.TextureLoader().load(blueSky, (texture) => { this.scene.background = texture; });
        }
        this.camera = new THREE.PerspectiveCamera(70, width / height, 1, 2000);
        this.camera.up = new THREE.Vector3(0, 0, 1);
        this.scene.add(this.camera);
        this.scene.add(new THREE.AmbientLight(0xf0f0f0));
        const light = new THREE.SpotLight(0xffffff, 1.5);
        light.position.set(0, 350, 200);
        light.castShadow = true;
        light.shadow.camera.fov = 70;
        light.shadow.camera.near = 200;
        light.shadow.camera.far = 2000;
        light.shadow.bias = -0.000222;
        light.shadow.mapSize.width = 1024;
        light.shadow.mapSize.height = 1024;
        this.scene.add(light);
        this.texturesLoading = 0;
        this.setupBallpark(this.scene);
        if (strikeZone)
            this.buildStrikeZone(strikeZone);
        if (showBall)
            this.buildBall(pitches);
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(width, height);
        this.renderer.shadowMap.enabled = true;
        container.appendChild(this.renderer.domElement);
        const direction = new THREE.Vector3();
        this.camera.getWorldDirection(direction);
        // Controls
        this.controls = undefined;
        if (!disableControls) {
            this.controls = new OrbitControls(this.camera, this.renderer.domElement);
            this.controls.dampingFactor = 0.2; // inertia factor when dragging
            this.controls.zoomSpeed = 0.5;
            this.controls.rotateSpeed = 0.1;
            this.controls.maxDistance = 925; // prevent from zooming out so far that the background goes off-scene
            this.controls.addEventListener('change', this.renderScene.bind(this));
            this.controls.target.addScaledVector(direction, 0);
        }
        switch (view) {
            case 'catcher':
                this.camera.position.set(0, -1.5, 1.78);
                if (this.controls) {
                    this.controls.target.set(0, 56, 6);
                }
                else {
                    this.camera.lookAt(0, 55, 1.79);
                }
                break;
            case 'rhh':
                this.camera.position.set(-2.5, -1, 5.25);
                if (this.controls)
                    this.controls.target.set(0, 56, 6);
                break;
            case 'lhh':
                this.camera.position.set(2.5, -1, 5.25);
                if (this.controls)
                    this.controls.target.set(0, 56, 6);
                break;
            case 'side':
                this.camera.position.set(-18, 25, 2.25);
                if (this.controls)
                    this.controls.target.set(0, 25, 2.25);
                break;
            case 'overhead':
                this.camera.position.set(-0.01, 25, 25);
                if (this.controls)
                    this.controls.target.set(0.01, 25, 0.5);
                break;
            default:
                this.camera.position.set(0, 55, 10.25);
                if (this.controls)
                    this.controls.target.set(-10, 0, 0);
                break;
        }
        if (this.controls)
            this.controls.update();
        pitches.forEach((pitch) => {
            const points = new Array();
            pitch.positions.forEach((pos) => {
                points.push(new THREE.Vector3(pos.posx, pos.posy, pos.posz));
            });
            const curve = new THREE.CatmullRomCurve3(points);
            const geometry = new THREE.TubeGeometry(curve, 64, 0.055, 8, false);
            const mesh = new THREE.Mesh(geometry, pitch.meshphongmaterial);
            this.scene.add(mesh);
            const circlegeometry = new THREE.CircleGeometry(0.085, 32);
            const circle = new THREE.Mesh(circlegeometry, pitch.meshphongmaterial);
            circle.position.x = pitch.platelocpitch.posx;
            circle.position.y = pitch.platelocpitch.posy;
            circle.position.z = pitch.platelocpitch.posz;
            circle.rotation.x = Math.PI / 2;
            this.scene.add(circle);
        });
        // TODO: add tooltips like http://jsfiddle.net/mmalex/ycnh0wze/
        this.renderer.render(this.scene, this.camera);
        this.animate();
    }
    buildBall(pitches) {
        pitches.forEach((pitch) => {
            if (!pitch.pitcherid || pitch.pitcherid > 2) {
                const geometry = new THREE.SphereGeometry(0.12, 32, 32, 0, Math.PI * 2, 0, Math.PI);
                this.texturesLoading += 1;
                const texture = new THREE.TextureLoader().load(baseballWLogo, () => { this.texturesLoading -= 1; });
                const material = new THREE.MeshBasicMaterial({
                    map: texture,
                });
                const ball = new THREE.Mesh(geometry, material);
                ball.position.z = pitch.platelocpitch.posz;
                ball.position.y = pitch.platelocpitch.posy;
                ball.position.x = pitch.platelocpitch.posx;
                this.scene.add(ball);
            }
        });
    }
    /*
    buildBackdrop() {
        var backdropTexture = new THREE.TextureLoader().load('/bbops/Content/images/webgltextures/yankeestadiumbackdrop.png');
        var backdropGeometry = new THREE.PlaneGeometry(968, 374);
        backdropGeometry.rotateX(Math.PI/2);
        var backdropMaterial = new THREE.MeshPhongMaterial({ needsUpdate: true, map: backdropTexture });
        var backdrop = new THREE.Mesh(backdropGeometry, backdropMaterial);
        backdrop.position.y = 460;
        backdrop.position.z = 187;
        scene.add(backdrop);
    }
    */
    buildStrikeZone(strikeZone) {
        if (strikeZone.length) {
            const szHPoints = strikeZone.map((point) => new THREE.Vector3(point.platex, 1.4167, point.platez));
            szHPoints.push(new THREE.Vector3(strikeZone[0].platex, 1.4167, strikeZone[0].platez));
            const szHGeometry = new THREE.BufferGeometry().setFromPoints(szHPoints);
            const szHMaterial = new THREE.LineBasicMaterial({ color: 0xff0000 });
            const szHObject = new THREE.Line(szHGeometry, szHMaterial);
            this.scene.add(szHObject);
        }
    }
    drawCircleExtrude(shape) {
        const sh = new THREE.Shape();
        const { x } = shape;
        const { y } = shape;
        const { radius } = shape;
        sh.moveTo(x, y + radius);
        sh.quadraticCurveTo(x + radius, y + radius, x + radius, y);
        sh.quadraticCurveTo(x + radius, y - radius, x, y - radius);
        sh.quadraticCurveTo(x - radius, y - radius, x - radius, y);
        sh.quadraticCurveTo(x - radius, y + radius, x, y + radius);
        const shGeometry = new THREE.ExtrudeGeometry(sh, shape.extrudeSettings);
        const shMesh = new THREE.Mesh(shGeometry, shape.material);
        this.scene.add(shMesh);
    }
    drawPolygonExtrude(shape) {
        const sh = new THREE.Shape();
        let { x } = shape;
        let { y } = shape;
        sh.moveTo(x, y);
        shape.points.forEach((point) => {
            sh.bezierCurveTo(x, y, x + point.x, y + point.y, x + point.x, y + point.y);
            x += point.x;
            y += point.y;
        });
        if (shape.hole && shape.holex && shape.holey) {
            const h = new THREE.Shape();
            let hx = shape.holex;
            let hy = shape.holey;
            h.moveTo(hx, hy);
            shape.hole.forEach((point) => {
                h.bezierCurveTo(hx, hy, hx + point.x, hy + point.y, hx + point.x, hy + point.y);
                hx += point.x;
                hy += point.y;
            });
            sh.holes.push(h);
        }
        const shGeometry = new THREE.ExtrudeGeometry(sh, shape.extrudeSettings);
        const shMesh = new THREE.Mesh(shGeometry, shape.material);
        this.scene.add(shMesh);
    }
    animate() {
        if (this.controls || this.texturesLoading > 0) {
            window.requestAnimationFrame(this.animate.bind(this));
            if (this.controls)
                this.controls.update();
        }
        this.renderScene();
    }
    renderScene() {
        this.camera.updateMatrixWorld();
        this.renderer.render(this.scene, this.camera);
    }
    render() {
        return (React.createElement("div", { ref: this.pathDisplayContainer }));
    }
}

const StyledHeatMap = styled.div `
    height: ${(props) => props.height - 40}px !important;
    width: ${(props) => props.width}px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    > div {
        position: relative;        
        overflow: hidden;
        height: ${(props) => props.height - 12}px;
        width: 100%;
        > img {
            z-index: 101;
            position: absolute;
            height: ${(props) => props.height - 50}px;
            left: ${(props) => ((props.reverse ? !props.islhb : props.islhb) ? 0 : 135)}px;
            top: 0px;
        }
        > div {
            width: 100%;
            margin-top: 150px;
            text-align: center;
        }
        > span > img {
            position: absolute;
            z-index: 100;
            width: ${(props) => props.width + (props.isHeatMap3 ? -5.5 : 20)}px;
            height: ${(props) => props.height + (props.isHeatMap3 ? 3 : 18)}px;
            top: -20px;
            left: ${(props) => {
    const leftLhb = props.isHeatMap3 ? 16 : -23;
    const leftRhb = props.isHeatMap3 ? -12 : -20;
    return `${(props.reverse ? !props.islhb : props.islhb) ? leftLhb : leftRhb}px`;
}};
            ${(props) => (props.reverse ? 'transform: scaleX(-1);' : '')}
        }
    }
`;
const StyledOuterHeatMap = styled.div `
    {
        margin-left: ${(props) => (props.islhb ? -15 : 0)}px !important;
    }
`;
const HeatMap = ({ islhb, src = null, srcAlt = null, showAlt = false, height = 290, width = 240, catcherPerspective = false, isHeatMap3 }) => {
    const { t: translate } = useTranslation();
    let batterImg;
    if (catcherPerspective) {
        batterImg = islhb ? lhbImgRear : rhbImgRear;
    }
    else {
        batterImg = islhb ? lhbImgFront : rhbImgFront;
    }
    return (React.createElement(StyledHeatMap, { height: height, width: width, islhb: islhb, reverse: catcherPerspective, isHeatMap3: !!isHeatMap3 },
        React.createElement(StyledOuterHeatMap, { islhb: islhb },
            React.createElement(Image, { src: batterImg, alt: "" }),
            !src && React.createElement("div", null, translate('components.charts.not-enough-data')),
            src && (React.createElement("span", null,
                React.createElement(Image, { src: (srcAlt && showAlt) ? srcAlt : src }))))));
};

const StyledHeatmapSVGOverlay = styled.svg `
    position: absolute;
    top: ${({ $padding }) => $padding}px;
    left: ${({ $padding }) => $padding}px;
`;
const StyledHeatMapContainer = styled.div `
    position: relative;
    max-width: ${({ $width }) => $width}px;
    > img {
        width: 100%;
        ${({ $reverse }) => ($reverse ? 'transform: scaleX(-1);' : '')}
    }
`;
const StyledHeatMapImgBackground = styled.div `
    background-color: white;
    position: absolute;
    z-index: -1;
    ${({ $padding }) => `
        width: calc(100% - ${2 * $padding}px);
        height: calc(100% - ${2 * $padding}px);
        margin: ${$padding}px ${$padding}px;
    `};
`;
const HeatMapImgContainer = ({ type, src, children, plateX, plateZ, size = 150, includeBackground = false, reverse = false }) => {
    const { height, width, padding } = getHeatmapSizeByType(type, size);
    return (React.createElement(StyledHeatMapContainer, { "$width": size, "$reverse": reverse },
        includeBackground && React.createElement(StyledHeatMapImgBackground, { "$padding": padding }),
        React.createElement(Image, { src: src }),
        children,
        isNumber$2(plateX, plateZ) && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": padding, height: height, width: width },
            React.createElement("circle", { cx: (width / 2) + (inRange(plateX, -1.65, 1.65) / 1.65 * (width / 2)), cy: height - (inRange(plateZ - 0.4, 0, 4.35) / 4.35 * height), r: "5", fill: "black" }),
            React.createElement("circle", { cx: (width / 2) + (inRange(plateX, -1.65, 1.65) / 1.65 * (width / 2)), cy: height - (inRange(plateZ - 0.4, 0, 4.35) / 4.35 * height), r: "3", fill: "white" })))));
};

const StyledCatcherWristbandBadge = styled.div `
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    text-align: center;
    z-index: 99;
    font-size: ${({ $fontSize }) => $fontSize + 3}px;
    -webkit-print-color-adjust: exact;
    padding: ${({ $size }) => $size / 15}px ${({ $grade, $size }) => $size / ($grade === 10 ? 18.75 : 10)}px;
    background-color: ${({ $grade, $bluetowhite }) => {
    if ($grade === 0)
        return $bluetowhite ? '#FFFFFF' : '#013220';
    if ($grade === 1)
        return $bluetowhite ? '#E0E8EF' : '#335B4C';
    if ($grade === 2)
        return $bluetowhite ? '#C1D1DE' : '#668479';
    if ($grade === 3)
        return $bluetowhite ? '#A2B9CD' : '#99ADA5';
    if ($grade === 4)
        return $bluetowhite ? '#83A2BC' : '#FFFFFF';
    if ($grade === 5)
        return $bluetowhite ? '#648BAA' : '#FFFFFF';
    if ($grade === 6)
        return $bluetowhite ? '#457499' : '#FFFFFF';
    if ($grade === 7)
        return $bluetowhite ? '#265D88' : '#D09999';
    if ($grade === 8)
        return $bluetowhite ? '#074577' : '#B96666';
    if ($grade === 9)
        return $bluetowhite ? '#00345F' : '#A23333';
    if ($grade === 10)
        return $bluetowhite ? '#002244' : '#8B0000';
    return '#FFFFFF';
}};
    font-weight: ${({ $bluetowhite }) => ($bluetowhite ? 'bold' : 'normal')};
    color: ${({ $grade, $bluetowhite }) => {
    if ($grade < 3)
        return $bluetowhite ? '#002244' : '#FFFFFF';
    if ($grade === 3)
        return $bluetowhite ? '#002244' : '#013220';
    if ($grade === 4)
        return $bluetowhite ? '#FFFFFF' : '#013220';
    if ($grade === 5)
        return $bluetowhite ? '#FFFFFF' : '#000000';
    if ($grade === 6)
        return $bluetowhite ? '#FFFFFF' : '#8B0000';
    if ($grade > 6)
        return $bluetowhite ? '#FFFFFF' : '#FFFFFF';
    return '#FFFFFF';
}};
    border: 1px solid ${({ $grade, $bluetowhite }) => {
    if ($grade < 5)
        return $bluetowhite ? '#002244' : '#00FF00';
    if ($grade === 5)
        return $bluetowhite ? '#002244' : '#000000';
    return $bluetowhite ? '#002244' : '#FF0000';
}};
`;
const CatcherWristbandHeatMap = ({ is2K, plateX, plateZ, src = null, grade = null, gradetext = null, size = 150, redX = false, greenBox = false, dashGreenBox = false, selected = false, otz = false, kFree = false, includeBackground = false, isCatcherPerspective = false, isbluetowhite = false, }) => {
    const { t: translate } = useTranslation();
    const { width, height, padding: heatMapPadding } = getHeatmapSizeByType(heatMapModelIds.CatcherWristband, size);
    const fontSize = 0.14 * size;
    return (React.createElement(HeatMapImgContainer, { size: size, type: heatMapModelIds.CatcherWristband, src: src || blankHeatMap, plateX: plateX, plateZ: plateZ, includeBackground: includeBackground, reverse: isCatcherPerspective },
        isNumber$2(grade) && (React.createElement(StyledCatcherWristbandBadge, { "$grade": grade, "$fontSize": fontSize + (gradetext === null ? 3 : -3), "$size": size, "$bluetowhite": isbluetowhite }, gradetext || grade)),
        redX && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            React.createElement("line", { x1: "3", y1: "3", x2: width - 3, y2: height - 3, style: { stroke: 'rgb(0,0,0)', strokeWidth: 2 } }),
            React.createElement("line", { x1: width - 3, y1: "3", x2: "3", y2: height - 3, style: { stroke: 'rgb(0,0,0)', strokeWidth: 2 } }))),
        greenBox && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            React.createElement("rect", { x: "0", y: "0", width: width, height: height, style: { fill: 'none', stroke: '#008000', strokeWidth: 3 + Math.ceil(height / 100) } }))),
        dashGreenBox && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            React.createElement("rect", { x: "0", y: "0", width: width, height: height, style: { fill: 'none', stroke: '#000000', strokeWidth: 3 + Math.ceil(height / 100) } }))),
        selected && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            !!src && (React.createElement(React.Fragment, null,
                React.createElement("text", { x: "5", y: "20", fontSize: fontSize, fill: "#000" }, is2K ? '3-2' : '0-0'),
                React.createElement("text", { x: width - (fontSize - 16) - (!is2K && kFree ? 46 : 32), y: height - 4, fontSize: fontSize, fill: "#000" }, is2K ? '3-2' : '0-0'),
                !is2K && kFree && (
                // eslint-disable-next-line react/no-unknown-property
                React.createElement("g", { transform: "scale (-1, 1)", "transform-origin": "center" },
                    React.createElement("text", { x: width - 49, y: "20", fontSize: fontSize, fill: "#000" }, translate('baseball.abbr-strikeout-k')),
                    React.createElement("text", { x: "7", y: height - 4, fontSize: fontSize, fill: "#000" }, translate('baseball.abbr-strikeout-k')))))),
            !src && (React.createElement(React.Fragment, null,
                React.createElement("text", { x: (width / 2) - (!is2K && kFree ? 22 : 15), y: height / 2, fontSize: fontSize, fill: "#000" }, is2K ? '3-2' : '0-0'),
                !is2K && kFree && (
                // eslint-disable-next-line react/no-unknown-property
                React.createElement("g", { transform: "scale (-1, 1)", "transform-origin": "center" },
                    React.createElement("text", { x: (width / 2) - 22, y: height / 2, fontSize: fontSize, fill: "#000" }, translate('baseball.abbr-strikeout-k')))))))),
        is2K && otz && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            !!src && (React.createElement(React.Fragment, null,
                !selected && React.createElement("text", { x: "5", y: "20", fontSize: fontSize, fill: "#000" }, translate('components.charts.abbr-out-zone')),
                React.createElement("text", { x: "5", y: height - 4, fontSize: fontSize, fill: "#000" }, translate('components.charts.abbr-out-zone')))),
            !src && (React.createElement("text", { x: (width / 2) - 14, y: (height / 2) + 20, fontSize: fontSize, fill: "#000" }, translate('components.charts.abbr-out-zone')))))));
};

const StyledBallSpin = styled.div `
    border-radius: 10px;
    overflow: hidden;
    canvas {
        border-radius: 10px;
    }
`;
class BallSpin extends Component {
    constructor(props) {
        super(props);
        this.ball = null;
        this.camera = null;
        this.renderer = null;
        this.scene = null;
        this.ballSpinContainer = createRef();
        // there is an issue with rotation speeds when rerendering the component
        // this count is here to reset the recursive animation process
        this.renderCount = 0;
        this.texturesLoading = 0;
        this.animate = this.animate.bind(this);
        this.init = this.init.bind(this);
        this.axis = new THREE.Vector3(1, 0, 0).normalize();
        this.axis.applyAxisAngle(new THREE.Vector3(0, 0, 1).normalize(), THREE.MathUtils.degToRad(props.theta * -1));
        this.axis.applyAxisAngle(new THREE.Vector3(0, 1, 0).normalize(), THREE.MathUtils.degToRad(props.phi));
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate(prevProps) {
        if (this.props.animate && !prevProps.animate && !this.texturesLoading) {
            this.animate(this.renderCount, this.props.perspective);
        }
        else if (this.props.phi !== prevProps.phi || this.props.theta !== prevProps.theta) {
            this.init();
        }
    }
    componentWillUnmount() {
        this.renderCount = 0;
    }
    init() {
        this.renderCount += 1;
        const container = this.ballSpinContainer.current;
        const { phi, theta } = this.props;
        this.texturesLoading = 0;
        this.scene = new THREE.Scene();
        new THREE.TextureLoader().load(ifGrassZoomOutNoStripe, (texture) => { this.scene.background = texture; });
        this.camera = new THREE.PerspectiveCamera(70, 1, 1, 2000);
        this.camera.position.set(0, -200, 0);
        this.camera.up = new THREE.Vector3(0, 0, 1);
        this.camera.lookAt(new THREE.Vector3(0, 0, 0));
        this.scene.add(this.camera);
        this.scene.add(new THREE.AmbientLight(0xf0f0f0));
        const light = new THREE.SpotLight(0xffffff, 1.5);
        light.position.set(0, 350, 200);
        light.castShadow = true;
        light.shadow.camera.fov = 70;
        light.shadow.camera.near = 200;
        light.shadow.camera.far = 2000;
        light.shadow.bias = -0.000222;
        light.shadow.mapSize.width = 1024;
        light.shadow.mapSize.height = 1024;
        this.scene.add(light);
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.props.size, this.props.size);
        this.renderer.shadowMap.enabled = true;
        container.innerHTML = '';
        container.appendChild(this.renderer.domElement);
        const geometry = new THREE.SphereGeometry(80, 32, 32, 0, Math.PI * 2, 0, Math.PI);
        this.texturesLoading += 1;
        const texture = new THREE.TextureLoader().load(baseballWLogo, () => { this.texturesLoading -= 1; });
        const material = new THREE.MeshBasicMaterial({
            map: texture,
        });
        this.ball = new THREE.Mesh(geometry, material);
        // rotate the ball into alignment with the spin axis and add it to the scene
        this.ball.rotateY(THREE.MathUtils.degToRad(phi));
        this.ball.rotateZ(THREE.MathUtils.degToRad(theta * -1));
        this.scene.add(this.ball);
        // add orthogonal disk
        const diskGeom = new THREE.RingGeometry(75, 110, 32);
        diskGeom.lookAt(this.axis); // set the normal vector of the ring geometry to be the spin axis
        const diskMat = new THREE.MeshBasicMaterial({ color: 0x0000ff, side: THREE.DoubleSide, transparent: true, opacity: 0.5 });
        const disk = new THREE.Mesh(diskGeom, diskMat);
        this.scene.add(disk);
        const origin = new THREE.Vector3(0, 0, 0);
        const length = 100;
        const hex = 0xff0000;
        const hex2 = 0xffff00;
        const arrowHelper = new THREE.ArrowHelper(this.axis, origin, length, hex);
        const redCylinderGeometry = new THREE.CylinderGeometry(5, 5, 100, 16);
        redCylinderGeometry.translate(0, 75, 0);
        const redCylinderEdges = new THREE.EdgesGeometry(redCylinderGeometry);
        const edgeLine = new THREE.LineSegments(redCylinderEdges, new THREE.LineBasicMaterial({ color: 0x880000 }));
        const redCylinder = new THREE.Mesh(redCylinderGeometry, new THREE.MeshBasicMaterial({ color: 0xff0000 }));
        arrowHelper.add(redCylinder);
        arrowHelper.add(edgeLine);
        const arrowHelper2 = new THREE.ArrowHelper(new THREE.Vector3(-this.axis.x, -this.axis.y, -this.axis.z), origin, length, hex2);
        this.scene.add(arrowHelper);
        this.scene.add(arrowHelper2);
        this.renderer.render(this.scene, this.camera);
        this.animate(this.renderCount, this.props.perspective);
    }
    animate(currentRenderCount, perspective) {
        if ((this.props.animate || this.texturesLoading > 0) && currentRenderCount === this.renderCount) {
            window.requestAnimationFrame(() => this.animate(currentRenderCount, perspective));
        }
        this.renderBall(perspective);
    }
    rotateBall(perspective) {
        const spinDirection = perspective === 'pitcher' ? -1 : 1;
        this.ball.rotateOnWorldAxis(this.axis, spinDirection * 0.05);
    }
    renderBall(perspective) {
        this.renderer.render(this.scene, this.camera);
        if (this.props.animate) {
            this.rotateBall(perspective);
        }
    }
    render() {
        return (React.createElement(StyledBallSpin, { ref: this.ballSpinContainer }));
    }
}
BallSpin.defaultProps = {
    size: 300,
    perspective: 'catcher',
};

const Container$k = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
/** This chart is re-used for the BallCap version, which has different min/max. */
const ALTERNATE_AXIS_EXTENT = 24;
const alternateAxisStyle = {
    visible: true,
    lineWidth: 0,
    gridLineWidth: 1,
    gridLineColor: '#888888',
    tickInterval: 12,
    tickLength: 10,
    minorTickInterval: 6,
    minorTickLength: 10,
    minorTickWidth: 1,
    minorGridLineWidth: 0,
    minorGridLineColor: '#888888',
    startOnTick: false,
    endOnTick: false,
    minPadding: 0,
    maxPadding: 0,
    plotLines: [
        { value: 0, color: '#000000', width: 3 },
    ],
};
const mapPitchesToSeries$2 = (translate, pitches, keyX, keyY, marker, opacity = 0.8, enableMouseTracking = true, abbreviateName = false, colorFunc) => {
    const initPitchTypeGroups = [];
    const pitchTypeGroups = pitches.reduce((acc, p) => {
        var _a, _b;
        if (!acc.find((x) => x.pitchtype === p.pitchtype && x.fxsubtype === p.fxsubtype)) {
            acc.push({
                pitchtype: p.pitchtype,
                fxsubtype: p.fxsubtype,
                points: [],
            });
        }
        const pitchGroup = acc.find((x) => x.pitchtype === p.pitchtype && x.fxsubtype === p.fxsubtype);
        if (((_b = (_a = pitchGroup === null || pitchGroup === void 0 ? void 0 : pitchGroup.points) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER) < 500 && p[keyX] !== null && p[keyY] !== null) {
            pitchGroup === null || pitchGroup === void 0 ? void 0 : pitchGroup.points.push(Object.assign(Object.assign({}, p), { x: p[keyX], y: p[keyY], color: colorFunc(p), marker }));
        }
        return acc;
    }, initPitchTypeGroups);
    return pitchTypeGroups.map((pt) => ({
        type: 'scatter',
        data: pt.points,
        name: (pitchTypeDisplayName(pt, abbreviateName, abbreviateName, translate)
            || pitchType(0, abbreviateName, undefined, translate)),
        opacity,
        enableMouseTracking,
        id: `${pt.pitchtype}${pt.fxsubtype != null ? `-${pt.fxsubtype}` : ''}`,
        color: colorFunc({ pitchtype: pt.pitchtype, fxsubtype: pt.fxsubtype }),
    })).filter((g) => { var _a; return (_a = g === null || g === void 0 ? void 0 : g.data) === null || _a === void 0 ? void 0 : _a.length; });
};
const PitchBreakPlotChart = forwardRef(({ pitches, videoPlayerModal: VideoPlayerModal, pitchVideoFn, multiVideoFn, modalContainer, keyX = 'breakx', keyY = 'breakz', labelX = '', labelY = '', minX = null, minY = null, maxX = null, maxY = null, minMaxCoordinate = 5, height = 210, width = 210, enableZoom = true, perspective = 'pitcher', allPitches = [], seriesData = [], plotLinesX = [], plotLinesY = [], showlegend = false, abbreviateName = false, colorFunc = (pt) => pitchTypeColor(pt.pitchtype), turboThreshold = 10000, tooltipFormatter, useAlternateStyle = false, pitchMarker = { radius: 4, lineWidth: 1, lineColor: '#333' }, autoSizeMarkers = false, }, outerRef) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const inUpdateRef = useRef(false);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    // Scales every scatter series' marker radius to the on-screen size of a
    // real baseball (`BALL_RADIUS` inches) at the current y-axis zoom. Runs on
    // chart load/redraw; the recursion guard prevents the resulting
    // `chart.redraw()` from re-entering this function.
    function updateMarkers(chart) {
        if (!autoSizeMarkers)
            return;
        if (inUpdateRef.current)
            return;
        inUpdateRef.current = true;
        const axis = chart.yAxis[0];
        const rPx = Math.abs(axis.toPixels(BALL_RADIUS$1, false) - axis.toPixels(0, false));
        chart.series.forEach((s) => {
            if (s.type && s.type !== 'scatter')
                return;
            const scatterOpts = s.options;
            if (!scatterOpts.marker || typeof scatterOpts.marker !== 'object')
                return;
            // eslint-disable-next-line no-param-reassign
            scatterOpts.marker.radius = rPx;
        });
        chart.redraw(false);
        inUpdateRef.current = false;
    }
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    const labelXuse = labelX === '' ? translate('components.charts.break-x-in') : labelX;
    const labelYuse = labelY === '' ? translate('components.charts.break-z-in') : labelY;
    if (!(pitches === null || pitches === void 0 ? void 0 : pitches.length) && !seriesData.length) {
        return React.createElement(Container$k, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const pitchSeries = mapPitchesToSeries$2(translate, pitches, keyX, keyY, pitchMarker, 0.8, true, abbreviateName, colorFunc);
    const allPitchSeries = mapPitchesToSeries$2(translate, allPitches || [], keyX, keyY, { radius: 2 }, 0.3, false, abbreviateName, colorFunc);
    const pitchTypeSeries = allPitchSeries.concat(pitchSeries).concat(seriesData);
    const xAbsVals = pitchTypeSeries.flatMap(({ data }) => data.map(({ x }) => Math.abs(x || 0)));
    const yAbsVals = pitchTypeSeries.flatMap(({ data }) => data.map(({ y }) => Math.abs(y || 0)));
    const chartScale = Math.max(minMaxCoordinate - 1, ...xAbsVals, ...yAbsVals) + 1;
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const fetchMultiVideo = (videoPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const pitchIds = videoPitches
                .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
                .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
            const playlist = yield multiVideoFn(pitchIds);
            setVideoPlaylist(playlist);
        }
        catch (_b) {
            closePitchVideo();
        }
    });
    const defaultXAxis = {
        min: minX != null ? minX : -chartScale,
        max: maxX != null ? maxX : chartScale,
        gridLineWidth: 0,
        lineWidth: 1,
        tickInterval: 3,
        tickLength: 6,
        minorGridLineWidth: 0,
        minorGridLineColor: '#FCF8F8',
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
        opposite: false,
        reversed: !perspective || perspective === 'pitcher',
        title: {
            text: labelXuse,
        },
        plotLines: [{
                color: 'lightgrey',
                value: 0,
                width: 1,
            }, ...plotLinesX],
    };
    const defaultYAxis = {
        min: minY != null ? minY : -chartScale,
        max: maxY != null ? maxY : chartScale,
        gridLineWidth: 0,
        lineWidth: 1,
        tickInterval: 3,
        tickLength: 6,
        minorTickInterval: 3,
        minorTickLength: 4,
        minorTickWidth: 1,
        minorGridLineWidth: 0,
        minorGridLineColor: '#FCF8F8',
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
        opposite: false,
        title: {
            text: labelYuse,
        },
        plotLines: [{
                color: 'lightgrey',
                value: 0,
                width: 1,
            }, ...plotLinesY],
    };
    const alternateXAxis = Object.assign(Object.assign({}, alternateAxisStyle), { min: minX != null ? minX : -ALTERNATE_AXIS_EXTENT, max: maxX != null ? maxX : ALTERNATE_AXIS_EXTENT, opposite: false, reversed: !perspective || perspective === 'pitcher', title: {
            text: labelXuse,
        }, plotLines: [...alternateAxisStyle.plotLines, ...plotLinesX] });
    const alternateYAxis = Object.assign(Object.assign({}, alternateAxisStyle), { min: minY != null ? minY : -ALTERNATE_AXIS_EXTENT, max: maxY != null ? maxY : ALTERNATE_AXIS_EXTENT, opposite: false, title: {
            text: labelYuse,
        }, plotLines: [...alternateAxisStyle.plotLines, ...plotLinesY] });
    const chartConfig = {
        chart: Object.assign(Object.assign({ type: 'scatter', animation: false }, (useAlternateStyle
            ? { marginLeft: 60, marginBottom: 60 }
            : { plotBorderWidth: 1 })), { zoomType: enableZoom ? 'xy' : undefined, backgroundColor: undefined, height,
            width, events: {
                selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, x, y } = point;
                            return enabled !== false && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            fetchMultiVideo(points.map((p) => ({
                                gameid: p.gameid,
                                pitchseq: p.pitchseq,
                                eventseq: p.eventseq,
                            })));
                        }
                        return false;
                    }
                    return true;
                },
                load() {
                    updateMarkers(this);
                },
                redraw() {
                    updateMarkers(this);
                },
            } }),
        title: {
            text: undefined,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                animation: false,
                stickyTracking: false,
                marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: '#000',
                        },
                    },
                },
            },
            series: {
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: {
            enabled: showlegend,
            width: '100%',
            x: width * 0.1,
            align: 'center',
        },
        xAxis: useAlternateStyle ? alternateXAxis : defaultXAxis,
        yAxis: useAlternateStyle ? alternateYAxis : defaultYAxis,
        tooltip: {
            formatter(tooltip) {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (!this.point.tooltip && !this.point.name)
                    return tooltip.defaultFormatter.call(this, tooltip);
                return `<b>${this.series.name}</b><br/>${this.point.tooltip || this.point.name}`;
            },
        },
        series: pitchTypeSeries,
    };
    return (React.createElement(Container$k, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { immutable: true, ref: ref, width: width, options: chartConfig, useBodyFont: false, className: useAlternateStyle ? 'pitchBreakPlotChartAlt' : 'pitchBreakPlotChart' })));
});

/* eslint-disable react/no-this-in-sfc */
const Container$j = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const LineChart = ({ seriesData, width, titleX, minY, maxY, minX, maxX, dateFormatX, isDateX = false, showLegend = false, title = '', subtitle = '', titleY = '', legendposition = 'float', }) => {
    const legendConfig = {
        enabled: showLegend,
    };
    if (legendposition === 'float' || !legendposition) {
        legendConfig.align = 'right';
        legendConfig.verticalAlign = 'top';
    }
    else if (legendposition === 'below') {
        legendConfig.align = 'center';
    }
    const chartConfig = {
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            min: minX,
            max: maxX,
            title: {
                text: titleX,
            },
            type: isDateX ? 'datetime' : undefined,
            labels: {
                formatter() {
                    if (isDateX)
                        return Highcharts.dateFormat(dateFormatX, Number(this.value));
                    return this.value.toString();
                },
            },
            endOnTick: true,
            showFirstLabel: false,
            startOnTick: true,
        },
        yAxis: {
            min: minY,
            max: maxY,
            title: {
                text: titleY,
            },
            endOnTick: true,
            showFirstLabel: false,
            startOnTick: true,
        },
        tooltip: {
            formatter(tooltip) {
                if (isDateX)
                    return `<b>${Highcharts.dateFormat(dateFormatX, this.point.x)}</b><br />${this.point.y}`;
                return tooltip.defaultFormatter.call(this, tooltip);
            },
        },
        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false,
                },
            },
        },
        legend: legendConfig,
        series: seriesData,
    };
    return (React.createElement(Container$j, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false, className: "lineChart" })));
};

const StyledContainer$6 = styled.div `
    display: flex;
    flex-wrap: wrap;
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;
    border: 1px solid #737373;
    border-radius: 5px;

    background: url("data:image/svg+xml;utf8,
        <svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'> 
            <path d='M0 0 L0 100 L100 100 L100 0' fill='%23EDEDED' />    
            <path d='M0 0 L25 34' stroke='%23737373' stroke-width='0.5' />
            <path d='M100 0 L75 34' stroke='%23737373' stroke-width='0.5' />
            <path d='M0 100 L25 67' stroke='%23737373' stroke-width='0.5' />   
            <path d='M100 100 L75 67' stroke='%23737373' stroke-width='0.5' /> 
        </svg>"
    );
    background-repeat:no-repeat;
    background-position:center center;
    background-size: 100% 100%, auto;
`;
const StyledUpDown = styled.div `
    width: ${(props) => props.width}px;
    height: ${(props) => props.width / 6}px;
`;
const StyledInOut = styled.div `
    width: ${(props) => (props.width / 4) - 1}px;
    height: ${(props) => props.width / 6}px;
`;
const StyledCenter = styled.div `
    width: ${(props) => props.width / 2}px;
    height: ${(props) => props.width / 3}px;
    margin: auto;
    position: relative;
    background-color: #737373;
    border: 1px solid #737373;
`;
const StyledContent = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${(props) => props.width / 3}px;
    font-size: ${(props) => props.fontsize || '1.3em'};
    font-weight: ${(props) => props.fontweight || 'normal'};
    color: ${(props) => props.fontcolor || '#515151'};
`;
const StyledOverall = styled.div `
    width: ${(props) => props.width}px;
    display: flex;
    justify-content: center;
    font-size: 1.4em;
    font-weight: bold;
    margin-top: 10px;
`;
const addSign$1 = (value) => {
    if (typeof value !== 'number')
        return value;
    if (value > 0)
        return `+${value.toFixed(1)}`;
    return value.toFixed(1);
};
const ReceivingChart = ({ width = 200, split, up, down, gloveSide, armSide, total }) => (React.createElement("div", null,
    React.createElement(StyledContainer$6, { width: width },
        React.createElement(StyledUpDown, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(up))),
        React.createElement(StyledInOut, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(gloveSide))),
        React.createElement(StyledCenter, { width: width },
            React.createElement(StyledContent, { fontsize: "1.5em", fontcolor: "white", fontweight: "bold", width: width }, split)),
        React.createElement(StyledInOut, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(armSide))),
        React.createElement(StyledUpDown, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(down)))),
    React.createElement(StyledOverall, { width: width }, addSign$1(total))));

const CatcherDepth = ({ seriesData, width, title = '', subtitle = '', titleDataY = '', titleHistogramY = '', titleDataX = '', titleHistogramX = '', }) => {
    const { t: translate } = useTranslation();
    const { name, data, leagueAverage } = seriesData;
    const titleDataYuse = titleDataY === '' ? translate('components.charts.data') : titleDataY;
    const titleDataXuse = titleDataX === '' ? translate('components.charts.data') : titleDataX;
    const titleHistogramYuse = titleHistogramY === '' ? translate('components.charts.histogram') : titleHistogramY;
    const titleHistogramXuse = titleHistogramX === '' ? translate('components.charts.histogram') : titleHistogramX;
    histogram(Highcharts);
    const ref = useRef(null);
    const chartConfig = {
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: [{
                title: { text: titleDataXuse },
                alignTicks: false,
                visible: false,
            }, {
                title: { text: titleHistogramXuse },
                alignTicks: false,
                opposite: true,
                plotLines: [{
                        color: 'red',
                        dashStyle: 'LongDashDot',
                        value: leagueAverage,
                        width: 2,
                        zIndex: 99,
                    }],
            }],
        yAxis: [{
                title: { text: titleDataYuse },
                visible: false,
            }, {
                title: { text: titleHistogramYuse },
                opposite: true,
            }],
        plotOptions: {
            histogram: {
                accessibility: {
                    pointDescriptionFormatter(point) {
                        const ix = point.index + 1;
                        const x1 = point.x.toFixed(3);
                        const x2 = point.x2.toFixed(3);
                        const val = point.y;
                        return `${ix}. ${x1} to ${x2}, ${val}.`;
                    },
                },
                tooltip: {
                    pointFormatter() {
                        const { x, x2, y } = this;
                        return `<strong>${translate('components.charts.depth')}</strong>: ${x.toFixed(2)} in. - ${x2.toFixed(2)} in.<br/><strong>${translate('components.charts.count')}</strong>: ${y}`;
                    },
                },
            },
        },
        series: [{
                name,
                type: 'histogram',
                xAxis: 1,
                yAxis: 1,
                baseSeries: 's1',
                zIndex: -1,
            }, {
                name: translate('components.charts.data'),
                type: 'scatter',
                data,
                id: 's1',
                marker: {
                    radius: 1.5,
                },
                visible: false,
                showInLegend: false,
            }],
        credits: {
            enabled: false,
        },
    };
    return (React.createElement(BaseChartContainer, { "$width": width, "$useBodyFont": false },
        React.createElement(HighchartsReact, { ref: ref, highcharts: Highcharts, options: chartConfig })));
};

const Container$i = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const GloveLocation = ({ seriesData, categories, width, title, subtitle, titleX, titleY, tooltipSuffix, type = 'column' }) => {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBattersBoxes(chart);
    }, [ref, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    function renderBattersBoxes(chart) {
        var _a, _b;
        const rectattr = {
            'stroke-width': 2,
            stroke: 'lightgrey',
            fill: 'none',
            zIndex: 1,
        };
        const playerSeries = (_b = (_a = chart.xAxis[0]) === null || _a === void 0 ? void 0 : _a.series[0]) === null || _b === void 0 ? void 0 : _b.data;
        if (!playerSeries)
            return;
        const platePath = new Array();
        const { min, max } = chart.xAxis[0].getExtremes();
        const midPoint = chart.xAxis[0].toPixels((min + max) / 2, false);
        const leftEdge = chart.xAxis[0].toPixels(1, false);
        const rightEdge = chart.xAxis[0].toPixels(4, false);
        const segmentLength = (rightEdge - leftEdge) / 2;
        platePath.push('M');
        platePath.push(leftEdge, 50);
        platePath.push('L');
        platePath.push(leftEdge, segmentLength);
        platePath.push(midPoint, chart.plotHeight + 40);
        platePath.push(rightEdge, segmentLength);
        platePath.push(rightEdge, 50);
        platePath.push(leftEdge, 50);
        chart.renderer.path(platePath).attr(rectattr).add();
    }
    const chartConfig = {
        chart: {
            type,
            height: 400,
            width: 700,
        },
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            categories,
            title: {
                text: titleX,
            },
        },
        yAxis: {
            title: {
                text: titleY,
                align: 'high',
            },
            labels: {
                overflow: 'justify',
            },
        },
        tooltip: {
            valueSuffix: tooltipSuffix,
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                },
            },
        },
        credits: {
            enabled: false,
        },
        series: seriesData,
    };
    return (React.createElement(Container$i, null,
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
const HomePlateChart = ({ seriesData, legendPosition, onClick, height = 350, width = 350, minX = -6, maxX = 6, minY = -6, maxY = 6, oppositeY = false, showLegend = true, enableZoom = false, turboThreshold = 1000, }) => {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBattersBoxes(chart);
    }, [ref, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    function renderBattersBoxes(chart) {
        const bbtop = 3.7083;
        const bbbottom = -2.2917;
        const x1 = chart.xAxis[0].toPixels(-5.2083, false);
        const x2 = chart.xAxis[0].toPixels(1.2083, false);
        const y = chart.yAxis[0].toPixels(bbtop, false);
        const h = chart.yAxis[0].toPixels(bbbottom, false) - chart.yAxis[0].toPixels(bbtop, false);
        const w = chart.xAxis[0].toPixels(-1.2083, false) - chart.xAxis[0].toPixels(-5.2083, false);
        const rectattr = {
            'stroke-width': 1,
            stroke: '#333333',
            fill: 'none',
            zIndex: 1,
        };
        chart.renderer.rect(x1, y, w, h, 0).attr(rectattr).add();
        chart.renderer.rect(x2, y, w, h, 0).attr(rectattr).add();
        const platePath = new Array();
        platePath.push('M');
        platePath.push(chart.xAxis[0].toPixels(0, false));
        platePath.push(chart.yAxis[0].toPixels(0, false));
        platePath.push('L');
        platePath.push(chart.xAxis[0].toPixels(0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(0.7083, false));
        platePath.push(chart.xAxis[0].toPixels(0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(1.4167, false));
        platePath.push(chart.xAxis[0].toPixels(-0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(1.4167, false));
        platePath.push(chart.xAxis[0].toPixels(-0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(0.7083, false));
        platePath.push(chart.xAxis[0].toPixels(0, false));
        platePath.push(chart.yAxis[0].toPixels(0, false));
        platePath.push('Z');
        chart.renderer.path(platePath).attr(rectattr).add();
        const bhpPath = new Array();
        bhpPath.push('M');
        bhpPath.push(chart.xAxis[0].toPixels(-1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-2.2917, false));
        bhpPath.push('L');
        bhpPath.push(chart.xAxis[0].toPixels(-1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-8, false));
        bhpPath.push(chart.xAxis[0].toPixels(1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-8, false));
        bhpPath.push(chart.xAxis[0].toPixels(1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-2.2917, false));
        chart.renderer.path(bhpPath).attr(rectattr).add();
    }
    let legendConfig = { enabled: showLegend };
    if (legendPosition === 'float' || !legendPosition) {
        legendConfig = Object.assign(Object.assign({}, legendConfig), { align: 'right', verticalAlign: 'top', layout: 'vertical', floating: true, x: -16, y: 10 });
    }
    else if (legendPosition === 'below') {
        legendConfig = Object.assign(Object.assign({}, legendConfig), { align: 'center' });
    }
    else if (legendPosition === 'upperleft') {
        legendConfig = Object.assign(Object.assign({}, legendConfig), { align: 'left', verticalAlign: 'top', layout: 'vertical', floating: true, x: 22, y: -6 });
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: { text: undefined },
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                point: {
                    events: {
                        click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                            }
                            return null;
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: legendConfig,
        xAxis: {
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
        },
        yAxis: {
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: oppositeY,
            title: {
                text: null,
            },
        },
        tooltip: {
            formatter() {
                if (!this.point.tooltip && !this.point.name)
                    return false;
                let tooltip = `<b>${this.series.name}</b><br />`;
                if (this.point.tooltip) {
                    tooltip += this.point.tooltip;
                }
                else {
                    tooltip += this.point.name;
                }
                return tooltip;
            },
        },
        series: seriesData,
    };
    return (React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false, className: "homePlateChart" }));
};

const StyledContainer$5 = styled.div `
    width: ${(props) => props.width}px;
`;
const StyledLegend$2 = styled.table `
    width: 100%;
    border: 1px solid 
`;
const StyledLegendData$1 = styled.td `
&& {
    text-align: center;
    padding: 2px 6px 2px 3px;
    border: solid 1px #999999;
}`;
const StyledColorBlock$1 = styled.a `
&& {
    width: 15px; 
    height: 15px; 
    display: inline-block; 
    background-color: ${(props) => props.color};
}`;
const CatcherAccuracy = ({ base, seriesData, modalContainer, pitchVideoFn, onClick, videoPlayerModal: VideoPlayerModal, enableZoom = true, height = 500, width = 400, minX = 0, maxX = 400, minY = 0, maxY = 500, showLegend = true, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [videoPlaylist, setVideoPlaylist] = useState();
    // Update state when prop changes through
    useEffect(() => {
        redraw();
    }, [ref, base, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    let bgGroup;
    const renderBackgroundImage = () => {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        const xExtent = chart.xAxis[0].getExtremes();
        const yExtent = chart.yAxis[0].getExtremes();
        const arcAdjustment = (500 / (yExtent.max - yExtent.min));
        // create an SVG group and remove it first if it already exists
        if (bgGroup != null)
            bgGroup.element.remove();
        bgGroup = chart.renderer.g().add();
        // add background image scaled to current extents
        const img = base === 2 ? catcherThrows2B : catcherThrows3B;
        chart.renderer
            .image(img, chart.xAxis[0].toPixels(minX, false), chart.yAxis[0].toPixels(maxY, false), width * (width / (xExtent.max - xExtent.min)), height * (height / (yExtent.max - yExtent.min)))
            .attr({
            zIndex: 2,
            opacity: 0.75,
        })
            .add(bgGroup);
        // draw two concentric circles at (255,230), scaled to current extents
        // (arbitrarily chose Y-extent for scaling _arcAdjustment, so there will probably be some squishyness but i bet nobody notices)
        chart.renderer
            .circle(chart.xAxis[0].toPixels(255, false), chart.yAxis[0].toPixels(230, false), 78 * arcAdjustment)
            .attr({
            fill: 'transparent',
            stroke: '#999999',
            'stroke-width': 1,
        }).add(bgGroup);
        chart.renderer
            .circle(chart.xAxis[0].toPixels(255, false), chart.yAxis[0].toPixels(230, false), 124 * arcAdjustment)
            .attr({
            fill: 'transparent',
            stroke: '#999999',
            'stroke-width': 1,
        }).add(bgGroup);
    };
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBackgroundImage();
        chart.redraw();
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            margin: [0, 0, 0, 0],
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: {
            text: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 4,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                                return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            height,
            width,
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        yAxis: {
            height,
            width,
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        tooltip: {
            formatter() {
                let tooltip = '';
                if (this.point.tooltip)
                    tooltip += this.point.tooltip;
                tooltip += this.point.name;
                return tooltip;
            },
        },
        series: seriesData,
        loading: undefined,
    };
    const defaultSeries = base === 2 ? [
        { data: [], name: '<1.82', index: 1, id: 'set1', color: '#cc0000', threshold: 1.82 },
        { data: [], name: '1.82-1.90', index: 2, id: 'set2', color: '#dddd00', threshold: 1.90 },
        { data: [], name: '1.90-1.98', index: 3, id: 'set3', color: '#009900', threshold: 1.98 },
        { data: [], name: '1.98-2.06', index: 4, id: 'set4', color: '#0000cc', threshold: 2.06 },
        { data: [], name: '2.06+', index: 5, id: 'set5', color: '#aa00aa', threshold: 999 },
    ] : [
        { data: [], name: '<1.40', index: 1, id: 'set1', color: '#cc0000', threshold: 1.401 },
        { data: [], name: '1.40-1.46', index: 2, id: 'set2', color: '#dddd00', threshold: 1.468 },
        { data: [], name: '1.46-1.50', index: 3, id: 'set3', color: '#009900', threshold: 1.502 },
        { data: [], name: '1.50-1.56', index: 4, id: 'set4', color: '#0000cc', threshold: 1.568 },
        { data: [], name: '1.56+', index: 5, id: 'set5', color: '#aa00aa', threshold: 999 },
    ];
    return (React.createElement(StyledContainer$5, { width: width },
        !!pitchVideoFn && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false }),
        !!showLegend && (React.createElement(StyledLegend$2, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement(StyledLegendData$1, { colSpan: defaultSeries.length }, base === 2 ? `${translate('baseball.2b')} ${translate('components.charts.pop-times')}` : `${translate('baseball.3b')} ${translate('components.charts.pop-times')}`)),
                React.createElement("tr", null, defaultSeries.map((d) => React.createElement(StyledLegendData$1, { key: d.id },
                    React.createElement(StyledColorBlock$1, { color: d.color }),
                    React.createElement("br", null),
                    d.name))))))));
};

const StyledContainer$4 = styled.div `
    width: ${(props) => props.width}px;
`;
const StyledLegend$1 = styled.table `
    width: 100%;
    border: 1px solid 
`;
const StyledLegendData = styled.td `
&& {
    text-align: center;
    padding: 2px 6px 2px 3px;
    border: solid 1px #999999;
}`;
const StyledColorBlock = styled.a `
&& {
    width: 15px; 
    height: 15px; 
    display: inline-block; 
    background-color: ${(props) => props.color};
}`;
const InfielderAccuracy$1 = forwardRef(({ position, seriesData, modalContainer, pitchVideoFn, onClick, videoPlayerModal: VideoPlayerModal, enableZoom = true, width = 700, minX = 0, maxX = width, minY = 0, showLegend = true, tooltipFormatter, }, outerRef) => {
    const defaultWidth = 700;
    const defaultHeight = 550;
    const aspectRatio = defaultWidth / defaultHeight; // Aspect ratio of 7:5
    const height = width / aspectRatio;
    const maxY = height;
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState();
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const [chartConfig, setChartConfig] = useState({
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            margin: [0, 0, 0, 0],
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: {
            text: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 4,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick) {
                                    return onClick(this);
                                }
                                return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            height,
            width,
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        yAxis: {
            height,
            width,
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (this.point.tooltip === undefined)
                    return false;
                let tooltip = `<b>${this.point.name || this.series.name}</b>`;
                if (this.point.tooltip)
                    tooltip += `<br/>${this.point.tooltip}`;
                return tooltip;
            },
        },
        series: seriesData,
        loading: undefined,
    });
    // Update state when prop changes through
    useEffect(() => {
        redraw();
        setChartConfig((prevConfig) => (Object.assign(Object.assign({}, prevConfig), { series: seriesData })));
    }, [ref, position, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    let bgGroup;
    const renderBackgroundImage = () => {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        const xRange = 22; // +/- 11 on the x-axis (total 22 units)
        const yRange = 17; // -5 to +11 on the y-axis (total 17 units)
        const arcAdjustment = height / Math.min(xRange, yRange); // Adjustment factor
        // create an SVG group and remove it first if it already exists
        if (bgGroup != null)
            bgGroup.element.remove();
        bgGroup = chart.renderer.g().add();
        // Add background image based on the selected position
        let img;
        if (position === 5) {
            img = infAccuracy3bGrayscale;
        }
        else if (position === 4) {
            img = infAccuracy2bGrayscale;
        }
        else if (position === 6) {
            img = infAccuracySSGrayscale;
        }
        chart.renderer
            .image(img, chart.xAxis[0].toPixels(minX, false), chart.yAxis[0].toPixels(maxY, false), width, height)
            .attr({
            zIndex: 2,
        })
            .add(bgGroup);
        // Adjusting the coordinates for the center (0, 3) on a 20x20 grid
        const gridYMin = -5;
        const gridYMax = 11;
        const gridYRange = gridYMax - gridYMin;
        // Coordinates for the center (0, 3)
        const xc = width / 2;
        const yc = height * (1 - (3 - gridYMin) / gridYRange);
        // Ellipse axes scaling based on the chart dimensions
        const a = 7.5 * arcAdjustment; // Major axis length
        const b = a / 1.5; // Minor axis length
        const a2 = 9 * arcAdjustment; // Major axis length for outer ellipse
        const b2 = a2 / 1.5; // Minor axis length for outer ellipse
        // Draw the inner ellipse
        chart.renderer
            .createElement('ellipse').attr({
            cx: xc,
            cy: yc,
            rx: a,
            ry: b,
            'stroke-width': 2,
            fill: 'transparent',
            stroke: '#000',
        }).add();
        // Draw the outer ellipse
        chart.renderer
            .createElement('ellipse').attr({
            cx: xc,
            cy: yc,
            rx: a2,
            ry: b2,
            fill: 'transparent',
            stroke: '#000',
            'stroke-width': 2,
        }).add();
        // Draw the line passing through the grid, based on the y-axis center position
        chart.renderer
            .createElement('line')
            .attr({
            x1: chart.plotLeft,
            y1: chart.plotTop + yc + 4 * arcAdjustment,
            x2: chart.plotLeft + chart.plotWidth,
            y2: chart.plotTop + yc + 4 * arcAdjustment,
            stroke: 'black',
            'stroke-width': 2,
            'stroke-dasharray': '8, 4',
            zIndex: 3,
        })
            .add(bgGroup);
    };
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBackgroundImage();
        chart.redraw();
    }
    const defaultSeries = [
        { data: [], name: translate('components.charts.safe'), index: 1, id: 'set1', color: '#cc0000' },
        { data: [], name: translate('baseball.outs_one'), index: 2, id: 'set3', color: '#35a84c' },
    ];
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(StyledContainer$4, { className: "mt-4" },
            React.createElement("em", null, translate('components.charts.no-balls-in-play')));
    }
    return (React.createElement(StyledContainer$4, { width: width },
        !!pitchVideoFn && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false }),
        !!showLegend && (React.createElement(StyledLegend$1, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement(StyledLegendData, { colSpan: defaultSeries.length },
                        position,
                        " ",
                        translate('components.charts.throws'))),
                React.createElement("tr", null, defaultSeries.map((d) => React.createElement(StyledLegendData, { key: d.id },
                    React.createElement(StyledColorBlock, { color: d.color }),
                    React.createElement("br", null),
                    d.name))))))));
});

const StyledContainer$3 = styled.div `
    width: ${(props) => props.width}px;
`;
const CatcherTimes = ({ seriesData, enableZoom, minX, maxX, titleX, minY, maxY, titleY, modalContainer, pitchVideoFn, videoPlayerModal: VideoPlayerModal, onClick, height = 500, width = 400, }) => {
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        title: {
            text: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 4,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                                return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            min: minX,
            max: maxX,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleX,
            },
            labels: {
                formatter() {
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'string')
                        return Number(this.value).toFixed(2);
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'number')
                        return this.value.toFixed(2);
                    return '';
                },
            },
        },
        yAxis: {
            min: minY,
            max: maxY,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleY,
            },
            labels: {
                formatter() {
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'string')
                        return Number(this.value).toFixed(2);
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'number')
                        return this.value.toFixed(2);
                    return '';
                },
            },
        },
        tooltip: {
            formatter() {
                let tooltip = '';
                if (this.point.tooltip)
                    tooltip += this.point.tooltip;
                tooltip += this.point.name;
                return tooltip;
            },
        },
        series: seriesData,
    };
    return (React.createElement(StyledContainer$3, { width: width },
        !!pitchVideoFn && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
const Container$h = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const ScatterPlotChart = ({ width = 500, height = undefined, typeX = undefined, minX = undefined, maxX = undefined, typeY = undefined, minY = undefined, maxY = undefined, title = '', subtitle = '', titleX = '', tooltipLabelX = '', titleY = '', tooltipLabelY = '', seriesData, tooltipFormatter = undefined, }) => {
    const ref = useRef(null);
    if (Array.isArray(seriesData) && !(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$h, null,
            React.createElement("em", null, "No Data"));
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            zoomType: 'xy',
            height,
        },
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            type: typeX,
            title: {
                text: titleX,
            },
            labels: {
                formatter() {
                    if (typeX === 'datetime' && typeof this.value === 'number') {
                        return Highcharts.dateFormat('%b \'%y', Number(this.value));
                    }
                    return this.value.toString();
                },
            },
            min: minX,
            max: maxX,
            startOnTick: true,
            endOnTick: true,
            tickInterval: typeX === 'datetime' ? (24 * 3000 * 1000 * 30) : undefined,
        },
        yAxis: {
            type: typeY,
            title: {
                text: titleY,
            },
            min: minY,
            max: maxY,
        },
        plotOptions: {
            scatter: {
                marker: {
                    radius: 5,
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)',
                        },
                    },
                },
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                let valueX = this.x ? this.x.toString() : '';
                let valueY = this.y ? this.y.toString() : '';
                if (typeX === 'datetime')
                    valueX = Highcharts.dateFormat('%e %b \'%y', this.x);
                if (typeY === 'datetime')
                    valueY = Highcharts.dateFormat('%e %b \'%y', this.x);
                return `<div>${valueX}${tooltipLabelX}, ${valueY}${tooltipLabelY}</div>`;
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$h, null,
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false, className: "scatterPlotChart" })));
};

const Container$g = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;

        div {
            overflow: visible !important;
        }
        svg {
            overflow: visible !important;

            .highcharts-axis {
                display: none;
            }
        }
        .highcharts-container {
            z-index: unset !important;
            overflow: unset !important;
        }
    }
`;
/** Full-field chart version uses special measurements to match legacy spray-chart. */
const FULL_FIELD_PADDING_X = 50;
const FULL_FIELD_WIDTH_PX = 476;
const FULL_FIELD_HEIGHT_PX = 490;
const FULL_FIELD_PX_RATIO = 407 / 408;
const FULL_FIELD_PLATE_OFFSET_X = 234;
const FULL_FIELD_PLATE_PIXEL_Y = 431;
const FULL_FIELD_AXIS_EXTENTS = (() => {
    const platePixelX = FULL_FIELD_PLATE_OFFSET_X + FULL_FIELD_PADDING_X;
    const minX = -1 * platePixelX * FULL_FIELD_PX_RATIO;
    const maxX = (FULL_FIELD_WIDTH_PX + (2 * FULL_FIELD_PADDING_X) - platePixelX) * FULL_FIELD_PX_RATIO;
    const minY = -1 * (FULL_FIELD_HEIGHT_PX - FULL_FIELD_PLATE_PIXEL_Y) * FULL_FIELD_PX_RATIO;
    const maxY = FULL_FIELD_PLATE_PIXEL_Y * FULL_FIELD_PX_RATIO;
    return { minX, maxX, minY, maxY };
})();
const FULL_FIELD_CALIBRATION_POINTS = [
    { x: 0, y: 0, marker: { radius: 2, lineWidth: 0 } },
    { x: 63.6, y: 63.6, marker: { radius: 2, lineWidth: 0 } },
    { x: -63.6, y: 63.6, marker: { radius: 2, lineWidth: 0 } },
    { x: 0, y: 127.3, marker: { radius: 2, lineWidth: 0 } },
    { x: -224.9, y: 224.9, marker: { radius: 2, lineWidth: 0 } },
    { x: 222, y: 222, marker: { radius: 2, lineWidth: 0 } },
    { x: 0, y: 408, marker: { radius: 2, lineWidth: 0 } },
];
const TOP_EDGE_INSET = 6;
function clampSeriesTopY(series, maxY) {
    return series.map((s) => (Object.assign(Object.assign({}, s), { data: (Array.isArray(s.data) ? s.data : []).map((p) => {
            if (typeof p !== 'object' || p === null)
                return p;
            const point = p;
            if (!isNumber$2(point.x, point.y))
                return p;
            const y = Number(point.y);
            if (y > maxY) {
                return Object.assign(Object.assign({}, p), { y: maxY - TOP_EDGE_INSET });
            }
            return p;
        }) })));
}
function applyFullFieldSeriesTransform(series, calibrate) {
    const { minX, maxX, maxY } = FULL_FIELD_AXIS_EXTENTS;
    const xlimit = Math.min(Math.abs(minX), maxX);
    const ylimit = maxY;
    if (calibrate) {
        return series.map((s) => (Object.assign(Object.assign({}, s), { data: [
                ...(Array.isArray(s.data) ? s.data : []),
                ...FULL_FIELD_CALIBRATION_POINTS,
            ] })));
    }
    return series.map((s) => (Object.assign(Object.assign({}, s), { data: (Array.isArray(s.data) ? s.data : []).map((p) => {
            if (typeof p !== 'object' || p === null)
                return p;
            const px = Number(p.x);
            const py = Number(p.y);
            if (Number.isNaN(px) || Number.isNaN(py))
                return p;
            if (Math.abs(px) > xlimit || Math.abs(py) > ylimit) {
                const hypotenuse = Math.sqrt((Math.pow(px, 2)) + (Math.pow(py, 2))) || 1;
                return Object.assign(Object.assign({}, p), { x: px * (xlimit / hypotenuse), y: py * (ylimit / hypotenuse) });
            }
            return p;
        }) })));
}
const SprayChart$3 = forwardRef(({ type, seriesData, enableZoom, enableLegend, disableLegendClick, onClick, pitchVideoFn, multiVideoFn, videoPlayerModal: VideoPlayerModal, modalContainer, sizeMultiplier = 1, preventLegendSeriesHover = false, tooltipFormatter, isGrayScale = false, fullFieldCalibrate = false, }, outerRef) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const [bgImgPath, setBgImgPath] = useState(null);
    // Tracks the config the current background image was rendered for so we
    // can skip the (visible) remove + re-add when only `seriesData` changes.
    const lastBgConfigRef = useRef(null);
    const isFullField = type === 'fullfield';
    const fullFieldPad = FULL_FIELD_PADDING_X / sizeMultiplier;
    const fullFieldWpx = FULL_FIELD_WIDTH_PX / sizeMultiplier;
    const fullFieldHpx = FULL_FIELD_HEIGHT_PX / sizeMultiplier;
    const fullFieldChartW = fullFieldWpx + (2 * fullFieldPad);
    const { minX: ffMinX, maxX: ffMaxX, minY: ffMinY, maxY: ffMaxY } = FULL_FIELD_AXIS_EXTENTS;
    const pixOF = 1.165 * sizeMultiplier;
    const pixIF = 2.23 / sizeMultiplier;
    const pixIFBW = 0.67 / sizeMultiplier;
    let canvasWidth = 0;
    let width = 0;
    let height = 0;
    let axisWidth = 0;
    let axisHeight = 0;
    // Defaulted to Yankee Stadium. Need to update this to accept other venues.
    let image = '';
    if (type === 'outfield') {
        canvasWidth = 550 / sizeMultiplier;
        width = 500 / sizeMultiplier;
        height = 404 / sizeMultiplier;
        axisWidth = (canvasWidth * pixOF);
        axisHeight = (height * pixOF);
        image = isGrayScale ? sprayChartOfGrayscale : sprayChartOF;
    }
    else if (type === 'infield') {
        canvasWidth = 500 / sizeMultiplier;
        width = 500 / sizeMultiplier;
        height = 404 / sizeMultiplier;
        axisWidth = canvasWidth / pixIF;
        axisHeight = height / pixIF;
        image = isGrayScale ? sprayChartIfGrayscale : sprayChartIF;
    }
    else if (type === 'infieldbw') {
        canvasWidth = 134 / sizeMultiplier;
        width = 134 / sizeMultiplier;
        height = 134 / sizeMultiplier;
        axisWidth = canvasWidth / pixIFBW;
        axisHeight = height / pixIFBW;
        image = sprayChartIFBW;
    }
    else if (type === 'fullfield') {
        canvasWidth = fullFieldChartW;
        width = fullFieldChartW;
        height = fullFieldHpx;
        axisWidth = 0;
        axisHeight = 0;
        image = fullFieldOutlineGrayscale;
    }
    const chartMaxY = isFullField ? ffMaxY : axisHeight;
    const processedSeries = useMemo(() => {
        if (type === 'fullfield') {
            return applyFullFieldSeriesTransform(seriesData !== null && seriesData !== void 0 ? seriesData : [], fullFieldCalibrate);
        }
        return clampSeriesTopY(seriesData !== null && seriesData !== void 0 ? seriesData : [], chartMaxY);
    }, [type, seriesData, fullFieldCalibrate, chartMaxY]);
    // `seriesData` stays in the deps so this fires the first time the chart
    // mounts (the chart instance isn't ready on the initial empty render).
    // `drawBackground` itself is now a no-op when only `seriesData` changed.
    useEffect(() => {
        drawBackground();
    }, [ref, type, seriesData, sizeMultiplier, isGrayScale, fullFieldCalibrate]); // eslint-disable-line react-hooks/exhaustive-deps
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$g, { className: "mt-4" },
            React.createElement("em", null, translate('components.charts.no-balls-in-play')));
    }
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
        setVideoPlaylist(playlist);
    });
    const fetchMultiVideo = (pitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const pitchIds = pitches
            .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
            .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
        const playlist = yield multiVideoFn(pitchIds);
        setVideoPlaylist(playlist);
    });
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    function drawBackground() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            // force re-draw to account for empty arrays of pitches
            lastBgConfigRef.current = null;
            if (bgImgPath != null)
                setBgImgPath(null);
            return;
        }
        // Skip the remove + re-add when nothing that affects the image itself
        // has changed. Without this, every `seriesData` update (e.g. selecting
        // a new pitch) re-renders the background and the user sees a flash.
        const configKey = `${type}|${sizeMultiplier}|${isGrayScale}|${fullFieldCalibrate}`;
        if (bgImgPath != null && lastBgConfigRef.current === configKey) {
            return;
        }
        lastBgConfigRef.current = configKey;
        const xExtent = chart.xAxis[0].getExtremes();
        const yExtent = chart.yAxis[0].getExtremes();
        // draw the park/infield background
        if (bgImgPath != null) {
            bgImgPath.element.remove();
        }
        if (type === 'fullfield') {
            setBgImgPath(chart.renderer.image(fullFieldOutlineGrayscale, fullFieldPad, 0, fullFieldWpx, fullFieldHpx)
                .attr({
                zIndex: 1,
            })
                .add());
            return;
        }
        setBgImgPath(chart.renderer.image(image, chart.xAxis[0].toPixels(-1 * (axisWidth / 2), false) + (0.5 * (canvasWidth - width)), chart.yAxis[0].toPixels((axisHeight), false), width * (axisWidth / (xExtent.max - xExtent.min)), height * (axisHeight / (yExtent.max - yExtent.min)))
            .attr({
            zIndex: -999,
        })
            .add());
    }
    const onSprayChartSelection = function onSprayChartSelection(e) {
        var _a, _b;
        if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
            const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
            const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
            const points = this.series.flatMap((s) => s.points.filter((point) => {
                const { enabled, visible, x, y } = point;
                return enabled !== false && visible !== false
                    && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
            }));
            if (points.length)
                fetchMultiVideo(points);
        }
        return false;
    };
    const chartBlock = isFullField
        ? {
            type: 'scatter',
            height: fullFieldHpx,
            width: fullFieldChartW,
            backgroundColor: 'transparent',
            zoomType: (enableZoom ? 'xy' : undefined),
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
            events: {
                selection: onSprayChartSelection,
            },
        }
        : {
            type: 'scatter',
            height,
            width: canvasWidth,
            backgroundColor: undefined,
            zoomType: (enableZoom ? 'xy' : undefined),
            marginBottom: 0,
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            events: {
                selection: onSprayChartSelection,
            },
        };
    const chartConfig = {
        chart: chartBlock,
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: { text: undefined },
        plotOptions: {
            series: {
                marker: {
                    radius: 3,
                    symbol: 'circle',
                },
                stickyTracking: false,
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                                if (pitchVideoFn)
                                    return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
                states: {
                    inactive: {
                        opacity: preventLegendSeriesHover ? 1 : 0.2,
                    },
                },
                events: {
                    legendItemClick() {
                        if (disableLegendClick) {
                            return false;
                        }
                        return true;
                    },
                },
            },
        },
        legend: {
            enabled: enableLegend,
            y: 50,
            useHTML: disableLegendClick,
            labelFormatter() {
                if (disableLegendClick) {
                    return `<span style="pointer-events: none;">${this.name}</span>`;
                }
                return this.name;
            },
        },
        xAxis: isFullField ? {
            width: fullFieldChartW,
            height: fullFieldHpx,
            min: ffMinX,
            max: ffMaxX,
            gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            labels: {
                enabled: false,
            },
        } : {
            height,
            width: canvasWidth,
            min: -1 * (axisWidth / 2),
            max: (axisWidth / 2),
            gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            labels: {
                enabled: false,
            },
        },
        yAxis: isFullField ? {
            width: fullFieldChartW,
            height: fullFieldHpx,
            min: ffMinY,
            max: ffMaxY,
            gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            title: {
                text: null,
            },
            labels: {
                enabled: false,
            },
        } : {
            height,
            width: canvasWidth,
            min: (type === 'infield' ? 1.5 : 0),
            max: chartMaxY,
            gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            title: {
                text: null,
            },
            labels: {
                enabled: false,
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (this.point.tooltip === undefined)
                    return false;
                let tooltip = `<b>${this.point.name || this.series.name}</b>`;
                if (this.point.tooltip)
                    tooltip += `<br/>${this.point.tooltip}`;
                return tooltip;
            },
        },
        series: processedSeries,
    };
    return (React.createElement(Container$g, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: isFullField ? fullFieldChartW : width, options: chartConfig, useBodyFont: false, className: "sprayChart" })));
});

/* eslint-disable @typescript-eslint/no-explicit-any */
const generatexplotlines = (levels) => levels.map((l) => ({
    value: l.gameDate.getTime(),
    color: '#B9B9B9',
    width: 1,
    dashStyle: 'Dash',
    label: {
        text: l.levelAbbr,
        rotation: 270,
        x: 12,
        y: 35,
        style: {
            color: '#A2A2A2',
        },
    },
}));
const leagueAvgPlotlineColor = 'rgba(255, 128, 128, .5)';
const targetPlotlineColor = 'rgba(0, 255, 0, .8)';
const generateyplotlines = (leagueAvgRate) => ({
    value: leagueAvgRate,
    color: leagueAvgPlotlineColor,
    width: 4,
    events: {
        mouseover(e) {
            const series = this.axis.series[0];
            const { chart } = series;
            const PointClass = series.pointClass;
            const { tooltip } = chart;
            const point = (new PointClass()).init(series, ['avg', this.options.value]);
            const normalizedEvent = chart.pointer.normalize(e);
            point.tooltipPos = [
                normalizedEvent.chartX - chart.plotLeft,
                normalizedEvent.chartY - chart.plotTop,
            ];
            tooltip.refresh(point);
        },
        mouseout() {
            this.axis.chart.tooltip.hide();
        },
    },
});
const generatetargetplotline = (targetVal) => ({
    value: targetVal,
    color: targetPlotlineColor,
    width: 2,
    events: {
        mouseover(e) {
            const series = this.axis.series[0];
            const { chart } = series;
            const PointClass = series.pointClass;
            const { tooltip } = chart;
            const point = (new PointClass()).init(series, ['target', this.options.value]);
            const normalizedEvent = chart.pointer.normalize(e);
            point.tooltipPos = [
                normalizedEvent.chartX - chart.plotLeft,
                normalizedEvent.chartY - chart.plotTop,
            ];
            tooltip.refresh(point);
        },
        mouseout() {
            this.axis.chart.tooltip.hide();
        },
    },
});
const ObjectiveMetricChart = ({ seriesData, minY, maxY, minRangeY, minX, maxX, labelFormat, leagueAvg, targetVal, levels, showLeagueAvgLineName, showTargetLineName, disableLegendInteractivity }) => {
    const dateArray = [];
    const currentDate = minX;
    while (currentDate <= maxX) {
        dateArray.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    const tickPositions = dateArray.filter((d) => d.getDate() === 1)
        .map((d) => (new Date(`${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`)).getTime());
    let seriesDataUse = seriesData;
    if (showLeagueAvgLineName) { // these are to allow the user to add to the legend the target/league lines (by passing in what to call them, since it needs to be translated)
        seriesDataUse = [...seriesDataUse, { color: leagueAvgPlotlineColor, name: showLeagueAvgLineName, data: [], type: 'line', legendSymbol: 'lineMarker' }];
    }
    if (showTargetLineName) {
        seriesDataUse = [...seriesDataUse, { color: targetPlotlineColor, name: showTargetLineName, data: [], type: 'line', legendSymbol: 'lineMarker' }];
    }
    const chartConfig = {
        title: undefined,
        series: seriesDataUse.map((series) => (Object.assign(Object.assign({}, series), { events: disableLegendInteractivity ? {
                legendItemClick(event) {
                    event.preventDefault();
                },
            } : {} }))),
        xAxis: {
            plotLines: generatexplotlines(levels),
            labels: {
                formatter() {
                    return dateFormat('%b %e', Number(this.value));
                },
            },
            tickPositions,
        },
        yAxis: {
            title: undefined,
            plotLines: leagueAvg ? [generateyplotlines(leagueAvg), generatetargetplotline(targetVal)] : [generatetargetplotline(targetVal)],
            labels: {
                format: labelFormat,
            },
            max: maxY,
            min: minY,
            minRange: minRangeY,
        },
        chart: {
            height: 250,
            backgroundColor: 'transparent',
            plotBackgroundColor: 'white',
        },
        legend: {
            enabled: true,
        },
    };
    return React.createElement(BaseChart, { options: chartConfig, height: 250, className: "objectiveMetricChart" });
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$f = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
function roundCornerBox(pathBBox, radius) {
    const { x, y, width, height } = pathBBox;
    const eightPoints = [
        { x, y: y + radius },
        { x: x + radius, y },
        { x: x - radius + width, y },
        { x: x + width, y: y + radius },
        { x: x + width, y: y + height - radius },
        { x: x + width - radius, y: y + height },
        { x: x + radius, y: y + height },
        { x, y: y + height - radius },
    ];
    const controlPoints = [
        { x, y },
        { x: x + width, y },
        { x: x + width, y: y + height },
        { x, y: y + height },
    ];
    let controlPointIndex = 0;
    let lastCommand = 'Q';
    let controlPoint = controlPoints[0];
    let d = '';
    eightPoints.forEach((point, index) => {
        if (index === 0) {
            d += `M ${point.x} ${point.y} `;
            return;
        }
        if (lastCommand === 'Q') {
            controlPoint = controlPoints[controlPointIndex];
            d += `${lastCommand} ${controlPoint.x} ${controlPoint.y} ${point.x} ${point.y}`;
            lastCommand = 'L';
            // eslint-disable-next-line no-plusplus
            controlPointIndex++;
        }
        else {
            d += `${lastCommand} ${point.x} ${point.y} `;
            lastCommand = 'Q';
        }
    });
    d += 'z';
    return d;
}
const PerformanceScienceBoxChart = ({ seriesData, width, height = 400, titleX, minY, maxY, minX, maxX, showLegend = false, title = '', subtitle = '', titleY = '', plotLineValue, minLabel = '', maxLabel = '', }) => {
    const chartConfig = {
        chart: {
            type: 'boxplot',
            inverted: true,
            width,
            height,
            events: {
                render() {
                    const { points } = this.series[0];
                    if (!points[0])
                        return;
                    let pathBBox;
                    let path;
                    // calculate an appropriate radius based on the percentage of the graph taken up by the plot
                    const impliedRadius = Math.ceil(128 * (points[0].high - points[0].low) / (maxY - minY));
                    const radius = impliedRadius > 15 ? 15 : impliedRadius; // cap the radius at 15
                    Highcharts.each(points, (p) => {
                        if (p.graphic != null) {
                            // eslint-disable-next-line prefer-destructuring
                            path = p.graphic.element.children[2];
                            pathBBox = path.getBBox();
                            path.setAttribute('d', roundCornerBox(pathBBox, radius));
                        }
                    }, this);
                },
            },
        },
        title: {
            text: title,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
            y: height * 0.175,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            min: minX,
            max: maxX,
            title: {
                text: titleX,
            },
            showFirstLabel: false,
            lineWidth: 0,
            tickWidth: 0,
            gridLineColor: 'transparent',
            labels: { enabled: false },
            plotLines: [{ color: '#cccccc', width: 2, value: 0, zIndex: 0 }],
        },
        yAxis: {
            min: minY,
            max: maxY,
            title: {
                text: titleY,
            },
            tickPositioner() {
                return [minY, maxY];
            },
            startOnTick: false,
            endOnTick: false,
            showFirstLabel: false,
            plotLines: [{ color: '#9cccfe', width: 5, value: plotLineValue, zIndex: 0 }],
            gridLineColor: 'transparent',
            lineWidth: 0,
            tickWidth: 0,
            labels: {
                y: title.length > 0 ? -0.3 * height : -0.5 * height,
                formatter() {
                    const label = this.axis.defaultLabelFormatter.call(this);
                    if (minLabel === '' && maxLabel === '')
                        return label;
                    if (label === minY.toString() && minLabel !== '')
                        return minLabel;
                    if (label === maxY.toString() && maxLabel !== '')
                        return maxLabel;
                    return label;
                },
            },
        },
        plotOptions: {
            boxplot: {
                color: '#008800',
                fillColor: '#0C5DA5',
                lineWidth: 0,
                medianColor: '#880000',
                medianWidth: 0,
                stemWidth: 0,
                whiskerColor: 'red',
                whiskerLength: '20%',
                whiskerWidth: 0,
                grouping: false,
            },
        },
        legend: {
            enabled: showLegend,
            align: 'right',
            verticalAlign: 'top',
        },
        series: seriesData,
    };
    return (React.createElement(Container$f, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$e = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
const yAxisBank = {
    8: {
        min: 0.5,
        max: 8.5,
        minorTickInterval: 'auto',
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
        },
        plotBands: [{
                from: 0.5,
                to: 1.5,
                color: '#B51B1B',
                thickness: 30,
            }, {
                from: 1.5,
                to: 2.5,
                color: '#F54B4E',
                thickness: 30,
            }, {
                from: 2.5,
                to: 3.5,
                color: '#FD9D9F',
                thickness: 30,
            }, {
                from: 3.5,
                to: 4.5,
                color: '#CECECE',
                thickness: 30,
            }, {
                from: 4.5,
                to: 5.5,
                color: '#C7E3FE',
                thickness: 30,
            }, {
                from: 5.5,
                to: 6.5,
                color: '#99CCFD',
                thickness: 30,
            }, {
                from: 6.5,
                to: 7.5,
                color: '#137AD6',
                thickness: 30,
            }, {
                from: 7.5,
                to: 8.5,
                color: '#274D74',
                thickness: 30,
            }],
    },
    5: {
        min: 0.5,
        max: 5.5,
        minorTickInterval: 'auto',
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
        },
        plotBands: [{
                from: 0.5,
                to: 1.5,
                color: '#F84949',
                thickness: 30,
            }, {
                from: 1.5,
                to: 2.5,
                color: '#FF9D9D',
                thickness: 30,
            }, {
                from: 2.5,
                to: 3.5,
                color: '#CECECE',
                thickness: 30,
            }, {
                from: 3.5,
                to: 4.5,
                color: '#98CBFF',
                thickness: 30,
            }, {
                from: 4.5,
                to: 5.5,
                color: '#0077D9',
                thickness: 30,
            }],
    },
    3: {
        min: 0.5,
        max: 3.5,
        minorTickInterval: 'auto',
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
        },
        plotBands: [{
                from: 0.5,
                to: 1.5,
                color: '#F84949',
                thickness: 30,
            }, {
                from: 1.5,
                to: 2.5,
                color: '#CECECE',
                thickness: 30,
            }, {
                from: 2.5,
                to: 3.5,
                color: '#0077D9',
                thickness: 30,
            }],
    },
};
const GasGaugeChart = ({ seriesData, width = 174, height = 174, title = '', plotBandsNum = 5, }) => {
    const yAxis = yAxisBank[plotBandsNum];
    const chartConfig = {
        chart: {
            type: 'gauge',
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
            margin: [0, 0, 0, 0],
            spacing: [0, 0, 0, 0],
        },
        title: {
            text: title,
        },
        tooltip: {
            enabled: false,
        },
        pane: {
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        // the value axis
        yAxis,
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 10,
                    radius: '85%',
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$e, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false, className: "gasGaugeChart" })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$d = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
const generateYAxis = (plotBandsNum, lowerBound, upperBound, dataColor) => {
    const yAxis = {
        min: 0.5,
        max: 0.5 + plotBandsNum,
        minorTickInterval: 1,
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickInterval: 1,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
            style: {
                color: '#123F6A',
                fontWeight: 'bold',
            },
        },
        lineColor: 'transparent',
        plotBands: [],
    };
    const gap = 0.033;
    const lb = lowerBound < upperBound ? lowerBound : upperBound;
    const ub = lowerBound < upperBound ? upperBound : lowerBound;
    const bandWidth = (plotBandsNum - (gap * (plotBandsNum - 1))) / plotBandsNum;
    for (let plotband = 1; plotband <= plotBandsNum; plotband++) {
        yAxis.plotBands.push({
            from: 0.5 + ((plotband - 1) * bandWidth) + ((plotband - 1) * gap),
            to: 0.5 + ((plotband - 1) * bandWidth) + ((plotband - 1) * gap) + bandWidth,
            color: lb <= plotband && plotband <= ub ? dataColor : '#CECECE',
            thickness: lb <= plotband && plotband <= ub ? 26 : 20,
            outerRadius: lb <= plotband && plotband <= ub ? '103%' : '100%',
        });
    }
    return yAxis;
};
const WedgeChart = ({ width = 300, height = 200, title = '', plotBandsNum = 5, lowerBound = 3, upperBound = 3, dataColor = '#003260', show2080Labels = false, draftBoardMode = false, }) => {
    const { t: translate } = useTranslation();
    const style2080 = {
        fontSize: height >= 300 ? '14px' : '10px',
        fontWeight: 'bold',
        color: 'rgba(51,51,51,1)',
    };
    const baseProps2080 = {
        linkedTo: 0,
        lineWidth: 0,
        minorTickLength: 0,
        tickWidth: 0,
        zIndex: 99,
    };
    const yAxis2080 = [
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [1], labels: {
                x: draftBoardMode ? -40 : -10,
                // eslint-disable-next-line no-nested-ternary
                y: draftBoardMode ? 15 : (height >= 300 ? 60 : 45),
                style: style2080,
                format: draftBoardMode ? translate('components.charts.min') : translate('components.charts.minimal'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [2], labels: {
                x: -50,
                y: -20,
                style: style2080,
                format: `${translate('components.charts.very')}</br>${translate('components.charts.low')}`,
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [3], labels: {
                x: -40,
                y: -30,
                style: style2080,
                format: translate('components.charts.low'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [4], labels: {
                x: 0,
                y: -35,
                style: style2080,
                format: translate('components.charts.moderate'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [5], labels: {
                x: 40,
                y: -30,
                style: style2080,
                format: translate('components.charts.high'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [6], labels: {
                x: 50,
                y: -20,
                style: style2080,
                format: `${translate('components.charts.very')}</br>${translate('components.charts.high')}`,
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [7], labels: {
                x: draftBoardMode ? 40 : 10,
                // eslint-disable-next-line no-nested-ternary
                y: draftBoardMode ? 15 : (height >= 300 ? 60 : 45),
                style: style2080,
                format: draftBoardMode ? translate('components.charts.max') : translate('components.charts.maximal'),
            } })
    ];
    const yAxis = generateYAxis(plotBandsNum, lowerBound, upperBound, dataColor);
    const seriesData = [{
            name: translate('components.charts.speed'),
            data: [],
            dataLabels: {
                enabled: false,
            },
        }];
    for (let dataPoint = lowerBound; dataPoint <= upperBound; dataPoint++) {
        seriesData[0].data.push(dataPoint);
    }
    const chartConfig = {
        chart: {
            type: 'gauge',
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
            margin: [10, 0, 0, 0],
            spacing: [0, 0, 0, 0],
        },
        title: {
            text: title,
            verticalAlign: 'bottom',
            floating: true,
            style: {
                color: 'rgba(51,51,51,1)',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily: 'Amble',
                letterSpacing: '0px',
                lineHeight: '16px',
            },
            y: draftBoardMode ? 12 : 2,
        },
        tooltip: {
            enabled: false,
        },
        pane: {
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        // the value axis
        yAxis: show2080Labels ? [yAxis, ...yAxis2080] : yAxis,
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 0,
                    radius: '0%',
                },
                pivot: {
                    radius: 0,
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$d, null,
        React.createElement(BaseChart, { immutable: true, width: width, options: chartConfig, useBodyFont: false, className: "wedgeChart" })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$c = styled.div `
    ${BaseChartContainer} {
        min-height: 24px;
        text-align: center;
    }
`;
const colorBuckets = (v) => {
    switch (Math.abs(v)) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
            return 'rgba(255,255,255,1.0)';
        case 15:
            return 'rgba(255, 230, 230, 1.0)';
        case 16:
            return 'rgba(255, 195, 195, 1.0)';
        case 17:
            return 'rgba(255, 180, 180, 1.0)';
        case 18:
            return 'rgba(250, 165, 165, 1.0)';
        case 19:
            return 'rgba(245, 150, 150, 1.0)';
        case 20:
            return 'rgba(240, 135, 135, 1.0)';
        case 21:
            return 'rgba(235, 120, 120, 1.0)';
        case 22:
            return 'rgba(230, 105, 105, 1.0)';
        case 23:
            return 'rgba(225, 90, 90, 1.0)';
        case 24:
            return 'rgba(220, 75, 75, 1.0)';
        case 25:
            return 'rgba(215, 60, 60, 1.0)';
        case 26:
            return 'rgba(210, 45, 45, 1.0)';
        case 27:
            return 'rgba(205, 30, 30, 1.0)';
        case 28:
            return 'rgba(200, 15, 15, 1.0)';
        case 29:
            return 'rgba(195, 0, 0, 1.0)';
        case 30:
            return 'rgba(180, 0, 0, 1.0)';
        default:
            return 'rgba(0,0,0,1.0)';
    }
};
const PerformanceScienceSymmetryChart = ({ width, height = 400, title = '', dotSize = 12, gridLineWidth = 10, score, }) => {
    const { t: translate } = useTranslation();
    // eslint-disable-next-line no-nested-ternary
    const val = score > 30 ? 30 : (score < -30 ? -30 : Math.round(score));
    const series = [{
            type: 'scatter',
            color: colorBuckets(val),
            data: [[val, 0]],
            marker: {
                lineColor: '#cecece',
                lineWidth: 2,
            },
        }];
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            backgroundColor: 'rgba(0,0,0,0)',
        },
        title: {
            text: title,
        },
        tooltip: {
            enabled: false,
        },
        xAxis: {
            min: -30,
            max: 30,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: false,
            visible: false,
            reversed: true,
        },
        yAxis: [{
                title: {
                    text: translate('baseball.abbr-left'),
                    rotation: 0,
                    y: 4,
                },
                gridLineWidth,
                labels: {
                    enabled: false,
                },
            }, {
                linkedTo: 0,
                opposite: true,
                labels: {
                    enabled: false,
                },
                title: {
                    text: translate('baseball.abbr-right'),
                    rotation: 0,
                    y: 4,
                },
            }],
        legend: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                marker: {
                    radius: dotSize,
                },
            },
        },
        series,
    };
    return (React.createElement(Container$c, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$b = styled.div `
    ${BaseChartContainer} {
        min-height: 24px;
        text-align: center;
    }
`;
const PerformanceScienceAsymmetryChart = ({ width = 400, height = 300, title = '', upperVal = 15, lowerVal = 5, medianVal = 10, dataLabelFontSize = '3.0em', labelY = -15, titleY = -11, }) => {
    const { t: translate } = useTranslation();
    const seriesData = [{
            name: translate('components.charts.speed'),
            data: [medianVal],
            dataLabels: {
                enabled: true,
                borderWidth: 0,
                formatter() {
                    return `${Math.round(Math.abs(this.y))}%`;
                },
                style: {
                    color: '#002E60',
                    fontWeight: 'bold',
                    fontSize: dataLabelFontSize,
                },
                y: labelY,
            },
        }];
    const yAxis = {
        min: -30,
        max: 30,
        reversed: true,
        minorTickInterval: 1,
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 2,
        tickLength: 15,
        tickInterval: 10,
        tickPosition: 'inside',
        tickColor: '#FFFFFF',
        labels: {
            enabled: false,
            style: {
                color: '#123F6A',
                fontWeight: 'bold',
            },
        },
        lineColor: 'transparent',
        plotBands: [{
                from: lowerVal,
                to: upperVal,
                color: '#9AAFC0',
                thickness: width >= 300 && height >= 300 ? 15 : 10,
                outerRadius: '83%',
            }, {
                from: medianVal - 0.40,
                to: medianVal + 0.40,
                color: '#002E60',
                thickness: width >= 300 && height >= 300 ? 22 : 17,
                outerRadius: '83%',
            }, {
                from: -20,
                to: 20,
                color: '#CECECE',
                thickness: 10,
                outerRadius: '96.5%',
            }, {
                from: -30,
                to: -20,
                color: '#E2364E',
                thickness: 10,
                outerRadius: '96.5%',
            }, {
                from: 20,
                to: 30,
                color: '#E2364E',
                thickness: 10,
                outerRadius: '96.5%',
            }],
    };
    const yAxisLabels = [
        {
            linkedTo: 0,
            lineWidth: 0,
            minorTickLength: 0,
            tickWidth: 0,
            zIndex: 99,
            tickPositions: [-30],
            labels: {
                x: width >= 300 && height >= 300 ? 10 : 35,
                y: width >= 300 && height >= 300 ? 40 : 30,
                style: {
                    fontSize: '30px',
                    fontWeight: 'bold',
                    color: '#7D7D7D',
                },
                format: 'R',
            },
        }, {
            linkedTo: 0,
            lineWidth: 0,
            minorTickLength: 0,
            tickWidth: 0,
            zIndex: 99,
            tickPositions: [30],
            labels: {
                x: width >= 300 && height >= 300 ? -10 : -35,
                y: width >= 300 && height >= 300 ? 40 : 30,
                style: {
                    fontSize: '30px',
                    fontWeight: 'bold',
                    color: '#7D7D7D',
                },
                format: 'L',
            },
        },
    ];
    // eslint-disable-next-line no-nested-ternary
    const chartConfig = {
        chart: {
            type: 'gauge',
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
            margin: 0,
        },
        pane: {
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        title: {
            text: title,
            verticalAlign: 'bottom',
            floating: true,
            style: {
                color: 'rgba(51,51,51,1)',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily: 'Amble',
                letterSpacing: '0px',
                lineHeight: '16px',
            },
            y: titleY,
        },
        tooltip: {
            enabled: false,
        },
        xAxis: {
            min: -30,
            max: 30,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: false,
            visible: false,
        },
        yAxis: [yAxis, ...yAxisLabels],
        legend: {
            enabled: false,
        },
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 0,
                    radius: '0%',
                },
                pivot: {
                    radius: 0,
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$b, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$a = styled.div `
    ${BaseChartContainer} {
        min-height: 24px;
        text-align: center;
    }
`;
const PerformanceScienceAthleticIndexChart = ({ width, height, title = '', data, }) => {
    const { t: translate } = useTranslation();
    let dataLabel = null;
    if (data.pmedianVal != null && data.fmedianVal != null) {
        dataLabel = `<span class="present-label">${format(data.pmedianVal, 0)} | </span><span class="future-label">${format(data.fmedianVal, 0)}</span>`;
    }
    else if (data.pmedianVal != null) {
        dataLabel = `<span class="present-label single-grade">${format(data.pmedianVal, 0)}</span>`;
    }
    else if (data.fmedianVal != null) {
        dataLabel = `<span class="future-label single-grade">${format(data.fmedianVal, 0)}</span>`;
    }
    const seriesData = [{
            name: translate('components.charts.speed'),
            data: [data.pmedianVal],
            dataLabels: {
                enabled: true,
                borderWidth: 0,
                format: dataLabel,
                useHTML: true,
                y: -30,
                x: 0,
            },
        }];
    const yAxis = {
        min: 20,
        max: 80,
        minorTickInterval: 1,
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 2,
        tickLength: 12,
        tickInterval: 10,
        tickPosition: 'inside',
        tickColor: '#FFFFFF',
        labels: {
            enabled: false,
            style: {
                color: '#123F6A',
                fontWeight: '700',
                fontFamily: 'Amble',
                letterSpacing: '0px',
            },
        },
        lineColor: 'transparent',
        plotBands: [{
                from: data.plowerVal,
                to: data.pupperVal,
                color: '#9AAFC0',
                thickness: 10,
                outerRadius: '84%',
            }, {
                from: data.pmedianVal - 0.40,
                to: data.pmedianVal + 0.40,
                color: '#002E60',
                thickness: 17,
                outerRadius: '84%',
            }, {
                from: data.flowerVal,
                to: data.fupperVal,
                color: '#F3B2BA',
                thickness: 10,
                outerRadius: '112%',
            }, {
                from: data.fmedianVal - 0.25,
                to: data.fmedianVal + 0.25,
                color: '#FF001B',
                thickness: 16,
                outerRadius: '119%',
            }, {
                from: 20,
                to: 80,
                color: '#CECECE',
                thickness: 10,
                outerRadius: '98.5%',
            }],
    };
    // eslint-disable-next-line no-nested-ternary
    const chartConfig = {
        chart: {
            type: 'gauge',
            width,
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
            style: {
                fontFamily: 'inherit', // Forces chart to inherit from the parent container
            },
        },
        pane: {
            center: ['50%', '70%'],
            size: '125%',
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        title: {
            text: title,
            verticalAlign: 'bottom',
            floating: true,
            style: {
                color: 'rgba(51,51,51,1)',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily: 'Amble',
                letterSpacing: '0px',
                lineHeight: '16px',
            },
            y: 30,
        },
        tooltip: {
            enabled: false,
        },
        xAxis: {
            min: -30,
            max: 30,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: false,
            visible: false,
        },
        yAxis,
        legend: {
            enabled: false,
        },
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 0,
                    radius: '0%',
                },
                pivot: {
                    radius: 0,
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$a, null,
        React.createElement(BaseChart, { width: width, height: height, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
const PerformanceScienceFilledCircle = ({ innerCircle, outerCircle, width = 10, }) => {
    const CircleDiv = styled.div `
        width: ${2 * width}px;
        height: ${2 * width}px;
    `;
    return (React.createElement(CircleDiv, null,
        React.createElement("svg", { width: (width + 5) * 2, height: (width + 5) * 2, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: width + 5, cy: width + 5, r: width, strokeWidth: "0", fill: "#002E60", fillOpacity: "100%" }),
            !outerCircle && (React.createElement("circle", { cx: width + 5, cy: width + 5, r: 0.75 * width, strokeWidth: "0", fill: "#FFFFFF", fillOpacity: "100%" })),
            !innerCircle && (React.createElement("circle", { cx: width + 5, cy: width + 5, r: 0.5 * width, strokeWidth: "0", fill: "#FFFFFF", fillOpacity: "100%" })),
            innerCircle && (React.createElement("circle", { cx: width + 5, cy: width + 5, r: 0.5 * width, strokeWidth: "0", fill: "#002E60", fillOpacity: "100%" })))));
};

/* eslint-disable max-len */
const StyledPercentageCircleContainer = styled.div `
/****************************************************************
 *
 * CSS Percentage Circle
 * Author: Andre Firchow
 *
*****************************************************************/
.rect-auto, .c100.p51 .slice, .c100.p52 .slice, .c100.p53 .slice, .c100.p54 .slice, .c100.p55 .slice, .c100.p56 .slice, .c100.p57 .slice, .c100.p58 .slice, .c100.p59 .slice, .c100.p60 .slice, .c100.p61 .slice, .c100.p62 .slice, .c100.p63 .slice, .c100.p64 .slice, .c100.p65 .slice, .c100.p66 .slice, .c100.p67 .slice, .c100.p68 .slice, .c100.p69 .slice, .c100.p70 .slice, .c100.p71 .slice, .c100.p72 .slice, .c100.p73 .slice, .c100.p74 .slice, .c100.p75 .slice, .c100.p76 .slice, .c100.p77 .slice, .c100.p78 .slice, .c100.p79 .slice, .c100.p80 .slice, .c100.p81 .slice, .c100.p82 .slice, .c100.p83 .slice, .c100.p84 .slice, .c100.p85 .slice, .c100.p86 .slice, .c100.p87 .slice, .c100.p88 .slice, .c100.p89 .slice, .c100.p90 .slice, .c100.p91 .slice, .c100.p92 .slice, .c100.p93 .slice, .c100.p94 .slice, .c100.p95 .slice, .c100.p96 .slice, .c100.p97 .slice, .c100.p98 .slice, .c100.p99 .slice, .c100.p100 .slice {
    clip: rect(auto, auto, auto, auto);
}

.pie, .c100 .bar, .c100.p51 .fill, .c100.p52 .fill, .c100.p53 .fill, .c100.p54 .fill, .c100.p55 .fill, .c100.p56 .fill, .c100.p57 .fill, .c100.p58 .fill, .c100.p59 .fill, .c100.p60 .fill, .c100.p61 .fill, .c100.p62 .fill, .c100.p63 .fill, .c100.p64 .fill, .c100.p65 .fill, .c100.p66 .fill, .c100.p67 .fill, .c100.p68 .fill, .c100.p69 .fill, .c100.p70 .fill, .c100.p71 .fill, .c100.p72 .fill, .c100.p73 .fill, .c100.p74 .fill, .c100.p75 .fill, .c100.p76 .fill, .c100.p77 .fill, .c100.p78 .fill, .c100.p79 .fill, .c100.p80 .fill, .c100.p81 .fill, .c100.p82 .fill, .c100.p83 .fill, .c100.p84 .fill, .c100.p85 .fill, .c100.p86 .fill, .c100.p87 .fill, .c100.p88 .fill, .c100.p89 .fill, .c100.p90 .fill, .c100.p91 .fill, .c100.p92 .fill, .c100.p93 .fill, .c100.p94 .fill, .c100.p95 .fill, .c100.p96 .fill, .c100.p97 .fill, .c100.p98 .fill, .c100.p99 .fill, .c100.p100 .fill {
    position: absolute;
    border: 0.18em solid #254c75;
    width: 0.64em;
    height: 0.64em;
    clip: rect(0em, 0.5em, 1em, 0em);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
}

.pie-fill, .c100.p51 .bar:after, .c100.p51 .fill, .c100.p52 .bar:after, .c100.p52 .fill, .c100.p53 .bar:after, .c100.p53 .fill, .c100.p54 .bar:after, .c100.p54 .fill, .c100.p55 .bar:after, .c100.p55 .fill, .c100.p56 .bar:after, .c100.p56 .fill, .c100.p57 .bar:after, .c100.p57 .fill, .c100.p58 .bar:after, .c100.p58 .fill, .c100.p59 .bar:after, .c100.p59 .fill, .c100.p60 .bar:after, .c100.p60 .fill, .c100.p61 .bar:after, .c100.p61 .fill, .c100.p62 .bar:after, .c100.p62 .fill, .c100.p63 .bar:after, .c100.p63 .fill, .c100.p64 .bar:after, .c100.p64 .fill, .c100.p65 .bar:after, .c100.p65 .fill, .c100.p66 .bar:after, .c100.p66 .fill, .c100.p67 .bar:after, .c100.p67 .fill, .c100.p68 .bar:after, .c100.p68 .fill, .c100.p69 .bar:after, .c100.p69 .fill, .c100.p70 .bar:after, .c100.p70 .fill, .c100.p71 .bar:after, .c100.p71 .fill, .c100.p72 .bar:after, .c100.p72 .fill, .c100.p73 .bar:after, .c100.p73 .fill, .c100.p74 .bar:after, .c100.p74 .fill, .c100.p75 .bar:after, .c100.p75 .fill, .c100.p76 .bar:after, .c100.p76 .fill, .c100.p77 .bar:after, .c100.p77 .fill, .c100.p78 .bar:after, .c100.p78 .fill, .c100.p79 .bar:after, .c100.p79 .fill, .c100.p80 .bar:after, .c100.p80 .fill, .c100.p81 .bar:after, .c100.p81 .fill, .c100.p82 .bar:after, .c100.p82 .fill, .c100.p83 .bar:after, .c100.p83 .fill, .c100.p84 .bar:after, .c100.p84 .fill, .c100.p85 .bar:after, .c100.p85 .fill, .c100.p86 .bar:after, .c100.p86 .fill, .c100.p87 .bar:after, .c100.p87 .fill, .c100.p88 .bar:after, .c100.p88 .fill, .c100.p89 .bar:after, .c100.p89 .fill, .c100.p90 .bar:after, .c100.p90 .fill, .c100.p91 .bar:after, .c100.p91 .fill, .c100.p92 .bar:after, .c100.p92 .fill, .c100.p93 .bar:after, .c100.p93 .fill, .c100.p94 .bar:after, .c100.p94 .fill, .c100.p95 .bar:after, .c100.p95 .fill, .c100.p96 .bar:after, .c100.p96 .fill, .c100.p97 .bar:after, .c100.p97 .fill, .c100.p98 .bar:after, .c100.p98 .fill, .c100.p99 .bar:after, .c100.p99 .fill, .c100.p100 .bar:after, .c100.p100 .fill {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
}

.c100 {
    position: relative;
    font-size: 120px;
    width: 1em;
    height: 1em;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
    float: left;
    margin: 0 0.1em 0.1em 0;
    background-color: #cccccc;
}

    .c100 *, .c100 *:before, .c100 *:after {
        -webkit-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
    }

    .c100.center {
        float: none;
        margin: 0 auto;
    }

    .c100.big {
        font-size: 240px;
    }

    .c100.small {
        font-size: 80px;
    }

    .c100 > span {
        position: absolute;
        width: 100%;
        z-index: 1;
        left: 0;
        top: -0.5em;
        width: 4em;
        line-height: 5em;
        font-size: 0.25em;
        color: #254c75;
        font-weight: bold;
        display: block;
        text-align: center;
        white-space: nowrap;
        pointer-events: none;
    }

    .c100 > div.captiontext {
        position: absolute;
        width: 100%;
        font-weight: bold;
        z-index: 1;
        left: 50%;
        margin-left: -2.5em;
        top: 75%;
        width: 5em;
        line-height: 5em;
        font-size: 0.12em;
        color: #254c75;
        display: block;
        text-align: center;
        white-space: nowrap;
    }

    .c100:after {
        position: absolute;
        top: 0.18em;
        left: 0.18em;
        display: block;
        content: " ";
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        -o-border-radius: 50%;
        border-radius: 50%;
        background-color: whitesmoke;
        width: 0.64em;
        height: 0.64em;
    }

    .c100 .slice {
        position: absolute;
        width: 1em;
        height: 1em;
        clip: rect(0em, 1em, 1em, 0.5em);
    }

    .c100.p1 .bar {
        -webkit-transform: rotate(3.6deg);
        -moz-transform: rotate(3.6deg);
        -ms-transform: rotate(3.6deg);
        -o-transform: rotate(3.6deg);
        transform: rotate(3.6deg);
    }

    .c100.p2 .bar {
        -webkit-transform: rotate(7.2deg);
        -moz-transform: rotate(7.2deg);
        -ms-transform: rotate(7.2deg);
        -o-transform: rotate(7.2deg);
        transform: rotate(7.2deg);
    }

    .c100.p3 .bar {
        -webkit-transform: rotate(10.8deg);
        -moz-transform: rotate(10.8deg);
        -ms-transform: rotate(10.8deg);
        -o-transform: rotate(10.8deg);
        transform: rotate(10.8deg);
    }

    .c100.p4 .bar {
        -webkit-transform: rotate(14.4deg);
        -moz-transform: rotate(14.4deg);
        -ms-transform: rotate(14.4deg);
        -o-transform: rotate(14.4deg);
        transform: rotate(14.4deg);
    }

    .c100.p5 .bar {
        -webkit-transform: rotate(18deg);
        -moz-transform: rotate(18deg);
        -ms-transform: rotate(18deg);
        -o-transform: rotate(18deg);
        transform: rotate(18deg);
    }

    .c100.p6 .bar {
        -webkit-transform: rotate(21.6deg);
        -moz-transform: rotate(21.6deg);
        -ms-transform: rotate(21.6deg);
        -o-transform: rotate(21.6deg);
        transform: rotate(21.6deg);
    }

    .c100.p7 .bar {
        -webkit-transform: rotate(25.2deg);
        -moz-transform: rotate(25.2deg);
        -ms-transform: rotate(25.2deg);
        -o-transform: rotate(25.2deg);
        transform: rotate(25.2deg);
    }

    .c100.p8 .bar {
        -webkit-transform: rotate(28.8deg);
        -moz-transform: rotate(28.8deg);
        -ms-transform: rotate(28.8deg);
        -o-transform: rotate(28.8deg);
        transform: rotate(28.8deg);
    }

    .c100.p9 .bar {
        -webkit-transform: rotate(32.4deg);
        -moz-transform: rotate(32.4deg);
        -ms-transform: rotate(32.4deg);
        -o-transform: rotate(32.4deg);
        transform: rotate(32.4deg);
    }

    .c100.p10 .bar {
        -webkit-transform: rotate(36deg);
        -moz-transform: rotate(36deg);
        -ms-transform: rotate(36deg);
        -o-transform: rotate(36deg);
        transform: rotate(36deg);
    }

    .c100.p11 .bar {
        -webkit-transform: rotate(39.6deg);
        -moz-transform: rotate(39.6deg);
        -ms-transform: rotate(39.6deg);
        -o-transform: rotate(39.6deg);
        transform: rotate(39.6deg);
    }

    .c100.p12 .bar {
        -webkit-transform: rotate(43.2deg);
        -moz-transform: rotate(43.2deg);
        -ms-transform: rotate(43.2deg);
        -o-transform: rotate(43.2deg);
        transform: rotate(43.2deg);
    }

    .c100.p13 .bar {
        -webkit-transform: rotate(46.8deg);
        -moz-transform: rotate(46.8deg);
        -ms-transform: rotate(46.8deg);
        -o-transform: rotate(46.8deg);
        transform: rotate(46.8deg);
    }

    .c100.p14 .bar {
        -webkit-transform: rotate(50.4deg);
        -moz-transform: rotate(50.4deg);
        -ms-transform: rotate(50.4deg);
        -o-transform: rotate(50.4deg);
        transform: rotate(50.4deg);
    }

    .c100.p15 .bar {
        -webkit-transform: rotate(54deg);
        -moz-transform: rotate(54deg);
        -ms-transform: rotate(54deg);
        -o-transform: rotate(54deg);
        transform: rotate(54deg);
    }

    .c100.p16 .bar {
        -webkit-transform: rotate(57.6deg);
        -moz-transform: rotate(57.6deg);
        -ms-transform: rotate(57.6deg);
        -o-transform: rotate(57.6deg);
        transform: rotate(57.6deg);
    }

    .c100.p17 .bar {
        -webkit-transform: rotate(61.2deg);
        -moz-transform: rotate(61.2deg);
        -ms-transform: rotate(61.2deg);
        -o-transform: rotate(61.2deg);
        transform: rotate(61.2deg);
    }

    .c100.p18 .bar {
        -webkit-transform: rotate(64.8deg);
        -moz-transform: rotate(64.8deg);
        -ms-transform: rotate(64.8deg);
        -o-transform: rotate(64.8deg);
        transform: rotate(64.8deg);
    }

    .c100.p19 .bar {
        -webkit-transform: rotate(68.4deg);
        -moz-transform: rotate(68.4deg);
        -ms-transform: rotate(68.4deg);
        -o-transform: rotate(68.4deg);
        transform: rotate(68.4deg);
    }

    .c100.p20 .bar {
        -webkit-transform: rotate(72deg);
        -moz-transform: rotate(72deg);
        -ms-transform: rotate(72deg);
        -o-transform: rotate(72deg);
        transform: rotate(72deg);
    }

    .c100.p21 .bar {
        -webkit-transform: rotate(75.6deg);
        -moz-transform: rotate(75.6deg);
        -ms-transform: rotate(75.6deg);
        -o-transform: rotate(75.6deg);
        transform: rotate(75.6deg);
    }

    .c100.p22 .bar {
        -webkit-transform: rotate(79.2deg);
        -moz-transform: rotate(79.2deg);
        -ms-transform: rotate(79.2deg);
        -o-transform: rotate(79.2deg);
        transform: rotate(79.2deg);
    }

    .c100.p23 .bar {
        -webkit-transform: rotate(82.8deg);
        -moz-transform: rotate(82.8deg);
        -ms-transform: rotate(82.8deg);
        -o-transform: rotate(82.8deg);
        transform: rotate(82.8deg);
    }

    .c100.p24 .bar {
        -webkit-transform: rotate(86.4deg);
        -moz-transform: rotate(86.4deg);
        -ms-transform: rotate(86.4deg);
        -o-transform: rotate(86.4deg);
        transform: rotate(86.4deg);
    }

    .c100.p25 .bar {
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    .c100.p26 .bar {
        -webkit-transform: rotate(93.6deg);
        -moz-transform: rotate(93.6deg);
        -ms-transform: rotate(93.6deg);
        -o-transform: rotate(93.6deg);
        transform: rotate(93.6deg);
    }

    .c100.p27 .bar {
        -webkit-transform: rotate(97.2deg);
        -moz-transform: rotate(97.2deg);
        -ms-transform: rotate(97.2deg);
        -o-transform: rotate(97.2deg);
        transform: rotate(97.2deg);
    }

    .c100.p28 .bar {
        -webkit-transform: rotate(100.8deg);
        -moz-transform: rotate(100.8deg);
        -ms-transform: rotate(100.8deg);
        -o-transform: rotate(100.8deg);
        transform: rotate(100.8deg);
    }

    .c100.p29 .bar {
        -webkit-transform: rotate(104.4deg);
        -moz-transform: rotate(104.4deg);
        -ms-transform: rotate(104.4deg);
        -o-transform: rotate(104.4deg);
        transform: rotate(104.4deg);
    }

    .c100.p30 .bar {
        -webkit-transform: rotate(108deg);
        -moz-transform: rotate(108deg);
        -ms-transform: rotate(108deg);
        -o-transform: rotate(108deg);
        transform: rotate(108deg);
    }

    .c100.p31 .bar {
        -webkit-transform: rotate(111.6deg);
        -moz-transform: rotate(111.6deg);
        -ms-transform: rotate(111.6deg);
        -o-transform: rotate(111.6deg);
        transform: rotate(111.6deg);
    }

    .c100.p32 .bar {
        -webkit-transform: rotate(115.2deg);
        -moz-transform: rotate(115.2deg);
        -ms-transform: rotate(115.2deg);
        -o-transform: rotate(115.2deg);
        transform: rotate(115.2deg);
    }

    .c100.p33 .bar {
        -webkit-transform: rotate(118.8deg);
        -moz-transform: rotate(118.8deg);
        -ms-transform: rotate(118.8deg);
        -o-transform: rotate(118.8deg);
        transform: rotate(118.8deg);
    }

    .c100.p34 .bar {
        -webkit-transform: rotate(122.4deg);
        -moz-transform: rotate(122.4deg);
        -ms-transform: rotate(122.4deg);
        -o-transform: rotate(122.4deg);
        transform: rotate(122.4deg);
    }

    .c100.p35 .bar {
        -webkit-transform: rotate(126deg);
        -moz-transform: rotate(126deg);
        -ms-transform: rotate(126deg);
        -o-transform: rotate(126deg);
        transform: rotate(126deg);
    }

    .c100.p36 .bar {
        -webkit-transform: rotate(129.6deg);
        -moz-transform: rotate(129.6deg);
        -ms-transform: rotate(129.6deg);
        -o-transform: rotate(129.6deg);
        transform: rotate(129.6deg);
    }

    .c100.p37 .bar {
        -webkit-transform: rotate(133.2deg);
        -moz-transform: rotate(133.2deg);
        -ms-transform: rotate(133.2deg);
        -o-transform: rotate(133.2deg);
        transform: rotate(133.2deg);
    }

    .c100.p38 .bar {
        -webkit-transform: rotate(136.8deg);
        -moz-transform: rotate(136.8deg);
        -ms-transform: rotate(136.8deg);
        -o-transform: rotate(136.8deg);
        transform: rotate(136.8deg);
    }

    .c100.p39 .bar {
        -webkit-transform: rotate(140.4deg);
        -moz-transform: rotate(140.4deg);
        -ms-transform: rotate(140.4deg);
        -o-transform: rotate(140.4deg);
        transform: rotate(140.4deg);
    }

    .c100.p40 .bar {
        -webkit-transform: rotate(144deg);
        -moz-transform: rotate(144deg);
        -ms-transform: rotate(144deg);
        -o-transform: rotate(144deg);
        transform: rotate(144deg);
    }

    .c100.p41 .bar {
        -webkit-transform: rotate(147.6deg);
        -moz-transform: rotate(147.6deg);
        -ms-transform: rotate(147.6deg);
        -o-transform: rotate(147.6deg);
        transform: rotate(147.6deg);
    }

    .c100.p42 .bar {
        -webkit-transform: rotate(151.2deg);
        -moz-transform: rotate(151.2deg);
        -ms-transform: rotate(151.2deg);
        -o-transform: rotate(151.2deg);
        transform: rotate(151.2deg);
    }

    .c100.p43 .bar {
        -webkit-transform: rotate(154.8deg);
        -moz-transform: rotate(154.8deg);
        -ms-transform: rotate(154.8deg);
        -o-transform: rotate(154.8deg);
        transform: rotate(154.8deg);
    }

    .c100.p44 .bar {
        -webkit-transform: rotate(158.4deg);
        -moz-transform: rotate(158.4deg);
        -ms-transform: rotate(158.4deg);
        -o-transform: rotate(158.4deg);
        transform: rotate(158.4deg);
    }

    .c100.p45 .bar {
        -webkit-transform: rotate(162deg);
        -moz-transform: rotate(162deg);
        -ms-transform: rotate(162deg);
        -o-transform: rotate(162deg);
        transform: rotate(162deg);
    }

    .c100.p46 .bar {
        -webkit-transform: rotate(165.6deg);
        -moz-transform: rotate(165.6deg);
        -ms-transform: rotate(165.6deg);
        -o-transform: rotate(165.6deg);
        transform: rotate(165.6deg);
    }

    .c100.p47 .bar {
        -webkit-transform: rotate(169.2deg);
        -moz-transform: rotate(169.2deg);
        -ms-transform: rotate(169.2deg);
        -o-transform: rotate(169.2deg);
        transform: rotate(169.2deg);
    }

    .c100.p48 .bar {
        -webkit-transform: rotate(172.8deg);
        -moz-transform: rotate(172.8deg);
        -ms-transform: rotate(172.8deg);
        -o-transform: rotate(172.8deg);
        transform: rotate(172.8deg);
    }

    .c100.p49 .bar {
        -webkit-transform: rotate(176.4deg);
        -moz-transform: rotate(176.4deg);
        -ms-transform: rotate(176.4deg);
        -o-transform: rotate(176.4deg);
        transform: rotate(176.4deg);
    }

    .c100.p50 .bar {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        transform: rotate(180deg);
    }

    .c100.p51 .bar {
        -webkit-transform: rotate(183.6deg);
        -moz-transform: rotate(183.6deg);
        -ms-transform: rotate(183.6deg);
        -o-transform: rotate(183.6deg);
        transform: rotate(183.6deg);
    }

    .c100.p52 .bar {
        -webkit-transform: rotate(187.2deg);
        -moz-transform: rotate(187.2deg);
        -ms-transform: rotate(187.2deg);
        -o-transform: rotate(187.2deg);
        transform: rotate(187.2deg);
    }

    .c100.p53 .bar {
        -webkit-transform: rotate(190.8deg);
        -moz-transform: rotate(190.8deg);
        -ms-transform: rotate(190.8deg);
        -o-transform: rotate(190.8deg);
        transform: rotate(190.8deg);
    }

    .c100.p54 .bar {
        -webkit-transform: rotate(194.4deg);
        -moz-transform: rotate(194.4deg);
        -ms-transform: rotate(194.4deg);
        -o-transform: rotate(194.4deg);
        transform: rotate(194.4deg);
    }

    .c100.p55 .bar {
        -webkit-transform: rotate(198deg);
        -moz-transform: rotate(198deg);
        -ms-transform: rotate(198deg);
        -o-transform: rotate(198deg);
        transform: rotate(198deg);
    }

    .c100.p56 .bar {
        -webkit-transform: rotate(201.6deg);
        -moz-transform: rotate(201.6deg);
        -ms-transform: rotate(201.6deg);
        -o-transform: rotate(201.6deg);
        transform: rotate(201.6deg);
    }

    .c100.p57 .bar {
        -webkit-transform: rotate(205.2deg);
        -moz-transform: rotate(205.2deg);
        -ms-transform: rotate(205.2deg);
        -o-transform: rotate(205.2deg);
        transform: rotate(205.2deg);
    }

    .c100.p58 .bar {
        -webkit-transform: rotate(208.8deg);
        -moz-transform: rotate(208.8deg);
        -ms-transform: rotate(208.8deg);
        -o-transform: rotate(208.8deg);
        transform: rotate(208.8deg);
    }

    .c100.p59 .bar {
        -webkit-transform: rotate(212.4deg);
        -moz-transform: rotate(212.4deg);
        -ms-transform: rotate(212.4deg);
        -o-transform: rotate(212.4deg);
        transform: rotate(212.4deg);
    }

    .c100.p60 .bar {
        -webkit-transform: rotate(216deg);
        -moz-transform: rotate(216deg);
        -ms-transform: rotate(216deg);
        -o-transform: rotate(216deg);
        transform: rotate(216deg);
    }

    .c100.p61 .bar {
        -webkit-transform: rotate(219.6deg);
        -moz-transform: rotate(219.6deg);
        -ms-transform: rotate(219.6deg);
        -o-transform: rotate(219.6deg);
        transform: rotate(219.6deg);
    }

    .c100.p62 .bar {
        -webkit-transform: rotate(223.2deg);
        -moz-transform: rotate(223.2deg);
        -ms-transform: rotate(223.2deg);
        -o-transform: rotate(223.2deg);
        transform: rotate(223.2deg);
    }

    .c100.p63 .bar {
        -webkit-transform: rotate(226.8deg);
        -moz-transform: rotate(226.8deg);
        -ms-transform: rotate(226.8deg);
        -o-transform: rotate(226.8deg);
        transform: rotate(226.8deg);
    }

    .c100.p64 .bar {
        -webkit-transform: rotate(230.4deg);
        -moz-transform: rotate(230.4deg);
        -ms-transform: rotate(230.4deg);
        -o-transform: rotate(230.4deg);
        transform: rotate(230.4deg);
    }

    .c100.p65 .bar {
        -webkit-transform: rotate(234deg);
        -moz-transform: rotate(234deg);
        -ms-transform: rotate(234deg);
        -o-transform: rotate(234deg);
        transform: rotate(234deg);
    }

    .c100.p66 .bar {
        -webkit-transform: rotate(237.6deg);
        -moz-transform: rotate(237.6deg);
        -ms-transform: rotate(237.6deg);
        -o-transform: rotate(237.6deg);
        transform: rotate(237.6deg);
    }

    .c100.p67 .bar {
        -webkit-transform: rotate(241.2deg);
        -moz-transform: rotate(241.2deg);
        -ms-transform: rotate(241.2deg);
        -o-transform: rotate(241.2deg);
        transform: rotate(241.2deg);
    }

    .c100.p68 .bar {
        -webkit-transform: rotate(244.8deg);
        -moz-transform: rotate(244.8deg);
        -ms-transform: rotate(244.8deg);
        -o-transform: rotate(244.8deg);
        transform: rotate(244.8deg);
    }

    .c100.p69 .bar {
        -webkit-transform: rotate(248.4deg);
        -moz-transform: rotate(248.4deg);
        -ms-transform: rotate(248.4deg);
        -o-transform: rotate(248.4deg);
        transform: rotate(248.4deg);
    }

    .c100.p70 .bar {
        -webkit-transform: rotate(252deg);
        -moz-transform: rotate(252deg);
        -ms-transform: rotate(252deg);
        -o-transform: rotate(252deg);
        transform: rotate(252deg);
    }

    .c100.p71 .bar {
        -webkit-transform: rotate(255.6deg);
        -moz-transform: rotate(255.6deg);
        -ms-transform: rotate(255.6deg);
        -o-transform: rotate(255.6deg);
        transform: rotate(255.6deg);
    }

    .c100.p72 .bar {
        -webkit-transform: rotate(259.2deg);
        -moz-transform: rotate(259.2deg);
        -ms-transform: rotate(259.2deg);
        -o-transform: rotate(259.2deg);
        transform: rotate(259.2deg);
    }

    .c100.p73 .bar {
        -webkit-transform: rotate(262.8deg);
        -moz-transform: rotate(262.8deg);
        -ms-transform: rotate(262.8deg);
        -o-transform: rotate(262.8deg);
        transform: rotate(262.8deg);
    }

    .c100.p74 .bar {
        -webkit-transform: rotate(266.4deg);
        -moz-transform: rotate(266.4deg);
        -ms-transform: rotate(266.4deg);
        -o-transform: rotate(266.4deg);
        transform: rotate(266.4deg);
    }

    .c100.p75 .bar {
        -webkit-transform: rotate(270deg);
        -moz-transform: rotate(270deg);
        -ms-transform: rotate(270deg);
        -o-transform: rotate(270deg);
        transform: rotate(270deg);
    }

    .c100.p76 .bar {
        -webkit-transform: rotate(273.6deg);
        -moz-transform: rotate(273.6deg);
        -ms-transform: rotate(273.6deg);
        -o-transform: rotate(273.6deg);
        transform: rotate(273.6deg);
    }

    .c100.p77 .bar {
        -webkit-transform: rotate(277.2deg);
        -moz-transform: rotate(277.2deg);
        -ms-transform: rotate(277.2deg);
        -o-transform: rotate(277.2deg);
        transform: rotate(277.2deg);
    }

    .c100.p78 .bar {
        -webkit-transform: rotate(280.8deg);
        -moz-transform: rotate(280.8deg);
        -ms-transform: rotate(280.8deg);
        -o-transform: rotate(280.8deg);
        transform: rotate(280.8deg);
    }

    .c100.p79 .bar {
        -webkit-transform: rotate(284.4deg);
        -moz-transform: rotate(284.4deg);
        -ms-transform: rotate(284.4deg);
        -o-transform: rotate(284.4deg);
        transform: rotate(284.4deg);
    }

    .c100.p80 .bar {
        -webkit-transform: rotate(288deg);
        -moz-transform: rotate(288deg);
        -ms-transform: rotate(288deg);
        -o-transform: rotate(288deg);
        transform: rotate(288deg);
    }

    .c100.p81 .bar {
        -webkit-transform: rotate(291.6deg);
        -moz-transform: rotate(291.6deg);
        -ms-transform: rotate(291.6deg);
        -o-transform: rotate(291.6deg);
        transform: rotate(291.6deg);
    }

    .c100.p82 .bar {
        -webkit-transform: rotate(295.2deg);
        -moz-transform: rotate(295.2deg);
        -ms-transform: rotate(295.2deg);
        -o-transform: rotate(295.2deg);
        transform: rotate(295.2deg);
    }

    .c100.p83 .bar {
        -webkit-transform: rotate(298.8deg);
        -moz-transform: rotate(298.8deg);
        -ms-transform: rotate(298.8deg);
        -o-transform: rotate(298.8deg);
        transform: rotate(298.8deg);
    }

    .c100.p84 .bar {
        -webkit-transform: rotate(302.4deg);
        -moz-transform: rotate(302.4deg);
        -ms-transform: rotate(302.4deg);
        -o-transform: rotate(302.4deg);
        transform: rotate(302.4deg);
    }

    .c100.p85 .bar {
        -webkit-transform: rotate(306deg);
        -moz-transform: rotate(306deg);
        -ms-transform: rotate(306deg);
        -o-transform: rotate(306deg);
        transform: rotate(306deg);
    }

    .c100.p86 .bar {
        -webkit-transform: rotate(309.6deg);
        -moz-transform: rotate(309.6deg);
        -ms-transform: rotate(309.6deg);
        -o-transform: rotate(309.6deg);
        transform: rotate(309.6deg);
    }

    .c100.p87 .bar {
        -webkit-transform: rotate(313.2deg);
        -moz-transform: rotate(313.2deg);
        -ms-transform: rotate(313.2deg);
        -o-transform: rotate(313.2deg);
        transform: rotate(313.2deg);
    }

    .c100.p88 .bar {
        -webkit-transform: rotate(316.8deg);
        -moz-transform: rotate(316.8deg);
        -ms-transform: rotate(316.8deg);
        -o-transform: rotate(316.8deg);
        transform: rotate(316.8deg);
    }

    .c100.p89 .bar {
        -webkit-transform: rotate(320.4deg);
        -moz-transform: rotate(320.4deg);
        -ms-transform: rotate(320.4deg);
        -o-transform: rotate(320.4deg);
        transform: rotate(320.4deg);
    }

    .c100.p90 .bar {
        -webkit-transform: rotate(324deg);
        -moz-transform: rotate(324deg);
        -ms-transform: rotate(324deg);
        -o-transform: rotate(324deg);
        transform: rotate(324deg);
    }

    .c100.p91 .bar {
        -webkit-transform: rotate(327.6deg);
        -moz-transform: rotate(327.6deg);
        -ms-transform: rotate(327.6deg);
        -o-transform: rotate(327.6deg);
        transform: rotate(327.6deg);
    }

    .c100.p92 .bar {
        -webkit-transform: rotate(331.2deg);
        -moz-transform: rotate(331.2deg);
        -ms-transform: rotate(331.2deg);
        -o-transform: rotate(331.2deg);
        transform: rotate(331.2deg);
    }

    .c100.p93 .bar {
        -webkit-transform: rotate(334.8deg);
        -moz-transform: rotate(334.8deg);
        -ms-transform: rotate(334.8deg);
        -o-transform: rotate(334.8deg);
        transform: rotate(334.8deg);
    }

    .c100.p94 .bar {
        -webkit-transform: rotate(338.4deg);
        -moz-transform: rotate(338.4deg);
        -ms-transform: rotate(338.4deg);
        -o-transform: rotate(338.4deg);
        transform: rotate(338.4deg);
    }

    .c100.p95 .bar {
        -webkit-transform: rotate(342deg);
        -moz-transform: rotate(342deg);
        -ms-transform: rotate(342deg);
        -o-transform: rotate(342deg);
        transform: rotate(342deg);
    }

    .c100.p96 .bar {
        -webkit-transform: rotate(345.6deg);
        -moz-transform: rotate(345.6deg);
        -ms-transform: rotate(345.6deg);
        -o-transform: rotate(345.6deg);
        transform: rotate(345.6deg);
    }

    .c100.p97 .bar {
        -webkit-transform: rotate(349.2deg);
        -moz-transform: rotate(349.2deg);
        -ms-transform: rotate(349.2deg);
        -o-transform: rotate(349.2deg);
        transform: rotate(349.2deg);
    }

    .c100.p98 .bar {
        -webkit-transform: rotate(352.8deg);
        -moz-transform: rotate(352.8deg);
        -ms-transform: rotate(352.8deg);
        -o-transform: rotate(352.8deg);
        transform: rotate(352.8deg);
    }

    .c100.p99 .bar {
        -webkit-transform: rotate(356.4deg);
        -moz-transform: rotate(356.4deg);
        -ms-transform: rotate(356.4deg);
        -o-transform: rotate(356.4deg);
        transform: rotate(356.4deg);
    }

    .c100.p100 .bar {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }

    .c100.dark {
        background-color: #777777;
    }

        .c100.dark .bar,
        .c100.dark .fill {
            border-color: #c6ff00 !important;
        }

        .c100.dark > span {
            color: #777777;
        }

        .c100.dark:after {
            background-color: #666666;
        }

    .c100.green .bar, .c100.green .fill {
        border-color: #4db53c !important;
    }

    .c100.green.dark .bar, .c100.green.dark .fill {
        border-color: #5fd400 !important;
    }

    .c100.orange .bar, .c100.orange .fill {
        border-color: #dd9d22 !important;
    }

    .c100.orange.dark .bar, .c100.orange.dark .fill {
        border-color: #e08833 !important;
    }

`;
const PercentageCircle = ({ value, is2080 = false }) => {
    let valueclass = value;
    if (is2080) {
        valueclass = Math.floor(100 * ((value - 20) / 60));
    }
    return (React.createElement(StyledPercentageCircleContainer, { style: { marginBottom: '10px' } },
        React.createElement("div", { className: `c100 center p${valueclass}` },
            React.createElement("span", null, value),
            React.createElement("div", { className: "slice" },
                React.createElement("div", { className: "bar" }),
                React.createElement("div", { className: "fill" })))));
};

/* eslint-disable react/no-this-in-sfc */
const Container$9 = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
// eslint-disable-next-line no-mixed-operators
Highcharts.SVGRenderer.prototype.symbols.line = (x, y, w, h) => ['M', x + w / 2, y, 'L', x + w / 2, y + h, 'z'];
const PerformanceScienceProjectabilityBarChart = ({ seriesData, width = 325, height = 40, title, titleStyle, formatter }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    if (formatter === undefined) {
        // eslint-disable-next-line
        formatter = function () {
            // eslint-disable-next-line
            return this.y;
            // eslint-disable-next-line
        };
    }
    const chartConfig = {
        chart: {
            type: 'columnrange',
            height,
            width,
            margin: [12, 10, 12, 10],
            backgroundColor: 'transparent',
            inverted: true,
        },
        legend: {
            enabled: false,
        },
        title: {
            text: title,
            style: titleStyle,
            verticalAlign: 'bottom',
            margin: 0,
        },
        xAxis: {
            visible: false,
            categories: [translate('components.charts.present'), translate('components.charts.future')],
        },
        yAxis: {
            visible: true,
            labels: { enabled: false, align: 'center' },
            showFirstLabel: true,
            showLastLabel: true,
            title: { text: null },
            tickPositions: [20, 30, 40, 50, 60, 70, 80],
            min: 20,
            max: 80,
            offset: -24,
            lineColor: 'green',
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            columnrange: {
                borderRadius: 5,
                dataLabels: {
                    enabled: false,
                    formatter,
                },
                pointPadding: 0,
                groupPadding: 0,
            },
            scatter: {
                marker: {
                    symbol: 'line',
                    lineWidth: 3,
                    radius: 6,
                },
                dataLabels: { enabled: true },
            },
        },
        credits: {
            enabled: false,
        },
        series: seriesData,
    };
    return (React.createElement(Container$9, null,
        React.createElement(BaseChart, { ref: ref, width: width, height: height, options: chartConfig, useBodyFont: false })));
};

const Container$8 = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
const COLUMN_THICKNESS$1 = 30;
const chartElements = new WeakMap();
const PerformanceScienceSliderChart = ({ seriesData, width, height, min, max, minLabel = '', maxLabel = '', labelFontSize, plotLineValue, highlightRangeLower, highlightRangeUpper, label, labelValue, }) => {
    function getLabel(chart, lbl, yPos, xPos, rotation) {
        return chart.renderer
            .text(lbl, yPos, xPos)
            .css({
            fontSize: labelFontSize !== null && labelFontSize !== void 0 ? labelFontSize : '12px',
            fontWeight: 'bold',
            textAnchor: 'middle',
        })
            .attr({
            align: 'center',
            rotation,
        })
            .add();
    }
    function renderSlider(chart) {
        var _a;
        const xAxis = chart.xAxis[0];
        const yAxis = chart.yAxis[0];
        const columnRadius = COLUMN_THICKNESS$1 / 2;
        (_a = chartElements.get(chart)) === null || _a === void 0 ? void 0 : _a.forEach((element) => element.destroy());
        const els = [];
        if (plotLineValue !== undefined) {
            const pos = yAxis.toPixels(plotLineValue, false);
            const x0 = xAxis.toPixels(0, false);
            const plotLine = chart.renderer.path(['M', pos, x0 - columnRadius, 'L', pos, x0 + columnRadius])
                .attr({
                stroke: '#888888',
                'stroke-width': 3,
                zIndex: 1,
            })
                .add();
            els.push(plotLine);
        }
        if (minLabel) {
            const lbl = getLabel(chart, minLabel, yAxis.toPixels(min, false) - columnRadius, xAxis.toPixels(0, false), 270);
            els.push(lbl);
        }
        if (maxLabel) {
            const lbl = getLabel(chart, maxLabel, yAxis.toPixels(max, false) + columnRadius, xAxis.toPixels(0, false), 90);
            els.push(lbl);
        }
        const x0 = xAxis.toPixels(0, false);
        const minY = yAxis.toPixels(min, false);
        const maxY = yAxis.toPixels(max, false);
        const trackHeight = 10;
        const sliderTrack = chart.renderer.rect(Math.min(minY, maxY), x0 - (trackHeight / 2), Math.abs(maxY - minY), trackHeight, trackHeight / 2).attr({
            fill: '#e0e0e0',
            zIndex: 0,
        }).add();
        els.push(sliderTrack);
        if ((highlightRangeLower === null || highlightRangeLower === void 0 ? void 0 : highlightRangeLower.length) === 2) {
            const hlLeft = yAxis.toPixels(highlightRangeLower[0], false);
            const hlRight = yAxis.toPixels(highlightRangeLower[1], false);
            const mid = (hlLeft + hlRight) / 2;
            els.push(chart.renderer.rect(Math.min(hlLeft, hlRight), x0 - (trackHeight / 2), Math.abs(hlRight - hlLeft), trackHeight, trackHeight / 2).attr({
                fill: '#ffc704',
                zIndex: 0,
            }).add());
            els.push(chart.renderer.rect(Math.min(mid, hlRight), x0 - (trackHeight / 2), Math.abs(hlRight - mid), trackHeight, 0).attr({
                fill: '#ffc704',
                zIndex: 0,
            }).add());
        }
        if ((highlightRangeUpper === null || highlightRangeUpper === void 0 ? void 0 : highlightRangeUpper.length) === 2) {
            const hlLeft = yAxis.toPixels(highlightRangeUpper[0], false);
            const hlRight = yAxis.toPixels(highlightRangeUpper[1], false);
            const mid = (hlLeft + hlRight) / 2;
            els.push(chart.renderer.rect(Math.min(hlLeft, hlRight), x0 - (trackHeight / 2), Math.abs(hlRight - hlLeft), trackHeight, trackHeight / 2).attr({
                fill: '#ffc704',
                zIndex: 0,
            }).add());
            els.push(chart.renderer.rect(Math.min(hlLeft, mid), x0 - (trackHeight / 2), Math.abs(mid - hlLeft), trackHeight, 0).attr({
                fill: '#ffc704',
                zIndex: 0,
            }).add());
        }
        if (label && labelValue) {
            let yVal = yAxis.toPixels(labelValue, false);
            if (yVal < 45)
                yVal = 45;
            if (yVal > (width - 42))
                yVal = (width - 42);
            const lbl = chart.renderer
                .text(label.toString(), yVal, xAxis.toPixels(0, false) + 25)
                .css({
                fontSize: labelFontSize !== null && labelFontSize !== void 0 ? labelFontSize : '10px',
                fontWeight: 'bold',
                textAnchor: 'middle',
            })
                .attr({
                align: 'center',
            })
                .add();
            els.push(lbl);
        }
        chartElements.set(chart, els);
    }
    const chartConfig = {
        chart: {
            type: 'columnrange',
            height,
            width,
            margin: [12, 30, 12, 30],
            backgroundColor: 'transparent',
            inverted: true,
            style: {
                fontFamily: 'inherit', // Forces chart to inherit from the parent container
            },
            events: {
                render() {
                    renderSlider(this);
                },
            },
        },
        legend: {
            enabled: false,
        },
        title: undefined,
        xAxis: {
            showFirstLabel: false,
            lineWidth: 0,
            tickWidth: 0,
            min: -1,
            max: 1,
            gridLineWidth: 0,
            labels: { enabled: false },
        },
        yAxis: {
            visible: true,
            showFirstLabel: true,
            showLastLabel: true,
            title: { text: null },
            min,
            max,
            tickPositioner() {
                return [min, max];
            },
            tickWidth: 0,
            gridLineWidth: 0,
            lineWidth: 0,
            labels: { enabled: false },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            series: {
                enableMouseTracking: false,
            },
            columnrange: {
                borderRadius: (COLUMN_THICKNESS$1 / 2),
                clip: false,
                minPointLength: COLUMN_THICKNESS$1,
                pointWidth: COLUMN_THICKNESS$1,
                dataLabels: {
                    enabled: true,
                    format: '{point.name}',
                },
                pointPadding: 0,
                groupPadding: 0,
            },
            scatter: {
                marker: {
                    symbol: 'circle',
                },
                // dataLabels: { enabled: false },
            },
        },
        credits: {
            enabled: false,
        },
        series: seriesData,
    };
    return (React.createElement(Container$8, null,
        React.createElement(BaseChart, { width: width, height: height, options: chartConfig, useBodyFont: false })));
};

Highcharts.SVGRenderer.prototype.symbols.perfsci2080tickmark = (x, y, w, h) => {
    const cx = x + (w / 2);
    const halfThickness = 0.5;
    return [
        'M', cx - halfThickness, y + 1,
        'L', cx - halfThickness, y + h,
        'L', cx + halfThickness, y + h,
        'L', cx + halfThickness, y + 1,
        'Z',
    ];
};
// [
//     'M', x + (w / 2) - 0.5, y,
//     'L', x + (w / 2) - 0.5, y + h,
//     'L', x + (w / 2) + 0.5, y + h,
//     'L', x + (w / 2) + 0.5, y,
//     'Z',
// ];
const Container$7 = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
const minY = 20;
const maxY = 80;
const COLUMN_THICKNESS = 8;
const PerformanceScience2080Chart = ({ seriesData, width, height = 60, minLabel, maxLabel, }) => {
    const ref = useRef(null);
    const [elements, setElements] = useState([]);
    useEffect(() => {
        redraw();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, seriesData]);
    function getLabel(chart, label, yPos, xPos) {
        return chart.renderer
            .text(label, yPos, xPos)
            .css({
            fontSize: '11px',
            color: '#808080',
        })
            .add();
    }
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (!chart)
            return;
        const xAxis = chart.xAxis[0];
        const yAxis = chart.yAxis[0];
        if (elements.length) {
            elements.forEach((el) => {
                el.element.remove();
            });
        }
        const els = [];
        if (minLabel) {
            const label = getLabel(chart, minLabel, yAxis.toPixels(minY, false) - 23, xAxis.toPixels(0, false) + 4);
            els.push(label);
        }
        if (maxLabel) {
            const label = getLabel(chart, maxLabel, yAxis.toPixels(maxY, false) + 10, xAxis.toPixels(0, false) + 4);
            els.push(label);
        }
        const x0 = xAxis.toPixels(0, false);
        [20, 30, 40, 50, 60, 70, 80].forEach((yval) => {
            const el = chart.renderer.circle(yAxis.toPixels(yval, false), x0, 3)
                .attr({
                fill: '#c0c0c0',
                zIndex: 1,
            })
                .add();
            els.push(el);
        });
        setElements(els);
        chart.redraw();
    }
    const mapSeries = (series) => [
        ...series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data && [
                s.data[0] && { low: s.data[0].low, high: s.data[0].high, x: -1, color: '#9AAFC0' },
                s.data[1] && { low: s.data[1].low, high: s.data[1].high, x: 1, color: '#F3B2BA' },
            ] }))),
        ...series.map((s) => {
            const { data } = s, rest = __rest(s, ["data"]);
            return Object.assign(Object.assign({}, rest), { type: 'scatter', data: data && [
                    data[0] && {
                        x: -1,
                        y: data[0].mid,
                        color: '#025',
                        dataLabels: {
                            y: -1,
                            x: 0,
                            color: '#025',
                        },
                    },
                    data[1] && {
                        x: 1,
                        y: data[1].mid,
                        color: '#FF001B',
                        dataLabels: {
                            y: 21,
                            x: 0,
                            color: '#FF001B',
                        },
                    },
                ] });
        }),
    ];
    const chartConfig = {
        chart: {
            type: 'columnrange',
            height,
            width,
            margin: [12, 30, 12, 30],
            backgroundColor: 'transparent',
            inverted: true,
            style: {
                fontFamily: 'inherit', // Forces chart to inherit from the parent container
            },
            events: {
                redraw() {
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    const yAxis = this.yAxis[0];
                    this.series.forEach((series) => {
                        series.points.forEach((point) => {
                            if (point.low === undefined || point.high === undefined)
                                return;
                            // does this columnrange datapoint have a column size less than the thickness
                            // of the column, resulting in a smashed ellipse which we do not want?
                            const columnSize = Math.abs(point.high - point.low);
                            const columnWidthPx = yAxis.toPixels(minY + columnSize, true); // measure in axis pixels here
                            if (columnWidthPx < COLUMN_THICKNESS) {
                                // replot its values to draw a circle centered on its mean value
                                const rVal = yAxis.toValue(yAxis.toPixels(0, false) + (COLUMN_THICKNESS / 2)) - yAxis.toValue(yAxis.toPixels(0, false));
                                // const cY = Math.min(maxY - rVal, Math.max(minY + rVal, (point.high + point.low) / 2));
                                const cY = (point.high + point.low) / 2;
                                point.update({ low: cY - rVal, high: cY + rVal }, true);
                            }
                        });
                    });
                },
            },
        },
        legend: {
            enabled: false,
        },
        title: undefined,
        xAxis: {
            showFirstLabel: false,
            lineWidth: 0,
            tickWidth: 0,
            min: -1,
            max: 1,
            gridLineWidth: 0,
            labels: { enabled: false },
            plotLines: [{ color: '#e0e0e0', width: 2, value: 0, zIndex: 0 }],
        },
        yAxis: {
            visible: true,
            showFirstLabel: true,
            showLastLabel: true,
            title: { text: null },
            min: minY,
            max: maxY,
            lineWidth: 0,
            tickWidth: 0,
            tickLength: 0,
            gridLineWidth: 0,
            labels: { enabled: false },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            series: {
                enableMouseTracking: false,
            },
            columnrange: {
                borderRadius: COLUMN_THICKNESS / 2,
                pointWidth: COLUMN_THICKNESS,
                dataLabels: {
                    enabled: false,
                },
                pointPadding: 0,
                groupPadding: 0,
                clip: false,
            },
            scatter: {
                marker: {
                    symbol: 'perfsci2080tickmark',
                    radius: 6,
                },
                dataLabels: {
                    enabled: true,
                    crop: false,
                    overflow: 'allow',
                    allowOverlap: true,
                    align: 'center',
                    style: {
                        fontSize: '10px',
                        textOutline: 'none',
                    },
                    formatter() { return format(this.y, 0); },
                },
            },
        },
        credits: {
            enabled: false,
        },
        series: mapSeries(seriesData),
    };
    return (React.createElement(Container$7, null,
        React.createElement(BaseChart, { ref: ref, width: width, height: height, options: chartConfig, useBodyFont: false })));
};

var COLUMN_TYPES;
(function (COLUMN_TYPES) {
    COLUMN_TYPES["TEXT"] = "text";
    COLUMN_TYPES["NUMBER"] = "number";
    COLUMN_TYPES["RATE"] = "ratestat";
    COLUMN_TYPES["YESNO"] = "yesno";
    COLUMN_TYPES["PERCENT"] = "percent";
    COLUMN_TYPES["NODE"] = "node";
})(COLUMN_TYPES || (COLUMN_TYPES = {}));
const evaluateIfFunction = (evalObj, ...params) => (typeof evalObj === 'function') && evalObj(...params);
const formatCell = (row, col, isHeader, idx, sortedData, translate = null) => {
    const colType = col.type || COLUMN_TYPES.NUMBER;
    const isRateStat = colType === COLUMN_TYPES.RATE;
    const isNumberOrRateStat = colType === COLUMN_TYPES.NUMBER || isRateStat;
    let formattedValue;
    let cellValue;
    if (isHeader) {
        cellValue = evaluateIfFunction(col.title) || col.title;
        formattedValue = cellValue;
    }
    else {
        // const evaluatedValue = evaluateIfFunction(col.transform, row, idx, sortedData);
        // if (evaluatedValue !== false && evaluatedValue !== null && evaluatedValue !== undefined) {
        //     cellValue = evaluatedValue;
        // } else {
        //     cellValue = get(row, col.id);
        // }
        if (typeof col.transform === 'function') {
            cellValue = evaluateIfFunction(col.transform, row, idx, sortedData);
        }
        else {
            cellValue = get$2(row, col.id);
        }
        formattedValue = cellValue;
        if (isNumberOrRateStat) {
            if (cellValue !== false && cellValue !== true && cellValue !== null && cellValue !== undefined) {
                formattedValue = format(cellValue, isRateStat ? true : col.precision, col.useGroupingFormat);
            }
            else {
                formattedValue = null;
            }
        }
        else if (colType === COLUMN_TYPES.PERCENT) {
            if (isNumber$2(cellValue)) {
                formattedValue = percent(cellValue, col.precision);
            }
            else {
                formattedValue = null;
            }
        }
        else if (colType === COLUMN_TYPES.YESNO) {
            formattedValue = yesNo(cellValue, false, translate);
        }
    }
    return { isNumber: isNumberOrRateStat, formattedValue, cellValue };
};
const sortTableRows = (sortBy, translate = null) => (a, b) => {
    let sortVal = 0;
    if ((sortBy === null || sortBy === void 0 ? void 0 : sortBy.col) && a && b) {
        const aCell = formatCell(a, sortBy.col, undefined, undefined, undefined, translate);
        const bCell = formatCell(b, sortBy.col, undefined, undefined, undefined, translate);
        let compare;
        let aCellValue = aCell.cellValue;
        let bCellValue = bCell.cellValue;
        if (typeof sortBy.col.sortBy === 'function' && !Array.isArray(a) && !Array.isArray(b)) {
            aCellValue = sortBy.col.sortBy(a);
            bCellValue = sortBy.col.sortBy(b);
        }
        // Handle null/undefined values
        const aIsNull = aCellValue === null || aCellValue === undefined;
        const bIsNull = bCellValue === null || bCellValue === undefined;
        if (aIsNull && !bIsNull) {
            return 1; // Push a to the bottom
        }
        if (!aIsNull && bIsNull) {
            return -1; // Push b to the bottom
        }
        if (aIsNull && bIsNull) {
            return 0; // Both are null/undefined, consider them equal
        }
        // Compare non-null/undefined values
        if ((aCell.isNumber && bCell.isNumber) || isNumber$2(aCellValue, bCellValue)) {
            compare = Number(aCellValue || 0) - Number(bCellValue || 0);
        }
        else {
            compare = (aCellValue || '').toString().localeCompare((bCellValue || '').toString());
        }
        sortVal = compare * (sortBy.isDesc ? -1 : 1);
    }
    return sortVal;
};

const AscDescIcon = styled.i.attrs({ className: 'dropdown-toggle' }) `
    &:after {
        ${(props) => (props.asc ? 'transform: rotate(180deg)' : '')};
    }
`;
const HeaderTitle = styled.div `
    display: flex;
    align-items: center;
    .header-title {
        flex-grow: 1;
    }
`;
const StyledButton$1 = styled.button `
    && {
        font-size: 0.5em !important;
        background-color: transparent;
        border: none;
        padding: 0 5px;
        &:focus {
            outline: none;
            border: none;
        }
        transform: rotate(${(props) => props.rotation}deg);
}
`;
const RowGroupCell = styled.div `
    display: flex;
    justify-content: center;
`;
const DataTableCell = (_a) => {
    var { row, col, header = false, sortDirectionDesc, statTooltip: StatTooltip, isRowGroupCell = false, onRowGroupIndexChange, rowIndex = -1, sortedData = [], customClass } = _a, rest = __rest(_a, ["row", "col", "header", "sortDirectionDesc", "statTooltip", "isRowGroupCell", "onRowGroupIndexChange", "rowIndex", "sortedData", "customClass"]);
    const { t: translate } = useTranslation();
    const { cellValue, formattedValue, isNumber } = formatCell(row, col, header, rowIndex, sortedData, translate);
    let cellClass = ' ';
    if (!header && col.cellClass) {
        const value = evaluateIfFunction(col.cellClass, row, cellValue, formattedValue) || col.cellClass;
        cellClass += (typeof value === 'string' || value instanceof String) ? `${value} ` : '';
    }
    else if (header && col.headerClass) {
        const value = evaluateIfFunction(col.headerClass, row, cellValue, formattedValue) || col.headerClass;
        cellClass += (typeof value === 'string' || value instanceof String) ? `${value} ` : '';
    }
    if (isNumber) {
        cellClass += 'number-value ';
    }
    if (col.isSticky) {
        cellClass += 'sticky ';
    }
    if (rest.onClick) {
        cellClass += 'has-click-handler ';
    }
    if (customClass) {
        cellClass += ` ${customClass}`;
    }
    let cellColSpan = 1;
    if (col.colSpan != null) {
        const value = evaluateIfFunction(col.colSpan, row, cellValue, formattedValue);
        if (typeof value === 'number')
            cellColSpan = value;
    }
    if (typeof col.colSpan === 'number') {
        cellColSpan = col.colSpan;
    }
    if (cellColSpan === 0)
        return (React.createElement("td", { style: { display: 'none' } }));
    if (header) {
        let title = formattedValue;
        if (StatTooltip && col.statistic) {
            title = React.createElement(StatTooltip, { statistic: col.statistic, placement: col.tooltipPlacement }, title);
        }
        return (React.createElement("th", Object.assign({ className: cellClass }, rest),
            React.createElement(HeaderTitle, null,
                React.createElement("div", { className: "header-title" }, title),
                sortDirectionDesc !== undefined && React.createElement(AscDescIcon, { asc: sortDirectionDesc === false }))));
    }
    const nullHandledCellValue = formattedValue || '--';
    if (col.isSticky)
        return (React.createElement("th", Object.assign({ colSpan: cellColSpan, className: cellClass }, rest), nullHandledCellValue));
    if (isRowGroupCell) {
        return (React.createElement("td", Object.assign({ className: cellClass }, rest),
            React.createElement(RowGroupCell, null,
                React.createElement(StyledButton$1, { rotation: 90, onClick: onRowGroupIndexChange ? () => onRowGroupIndexChange(-1) : undefined },
                    React.createElement(Icon, { icon: "chevron-down" })),
                React.createElement("div", null, nullHandledCellValue),
                React.createElement(StyledButton$1, { rotation: -90, onClick: onRowGroupIndexChange ? () => onRowGroupIndexChange(1) : undefined },
                    React.createElement(Icon, { icon: "chevron-down" })))));
    }
    if (col.overlay) {
        const overlay = col.overlay(row);
        // console.log('got overlay for column', col, overlay);
        if (overlay) {
            return (React.createElement("td", Object.assign({ colSpan: cellColSpan, className: cellClass }, rest),
                React.createElement(OverlayTrigger, { placement: "top", overlay: React.createElement(Tooltip, null, overlay) },
                    React.createElement("span", null, nullHandledCellValue))));
        }
    }
    return (React.createElement("td", Object.assign({ colSpan: cellColSpan, className: cellClass }, rest), nullHandledCellValue));
};

const ExpandButton = styled.button `
    && {
        font-size: 0.5em !important;
        background-color: transparent;
        border: none;
        padding: 2px;
        &:focus {
            outline: none;
            border: none;
        }
    }
`;
const Chevron = styled.svg `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    height: 18px;
    width: 18px;
    padding: 2px;
    border: 2px solid transparent;
    cursor: pointer;
    transform: rotate(${(props) => (props.$isOpen ? '0' : '270')}deg);

    &:hover {
        border: 2px solid #cccccc;
    }
`;
const DrilldownToggle = ({ isOpen, onClick, ariaLabel, }) => (React.createElement(ExpandButton, { type: "button", onClick: onClick, "aria-expanded": isOpen, "aria-label": ariaLabel },
    React.createElement(Chevron, { "$isOpen": isOpen, viewBox: "0 0 24 15", "aria-hidden": "true" },
        React.createElement("path", { fill: "#2877d9", d: "M2.8299999 0L12 9.1700001L21.17 0L24 2.8299999L12 14.83L0 2.8299999L2.8299999 0Z" }))));

const DataTableRow = ({ sortedData, row, rowIndex, filteredColumns, rowClassName, hasExpandableRows = false, initExpanded = false, isExpanded = false, toggleExpandedRow, }) => {
    var _a;
    const [isDrilldownExpanded, setIsDrilldownExpanded] = useState(initExpanded);
    useEffect(() => {
        setIsDrilldownExpanded(initExpanded);
    }, [row, initExpanded]);
    const [selectedRowGroupIndex, setSelectedRowGroupIndex] = useState(0);
    if (Array.isArray(row) && !row.length)
        return React.createElement(React.Fragment, null);
    const isRowGroup = Array.isArray(row);
    const selectedRow = isRowGroup ? row[selectedRowGroupIndex] : row;
    const { drilldown, drilldownParent, forceIsDrilldownTableRow } = selectedRow;
    const isDrilldownTableRow = forceIsDrilldownTableRow || (drilldown && (Array.isArray(drilldown) ? ((_a = drilldown[0]) === null || _a === void 0 ? void 0 : _a.type) === 'tr' : drilldown.type === 'tr'));
    const expanded = isExpanded !== undefined ? isExpanded : isDrilldownExpanded;
    const handleToggle = () => {
        if (isExpanded === undefined || !toggleExpandedRow) {
            // update our own state
            setIsDrilldownExpanded(!isDrilldownExpanded);
        }
        else {
            // tell the parent to update
            toggleExpandedRow === null || toggleExpandedRow === void 0 ? void 0 : toggleExpandedRow();
        }
    };
    return (React.createElement(React.Fragment, { key: rowIndex },
        React.createElement("tr", { className: rowClassName },
            hasExpandableRows && drilldown && (React.createElement("td", { className: "yru--data-table-drilldown" },
                React.createElement(DrilldownToggle, { isOpen: expanded, onClick: handleToggle }))),
            hasExpandableRows && !drilldown && (React.createElement("td", null, "\u00A0")),
            filteredColumns.map((col, colIdx) => (React.createElement(DataTableCell, { key: col.id, col: col, row: selectedRow, rowIndex: rowIndex, sortedData: sortedData, isRowGroupCell: isRowGroup && colIdx === 0, onRowGroupIndexChange: (n) => {
                    if (!Array.isArray(row))
                        return;
                    let nextIndex = selectedRowGroupIndex + n;
                    if (nextIndex >= row.length) {
                        nextIndex = 0;
                    }
                    else if (nextIndex < 0) {
                        nextIndex = row.length - 1;
                    }
                    setSelectedRowGroupIndex(nextIndex);
                } })))),
        drilldownParent && !isDrilldownTableRow && expanded && (React.createElement("tr", null,
            React.createElement("td", { colSpan: filteredColumns.length + 1 }, drilldownParent))),
        drilldown && isDrilldownTableRow && expanded && drilldown,
        drilldown && !isDrilldownTableRow && expanded && (React.createElement("tr", null,
            React.createElement("td", { colSpan: filteredColumns.length + 1 }, drilldown)))));
};

function DataTableHeaderCell(_a) {
    var _b;
    var { onClick, sortBy, col, sortable = false } = _a, rest = __rest(_a, ["onClick", "sortBy", "col", "sortable"]);
    const onColHeaderClick = (sortable && onClick) ? () => onClick(col) : undefined;
    const sortDirectionDesc = (sortable && ((_b = sortBy.col) === null || _b === void 0 ? void 0 : _b.id) === col.id) ? !!sortBy.isDesc : undefined;
    return (React.createElement(DataTableCell, Object.assign({ header: true, onClick: onColHeaderClick, col: col, sortDirectionDesc: sortDirectionDesc }, rest)));
}

const stickyBoxShadowWidth = '13px';
const tableBorder = `1px solid ${theme.border.bombay}`;
const headerColor = theme.background.astronaut;
const headerBorderColor = pSBC(-0.2, headerColor);
const StyledTable$1 = styled(Table) `
    > :not(caption) > * > * {
        box-shadow: none !important;
    }
    th {
        border: none; //override BASE style
    }

    th.sticky {
        position: sticky;
        left: 0;
    }
    &.is-scrolling th.sticky {
        //box-shadow element for right-side
        &:not(.table-title):after {
            content: '';
            height: 100%;
            position: absolute;
            top: 0;
            right: -${stickyBoxShadowWidth};
            width: ${stickyBoxShadowWidth};
            ${boxShadow(`${stickyBoxShadowWidth} 0px 10px -10px inset rgba(0, 0, 0, .5)`)}
        }
        //fake border to make it seem like table does not move
        &:before {
            content: '';
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            border-left: ${tableBorder};
        }
        &.table-title:before {
            border-left-color: ${headerBorderColor};
        }
        + td, + th {
            padding-left: ${stickyBoxShadowWidth};
        }
    }
    tbody th.sticky {
        font-weight: inherit;
    }
    tbody th.sticky, tfoot th.sticky {
        background-color: white;
    }
    thead > tr > th, tbody > tr > th:not(.sticky), tfoot > tr > th:not(.sticky) {
        background-color: ${theme.background.geyser} !important;
    }

    &&.table {
        background-color: white;
        border: ${tableBorder};
        margin-bottom: 0;
        &.is-scrolling {
            border-left: none;
        }
        tbody, thead, tfoot {
            td, th {
                vertical-align: middle;
                line-height: 1.2;
                &.has-click-handler:hover {
                    cursor: pointer;
                }
            }
        }
        tbody, tfoot {
            td, th {
                border: none;
            }
        }
        thead th {
            border-top: ${tableBorder};
            border-bottom: ${tableBorder} !important;
        }
        tbody tr.is-column-header {
            &,
            > th,
            &:hover,
            &:hover > th {
                background-color: ${theme.background.geyser} !important;
            }
            > th {
                border-top: ${tableBorder};
                border-bottom: ${tableBorder} !important;
            }
        }
        thead th, tbody th {
            &.table-title, &.table-subtitle {
                color: white;
                white-space: nowrap;
                max-width: 1px;
            }
            &.table-title {
                background-color: ${headerColor} !important;
                border-top-color: ${headerBorderColor};
                text-transform: uppercase;
                padding-top: 6px;
                padding-bottom: 6px;
                letter-spacing: .75px;
                &:first-of-type {
                    border-left: 1px solid ${headerBorderColor};
                }
                &:last-of-type {
                    border-right: 1px solid ${headerBorderColor};
                }
            }
            &.table-subtitle {
                font-weight: normal;
                background-color: ${theme.background.endeavour};
            }
        }
        tfoot {
            font-weight: bold;
            border-top: ${tableBorder};
            border-top-width: 2px;
        }
    }
    &&.table-striped {
        tbody tr:nth-of-type(odd) {
            &, th.sticky {
                background-color: ${theme.background.solitude};
            }
            > td {
                background-color: inherit;
        }
    }
    &&.table-hover {
        tbody tr:hover {
            background-color: #ffffcc;
            th.sticky {
                background-color: #ffffcc;
            }
            > td {
                background-color: #ffffcc;
            }
        }
    }
    &&.table-dark {
        tbody th.sticky, tfoot th.sticky {
            background-color: ${theme.background.codGray};
        }
        thead > tr > th, tbody > tr > th:not(.sticky) {
            background-color: #3E444A;
            color: ${theme.fontColors.silver};
        }
        tbody tr.is-column-header {
            &,
            > th,
            &:hover,
            &:hover > th {
                background-color: #3E444A !important;
                color: ${theme.fontColors.silver};
            }
        }
        &.table {
            tfoot {
                color: ${theme.fontColors.silver};
            }
        }
        &.table-striped {
            tbody tr:nth-of-type(odd) {
                &, th.sticky {
                    background-color: #343a40;
                }
            }
        }
        &.table-hover {
            tbody tr:hover {
                background-color: #43494E;
                th.sticky {
                    background-color: #43494E;
                }
            }
        }
    }
    .number-value {
        text-align: center;
    }
    p {
        margin-top: 0.25em;
        margin-bottom: 0.25em;
    }
    // Needed to override global bootstrap class when table is the child of another table
    .unstriped-rows tr > td {
        background-color: white !important;
    }
`;
const defaultProps = {
    size: 'sm',
    responsive: true,
    hover: true,
    striped: true,
};
StyledTable$1.defaultProps = defaultProps;

const DataTable = ({ className, toprows, toprowsClasses, rows, superheader, columns, subheader, footer, title, subtitle, statTooltip, rowClass, rowKey, responsive = true, sortable = false, striped = true, hover = true, hideHeader = false, toggleExpandedRowCallback, pagination, onSortChange, footerRowClass, expandedRows, }) => {
    const { t: translate } = useTranslation();
    const [isTableScrolling, setIsTableScrolling] = useState(false);
    // const {isDarkMode = false} = useContext(ThemeContext);
    // const variant = false ? 'dark' : undefined;
    const variant = undefined;
    // filter columns by role/defined
    const filteredColumns = columns.filter((c) => c);
    // watch for resize so we can add "sticky" effect styling
    const hasStickyColumn = filteredColumns.some((c) => c.isSticky);
    const hasHeaderRow = columns.some((c) => c.title);
    const tableRef = useRef(null);
    useLayoutEffect(() => {
        var _a;
        if (responsive && hasStickyColumn && ((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.parentElement)) {
            const parent = tableRef.current.parentElement;
            const checkAndSetIfTableScrolls = () => setIsTableScrolling(parent.scrollWidth > parent.offsetWidth);
            // https://stackoverflow.com/a/19014495/2486531
            window.addEventListener('resize', checkAndSetIfTableScrolls);
            checkAndSetIfTableScrolls();
            return () => window.removeEventListener('resize', checkAndSetIfTableScrolls);
        }
        return () => { };
    }, [responsive, hasStickyColumn]);
    // configure sorting
    let initSortObj = {};
    if (sortable && typeof sortable === 'object' && sortable.id) {
        const sortCol = columns.find((c) => c.id === sortable.id);
        if (sortCol)
            initSortObj = { col: sortCol, isDesc: !!sortable.isDesc };
    }
    const [sortBy, setSortBy] = useState(initSortObj);
    // const [expandedRows, setExpandedRows] = useState(new Array<number>());
    const [internalExpandedRows, setInternalExpandedRows] = useState([]);
    const isControlled = Array.isArray(expandedRows) && typeof toggleExpandedRowCallback === 'function';
    const currentExpandedRows = isControlled
        ? expandedRows
        : internalExpandedRows;
    const handleToggle = (idx) => {
        if (isControlled) {
            toggleExpandedRowCallback(idx, !currentExpandedRows.includes(idx));
        }
        else {
            setInternalExpandedRows((prev) => (prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]));
        }
    };
    const onHeaderCellClick = (headerCol) => {
        var _a;
        const newSortBy = {
            col: headerCol,
            isDesc: ((_a = sortBy.col) === null || _a === void 0 ? void 0 : _a.id) === headerCol.id ? !sortBy.isDesc : !!sortBy.isDesc,
        };
        setSortBy(newSortBy);
        if (onSortChange) {
            onSortChange(newSortBy);
        }
    };
    const onHeaderCellClickNoOp = () => ({});
    let sortedRows = sortable ? [...rows].sort(sortTableRows(sortBy, translate)) : rows;
    if ((pagination === null || pagination === void 0 ? void 0 : pagination.page) && (pagination === null || pagination === void 0 ? void 0 : pagination.pageSize)) {
        sortedRows = sortedRows.slice((pagination.page - 1) * pagination.pageSize, pagination.page * pagination.pageSize);
    }
    const hasExpandableRows = sortedRows.some((r) => !Array.isArray(r) && r.drilldown) || (footer && footer.some((r) => !Array.isArray(r) && r.drilldown));
    return (React.createElement(StyledTable$1, { size: "sm", variant: variant, responsive: responsive, striped: striped, hover: hover, ref: tableRef, className: `${className} ${isTableScrolling ? 'is-scrolling' : ''}` },
        (hasHeaderRow || title || subtitle) && hideHeader !== true && (React.createElement("thead", null,
            title && (React.createElement("tr", null,
                React.createElement("th", { className: `table-title ${hasStickyColumn ? 'sticky' : ''}` }, title),
                filteredColumns.length > 1 && (React.createElement("th", { className: "table-title", colSpan: hasExpandableRows ? filteredColumns.length : filteredColumns.length - 1 })))),
            subtitle && (React.createElement("tr", null,
                React.createElement("th", { className: `table-subtitle ${hasStickyColumn ? 'sticky' : ''}` }, subtitle),
                filteredColumns.length > 1 && (React.createElement("th", { className: "table-subtitle", colSpan: hasExpandableRows ? filteredColumns.length : filteredColumns.length - 1 })))),
            superheader,
            hasHeaderRow && (React.createElement("tr", null,
                hasExpandableRows && (React.createElement("th", { className: "yru--data-table-drilldown" }, "\u00A0")),
                filteredColumns.map((col) => (React.createElement(DataTableHeaderCell, { key: col.id, col: col, onClick: col.orderable === false ? onHeaderCellClickNoOp : onHeaderCellClick, sortable: !!sortable, sortBy: sortBy, statTooltip: statTooltip }))))),
            subheader)),
        React.createElement("tbody", { className: striped ? 'striped-rows' : 'unstriped-rows' },
            toprows && toprows.map((row, idx) => (React.createElement("tr", { key: rowKey && !Array.isArray(row) ? row[rowKey] : idx },
                hasExpandableRows && (React.createElement("td", { className: "yru--data-table-drilldown" }, "\u00A0")),
                filteredColumns.map((col) => (React.createElement(DataTableCell, { key: col.id, col: col, row: row, customClass: toprowsClasses && (toprowsClasses[idx] || '') })))))),
            sortedRows.map((row, idx, self) => {
                // const toggleExpandedRow = () => {
                //     if (toggleExpandedRowCallback) {
                //         toggleExpandedRowCallback(row, !expandedRows.includes(idx));
                //     }
                //     if (expandedRows.includes(idx)) return setExpandedRows(expandedRows.filter((r) => r !== idx));
                //     return setExpandedRows([...expandedRows, idx]);
                // };
                if (Array.isArray(row))
                    return null;
                const isOpen = currentExpandedRows.includes(idx);
                let rowClassName;
                if (typeof rowClass === 'function')
                    rowClassName = rowClass(row);
                else if (rowClass && !Array.isArray(row))
                    rowClassName = row[rowClass];
                if (row.isHeaderRow) {
                    const headerClassName = ['is-column-header', rowClassName].filter(Boolean).join(' ');
                    return (React.createElement("tr", { key: rowKey ? row[rowKey] : idx, className: headerClassName },
                        hasExpandableRows && (React.createElement("th", { className: "yru--data-table-drilldown" }, "\u00A0")),
                        filteredColumns.map((col) => (React.createElement(DataTableHeaderCell, { key: col.id, col: col, sortable: false, sortBy: {}, statTooltip: statTooltip })))));
                }
                return (React.createElement(DataTableRow, { key: rowKey && !Array.isArray(row) ? row[rowKey] : idx, row: row, rowIndex: idx, sortedData: self, rowClassName: rowClassName, hasExpandableRows: hasExpandableRows, filteredColumns: filteredColumns, initExpanded: (row === null || row === void 0 ? void 0 : row.initExpanded) || false, isExpanded: isOpen, toggleExpandedRow: () => handleToggle(idx) }));
            })),
        footer && (React.createElement("tfoot", null, footer.map((row, idx, self) => {
            let rowClassName;
            if (typeof footerRowClass === 'function')
                rowClassName = footerRowClass(row);
            else if (footerRowClass && !Array.isArray(row))
                rowClassName = row[footerRowClass];
            const footerIdx = sortedRows.length + idx;
            return (React.createElement(DataTableRow, { key: rowKey && !Array.isArray(row) ? row[rowKey] : idx, row: row, rowIndex: idx, sortedData: self, rowClassName: rowClassName, hasExpandableRows: hasExpandableRows, filteredColumns: filteredColumns, initExpanded: (row === null || row === void 0 ? void 0 : row.initExpanded) || false, isExpanded: currentExpandedRows.includes(footerIdx), toggleExpandedRow: () => handleToggle(footerIdx) }));
        })))));
};

const SyledPagination = styled(Pagination) `
    && {
        margin: 5px 0;
    }
    justify-content: ${({ position }) => {
    if (position === 'right')
        return 'flex-end';
    if (position === 'center')
        return 'center';
    return 'flex-start';
}};
`;
const DataTablePagination = ({ totalItems, itemsPerPage, page, onPageChange, size, position = 'right', maxSize = 5, href = '#' }) => {
    const totalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
    const currentPage = Math.min(Math.max(page, 1), totalPages);
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === totalPages;
    let innerPaginationStart;
    let innerPaginationEnd;
    let ellipsesStart = false;
    let ellipsesEnd = false;
    if (totalPages > 2 && totalPages <= maxSize + 2) {
        innerPaginationStart = 2;
        innerPaginationEnd = totalPages - 1;
    }
    else if (totalPages > maxSize + 2) {
        if (currentPage <= 1 + Math.ceil(maxSize / 2)) {
            innerPaginationStart = 2;
            innerPaginationEnd = innerPaginationStart + maxSize - 1;
            ellipsesEnd = true;
        }
        else if (currentPage >= totalPages - Math.ceil(maxSize / 2)) {
            innerPaginationEnd = totalPages - 1;
            innerPaginationStart = innerPaginationEnd - maxSize + 1;
            ellipsesStart = true;
        }
        else {
            ellipsesStart = true;
            ellipsesEnd = true;
            innerPaginationStart = currentPage - Math.floor(maxSize / 2);
            innerPaginationEnd = currentPage + Math.floor(maxSize / 2);
        }
    }
    return (React.createElement(SyledPagination, { size: size, position: position },
        React.createElement(Pagination.First, { disabled: isOnFirstPage, onClick: () => !isOnFirstPage && onPageChange(1), href: href }),
        React.createElement(SyledPagination.Prev, { disabled: isOnFirstPage, onClick: () => !isOnFirstPage && onPageChange(currentPage - 1), href: href }),
        React.createElement(Pagination.Item, { active: isOnFirstPage, onClick: () => !isOnFirstPage && onPageChange(1), href: href }, "1"),
        ellipsesStart && React.createElement(Pagination.Ellipsis, { onClick: () => onPageChange(currentPage - maxSize + 1), href: href }),
        !!innerPaginationEnd && new Array(innerPaginationEnd - innerPaginationStart + 1).fill(undefined).map((_, idx) => {
            const pageNum = innerPaginationStart + idx;
            const active = pageNum === currentPage;
            return (React.createElement(Pagination.Item, { key: pageNum, active: active, onClick: () => !active && onPageChange(pageNum), href: href }, pageNum));
        }),
        ellipsesEnd && React.createElement(Pagination.Ellipsis, { onClick: () => onPageChange(currentPage + maxSize - 1), href: href }),
        totalPages > 1 && (React.createElement(Pagination.Item, { active: isOnLastPage, onClick: () => !isOnLastPage && onPageChange(totalPages), href: href }, totalPages)),
        React.createElement(Pagination.Next, { disabled: isOnLastPage, onClick: () => !isOnLastPage && onPageChange(currentPage + 1), href: href }),
        React.createElement(Pagination.Last, { disabled: isOnLastPage, onClick: () => !isOnLastPage && onPageChange(totalPages), href: href })));
};

/* eslint-disable react/no-this-in-sfc */
const StyledPercentileStatRow = styled.div `
    display: flex;
    justify-content: flex-start;
    padding: 0 ${(props) => (props.size !== 'xs' ? '20px' : '0')};
    label {
        font-weight: bold;
        font-size: 1.1em;
        display: flex;
        align-items: center;
        margin-bottom: 0;
        width: 150px;
        justify-content: flex-start;
    }
`;
const StyledPercentileStat = styled.div `
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: start;
    margin: 0 10px;
`;
const PercentileChart = ({ teamid, percentilesToDisplay, statAllTeams, leagueid, displayTeams, teamLogos, hideMedianDisplay, hideLabels, labelLeft, labelMiddle, labelRight, simplifyTooltip, hideTooltip, singleDataPoint, size, showValueOnPoint, svgWidth, labelWidth, statlineWidth, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const evaluateIfFunction = (evalObj, ...params) => (typeof evalObj === 'function') && evalObj(...params);
    let iSvgWidth = svgWidth !== null && svgWidth !== void 0 ? svgWidth : 900;
    let iLabelWidth = labelWidth !== null && labelWidth !== void 0 ? labelWidth : 145;
    let iStatlineWidth = statlineWidth !== null && statlineWidth !== void 0 ? statlineWidth : 882;
    if (size) {
        switch (size) {
            case 'l':
                iSvgWidth = 750;
                iLabelWidth = 150;
                iStatlineWidth = 735;
                break;
            case 'm':
                iSvgWidth = 500;
                iLabelWidth = 138;
                iStatlineWidth = 507;
                break;
            case 's':
                iSvgWidth = 250;
                iLabelWidth = 136;
                iStatlineWidth = 258;
                break;
            case 'xs':
                iSvgWidth = 200;
                iLabelWidth = 90;
                iStatlineWidth = 200;
                break;
            case 'xl':
            default:
                iSvgWidth = 900;
                iLabelWidth = 145;
                iStatlineWidth = 882;
                break;
        }
    }
    const formatValue = (value, p) => {
        const isRateStat = p.type === COLUMN_TYPES.RATE;
        let formattedValue = '';
        if (p.type === COLUMN_TYPES.PERCENT) {
            const formattedPercent = Number(value * 100).toLocaleString(undefined, {
                minimumFractionDigits: p.precision || 0,
                maximumFractionDigits: p.precision || 0,
            });
            formattedValue = `${Number(formattedPercent)}%`;
        }
        else {
            const precision = isRateStat ? 3 : p.precision || 1;
            formattedValue = Number(value).toLocaleString(undefined, {
                minimumFractionDigits: precision,
                maximumFractionDigits: precision,
            });
            if (isRateStat) {
                formattedValue = formattedValue.replace('0.', '.');
            }
        }
        return formattedValue;
    };
    const drawPercentileLocation = (p) => {
        const sortedTeamRankings = statAllTeams ? statAllTeams
            .filter((t) => t.teamid !== null)
            .map((stat) => {
            const value = evaluateIfFunction(p.transform, stat);
            return {
                id: stat.teamid,
                name: `${(stat.city)} ${(stat.name)}`,
                value,
                statistic: p.statistic,
                title: p.title.toString(),
                displayPercentOnLine: null,
                fillColorHex: '',
                textColorHex: '',
            };
        })
            .sort((a, b) => b.value - a.value) : [];
        if (p.qualityType === 1) {
            sortedTeamRankings.reverse();
        }
        const teamIds = [];
        const teamsFiltered = sortedTeamRankings
            .filter((element) => {
            const isDuplicate = teamIds.includes(element.id);
            if (!isDuplicate) {
                teamIds.push(element.id);
                return true;
            }
            return false;
        });
        let activeDatapoint = teamsFiltered.find((s) => s.id === teamid);
        if (!activeDatapoint && singleDataPoint) {
            activeDatapoint = {
                id: 1,
                name: 'SingleStat',
                value: singleDataPoint.value,
                statistic: singleDataPoint.name,
                title: singleDataPoint.name,
                displayPercentOnLine: singleDataPoint.displayPercentOnLine,
                fillColorHex: singleDataPoint.fillColorHex,
                textColorHex: singleDataPoint.textColorHex,
            };
        }
        else if (!activeDatapoint) {
            return React.createElement(React.Fragment, null, translate('components.charts.team-or-data-required')); // Cannot continue without a team OR datapoint
        }
        const rankingPosition = teamsFiltered.indexOf(activeDatapoint);
        const statsMedians = statAllTeams ? statAllTeams
            .filter((t) => t.teamid === null && t.leagueid === leagueid)
            .map((stat) => {
            let value = evaluateIfFunction(p.transform, stat);
            if (p.needsAverage === true) {
                value = ratio(value, teamsFiltered.length);
            }
            return { teamid: stat.teamid,
                name: `${(stat.city)} ${(stat.name)}`,
                value,
                statistic: p.statistic,
                title: p.id === 'rperg' ? translate('components.charts.abbr-rg') : p.title,
                stddev: stat[p.stddev] };
        }) : [];
        const median = statsMedians.length === 0
            ? ratio(sortedTeamRankings.reduce((a, b) => a + b.value, 0), teamsFiltered.length) : statsMedians[0].value;
        const ranking = ratio(rankingPosition, teamsFiltered.length);
        const formattedRanking = ranking != null ? percent(ranking) : '';
        const formattedMedian = formatValue(median, p);
        const formattedValue = formatValue(activeDatapoint.value, p);
        // eslint-disable-next-line no-nested-ternary, max-len
        const sliderPosition = singleDataPoint && activeDatapoint && activeDatapoint.displayPercentOnLine ? ((iSvgWidth * (activeDatapoint.displayPercentOnLine * 0.01)) - 10)
            : ranking != null ? Math.floor(iSvgWidth * ranking) : 0;
        const colorShading = activeDatapoint && singleDataPoint && activeDatapoint.fillColorHex ? activeDatapoint.fillColorHex : 'rgba(235, 235, 235, 1)';
        const fontColor = '#333333';
        const circleBorderColor = '#9b9b9b';
        const medianPos = displayTeams ? '40' : '20';
        // eslint-disable-next-line max-len, no-nested-ternary
        const medianFont = activeDatapoint && singleDataPoint && activeDatapoint.textColorHex ? activeDatapoint.textColorHex : displayTeams ? fontColor : '#fff';
        const medianColor = displayTeams ? '#fff' : '#9b9b9b';
        const teams = displayTeams
            ? teamsFiltered
                .map((team, i) => {
                var _a;
                const rank = ratio(i, teamsFiltered.length);
                const teamSliderPosition = rank != null ? Math.floor(iSvgWidth * rank) : 0;
                const formattedTeamValue = formatValue(team.value, p);
                const logo = (_a = teamLogos === null || teamLogos === void 0 ? void 0 : teamLogos.find((t) => t.teamid === team.id)) === null || _a === void 0 ? void 0 : _a.logoSvg;
                return { team, rank, teamSliderPosition, formattedTeamValue, logo };
            })
            : teamsFiltered;
        const teamLogo = teamLogos === null || teamLogos === void 0 ? void 0 : teamLogos.find((t) => t.teamid === teamid).logoSvg;
        const chartData = {
            activeDatapoint,
            formattedRanking,
            formattedValue,
            formattedMedian,
            median,
            medianPos,
            medianFont,
            medianColor,
            sliderPosition,
            rankingPosition,
            colorShading,
            fontColor,
            circleBorderColor,
            teamLogo,
            teams,
        };
        return (React.createElement(React.Fragment, null,
            !hideMedianDisplay && (React.createElement("g", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-median-group`, transform: `translate(416, ${(chartData.medianPos)})` },
                React.createElement("rect", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-median-rect`, width: "40", height: "20", fill: `${chartData.medianColor}`, stroke: `${chartData.medianColor}`, rx: "5", ry: "5" },
                    React.createElement("title", null, `${(chartData.activeDatapoint.title)}: ${(chartData.formattedMedian)}`)),
                React.createElement("text", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-median-text`, x: "20", y: "10", textAnchor: "middle", fill: `${chartData.medianFont}`, alignmentBaseline: "central", fontSize: ".6rem", fontWeight: "bold" },
                    chartData.formattedMedian,
                    React.createElement("title", null, `${(chartData.activeDatapoint.title)}: ${(chartData.formattedMedian)}`)))),
            React.createElement("g", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-value-group`, transform: `translate(${(sliderPosition)}, 30)` },
                React.createElement("circle", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-value-circle`, r: "14", fill: `${(chartData.colorShading)}`, stroke: `${chartData.circleBorderColor}`, strokeWidth: "2" }, !hideTooltip && (React.createElement("title", null,
                    !simplifyTooltip && `${(chartData.activeDatapoint.name)}`,
                    '\n',
                    !simplifyTooltip && `${(chartData.activeDatapoint.title)}: ${(chartData.formattedValue)}`,
                    '\n',
                    !simplifyTooltip && `${translate('components.charts.rank')}: ${(chartData.rankingPosition + 1)}`,
                    simplifyTooltip && chartData.formattedValue))),
                React.createElement("image", { x: "-10", y: "-10", width: "20", height: "20", xlinkHref: chartData.teamLogo }, !hideTooltip && (React.createElement("title", null,
                    !simplifyTooltip && `${(chartData.activeDatapoint.name)}`,
                    '\n',
                    !simplifyTooltip && `${(chartData.activeDatapoint.title)}: ${(chartData.formattedValue)}`,
                    '\n',
                    !simplifyTooltip && `${translate('components.charts.rank')}: ${(chartData.rankingPosition + 1)}`,
                    simplifyTooltip && chartData.formattedValue))),
                showValueOnPoint && (React.createElement("text", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-datapoint-text`, x: "0", y: "0", textAnchor: "middle", fill: `${chartData.medianFont}`, alignmentBaseline: "central", fontSize: ".6rem", fontWeight: "bold" }, chartData.activeDatapoint.value))),
            React.createElement("g", null, displayTeams && (chartData.teams.map((t, index) => (React.createElement(React.Fragment, null, t.team.id !== teamid && (React.createElement(React.Fragment, null,
                React.createElement("image", { x: `${(t.teamSliderPosition - 10)}`, y: "20", width: "20", height: "20", xlinkHref: t.logo }, !hideTooltip && (React.createElement("title", null,
                    !simplifyTooltip && `${(t.team.name)}`,
                    '\n',
                    !simplifyTooltip && `${(t.team.title)}: ${(t.formattedTeamValue)}`,
                    '\n',
                    !simplifyTooltip && `${translate('components.charts.rank')}: ${(index + 1)}`,
                    simplifyTooltip && t.formattedTeamValue))))))))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref },
            percentilesToDisplay.map((p, index) => (React.createElement("div", { key: p.id }, p.isActive && (React.createElement(StyledPercentileStatRow, { id: `${(p.id)}-${(index)}-row`, key: p.id, size: size },
                React.createElement("label", { id: `${(p.id)}-${(index)}-label`, style: { width: `${iLabelWidth}px` } }, evaluateIfFunction(p.title) || p.title),
                React.createElement(StyledPercentileStat, { id: `${(p.id)}-${(index)}-stat` },
                    React.createElement("svg", { height: "60", style: { overflow: 'visible', width: iSvgWidth }, id: `${(p.id)}-${(index)}-svg` },
                        React.createElement("g", { id: `${(p.id)}-${(index)}-svg-group` },
                            React.createElement("line", { x1: "0", x2: "96.6%", y1: "30", y2: "30", stroke: "#9b9b9b", strokeWidth: "3px", id: `${(p.id)}-${(index)}-line` }),
                            React.createElement("circle", { id: `${(p.id)}-${(index)}-circle1`, cx: "0%", cy: "30", r: "2", fill: "#9b9b9b", stroke: "#9b9b9b", strokeWidth: "3px" }),
                            React.createElement("circle", { id: `${(p.id)}-${(index)}-circle2`, cx: "96.6%", cy: "30", r: "2", fill: "#9b9b9b", stroke: "#9b9b9b", strokeWidth: "3px" }),
                            drawPercentileLocation(p))))))))),
            hideLabels !== true && (React.createElement(StyledPercentileStatRow, { size: size },
                React.createElement("label", { style: { width: `${iLabelWidth}px` } }),
                React.createElement(StyledPercentileStat, null,
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', width: `${iStatlineWidth}px` } },
                        React.createElement("label", { style: { display: 'flex', justifyContent: 'flex-start' } }, labelLeft),
                        React.createElement("label", { style: { display: 'flex', justifyContent: 'center' } }, labelMiddle),
                        React.createElement("label", { style: { display: 'flex', justifyContent: 'flex-end' } }, labelRight))))))));
};

const EV_LA_CHART_BACKGROUND_TYPE = {
    hitFx: 1,
    actual: 2,
    diff: 3,
};
const backgroundMap = {
    [EV_LA_CHART_BACKGROUND_TYPE.hitFx]: evLaHitFx,
    [EV_LA_CHART_BACKGROUND_TYPE.actual]: evLaActual,
    [EV_LA_CHART_BACKGROUND_TYPE.diff]: evLaDifference,
};
const StyledChartWrapper = styled.div `
    background-image: url(${(props) => backgroundMap[props.$backgroundType]});
    background-repeat: no-repeat;
    background-size: cover;
    height: ${(props) => props.$height}px !important;
    width: ${(props) => props.$width}px !important;
    overflow: hidden;
`;
const sizeMap = {
    md: { height: 326, width: 280, center: [1, 190], multiplier: 2.79 },
    lg: { height: 407, width: 350, center: [1, 238], multiplier: 2.45 },
};
const EvLaChart$1 = forwardRef(({ size = 'lg', seriesData, showGrid, videoPlayerModal: VideoPlayerModal, pitchVideoFn, multiVideoFn, modalContainer, backgroundType = EV_LA_CHART_BACKGROUND_TYPE.hitFx, tooltipFormatter }, outerRef) => {
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const fetchMultiVideo = (pitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const pitchIds = pitches
                .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
                .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
            const playlist = yield multiVideoFn(pitchIds);
            setVideoPlaylist(playlist);
        }
        catch (_b) {
            closePitchVideo();
        }
    });
    const sizeObj = sizeMap[size];
    const chartConfig = {
        title: undefined,
        chart: {
            type: 'line',
            polar: true,
            width: sizeObj.width * sizeObj.multiplier,
            height: sizeObj.height * sizeObj.multiplier,
            backgroundColor: undefined,
            margin: [0, 0, 0, 0],
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, x, y } = point;
                            return enabled !== false && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length)
                            fetchMultiVideo(points);
                    }
                    return false; // Don't zoom
                },
            },
            zoomType: 'xy',
        },
        pane: {
            startAngle: 0,
            endAngle: 180,
            center: sizeObj.center,
        },
        xAxis: {
            min: 0,
            max: 360,
            opposite: true,
            visible: showGrid,
        },
        yAxis: {
            min: 60,
            max: 130,
            visible: showGrid,
        },
        plotOptions: {
            series: {
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (pitchVideoFn)
                                    return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (!this.point.tooltip && !this.point.name)
                    return false;
                return `<b>${this.series.name}</b><br/>${this.point.tooltip || this.point.name}`;
            },
        },
        series: seriesData.map((sd) => (Object.assign(Object.assign({}, sd), { type: 'scatter', data: sd.data.map((_a) => {
                var { launchangle, exitvelo } = _a, rest = __rest(_a, ["launchangle", "exitvelo"]);
                return (Object.assign({ x: 180 - (2 * launchangle), y: exitvelo }, rest));
            }) }))),
    };
    return (React.createElement(React.Fragment, null,
        !!(pitchVideoFn || multiVideoFn) && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(StyledChartWrapper, { "$height": sizeObj.height, "$width": sizeObj.width, "$backgroundType": backgroundType },
            React.createElement(BaseChart, { ref: ref, options: chartConfig, className: "evLaChart" }))));
});

/* eslint-disable react/no-this-in-sfc */
const Container$6 = styled.div `
    ${BaseChartContainer} {
        text-align: center;
    }
`;
const NtilesChart = ({ width = 500, height = 400, title = '', seriesData, statTooltip: StatTooltip, thresholdOnlyTooltip = false, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    if (Array.isArray(seriesData) && !(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$6, null,
            React.createElement("em", null, translate('components.charts.no-data')));
    }
    const chartSections = [
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            gridLineWidth: 1,
            alternateGridColor: '#E6F5FF',
            labels: {
                formatter() {
                    var _a, _b;
                    return (_b = (_a = seriesData[0]) === null || _a === void 0 ? void 0 : _a.data[this.pos]) === null || _b === void 0 ? void 0 : _b.lowText;
                },
                align: 'center',
                style: {
                    textTransform: 'uppercase',
                    color: '#333',
                },
                x: -15,
            },
            title: {
                text: null,
            },
            lineColor: '#cdcdcd',
        },
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            gridLineWidth: 1,
            alternateGridColor: '#E6F5FF',
            linkedTo: 0,
            lineWidth: 0,
            labels: {
                formatter() {
                    return '';
                },
                y: 3,
                x: -15,
                align: 'center',
                style: {
                    color: '#333',
                    fontSize: '10px',
                    fontWeight: 'bold',
                },
            },
        },
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            gridLineWidth: 1,
            alternateGridColor: '#E6F5FF',
            linkedTo: 0,
            opposite: true,
            lineColor: '#cdcdcd',
            labels: {
                formatter() {
                    var _a, _b;
                    return (_b = (_a = seriesData[0]) === null || _a === void 0 ? void 0 : _a.data[this.pos]) === null || _b === void 0 ? void 0 : _b.highText;
                },
                align: 'center',
                style: {
                    textTransform: 'uppercase',
                    color: '#333',
                },
                x: 15,
            },
        },
    ];
    const chartConfig = {
        chart: {
            type: 'scatter',
            inverted: true,
            backgroundColor: 'none',
            spacing: [0, 20, 5, 0],
            height,
        },
        title: {
            text: title,
        },
        subtitle: {
            text: undefined,
        },
        legend: {
            enabled: false,
        },
        xAxis: chartSections,
        yAxis: {
            opposite: true,
            title: {
                text: undefined,
                style: {
                    color: '#333',
                    fontSize: '14px',
                },
            },
            labels: {
                format: '{value}th',
                style: {
                    color: '#333',
                    fontSize: '8px',
                },
                rotation: 0,
                autoRotation: undefined,
            },
            min: 0,
            max: 100,
            startOnTick: true,
            endOnTick: true,
            minTickInterval: 25,
            minRange: 100,
            tickInterval: 25,
            tickPositions: [0, 25, 50, 75, 100],
            minColor: '#cdcdcd',
            maxColor: '#cdcdcd',
            gridLineColor: '#cdcdcd',
            showLastLabel: false,
            showFirstLabel: false,
        },
        tooltip: {
            formatter() {
                return `${this.point.ntileData.statname}
                    ${!thresholdOnlyTooltip ? `<br /><b>${ordinal(this.point.ntileData.percentile, translate)}: ${this.point.value}${this.point.units}</b>` : ''}
                    <br />${translate('format.number', { count: 25, ordinal: true })}: ${this.point.ntileData.p25}${this.point.units}
                    <br />${translate('format.number', { count: 50, ordinal: true })}: ${this.point.ntileData.p50}${this.point.units}
                    <br />${translate('format.number', { count: 75, ordinal: true })}: ${this.point.ntileData.p75}${this.point.units}`;
            },
        },
        plotOptions: {
            scatter: {
                zones: [{
                        value: 25,
                        color: 'rgb(0, 122, 213)',
                    }, {
                        value: 75,
                        color: 'rgb(240, 240, 240)',
                    }, {
                        color: 'rgb(247, 46, 46)',
                    }],
                marker: {
                    lineWidth: 1,
                    lineColor: '#222',
                    radius: 6,
                },
            },
        },
        series: seriesData.map((ser) => (Object.assign(Object.assign({}, ser), { data: ser.data.map((pt) => (Object.assign(Object.assign({}, pt), { marker: {
                    symbol: 'circle',
                }, dataLabels: {
                    enabled: false,
                } }))) }))),
    };
    return (React.createElement(Container$6, null,
        React.createElement("div", { className: "d-flex justify-content-center" },
            React.createElement("div", { style: { marginBottom: 3, paddingTop: 68, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingRight: 16 } }, seriesData[0].data.map((sd) => (React.createElement("b", { key: sd.name, style: { height: `calc(100% / ${seriesData[0].data.length})`, display: 'flex', alignItems: 'center' } }, StatTooltip && (React.createElement(StatTooltip, { statistic: sd.statistic },
                React.createElement("div", null,
                    sd.name,
                    React.createElement("br", null),
                    React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: sd.value != null ? `${sd.value}${sd.units ? `${sd.units}` : ''}` : '--',
                        } })))))))),
            React.createElement("div", null,
                React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false, className: "ntilesChart" })),
            seriesData[0].data.some((sd) => { var _a, _b, _c; return ((_a = sd.ntileData) === null || _a === void 0 ? void 0 : _a.extraData) && ((_c = (_b = sd.ntileData) === null || _b === void 0 ? void 0 : _b.extraData) === null || _c === void 0 ? void 0 : _c.length) > 0; }) && (React.createElement("div", { style: { marginBottom: 3, paddingTop: 68, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingRight: 16 } }, seriesData[0].data.map((sd) => {
                var _a;
                if (((_a = sd === null || sd === void 0 ? void 0 : sd.ntileData) === null || _a === void 0 ? void 0 : _a.extraData) != null && sd.ntileData.extraData.length > 0) {
                    return (React.createElement("span", { key: `${sd.name}extra`, style: { height: `calc(100% / ${seriesData[0].data.length})`, display: 'flex', alignItems: 'center' } },
                        React.createElement("div", null, sd.ntileData.extraData.map((ed) => (React.createElement("span", { key: `${sd.name}e${ed.name}` },
                            React.createElement("b", null,
                                ed.name,
                                ": "),
                            ed.value,
                            React.createElement("br", null)))))));
                }
                return '';
            }))))));
};

/* eslint-disable react/no-this-in-sfc */
const SprintExertionsChart = ({ sprints, height = 300 }) => {
    const chartConfig = {
        chart: {
            type: 'column',
            marginRight: 30,
            height,
        },
        title: {
            text: undefined,
        },
        yAxis: {
            title: {
                text: 'MPH',
            },
            lineWidth: 1,
            gridLineColor: 'transparent',
            lineColor: styles.theme.fontColors.silverChalice,
        },
        xAxis: {
            type: 'datetime',
            startOnTick: true,
            labels: {
                formatter() {
                    if (this.value) {
                        return date(this.value, 'HH:mm');
                    }
                    return '';
                },
            },
            endOnTick: true,
            tickPosition: 'inside',
            tickColor: styles.theme.fontColors.silverChalice,
            lineColor: styles.theme.fontColors.silverChalice,
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointWidth: 1,
                maxPointWidth: 1,
                color: styles.theme.border.alto,
                dataLabels: {
                    overflow: 'allow',
                    allowOverlap: true,
                    crop: false,
                    enabled: true,
                    useHTML: true,
                    formatter() {
                        return '<div style="height: 6px; width: 6px; background-color: #254C75; border-radius: 9999px;" />';
                    },
                    y: 10,
                },
            },
        },
        legend: {
            enabled: false,
        },
        series: [{
                type: 'column',
                data: sprints.map((s) => ({
                    x: new Date(s.datetime).getTime(),
                    y: s.mph,
                })),
            }],
    };
    return React.createElement(BaseChart, { options: chartConfig });
};

/* eslint-disable react/no-this-in-sfc */
const TrunkRotationPieChart = ({ rotation, flexion, tilt, height = 350 }) => {
    const { t: translate } = useTranslation();
    const chartConfig = {
        chart: {
            type: 'pie',
            height,
        },
        title: {
            text: undefined,
        },
        plotOptions: {
            pie: {
                borderWidth: 0,
                enableMouseTracking: false,
                innerSize: '60%',
                dataLabels: {
                    formatter() {
                        if (this.y) {
                            return percent(this.y, 0);
                        }
                        return '-';
                    },
                    distance: 15,
                    style: {
                        fontSize: '16px',
                        fontFamily: "'Amble', sans-serif",
                    },
                    padding: 0,
                },
                showInLegend: true,
                point: {
                    events: {
                        legendItemClick() {
                            return false;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: true,
            symbolWidth: 12,
            symbolHeight: 12,
            symbolRadius: 0,
            useHTML: true,
            itemStyle: {
                fontSize: '12px',
                lineHeight: '14px',
                fontWeight: '700',
                fontFamily: "'Amble', sans-serif",
            },
        },
        colors: ['#0078da', '#204b76', '#cfcfcf'],
        series: [{
                type: 'pie',
                data: [
                    { name: translate('components.charts.flexion'), y: flexion },
                    { name: translate('components.charts.rotation'), y: rotation },
                    { name: translate('components.charts.tilt'), y: tilt },
                ],
            }],
        tooltip: {
            enabled: false,
        },
    };
    return React.createElement(BaseChart, { options: chartConfig });
};

const CHUNK_DIFF_MINUTES$1 = 8;
const getChunks$1 = (swings) => {
    if (!swings.length) {
        return [];
    }
    let lastDateTime = new Date(swings[0].datetime);
    let chunkIndex = 0;
    const chunks = [[swings[0]]];
    for (let i = 1; i < swings.length; i++) {
        const swing = swings[i];
        const swingDateTime = new Date(swing.datetime);
        const minutesDiff = (swingDateTime.getTime() - lastDateTime.getTime()) / (1000 * 60);
        if (minutesDiff > CHUNK_DIFF_MINUTES$1) {
            chunkIndex += 1;
            chunks[chunkIndex] = [swing];
        }
        else {
            chunks[chunkIndex].push(swing);
        }
        lastDateTime = swingDateTime;
    }
    return chunks;
};
const getChartConfig$1 = (translate, chunk, isFirst, maxMagnitude, height) => {
    var _a, _b;
    return ({
        chart: {
            type: 'column',
            marginRight: 15,
            height,
        },
        title: {
            text: undefined,
        },
        yAxis: {
            title: {
                text: translate('components.charts.rotation-speed-degs'),
            },
            lineWidth: 1,
            gridLineColor: 'transparent',
            lineColor: styles.theme.fontColors.silverChalice,
            visible: isFirst,
            min: 0,
            max: maxMagnitude,
            offset: isFirst ? 15 : undefined,
        },
        xAxis: {
            type: 'datetime',
            labels: {
                enabled: false,
            },
            lineColor: styles.theme.fontColors.silverChalice,
            tickWidth: 0,
            title: {
                useHTML: true,
                text: `${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a < b ? a : b)), true, (_a = chunk[0]) === null || _a === void 0 ? void 0 : _a.timezonename)}–
            <br/>${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a > b ? a : b)), true, (_b = chunk[0]) === null || _b === void 0 ? void 0 : _b.timezonename)}`,
                style: {
                    whiteSpace: 'nowrap',
                    fontSize: '11px',
                },
            },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointWidth: 1,
                color: styles.theme.border.alto,
                dataLabels: {
                    overflow: 'allow',
                    allowOverlap: true,
                    crop: false,
                    enabled: true,
                    useHTML: true,
                    formatter() {
                        return '<div style="height: 6px; width: 6px; background-color: #254C75; border-radius: 9999px;" />';
                    },
                    y: 10,
                },
            },
        },
        legend: {
            enabled: false,
        },
        series: [{
                type: 'column',
                data: chunk.map((s) => ({
                    x: new Date(s.datetime).getTime(),
                    y: s.magnitude,
                })),
            }],
    });
};
const getTimeGaps$1 = (chunks) => {
    const timeGaps = chunks.map((chunk) => new Date(chunk[chunk.length - 1].datetime).getTime() - new Date(chunk[0].datetime).getTime());
    const timeGapSum = timeGaps.reduce((sum, v) => (sum + v), 0);
    const newTimeGaps = timeGaps.map((g, i) => Math.max(g, timeGapSum * (i ? 0.15 : 0.3)));
    const newTimeGapSum = newTimeGaps.reduce((sum, v) => (sum + v), 0);
    return { timeGaps: newTimeGaps, timeGapSum: newTimeGapSum };
};
const SwingTimelineChart = ({ swings, height = 350 }) => {
    const { t: translate } = useTranslation();
    const chunks = getChunks$1(swings);
    const maxMagnitude = Math.max(...swings.map((s) => s.magnitude));
    const { timeGaps, timeGapSum } = getTimeGaps$1(chunks);
    return (React.createElement("div", { className: "d-flex" }, chunks.map((chunk, index) => (React.createElement("div", { style: { width: `calc(100% * ${timeGaps[index] / timeGapSum}` }, key: chunk[0].swingid },
        React.createElement(BaseChart, { options: getChartConfig$1(translate, chunk, index === 0, maxMagnitude, height) }))))));
};

const THROW_TYPES = {
    game: 1,
    bullpen: 2,
    warmup: 3,
    other: 4,
};
const CHUNK_DIFF_MINUTES = 8;
const getPregameChunks = (throws) => {
    if (!throws.length) {
        return [];
    }
    let lastDateTime = new Date(throws[0].datetime);
    let chunkIndex = 0;
    const chunks = [[throws[0]]];
    for (let i = 1; i < throws.length; i++) {
        const t = throws[i];
        const throwDateTime = new Date(t.datetime);
        const minutesDiff = (throwDateTime.getTime() - lastDateTime.getTime()) / (1000 * 60);
        if (minutesDiff > CHUNK_DIFF_MINUTES) {
            chunkIndex += 1;
            chunks[chunkIndex] = [t];
        }
        else {
            chunks[chunkIndex].push(t);
        }
        lastDateTime = throwDateTime;
    }
    return chunks;
};
const getGameChunks = (throws) => {
    var _a;
    if (!throws.length)
        return [];
    let currentInning = (_a = throws[0].inning) !== null && _a !== void 0 ? _a : null;
    let chunkIndex = 0;
    const chunks = [[throws[0]]];
    for (let i = 0; i < throws.length; i++) {
        const t = throws[i];
        if (t.inning !== currentInning) {
            chunkIndex += 1;
            chunks[chunkIndex] = [t];
        }
        else {
            chunks[chunkIndex].push(t);
        }
        currentInning = t.inning;
    }
    return chunks;
};
const getChunks = (throws) => {
    if (!throws.length) {
        return [];
    }
    const firstWarmupIndex = throws.findIndex((t) => t.throwtype === THROW_TYPES.game || t.throwtype === THROW_TYPES.warmup);
    if (firstWarmupIndex >= 0) {
        const pregamePitches = throws.slice(0, firstWarmupIndex);
        const gamePitches = throws.slice(firstWarmupIndex, throws.length);
        return [...getPregameChunks(pregamePitches), ...getGameChunks(gamePitches)];
    }
    return getPregameChunks(throws);
};
const getTitle = (inning) => (inning ? `Inn ${inning}` : '&nbsp;');
const getChartConfig = (translate, chunk, isFirst, height) => {
    var _a, _b, _c, _d;
    return ({
        chart: {
            type: 'column',
            marginRight: 15,
            height,
        },
        title: {
            useHTML: !((_a = chunk.find((t) => t.inning)) === null || _a === void 0 ? void 0 : _a.inning),
            text: getTitle((_b = chunk.find((t) => t.inning)) === null || _b === void 0 ? void 0 : _b.inning),
            style: {
                fontFamily: '"Amble", sans-serif',
                fontSize: '14px',
                fontWeight: '700',
                whiteSpace: 'nowrap',
            },
        },
        yAxis: {
            title: {
                text: translate('components.charts.throw-intensity'),
            },
            lineWidth: 1,
            gridLineColor: 'transparent',
            lineColor: styles.theme.fontColors.silverChalice,
            visible: isFirst,
            min: 0,
            max: 100,
            offset: isFirst ? 15 : undefined,
        },
        xAxis: {
            type: 'datetime',
            labels: {
                enabled: false,
            },
            lineColor: styles.theme.fontColors.silverChalice,
            tickWidth: 0,
            title: {
                useHTML: true,
                text: `${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a < b ? a : b)), true, (_c = chunk[0]) === null || _c === void 0 ? void 0 : _c.timezonename)}–
            <br />${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a > b ? a : b)), true, (_d = chunk[0]) === null || _d === void 0 ? void 0 : _d.timezonename)}`,
                style: {
                    whiteSpace: 'nowrap',
                    fontSize: '11px',
                },
            },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointWidth: 1,
                maxPointWidth: 1,
                color: styles.theme.border.alto,
                dataLabels: {
                    overflow: 'allow',
                    allowOverlap: true,
                    crop: false,
                    enabled: true,
                    useHTML: true,
                    formatter() {
                        return `<div 
                            style="
                                height: 6px;
                                width: 6px;
                                background-color: ${this.point.options.throwtype === THROW_TYPES.game ? '#FF0000' : '#254C75'};
                                border-radius: 9999px;
                            " />`;
                    },
                    y: 10,
                },
            },
        },
        legend: {
            enabled: false,
        },
        series: [{
                type: 'column',
                data: chunk.map((s) => ({
                    x: new Date(s.datetime).getTime(),
                    y: s.intensity * 100,
                    throwtype: s.throwtype,
                })),
            }],
    });
};
const getTimeGaps = (chunks) => {
    const timeGaps = chunks.map((chunk) => new Date(chunk[chunk.length - 1].datetime).getTime() - new Date(chunk[0].datetime).getTime());
    const timeGapSum = timeGaps.reduce((sum, v) => (sum + v), 0);
    const newTimeGaps = timeGaps.map((g, i) => Math.max(g, timeGapSum * (i ? 0.15 : 0.26)));
    const newTimeGapSum = newTimeGaps.reduce((sum, v) => (sum + v), 0);
    return { timeGaps: newTimeGaps, timeGapSum: newTimeGapSum };
};
const ThrowTimelineChart = ({ throws, height = 350 }) => {
    const { t: translate } = useTranslation();
    const chunks = getChunks(throws);
    const { timeGaps, timeGapSum } = getTimeGaps(chunks);
    return (React.createElement("div", { className: "d-flex" }, chunks.map((chunk, index) => (React.createElement("div", { style: { width: `calc(100% * ${timeGaps[index] / timeGapSum}` }, key: chunk[0].throwid },
        React.createElement(BaseChart, { options: getChartConfig(translate, chunk, index === 0, height) }))))));
};

/* eslint-disable no-mixed-operators */
function seamOrientationSeriesify(data, seamCt, radius, fillColor) {
    const seriesData = {
        type: 'scatter',
        data: data ? data.map((row) => ({
            x: seamCt === 2 ? row.axis_x_2s : row.axis_x_4s,
            y: seamCt === 2 ? row.axis_z_2s : row.axis_z_4s,
            gamedate: date(row.gamedate),
            awayteam: row.awayteam,
            hometeam: row.hometeam,
            battername: row.battername,
            balls: row.balls,
            strikes: row.strikes,
            inning: row.inning,
        })) : null,
        marker: { radius, fillColor },
        color: fillColor,
    };
    return seriesData;
}
function renderBaseballSeams(chart, seamCt) {
    const ball = {
        x: 0,
        y: 0,
        r: 1,
    };
    const innerCircleAttr = {
        'stroke-width': 1,
        stroke: '#CCCCCC',
        fill: 'none',
        zIndex: 1,
    };
    const circleAttr = {
        'stroke-width': 1,
        stroke: '#777777',
        fill: 'none',
    };
    const seamsPathTop = new Array();
    const seamsPathBottom = new Array();
    const seamsPath2S = new Array();
    const Ff = 1;
    const B = 0.45;
    for (let i = 0; i <= 360; i++) {
        const alpha = i * Math.PI / 180;
        const x = Math.cos(alpha) - B * Math.cos(3 * alpha);
        const y = Math.sin(alpha) + B * Math.sin(3 * alpha);
        const z = Ff * Math.cos(2 * alpha);
        const r = Math.sqrt(1 + B * B + (Ff * Ff - 2 * B) * Math.cos(2 * alpha) * Math.cos(2 * alpha) + 2 * B * Math.sin(2 * alpha) * Math.sin(2 * alpha));
        const xNorm = ball.r * (x / r);
        const yNorm = ball.r * (y / r);
        const zNorm = ball.r * (z / r);
        if (zNorm < 0 && yNorm > 0 && seamsPathTop.length === 0) {
            seamsPathTop.push('M');
            seamsPathTop.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathTop.push(chart.yAxis[0].toPixels(yNorm, false));
            seamsPathTop.push('L');
        }
        else if (zNorm < 0 && yNorm < 0 && seamsPathBottom.length === 0) {
            seamsPathBottom.push('M');
            seamsPathBottom.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathBottom.push(chart.yAxis[0].toPixels(yNorm, false));
            seamsPathBottom.push('L');
        }
        else if (zNorm < 0 && yNorm > 0) {
            seamsPathTop.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathTop.push(chart.yAxis[0].toPixels(yNorm, false));
        }
        else if (zNorm < 0 && yNorm < 0) {
            seamsPathBottom.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathBottom.push(chart.yAxis[0].toPixels(yNorm, false));
        }
        if (yNorm < 0 && seamsPath2S.length === 0) {
            seamsPath2S.push('M');
            seamsPath2S.push(chart.xAxis[0].toPixels(zNorm, false));
            seamsPath2S.push(chart.yAxis[0].toPixels(xNorm, false));
            seamsPath2S.push('L');
        }
        if (yNorm < 0) {
            seamsPath2S.push(chart.xAxis[0].toPixels(zNorm, false));
            seamsPath2S.push(chart.yAxis[0].toPixels(xNorm, false));
        }
    }
    chart.renderer.circle(chart.xAxis[0].toPixels(ball.x, false), chart.yAxis[0].toPixels(ball.y, false), chart.xAxis[0].toPixels(ball.r, false) - chart.xAxis[0].toPixels(0, false)).attr(circleAttr).add();
    if (seamCt === 4) {
        chart.renderer.circle(chart.xAxis[0].toPixels(ball.x, false), chart.yAxis[0].toPixels(ball.y, false), chart.xAxis[0].toPixels(0.6, false) - chart.xAxis[0].toPixels(0, false)).attr(innerCircleAttr).add();
        chart.renderer.circle(chart.xAxis[0].toPixels(ball.x, false), chart.yAxis[0].toPixels(ball.y, false), chart.xAxis[0].toPixels(0.33, false) - chart.xAxis[0].toPixels(0, false)).attr(innerCircleAttr).add();
        chart.renderer.path(seamsPathTop).attr(circleAttr).add();
        chart.renderer.path(seamsPathBottom).attr(circleAttr).add();
    }
    else if (seamCt === 2) {
        chart.renderer.path(seamsPath2S).attr(circleAttr).add();
        const seamsPath2SLines1 = new Array();
        seamsPath2SLines1.push('M');
        seamsPath2SLines1.push(chart.xAxis[0].toPixels(1, false));
        seamsPath2SLines1.push(chart.yAxis[0].toPixels(0, false));
        seamsPath2SLines1.push('L');
        seamsPath2SLines1.push(chart.xAxis[0].toPixels(-1, false));
        seamsPath2SLines1.push(chart.yAxis[0].toPixels(0, false));
        chart.renderer.path(seamsPath2SLines1).attr(innerCircleAttr).add();
        const seamsPath2SLines2 = new Array();
        seamsPath2SLines2.push('M');
        seamsPath2SLines2.push(chart.xAxis[0].toPixels(0, false));
        seamsPath2SLines2.push(chart.yAxis[0].toPixels(1, false));
        seamsPath2SLines2.push('L');
        seamsPath2SLines2.push(chart.xAxis[0].toPixels(0, false));
        seamsPath2SLines2.push(chart.yAxis[0].toPixels(-1, false));
        chart.renderer.path(seamsPath2SLines2).attr(innerCircleAttr).add();
    }
}
const SeamOrientationChart = ({ seamOrientationData, seamOrientationAllData, onClick, height = 350, width = 350, minX = -1.1, maxX = 1.1, minY = -1.1, maxY = 1.1, oppositeY = false, enableZoom = false, turboThreshold = 10000, seamCt = 4, title = null, }) => {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBaseballSeams(chart, seamCt);
    }, [ref, seamOrientationData, seamCt]); // eslint-disable-line react-hooks/exhaustive-deps
    const legendConfig = { enabled: false };
    let fgRadius = 1.25;
    if (seamOrientationData.length > 50 && seamOrientationData.length < 150)
        fgRadius = 2.25;
    if (seamOrientationData.length <= 50)
        fgRadius = 3.25;
    const seriesData = seamOrientationSeriesify(seamOrientationData, seamCt, fgRadius, 'rgba(55, 117, 255, 0.75)');
    const seriesAllData = seamOrientationSeriesify(seamOrientationAllData, seamCt, 1, 'rgba(155, 155, 155, 0.35)');
    seriesAllData.enableMouseTracking = false;
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        title: {
            text: title,
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                point: {
                    events: {
                        click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                            }
                            return null;
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: legendConfig,
        xAxis: {
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
        },
        yAxis: {
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: oppositeY,
            title: {
                text: null,
            },
        },
        tooltip: {
            formatter() {
                var _a, _b, _c, _d, _e, _f, _g;
                // eslint-disable-next-line max-len
                return `<b>${(_a = this.point) === null || _a === void 0 ? void 0 : _a.gamedate} ${(_b = this.point) === null || _b === void 0 ? void 0 : _b.awayteam} @ ${(_c = this.point) === null || _c === void 0 ? void 0 : _c.hometeam}</b><br />Batter: ${(_d = this.point) === null || _d === void 0 ? void 0 : _d.battername}<br />${(_e = this.point) === null || _e === void 0 ? void 0 : _e.inning} Inn ${(_f = this.point) === null || _f === void 0 ? void 0 : _f.balls}-${(_g = this.point) === null || _g === void 0 ? void 0 : _g.strikes} Count`;
            },
            shared: true,
        },
        series: [seriesAllData, seriesData],
    };
    return (React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false }));
};

const Container$5 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
// eslint-disable-next-line max-len
const getAverageSeries = (pitches, key, name, fillColor, visible, symbol) => {
    const x = pitches.reduce((acc, p) => acc + parseFloat(p[`${key}x`]), 0.0) / pitches.length;
    const y = pitches.reduce((acc, p) => acc + parseFloat(p[`${key}z`]), 0.0) / pitches.length;
    const series = {
        type: 'scatter',
        name,
        data: [{ x, y }],
        marker: { symbol, radius: 5, fillColor, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
        zIndex: 99,
        visible,
        color: fillColor,
    };
    return series;
};
const seriesTypes$1 = [
    { name: 'components.charts.drag', key: 'drag_break', fillColor: '#CC0000', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.magnus', key: 'magnus_break', fillColor: '#0000CC', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.seam', key: 'seam_break', fillColor: '#006600', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.total', key: 'total_break', fillColor: '#444444', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.drag', key: 'drag_break', fillColor: '#CC2222', ismlb: false, visible: true, symbol: 'diamond' },
    { name: 'components.charts.magnus', key: 'magnus_break', fillColor: '#2222CC', ismlb: false, visible: true, symbol: 'diamond' },
    { name: 'components.charts.seam', key: 'seam_break', fillColor: '#226622', ismlb: false, visible: true, symbol: 'diamond' },
    { name: 'components.charts.total', key: 'total_break', fillColor: '#666666', ismlb: false, visible: true, symbol: 'diamond' },
];
const mapPitchesToSeries$1 = (translate, pitches) => {
    const series = [];
    seriesTypes$1.forEach((ser) => {
        const name = `${ser.ismlb ? 'MLB' : 'MILB'} ${translate(ser.name)}`;
        let bgRadius = 0.75;
        if (pitches.filter((p) => p.ismlb === ser.ismlb).length < 125)
            bgRadius = 1.25;
        if (pitches.filter((p) => p.ismlb === ser.ismlb).length > 0) {
            series.push(getAverageSeries(pitches.filter((p) => p.ismlb === ser.ismlb), ser.key, name, `${ser.fillColor}99`, ser.visible, ser.symbol));
            series.push({
                type: 'scatter',
                name,
                data: pitches ? pitches.filter((p) => p.ismlb === ser.ismlb).map((row) => ({
                    x: row[`${ser.key}x`],
                    y: row[`${ser.key}z`],
                })) : [],
                marker: { symbol: ser.symbol, radius: ser.ismlb ? bgRadius : 1.33 * bgRadius, fillColor: `${ser.fillColor}55` },
                color: ser.fillColor,
                visible: ser.visible,
                showInLegend: false,
                linkedTo: ':previous',
            });
        }
    });
    return series;
};
const BreakComponentsChart = ({ pitches, videoPlayerModal: VideoPlayerModal, pitchVideoFn, modalContainer, minX = null, minY = null, maxX = null, maxY = null, height = 210, width = 210, enableZoom = true, showlegend = false, title = null, turboThreshold = 10000, isCurrentLevelMLB = true, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const labelXuse = translate('components.charts.break-x-in');
    const labelYuse = translate('components.charts.break-z-in');
    seriesTypes$1.forEach((ser) => {
        ser.visible = ser.ismlb === isCurrentLevelMLB;
    });
    if (!(pitches === null || pitches === void 0 ? void 0 : pitches.length)) {
        return React.createElement(Container$5, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const pitchSeries = mapPitchesToSeries$1(translate, pitches);
    const xAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ x }) => Math.abs(x || 0)));
    const yAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ y }) => Math.abs(y || 0)));
    const chartScale = Math.max(...xAbsVals, ...yAbsVals) + 1;
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
        setVideoPlaylist(playlist);
    });
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const chartConfig = {
        chart: {
            type: 'scatter',
            animation: false,
            plotBorderWidth: 1,
            zoomType: enableZoom ? 'xy' : undefined,
            backgroundColor: undefined,
            height,
            width,
        },
        title: {
            text: title,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                animation: false,
                stickyTracking: false,
                marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: '#000',
                        },
                    },
                },
            },
            series: {
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: {
            enabled: showlegend,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
        },
        xAxis: {
            min: minX != null ? minX : -chartScale,
            max: maxX != null ? maxX : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelXuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
        },
        yAxis: {
            min: minY != null ? minY : -chartScale,
            max: maxY != null ? maxY : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorTickInterval: 3,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelYuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
        },
        tooltip: {
            formatter() {
                return `<b>${this.series.name}</b><br><b>${labelXuse}: </b>${format(this.x, 2)}";<br><b>${labelYuse}: </b>${format(this.y, 2)}"`;
            },
            shared: true,
        },
        series: pitchSeries,
    };
    return (React.createElement(Container$5, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false, className: "breakComponentsChart" })));
};

const Container$4 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const seriesTypes = [
    { name: 'baseball.pitches.fastball-2-alt', key: 'fb2', pitchtype: 9, fillColor: 'rgba(255, 0, 0, 0.5)' },
    { name: 'baseball.pitches.fastball-4-alt', key: 'fb4', pitchtype: 10, fillColor: 'rgba(0, 0, 255, 0.5)' },
    { name: 'baseball.pitches.cutter', key: 'ct', pitchtype: 8, fillColor: 'rgba(0, 100, 0, 0.5)' },
    { name: 'baseball.pitches.changeup_one', key: 'ch', pitchtype: 4, fillColor: 'rgba(0, 0, 0, 0.5)' },
    { name: 'baseball.pitches.splitter', key: 'sp', pitchtype: 7, fillColor: 'rgba(100, 0, 100, 0.5)' },
];
const mapPitchesToSeries = (translate, pitches, lines, ismlb, playerid, yearid) => {
    const series = [];
    seriesTypes.forEach((ser) => {
        const p = pitches.filter((x) => x.fxtype === ser.pitchtype && x.ismlb === ismlb);
        let player = pitches.filter((x) => x.fxtype === ser.pitchtype && x.ismlb === ismlb && x.pitcherid === playerid);
        let playerPrevYear = [];
        if (yearid !== null) {
            playerPrevYear = player.filter((x) => x.yearid !== yearid);
            player = player.filter((x) => x.yearid === yearid);
        }
        const seriesColorString = pitchTypeColor(ser.pitchtype, translate);
        if (p.length > 0) {
            if (player.length > 0) {
                series.push({
                    type: 'scatter',
                    name: translate(ser.name),
                    data: player.map((row) => ({
                        x: row.gyrodegree,
                        y: row.total_perp_break,
                        pitchername: row.pitchername,
                        yearid: row.yearid,
                    })),
                    marker: { radius: 7, fillColor: seriesColorString, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
                    color: seriesColorString,
                    showInLegend: true,
                    zIndex: 99,
                });
            }
            else {
                series.push({
                    type: 'scatter',
                    name: translate(ser.name),
                    data: [],
                    marker: { radius: 7, fillColor: seriesColorString, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
                    color: seriesColorString,
                    showInLegend: true,
                    zIndex: 99,
                });
            }
            if (playerPrevYear.length > 0) {
                series.push({
                    type: 'scatter',
                    name: translate(ser.name),
                    data: playerPrevYear.map((row) => ({
                        x: row.gyrodegree,
                        y: row.total_perp_break,
                        pitchername: row.pitchername,
                        yearid: row.yearid,
                    })),
                    marker: { symbol: 'triangle', radius: 7, fillColor: `${seriesColorString}CC`, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
                    color: `${seriesColorString}CC`,
                    showInLegend: false,
                    linkedTo: ':previous',
                    zIndex: 98,
                });
            }
            series.push({
                type: 'scatter',
                name: translate(ser.name),
                data: p.map((row) => ({
                    x: row.gyrodegree,
                    y: row.total_perp_break,
                    pitchername: row.pitchername,
                })),
                marker: { radius: 0.75, fillColor: `${seriesColorString}88` },
                color: `${seriesColorString}88`,
                showInLegend: false,
                linkedTo: ':previous',
            });
            series.push({
                type: 'scatter',
                name: `${translate(ser.name)} ${translate('common.abbr-average')}`,
                data: lines.map((row) => ({
                    x: row.gyrodegree,
                    y: row[`${ser.key}_${ismlb ? 'mlb' : 'milb'}`],
                    pitchername: 'League Average',
                })),
                marker: { radius: 1, fillColor: seriesColorString },
                color: seriesColorString,
                showInLegend: true,
            });
        }
    });
    return series;
};
const GyroSeamChart = ({ pitches, lines, videoPlayerModal: VideoPlayerModal, pitchVideoFn, modalContainer, minX = null, minY = null, maxX = null, maxY = null, height = 210, width = 210, enableZoom = true, showlegend = false, title = null, ismlb = true, playerid, turboThreshold = 10000, yearid = null, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const labelXuse = translate('components.charts.gyro-degree');
    const labelYuse = translate('components.charts.signed-seam-break');
    if (!(pitches === null || pitches === void 0 ? void 0 : pitches.length)) {
        return React.createElement(Container$4, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const pitchSeries = mapPitchesToSeries(translate, pitches, lines, ismlb, playerid, yearid);
    const xAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ x }) => Math.abs(x || 0)));
    const yAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ y }) => Math.abs(y || 0)));
    const chartScale = Math.max(...xAbsVals, ...yAbsVals) + 1;
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
        setVideoPlaylist(playlist);
    });
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const chartConfig = {
        chart: {
            type: 'scatter',
            animation: false,
            plotBorderWidth: 1,
            zoomType: enableZoom ? 'xy' : undefined,
            backgroundColor: undefined,
            height,
            width,
        },
        title: {
            text: title,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                animation: false,
                stickyTracking: false,
                marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: '#000',
                        },
                    },
                },
            },
            series: {
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: {
            enabled: showlegend,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
        },
        xAxis: {
            min: minX != null ? minX : -chartScale,
            max: maxX != null ? maxX : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelXuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
            reversed: true,
        },
        yAxis: {
            min: minY != null ? minY : -chartScale,
            max: maxY != null ? maxY : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorTickInterval: 3,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelYuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
        },
        tooltip: {
            formatter() {
                var _a, _b, _c;
                // eslint-disable-next-line max-len
                return `<b>Pitch Type: </b>${((_a = this.point) === null || _a === void 0 ? void 0 : _a.yearid) || ''} ${(_b = this.series) === null || _b === void 0 ? void 0 : _b.name}<br><b>Pitcher: </b>${(_c = this.point) === null || _c === void 0 ? void 0 : _c.pitchername}<br><b>${labelXuse}: </b>${format(this.x, 0)}&deg;<br><b>${labelYuse}: </b>${format(this.y, 2)}"`;
            },
            shared: true,
        },
        series: pitchSeries,
    };
    return (React.createElement(Container$4, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { immutable: true, ref: ref, width: width, options: chartConfig, useBodyFont: false, className: "gyroSeamChart" })));
};

const StyledContainer$2 = styled.div `
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
`;
const ThreeSixtyBreakdownChart = ({ onClick, height = 55, width = 55, filterdata, }) => {
    const ref = useRef(null);
    const chartConfig = {
        chart: {
            plotBackgroundColor: undefined,
            plotBorderWidth: undefined,
            plotShadow: false,
            type: 'pie',
            height,
            width,
        },
        title: {
            text: undefined,
        },
        tooltip: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                startAngle: -112.5,
                colors: [
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                ],
                borderColor: '#002255',
                dataLabels: {
                    enabled: false,
                },
                size: height - 6,
            },
        },
        series: [
            {
                type: 'pie',
                animation: false,
                colorByPoint: true,
                slicedOffset: 0,
                data: [
                    { name: '1', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '2', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '3', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '4', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '5', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '6', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '7', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '8', y: 45, states: { select: { color: '#b4cef5' } } },
                ],
                events: {
                    click(event) {
                        const value = event.point.x + 1;
                        onClick(value);
                    },
                },
            },
        ],
    };
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        if (chart && chart.series.length > 0 && chart.series[0].points) {
            chart.getSelectedPoints().forEach((p) => p.select(false));
            chart.series[0].points.forEach((p) => {
                if (filterdata.includes(Number(p.name))) {
                    p.select(true, true);
                }
            });
            chart.redraw();
        }
    }
    useEffect(() => {
        redraw();
    }, [ref, filterdata]); // eslint-disable-line react-hooks/exhaustive-deps
    return (React.createElement(StyledContainer$2, { width: width, height: height },
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable camelcase */
const ChartDiv = styled.div `
    display: flex;
    flex-wrap: wrap;
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const buildSeriesData = (stats, player, percentiles) => [{
        data: stats.map((s) => {
            if (s.key) {
                let y = null;
                if (player[`${s.key}_ntile`])
                    y = s.reversed ? 100 - player[`${s.key}_ntile`] : player[`${s.key}_ntile`];
                return (Object.assign(Object.assign({}, s), { value: s.formatter(player[s.key]), y, ntileData: {
                        percentile: format(s.reversed ? 100 - player[`${s.key}_ntile`] : player[`${s.key}_ntile`], 0),
                        statname: s.name,
                        p25: s.formatter(percentiles[`${s.key}_p${s.reversed ? '75' : '25'}`]),
                        p50: s.formatter(percentiles[`${s.key}_p50`]),
                        p75: s.formatter(percentiles[`${s.key}_p${s.reversed ? '25' : '75'}`]),
                    } }));
            }
            return null;
        }).filter((x) => x),
    }];
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
const PitcherStrengthsPercentiles = ({ className = '', overview, statTooltip, }) => {
    const { player, percentiles } = overview;
    const { t: translate } = useTranslation();
    const overallChart = [{
            key: 'hitfxera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.hitfx-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'HitFX2ERA',
        }, {
            key: 'ubbrate',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.walk-percentage'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'UBBPercent',
        }, {
            key: 'krate',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.strikeout-percentage'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'KPercent',
        }, {
            key: 'cq',
            formatter: (v) => (v != null ? format(v, 1) : '--'),
            name: translate('sections.reports.pitcher.contact-quality'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'ContactQuality',
        }, {
            key: 'pitchfxera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.pitchfx-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'PitchFXERA',
        }, {
            key: 'stuffera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.stuff-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'StuffERA',
        }, {
            key: 'breakera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.break-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'BreakERA',
        }, {
            key: 'locera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.location-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'LocERA',
        }];
    const controllingTheZone = [overallChart[1], {
            key: 'stk',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.strike-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'Stk',
        }, {
            key: 'kzon',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.kzon-pct'),
            units: '%',
            lowText: 'Low',
            highText: 'High',
            precision: 1,
            statistic: 'KZon',
        }, {
            key: 'firstpstk',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.first-pitch-strike-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: '1PitStk',
        }, {
            key: 'wayahead',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.way-ahead'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'WayAhead',
        }, {
            key: 'closepitch',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.close-pitch-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'ClosePitch',
        }, {
            key: 'wastepitch',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.waste-pitch-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'WastedPitPercent',
        }];
    const missingBats = [overallChart[2], {
            key: 'ms',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.miss-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'Ms',
        }, {
            key: 'msinz',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.miss-in-zone-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'MsInZon',
        }, {
            key: 'tkstk',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.called-stk-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'CalledStk',
        }, {
            key: 'ch',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.chase-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'Ch',
        }, {
            key: 'putaway',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.put-away-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'PutAwayPct',
        }];
    const limitingDamage = [overallChart[3], {
            key: 'cr',
            formatter: (v) => (v != null ? format(v, 1) : '--'),
            name: translate('sections.reports.pitcher.contact-results'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'ContactResults',
        }, {
            key: 'gb',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('baseball.abbr-groundball-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'GBPercent',
        }, {
            key: 'pop',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.popup-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'PopPercent',
        }, {
            key: 'hitvelocity',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.exit-velo'),
            units: 'mph',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'ExitVelo',
        }, {
            key: 'wellhit',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.well-hit-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'WellHitPercent',
        }, {
            key: 'slg',
            formatter: (v) => (v != null ? format(v, true) : '--'),
            name: translate('baseball.abbr-slugging'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 3,
            statistic: 'SLG',
        }];
    if (!player || player.length === 0 || !percentiles || percentiles.length === 0) {
        return (React.createElement("div", null, "No Data"));
    }
    return (React.createElement(ChartDiv, { className: `${className} text-center justify-content-around` },
        React.createElement(NtilesChart, { width: 300, height: 450, title: translate('sections.reports.pitcher.overall'), seriesData: buildSeriesData(overallChart, player[0], percentiles[0]), statTooltip: statTooltip }),
        React.createElement(NtilesChart, { width: 300, height: 402, title: translate('sections.reports.pitcher.controlling-the-zone'), seriesData: buildSeriesData(controllingTheZone, player[0], percentiles[0]), statTooltip: statTooltip }),
        React.createElement(NtilesChart, { width: 300, height: 355, title: translate('sections.reports.pitcher.missing-bats'), seriesData: buildSeriesData(missingBats, player[0], percentiles[0]), statTooltip: statTooltip }),
        React.createElement(NtilesChart, { width: 300, height: 402, title: translate('sections.reports.pitcher.limiting-damage'), seriesData: buildSeriesData(limitingDamage, player[0], percentiles[0]), statTooltip: statTooltip })));
};

const StyledCenteredLabel = styled.div `
    text-align: center;
    padding: 2px;
    font-size: 1.5em;
    font-weight: bold;
`;
const StyledBreakdownContainer = styled.div `
    display: table;
    overflow: hidden;
    text-align: center;
`;
const StyledLeftRightLabel = styled.div `
    display: table-cell;
    vertical-align: middle;
    padding: 2px;
    font-size: 1.3em;
    font-weight: bold;
`;
const addSign = (value) => {
    if (value === null || value === undefined)
        return '--';
    const formatted = format(value, 2);
    if (formatted > 0)
        return `+${formatted}`;
    return formatted;
};
const getColor = (value) => {
    if (value === null || value === undefined)
        return 'transparent';
    if (value < -0.05)
        return 'rgba(50, 220, 50, .95)'; // darker green
    if (value >= -0.05 && value <= -0.02)
        return 'rgba(0, 220, 0, .50)'; // lighter green
    if (value > -0.02 && value < 0.02)
        return 'transparent'; // neutral
    if (value >= 0.02 && value <= 0.05)
        return 'rgba(255, 50, 50, .70)'; // lighter red
    if (value > 0.05)
        return 'rgba(255, 50, 50, .95)'; // darker red
    return 'transparent';
};
const isLightGreenOrTransparent = (color) => color === 'transparent' || color.startsWith('rgba(0, 220, 0');
const FirstStepChart = ({ width = 500, forward, back, left, right, }) => {
    const ref = useRef(null);
    const [chartConfig, setChartConfig] = useState({});
    const defaultWidth = 500;
    const defaultHeight = 500;
    const aspectRatio = defaultWidth / defaultHeight;
    const height = width / aspectRatio;
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        if (chart && chart.series.length > 0 && chart.series[0].points) {
            chart.getSelectedPoints().forEach((p) => p.select(false));
            chart.redraw();
        }
    }
    useEffect(() => {
        const forwardColor = getColor(forward.average);
        const leftColor = getColor(left.average);
        const rightColor = getColor(right.average);
        const backColor = getColor(back.average);
        setChartConfig({
            chart: {
                plotBackgroundColor: undefined,
                plotBorderWidth: undefined,
                plotShadow: false,
                type: 'pie',
                height,
                width,
            },
            title: {
                text: undefined,
            },
            tooltip: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    startAngle: -45,
                    colors: [forwardColor, rightColor, backColor, leftColor],
                    borderColor: '#002255',
                    dataLabels: {
                        enabled: true,
                        distance: -50,
                        formatter() {
                            const { point } = this;
                            const value = [forward, right, back, left][point.index].average;
                            const color = isLightGreenOrTransparent([forwardColor, rightColor, backColor, leftColor][point.index]) ? '#000000' : '#FFFFFF';
                            return `<span style="color: ${color}">${addSign(value)}</span>`;
                        },
                        style: {
                            fontSize: '1.3em',
                            fontWeight: 'bold',
                            textOutline: 'none',
                        },
                    },
                    size: 300,
                    enableMouseTracking: false,
                },
            },
            series: [
                {
                    type: 'pie',
                    animation: false,
                    slicedOffset: 0,
                    data: [
                        { name: '1', y: 45 },
                        { name: '2', y: 45 },
                        { name: '3', y: 45 },
                        { name: '4', y: 45 },
                    ],
                },
            ],
        });
        redraw();
    }, [forward, back, left, right]); // eslint-disable-line react-hooks/exhaustive-deps
    return (React.createElement("div", { className: "d-flex flex-column justify-content-center" },
        React.createElement(StyledCenteredLabel, null,
            "In (",
            forward.count,
            ")"),
        React.createElement(StyledBreakdownContainer, null,
            React.createElement(StyledLeftRightLabel, null,
                "Left (",
                left.count,
                ")"),
            React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false, className: "firstStepChart" }),
            React.createElement(StyledLeftRightLabel, null,
                "Right (",
                right.count,
                ")")),
        React.createElement(StyledCenteredLabel, null,
            "Back (",
            back.count,
            ")")));
};

const Container$3 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
function onSeriesAssignment(series, pointshrinkcutoff) {
    const numScatterPoints = series
        .filter((s) => !s.type || s.type === 'scatter')
        .map((x) => (x.data ? x.data.length : 0))
        .reduce((a, b) => a + b, 0);
    if (numScatterPoints <= pointshrinkcutoff) {
        return series;
    }
    const computedSeries = series.map((s) => {
        var _a;
        if (s.type && s.type !== 'scatter')
            return s;
        return Object.assign(Object.assign({}, s), { marker: Object.assign(Object.assign({}, s.marker), { radius: !((_a = s.marker) === null || _a === void 0 ? void 0 : _a.radius) ? 2 : Math.max(1, s.marker.radius - 2) }) });
    });
    return computedSeries;
}
const HangtimeChart = forwardRef(({ titleX, titleY, minRangeY, yplotbands, seriesData, pitchVideoFn, modalContainer, videoPlayerModal: VideoPlayerModal, width = 800, pointshrinkcutoff = 250, subscaleY = 0.50, onClick, xAxisType, tooltipFormatter, enableLegend = true, }, outerRef) => {
    const defaultWidth = 800;
    const defaultHeight = 500;
    const aspectRatio = defaultWidth / defaultHeight;
    const height = width / aspectRatio;
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$3, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            width,
            height,
            backgroundColor: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (onClick)
                                return onClick(this);
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                            return null;
                        },
                    },
                },
                events: {
                    legendItemClick(event) {
                        const { chart } = this;
                        const { series } = chart;
                        const clickedSeries = series[event.target.index];
                        if (clickedSeries.type !== 'scatter') {
                            return true;
                        }
                        const visibleScatterSeries = series.filter((s) => s.visible && s.type === 'scatter');
                        const onlyVisibleScatter = visibleScatterSeries.length === 1 && visibleScatterSeries[0] === clickedSeries;
                        if (onlyVisibleScatter) {
                            series.forEach((s) => {
                                if (s.type === 'scatter') {
                                    s.update({ visible: true }, false);
                                }
                            });
                        }
                        else {
                            series.forEach((s) => {
                                if ((s).type === 'scatter') {
                                    (s).update({ visible: false }, false);
                                }
                            });
                            clickedSeries.update({ visible: true }, false);
                        }
                        chart.redraw();
                        return false;
                    },
                },
            },
            spline: {
                allowPointSelect: false,
                enableMouseTracking: false,
                lineWidth: 1,
                marker: {
                    enabled: false,
                },
            },
        },
        legend: {
            enabled: enableLegend,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            min: 0,
            max: 150,
            tickInterval: 15,
            gridLineWidth: 0,
            tickLength: 10,
            minorTickInterval: 5,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleX,
            },
            type: xAxisType,
        },
        yAxis: {
            min: 1,
            max: 8,
            tickInterval: 1,
            minRange: minRangeY,
            gridLineWidth: 0,
            lineWidth: 1,
            minorTickInterval: subscaleY,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0.05,
            maxPadding: 0.05,
            title: {
                text: titleY,
            },
            plotBands: yplotbands,
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (this.point.tooltip === undefined)
                    return false;
                let tooltip = `<b>${this.point.name || this.series.name}</b>`;
                if (this.point.tooltip)
                    tooltip += `<br/>${this.point.tooltip}`;
                return tooltip;
            },
        },
        series: onSeriesAssignment(seriesData, pointshrinkcutoff),
        title: {
            text: undefined,
            align: 'center',
            floating: true,
            verticalAlign: 'top',
        },
    };
    const seriesDataData = seriesData.flatMap((x) => x.data).map(({ y }) => y || 0);
    const newMinY = seriesDataData.length ? Math.min(...seriesDataData) : null;
    const newMaxY = seriesDataData.length ? Math.max(...seriesDataData) : null;
    if (minRangeY && newMaxY != null && newMinY != null && (newMaxY - newMinY < minRangeY)) {
        const md = ((newMaxY - newMinY) / 2) + newMinY;
        const min = Math.floor((md - (minRangeY / 2)) * 4) / 4;
        const max = min + minRangeY;
        chartConfig.yAxis.min = min;
        chartConfig.yAxis.max = max;
    }
    return (React.createElement(Container$3, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false, className: "hangtimeChart" })));
});

/* eslint-disable react/no-this-in-sfc */
Annotation(Highcharts$1);
const getBackgroundImage = (isLhb, zoom, pitcher) => {
    if (zoom) {
        if (pitcher) {
            return isLhb ? batimpactlhhzoom : batimpactrhhzoom;
        }
        return isLhb ? batimpactrhhzoom : batimpactlhhzoom;
    }
    if (pitcher) {
        return isLhb ? batimpactlhh : batimpactrhh;
    }
    return isLhb ? batimpactrhh : batimpactlhh;
};
const ChartWrapper = styled.div `
    background-image: url(${(props) => getBackgroundImage(props.$isLhb, props.$zoom, props.$pitcher)});
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: contain;
    height: ${(props) => props.$sizeMultiplier * 412}px;
    width: ${(props) => props.$sizeMultiplier * 600} px;
`;
const degrees = 27;
const radians = degrees * Math.PI / 180;
const transformPoints = (isLhb, zoom, pitcherView, points) => points.map((p) => {
    if (p.x === null || p.x === undefined || p.y === null || p.y === undefined) {
        return Object.assign(Object.assign({}, p), { x: undefined, y: undefined });
    }
    const transformedX = (pitcherView ? 1 : -1) * (((p.x * Math.cos(radians)) - (p.y * Math.sin(radians))));
    const transformedY = (p.x * Math.sin(radians)) + (p.y * Math.cos(radians));
    if (zoom) {
        if (pitcherView) {
            return Object.assign(Object.assign({}, p), { x: (transformedX * 2.38 * (430 / 600)) - 4.7, y: (transformedY * 2.38) - 1.6 });
        }
        return Object.assign(Object.assign({}, p), { x: (transformedX * 2.38 * (430 / 600)) + 4.7, y: (transformedY * 2.38) - 2 });
    }
    if (pitcherView) {
        return Object.assign(Object.assign({}, p), { x: (transformedX * 1.58 * (330 / 600)) + (isLhb ? 0.8 : 0.2), y: (transformedY * 1.58) + 0.9 });
    }
    return Object.assign(Object.assign({}, p), { x: (transformedX * 1.58 * (330 / 600)) + (isLhb ? -0.3 : -0.8), y: (transformedY * 1.58) + 0.8 });
});
const BatImpactChart$2 = forwardRef(({ className, isLhb = false, seriesData, tooltipFormatter, pitchVideoFn, multiVideoFn, pitchTypeLeagueAverages, zoom = false, pitcherView = true, sizeMultiplier = 1, }, outerRef) => {
    const ref = useRef(null);
    const [elements, setElements] = useState([]);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    // Update state when prop changes through
    useEffect(() => {
        redraw();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, isLhb, pitcherView, zoom]);
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (!chart)
            return;
        renderSweetSpotMarkers(chart);
    }
    function renderSweetSpotMarkers(chart) {
        if (elements.length) {
            elements.forEach((el) => {
                el.element.remove();
            });
        }
        const xAxis = chart.xAxis[0];
        const yAxis = chart.yAxis[0];
        const lineAttr = {
            'stroke-width': 3,
            stroke: 'green',
            zIndex: 1,
        };
        const points = transformPoints(isLhb, zoom, pitcherView, [{
                x: 4,
                y: (zoom ? -4.5 : -11.5),
            }, {
                x: 4,
                y: (zoom ? -6 : -14),
            }, {
                x: 9,
                y: (zoom ? -4.5 : -11.5),
            }, {
                x: 9,
                y: (zoom ? -6 : -14),
            }]);
        const markerElements = [];
        markerElements.push(chart.renderer.path([
            'M', xAxis.toPixels(points[0].x, false), yAxis.toPixels(points[0].y, false),
            'L', xAxis.toPixels(points[1].x, false), yAxis.toPixels(points[1].y, false),
        ]).attr(lineAttr).add());
        markerElements.push(chart.renderer.path([
            'M', xAxis.toPixels(points[2].x, false), yAxis.toPixels(points[2].y, false),
            'L', xAxis.toPixels(points[3].x, false), yAxis.toPixels(points[3].y, false),
        ]).attr(lineAttr).add());
        setElements(() => markerElements);
    }
    const options = {
        chart: {
            type: 'scatter',
            height: (zoom ? 450 : 350) * sizeMultiplier,
            width: 600 * sizeMultiplier,
            backgroundColor: undefined,
            zoomType: 'xy',
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, visible, x, y } = point;
                            return enabled !== false && visible !== false
                                && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            multiVideoFn(points.filter((p) => isNumber$2(p.gameid, p.eventseq, p.pitchseq)).map((p) => ({
                                gameid: Number(p.gameid),
                                eventseq: Number(p.eventseq),
                                pitchseq: Number(p.pitchseq),
                            })));
                        }
                    }
                    return false; // Don't zoom
                },
            },
        },
        title: {
            text: undefined,
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            visible: false,
            reversed: isLhb,
            min: -20,
            max: 20,
        },
        yAxis: {
            visible: false,
            min: -20,
            max: 20,
        },
        series: seriesData.map((sd) => (Object.assign(Object.assign({}, sd), { type: 'scatter', data: transformPoints(isLhb, zoom, pitcherView, sd.data) }))),
        annotations: pitchTypeLeagueAverages ? [{
                zIndex: 0,
                shapes: pitchTypeLeagueAverages.map((s) => ({
                    type: 'ellipse',
                    xAxis: 0,
                    yAxis: 0,
                    points: transformPoints(isLhb, zoom, pitcherView, [{
                            x: s.x + (s.majorRadius * Math.cos(s.angle)),
                            y: s.y + (s.majorRadius * Math.sin(s.angle)),
                        }, {
                            x: s.x - (s.majorRadius * Math.cos(s.angle)),
                            y: s.y - (s.majorRadius * Math.sin(s.angle)),
                        }]).filter((x) => x.x !== undefined && x.y !== undefined)
                        .map((x) => (Object.assign(Object.assign({}, x), { xAxis: 0, yAxis: 0 }))),
                    ry: s.minorRadius,
                    stroke: pitchSubTypeColor(s),
                    fill: `${pitchSubTypeColor(s)}33`,
                    strokeWidth: 1.5,
                })),
                draggable: '',
            }] : undefined,
        plotOptions: {
            scatter: {
                stickyTracking: false,
            },
            series: {
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (pitchVideoFn)
                                    return pitchVideoFn(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                return '';
            },
        },
    };
    return (React.createElement(ChartWrapper, { "$isLhb": isLhb, "$zoom": zoom, "$pitcher": pitcherView, "$sizeMultiplier": sizeMultiplier, className: className },
        React.createElement(BaseChart, { ref: ref, options: options, className: "batImpactChart" })));
});

/* eslint-disable react/no-this-in-sfc */
Annotation(Highcharts$1);
const headingAverageMap = new Map([
    [2, 25.06],
    [3, 21.63],
    [4, 23.27],
    [6, 17.31],
    [7, 23.77],
    [8, 11.28],
    [9, 1.36],
    [10, -0.21],
    [32, 25.84],
    [33, 20.64],
    [34, 23.07],
]);
const headingStandardDeviationMap = new Map([
    [2, 9.59],
    [3, 8.16],
    [4, 8.81],
    [6, 5.99],
    [7, 8.93],
    [8, 8.65],
    [9, 7.02],
    [10, 6.99],
    [33, 9.2],
    [34, 7.44],
]);
const getHeadingStats = (pitchType, leagueHeadingByPitchType) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        avg: (_c = (_b = (_a = leagueHeadingByPitchType === null || leagueHeadingByPitchType === void 0 ? void 0 : leagueHeadingByPitchType[pitchType]) === null || _a === void 0 ? void 0 : _a.avg) !== null && _b !== void 0 ? _b : headingAverageMap.get(pitchType)) !== null && _c !== void 0 ? _c : 0,
        sd: (_f = (_e = (_d = leagueHeadingByPitchType === null || leagueHeadingByPitchType === void 0 ? void 0 : leagueHeadingByPitchType[pitchType]) === null || _d === void 0 ? void 0 : _d.sd) !== null && _e !== void 0 ? _e : headingStandardDeviationMap.get(pitchType)) !== null && _f !== void 0 ? _f : 0,
    });
};
const HeadingChart$2 = forwardRef(({ seriesData, orderedPitchTypes, tooltipFormatter, pitchVideoFn, multiVideoFn, showLeagueAverageEllipses = false, leagueHeadingByPitchType, disableJitter = false, sizeMultiplier = 1, min = -70, max = 70, }, outerRef) => {
    const ref = useRef(null);
    const { t: translate } = useTranslation();
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    const series = seriesData.map((sd) => (Object.assign(Object.assign({}, sd), { type: 'scatter' })));
    const options = {
        chart: {
            type: 'scatter',
            height: Math.max(Math.min(orderedPitchTypes.length * 80, 400), 200) * sizeMultiplier,
            width: 480 * sizeMultiplier,
            zoomType: 'xy',
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, visible, heading, x, y } = point;
                            return enabled !== false && visible !== false && heading !== null
                                && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            multiVideoFn(points.filter((p) => isNumber$2(p.gameid, p.eventseq, p.pitchseq)).map((p) => ({
                                gameid: Number(p.gameid),
                                eventseq: Number(p.eventseq),
                                pitchseq: Number(p.pitchseq),
                            })));
                        }
                    }
                    return false; // Don't zoom
                },
                load: function load() {
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    const chart = this;
                    const xAxis = chart.xAxis[0];
                    const yAxis = chart.yAxis[0];
                    const lineAttr = {
                        'stroke-width': 3,
                        stroke: 'green',
                        zIndex: 1,
                    };
                    chart.renderer.path([
                        'M', xAxis.toPixels(8, false), yAxis.toPixels(-1, false) - 15,
                        'L', xAxis.toPixels(8, false), yAxis.toPixels(-1, false) + 15,
                    ]).attr(lineAttr).add();
                    chart.renderer.path([
                        'M', xAxis.toPixels(20, false), yAxis.toPixels(-1, false) - 15,
                        'L', xAxis.toPixels(20, false), yAxis.toPixels(-1, false) + 15,
                    ]).attr(lineAttr).add();
                },
            },
        },
        title: {
            text: undefined,
        },
        xAxis: {
            title: {
                text: translate('components.charts.heading'),
                style: {
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: 'black',
                },
            },
            min,
            max,
            tickInterval: 30,
            labels: {
                formatter() {
                    return `${+this.value > 0 ? '+' : ''}${this.value}°`;
                },
                style: {
                    fontSize: '12px',
                    color: 'black',
                },
            },
            plotLines: [-60, -30, 0, 30, 60].map((pl) => ({
                value: pl,
                color: '#c2c2c2',
                width: pl ? 2 : 3,
                dashStyle: 'Dash',
            })),
            lineColor: 'black',
            lineWidth: 2,
        },
        yAxis: {
            title: undefined,
            labels: {
                formatter() {
                    var _a;
                    return ((_a = pitchTypeOrSubType(orderedPitchTypes[+this.value], true)) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                },
                style: {
                    fontSize: '12px',
                    color: 'black',
                },
            },
            gridLineWidth: 0,
            min: -1,
            max: orderedPitchTypes.length,
            tickInterval: 1,
            lineColor: 'black',
            lineWidth: 2,
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                return '';
            },
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                jitter: disableJitter ? undefined : {
                    y: 0.1,
                    x: 0,
                },
            },
            series: {
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (pitchVideoFn)
                                    return pitchVideoFn(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        annotations: [showLeagueAverageEllipses ? {
                zIndex: 2,
                shapes: orderedPitchTypes.map((opt, index) => {
                    const { avg, sd } = getHeadingStats(opt, leagueHeadingByPitchType);
                    return {
                        type: 'ellipse',
                        xAxis: 0,
                        yAxis: 0,
                        points: [{
                                x: avg - (1.5 * sd),
                                y: index,
                                xAxis: 0,
                                yAxis: 0,
                            }, {
                                x: avg + (1.5 * sd),
                                y: index,
                                xAxis: 0,
                                yAxis: 0,
                            }],
                        ry: 0.25,
                        stroke: pitchSubTypeColor({ fxtype: opt > 10 ? opt / 10 : opt, fxsubtype: opt > 10 ? opt : null }),
                        fill: `${pitchSubTypeColor({ fxtype: opt > 10 ? opt / 10 : opt, fxsubtype: opt > 10 ? opt : null })}33`,
                        strokeWidth: 1.5,
                    };
                }),
                draggable: '',
            } : {}, {
                zIndex: 1,
                shapeOptions: {
                    src: 'data:image/png;base64,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',
                },
                shapes: orderedPitchTypes.map((opt, index) => ({
                    type: 'image',
                    width: 11,
                    height: 33,
                    point: {
                        x: getHeadingStats(opt, leagueHeadingByPitchType).avg - 1.75,
                        y: index + 0.5,
                        xAxis: 0,
                        yAxis: 0,
                    },
                })),
                draggable: '',
            }],
        series,
    };
    return (React.createElement(BaseChart, { key: seriesData, ref: ref, options: options, className: "headingChart" }));
});

const sizesWidth = { sm: 200, md: 300, lg: 400 };
const sizesHeight = { sm: 200, md: 300, lg: 400 };
const sizesAxisWidth = { sm: 200, md: 300, lg: 400 };
const sizesAxisHeight = { sm: 200, md: 300, lg: 400 };
// Size and place the batter feet
const sizesBatterFeetWidth = { sm: 35, md: 60, lg: 75 };
const sizesBatterFeetHeight = { sm: 100, md: 175, lg: 250 };
const sizesLhbPosition = {
    sm: { x: 5, y: 35 },
    md: { x: 5, y: 55 },
    lg: { x: 8, y: 70 },
};
const sizesRhbPosition = {
    sm: { x: 135, y: 35 },
    md: { x: 235, y: 55 },
    lg: { x: 315, y: 70 },
};
const LOCAL_STORAGE_CHARTLEGEND_KEY = 'chart_legend_ht';
const sizes = {
    width: sizesWidth,
    height: sizesHeight,
    axiswidth: sizesAxisWidth,
    axisheight: sizesAxisHeight,
    batterfeetwidth: sizesBatterFeetWidth,
    batterfeetheight: sizesBatterFeetHeight,
    lhbposition: sizesLhbPosition,
    rhbposition: sizesRhbPosition,
};
const HitterTiming$2 = forwardRef(({ size = 'lg', enableZoom = true, minX = null, maxX = null, minY = null, maxY = null, isLhb = false, showlegend = false, legendposition = 'float', seriesData, showoffgrid = true, pitcherView = false, pointshrinkcutoff = 250, modalContainer, pitchVideoFn, multiVideoFn, videoPlayerModal: VideoPlayerModal, exportPlaylistCallback, onClick, legendClickFn, customLegend, preventLegendSeriesHover = false, ignoreLocalStorageChartLegend = true, tooltipFormatter, sizeMultiplier = 1, }, outerRef) => {
    const ref = useRef(null);
    const [bgImgPath, setBgImgPath] = useState(null);
    const [series, updateSeries] = useState(onSeriesAssignment(seriesData));
    const [elements, setElements] = useState({});
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const [minXdraw, setMinXdraw] = useState(minX);
    const [maxXdraw, setMaxXdraw] = useState(maxX);
    const [minYdraw, setMinYdraw] = useState(minY);
    const [maxYdraw, setMaxYdraw] = useState(maxY);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    useEffect(() => {
        var _a;
        redraw();
        updateSeries(onSeriesAssignment(fixOffGridPoints(((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null, seriesData)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, seriesData, size, isLhb, pitcherView, sizeMultiplier]);
    useEffect(() => {
        if (minX) {
            setMinXdraw(minX);
        }
        else if (pitcherView) {
            setMinXdraw(-33);
        }
        else {
            setMinXdraw(-33);
        }
        if (maxX) {
            setMaxXdraw(maxX);
        }
        else if (pitcherView) {
            setMaxXdraw(32);
        }
        else {
            setMaxXdraw(32);
        }
        if (minY) {
            setMinYdraw(minY);
        }
        else if (pitcherView) {
            setMinYdraw(-45);
        }
        else {
            setMinYdraw(-25);
        }
        if (maxY) {
            setMaxYdraw(maxY);
        }
        else if (pitcherView) {
            setMaxYdraw(25);
        }
        else {
            setMaxYdraw(43);
        }
    }, [ref, minX, maxX, minY, maxY, pitcherView]);
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (!chart)
            return;
        drawBackground();
        renderBatterFeet(chart);
    }
    function drawBackground() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        if (bgImgPath != null) {
            bgImgPath.element.remove();
        }
        setBgImgPath(chart.renderer.image(pitcherView ? battersBoxOverheadPitcher : battersBoxOverheadCatcher, 0, 0, sizes.width[size] * sizeMultiplier, sizes.height[size] * sizeMultiplier)
            .attr({
            zIndex: -999,
        })
            .add());
    }
    const legendConfig = Object.assign({ enabled: showlegend }, customLegend);
    if (customLegend === null || customLegend === undefined) {
        if (legendposition === 'float') {
            legendConfig.align = 'right';
            legendConfig.verticalAlign = 'top';
            legendConfig.layout = 'vertical';
            legendConfig.floating = true;
            legendConfig.x = -16;
            legendConfig.y = 10;
        }
        else if (legendposition === 'below') {
            legendConfig.align = 'center';
            legendConfig.floating = true;
            if (size && size !== 'lg') {
                legendConfig.itemDistance = 10;
                legendConfig.width = '100%';
            }
            if (size === 'sm') {
                legendConfig.itemWidth = 100;
                legendConfig.itemStyle = {
                    fontSize: '10px',
                };
                legendConfig.margin = 0;
            }
        }
    }
    function onSeriesAssignment(_series) {
        const numScatterPoints = _series
            .filter((s) => !s.type || s.type === 'scatter')
            .map((x) => (x.data ? x.data.length : 0))
            .reduce((a, b) => a + b, 0);
        return _series.map((s) => {
            var _a;
            const mappedSeries = Object.assign(Object.assign({}, s), { data: (_a = s.data) === null || _a === void 0 ? void 0 : _a.map((d) => (pitcherView ? d : Object.assign(Object.assign({}, d), { x: d.x * -1 }))) });
            if (numScatterPoints > pointshrinkcutoff && (!s.type || s.type === 'scatter')) {
                mappedSeries.marker = Object.assign(Object.assign({}, mappedSeries.marker), { radius: !mappedSeries.marker ? 2 : Math.max(1, mappedSeries.marker.radius - 2) });
            }
            return mappedSeries;
        });
    }
    function renderBatterFeet(chart) {
        let batterFeetImg;
        let batterFeetPosition;
        if (pitcherView) {
            batterFeetImg = isLhb ? feetPointingRight : feetPointingLeft;
            batterFeetPosition = isLhb ? 'lhb' : 'rhb';
        }
        else {
            batterFeetImg = isLhb ? feetPointingLeft : feetPointingRight;
            batterFeetPosition = isLhb ? 'rhb' : 'lhb';
        }
        const { x, y } = sizes[`${batterFeetPosition}position`][size];
        const w = sizes.batterfeetwidth[size] * sizeMultiplier;
        const h = sizes.batterfeetheight[size] * sizeMultiplier;
        const imgattr = {
            zIndex: -998,
            opacity: 0.4,
        };
        if (elements.batterFeetRender) {
            elements.batterFeetRender.element.remove();
        }
        elements.batterFeetRender = chart.renderer
            .image(batterFeetImg, x * sizeMultiplier, y * sizeMultiplier, w, h)
            .attr(imgattr)
            .add();
        setElements(elements);
    }
    function fixOffGridPoints(chart, _series) {
        if (!chart || !showoffgrid)
            return _series;
        const xrange = chart.xAxis[0].getExtremes();
        const yrange = chart.yAxis[0].getExtremes();
        for (let i = 0; i < _series.length; i += 1) {
            if (!isNaN(parseInt(showoffgrid.toString()))) {
                if (parseInt(showoffgrid.toString()) !== i) {
                    continue; // eslint-disable-line no-continue
                }
            }
            if (_series[i].data.length > 0) {
                for (let j = 0; j < _series[i].data.length; j += 1) {
                    const point = _series[i].data[j];
                    if (isNumber$2(point.x, point.y) && (point.x < xrange.min || xrange.max < point.x || point.y <= yrange.min || yrange.max <= point.y)) {
                        /* eslint-disable no-param-reassign, no-nested-ternary */
                        _series[i].data[j].x = (point.x <= xrange.min ? xrange.min + 0.05 : (xrange.max < point.x ? xrange.max - 0.05 : point.x));
                        _series[i].data[j].y = (point.y <= yrange.min ? yrange.min + 0.05 : (yrange.max < point.y ? yrange.max - 0.05 : point.y));
                        /* eslint-enable no-param-reassign, no-nested-ternary */
                    }
                }
            }
        }
        return _series;
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const fetchMultiVideo = (pitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const pitchIds = pitches
                .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
                .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
            const playlist = yield multiVideoFn(pitchIds);
            setVideoPlaylist(playlist);
        }
        catch (_b) {
            closePitchVideo();
        }
    });
    if (!ignoreLocalStorageChartLegend) {
        const legendJson = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_CHARTLEGEND_KEY) || '[]');
        series.forEach((x) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const leg = legendJson.find((y) => y.id === x.id);
            if (leg != null)
                x.visible = leg.visible;
        });
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            height: sizes.height[size] * sizeMultiplier,
            width: sizes.width[size] * sizeMultiplier,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.filter((s) => s.visible).flatMap((s) => s.points.filter((point) => {
                            const { enabled, x, y } = point;
                            return enabled !== false && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            fetchMultiVideo(points.map((p) => ({
                                gameid: p.gameid,
                                pitchseq: p.pitchseq,
                                eventseq: p.eventseq,
                            })));
                        }
                    }
                    return false; // Don't zoom
                },
            },
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                turboThreshold: 0,
                dataLabels: {
                    allowOverlap: true,
                    crop: false,
                    overflow: 'justify',
                },
                point: {
                    events: {
                        click: function click() {
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                if (onClick)
                                    return onClick(this);
                                if (pitchVideoFn)
                                    return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                            return null;
                        },
                    },
                },
                events: {
                    legendItemClick(e) {
                        const chart = this.chart.legend.allItems;
                        if (chart !== undefined && !ignoreLocalStorageChartLegend) {
                            window.localStorage.setItem(LOCAL_STORAGE_CHARTLEGEND_KEY, JSON.stringify(chart.map((ch) => ({
                                id: ch.options.id,
                                visible: this.index === ch.index ? !ch.visible : ch.visible,
                                name: ch.name,
                            }))));
                        }
                        if (legendClickFn) {
                            const returnLegend = [];
                            const thisLegendItem = e.target;
                            returnLegend.push(Object.assign(Object.assign({}, thisLegendItem), { visible: !thisLegendItem.visible }));
                            this.chart.series.filter((x) => x.index !== thisLegendItem.index).forEach((x) => {
                                if (x.visible) {
                                    returnLegend.push(Object.assign({}, x));
                                }
                                else {
                                    returnLegend.push(Object.assign({}, x));
                                }
                            });
                            legendClickFn(returnLegend);
                        }
                        return this;
                    },
                },
                states: {
                    inactive: {
                        opacity: preventLegendSeriesHover ? 1 : 0.2,
                    },
                },
            },
        },
        legend: legendConfig,
        xAxis: {
            visible: false,
            tickInterval: 1,
            gridLineWidth: 1,
            gridLineColor: '#ccc',
            plotLines: [{
                    value: 0,
                    color: '#000000',
                    width: 1,
                    zIndex: 5,
                }],
            height: sizes.axisheight[size] * sizeMultiplier,
            width: sizes.axiswidth[size] * sizeMultiplier,
            min: minXdraw,
            max: maxXdraw,
            minPadding: 0,
            maxPadding: 0,
            title: {
                text: null,
            },
            labels: {
                enabled: false,
                reserveSpace: false,
            },
        },
        yAxis: {
            visible: false,
            tickInterval: 1,
            gridLineWidth: 1,
            minorGridLineColor: '#ccc',
            plotLines: [{
                    value: 0,
                    color: '#000000',
                    width: 1,
                    zIndex: 5,
                }],
            height: sizes.axisheight[size] * sizeMultiplier,
            width: sizes.axiswidth[size] * sizeMultiplier,
            min: minYdraw,
            max: maxYdraw,
            title: {
                text: null,
            },
            labels: {
                enabled: false,
                reserveSpace: false,
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (!this.point.tooltip && !this.point.name)
                    return false;
                return `<b>${this.series.name}</b><br/>${this.point.tooltip || this.point.name}`;
            },
            outside: true,
        },
        series,
        title: {
            align: 'center',
            floating: true,
            verticalAlign: 'top',
            text: undefined,
        },
        credits: {
            enabled: false,
        },
    };
    return (React.createElement(React.Fragment, null,
        !!(pitchVideoFn || multiVideoFn) && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer, exportPlaylist: (clips) => { closePitchVideo(); if (exportPlaylistCallback)
                exportPlaylistCallback(clips); } })),
        React.createElement(BaseChart, { ref: ref, width: sizes.width[size] * sizeMultiplier, options: chartConfig, useBodyFont: false, className: "hitterTimingChart" })));
});

const BallRMini = ({ height = null, width = null, ballcapSensorEvent, iframeSrc = '/miniballr/index.html', resendNonce = 0, sensorEventKey, }) => {
    // Vendor access token (consider passing via prop/env per environment).
    // eslint-disable-next-line max-len -- single-line JWT
    const ballrKey = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJCYWxsUjIiLCJjbGllbnQiOiJOWVkiLCJleHAiOjE4MDE0NTgwMDB9.ovS29UOzXo87U-LyaostAZ5BrTkbamDtqfq7Xj5x_bg-ThTC9zrjQmwQNp4RfFAVFhWaP1FtlrdtNw5BJOnBwPd1o8tRApck28fHoYnoPoM6-BTgkvgenf5dVMmp1jFwd2MdYisK8761Q2Kfuu7bSUX2IbDxS6aiSWA1ylPvSaerWhuFYY8YkMMmOkKD3noRdtbL8l4uKDZOVyHGMAuZPFwPVE5D4_tme2ZxNU6pN24-u8jPDHtG2-TYCigZa3dkLtB976E4zfwUlKBdYhLLn6vo_lHm4SlecVw4ROhsNXw6MKUb7WW7bkSjVfD4safAQRzljqP53BelDCeAye2D6u2FO_0oxshu6TdseHM3JJCQ0MTsswW9JgSdUdfbSVUr1tJRWENAOh6FAeSJ_qtVVXIS_JHrtuIo7fu76LJqfSM1hJbXwLT1S46UAqxgYWGFwxlZ9UbahkkyqEVwcTWGkMjKB-ixbqe4wmmg2edwXn68dLWpNcCOkditfZCj8HPnJzJwM2AoWcj9WOBAiDvunvARJ3jzR2G-ACGWupM4N8aURuTcxrVdb9_h2MVzSXi6_Utc3rN1EbJeGfnUymTDeg5BrAojdbqspf4-qH_mZyGh-QlDUD3lkCHxOQF_Qx86VxIj1DePM702Yl8-ILLdwzDgVdnWrOlQBGv8YPHbt2Q';
    const iframeRef = useRef(null);
    const iframeTargetWinRef = useRef(null);
    const ballrPitchDataRef = useRef(null);
    const [ballrPitchData, setBallrPitchData] = useState(null);
    useEffect(() => {
        ballrPitchDataRef.current = ballrPitchData;
    }, [ballrPitchData]);
    const postToIframe = useCallback((message) => {
        var _a, _b;
        const win = (_b = (_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) !== null && _b !== void 0 ? _b : iframeTargetWinRef.current;
        win === null || win === void 0 ? void 0 : win.postMessage(message, '*');
    }, []);
    const isEmptyObject = (obj) => Object.keys(obj).length === 0;
    const isPlainObject = (obj) => (typeof obj === 'object' && obj !== null && !Array.isArray(obj));
    useEffect(() => {
        const frameMessageReceived = (event) => {
            var _a, _b;
            if (event.data !== 'Mini BallR ready') {
                return;
            }
            // Do not use `instanceof Window`: child iframe Window is a different realm and fails the check.
            const src = event.source;
            if (src == null || typeof src.postMessage !== 'function') {
                return;
            }
            const targetWin = src;
            iframeTargetWinRef.current = targetWin;
            const accessPayload = { accessKey: ballrKey };
            targetWin.postMessage(accessPayload, '*');
            // Same reference can miss in some embeds; mirror via ref when it matches.
            (_b = (_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(accessPayload, '*');
            const pending = ballrPitchDataRef.current;
            if (pending != null) {
                queueMicrotask(() => {
                    var _a, _b;
                    const gamePayload = Object.assign(Object.assign({}, pending), { sendMessageType: 'SendYTGameEvent' });
                    targetWin.postMessage(gamePayload, '*');
                    (_b = (_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(gamePayload, '*');
                });
            }
        };
        window.addEventListener('message', frameMessageReceived);
        return () => {
            window.removeEventListener('message', frameMessageReceived);
        };
    }, [ballrKey]);
    useEffect(() => {
        var _a;
        // Prefer `DataRaw` (untouched vendor payload) and fall back to `Data`.
        // Skip until we have a Yakker-style payload with one of them.
        if (ballcapSensorEvent == null
            || !isPlainObject(ballcapSensorEvent)
            || isEmptyObject(ballcapSensorEvent)) {
            return;
        }
        if (ballcapSensorEvent.isReset) {
            setBallrPitchData(Object.assign({}, ballcapSensorEvent));
            return;
        }
        const rawSource = (_a = ballcapSensorEvent.DataRaw) !== null && _a !== void 0 ? _a : ballcapSensorEvent.Data;
        if (!isPlainObject(rawSource)) {
            return;
        }
        const yakkerPayload = rawSource;
        const hitData = yakkerPayload.hit_data;
        const rawPitch = yakkerPayload.pitch_data;
        let pitchData = rawPitch;
        if (rawPitch != null && isPlainObject(rawPitch)) {
            pitchData = Object.assign(Object.assign({}, rawPitch), { ShowMetrics: false });
        }
        const ballRFormat = {
            method: 'gameevent',
            gameevent: {
                gameEventUUID: crypto.randomUUID(),
                gameUUID: crypto.randomUUID(),
                machineUUID: crypto.randomUUID(),
                // eslint-disable-next-line camelcase -- BallR / Yakker wire shape
                metrics: { pitch_data: pitchData, hit_data: hitData },
            },
        };
        ballrPitchDataRef.current = ballRFormat;
        setBallrPitchData(ballRFormat);
    }, [ballcapSensorEvent, sensorEventKey]);
    useEffect(() => {
        if (ballrPitchData == null) {
            return;
        }
        postToIframe(Object.assign(Object.assign({}, ballrPitchData), { sendMessageType: 'SendYTGameEvent' }));
    }, [ballrPitchData, postToIframe]);
    useEffect(() => {
        if (resendNonce < 1) {
            return;
        }
        const pending = ballrPitchDataRef.current;
        if (pending == null) {
            return;
        }
        postToIframe(Object.assign(Object.assign({}, pending), { sendMessageType: 'SendYTGameEvent' }));
    }, [resendNonce, postToIframe]);
    return (React.createElement("div", { style: Object.assign(Object.assign({ overflow: 'hidden', margin: 'auto' }, (width != null ? { width: `${width}px` } : { width: '100%' })), (height != null ? { height: `${height}px` } : { height: '100%' })) },
        React.createElement("iframe", { ref: iframeRef, title: "Mini BallR Frame", src: iframeSrc, style: Object.assign(Object.assign({ overflow: 'hidden', margin: '0px', border: 'none', backgroundColor: '#ffffff' }, (width != null ? { width: `${width}px` } : { width: '100%' })), (height != null ? { height: `${height}px` } : { height: '100%' })) })));
};

const Container$2 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;

        div {
            overflow: visible !important;
        }
        svg {
            overflow: visible !important;
        }
        .highcharts-container {
            z-index: unset !important;
            overflow: unset !important;
        }
    }
`;
const AXIS_MIN_X = -20;
const AXIS_MAX_X = 20;
const AXIS_MIN_Y = 0;
const AXIS_MAX_Y = 40;
const CHART_HEIGHT = 330;
const CHART_WIDTH = 360;
function buildZoneDepthChartOptions(series, w, h, handlers, tooltipFormatter) {
    return {
        title: { text: undefined },
        chart: {
            type: 'scatter',
            height: h,
            width: w,
            events: {
                selection() {
                    return false;
                },
                load() {
                    const chart = this;
                    handlers.drawHomePlate(chart);
                    handlers.updateMarkerSizes(chart);
                },
                redraw() {
                    const chart = this;
                    handlers.drawHomePlate(chart);
                    handlers.updateMarkerSizes(chart);
                },
            },
        },
        series,
        xAxis: {
            min: AXIS_MIN_X,
            max: AXIS_MAX_X,
            visible: false,
            gridLineWidth: 0,
            lineWidth: 0,
        },
        yAxis: {
            title: { text: undefined },
            min: AXIS_MIN_Y,
            max: AXIS_MAX_Y,
            opposite: true,
            gridLineColor: '#888888',
            gridLineDashStyle: 'Dash',
            labels: {
                format: '{value:.1f}"',
                style: {
                    fontSize: '14px',
                },
            },
        },
        legend: { enabled: false },
        tooltip: {
            formatter() {
                var _a, _b;
                if (tooltipFormatter) {
                    return tooltipFormatter(this.series, this.point);
                }
                const x = typeof this.x === 'number' ? this.x.toFixed(1) : '-';
                const y = typeof this.y === 'number' ? this.y.toFixed(1) : '-';
                const label = (_b = (_a = this.series) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
                return `<b>${label}</b><br/>x: ${x}<br/>y: ${y}`;
            },
        },
    };
}
function clampZoneDepthSeries(series) {
    return series.map((s) => (Object.assign(Object.assign({}, s), { data: (Array.isArray(s.data) ? s.data : []).map((p) => {
            if (typeof p !== 'object' || p === null)
                return p;
            const pt = p;
            let x = Number(pt.x);
            let y = Number(pt.y);
            if (Number.isNaN(x))
                x = 0;
            if (Number.isNaN(y))
                y = 0;
            x = Math.max(AXIS_MIN_X, Math.min(x, AXIS_MAX_X));
            y = Math.max(AXIS_MIN_Y, Math.min(y, AXIS_MAX_Y));
            return Object.assign(Object.assign({}, pt), { x, y });
        }) })));
}
function seriesHasPoints(series) {
    return (series !== null && series !== void 0 ? series : []).some((s) => Array.isArray(s.data) && s.data.length > 0);
}
const ZoneDepthChart = ({ seriesData, width = CHART_WIDTH, height = CHART_HEIGHT, autoSizeMarkers = true, tooltipFormatter, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const plateGraphicRef = useRef(null);
    const markerUpdateLockRef = useRef(false);
    const clampedSeries = useMemo(() => clampZoneDepthSeries(seriesData !== null && seriesData !== void 0 ? seriesData : []), [seriesData]);
    const hasData = useMemo(() => seriesHasPoints(seriesData), [seriesData]);
    const drawHomePlate = useCallback((chart) => {
        var _a;
        (_a = plateGraphicRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        plateGraphicRef.current = null;
        const xAxis = chart.xAxis[0];
        const yAxis = chart.yAxis[0];
        const path = [
            'M', xAxis.toPixels(-8.5, false), yAxis.toPixels(17, false),
            'L', xAxis.toPixels(8.5, false), yAxis.toPixels(17, false),
            xAxis.toPixels(8.5, false), yAxis.toPixels(8.5, false),
            xAxis.toPixels(0, false), yAxis.toPixels(0, false),
            xAxis.toPixels(-8.5, false), yAxis.toPixels(8.5, false),
            'Z',
        ];
        plateGraphicRef.current = chart.renderer.path(path)
            .attr({
            'stroke-width': 0,
            stroke: '#c0c0c0',
            fill: '#c0c0c0',
            zIndex: 1,
        })
            .add();
    }, []);
    const updateMarkerSizes = useCallback((chart) => {
        if (markerUpdateLockRef.current)
            return;
        if (!autoSizeMarkers)
            return;
        markerUpdateLockRef.current = true;
        const rData = 1.47;
        const axis = chart.yAxis[0];
        const rPx = Math.abs(axis.toPixels(rData, false) - axis.toPixels(0, false));
        chart.series.forEach((s) => {
            const { marker } = s.options;
            if (marker && typeof marker === 'object') {
                // eslint-disable-next-line no-param-reassign
                s.options.marker = Object.assign(Object.assign({}, marker), { radius: rPx });
            }
        });
        chart.redraw(false);
        markerUpdateLockRef.current = false;
    }, [autoSizeMarkers]);
    const chartOptions = useMemo(() => buildZoneDepthChartOptions(clampedSeries, width, height, {
        drawHomePlate,
        updateMarkerSizes,
    }, tooltipFormatter), [clampedSeries, drawHomePlate, height, tooltipFormatter, updateMarkerSizes, width]);
    if (!hasData) {
        return (React.createElement(Container$2, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-data'))));
    }
    return (React.createElement(Container$2, null,
        React.createElement(BaseChart, { ref: ref, options: chartOptions, width: width })));
};

const LoadingSpinner$1 = (props) => (React.createElement(Spinner, Object.assign({ animation: "border" }, props)));

const StyledSpinner = styled.div `
    background: transparent url(${spinnerImg}) no-repeat center;
    height: 15px;
    width: 15px;
`;
const StyledLoadingSpinner$1 = styled.div `
    h6 {
        font-weight: bold;
    }
    h6, ${StyledSpinner} {
        display: inline-block;
    }
    h6 + ${StyledSpinner} {
        position: relative;
        top: 2px;
    }
`;
const LoadingSpinner = ({ withText = false }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(StyledLoadingSpinner$1, null,
        withText && React.createElement("h6", null,
            translate('common.loading'),
            "...\u00A0"),
        React.createElement(StyledSpinner, null)));
};

const StyledName$1 = styled.span `
    color: ${({ handedness }) => {
    if (handedness === 3)
        return '#0000CC';
    if (handedness === 2)
        return '#CC0000';
    return theme.fontColors.mineShaft;
}};
    font-weight: bold;
`;
const PlayerName = ({ throws, bats, player = {}, name = '', formal = false }) => {
    let playerName = name;
    if (!playerName) {
        // covering our bases. Player names and IDs come in all shapes and sizes depending on the API call
        playerName = formal ? player.FormalName : player.FullName;
        if (!playerName) {
            const firstName = player.UsesName || player.usesname;
            const lastName = player.LastName || player.lastname;
            playerName = formal ? `${lastName}, ${firstName}` : `${firstName} ${lastName}`;
        }
    }
    let handedness = throws === true ? player.Throws || player.throws : throws;
    if (handedness === undefined || handedness === null) {
        handedness = bats === true ? player.Bats || player.bats : bats;
    }
    return (React.createElement(StyledName$1, { handedness: handedness }, playerName));
};

/* eslint-disable react/no-danger */
const StyledStatPopover = styled(Popover) `
    h5.popover-header {
        font-size: 1.25em;
    }
    .popover-body {
        font-size: 1.05em;
        min-width: 165px;
    }
`;
const StyledPopoverTriggerText = styled.span `
    border-bottom: 1px dotted;
`;
const StatTooltip = ({ children, onToggle, definition, isLoading = false, placement = 'top' }) => {
    const { t: translate, i18n } = useTranslation();
    const languageCode = i18n.language;
    const [definitionText, setDefinitionText] = useState('');
    const [definitionTitle, setDefinitionTitle] = useState('');
    useEffect(() => {
        if (languageCode) {
            let primaryDef = '';
            let primaryTitle = '';
            switch (languageCode) {
                case 'es': // spanish
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextSpanish) || (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleSpanish) || (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
                case 'ja':
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextJapanese) || (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleJapanese) || (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
                case 'ko':
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextKorean) || (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleKorean) || (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
                case 'en':
                default:
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
            }
            setDefinitionTitle(primaryTitle || '');
            setDefinitionText(primaryDef || primaryTitle || '');
        }
    }, [languageCode, definition]);
    const title = definitionText ? (definitionTitle || children) : children;
    const popover = (React.createElement(StyledStatPopover, { id: "stat-tooltip" },
        React.createElement(StyledStatPopover.Header, { as: "h5" }, title),
        React.createElement(StyledStatPopover.Body, null,
            isLoading && `${translate('common.loading')}...`,
            !isLoading && !!definitionText && React.createElement("span", { dangerouslySetInnerHTML: { __html: definitionText } }))));
    return (React.createElement("div", null,
        React.createElement(OverlayTrigger$1
        // eslint-disable-next-line no-nested-ternary
        , { 
            // eslint-disable-next-line no-nested-ternary
            placement: placement, overlay: popover, onToggle: onToggle },
            React.createElement(StyledPopoverTriggerText, null, children))));
};

const EXECUTION_ERA_BUCKETS = [
    { maximum: 0, color: '#004400' },
    { maximum: 1.40, color: '#007000' },
    { maximum: 2.63, color: '#00b000' },
    { maximum: 4.10, color: '#00e000' },
    { maximum: 6.00, color: '#88ff88' },
    { maximum: Number.POSITIVE_INFINITY, color: '#ffffff' },
];
const executionEraColor = (executionEra) => {
    var _a;
    return (((_a = EXECUTION_ERA_BUCKETS.find(({ maximum }) => executionEra <= maximum)) === null || _a === void 0 ? void 0 : _a.color) || '#ffffff');
};
const executionEraGradientColors = [...EXECUTION_ERA_BUCKETS].reverse().map(({ color }) => color);
const EXECUTION_ERA_GRADIENT = `linear-gradient(to right, ${executionEraGradientColors.map((color, index) => {
    const start = (index / executionEraGradientColors.length) * 100;
    const end = ((index + 1) / executionEraGradientColors.length) * 100;
    return `${color} ${start}%, ${color} ${end}%`;
}).join(', ')})`;

const StyledExecutionEraKey = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
`;
const StyledExecutionEraGradient = styled.div `
    width: 180px;
    height: 14px;
    border: 1px solid #6c757d;
    background: ${EXECUTION_ERA_GRADIENT};
`;
const ExecutionEraKey = () => {
    const { t: translate } = useTranslation();
    const executionEra = translate('sections.reports.pitcher.exec-era');
    return (React.createElement(StyledExecutionEraKey, null,
        React.createElement("span", null,
            translate('components.charts.high'),
            " ",
            executionEra),
        React.createElement(StyledExecutionEraGradient, null),
        React.createElement("span", null,
            translate('components.charts.low'),
            " ",
            executionEra)));
};

const Card$1 = styled.div `
    background: ${theme.background.white};
    border: 1px solid ${theme.border.alto};
    border-radius: 0.25rem;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    min-width: 8.5rem;
    overflow: hidden;
`;
const Label = styled.div `
    background: ${theme.background.geyser};
    border-bottom: 1px solid ${theme.border.alto};
    color: ${theme.fontColors.mineShaft};
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.2;
    padding: 0.375rem 0.75rem;
    text-align: center;
`;
const Value = styled.div `
    align-items: center;
    color: ${theme.fontColors.metallicBlue};
    display: flex;
    flex: 1 1 auto;
    font-size: 1.5rem;
    font-weight: bold;
    justify-content: center;
    line-height: 1.2;
    min-height: 2.75rem;
    padding: 0.75rem 0.5rem;
    text-align: center;
`;
const LabeledValueCard = (_a) => {
    var { label, value } = _a, rest = __rest(_a, ["label", "value"]);
    return (React.createElement(Card$1, Object.assign({}, rest),
        React.createElement(Label, null, label),
        React.createElement(Value, null, value)));
};

const StyledDropdown$8 = styled(Dropdown) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    &.suppress-carat .dropdown-toggle::after {
        display: none !important; 
    }
`;
const StyledMenu$2 = styled(Dropdown.Menu) `
    max-height: 275px;
    overflow-y: auto;
    .dropdown-item {
        cursor: pointer;
        padding: 5px;
        letter-spacing: inherit;
        &.active {
            font-weight: 900;
        }   
    }
`;
const DropdownInput = (_a) => {
    var { className, options, onSelect, value, disabled, title = '', variant = 'default', size = 'sm', align = 'start', inline = false, suppressCarat = false } = _a, rest = __rest(_a, ["className", "options", "onSelect", "value", "disabled", "title", "variant", "size", "align", "inline", "suppressCarat"]);
    const selectedValue = value && typeof value === 'object' ? value.name : value;
    const onOptionSelect = (option, e) => {
        if (!onSelect)
            return undefined;
        const selectedOption = options.find((x) => { var _a; return ((_a = x.name) === null || _a === void 0 ? void 0 : _a.toString()) === option.toString(); });
        return onSelect(selectedOption || option, option.toString(), e);
    };
    return (React.createElement(StyledDropdown$8, Object.assign({}, rest, { className: suppressCarat ? `${className} suppress-carat` : className, style: { display: inline ? 'inline' : '' }, onSelect: (option, e) => onOptionSelect(option, e), align: align }),
        React.createElement(Dropdown.Toggle, { variant: variant, size: size, disabled: disabled, style: { display: inline ? 'inline' : '' } }, selectedValue != null ? selectedValue : title),
        React.createElement(StyledMenu$2, { align: align }, options.map((option) => (React.createElement(Dropdown.Item, { active: selectedValue === option.name, key: (option.key || option.value || option.name), eventKey: option.name.toString(), href: option.href, as: option.href ? undefined : 'button', type: option.href ? undefined : 'button' }, option.name))))));
};

const buttonLabelSpacing = 5;
const StyledCheckboxRadioContainer = styled.div `
    position: relative;
    height: ${(props) => props.size}px;
    padding-${(props) => props.direction}: ${(props) => props.size + buttonLabelSpacing}px;
    margin-right: ${buttonLabelSpacing * 2}px;
    display: inline-block;
    label {
        line-height: ${(props) => props.size / 10.0};
        color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.doveGray : theme.fontColors.sanMarino)};
        padding-${(props) => props.direction}: ${(props) => buttonLabelSpacing + (props.size / 2.0)}px;
        margin-${(props) => props.direction}: -${(props) => buttonLabelSpacing + (props.size / 2.0)}px;
        user-select: none;
        white-space: nowrap;
        &:hover {
            cursor: ${(props) => (props.disabled ? '' : 'pointer')};
        }
        &:before, &:after {
            position: absolute;
        }
        &:before {
            content: '';
            ${(props) => props.direction}: 0;
            width: ${(props) => props.size}px;
            height: ${(props) => props.size}px;
            display: inline-block;
            border-radius: 100%;
            text-align: center;
            background: white;
            border: 1px solid ${theme.border.bombay};
            transition: all .1s ease-in-out;
        }
        &:after {
            content: '';
            display: inline-block;
            ${(props) => props.direction}: 0;
            transition: all .2s ease-in-out .1s;
        }
    }
    input[type="${(props) => props.buttonType}"] {
        opacity: 0;
        position: absolute;
        left: -9999px;
        &:checked + label:before {
            background-color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
            border-color: ${(props) => pSBC(-0.2, props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
        }
    }
`;
const BaseCheckboxRadioButton = (_a) => {
    var { id, size, type, onChange, label = '', labelDirection = 'right', onLabelClick } = _a, rest = __rest(_a, ["id", "size", "type", "onChange", "label", "labelDirection", "onLabelClick"]);
    return (React.createElement(StyledCheckboxRadioContainer, { className: "nyy-checkbox-radio-container", size: size, direction: labelDirection === 'left' ? 'right' : 'left', buttonType: type, disabled: rest.disabled },
        React.createElement("input", Object.assign({ type: type, id: id, onChange: onChange, readOnly: !onChange }, rest)),
        React.createElement("label", { onClick: onLabelClick, htmlFor: onLabelClick ? undefined : id }, label)));
};

const StyledCheckbox = styled(BaseCheckboxRadioButton) `
    + label:after {
        border-left: 2px solid transparent;
        border-bottom: 2px solid transparent;
        transform: rotate(-45deg);
        height: ${(props) => props.size * 0.3}px;
        width: ${(props) => props.size / 2.0}px;
        top: ${(props) => props.size * 0.3}px;
        margin: 0 ${(props) => props.size / 4.0}px;
    }
    &[type="checkbox"]:checked + label:after {
        border-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : 'white')};
    }
`;
const Checkbox = (_a) => {
    var { size = 20 } = _a, rest = __rest(_a, ["size"]);
    return (React.createElement(StyledCheckbox, Object.assign({ type: "checkbox", size: size }, rest)));
};

const StyledDropdown$7 = styled(Dropdown) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
`;
const StyledMenu$1 = styled(Dropdown.Menu) `
    min-width: 100% !important;
    max-height: 275px;
    overflow-y: auto;
    .dropdown-item {
        cursor: pointer;
        padding: 5px;
        letter-spacing: inherit;
        &.active {
            font-weight: 900;
        }   
    }
`;
const StyledFormCheck = styled(Form.Check) `
   > label {
        width: 100%;
        cursor: pointer;
   }
`;
const CheckboxDropdownInput = (_a) => {
    var { options, onChange, disabled, title = '', titleOverrideFormat = false, variant = 'default', size = 'sm', alignRight = false, inline = false, id } = _a, rest = __rest(_a, ["options", "onChange", "disabled", "title", "titleOverrideFormat", "variant", "size", "alignRight", "inline", "id"]);
    const { t: translate } = useTranslation();
    const alignProp = { sm: '' };
    if (alignRight)
        alignProp.sm = 'end';
    const updateCheckboxForm = (key) => (e) => {
        if (!onChange)
            return undefined;
        const selectedOption = options.find((x) => x.name === key);
        return onChange(selectedOption, key, e);
    };
    return (React.createElement(StyledDropdown$7, Object.assign({}, rest, { style: { display: inline ? 'inline' : '' } }),
        React.createElement(Dropdown.Toggle, { variant: variant, size: size, disabled: disabled, style: { display: inline ? 'inline' : '' } }, titleOverrideFormat ? title : `${translate('components.form.select')} ${title} ${translate('components.form.stats')}`),
        React.createElement(StyledMenu$1, { align: alignProp }, options.map((option) => (React.createElement(Form.Group, { className: "dropdown-item mb-0", style: { cursor: 'default' }, controlId: option.name.toString(), key: option.name },
            React.createElement(StyledFormCheck, { type: "checkbox", key: option.name, id: `${id ? `${id}_` : ''}checkbox_${option.name}`, name: `checkbox_${option.name}`, label: option.name, checked: option.checked, onChange: updateCheckboxForm(option.name.toString()) })))))));
};

const StyledDatePickerContainer = styled.div `
    position: relative;
    display: inline-block;
    > button {
        position: absolute;
        right: 5px;
        top: 8px;
        padding: 0;
        margin: 0;
        border: none;
        background-color: inherit;
    }
    .form-control {
        padding-right: ${(props) => (props.isFormControlSmall ? 28 : 8)}px;
    }
    .react-datepicker__today-button, .react-datepicker__header, .react-datepicker__day:hover {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.tundora : theme.background.gallery)};
    }
    .react-datepicker__month-container {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : 'white')};
    }
    .react-datepicker__current-month, .react-datepicker__day, .react-datepicker__day-name, .react-datepicker__today-button {
        color: ${(props) => (props.theme.isDarkMode ? theme.border.alto : theme.fontColors.mineShaft)};
    }
    .react-datepicker__day--selected, .react-datepicker__day--keyboard-selected {
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
        &:hover {
            background-color: ${pSBC(-0.25, theme.fontColors.dodgerBlue)};
        }
    }
    .react-datepicker__navigation--next {
        border-left-color: ${theme.fontColors.doveGray};
        &:hover {
            border-left-color: ${pSBC(-0.25, theme.fontColors.doveGray)};
        }
    }
    .react-datepicker__navigation--previous {
        border-right-color: ${theme.fontColors.doveGray};
        &:hover {
            border-right-color: ${pSBC(-0.25, theme.fontColors.doveGray)};
        }
    }
    .react-datepicker__time-container--with-today-button {
        right: -85px;
    }
    .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
        li.react-datepicker__time-list-item--selected {
            background-color: ${theme.fontColors.dodgerBlue};
        }
    }

    .react-datepicker__day--keyboard-selected,
    .react-datepicker__month-text--keyboard-selected,
    .react-datepicker__quarter-text--keyboard-selected,
    .react-datepicker__year-text--keyboard-selected {
        border-radius: inherit;
        background-color: #B6D3FE;
        color: inherit;
    }
    .react-datepicker__month--selected,
    .react-datepicker__month--in-selecting-range,
    .react-datepicker__month--in-range,
    .react-datepicker__quarter--selected,
    .react-datepicker__quarter--in-selecting-range,
    .react-datepicker__quarter--in-range {
        border-radius: 0.3rem;
        background-color: #B6D3FE;
        color: #fff;
    }
`;
const DatePicker = (_a) => {
    var { onSelect, value, placeholder, size = 'sm', alignRight = false } = _a, rest = __rest(_a, ["onSelect", "value", "placeholder", "size", "alignRight"]);
    const { t: translate } = useTranslation();
    const isFormControlSmall = size === 'sm';
    const selected = typeof value === 'string' ? new Date(value) : value;
    const ref = useRef(null);
    let isopen = false;
    const toggle = () => {
        var _a;
        isopen = !isopen;
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.setOpen(isopen);
    };
    return (React.createElement(StyledDatePickerContainer, { isFormControlSmall: isFormControlSmall },
        React.createElement(ReactDatePicker, Object.assign({ ref: ref, className: `form-control ${isFormControlSmall ? 'form-control-sm' : undefined}`, selected: selected, onChange: onSelect, placeholderText: placeholder, todayButton: translate('common.today'), popperPlacement: alignRight ? 'bottom-end' : 'bottom-start', dateFormat: "yyyy-MM-dd" }, rest)),
        React.createElement("button", { type: "button", onClick: () => toggle() },
            React.createElement(Icon, { icon: "calendar", color: theme.fontColors.dodgerBlue, size: isFormControlSmall ? '18px' : '24px' }))));
};

const checkedFillRatio = 0.5;
const StyledRadioButton = styled(BaseCheckboxRadioButton) `
    &&[type="radio"] {
        &:checked + label:before {
            border: 2px solid ${(props) => pSBC(-0.2, props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
            background-color: white;
        }
        &:checked + label:after {
            border-radius: 100%;
            background-color: ${(props) => pSBC(-0.2, props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
            height: ${(props) => props.size * checkedFillRatio}px;
            width: ${(props) => props.size * checkedFillRatio}px;
            top: ${(props) => props.size * (1 - checkedFillRatio) / 2.0}px;
            margin: 0 ${(props) => props.size * (1 - checkedFillRatio) / 2.0}px;
        }
    }
`;
const RadioButton = (_a) => {
    var { size = 20 } = _a, rest = __rest(_a, ["size"]);
    return (React.createElement(StyledRadioButton, Object.assign({ type: "radio", size: size }, rest)));
};

const StyledSliderContainer = styled.div `
    flex-grow: 1;
    padding-right: 8px;
    /**** inspired by nouislider.css ****/
    .nyySlider-target, .nyySlider-target * {
        -webkit-touch-callout: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        touch-action: none;
        user-select: none;
        box-sizing: border-box;
    }
    .nyySlider-target {
        position: relative;
    }
    .nyySlider-base, .nyySlider-connects {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
    }
    .nyySlider-connects {
        overflow: hidden;
        z-index: 0;
    }
    .nyySlider-connect, .nyySlider-origin {
        will-change: transform;
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        -webkit-transform-style: preserve-3d;
        transform-origin: 0 0;
        transform-style: flat;
    }
    .nyySlider-connect {
        height: 100%;
        width: 100%;
    }
    .nyySlider-origin {
        height: 10%;
        width: 10%;
    }
    //offet direction
    .nyySlider-txt-dir-rtl.nyySlider-horizontal .nyySlider-origin {
        left: 0;
        right: auto;
    }
    //Give origins 0 height/width so they don't interfere with clicking the connect elements.
    .nyySlider-horizontal .nyySlider-origin {
        height: 0;
    }
    .nyySlider-handle {
        backface-visibility: hidden;
        position: absolute;
    }
    .nyySlider-touch-area {
        height: 100%;
        width: 100%;
    }
    .nyySlider-state-tap {
        .nyySlider-connect, .nyySlider-origin {
            //transition: transform 0.3s;
        }
    }
    .nyySlider-state-drag * {
        cursor: inherit !important;
    }
    //Slider size and handle placement
    .nyySlider-horizontal {
        height: 18px;
        .nyySlider-handle {
            width: 28px;
            height: 28px;
            right: -17px;
            top: -5.5px;
        }
    }
    .nyySlider-txt-dir-rtl.nyySlider-horizontal .nyySlider-handle {
        left: -17px;
        right: auto;
    }
    //Styling
    //Giving the connect element a border radius causes issues with using transform: scale
    .nyySlider-target, .nyySlider-connects {
        border-radius: 10px;
    }
    .nyySlider-target {
        background: #FFFFFF;
        //border: 1px solid #D3D3D3;
        //box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;
    }
    .nyySlider-connect {
        background: ${theme.background.cerulean};
    }
    //Handles and cursors
    .nyySlider-draggable {
        cursor: ew-resize;
    }
    .nyySlider-handle {
        border: 2px solid #7b7b7b;
        border-radius: 100%;
        background: ${theme.border.alto};
        cursor: default;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    }
    .nyySlider-handle, .nyySlider-touch-area {
        &:focus {
            outline: none;
        }
    }
    .nyySlider-active {
        box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
    }
    //Horizontal layout
    .nyySlider-pips-horizontal {
        padding: 10px 0;
        height: 80px;
        top: 100%;
        left: 0;
        width: 100%;
    }
    .nyySlider-value-horizontal {
        transform: translate(-50%, 50%);
    }
    .nyySlider-rtl .nyySlider-value-horizontal {
        transform: translate(50%, 50%);
    }
    .nyySlider-marker-horizontal {
        &.nyySlider-marker {
            margin-left: -1px;
            width: 2px;
            height: 5px;
        }
        &.nyySlider-marker-sub {
            height: 10px;
        }
        &.nyySlider-marker-large {
            height: 15px;
        }
    }
`;
class ProgressSlider extends Component {
    constructor(props) {
        super(props);
        this.slider = null;
        this.sliderContainer = createRef();
        this.onSliderInput = this.onSliderInput.bind(this);
    }
    componentDidMount() {
        this.slider = noUiSlider.create(this.sliderContainer.current, {
            start: 0,
            connect: 'lower',
            cssPrefix: 'nyySlider-',
            range: {
                min: 0,
                max: 100,
            },
        });
        this.slider.on('slide', this.onSliderInput);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.props.value || nextProps.max !== this.props.max;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.slider) {
            this.slider.set(this.props.value / (this.props.max || 1) * 100.0);
        }
    }
    onSliderInput(_val, _handle, rawValues) {
        const [unencodedSliderVal] = rawValues;
        this.props.onChange(unencodedSliderVal * this.props.max / 100.0);
    }
    render() {
        return (React.createElement(StyledSliderContainer, null,
            React.createElement("div", { ref: this.sliderContainer })));
    }
}
ProgressSlider.defaultProps = {
    max: 100,
    value: 0,
};

const StyledSliderRangeInput = styled(StyledSliderContainer) `
    flex-grow: 1;
    padding: 5px 10px 5px 3px;
    min-width: 150px;
    .nyySlider-target {
        background: ${styles.theme.background.geyser};
        ${({ $disabled }) => ($disabled ? `
            opacity: 0.6;
            pointer-events: none;
        ` : '')}
    }
    .nyySlider-handle {
        ${({ $disabled }) => ($disabled ? `
            border-radius: 0%;
            width: auto !important;
            padding: 0 2px;
            background-color: white;
            border: 1px solid #0077d9;
            color: #0077d9;
            opacity: 0.8;
        ` : '')}
    }
`;
const StyledSliderRangeInputContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    .form-control {
        max-width: 72px;
        &:first-child {
            margin-right: 10px;
        }
        &:last-child {
            margin-left: 10px;
        }
    }
`;
class BaseSliderRange extends Component {
    constructor(props) {
        super(props);
        this.slider = null;
        this.sliderContainer = createRef();
        this.onSliderChange = this.onSliderChange.bind(this);
    }
    componentDidMount() {
        const _a = this.props.config, { range } = _a, rest = __rest(_a, ["range"]);
        this.slider = noUiSlider.create(this.sliderContainer.current, Object.assign({ cssPrefix: 'nyySlider-', step: this.props.step, margin: this.props.margin, range: range || { min: this.props.min, max: this.props.max } }, rest));
        this.slider.on('change', this.onSliderChange);
        this.slider.on('update', (_value, _handle, rawValues) => {
            if (this.props.onChangingValue) {
                this.props.onChangingValue(rawValues.length > 1 ? rawValues : rawValues[0]);
            }
        });
        this.slider.on('start', () => {
            if (this.props.onChanging) {
                this.props.onChanging(true);
            }
        });
        this.slider.on('end', () => {
            if (this.props.onChanging) {
                this.props.onChanging(false);
            }
        });
    }
    componentDidUpdate(prevProps) {
        var _a;
        if (this.props.value !== undefined && prevProps.value !== this.props.value) {
            (_a = this.slider) === null || _a === void 0 ? void 0 : _a.set(this.props.value);
        }
    }
    onSliderChange(_val, _handle, rawValues) {
        this.props.onChange(rawValues.length > 1 ? rawValues : rawValues[0]);
    }
    render() {
        return (React.createElement(StyledSliderRangeInput, { "$disabled": !!this.props.disabled },
            React.createElement("div", { ref: this.sliderContainer })));
    }
}
BaseSliderRange.defaultProps = {
    min: 0,
    max: 100,
    step: 1,
    margin: 1,
};

const Slider = (_a) => {
    var { onChange, value, min = 0, max = 100, connect = 'lower', disabled = false, showInput = true, inputDirection = 'left' } = _a, rest = __rest(_a, ["onChange", "value", "min", "max", "connect", "disabled", "showInput", "inputDirection"]);
    const val = value !== undefined ? value : min;
    const config = Object.assign({ start: val, connect }, rest);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipValue, setTooltipValue] = useState(0);
    const onSliderMoving = (moving) => setShowTooltip(moving);
    const onSliderMovingValue = (movingValue) => setTooltipValue(movingValue);
    const tooltipOverrideValue = showTooltip ? tooltipValue : null;
    const onSliderInputChange = ({ currentTarget }) => onChange(currentTarget.value ? Number(currentTarget.value) : min);
    const sliderInput = (React.createElement(FormControl, { value: tooltipOverrideValue || val, onChange: onSliderInputChange, type: "number", min: min, max: max, size: "sm" }));
    const onSlideValueChange = (slideVal) => onChange(Array.isArray(slideVal) ? slideVal[0] : slideVal);
    return (React.createElement(StyledSliderRangeInputContainer, null,
        showInput && inputDirection !== 'right' && sliderInput,
        React.createElement(BaseSliderRange, { onChange: onSlideValueChange, min: min, max: max, value: value, disabled: disabled, config: config, onChanging: onSliderMoving, onChangingValue: onSliderMovingValue }),
        showInput && inputDirection === 'right' && sliderInput));
};

const Range = (_a) => {
    var { onChange, value, min = 0, max = 100, connect = true, disabled = false, showInput = true, step, margin } = _a, rest = __rest(_a, ["onChange", "value", "min", "max", "connect", "disabled", "showInput", "step", "margin"]);
    const [minVal, maxVal] = value || [min, max];
    const config = Object.assign({ start: [minVal, maxVal], connect }, rest);
    const [showMovingValue, setShowMovingValue] = useState(false);
    const [movingValue, setMovingValue] = useState([0, 0]);
    const onSliderMoving = (moving) => setShowMovingValue(moving);
    const onSliderMovingValue = (mvl) => setMovingValue(mvl);
    const onMinValChange = ({ currentTarget }) => onChange([
        currentTarget.value ? Number(currentTarget.value) : minVal, maxVal,
    ]);
    const onMaxValChange = ({ currentTarget }) => onChange([
        minVal, currentTarget.value ? Number(currentTarget.value) : maxVal,
    ]);
    const onRangeValueChange = (val) => onChange(Array.isArray(val) ? val : [val]);
    const minOverride = showMovingValue ? movingValue[0] : null;
    const maxOverride = showMovingValue ? movingValue[1] : null;
    return (React.createElement(StyledSliderRangeInputContainer, null,
        showInput && (React.createElement(FormControl, { value: minOverride !== null && minOverride !== void 0 ? minOverride : minVal, onChange: onMinValChange, type: "number", min: min, max: maxVal, size: "sm" })),
        React.createElement(BaseSliderRange, { onChange: onRangeValueChange, min: min, max: max, value: value, disabled: disabled, config: config, step: step, margin: margin, onChanging: onSliderMoving, onChangingValue: onSliderMovingValue }),
        showInput && (React.createElement(FormControl, { value: maxOverride !== null && maxOverride !== void 0 ? maxOverride : maxVal, onChange: onMaxValChange, type: "number", min: minVal, max: max, size: "sm" }))));
};

const defaultConfig = {
    versionCheck: false,
    toolbar: [
        ['PasteText', 'PasteFromWord'],
        ['Image', 'Flash'],
        ['Bold', 'Italic', 'Underline', 'TextColor', 'RemoveFormat'],
        ['Table', 'NumberedList', 'BulletedList', 'Indent', 'Outdent', 'Link'],
        ['Format', 'Font', 'FontSize'],
    ],
};
const CKEditorInput = (_a) => {
    var { onChange, onBlur, config = defaultConfig } = _a, rest = __rest(_a, ["onChange", "onBlur", "config"]);
    const onBeforeExec = (event) => {
        // Show the paste dialog for the paste buttons and right-click paste
        if (event.data.name === 'paste') {
            event.editor._.forcePasteDialog = true;
        }
        // Don't show the paste dialog for Ctrl+Shift+V
        if (event.data.name === 'pastetext' && event.data.commandData.from === 'keystrokeHandler') {
            event.cancel();
        }
    };
    return (React.createElement(CKEditor, Object.assign({ config: config, onBeforeCommandExec: onBeforeExec, onChange: onChange ? ({ editor }) => onChange(editor.getData()) : undefined, onBlur: onBlur ? ({ editor }) => onBlur(editor.getData()) : undefined }, rest)));
};

const StyledContainer$1 = styled.div `
    text-align: center;
    display: flex;
    flex-direction: ${({ $vertical }) => ($vertical ? 'column' : 'row')}
`;
const StyledLabelContainer = styled.div `
    height: 34px;
    line-height: 34px;
    padding: ${({ $vertical }) => ($vertical ? '0' : '0 5px')};
    margin-bottom: ${({ $vertical }) => ($vertical ? '5px' : '0')};
`;
const StyledLabel$3 = styled.label `
    font-size: 13px;
    font-weight: bold;
    margin-bottom: ${({ $vertical }) => ($vertical ? '0' : '0.5em')};
`;
const StyledToggleContainer = styled.label `
    position: relative;
    display: inline-block;
    height: ${({ $vertical }) => ($vertical ? '60px' : '34px')};
    width: ${({ $vertical }) => ($vertical ? '34px' : '60px')};
`;
const StyledInput = styled.input `
    opacity: 0;
    width: 0;
    height: 0;
    &:checked + .toggle {
        background-color: #2877D9;
    }
    &:focus + .toggle {
        box-shadow: 0 0 1px #2877D9;
    }
    &:checked + .toggle:before {
        -webkit-transform: ${({ $vertical }) => ($vertical ? 'translateY(-26px)' : 'translateX(26px)')};
        -ms-transform: ${({ $vertical }) => ($vertical ? 'translateY(-26px)' : 'translateX(26px)')};
        transform: ${({ $vertical }) => ($vertical ? 'translateY(-26px)' : 'translateX(26px)')};
    }
    
`;
const StyledSpan = styled.span `
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    &:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
    }
`;
const Switch = ({ checked, onChange, onClick, vertical = false, onLabel = 'On', offLabel = 'Off' }) => {
    const { t: translate } = useTranslation();
    const labelOnUse = onLabel === 'On' ? translate('components.form.on') : onLabel;
    const labelOffUse = offLabel === 'Off' ? translate('components.form.off') : offLabel;
    return (React.createElement(StyledContainer$1, { "$vertical": vertical },
        React.createElement(StyledLabelContainer, { "$vertical": vertical },
            React.createElement(StyledLabel$3, { "$vertical": vertical }, vertical ? labelOnUse : labelOffUse)),
        React.createElement("div", null,
            React.createElement(StyledToggleContainer, { "$vertical": vertical },
                React.createElement(StyledInput, { type: "checkbox", checked: checked, "$vertical": vertical, onChange: onChange, onClick: onClick }),
                React.createElement(StyledSpan, { className: "toggle" }))),
        React.createElement(StyledLabelContainer, { "$vertical": vertical },
            React.createElement(StyledLabel$3, { "$vertical": vertical }, vertical ? labelOffUse : labelOnUse))));
};

const StyledContainer = styled.div `
    justify-content: space-between;
    > div {
        flex-grow: 1;
        display: flex;
        align-items: center;
        > span {
            flex: 0;
        }
    }
    input {
        max-width: 200px;
    }
      
    input[type="number"] {
        max-width: 75px;
    }
    .dropdown > .btn {
        width: 100%;
        min-width: 75px;
    }
`;
const FormInputContainer = ({ label, children, className }) => (React.createElement(StyledContainer, { className: `${className} d-flex align-items-center` },
    React.createElement("span", { className: "me-1" }, label),
    React.createElement("div", null, children)));

const ALL_VALUE$2 = -1;
const ALL_ATTACK_VALUE$2 = -2;
const ALL_2K_VALUE$2 = -3;
const TIMING_LATE = 0;
const TIMING_ONTIME = 1;
const TIMING_EARLY = 2;
const COUNTS$2 = [
    { id: 0, name: '0-0', balls: 0, strikes: 0 },
    { id: 1, name: '1-0', balls: 1, strikes: 0 },
    { id: 2, name: '2-0', balls: 2, strikes: 0 },
    { id: 3, name: '3-0', balls: 3, strikes: 0 },
    { id: 4, name: '0-1', balls: 0, strikes: 1 },
    { id: 5, name: '1-1', balls: 1, strikes: 1 },
    { id: 6, name: '2-1', balls: 2, strikes: 1 },
    { id: 7, name: '3-1', balls: 3, strikes: 1 },
    { id: 8, name: '0-2', balls: 0, strikes: 2 },
    { id: 9, name: '1-2', balls: 1, strikes: 2 },
    { id: 10, name: '2-2', balls: 2, strikes: 2 },
    { id: 11, name: '3-2', balls: 3, strikes: 2 },
];

const StyledToggleButtons$d = styled(ToggleButtons) `
    display: inline-grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    .btn {
        width: ${(props) => props.$width}px;

        ${(props) => (props.$hasAll ? `&:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${props.$numRows} / span ${props.$numRows};
        }` : '')}
    }
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const CountSelect = ({ className, setCounts, counts }) => {
    const { t: translate } = useTranslation();
    const setFilterWithAll = (e) => {
        let newVal = [];
        if (!e.length || (e.includes(ALL_VALUE$2) && !(counts === null || counts === void 0 ? void 0 : counts.includes(ALL_VALUE$2)))) {
            newVal = [ALL_VALUE$2];
        }
        else if (!e.length || (e.includes(ALL_ATTACK_VALUE$2) && !(counts === null || counts === void 0 ? void 0 : counts.includes(ALL_ATTACK_VALUE$2)))) {
            newVal = [ALL_ATTACK_VALUE$2];
        }
        else if (!e.length || (e.includes(ALL_2K_VALUE$2) && !(counts === null || counts === void 0 ? void 0 : counts.includes(ALL_2K_VALUE$2)))) {
            newVal = [ALL_2K_VALUE$2];
        }
        else {
            newVal = e.filter((x) => x !== ALL_VALUE$2 && x !== ALL_ATTACK_VALUE$2 && x !== ALL_2K_VALUE$2);
        }
        setCounts(newVal);
    };
    return (React.createElement("div", { className: `d-flex ${className}` },
        React.createElement(StyledToggleButtons$d, { type: "checkbox", name: "count", options: [{ name: translate('common.all'), value: ALL_VALUE$2 }].concat(COUNTS$2.map((ct) => ({ name: ct.name, value: ct.id }))), separated: true, "$width": 42, "$numCols": 5, "$numRows": 3, "$hasAll": true, value: counts, onChange: (e) => setFilterWithAll(e) }),
        React.createElement(StyledToggleButtons$d, { type: "checkbox", name: "count", options: [
                { name: translate('components.hitmon.all-attack'), value: ALL_ATTACK_VALUE$2 },
                { name: translate('components.hitmon.all-2k'), value: ALL_2K_VALUE$2 },
            ], separated: true, "$width": 80, "$numRows": 2, "$numCols": 1, value: counts, onChange: (e) => setFilterWithAll(e) })));
};

const StyledDropdown$6 = styled(Dropdown$1) `
    .dropdown-toggle.form-control {
        width: 100%;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' 
            viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' 
            stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right .75rem center;
        background-size: 16px 12px;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 24px !important;
        display: block;
        text-align: left;
        color: #212529 !important;

        ::after {
            display: none !important;
        }
        min-height: 35px !important;
        cursor: pointer;
    }

    .dropdown-toggle::after {
        display: none !important;
    }
`;
const StyledDropdownMenu = styled(Dropdown$1.Menu) `
    max-height: 24rem;
    overflow: auto;
    min-width: ${(props) => props.$minWidth || '20rem'} !important;
    width: 100%;
`;
const StyledOption = styled.div `
    display: flex;
    align-items: center;
    padding: 0.375rem 0.5rem;
    cursor: pointer;
    user-select: none;

    &:hover {
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
    }

    .form-check {
        min-height: unset;
        margin-bottom: 0 !important;

        .form-check-input {
            margin-top: 0 !important;
        }
    }
`;
const StyledLoadMore = styled.div `
    cursor: pointer;
    text-align: center;
    color: ${theme.fontColors.doveGray};
    font-size: 0.75rem;
    padding: 0.5rem 0.25rem;

    &:hover {
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
    }
`;
const StyleOptionName = styled.div `
    ${(props) => (props.$canExclusiveSelect ? `
        &:hover {
            text-decoration: underline;
        }
    ` : '')}
`;
const PAGE_ITEM_COUNT = 100;
const MultiSelect = ({ className, style, children, options, value, setValue, allowSearch, allowLoadMore, displayFormClass, canExclusiveSelect, overrideDisplayValue, emptyValue = 'All', $minWidth, disabled, }) => {
    const { t: translate } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [pages, setPages] = useState(1);
    const containerRef = useRef();
    const onOptionClick = (v) => {
        if (value.includes(v)) {
            setValue(value.filter((x) => x !== v));
        }
        else {
            setValue([...value, v]);
        }
    };
    const onToggle = (newIsOpen) => {
        setIsOpen(newIsOpen);
        if (newIsOpen) {
            setSearchValue('');
            setPages(1);
            if (allowSearch) {
                setTimeout(() => {
                    var _a, _b;
                    (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('search')[0]) === null || _b === void 0 ? void 0 : _b.focus();
                }, 0);
            }
        }
    };
    const onNameClick = (e, option) => {
        if (canExclusiveSelect) {
            e.stopPropagation();
            setValue([option.value]);
        }
    };
    const filteredOptions = searchValue.trim() ? options.filter((o) => { var _a; return (_a = o.filterValue) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue.trim().toLowerCase()); }) : options;
    const selectedOptions = options.filter((o) => value.includes(o.value));
    const displayValue = overrideDisplayValue || (selectedOptions.length === options.length ? translate('common.all') : (selectedOptions.map((o) => (typeof o.name === 'object' ? (o.name.props.children.filter((c) => typeof c === 'string').join(' ')) : o.name)).join(', ') || emptyValue));
    return (React.createElement(StyledDropdown$6, { className: className, style: style, onToggle: onToggle, ref: containerRef },
        React.createElement(Dropdown$1.Toggle, { as: "span" }, children
            || (React.createElement(Form$1.Control, { size: "sm", className: `${displayFormClass} dropdown-toggle ${disabled ? '' : 'bg-white'}`, value: displayValue, readOnly: true, disabled: disabled }))),
        isOpen && (React.createElement(StyledDropdownMenu, { "$minWidth": $minWidth, className: `${allowSearch ? 'pt-0' : ''} ${allowLoadMore ? 'pb-0' : ''}` },
            allowSearch && (React.createElement("div", { className: "px-2 pt-2 pb-1 sticky-top bg-white" },
                React.createElement(Form$1.Control, { className: "search", size: "sm", value: searchValue, onChange: (e) => setSearchValue(e.target.value), placeholder: translate('common.search') }))),
            filteredOptions.slice(0, allowLoadMore ? pages * PAGE_ITEM_COUNT : filteredOptions.length).map((o) => (React.createElement(StyledOption, { className: "multi-select-option", onClick: () => onOptionClick(o.value), key: o.value },
                React.createElement(Form$1.Check, { className: "me-2 form-check", checked: value.includes(o.value), readOnly: true }),
                React.createElement("div", null,
                    React.createElement(StyleOptionName, { "$canExclusiveSelect": canExclusiveSelect, onClick: (e) => onNameClick(e, o) }, o.name),
                    o.description && React.createElement("small", { className: "text-muted", style: { whiteSpace: 'break-spaces' } }, o.description))))),
            allowLoadMore && pages * PAGE_ITEM_COUNT < filteredOptions.length && (React.createElement(StyledLoadMore, { onClick: () => setPages((p) => p + 1) }, translate('common.load-more')))))));
};

const StyledCheckboxSelect = styled.div `
    .value-label:hover {
        text-decoration: underline;
        cursor: pointer;
    }
    .nyy-checkbox-radio-container {
        margin-right: 0;
        label::before {
            top: 0;
        }
    }
`;
function CheckboxSelect({ id, className, title, options, value, setValue }) {
    const { t: translate } = useTranslation();
    const onCheckboxClick = (v) => {
        if (value.includes(v))
            setValue(value.filter((x) => x !== v));
        else
            setValue([...value, v]);
    };
    return (React.createElement(StyledCheckboxSelect, { className: `d-flex align-items-center ${className}` },
        title,
        " (",
        React.createElement("div", { className: "value-label", onClick: () => setValue(options.map((o) => o.value)) }, translate('common.all')),
        "):\u00A0",
        options.map((o) => (React.createElement("div", { key: o.value, className: "d-flex align-items-center me-2" },
            React.createElement(Checkbox, { checked: value.includes(o.value), onChange: () => onCheckboxClick(o.value), id: `${id !== null && id !== void 0 ? id : 'checkbox-select'}-${o.value.toString()}`, name: o.value.toString(), size: 14 }),
            React.createElement("div", { className: "value-label", onClick: () => setValue([o.value]) }, o.name))))));
}

const StyledToggle = styled(BootstrapButton) `
  &&&& {
    width: ${(props) => props.$isSubMenu && '100%'};
    font-size: ${(props) => !props.$isSubMenu && '1.2em;'};
    padding: ${(props) => (props.$isSubMenu ? '10px 20px' : '.25rem .5rem')};
    text-align: ${(props) => props.$isSubMenu && 'left'};
    font-size: ${(props) => props.$isSubMenu && '0.8em'};
    border-radius: ${(props) => props.$showBorder && '5px'};
    border: ${(props) => (props.$showBorder ? `2px solid ${theme.fontColors.anakiwa}` : 'none')};
    border-bottom: ${(props) => props.$isSubMenu && `0.5px solid ${theme.fontColors.dodgerBlue}`};
    background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
    color: ${(props) => (props.$isSubMenu ? 'white' : theme.fontColors.anakiwa)};
    box-shadow: none;
    &:hover {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
        cursor: ${(props) => props.$isSubMenu && 'pointer'};
    }
    &:focus {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
    }
    &:active {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
    }
    &:after {
        color: ${theme.fontColors.anakiwa};
        content: ${(props) => (!props.$showIcon ? '' : (props.$customIcon && 'none'))};
    }
  }
`;
const StyledDropdown$5 = styled.div `
    && {
        border-radius: 0px;
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
        width: 250px;
        padding: 5px;
        padding-bottom: 10px;
        left: ${(props) => (props.$alignRight ? '-20px' : undefined)};
    };
    border: ${(props) => props.theme.isDarkMode && `1px solid ${theme.background.astronaut}`};
}`;
const DropdownMenu = ({ children, label, customIcon, showBorder = false, alignRight = false, isSubMenu = false, showIcon = true, popperConfig = {}, disabled = false, drop, show, onToggle }) => (React.createElement(Dropdown, { drop: drop, show: show, onToggle: onToggle },
    React.createElement(Dropdown.Toggle, { as: StyledToggle, "$showBorder": showBorder, "$showIcon": showIcon, "$customIcon": customIcon, "$isSubMenu": isSubMenu, disabled: disabled },
        label && React.createElement("span", null, label),
        showIcon && customIcon && React.createElement(Icon, { icon: customIcon, size: "1.5em" })),
    React.createElement(Dropdown.Menu, { className: isSubMenu ? 'sub-menu' : '', as: StyledDropdown$5, "$alignRight": alignRight, "$isSubMenu": isSubMenu, popperConfig: popperConfig }, children)));

const StyledNavMenuItem = styled(Dropdown.Item) `&&{
    font-size: 0.8em;
    color: white;
    cursor: auto;
    padding: ${(props) => (props.featured ? '10px 20px' : '5px 20px')};
    border-bottom: ${(props) => props.featured && `0.5px solid ${theme.fontColors.dodgerBlue}`};
    &:hover {
        cursor: pointer;
        color: white;
        background-color: ${theme.fontColors.dodgerBlue};
    }
}`;
const StyledLabel$2 = styled.span `
{
    ${(props) => props.$hasIcon && 'margin-left: 20px'};
}`;
const ExternalLinkIcon = styled.span `
    margin-left: 0.45em;
    .nyy-icon {
        vertical-align: -0.1em;
    }
`;
const isExternalHref = (href) => /^https?:\/\//i.test(href);
const NavMenuItem = ({ label, icon, href, featured = false }) => {
    const isExternal = isExternalHref(href);
    return (React.createElement(StyledNavMenuItem, { featured: featured, href: href, target: isExternal ? '_blank' : undefined, rel: isExternal ? 'noopener noreferrer' : undefined },
        icon && React.createElement(Icon, { icon: icon }),
        label && (React.createElement(StyledLabel$2, { "$hasIcon": !!icon },
            label,
            isExternal && (React.createElement(ExternalLinkIcon, { title: "Opens in a new window" },
                React.createElement(Icon, { icon: "nyy-new-window", size: "0.85em", color: "currentColor" })))))));
};

const emitEvent = (messageType, messageData = {}) => {
    const event = new CustomEvent('action-menu-item', { detail: Object.assign({ messageType }, messageData) });
    window.dispatchEvent(event);
};

const StyledActionMenuItem = styled(Dropdown.Item) `&&{
    font-size: 0.8em;
    color: white;
    cursor: auto;
    &:hover {
        color: white;
        cursor: pointer;
        background-color: ${(props) => (props.href ? theme.fontColors.dodgerBlue : theme.background.astronaut)};
    }
    padding: 10px 20px;
    border-bottom: 0.5px solid ${theme.fontColors.dodgerBlue};
    &:last-child {
        border-bottom: none;
    }
}`;
const ActionMenuItem = (_a) => {
    var { label, icon, href, actionType, onClick } = _a, rest = __rest(_a, ["label", "icon", "href", "actionType", "onClick"]);
    return (React.createElement(StyledActionMenuItem, Object.assign({ href: href, onClick: () => (onClick ? onClick() : emitEvent(actionType)) }, rest),
        icon && React.createElement(Icon, { icon: icon }),
        label && React.createElement("span", null, label)));
};

const StyledMenuItem$1 = styled(Dropdown.Item) `&&{
    font-size: 0.8em;
    color: white;
    padding: 5px 20px;
    cursor: auto;
    &:hover {
        color: white;
        background-color: ${(props) => (props.href ? theme.fontColors.dodgerBlue : theme.background.astronaut)};
    }
}`;
const BaseMenuItem = ({ label, icon }) => (React.createElement(StyledMenuItem$1, null,
    icon && React.createElement(Icon, { icon: icon }),
    label && React.createElement("span", null, label)));

const BaseModal = styled(Modal) `&&
    .modal-header {
        background-color: ${theme.background.astronaut};
        color: white;
        justify-content: space-around;
        font-size: 18px;
    }
    .list-group-flush {
        margin: 10px 0px 10px 0px;
    }
    .list-group-item {
        :hover {
            cursor: pointer;
        }
        //values from bootstrap that for whatever reason aren't being applied
        &.list-group-item-dark {
            color: #1b1e21;
            background-color: #c6c8ca;
            &.list-group-item-action {
                &:focus, &:hover {
                    color: #1b1e21;
                    background-color: #b9bbbe; 
                }
            }
        }
        &.list-group-item-action {
            width: unset;
            border-color: darkgray;
            border-width: 1px;
            border-radius: 5px;
            margin: 2px 12px;
            font-weight: bold;
        }
    }
`;

const StyledModal$1 = styled(BaseModal) `
    && .modal-body {
        padding: 0;
        background-color: lightgray;
    }
    .list-group-item {
        // padding: 7.5px 15px;
        &:last-child {
            border-bottom-right-radius: inherit;
            border-bottom-left-radius: inherit;
        }
    }
`;
function SelectListModal(_a) {
    var { title, options, onHide, label } = _a, rest = __rest(_a, ["title", "options", "onHide", "label"]);
    const themeContext = useContext(ThemeContext);
    const variant = (themeContext === null || themeContext === void 0 ? void 0 : themeContext.isDarkMode) ? 'dark' : undefined;
    const onSelect = (selectedValue) => onHide(selectedValue);
    return (React.createElement(StyledModal$1, Object.assign({ onHide: () => onSelect(), size: "sm" }, rest),
        React.createElement(StyledModal$1.Header, null, title),
        React.createElement(StyledModal$1.Body, null,
            React.createElement(ListGroup, { variant: "flush" }, options.map((opt, idx) => {
                let labelVal;
                if (typeof label === 'function')
                    labelVal = label(opt);
                else if (typeof label === 'string')
                    labelVal = get$2(opt, label);
                else
                    labelVal = opt.toString();
                return (React.createElement(ListGroup.Item, { action: true, key: idx, variant: variant, onClick: () => onSelect(opt) }, labelVal));
            })))));
}

const StyledDialogModal = styled(BaseModal) `
    font-size: 1.15em;
    .modal-body > p {
        text-align: center;
        margin-bottom: 0;
        white-space: pre-wrap;
    }
    .col-form-label {
        font-weight: bold;
        font-size: .75rem !important;
    }
`;
const StyledDefaultButtonAlt = styled(DefaultButtonAlt) `
    min-width: 60px;
    font-weight: bold;
    padding: 4px 10px;
`;
const StyledButton = styled(Button) `
    min-width: 60px;
    font-weight: bold;
    padding: 4px 10px;
`;
const BaseDialogModal = (_a) => {
    var { children, onHide, onResolve, canResolve = true, onReject, canReject = true, resolveTxt, closeTxt, rejectTxt, size = 'sm', headerTxt } = _a, rest = __rest(_a, ["children", "onHide", "onResolve", "canResolve", "onReject", "canReject", "resolveTxt", "closeTxt", "rejectTxt", "size", "headerTxt"]);
    return (React.createElement(StyledDialogModal, Object.assign({ onHide: onHide, size: size }, rest),
        headerTxt && React.createElement(StyledDialogModal.Header, null, headerTxt),
        React.createElement(StyledDialogModal.Body, null, children),
        React.createElement(StyledDialogModal.Footer, null,
            closeTxt && React.createElement(StyledDefaultButtonAlt, { onClick: onHide }, closeTxt),
            !!rejectTxt && !!onReject && React.createElement(StyledButton, { variant: "danger", onClick: onReject, disabled: !canReject }, rejectTxt),
            !!resolveTxt && !!onResolve && React.createElement(StyledButton, { variant: "primary", onClick: onResolve, disabled: !canResolve }, resolveTxt))));
};

const ConfirmModal = (_a) => {
    var { message, onConfirm, confirmTxt = '', cancelTxt = '' } = _a, rest = __rest(_a, ["message", "onConfirm", "confirmTxt", "cancelTxt"]);
    const { t: translate } = useTranslation();
    const confirmTxtUse = confirmTxt === '' ? translate('common.ok') : confirmTxt;
    const cancelTxtUse = cancelTxt === '' ? translate('common.cancel') : cancelTxt;
    return (React.createElement(BaseDialogModal, Object.assign({ resolveTxt: confirmTxtUse, closeTxt: cancelTxtUse, onResolve: onConfirm }, rest),
        React.createElement("p", null, message)));
};

const CheckRoles = ({ children, checkRoles = () => false, checkUserName = () => false, roles = [], excludedRoles = [], allRoles = [], userNames = [], }) => {
    let roleList = new Array();
    if (Array.isArray(roles))
        roleList = roles;
    else if (roles)
        roleList = [roles];
    if (excludedRoles.length && checkRoles(excludedRoles)) {
        return null;
    }
    if (allRoles.length && !checkRoles(allRoles, true)) {
        return null;
    }
    if ((roleList.length && !checkRoles(roleList)) && (!userNames.length || !checkUserName(userNames))) {
        return null;
    }
    return React.createElement(React.Fragment, null, children);
};

/// <reference types="styled-components/cssprop" />
const screenOnlyStyle = css `
    @media print {
        display: none;
        visibility: hidden;
        position: absolute;
        top: -1000px;
    }
`;
const ScreenOnly = ({ children }) => (
// eslint-disable-next-line react/no-unknown-property
React.createElement("span", { css: screenOnlyStyle }, children));

const checkRoles = (roles, input, requireAllRoles = false) => {
    const inputRolesArr = Array.isArray(input) ? input : [input];
    const userHasRole = (r) => roles.includes(r);
    return requireAllRoles ? inputRolesArr.every(userHasRole) : inputRolesArr.some(userHasRole);
};
const checkUserName = (userName, input) => {
    const inputNamesArr = Array.isArray(input) ? new Set(input) : new Set([input]);
    return inputNamesArr.has(userName);
};

const StyledNote = styled.div `
    ${({ $canEditNote }) => ($canEditNote ? `
        &:hover {
            cursor: pointer;
            background-color: #FFFF77;
        }
    ` : '')}
    && {
        p, ul {
            margin: 0.25em 0;
        }
        > ul {
            padding-left: 20px;
        }
    }
`;
const StyledNoteInfo = styled.div `
    text-align: right;
    border-top: 1px solid ${styles.theme.border.alto};
    color: ${styles.theme.fontColors.silverChalice};
    font-style: italic;
    padding-right: 10px;
    font-size: 0.8em;
    white-space: nowrap;
    ${({ $printInfo }) => (!$printInfo ? screenOnlyStyle : '')}
`;
const ReportNote = ({ note, initValue, onNoteClick, isLoading = false, readOnly = true, showInfo = true, showSpanish = false, printInfo = false }) => {
    var _a;
    const { t: translate } = useTranslation();
    const isNoteDefined = !!(note === null || note === void 0 ? void 0 : note.NoteID);
    const isSpanish = isNoteDefined && showSpanish && ((_a = note.Type) === null || _a === void 0 ? void 0 : _a.HasSpanish) && !!note.EsNote;
    const canEditNote = !readOnly && !!(note === null || note === void 0 ? void 0 : note.CanEdit);
    let noteHTML = initValue ? `<span>${initValue}</span>` : undefined;
    if (isNoteDefined)
        noteHTML = isSpanish ? note.EsNote : note.Note;
    else if (!noteHTML && canEditNote)
        noteHTML = `<span>${translate('components.report.add-note')}...</span>`;
    return (React.createElement("div", null,
        isLoading && React.createElement(LoadingSpinner, null),
        note && (React.createElement("div", null,
            noteHTML && (React.createElement(StyledNote, { "$canEditNote": canEditNote, onClick: canEditNote ? onNoteClick : undefined, dangerouslySetInnerHTML: { __html: noteHTML } })),
            (showInfo || printInfo) && isNoteDefined && !!note.User && (React.createElement(StyledNoteInfo, { "$printInfo": printInfo },
                !isSpanish && (React.createElement(React.Fragment, null,
                    translate('components.report.last-updated'),
                    ":\u00A0",
                    dateTimeTranslate(translate, note.LastUpdateDate),
                    "\u00A0 (",
                    note.User.LastName,
                    ",\u00A0",
                    note.User.FirstName.substring(0, 2),
                    ")")),
                isSpanish && (React.createElement(React.Fragment, null,
                    translate('components.report.last-updated'),
                    ":\u00A0",
                    dateTimeTranslate(translate, note.EsLastUpdateDate, true),
                    "\u00A0(",
                    note.EsLastUpdateUserName,
                    ")"))))))));
};

const HEAT_MAP_SIZE = 150;
const BATTER_IMAGES = {
    batterMatchup: { lhb: lhbImgFront, rhb: rhbImgFront },
    pitcherOverview: { lhb: lhbImgRear, rhb: rhbImgRear },
};
const Group = styled.div `
    break-inside: avoid;
`;
const Content = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    padding: 0 50px;
`;
const Counts = styled.div `
    display: flex;
    flex: 1 1 auto;
    flex-wrap: wrap;
    gap: 8px 30px;
    justify-content: center;
    min-width: 0;
`;
const CountSection = styled.div `
    flex: 0 0 auto;
`;
const Cell = styled.div `
    flex: 0 0 ${HEAT_MAP_SIZE}px;

    p {
        margin: 0;
        padding: 5px;
        background: #c7c7c7;
        border-bottom: 2px solid #000;
        font-size: 1em;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
        -webkit-print-color-adjust: exact;
    }
`;
const Count = styled.div `
    display: flex;
`;
const SectionHeader = styled.div `
    margin-bottom: 0.5rem;
`;
const Title = styled.div `
    font-weight: bold;
`;
const CountExamples = styled.span `
    font-weight: normal;
`;
const BatterImageContainer = styled.div `
    display: flex;
    flex: 0 0 50px;
    height: ${HEAT_MAP_SIZE}px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
    }
`;
const Attack2KHeatMaps = ({ pitches, variant, isLhb, venueName, translate, }) => {
    if (!pitches.length)
        return null;
    const isPitcherOverview = variant === 'pitcherOverview';
    const batterImage = BATTER_IMAGES[variant][isLhb ? 'lhb' : 'rhb'];
    const isBatterImageOnLeft = isPitcherOverview !== isLhb;
    const attackTitle = (translate === null || translate === void 0 ? void 0 : translate('sections.opponent.player.attack-counts')) || 'Attack Counts';
    const twoStrikeTitle = translate ? `2-${translate('baseball.strikes_one')} ${translate('baseball.count')}` : '2-Strike Counts';
    const image = React.createElement(BatterImageContainer, null,
        React.createElement("img", { src: batterImage, alt: "" }));
    const cells = (count) => pitches.map((pitch) => {
        const cell = pitch[count];
        return (React.createElement(Cell, { key: `${count}-${pitch.fxtype}-${pitch.fxsubtype}` },
            React.createElement("p", null, pitch.label),
            React.createElement(CatcherWristbandHeatMap, { is2K: count === 'twoStrike', grade: cell.grade, gradetext: cell.gradeText, src: cell.src, redX: cell.redX, selected: cell.selected, kFree: cell.kFree, otz: cell.otz, size: HEAT_MAP_SIZE, isbluetowhite: isPitcherOverview, isCatcherPerspective: isPitcherOverview })));
    });
    const section = (title, count) => (React.createElement(CountSection, null,
        React.createElement(SectionHeader, null,
            React.createElement(Title, null,
                title,
                ' ',
                React.createElement(CountExamples, null,
                    "(",
                    count === 'attack' ? '0-0, 1-0, 1-1, 0-1, 2-0, 2-1, 3-0, 3-1' : '0-2, 1-2, 2-2, 3-2',
                    ")",
                    venueName && ` (at ${venueName})`))),
        React.createElement(Count, null, cells(count))));
    return (React.createElement(Group, null,
        React.createElement(Content, null,
            isBatterImageOnLeft && image,
            React.createElement(Counts, null,
                section(attackTitle, 'attack'),
                section(twoStrikeTitle, 'twoStrike')),
            !isBatterImageOnLeft && image)));
};

const matchesPitch = (pitch, pitchType, fxSubtype) => (pitchType === pitch.fxtype && (fxSubtype !== null && fxSubtype !== void 0 ? fxSubtype : 0) === pitch.fxsubtype);
const getSource = (images, pitch, split) => {
    const image = images === null || images === void 0 ? void 0 : images.find((item) => {
        var _a;
        return item.PitchType === pitch.fxtype
            && ((_a = item.FxSubType) !== null && _a !== void 0 ? _a : 0) === pitch.fxsubtype && item.Split === split;
    });
    return image ? `data:${image.ContentType};base64,${image.HeatMapImg}` : undefined;
};
const getOverrides = (overview, batterId, pitch) => {
    const batterOverrides = (overview === null || overview === void 0 ? void 0 : overview.overrides.filter((item) => item.BatterID === batterId)) || [];
    const early = batterOverrides.find((item) => item.SituationSplit === 'Early'
        && matchesPitch(pitch, item.PitchType, item.FXSubtype)) || {};
    const late = batterOverrides.find((item) => item.SituationSplit === 'TwoStrikes'
        && matchesPitch(pitch, item.PitchType, item.FXSubtype)) || {};
    const firstPitch = !batterOverrides.some((item) => item.SituationSplit === 'Early' && item.Selected === true)
        && early.Selected == null && (overview === null || overview === void 0 ? void 0 : overview.firstpitch.find((item) => item.batterid === batterId
        && matchesPitch(pitch, item.type, item.fxsubtype)));
    const outsideZonePitch = !batterOverrides.some((item) => item.SituationSplit === 'TwoStrikes' && item.OTZ === true)
        && late.OTZ == null && (overview === null || overview === void 0 ? void 0 : overview.oz.find((item) => item.batterid === batterId
        && matchesPitch(pitch, item.type, item.fxsubtype)));
    return {
        early: firstPitch ? Object.assign(Object.assign({}, early), { Selected: true, KFree: !!firstPitch.kfree }) : early,
        late: outsideZonePitch ? Object.assign(Object.assign({}, late), { OTZ: outsideZonePitch.oz }) : late,
    };
};
const getExpectedGrade = (pitch, count) => {
    if (!pitch)
        return {};
    const attack = (pitch.p00 || 0) + (pitch.p10 || 0) + (pitch.p11 || 0) + (pitch.p01 || 0)
        + (pitch.p20 || 0) + (pitch.p21 || 0) + (pitch.p30 || 0) + (pitch.p31 || 0);
    const attackTotal = (pitch.t00 || 0) + (pitch.t10 || 0) + (pitch.t11 || 0) + (pitch.t01 || 0)
        + (pitch.t20 || 0) + (pitch.t21 || 0) + (pitch.t30 || 0) + (pitch.t31 || 0);
    const numerator = count === 'attack' ? attack : (pitch.p2k || 0);
    const denominator = count === 'attack' ? attackTotal : (pitch.t2k || 0);
    if (!denominator)
        return {};
    return { grade: Math.floor(10 * numerator / denominator), gradeText: percent(numerator / denominator, 0) };
};
const getModelGrade = (overview, batterId, pitch, split) => {
    const override = overview === null || overview === void 0 ? void 0 : overview.overrides.find((item) => item.BatterID === batterId
        && item.SituationSplit === split && matchesPitch(pitch, item.PitchType, item.FXSubtype));
    if ((override === null || override === void 0 ? void 0 : override.val) != null)
        return { grade: override.val };
    const modelHeatMap = overview === null || overview === void 0 ? void 0 : overview.heatmaps.find((item) => item.playerid === batterId
        && item.situationsplit === split && item.x === 0 && item.y === 0
        && matchesPitch(pitch, item.pitchtype, item.fxsubtype));
    return { grade: modelHeatMap === null || modelHeatMap === void 0 ? void 0 : modelHeatMap.val };
};
const mapAttack2KHeatMapData = (repertoire, batterId, images, overview, gradeMapper, translate) => repertoire.flatMap((pitch) => {
    var _a, _b;
    const attackSource = getSource(images, pitch, 'Early');
    const twoStrikeSource = getSource(images, pitch, 'TwoStrikes');
    if (!attackSource && !twoStrikeSource)
        return [];
    const overrides = getOverrides(overview, batterId, pitch);
    return [Object.assign(Object.assign({}, pitch), { label: (_b = (_a = pitch.label) !== null && _a !== void 0 ? _a : pitchTypeDisplayName(pitch, true, true, translate)) !== null && _b !== void 0 ? _b : '', attack: Object.assign(Object.assign({}, gradeMapper(pitch, 'Early')), { src: attackSource, redX: overrides.early.RedX, selected: overrides.early.Selected, kFree: overrides.early.KFree }), twoStrike: Object.assign(Object.assign({}, gradeMapper(pitch, 'TwoStrikes')), { src: twoStrikeSource, redX: overrides.late.RedX, selected: overrides.late.Selected, otz: overrides.late.OTZ }) })];
});
const mapPitcherOverviewAttack2KHeatMapData = ({ batterId, repertoire, expected, images, overview, translate, }) => mapAttack2KHeatMapData(repertoire, batterId, images, overview, (pitch, split) => getExpectedGrade(expected === null || expected === void 0 ? void 0 : expected.find((item) => item.pitchtype === pitch.fxtype && item.fxsubtype === pitch.fxsubtype), split === 'Early' ? 'attack' : 'twoStrike'), translate);
const mapBatterMatchupAttack2KHeatMapData = ({ batterId, repertoire, images, overview, translate, }) => mapAttack2KHeatMapData(repertoire.map(({ FXType, FXSubType, name }) => ({
    fxtype: FXType,
    fxsubtype: FXSubType !== null && FXSubType !== void 0 ? FXSubType : 0,
    label: FXType ? undefined : name,
})), batterId, images, overview, (pitch, split) => getModelGrade(overview, batterId, pitch, split), translate);

const BatterMatchupAttack2KHeatMaps = ({ batterId, repertoire, images, overview, isLhb, venueName, translate, }) => (React.createElement(Attack2KHeatMaps, { pitches: mapBatterMatchupAttack2KHeatMapData({
        batterId,
        repertoire,
        images,
        overview,
        translate,
    }), variant: "batterMatchup", isLhb: isLhb, venueName: venueName, translate: translate }));

const DamageZoneTable = styled.div `
    tr {
        break-inside: avoid;
        page-break-inside: avoid;
    }
`;
const damageZonesToSeries = (damageZones, isLhp) => {
    const points = [];
    const ellipse = damageZones === null || damageZones === void 0 ? void 0 : damageZones.find((zone) => zone.IsLHP === isLhp);
    if (ellipse) {
        const pointCount = 40;
        for (let i = 0; i < pointCount; i += 1) {
            const theta = Math.PI * 2 * (i / pointCount);
            const x = ellipse.CenterX - (ellipse.MajorRadius * Math.cos(theta));
            const y = ellipse.CenterZ - (ellipse.MinorRadius * Math.sin(theta));
            const rotatedX = ((x - ellipse.CenterX) * Math.cos(ellipse.Angle)) - ((y - ellipse.CenterZ) * Math.sin(ellipse.Angle)) + ellipse.CenterX;
            const rotatedY = ((x - ellipse.CenterX) * Math.sin(ellipse.Angle)) + ((y - ellipse.CenterZ) * Math.cos(ellipse.Angle)) + ellipse.CenterZ;
            points.push({ x: -rotatedX, y: rotatedY });
        }
    }
    return {
        type: 'scatter',
        id: 'ellipse',
        zIndex: 999,
        marker: { fillColor: '#000000', lineColor: '#000000', lineWidth: 2, radius: 1 },
        data: points,
    };
};
const point = (pitch) => ({
    fxtype: pitch.fxtype,
    fxsubtype: pitch.fxsubtype,
    x: -pitch.platex,
    y: pitch.platez,
    gameid: pitch.gameid,
    eventseq: pitch.eventseq,
    pitchseq: pitch.pitchseq,
    isinstrikezone: pitch.isinstrikezone,
    pstrike: pitch.pstrike,
    gamedate: pitch.gamedate,
    istop: pitch.istop,
    inning: pitch.inning,
    outs: pitch.outs,
    balls: pitch.balls,
    strikes: pitch.strikes,
    marker: { symbol: pitch.stk ? 'circle' : 'square', radius: 4 },
});
const getLabel = (pitches, zone) => {
    if (!zone || !pitches.length)
        return null;
    const damageZone = pitches.filter((pitch) => {
        const first = Math.hypot((-pitch.x) - zone.Focus1X, pitch.y - zone.Focus1Z);
        const second = Math.hypot((-pitch.x) - zone.Focus2X, pitch.y - zone.Focus2Z);
        return (first + second) < zone.Radius;
    }).length;
    return { kzone: pitches.reduce((total, pitch) => total + pitch.pstrike, 0), damageZone, total: pitches.length };
};
const buildSeries$8 = (pitch, pitches, ellipse, translate) => {
    const points = pitches.filter((item) => item.fxtype === pitch.fxtype && item.fxsubtype === pitch.fxsubtype).map(point);
    return {
        points,
        series: [{
                type: 'scatter',
                name: pitchTypeDisplayName(pitch, true, true, translate),
                color: pitchSubTypeColor(pitch),
                marker: { radius: 4 },
                data: points,
            }, ellipse],
    };
};
const label = (value) => value && (React.createElement("div", { className: "text-center" },
    percent(value.kzone / value.total),
    "/",
    percent(value.damageZone / value.total)));
const PitcherOverviewDamageZones = ({ isLhb, isLhp, repertoire, pitches, damageZones, translate, modalContainer, pitchVideoFn, multiVideoFn, videoPlayerModal, tooltipFormatter, sztop, szbottom, }) => {
    const zone = damageZones === null || damageZones === void 0 ? void 0 : damageZones.find((item) => item.IsLHP === isLhp);
    const ellipse = Object.assign(Object.assign({}, damageZonesToSeries(damageZones, isLhp)), { enableMouseTracking: false });
    const kzoneDzone = (translate === null || translate === void 0 ? void 0 : translate('sections.opponent.player.kzone-dzone')) || 'K-Zone/D-Zone';
    const counts = [
        {
            id: 'zeroZero',
            title: `0-0 ${kzoneDzone}`,
            matches: (pitch) => pitch.balls === 0 && pitch.strikes === 0,
        },
        {
            id: 'hitterAhead',
            title: `${(translate === null || translate === void 0 ? void 0 : translate('sections.opponent.player.hitter-ahead')) || 'Hitter Ahead'} ${kzoneDzone}`,
            matches: (pitch) => pitch.balls > pitch.strikes && !(pitch.balls === 3 && pitch.strikes === 2),
        },
        {
            id: 'twoStrike',
            title: `2K ${kzoneDzone}`,
            matches: (pitch) => pitch.strikes === 2 && pitch.balls !== 3,
        },
    ];
    const rows = repertoire.filter((pitch) => pitch.fxtype !== 1).map((pitch) => {
        const rowPitches = pitches.filter((item) => item.islhb === isLhb);
        return {
            pitch,
            charts: counts.map((count) => {
                const chart = buildSeries$8(pitch, rowPitches.filter(count.matches), ellipse, translate);
                return Object.assign(Object.assign({}, count), { series: chart.series, label: getLabel(chart.points, zone) });
            }),
        };
    });
    const columns = [
        {
            id: 'pitch',
            title: '',
            transform: (row) => pitchTypeDisplayName(row.pitch, true, true, translate),
            cellClass: 'fs-6 ps-2',
            type: COLUMN_TYPES.NODE,
        },
        ...counts.map((count) => ({
            id: count.id,
            title: count.title,
            headerClass: 'text-center',
            transform: (row) => {
                const chart = row.charts.find((item) => item.id === count.id);
                if (!chart)
                    return null;
                return (React.createElement(React.Fragment, null,
                    React.createElement(StrikeZone$3, { enableZoom: false, seriesData: chart.series, size: "sm", legendposition: "below", yopposite: true, showlhb: isLhb, showoffgrid: true, pitcherView: false, modalContainer: modalContainer, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, tooltipFormatter: tooltipFormatter, sztop: sztop, szbottom: szbottom }),
                    label(chart.label)));
            },
            type: COLUMN_TYPES.NODE,
        })),
    ];
    return (React.createElement(DamageZoneTable, null,
        React.createElement(DataTable, { sortable: false, striped: false, hover: false, rowClass: () => 'border-bottom', columns: columns, rows: rows })));
};

const PitcherOverviewAttack2KHeatMaps = ({ batterId, repertoire, expected, images, overview, isLhb, translate, }) => (React.createElement(Attack2KHeatMaps, { pitches: mapPitcherOverviewAttack2KHeatMapData({
        batterId,
        repertoire,
        expected,
        images,
        overview,
        translate,
    }), variant: "pitcherOverview", isLhb: isLhb, translate: translate }));

const StyledFilterPill = styled.button `
    font-size: 12px;
    background-color: ${(props) => (props.$isDisabled ? '#eeeeee' : 'white')};
    color: ${(props) => (props.$isDisabled ? '#8f8f8f' : '#303030')}
`;
const StyledFilterPillWrapper = styled.div `
    display: grid;
    gap: 0.5rem;
    grid-template-columns: repeat(${(props) => Math.ceil(props.$columns / 2)}, minmax(0, 1fr));

    @media (min-width: 1200px) {
        grid-template-columns: repeat(${(props) => props.$columns}, minmax(0, 1fr));
    }
`;
const getSvg = (id, options, disabled) => () => { var _a; return (_a = options.find((o) => o.id === id)) === null || _a === void 0 ? void 0 : _a.svg({ disabled }); };
const LiveFilterPills = ({ className, filter, options, setFilter }) => {
    const updateFilter = (id) => {
        if (filter.includes(id)) {
            setFilter(filter.filter((x) => x !== id));
        }
        else {
            setFilter([id, ...filter]);
        }
    };
    const isOptionDisabled = (id) => !filter.includes(id);
    return (React.createElement(StyledFilterPillWrapper, { className: className, "$columns": options.length }, options.map((t) => (React.createElement(StyledFilterPill, { "$isDisabled": isOptionDisabled(t.id), onClick: () => updateFilter(t.id), key: t.id, className: "py-1 px-2 border rounded d-flex align-items-center fw-bold" },
        getSvg(t.id, options, isOptionDisabled(t.id))(),
        React.createElement("span", { className: "ms-2" }, t.name))))));
};

const ALL_VALUE$1 = -1;
const OUT_ZONE_VALUE = 0;
const IN_ZONE_VALUE = 1;
// don't insert within this range, increment
// otherwise saved Key Takeaways could be messed up
const SHOWING_RESULTS_VALUE = 0;
const SHOWING_TIMING_VALUE = 2; // has to match KeyTakeawayDisplayAs for KT save
const SHOWING_PITCH_TYPES_VALUE = 1;
const SHOWING_PITCH_TYPES_8PACK_VALUE = 3;
const ALL_FB_VALUE = 1;
const ALL_NON_FB_VALUE = 0;
const HOME_VALUE = -2;
const AWAY_VALUE = -3;
const PITCH_TYPES_HITMON = (translate) => [
    {
        id: 9,
        name: translate('baseball.pitches.fastball-2-alt'),
        abbr: translate('baseball.pitches.abbr-fastball-2'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#e31a1c', fill: disabled ? '#747474' : '#e31a1c', strokeWidth: "2" }))),
    },
    {
        id: 10,
        name: translate('baseball.pitches.fastball-4-alt'),
        abbr: translate('baseball.pitches.abbr-fastball-4'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#ff7f00', fill: disabled ? '#747474' : '#ff7f00', strokeWidth: "2" }))),
    },
    {
        id: 2,
        name: translate('baseball.pitches.curveball'),
        abbr: translate('baseball.pitches.abbr-curveball'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#a6cee3', fill: disabled ? '#747474' : '#a6cee3', strokeWidth: "2" }))),
    },
    {
        id: 4,
        name: translate('baseball.pitches.changeup_one'),
        abbr: translate('baseball.pitches.abbr-changeup'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#33a02c', fill: disabled ? '#747474' : '#33a02c', strokeWidth: "2" }))),
    },
    {
        id: 8,
        name: translate('baseball.pitches.cutter'),
        abbr: translate('baseball.pitches.abbr-cutter'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#6a3d9a', fill: disabled ? '#747474' : '#6a3d9a', strokeWidth: "2" }))),
    },
    {
        id: 3,
        name: translate('baseball.pitches.slider'),
        abbr: translate('baseball.pitches.abbr-slider'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#1f78b4', fill: disabled ? '#747474' : '#1f78b4', strokeWidth: "2" }))),
    },
    {
        id: 3033,
        name: translate('baseball.pitchsubtypes.slider.gyro'),
        abbr: translate('components.hitting-monitor.slider-gyro'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#713f12', fill: disabled ? '#747474' : '#713f12', strokeWidth: "2" }))),
    },
    {
        id: 3034,
        name: translate('baseball.pitchsubtypes.slider.sweeper'),
        abbr: translate('components.hitting-monitor.slider-sweeper'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#06b6d4', fill: disabled ? '#747474' : '#06b6d4', strokeWidth: "2" }))),
    },
    {
        id: 6,
        name: translate('baseball.pitches.knuckleball'),
        abbr: translate('baseball.pitches.abbr-knuckleball'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#fb9a99', fill: disabled ? '#747474' : '#fb9a99', strokeWidth: "2" }))),
    },
    {
        id: 7,
        name: translate('baseball.pitches.splitter'),
        abbr: translate('baseball.pitches.abbr-splitter'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#cab2d6', fill: disabled ? '#747474' : '#cab2d6', strokeWidth: "2" }))),
    },
];
const RESULT_TYPES = (translate) => [
    {
        id: 1,
        name: translate ? translate('components.hitmon.resulttype.hard-hit') : 'Hard Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-hit') : 'HH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#0000ff', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 2,
        name: translate ? translate('components.hitmon.resulttype.hard-batted-out') : 'Hard Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-batted-out') : 'HBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#0000ff', stroke: disabled ? '#747474' : '#0000ff', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 3,
        name: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
        abbr: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#00ff00', fill: disabled ? '#747474' : '#00ff00', strokeWidth: "2" }))),
    },
    {
        id: 4,
        name: translate ? translate('components.hitmon.resulttype.called-strike') : 'Called Strike',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-called-strike') : 'CS',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#ff0000', fill: disabled ? '#747474' : '#ff0000', strokeWidth: "2" }))),
    },
    {
        id: 5,
        name: translate ? translate('components.hitmon.resulttype.swinging-strike') : 'Swinging Strike',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-swinging-strike') : 'SS',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#ff0000', stroke: disabled ? '#747474' : '#ff0000', d: "M 6 0 L 12 6 6 12 0 6 6 0 Z", visibility: "inherit", strokeWidth: "0" }))),
    },
    {
        id: 6,
        name: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        abbr: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#ff0000', d: "M 1 1 L 11 1 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 7,
        name: translate ? translate('components.hitmon.resulttype.weak-hit') : 'Weak Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-hit') : 'WH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#ffa500', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 8,
        name: translate ? translate('components.hitmon.resulttype.weak-batted-out') : 'Weak Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-batted-out') : 'WBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#ffa500', stroke: disabled ? '#747474' : '#ffa500', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
];
// in the timing version, all the colors are "black" since they'll be colored based on something
// other than just the result
const TIMING_TYPES = (translate) => [
    {
        id: 1,
        name: translate ? translate('components.hitmon.resulttype.hard-hit') : 'Hard Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-hit') : 'HH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#000000', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 2,
        name: translate ? translate('components.hitmon.resulttype.hard-batted-out') : 'Hard Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-batted-out') : 'HBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#000000', stroke: disabled ? '#747474' : '#000000', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    // we don't actually want 3 and 4 to show, but if they get removed, the indexing is wrong for the hover popups(?)
    // {
    //     id: 3,
    //     name: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
    //     abbr: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
    //     svg: ({ disabled }) => (
    //         <svg width="12" height="12">
    //             <circle
    //                 cx="6"
    //                 cy="6"
    //                 r="5"
    //                 stroke={disabled ? '#747474' : '#000000'}
    //                 fill={disabled ? '#747474' : '#000000'}
    //                 strokeWidth="2"
    //             />
    //         </svg>
    //     ),
    // },
    // {
    //     id: 4,
    //     name: translate ? translate('components.hitmon.resulttype.called-strike') : 'Called Strike',
    //     abbr: translate ? translate('components.hitmon.resulttype.abbr-called-strike') : 'CS',
    //     svg: ({ disabled }) => (
    //         <svg width="12" height="12">
    //             <circle
    //                 cx="6"
    //                 cy="6"
    //                 r="5"
    //                 stroke={disabled ? '#747474' : '#000000'}
    //                 fill={disabled ? '#747474' : '#000000'}
    //                 strokeWidth="2"
    //             />
    //         </svg>
    //     ),
    // },
    {
        id: 5,
        name: translate ? translate('components.hitmon.resulttype.swinging-strike') : 'Swinging Strike',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-swinging-strike') : 'SS',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#000000', stroke: disabled ? '#747474' : '#000000', d: "M 6 0 L 12 6 6 12 0 6 6 0 Z", visibility: "inherit", strokeWidth: "0" }))),
    },
    {
        id: 6,
        name: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        abbr: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#000000', d: "M 1 1 L 11 1 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 7,
        name: translate ? translate('components.hitmon.resulttype.weak-hit') : 'Weak Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-hit') : 'WH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#000000', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 8,
        name: translate ? translate('components.hitmon.resulttype.weak-batted-out') : 'Weak Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-batted-out') : 'WBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#000000', stroke: disabled ? '#747474' : '#000000', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
];
const PERSPECTIVE_TYPES$1 = {
    hitter: 1,
    pitcher: 2,
};
const ALL_ATTACK_VALUE$1 = -2;
const ALL_2K_VALUE$1 = -3;
const COUNTS$1 = [
    { id: 0, name: '0-0', balls: 0, strikes: 0 },
    { id: 1, name: '1-0', balls: 1, strikes: 0 },
    { id: 2, name: '2-0', balls: 2, strikes: 0 },
    { id: 3, name: '3-0', balls: 3, strikes: 0 },
    { id: 4, name: '0-1', balls: 0, strikes: 1 },
    { id: 5, name: '1-1', balls: 1, strikes: 1 },
    { id: 6, name: '2-1', balls: 2, strikes: 1 },
    { id: 7, name: '3-1', balls: 3, strikes: 1 },
    { id: 8, name: '0-2', balls: 0, strikes: 2 },
    { id: 9, name: '1-2', balls: 1, strikes: 2 },
    { id: 10, name: '2-2', balls: 2, strikes: 2 },
    { id: 11, name: '3-2', balls: 3, strikes: 2 },
];
const PitchFilterValues = {
    getBaseState: (baseState, translate) => {
        switch (baseState) {
            case -1:
                return translate ? translate('common.all') : 'All';
            case 0:
                return translate ? translate('components.hitmon.empty') : 'Empty';
            case 1:
                return translate ? translate('baseball.abbr-runners-in-position') : 'RISP';
            case 2:
                return translate ? translate('baseball.abbr-runners-on') : 'Runners On';
            default:
                return '';
        }
    },
    getBatterHand: (batterHand, translate) => {
        switch (batterHand) {
            case -1:
                return translate ? translate('common.all') : 'All';
            case 1:
                return translate ? translate('baseball.rhh') : 'RHH';
            case 2:
                return translate ? translate('baseball.lhh') : 'LHH';
            default:
                return '';
        }
    },
    getPitcherRole: (pitcherRole, translate) => {
        switch (pitcherRole) {
            case -1:
                return translate ? translate('common.all') : 'All';
            case 1:
                return translate ? translate('baseball.positions.abbr-pitcher-starting') : 'SP';
            case 2:
                return translate ? translate('baseball.positions.abbr-pitcher-relief') : 'RP';
            default:
                return '';
        }
    },
    getPitchCounts: (counts, translate) => {
        if (counts.indexOf(-1) >= 0)
            return translate ? translate('common.all') : 'All';
        if (counts.indexOf(-2) >= 0)
            return translate ? translate('components.hitmon.all-attack') : 'All Attack';
        if (counts.indexOf(-3) >= 0)
            return translate ? translate('components.hitmon.all-2k') : 'All 2K';
        return COUNTS$1.filter((c) => counts.indexOf(c.id) >= 0).map((c) => c.name).join(', ');
    },
    getPitchResults: (results, translate) => {
        if (results.indexOf(-1) >= 0)
            return translate ? translate('common.all') : 'All';
        return RESULT_TYPES(translate).filter((c) => results.indexOf(c.id) >= 0).map((c) => c.name).join(', ');
    },
    getPitchZone: (zone, translate) => {
        switch (zone) {
            case ALL_VALUE$1:
                return translate ? translate('common.all') : 'All';
            case IN_ZONE_VALUE:
                return translate ? translate('components.search.filter.in-zone') : 'In Zone';
            case OUT_ZONE_VALUE:
                return translate ? translate('components.hitmon.out-zone') : 'Out Zone';
            default:
                return '';
        }
    },
};

const PitchLocation = ({ filter, setFilter, perspective }) => {
    const { t: translate } = useTranslation();
    const getPitcherPerspectivePitchLocation = (loc) => (Object.assign(Object.assign({}, loc), { locationx: 6 - loc.locationx }));
    const perspectivePitchLocation = perspective === PERSPECTIVE_TYPES$1.hitter ? filter.pitchLocation
        : filter.pitchLocation.map(getPitcherPerspectivePitchLocation);
    return (React.createElement("div", { className: "d-flex justify-content-center ms-2" },
        React.createElement("div", null,
            React.createElement("div", null,
                translate('components.hitmon.location'),
                React.createElement(Button, { variant: "link", size: "sm", className: "p-0 ms-1 align-baseline", onClick: () => setFilter(Object.assign(Object.assign({}, filter), { pitchLocation: [] })) },
                    "(",
                    translate('common.reset'),
                    ")")),
            React.createElement(PitchLocation$1, { locations: perspectivePitchLocation, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { pitchLocation: perspective === PERSPECTIVE_TYPES$1.hitter ? e : e.map(getPitcherPerspectivePitchLocation) })) }),
            React.createElement("div", { className: "d-flex justify-content-center" },
                React.createElement("img", { src: homeplate, alt: "Home Plate", height: 20, width: 50, style: { marginTop: '10px', transform: perspective === PERSPECTIVE_TYPES$1.hitter ? '' : 'scaleY(-1)' } })))));
};

const StyledToggleButtons$c = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const StyledVerticalToggleButtons = styled(StyledToggleButtons$c) `
    flex-direction: column;

    label {
        margin-top: 4px;
    }
`;
const PitchZone = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { style: { marginBottom: '-4px' } }, translate('components.hitmon.zone')),
            React.createElement(StyledVerticalToggleButtons, { type: "radio", "$btnWidth": 80, name: "zone", options: [
                    { name: translate('common.all'), value: ALL_VALUE$1 },
                    { name: translate('components.hitmon.in-zone'), value: IN_ZONE_VALUE },
                    { name: translate('components.hitmon.out-zone'), value: OUT_ZONE_VALUE },
                ], separated: true, value: filter.zoneLocation, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { zoneLocation: e })) }))));
};

const StyledToggleButtons$b = styled(ToggleButtons) `
    display: grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    ${(props) => (props.$disabled ? `
        opacity : 0.5;
        pointer-events: none;
    ` : '')}

    .btn {
        width: ${(props) => props.$btnWidth}px;

        ${(props) => (props.$hasAll ? `&:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${props.$numRows} / span ${props.$numRows};
        }` : '')}
    }
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const StyledToggleButtonsWithAll$1 = styled(StyledToggleButtons$b) `
    display: inline-grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    .btn {
        width: ${(props) => props.$btnWidth}px;
&:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${(props) => props.$numRows} / span ${(props) => props.$numRows};
        }
    }
`;
const PitchTypes = ({ className, filter, setFilter, availablePitchTypes }) => {
    const { t: translate } = useTranslation();
    const setFilterWithAll = (e) => {
        let newVal = [];
        if (!e.length || (e.includes(ALL_VALUE$1) && !filter.pitchTypes.includes(ALL_VALUE$1))) {
            newVal = [ALL_VALUE$1];
        }
        else if ((e.includes(ALL_FB_VALUE) && !filter.pitchTypes.includes(ALL_FB_VALUE))) {
            newVal = [ALL_FB_VALUE];
        }
        else if ((e.includes(ALL_NON_FB_VALUE) && !filter.pitchTypes.includes(ALL_NON_FB_VALUE))) {
            newVal = [ALL_NON_FB_VALUE];
        }
        else {
            newVal = e.filter((x) => x !== ALL_VALUE$1 && x !== ALL_FB_VALUE && x !== ALL_NON_FB_VALUE);
            // eslint-disable-next-line max-len
            if (newVal.includes(3) && !filter.pitchTypes.includes(3)) {
                if (!newVal.includes(3033) && availablePitchTypes.has(3033))
                    newVal.push(3033);
                if (!newVal.includes(3034) && availablePitchTypes.has(3034))
                    newVal.push(3034);
            }
        }
        setFilter(Object.assign(Object.assign({}, filter), { pitchTypes: newVal }));
    };
    const isShowingResults = filter.showing === SHOWING_RESULTS_VALUE || filter.showing === SHOWING_TIMING_VALUE;
    const isShowingPitchTypesExtended = filter.showing === SHOWING_PITCH_TYPES_8PACK_VALUE;
    return (React.createElement("div", { className: className },
        React.createElement("div", null, translate('components.hitmon.pitch-types')),
        React.createElement(StyledToggleButtonsWithAll$1, { "$numCols": 6, "$numRows": 2, "$btnWidth": 45, "$disabled": !isShowingResults || isShowingPitchTypesExtended, type: "checkbox", name: "pitchTypes", options: [{ name: translate('common.all'), value: ALL_VALUE$1 }].concat(PITCH_TYPES_HITMON(translate).map((pt) => ({ name: pt.abbr, value: pt.id, disabled: !availablePitchTypes.has(pt.id) }))), separated: true, value: filter.showing === SHOWING_PITCH_TYPES_VALUE || filter.showing === SHOWING_PITCH_TYPES_8PACK_VALUE
                ? [] : filter.pitchTypes, onChange: (e) => setFilterWithAll(e) }),
        React.createElement(StyledToggleButtons$b, { type: "checkbox", name: "pitchTypes-fb", options: [
                { name: translate('components.hitmon.all-fb'), value: ALL_FB_VALUE },
                { name: translate('components.hitmon.all-non-fb'), value: ALL_NON_FB_VALUE },
            ], separated: true, "$btnWidth": 145, "$numCols": 2, "$numRows": 1, "$disabled": !isShowingResults || isShowingPitchTypesExtended, value: filter.showing === SHOWING_PITCH_TYPES_VALUE || filter.showing === SHOWING_PITCH_TYPES_8PACK_VALUE
                ? [] : filter.pitchTypes, onChange: (e) => setFilterWithAll(e), className: "mt-1" })));
};

const StyledToggleButtons$a = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const StyledToggleButtonsWithAll = styled(StyledToggleButtons$a) `
    display: inline-grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    .btn {
        width: ${(props) => props.$btnWidth}px;

        &:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${(props) => props.$numRows} / span ${(props) => props.$numRows};
        }
    }
`;
const PitchResults = ({ filter, setFilter, availableResultTypes }) => {
    const { t: translate } = useTranslation();
    const setFilterWithAll = (key, e) => {
        var _a;
        let newVal = [];
        if (!e.length || (e.includes(ALL_VALUE$1) && !((_a = filter[key]) === null || _a === void 0 ? void 0 : _a.includes(ALL_VALUE$1)))) {
            newVal = [ALL_VALUE$1];
        }
        else {
            newVal = e.filter((x) => x !== ALL_VALUE$1);
        }
        setFilter(Object.assign(Object.assign({}, filter), { [key]: newVal }));
    };
    const isShowingResults = filter.showing === SHOWING_RESULTS_VALUE;
    const isShowingPitchTypesExtended = filter.showing === SHOWING_PITCH_TYPES_8PACK_VALUE;
    const isShowingTiming = filter.showing === SHOWING_TIMING_VALUE;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.results')),
        React.createElement(StyledToggleButtonsWithAll, { "$numCols": 5, "$numRows": 2, "$btnWidth": 52, "$disabled": isShowingResults || isShowingPitchTypesExtended || isShowingTiming, type: "checkbox", name: "result", options: [{ name: translate('common.all'), value: ALL_VALUE$1 }].concat(RESULT_TYPES(translate).map((rt) => ({ name: rt.abbr, value: rt.id, disabled: !availableResultTypes.has(rt.id) }))), separated: true, value: isShowingResults || isShowingPitchTypesExtended || isShowingTiming
                ? [] : filter.result, onChange: (e) => setFilterWithAll('result', e) })));
};

const StyledCountSelect = styled(CountSelect) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
`;
const PitchCounts = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    const isShowingPitchTypesExtended = filter.showing === SHOWING_PITCH_TYPES_8PACK_VALUE;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('baseball.count')),
        React.createElement(StyledCountSelect, { "$disabled": isShowingPitchTypesExtended, counts: isShowingPitchTypesExtended ? [] : filter.counts, setCounts: (newVal) => setFilter(Object.assign(Object.assign({}, filter), { counts: newVal })) })));
};

const StyledToggleButtons$9 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const BaseState = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.base-state')),
        React.createElement(StyledToggleButtons$9, { type: "radio", name: "baseState", options: [
                { name: translate('common.all'), value: ALL_VALUE$1 },
                { name: translate('components.hitmon.empty'), value: 0 },
                { name: translate('baseball.abbr-runners-in-position'), value: 1 },
                { name: translate('baseball.abbr-runners-on'), value: 2 },
            ], separated: true, value: filter.baseState, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { baseState: e })) })));
};

const StyledToggleButtons$8 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const PitcherHand = ({ filter, setFilter, isSwitch, hideAll = false }) => {
    const { t: translate } = useTranslation();
    const options = isSwitch || hideAll ? [
        { name: translate('baseball.lhp'), value: 2 },
        { name: translate('baseball.rhp'), value: 1 },
    ] : [
        { name: translate('common.all'), value: ALL_VALUE$1 },
        { name: translate('baseball.lhp'), value: 2 },
        { name: translate('baseball.rhp'), value: 1 },
    ];
    const setPitcherHand = (e) => {
        if (isSwitch && e !== ALL_VALUE$1) {
            setFilter(Object.assign(Object.assign({}, filter), { pitcherHand: e, batterHand: 3 - e }));
        }
        else {
            setFilter(Object.assign(Object.assign({}, filter), { pitcherHand: e }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.pitcher-hand')),
        React.createElement(StyledToggleButtons$8, { type: "radio", name: "pitcherHand", options: options, separated: true, value: filter.pitcherHand, onChange: setPitcherHand })));
};

const StyledToggleButtons$7 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const BatterHand = ({ filter, setFilter, isPitching }) => {
    const { t: translate } = useTranslation();
    const optionArray = [];
    if (isPitching === true)
        optionArray.push({ name: translate('common.all'), value: -1 });
    optionArray.push({ name: translate('baseball.lhh'), value: 2 });
    optionArray.push({ name: translate('baseball.rhh'), value: 1 });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.batter-hand')),
        React.createElement(StyledToggleButtons$7, { type: "radio", name: "batterHand", options: optionArray, separated: true, value: filter.batterHand, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { batterHand: e })) })));
};

const StyledToggleButtons$6 = styled(ToggleButtons) `
    .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const HitterTimingSelect = ({ setTiming, timing }) => {
    const { t: translate } = useTranslation();
    const optionArray = [];
    optionArray.push({ name: translate('common.all'), value: ALL_VALUE$2 });
    optionArray.push({ name: translate('components.hitmon.timing.late'), value: TIMING_LATE });
    optionArray.push({ name: translate('components.hitmon.timing.on-time'), value: TIMING_ONTIME });
    optionArray.push({ name: translate('components.hitmon.timing.early'), value: TIMING_EARLY });
    const setFilterWithAll = (e) => {
        let newVal = [];
        if (!e.length || (e.includes(ALL_VALUE$2) && !(timing === null || timing === void 0 ? void 0 : timing.includes(ALL_VALUE$2)))) {
            newVal = [ALL_VALUE$2];
        }
        else {
            newVal = e.filter((x) => x !== ALL_VALUE$2);
        }
        setTiming(newVal);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.timing.timing')),
        React.createElement(StyledToggleButtons$6, { type: "checkbox", name: "hitterTiming", "$btnWidth": 58, options: optionArray, separated: true, value: timing, onChange: (e) => setFilterWithAll(e) })));
};

const StyledHitterTimingSelect = styled(HitterTimingSelect) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
`;
const HitterTimings = ({ filter, setFilter }) => (React.createElement(StyledHitterTimingSelect, { "$disabled": false, timing: filter.timing, setTiming: (newVal) => setFilter(Object.assign(Object.assign({}, filter), { timing: newVal })) }));

const StyledToggleButtons$5 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const Showing = ({ filter, setFilter, hideHitterTimingViewOption }) => {
    const { t: translate } = useTranslation();
    const showingOptionsAll = [
        { name: translate('components.hitmon.results'), value: SHOWING_RESULTS_VALUE },
        { name: translate('components.hitmon.timing.timing'), value: SHOWING_TIMING_VALUE },
        { name: translate('components.hitmon.pitch-types'), value: SHOWING_PITCH_TYPES_VALUE },
        { name: translate('components.hitmon.abbr-eight-pack'), value: SHOWING_PITCH_TYPES_8PACK_VALUE },
    ];
    const [showingOpts, setShowingOpts] = useState(showingOptionsAll);
    const setShowing = (e) => {
        setFilter(Object.assign(Object.assign({}, filter), { 
            // eslint-disable-next-line no-nested-ternary
            result: e === SHOWING_RESULTS_VALUE ? RESULT_TYPES(translate).map((r) => r.id)
                : e === SHOWING_TIMING_VALUE ? RESULT_TYPES(translate).filter((x) => x.id !== 3 && x.id !== 4).map((r) => r.id) // remove ball and called strike from this view
                    : [ALL_VALUE$1], pitchTypes: e === SHOWING_PITCH_TYPES_VALUE || e === SHOWING_PITCH_TYPES_8PACK_VALUE
                ? PITCH_TYPES_HITMON(translate).map((pt) => pt.id) : [ALL_VALUE$1], counts: e === SHOWING_PITCH_TYPES_8PACK_VALUE ? [ALL_VALUE$1] : filter.counts, showing: e }));
    };
    useEffect(() => {
        setShowingOpts(hideHitterTimingViewOption ? showingOptionsAll.filter((x) => x.value !== SHOWING_TIMING_VALUE) : showingOptionsAll);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hideHitterTimingViewOption]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, translate('components.hitmon.showing')),
        React.createElement(StyledToggleButtons$5, { type: "radio", name: "showing", options: showingOpts, separated: true, value: filter.showing, onChange: setShowing })));
};

var InputField = ({ className, label, children }) => (React.createElement("div", { className: `${className} d-flex align-items-center` },
    React.createElement("span", { className: "me-1 text-end", style: { minWidth: 45 } }, label),
    children));

const StyledToggleButtons$4 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const Park = ({ filter, setFilter, parks }) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    const optionArray = [
        { name: translate('common.all'), value: -1 },
        { name: translate('baseball.home'), value: HOME_VALUE },
        { name: translate('baseball.away'), value: AWAY_VALUE },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.park')),
        React.createElement(StyledToggleButtons$4, { type: "radio", name: "park", options: optionArray, separated: true, value: filter.park, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { park: e })) }),
        parks && (React.createElement(Form$1.Select, { value: (_b = (_a = filter.park) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '', onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { park: +e.target.value || ALL_VALUE$1 })), className: "mt-2", size: "sm" },
            React.createElement("option", null, translate('components.hitmon.select-park')),
            parks.map((p) => React.createElement("option", { key: p.venueid, value: p.venueid }, p.venuename))))));
};

const StyledToggleButtons$3 = styled(ToggleButtons) `
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const ME_VALUE = 1;
const VsMe = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    const options = [
        { name: translate('common.all'), value: ALL_VALUE$1 },
        { name: translate('components.hitmon.me'), value: ME_VALUE },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.vs')),
        React.createElement(StyledToggleButtons$3, { type: "radio", name: "vsMe", options: options, separated: true, value: filter.isVsMe ? ME_VALUE : ALL_VALUE$1, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { isVsMe: e === ME_VALUE })) })));
};

const StyledTextControl = styled(Form$1.Control) `
    max-width: 80px;

    @media (min-width: 1367px) {
        max-width: 60px;
        &.form-control {
            padding: 0 0.25rem !important;
            min-height: unset !important;
        }
    }
`;
const StyledFilterWrapper$1 = styled.div `
    max-width: 1500px;
    margin: 0 auto;
`;
const MonitorFilter = ({ filter, setFilter, isSwitch, availablePitchTypes, availableResultTypes, perspective, hideBatterHand, hidePitcherHand, hideLastPAs, maxPAs, parks, hasVsMeFilter = false, useImputedData = false, hideHitterTimingFilter = false, hideHitterTimingViewOption = false, }) => {
    const { t: translate } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);
    const STEP_LAST_PAS = 50;
    const isNumber = (x) => /^-?\d*\.?\d*$/.test(x);
    const updateFilter = (key, value) => {
        setFilter(Object.assign(Object.assign({}, filter), { [key]: value }));
    };
    const onLastPaChange = (x) => {
        if (isNumber(x)) {
            const rounded = Math.round(x);
            if (maxPAs && rounded > maxPAs) {
                updateFilter('lastPAs', maxPAs);
            }
            else {
                updateFilter('lastPAs', rounded);
            }
        }
    };
    const handleNumInput = (e, key) => {
        const { value } = e.currentTarget;
        if (!isNumber(value)) {
            e.preventDefault();
        }
        else {
            updateFilter(key, value);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "yru--hitting-monitor-filter border rounded py-2 px-3" },
            React.createElement("div", { className: "d-flex justify-content-end" },
                React.createElement(Button, { variant: "primary", onClick: () => setIsOpen(!isOpen) },
                    isOpen ? translate('common.hide') : translate('common.show'),
                    " ",
                    translate('components.hitmon.all-filters'))),
            isOpen && (React.createElement(StyledFilterWrapper$1, { className: "mt-1" },
                React.createElement("div", { className: "d-flex flex-wrap justify-content-between" },
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(Showing, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, hideHitterTimingViewOption: hideHitterTimingViewOption }),
                        React.createElement(BaseState, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(PitchCounts, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(PitchResults, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(PitchTypes, { className: "mt-4", filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                    React.createElement("div", { className: "mx-2 mb-3" },
                        !hidePitcherHand
                            && (React.createElement(PitcherHand, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        isSwitch && !hideBatterHand && (React.createElement(BatterHand, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        !hideHitterTimingFilter && (React.createElement(HitterTimings, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        React.createElement(Park, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, parks: parks }),
                        hasVsMeFilter && React.createElement(VsMe, { filter: filter, setFilter: setFilter })),
                    React.createElement("div", { className: "mx-2 mb-3 d-flex" },
                        React.createElement("div", null,
                            React.createElement(PitchZone, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        React.createElement("div", { className: "d-flex justify-content-center ms-2" },
                            React.createElement("div", null,
                                React.createElement(PitchLocation, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }))))),
                React.createElement("div", { className: "d-flex flex-wrap align-items-center justify-content-around mt-4" },
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-velocity')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minVelo, onChange: (e) => handleNumInput(e, 'minVelo') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxVelo, onChange: (e) => handleNumInput(e, 'maxVelo') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-launch-angle')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minLa, onChange: (e) => handleNumInput(e, 'minLa') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxLa, onChange: (e) => handleNumInput(e, 'maxLa') })),
                    !useImputedData && (React.createElement(InputField, { label: `${translate('components.hitmon.abbr-exit-velo')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minEv, onChange: (e) => handleNumInput(e, 'minEv') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxEv, onChange: (e) => handleNumInput(e, 'maxEv') }))),
                    useImputedData && (React.createElement(InputField, { label: `${translate('components.hitmon.abbr-exit-velo')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minEvImputed, onChange: (e) => handleNumInput(e, 'minEvImputed') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxEvImputed, onChange: (e) => handleNumInput(e, 'maxEvImputed') }))),
                    React.createElement(InputField, { label: `${translate('components.hitmon.horiz-pull-angle')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minHorizLa, onChange: (e) => handleNumInput(e, 'minHorizLa') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxHorizLa, onChange: (e) => handleNumInput(e, 'maxHorizLa') })),
                    React.createElement(InputField, { label: `${translate('baseball.break-x')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minBreakX, onChange: (e) => handleNumInput(e, 'minBreakX') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxBreakX, onChange: (e) => handleNumInput(e, 'maxBreakX') })),
                    React.createElement(InputField, { label: `${translate('baseball.break-z')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minBreakZ, onChange: (e) => handleNumInput(e, 'minBreakZ') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxBreakZ, onChange: (e) => handleNumInput(e, 'maxBreakZ') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-release-x')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minRelX, onChange: (e) => handleNumInput(e, 'minRelX') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxRelX, onChange: (e) => handleNumInput(e, 'maxRelX') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-release-z')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minRelZ, onChange: (e) => handleNumInput(e, 'minRelZ') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxRelZ, onChange: (e) => handleNumInput(e, 'maxRelZ') })),
                    React.createElement(InputField, { label: "Ext:", className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minExt, onChange: (e) => handleNumInput(e, 'minExt') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxExt, onChange: (e) => handleNumInput(e, 'maxExt') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.arm-angle')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minArmAngle, onChange: (e) => handleNumInput(e, 'minArmAngle') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxArmAngle, onChange: (e) => handleNumInput(e, 'maxArmAngle') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.gyro-degree')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minGyroDegree, onChange: (e) => handleNumInput(e, 'minGyroDegree') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxGyroDegree, onChange: (e) => handleNumInput(e, 'maxGyroDegree') }))),
                !hideLastPAs && (React.createElement("div", { className: "d-flex flex-wrap justify-content-between" },
                    React.createElement("div", { className: "mx-2 mb-3", style: { width: '325px' } },
                        React.createElement("span", { className: "mb-2" },
                            `${translate('components.search.last-x-pas')}`,
                            React.createElement(Slider, { min: STEP_LAST_PAS, max: maxPAs || (2 * STEP_LAST_PAS), inputDirection: "right", step: STEP_LAST_PAS, value: filter.lastPAs, margin: 0, onChange: onLastPaChange, start: filter.lastPAs || STEP_LAST_PAS })))))))),
        React.createElement(LiveFilterPills, { className: "mt-3", filter: (filter.showing === SHOWING_RESULTS_VALUE || filter.showing === SHOWING_TIMING_VALUE) ? filter.result : filter.pitchTypes, options: filter.showing === SHOWING_RESULTS_VALUE
                ? RESULT_TYPES(translate).filter((rt) => availableResultTypes.has(rt.id))
                : filter.showing === SHOWING_TIMING_VALUE ? TIMING_TYPES(translate).filter((rt) => availableResultTypes.has(rt.id))
                    : PITCH_TYPES_HITMON(translate).filter((pt) => availablePitchTypes.has(pt.id)), setFilter: (e) => setFilter(Object.assign(Object.assign({}, filter), { [filter.showing === SHOWING_RESULTS_VALUE || filter.showing === SHOWING_TIMING_VALUE ? 'result' : 'pitchTypes']: e })) })));
};

const timingColorMinimumBucket = -14;
const timingColors = [
    '#f8696c',
    '#f87c7e',
    '#f99092',
    '#f9a3a6',
    '#fab7b9',
    '#facacd',
    '#fbdee1',
    '#e2e4e6',
    '#edeff0',
    '#def0e5',
    '#cae8d4',
    '#b5e0c2',
    '#a1d7b0',
    '#8ccf9f',
    '#78c78d',
    '#63be7b',
    '#77c68c',
    '#8bce9e',
    '#a0d6af',
    '#b4dfc1',
    '#c9e7d3',
    '#ddefe4',
    '#e9ecef',
    '#dee2e6',
    '#cae1f3',
    '#a8cdeb',
    '#87bbe2',
    '#65a8da',
    '#4396d1',
    '#2283c9',
    '#0070c0',
];
const timingPointColor = (timing) => {
    if (timing === null || Number.isNaN(timing))
        return null;
    const colorIndex = Math.ceil(timing) - timingColorMinimumBucket;
    const boundedColorIndex = Math.min(Math.max(colorIndex, 0), timingColors.length - 1);
    return timingColors[boundedColorIndex];
};

const ALL_VALUE = -1;
const PERSPECTIVE_TYPES = {
    hitter: 1,
    pitcher: 2,
};
const ALL_ATTACK_VALUE = -2;
const ALL_2K_VALUE = -3;
const COUNTS = [
    { id: 0, name: '0-0', balls: 0, strikes: 0 },
    { id: 1, name: '1-0', balls: 1, strikes: 0 },
    { id: 2, name: '2-0', balls: 2, strikes: 0 },
    { id: 3, name: '3-0', balls: 3, strikes: 0 },
    { id: 4, name: '0-1', balls: 0, strikes: 1 },
    { id: 5, name: '1-1', balls: 1, strikes: 1 },
    { id: 6, name: '2-1', balls: 2, strikes: 1 },
    { id: 7, name: '3-1', balls: 3, strikes: 1 },
    { id: 8, name: '0-2', balls: 0, strikes: 2 },
    { id: 9, name: '1-2', balls: 1, strikes: 2 },
    { id: 10, name: '2-2', balls: 2, strikes: 2 },
    { id: 11, name: '3-2', balls: 3, strikes: 2 },
];

const getResultTooltip$1 = (title, p, translate, showBatTracking = false, showTiming = false, useImputedData = false, xToShow = null, yToShow = null) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.pitcher_lastname && p.pitcher_usesname ? `${translate('baseball.pitcher_one')}:\
        ${p.pitcher_usesname} ${p.pitcher_lastname} (${p.islhp ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
        ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.pitchtype ? `${translate('components.hitmon.pitch-type')}: ${pitchTypeDisplayName(p, false, false, translate)}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip && !useImputedData ? `${translate('components.hitmon.abbr-exit-velo')}: 
        ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}
    ${p.bip && useImputedData ? `${translate('components.hitmon.abbr-exit-velo')}:
        ${p.exitveloimputed ? translate('format.abbr-mph', { value: format(p.exitveloimputed, 1) }) : '--'}<br />` : ''}\
    ${p.launchangle ? `${translate('components.hitmon.abbr-launch-angle')}: ${format(p.launchangle, 1)}°<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_b = (_a = p.heading) === null || _a === void 0 ? void 0 : _a.toFixed(1)) !== null && _b !== void 0 ? _b : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_d = (_c = p.vbat) === null || _c === void 0 ? void 0 : _c.toFixed(1)) !== null && _d !== void 0 ? _d : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_f = (_e = p.hbat) === null || _e === void 0 ? void 0 : _e.toFixed(1)) !== null && _f !== void 0 ? _f : '-'}<br />`
        : ''}\
    ${showTiming
        ? `${translate('components.hitmon.relative-zonedepth')}: ${(_g = translate('format.abbr-inches', { value: format(p.timingrz, 1) })) !== null && _g !== void 0 ? _g : '-'}<br />\
            ${translate('components.hitmon.timing-rv')}: ${(_j = (_h = p.ervadj) === null || _h === void 0 ? void 0 : _h.toFixed(3)) !== null && _j !== void 0 ? _j : '-'}<br />\
            ${translate('components.hitmon.timing.timing')}: ${(_k = translate('format.abbr-inches', { value: format(p.timing, 1) })) !== null && _k !== void 0 ? _k : '-'}<br />`
        : ''}\
    ${xToShow ? `X: ${xToShow !== null && xToShow !== void 0 ? xToShow : '-'}<br />` : ''}
    ${yToShow ? `Y: ${yToShow !== null && yToShow !== void 0 ? yToShow : '-'}` : ''}
`;
};
const getPitchTypeTooltip$1 = (title, p, translate, showBatTracking = false, showTiming = false, useImputedData = false, xToShow = null, yToShow = null) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.pitcher_lastname && p.pitcher_usesname ? `${translate('baseball.pitcher_one')}:\
         ${p.pitcher_usesname} ${p.pitcher_lastname} (${p.islhp ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
        ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.hitmonresulttype ? `${translate('sections.reports.pitcher.result')}: ${(_a = RESULT_TYPES(translate).find((rt) => rt.id === p.hitmonresulttype)) === null || _a === void 0 ? void 0 : _a.name}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip && !useImputedData ? `${translate('components.hitmon.abbr-exit-velo')}: ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}
    ${p.bip && useImputedData ? `${translate('components.hitmon.abbr-exit-velo')}: ${p.exitveloimputed ? translate('format.abbr-mph', { value: format(p.exitveloimputed, 1) }) : '--'}<br />` : ''}\
    ${p.launchangle ? `${translate('components.hitmon.abbr-launch-angle')}: ${format(p.launchangle, 1)}°<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_c = (_b = p.heading) === null || _b === void 0 ? void 0 : _b.toFixed(1)) !== null && _c !== void 0 ? _c : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_e = (_d = p.vbat) === null || _d === void 0 ? void 0 : _d.toFixed(1)) !== null && _e !== void 0 ? _e : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_g = (_f = p.hbat) === null || _f === void 0 ? void 0 : _f.toFixed(1)) !== null && _g !== void 0 ? _g : '-'}<br />`
        : ''}\
    ${showTiming
        ? `${translate('components.hitmon.relative-zonedepth')}: ${(_h = translate('format.abbr-inches', { value: format(p.timingrz, 1) })) !== null && _h !== void 0 ? _h : '-'}<br />\
            ${translate('components.hitmon.timing-rv')}: ${(_k = (_j = p.ervadj) === null || _j === void 0 ? void 0 : _j.toFixed(3)) !== null && _k !== void 0 ? _k : '-'}<br />\
            ${translate('components.hitmon.timing.timing')}: ${(_l = translate('format.abbr-inches', { value: format(p.timing, 1) })) !== null && _l !== void 0 ? _l : '-'}<br />`
        : ''}\
    ${xToShow ? `X: ${xToShow !== null && xToShow !== void 0 ? xToShow : '-'}<br />` : ''}
    ${yToShow ? `Y: ${yToShow !== null && yToShow !== void 0 ? yToShow : '-'}` : ''}
`;
};

const buildResultSeries$8 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez, id: `strike_zone_${d.id}` }))) })));
const buildPitchTypesSeries$6 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez, id: `strike_zone_${d.id}` }))) })));
const buildTimingSeries$b = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `strike_zone_${d.id}`, visible: !!(d.timingcolor) }))) })));
const StrikeZone$2 = forwardRef(({ batterHand, showing, pitches, resultSeries, pitchTypeSeries, perspective, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, tooltipFormatter, useImputedData = false, szTop, szBottom, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$8(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$6(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$b(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, false, useImputedData)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, true, useImputedData)
                : getPitchTypeTooltip$1(series.name, pitch, translate, false, false, useImputedData));
    };
    return (React.createElement(StrikeZone$3
    // eslint-disable-next-line no-nested-ternary
    , { 
        // eslint-disable-next-line no-nested-ternary
        seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, pitcherView: perspective === PERSPECTIVE_TYPES.pitcher, showlhb: batterHand === 2, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, hideAxis: true, hideGrid: true, sztop: szTop, szbottom: szBottom, ref: ref }));
});

const buildResultSeries$7 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.id}`, visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch) }))) })));
const buildPitchTypesSeries$5 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.id}`, visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch) }))) })));
const buildTimingSeries$a = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `spray_chart_${d.id}`, visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch && d.timingcolor) }))) })));
const SprayChart$2 = forwardRef(({ showing, pitches, resultSeries, pitchTypeSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, sizeMultiplier = 1, tooltipFormatter, useImputedData = false, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$7(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$5(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$a(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, false, useImputedData)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, true, useImputedData)
                : getPitchTypeTooltip$1(series.name, pitch, translate, false, false, useImputedData));
    };
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(SprayChart$3, { type: "outfield", seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, enableZoom: true, sizeMultiplier: sizeMultiplier, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, ref: ref })));
});

const buildResultSeries$6 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { id: `ev_la_chart_${d.id}`, visible: !!(d.exitvelo && d.launchangle) }))) })));
const buildPitchTypesSeries$4 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { id: `ev_la_chart_${d.id}`, visible: !!(d.exitvelo && d.launchangle) }))) })));
const buildTimingSeries$9 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign({}, d), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `ev_la_chart_${d.id}`, visible: !!(d.exitvelo && d.launchangle && d.timingcolor) }))) })));
const EvLaChart = forwardRef(({ showing, pitches, resultSeries, pitchTypeSeries, backgroundType, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, size = 'lg', evLaForceBackground = undefined, tooltipFormatter, useImputedData = false, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$6(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$4(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$9(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, false, useImputedData)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, true, useImputedData)
                : getPitchTypeTooltip$1(series.name, pitch, translate, false, false, useImputedData));
    };
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(EvLaChart$1, { seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, backgroundType: backgroundType, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, size: size, ref: ref, evLaForceBackground: evLaForceBackground, tooltipFormatter: tooltipFormatter || innerTooltipFormatter })));
});

const buildSeries$7 = (series, orderedPitchTypes) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.heading, y: orderedPitchTypes.findIndex((p) => p === (d.fxsubtype || d.pitchtype)), id: `heading_chart_${d.id}` }))) })));
const buildTimingSeries$8 = (series, orderedPitchTypes) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.heading, y: orderedPitchTypes.findIndex((p) => p === (d.fxsubtype || d.pitchtype)) }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `heading_chart_${d.id}`, visible: !!(d.timingcolor) }))) })));
const pitchOrders$1 = [10, 9, 8, 33, 3, 34, 4, 7, 2];
const getPitchOrderValue$1 = (pt) => {
    const index = pitchOrders$1.indexOf(pt);
    return index > -1 ? index : 100 + pt;
};
const HeadingChart$1 = forwardRef(({ pitches, showing, resultSeries, pitchTypeSeries, tooltipFormatter, availablePitchTypes, pitchVideoFn, multiVideoFn, useImputedData = false, sizeMultiplier = 1, }, ref) => {
    const { t: translate } = useTranslation();
    const orderedPitchTypes = useMemo(() => [...availablePitchTypes].sort((a, b) => getPitchOrderValue$1(+b) - getPitchOrderValue$1(+a)), [availablePitchTypes]);
    const innerResultSeries = useMemo(() => buildSeries$7(resultSeries, orderedPitchTypes), [resultSeries, orderedPitchTypes]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$7(pitchTypeSeries, orderedPitchTypes), [pitchTypeSeries, orderedPitchTypes]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$8(resultSeries, orderedPitchTypes), [resultSeries, orderedPitchTypes]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate, true, false, useImputedData)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, true, useImputedData)
                : getPitchTypeTooltip$1(series.name, pitch, translate, true, false, useImputedData));
    };
    return (React.createElement("div", { className: "flex-shrink-0 d-flex align-items-center" },
        React.createElement(HeadingChart$2, { seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, orderedPitchTypes: orderedPitchTypes, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref, sizeMultiplier: sizeMultiplier })));
});

const buildSeries$6 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.hbat, y: d.vbat, id: `bat_impact_chart_${d.id}` }))) })));
const buildTimingSeries$7 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.hbat, y: d.vbat }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `bat_impact_chart_${d.id}`, visible: !!(d.timingcolor) }))) })));
const BatImpactChart$1 = forwardRef(({ batterHand, showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, pitches, useImputedData = false, sizeMultiplier = 1, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildSeries$6(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$6(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$7(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate, true, false, useImputedData)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, true, useImputedData)
                : getPitchTypeTooltip$1(series.name, pitch, translate, true, false, useImputedData));
    };
    return (React.createElement(BatImpactChart$2, { className: "flex-shrink-0", isLhb: batterHand === 2, seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref, sizeMultiplier: sizeMultiplier }));
});

const buildResultSeries$5 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: (d.platex * 12), y: d.timingrz, id: `hitter_timing_${d.id}`, visible: !!(d.timingrz) }))) })));
const buildPitchTypesSeries$3 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: (d.platex * 12), y: d.timingrz, id: `hitter_timing_${d.id}`, visible: !!(d.timingrz) }))) })));
const buildTimingSeries$6 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: (d.platex * 12), y: d.timingrz }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `hitter_timing_${d.id}`, visible: !!(d.timingcolor && d.timingrz) }))) })));
const HitterTiming$1 = forwardRef(({ size, showing, isLhb, pitches, resultSeries, pitchTypeSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, tooltipFormatter, useImputedData = false, sizeMultiplier = 1, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$5(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$3(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$6(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, true, useImputedData)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip$1(series.name, pitch, translate, false, true, useImputedData, null, null) // point.x, point.y if you want to show them (instead of the null)
                : getPitchTypeTooltip$1(series.name, pitch, translate, false, true, useImputedData));
    };
    return (React.createElement(HitterTiming$2, { size: size, seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, isLhb: isLhb, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, hideAxis: true, hideGrid: true, ref: ref, sizeMultiplier: sizeMultiplier }));
});

const buildResultsSeries$1 = (translate, pitches, perspective, mouseOver, mouseOut, includeColor) => {
    const series = [
        {
            hitmonResultType: 1,
            color: includeColor ? '#0000ff' : '',
            marker: { symbol: 'diamond', radius: 4, lineColor: includeColor ? '#0000ff' : '', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
        },
        {
            hitmonResultType: 2,
            color: includeColor ? '#0000ff' : '',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 3,
            color: includeColor ? '#00ff00' : '',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 4,
            color: includeColor ? '#ff0000' : '',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 5,
            color: includeColor ? '#ff0000' : '',
            marker: { symbol: 'diamond', radius: 6, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 6,
            color: includeColor ? '#ff0000' : '',
            marker: { symbol: 'square', radius: 4, lineColor: includeColor ? '#ff0000' : '', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
        },
        {
            hitmonResultType: 7,
            color: includeColor ? '#ffa500' : '',
            marker: { symbol: 'diamond', radius: 4, lineColor: includeColor ? '#ffa500' : '', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
        },
        {
            hitmonResultType: 8,
            color: includeColor ? '#ffa500' : '',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
    ];
    return series.filter((s) => RESULT_TYPES(translate).some((rt) => rt.id === s.hitmonResultType)).map((s) => {
        var _a, _b;
        const hitmonResultType = RESULT_TYPES(translate).find((rt) => rt.id === s.hitmonResultType);
        return Object.assign(Object.assign({}, s), { id: (_a = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _a !== void 0 ? _a : '', name: (_b = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _b !== void 0 ? _b : '', data: pitches.filter((p) => p.hitmonresulttype === s.hitmonResultType).map((p) => ({
                platex: p.platex,
                platez: p.platez,
                bip: p.bip,
                ballinplayx: p.ballinplayx,
                ballinplayy: p.ballinplayy,
                islastpitch: p.islastpitch,
                exitvelo: p.exitvelo,
                launchangle: p.launchangle,
                gameid: p.gameid,
                eventseq: p.eventseq,
                pitchseq: p.pitchseq,
                heading: p.heading,
                pitchtype: p.pitchtype,
                fxsubtype: p.fxsubtype,
                hbat: p.hbat,
                vbat: p.vbat,
                timingrz: p.timingrz,
                timing: p.timing,
                ervadj: p.ervadj,
                timingcolor: timingPointColor(p.timing),
                id: `${p.id}-${perspective === PERSPECTIVE_TYPES.hitter ? 'hitter' : 'pitcher'}`,
            })), point: {
                events: {
                    mouseOver,
                    mouseOut,
                },
            } });
    });
};
const buildPitchTypesSeries$2 = (translate, availablePitchTypes, pitches, perspective, mouseOver, mouseOut) => availablePitchTypes.filter((type) => PITCH_TYPES_HITMON(translate).some((pt) => pt.id === type)).map((type, index) => {
    var _a, _b;
    const pitchType = PITCH_TYPES_HITMON(translate).find((pt) => pt.id === type);
    const color = pitchSubTypeColor({ type: type > 1000 ? Math.floor(type / 1000) : type, fxsubtype: type > 1000 ? type % 1000 : null });
    const data = pitches.filter((p) => (p.fxsubtype || p.pitchtype) === type % 1000).map((p) => {
        var _a;
        return ({
            platex: p.platex,
            platez: p.platez,
            bip: p.bip,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            islastpitch: p.islastpitch,
            exitvelo: p.exitvelo,
            launchangle: p.launchangle,
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            heading: p.heading,
            pitchtype: p.pitchtype,
            fxsubtype: (_a = p.fxsubtype) !== null && _a !== void 0 ? _a : 0,
            hbat: p.hbat,
            vbat: p.vbat,
            timingrz: p.timingrz,
            timing: p.timing,
            ervadj: p.ervadj,
            timingcolor: timingPointColor(p.timing),
            id: `${p.id}-${perspective === PERSPECTIVE_TYPES.hitter ? 'hitter' : 'pitcher'}`,
        });
    });
    return {
        index,
        data,
        name: (_a = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _a !== void 0 ? _a : '',
        id: (_b = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _b !== void 0 ? _b : '',
        color,
        marker: { symbol: 'circle', radius: 4, lineWidth: 1, lineColor: '#fff', states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        point: {
            events: {
                mouseOver,
                mouseOut,
            },
        },
    };
});
const perspectiveOptions = (translate) => [
    { name: translate('components.hitmon.hitters-perspective'), value: PERSPECTIVE_TYPES.hitter },
    { name: translate('components.hitmon.pitchers-perspective'), value: PERSPECTIVE_TYPES.pitcher },
];
const evLaBackgroundTypeOptions = (translate) => [
    { name: translate('components.hitmon.hitfx'), value: EV_LA_CHART_BACKGROUND_TYPE.hitFx },
    { name: translate('components.hitmon.actual'), value: EV_LA_CHART_BACKGROUND_TYPE.actual },
    { name: `${translate('components.hitmon.abbr-difference')}(${translate('components.hitmon.actual')} - ${translate('components.hitmon.hitfx')})`, value: EV_LA_CHART_BACKGROUND_TYPE.diff },
];
const StyledToggleButtons$2 = styled(ToggleButtons) `
    label.btn {
        background-color: transparent !important;
        color: #254c75 !important;
        font-size: 11px !important;
        border: 1px solid #254c75 !important;
        padding: 0.2rem 0.5rem;
    }
    label:first-of-type {
        border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important;
    }
    .btn-check:checked + .btn {
        background-color: #254c75 !important;
        color: white !important;
    }
`;
const AllCharts$1 = ({ isLoading, batterHand, showing, pitches, perspective, setPerspective, pitchVideoFn, multiVideoFn, videoPlayerModal: VideoPlayerModal, modalContainer, evLaChartSize = 'lg', sprayChartSizeMultipler = 1, hidePerspectiveToggle = false, hideStrikeZone = false, hideSprayChart = false, hideEvLaChart = false, evLaForceBackground = undefined, tooltipFormatter, hideHeadingChart = true, hideBatImpactChart = true, availablePitchTypes, useImputedData = false, hideHitterTimingChart = false, scaleHittingCharts, szTop, szBottom, }) => {
    const { t: translate } = useTranslation();
    const sprayChartRef = useRef(null);
    const strikeZoneRef = useRef(null);
    const evLaChartRef = useRef(null);
    const headingChartRef = useRef(null);
    const timingChartRef = useRef(null);
    const lhhBatImpactChartRef = useRef(null);
    const rhhBatImpactChartRef = useRef(null);
    const SCALE_HITTING_CHARTS = scaleHittingCharts !== null && scaleHittingCharts !== void 0 ? scaleHittingCharts : 0.7; // helps keep the bottom row of hitting charts on one line
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const mouseOver = function mouseOver() {
        var _a, _b, _c, _d, _e, _f, _g;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint(seriesIndex, dataIndex);
        if (this.timingrz) {
            (_b = timingChartRef.current) === null || _b === void 0 ? void 0 : _b.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.bip) {
            (_c = sprayChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.exitvelo && this.launchangle) {
            (_d = evLaChartRef.current) === null || _d === void 0 ? void 0 : _d.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.heading) {
            (_e = headingChartRef.current) === null || _e === void 0 ? void 0 : _e.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_f = lhhBatImpactChartRef.current) === null || _f === void 0 ? void 0 : _f.hoverPoint(seriesIndex, dataIndex);
            (_g = rhhBatImpactChartRef.current) === null || _g === void 0 ? void 0 : _g.hoverPoint(seriesIndex, dataIndex);
        }
    };
    const mouseOut = function mouseOut() {
        var _a, _b, _c, _d, _e, _f, _g;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint(seriesIndex, dataIndex);
        if (this.timingrz) {
            (_b = timingChartRef.current) === null || _b === void 0 ? void 0 : _b.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.bip) {
            (_c = sprayChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.exitvelo && this.launchangle) {
            (_d = evLaChartRef.current) === null || _d === void 0 ? void 0 : _d.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.heading) {
            (_e = headingChartRef.current) === null || _e === void 0 ? void 0 : _e.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_f = lhhBatImpactChartRef.current) === null || _f === void 0 ? void 0 : _f.resetHoverPoint(seriesIndex, dataIndex);
            (_g = rhhBatImpactChartRef.current) === null || _g === void 0 ? void 0 : _g.resetHoverPoint(seriesIndex, dataIndex);
        }
    };
    const resultSeries = useMemo(() => buildResultsSeries$1(translate, pitches, perspective, mouseOver, mouseOut, true), [translate, pitches, perspective]);
    const resultSeriesNoColor = useMemo(() => buildResultsSeries$1(translate, pitches, perspective, mouseOver, mouseOut, false), [translate, pitches, perspective]);
    const pitchTypeSeries = useMemo(() => buildPitchTypesSeries$2(translate, availablePitchTypes, pitches, perspective, mouseOver, mouseOut), [translate, availablePitchTypes, pitches, perspective]);
    const [evLaBackgroundType, setEvLaBackgroundType] = useState(evLaForceBackground !== null && evLaForceBackground !== void 0 ? evLaForceBackground : EV_LA_CHART_BACKGROUND_TYPE.hitFx);
    const innerPitchVideoFn = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_a) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    const innerMultiVideoFn = (playlistPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield multiVideoFn(playlistPitches);
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_b) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    if (isLoading) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5" },
            React.createElement(LoadingSpinner$1, null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "monitorAllChartsContainer" },
            React.createElement("div", { className: "d-flex flex-wrap justify-content-around monitorAllChartsTopContainer" },
                !hideStrikeZone && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorStrikeZoneContainer", style: { maxWidth: '500px' } },
                    showing != SHOWING_TIMING_VALUE && (React.createElement(StrikeZone$2, { batterHand: batterHand, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, perspective: perspective, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: strikeZoneRef, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData, szTop: szTop, szBottom: szBottom })),
                    showing === SHOWING_TIMING_VALUE && (React.createElement(StrikeZone$2, { batterHand: batterHand, showing: showing, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, perspective: perspective, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: strikeZoneRef, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData, szTop: szTop, szBottom: szBottom })),
                    !hidePerspectiveToggle && (React.createElement(StyledToggleButtons$2, { name: "perspective", options: perspectiveOptions(translate), value: perspective, onChange: setPerspective })))),
                !hideSprayChart && (React.createElement("div", { className: "mb-3 monitorSprayChartContainer", style: { maxWidth: '500px' } },
                    showing != SHOWING_TIMING_VALUE && (React.createElement(SprayChart$2, { showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: sprayChartRef, sizeMultiplier: sprayChartSizeMultipler, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData })),
                    showing === SHOWING_TIMING_VALUE && (React.createElement(SprayChart$2, { showing: showing, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: sprayChartRef, sizeMultiplier: sprayChartSizeMultipler, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData })))),
                !hideEvLaChart && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorEvLaChartContainer", style: { maxWidth: '500px' } },
                    showing != SHOWING_TIMING_VALUE && (React.createElement(EvLaChart, { showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, backgroundType: evLaBackgroundType, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: evLaChartRef, size: evLaChartSize, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData })),
                    showing === SHOWING_TIMING_VALUE && (React.createElement(EvLaChart, { showing: showing, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, backgroundType: evLaBackgroundType, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: evLaChartRef, size: evLaChartSize, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData })),
                    !evLaForceBackground && (React.createElement(StyledToggleButtons$2, { name: "background", options: evLaBackgroundTypeOptions(translate), value: evLaBackgroundType, onChange: setEvLaBackgroundType, className: "mt-3" }))))),
            React.createElement("div", { className: "d-flex flex-wrap justify-content-around monitorAllChartsBottomContainer" },
                !hideHitterTimingChart && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorHitterTimingChartContainer", style: { maxWidth: '500px' } },
                    showing != SHOWING_TIMING_VALUE && (React.createElement(HitterTiming$1, { size: "lg", showing: showing, isLhb: batterHand === 2, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: timingChartRef, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData, sizeMultiplier: SCALE_HITTING_CHARTS })),
                    showing === SHOWING_TIMING_VALUE && (React.createElement(HitterTiming$1, { size: "lg", showing: showing, isLhb: batterHand === 2, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: timingChartRef, tooltipFormatter: tooltipFormatter, useImputedData: useImputedData, sizeMultiplier: SCALE_HITTING_CHARTS })))),
                !hideHeadingChart && (React.createElement("div", { className: "mb-3 d-flex justify-content-center monitorHeadingChartContainer", style: { maxWidth: '500px' } },
                    showing != SHOWING_TIMING_VALUE && (React.createElement(HeadingChart$1, { ref: headingChartRef, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, availablePitchTypes: availablePitchTypes.map((pt) => pt % 1000), pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, useImputedData: useImputedData, sizeMultiplier: SCALE_HITTING_CHARTS })),
                    showing === SHOWING_TIMING_VALUE && (React.createElement(HeadingChart$1, { ref: headingChartRef, showing: showing, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, availablePitchTypes: availablePitchTypes.map((pt) => pt % 1000), pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, sizeMultiplier: SCALE_HITTING_CHARTS })))),
                !hideBatImpactChart && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorBatImpactChartContainer", style: { maxWidth: '500px' } },
                    showing != SHOWING_TIMING_VALUE && (batterHand === 2 || batterHand === 3) && (React.createElement(BatImpactChart$1, { ref: lhhBatImpactChartRef, batterHand: 2, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, useImputedData: useImputedData, sizeMultiplier: SCALE_HITTING_CHARTS })),
                    showing === SHOWING_TIMING_VALUE && (batterHand === 2 || batterHand === 3) && (React.createElement(BatImpactChart$1, { ref: lhhBatImpactChartRef, batterHand: 2, showing: showing, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, useImputedData: useImputedData, sizeMultiplier: SCALE_HITTING_CHARTS })),
                    showing != SHOWING_TIMING_VALUE && (batterHand === 1 || batterHand === 3) && (React.createElement(BatImpactChart$1, { ref: rhhBatImpactChartRef, batterHand: 1, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, useImputedData: useImputedData, sizeMultiplier: SCALE_HITTING_CHARTS })),
                    showing === SHOWING_TIMING_VALUE && (batterHand === 1 || batterHand === 3) && (React.createElement(BatImpactChart$1, { ref: rhhBatImpactChartRef, batterHand: 1, showing: showing, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, useImputedData: useImputedData, sizeMultiplier: SCALE_HITTING_CHARTS }))))),
            React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: () => setIsVideoPlayerOpen(false), playlist: videoPlaylist, container: modalContainer })),
        showing === SHOWING_TIMING_VALUE && (React.createElement(Row, null,
            React.createElement(Col, { md: 12, className: "d-flex justify-content-center", style: { paddingTop: '25px' } },
                React.createElement("img", { src: timingLegendImg, style: { maxWidth: '950px' }, alt: "Legend" }))))));
};

const StyledAbbrCell$1 = styled.div `
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;
    min-width: fit-content;
`;
const aggregate$1 = (pitches) => {
    var _a;
    const whipsNumeratorResultTypes = [1, 2];
    const whipsDenominatorResultTypes = [1, 2, 4, 5, 6, 7, 8];
    const row = {
        pitches: pitches.length,
        pitcheshidecount: false,
        sw: ratio(pitches.filter((p) => p.sw).length, pitches.length),
        swinz: ratio(pitches.filter((p) => p.swinz).length, pitches.filter((p) => p.inz).length),
        ch: ratio(pitches.filter((p) => p.ch).length, pitches.filter((p) => !p.inz).length),
        swdec: ratio(pitches.reduce((s, p) => { var _a; return s + ((_a = p.swds) !== null && _a !== void 0 ? _a : 0); }, 0), pitches.reduce((s, p) => { var _a; return s + ((_a = p.swdspit) !== null && _a !== void 0 ? _a : 0); }, 0)),
        ms: ratio(pitches.filter((p) => p.ms).length, pitches.filter((p) => p.sw).length),
        ev: ratio(pitches.reduce((s, p) => s + p.exitvelo, 0), pitches.filter((p) => p.exitvelo).length),
        evimputed: ratio(pitches.reduce((s, p) => s + p.exitveloimputed, 0), pitches.filter((p) => p.exitveloimputed).length),
        vla: ratio(pitches.reduce((s, p) => { var _a; return s + ((_a = p.launchangle) !== null && _a !== void 0 ? _a : 0); }, 0), pitches.filter((p) => p.launchangle).length),
        gb: ratio(pitches.filter((p) => p.gb).length, pitches.filter((p) => p.bip).length),
        whips: ratio(pitches.filter((p) => whipsNumeratorResultTypes.includes(p.hitmonresulttype)).length, pitches.filter((p) => whipsDenominatorResultTypes.includes(p.hitmonresulttype)).length),
        slg: slg(pitches.filter((p) => p.b1).length, pitches.filter((p) => p.b2).length, pitches.filter((p) => p.b3).length, pitches.filter((p) => p.hr).length, pitches.filter((p) => p.ab).length),
        avg: avg(pitches.filter((p) => p.b1).length, pitches.filter((p) => p.b2).length, pitches.filter((p) => p.b3).length, pitches.filter((p) => p.hr).length, pitches.filter((p) => p.ab).length),
        cq: pitches.length
            ? 100 * ((_a = ratio(pitches.reduce((s, p) => s + p.rvheopsbip, 0), pitches.reduce((s, p) => s + p.biprvdenom, 0))) !== null && _a !== void 0 ? _a : 0)
            : null,
        ervops: opsRVPitch(pitches.reduce((s, p) => s + p.ervpitch, 0), pitches.length),
        trkswg: pitches.filter((p) => p.pwbatspdinz || p.pwbatspdoutz).length,
        batspd: ratio(pitches.reduce((s, p) => { var _a, _b; return s + ((_a = p.batspdinz) !== null && _a !== void 0 ? _a : 0) + ((_b = p.batspdoutz) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwbatspdinz || p.pwbatspdoutz).length),
        atkangle: ratio(pitches.reduce((s, p) => { var _a, _b; return s + ((_a = p.atkanginz) !== null && _a !== void 0 ? _a : 0) + ((_b = p.atkangoutz) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwatkanginz || p.pwatkangoutz).length),
        heading: ratio(pitches.reduce((s, p) => { var _a, _b; return s + ((_a = p.fbhead) !== null && _a !== void 0 ? _a : 0) + ((_b = p.nfbhead) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwfbhead || p.pwnfbhead).length),
        headingplusminus: ratio(pitches.reduce((s, p) => { var _a; return s + ((_a = p.headpm) !== null && _a !== void 0 ? _a : 0); }, 0), pitches.reduce((s, p) => { var _a; return s + ((_a = p.pwheadpm) !== null && _a !== void 0 ? _a : 0); }, 0)),
        baracc: rvPerN(pitches.reduce((s, p) => { var _a; return s + ((_a = p.barracc) !== null && _a !== void 0 ? _a : 0); }, 0), pitches.filter((p) => p.pawbarracc).length, 100),
        barracch: rvPerN(pitches.reduce((s, p) => s + p.barracch, 0), pitches.filter((p) => p.pawbarracch).length, 100),
        barraccv: rvPerN(pitches.reduce((s, p) => s + p.barraccv, 0), pitches.filter((p) => p.pawbarraccv).length, 100),
        battilt: ratio(pitches.reduce((s, p) => { var _a, _b; return s + ((_a = p.battiltinz) !== null && _a !== void 0 ? _a : 0) + ((_b = p.battiltoutz) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwbattiltinz || p.pwbattiltoutz).length),
        hbat: ratio(pitches.reduce((s, p) => s + p.hbat, 0), pitches.filter((p) => p.pwhbat).length),
        vbat: ratio(pitches.reduce((s, p) => s + p.vbat, 0), pitches.filter((p) => p.pwvbat).length),
        timing: ratio(pitches.reduce((sum, pitch) => { var _a; return sum + ((_a = pitch.timing) !== null && _a !== void 0 ? _a : 0); }, 0), pitches.filter((pitch) => pitch.timing !== null).length),
    };
    return row;
};
const buildPitchTypeBreakdownRows$1 = (pitches, translate, showPitchSubTypes) => {
    const grouped = pitches.reduce((acc, p) => {
        if (p.pitchtype === 6)
            return acc; // exclude knuckleball
        const key = String(p.fxsubtype != null && p.fxsubtype !== 0 && showPitchSubTypes ? `${p.pitchtype}-${p.fxsubtype}` : p.pitchtype);
        (acc[key] || (acc[key] = [])).push(p);
        return acc;
    }, {});
    return Object.entries(grouped).map(([key, group]) => {
        var _a, _b;
        const label = pitchTypeDisplayName({ fxtype: group[0].pitchtype, fxsubtype: showPitchSubTypes ? group[0].fxsubtype : null }, true, showPitchSubTypes, translate) || String(key);
        return Object.assign({ rowid: `pt-${key}`, abbr: (_a = label === null || label === void 0 ? void 0 : label.toString()) !== null && _a !== void 0 ? _a : key, key, sortorder: (_b = group[0].pitchtypesortorder) !== null && _b !== void 0 ? _b : 999, pitpct: ratio(group.length, pitches.length) }, aggregate$1(group));
    });
};
const getColumns$2 = (translate, showLevelAverages, showBatTrackingStats, showBatTrackingStatsPlayerPortal, hideGbPercent, hideSwingDecision, hideWhips, useImputedData, onPlayAll, isDrilldown = false, onPitchTypeVideo) => {
    const spacer = isDrilldown && !showLevelAverages
        ? [{
                id: 'pitchtype-label',
                title: '',
                type: COLUMN_TYPES.TEXT,
                headerClass: 'd-print-none',
                cellClass: 'd-print-none',
                transform: () => React.createElement("span", null, "\u00A0"),
            }]
        : [];
    const actionColumn = [{
            id: 'pitchtype-video',
            title: '',
            type: COLUMN_TYPES.NODE,
            headerClass: 'd-print-none',
            cellClass: 'd-print-none',
            transform: (row) => ((row.rowid === 'summary' || isDrilldown)
                ? (React.createElement(VideoButton, { color: "#244c74", onClick: isDrilldown ? () => onPitchTypeVideo === null || onPitchTypeVideo === void 0 ? void 0 : onPitchTypeVideo(row) : onPlayAll })) : React.createElement("span", null, "\u00A0")),
        }];
    const abbrColumn = [{
            id: 'abbr',
            title: '',
            type: COLUMN_TYPES.TEXT,
            // eslint-disable-next-line no-nested-ternary
            transform: (row) => (React.createElement(StyledAbbrCell$1, null, row.rowid === 'summary' ? React.createElement("span", null, "\u00A0")
                : ((showLevelAverages && !isDrilldown)
                    ? `${row.abbr} Avg`
                    : React.createElement("span", null, row.abbr)))),
        }];
    return [
        ...spacer,
        ...actionColumn,
        ...abbrColumn,
        { id: 'pitches', title: translate('sections.reports.pitcher.abbr-num-pitches'), type: COLUMN_TYPES.NODE, transform: (row) => (row.pitcheshidecount ? '--' : row.pitches) },
        { id: 'pitpct', title: translate('pitcher-overview.pitch-break.pit-percent'), statistic: 'PitchTypePercent', type: COLUMN_TYPES.PERCENT, precision: 0 },
        { id: 'sw', title: translate('components.hitmon.abbr-swing-pct'), statistic: 'Sw', type: COLUMN_TYPES.PERCENT, precision: 1 },
        { id: 'swinz', title: translate('components.hitmon.abbr-swing-in-zone-pct'), statistic: 'SwInZon', type: COLUMN_TYPES.PERCENT, precision: 1 },
        { id: 'ch', title: translate('components.hitmon.abbr-chase-pct'), statistic: 'Ch', type: COLUMN_TYPES.PERCENT, precision: 1 },
        ...(!hideSwingDecision ? [{ id: 'swdec', title: translate('baseball.abbr-swingdecision'), statistic: 'Swds', type: COLUMN_TYPES.NUMBER, precision: 1 }] : []),
        { id: 'ms', title: translate('components.hitmon.abbr-miss-pct'), statistic: 'Ms', type: COLUMN_TYPES.PERCENT, precision: 1 },
        ...(showBatTrackingStats ? [
            { id: 'trkswg', title: 'Trk Swg', statistic: 'TrackedSwings', type: COLUMN_TYPES.NUMBER },
            { id: 'batspd', title: 'Bat Spd', statistic: 'BatSpeed', type: COLUMN_TYPES.NUMBER, precision: 1 },
            { id: 'timing', title: 'Timing', statistic: 'Timing', type: COLUMN_TYPES.NUMBER, precision: 1 },
            { id: 'atkangle', title: 'Att Ang', statistic: 'AttackAngle', type: COLUMN_TYPES.NUMBER, precision: 1 },
            { id: 'heading', title: 'Head', statistic: 'Heading', type: COLUMN_TYPES.NUMBER, precision: 1 },
            { id: 'headingplusminus', title: 'Head +/-', statistic: 'HeadPMPit', type: COLUMN_TYPES.NUMBER, transform: (row) => normalizeRoundedZero(row.headingplusminus), precision: 1 },
            { id: 'battilt', title: 'Bat Tilt', statistic: 'BatTilt', type: COLUMN_TYPES.NUMBER, precision: 1 },
            { id: 'hbat', title: 'Hbat', statistic: 'HBat', type: COLUMN_TYPES.NUMBER, precision: 2 },
            { id: 'vbat', title: 'Vbat', statistic: 'VBat', type: COLUMN_TYPES.NUMBER, precision: 2 },
        ] : []),
        ...(!useImputedData ? [{ id: 'ev', title: translate('components.hitmon.abbr-exit-velo'), statistic: 'ExitVelo', type: COLUMN_TYPES.NUMBER, precision: 1 }] : []),
        ...(useImputedData ? [{ id: 'evimputed', title: translate('components.hitmon.abbr-exit-velo'), statistic: 'ExitVelo', type: COLUMN_TYPES.NUMBER, precision: 1 }] : []),
        { id: 'vla', title: translate('components.hitmon.abbr-vla'), statistic: 'VertLA', type: COLUMN_TYPES.NUMBER, precision: 1 },
        ...(!hideGbPercent ? [{ id: 'gb', title: translate('baseball.abbr-groundball-pct'), statistic: 'GBPercent', type: COLUMN_TYPES.PERCENT, precision: 0 }] : []),
        ...(!hideWhips ? [{ id: 'whips', title: translate('components.hitmon.whips'), statistic: 'WHiPS', type: COLUMN_TYPES.RATE }] : []),
        { id: 'avg', title: translate('components.hitmon.abbr-average'), statistic: 'AVG', type: COLUMN_TYPES.RATE },
        { id: 'slg', title: translate('components.hitmon.abbr-slugging'), statistic: 'SLG', type: COLUMN_TYPES.RATE },
        { id: 'cq', title: translate('components.hitmon.abbr-contact-quality'), statistic: 'ContactQuality', type: COLUMN_TYPES.NUMBER, precision: 1 },
        ...(showBatTrackingStatsPlayerPortal ? [
            { id: 'trkswg', title: 'Trk Swg', statistic: 'TrackedSwings', type: COLUMN_TYPES.NUMBER },
            { id: 'heading', title: 'Head', statistic: 'Heading', type: COLUMN_TYPES.NUMBER, precision: 1 },
            { id: 'headingplusminus', title: 'Head +/-', statistic: 'HeadPMPit', type: COLUMN_TYPES.NUMBER, transform: (row) => normalizeRoundedZero(row.headingplusminus), precision: 1 },
            { id: 'hbat', title: 'Hbat', statistic: 'HBat', type: COLUMN_TYPES.NUMBER, precision: 2 },
            { id: 'vbat', title: 'Vbat', statistic: 'VBat', type: COLUMN_TYPES.NUMBER, precision: 2 },
        ] : []),
        { id: 'ervops', title: translate('components.hitmon.expected-ops'), statistic: 'ExpOPS', type: COLUMN_TYPES.RATE },
    ];
};
const StatsTable$1 = ({ pitches, isLoadingLevelAverages, levelAverages, enableLevelAverages = false, getLevelAverages, levels, statTooltip, showBatTrackingStats = false, showBatTrackingStatsPlayerPortal = false, hideGbPercent = false, hideSwingDecision = false, hideWhips = false, enablePlayAllInStatsTable, videoPlayerModal: VideoPlayerModal, modalContainer, multiVideoFn, useImputedData = false, showPitchSubTypes = false, }) => {
    const { t: translate } = useTranslation();
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const innerMultiVideoFn = (playlistPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield multiVideoFn(playlistPitches.map((p) => ({ gameid: p.gameid, eventseq: p.eventseq, pitchseq: p.pitchseq })));
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_a) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    const summary = Object.assign({ rowid: 'summary' }, aggregate$1(pitches));
    const breakdownRows = buildPitchTypeBreakdownRows$1(pitches, translate, showPitchSubTypes).sort((a, b) => (a.sortorder) - (b.sortorder));
    const drilldownColumns = getColumns$2(translate, false, showBatTrackingStats, showBatTrackingStatsPlayerPortal, hideGbPercent, hideSwingDecision, hideWhips, useImputedData, undefined, true, (row) => {
        const key = String(row.rowid.replace('pt-', ''));
        const filtered = pitches.filter((p) => {
            const pitchKey = String(p.fxsubtype != null && p.fxsubtype !== 0 && showPitchSubTypes
                ? `${p.pitchtype}-${p.fxsubtype}`
                : p.pitchtype);
            return pitchKey === key;
        });
        innerMultiVideoFn(filtered.map((p) => ({
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
        })));
    });
    summary.drilldown = [
        React.createElement("tr", { key: 0 }),
        breakdownRows
            .map((r, i) => (React.createElement(React.Fragment, { key: r.rowid },
            i === 0 && React.createElement("tr", null),
            React.createElement("tr", null, drilldownColumns.map((c) => React.createElement(DataTableCell, { key: `${c.id}-${r.rowid}`, col: c, row: r })))))),
    ];
    return (React.createElement("div", { className: "yru--hitting-monitor-stats-table text-center" },
        React.createElement(DataTable, { columns: getColumns$2(translate, !!levelAverages.length, showBatTrackingStats, showBatTrackingStatsPlayerPortal, hideGbPercent, hideSwingDecision, hideWhips, useImputedData, enablePlayAllInStatsTable ? () => innerMultiVideoFn(pitches) : undefined, false), rows: [summary].concat(levelAverages), statTooltip: statTooltip, rowClass: (r) => ('abbr' in r && !!r.abbr ? 'fw-bold' : '') }),
        !levelAverages.length && enableLevelAverages && (React.createElement("div", { style: { border: '1px solid #ADB0B2', borderTop: 0 }, className: "p-1" }, isLoadingLevelAverages ? React.createElement(LoadingSpinner$1, { size: "sm", style: { margin: '3px 0' } }) : (React.createElement(Button, { variant: "primary", onClick: getLevelAverages, disabled: !levels.filter((l) => l !== 7).length }, translate('components.hitmon.get-level-averages'))))),
        VideoPlayerModal && enablePlayAllInStatsTable && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: () => setIsVideoPlayerOpen(false), playlist: videoPlaylist, container: modalContainer }))));
};

const hitterTimingBucket$1 = (timing) => {
    if (timing === null)
        return null;
    if (timing < -6)
        return TIMING_LATE;
    if (timing > 6)
        return TIMING_EARLY;
    return TIMING_ONTIME;
};
var getCleanPitches$1 = (pitches) => {
    let cleanPitches = [];
    if (pitches) {
        cleanPitches = pitches.filter((p) => p.locationx && p.locationy).map((p) => ({
            id: `${p.gameid}_${p.eventseq}_${p.pitchseq}`,
            gameid: p.gameid,
            gamedate: p.gamedate,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            pitchtype: p.pitchtype,
            fxtype: p.fxtype,
            fxsubtype: p.fxsubtype,
            pitcherid: p.pitcherid,
            batterid: p.batterid,
            pitcher_lastname: p.pitcher_lastname,
            pitcher_usesname: p.pitcher_usesname,
            inning: p.inning,
            istop: p.istop,
            outs: p.outs,
            baseevent: p.baseevent,
            balls: p.balls,
            strikes: p.strikes,
            pitchresult: p.pitchresult,
            islastpitch: p.islastpitch,
            velocity: p.velocity,
            breakx: p.breakx || p.breakx54,
            breakz: p.breakz || p.breakz54,
            initposx: p.initposx,
            initposz: p.initposz,
            extension: p.extension,
            armangle: p.armangle,
            expstk_all: p.expstk_all,
            exppit_all: p.exppit_all,
            stk: p.stk,
            tkstk: p.tkstk,
            expstk: p.expstk,
            tk: p.tk,
            gb: p.gb,
            bip: p.bip,
            ms: p.ms,
            ch: p.ch,
            sw: p.sw,
            inz: p.inz,
            swinz: p.swinz,
            swds: p.swds,
            swdspit: p.swdspit,
            so: p.so,
            islhb: p.islhb,
            islhp: p.islhp,
            platex: p.platex,
            platez: p.platez,
            exitvelo: p.exitvelo,
            exitveloimputed: p.exitveloimputed,
            launchangle: p.launchangle,
            horizla: p.horizla,
            hittype: p.hittype,
            resultid: p.resultid,
            bcbefore: p.bcbefore,
            hitmonresulttype: p.hitmonresulttype,
            locationx: p.locationx,
            locationy: p.locationy,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            b1: p.b1,
            b2: p.b2,
            b3: p.b3,
            hr: p.hr,
            ab: p.ab,
            rvheopsbip: p.rvheopsbip,
            biprvdenom: p.biprvdenom,
            ervpitch: p.ervpitch,
            pawrv: p.pawrv,
            rvheops: p.rvheops,
            catcherid: p.catcherid,
            vsteamid: p.vsteamid,
            lastxpa: p.lastxpa,
            gyrodegree: p.gyrodegree,
            heading: p.heading,
            hbat: p.hbat,
            vbat: p.vbat,
            batspdinz: p.batspdinz,
            pwbatspdinz: p.pwbatspdinz,
            batspdoutz: p.batspdoutz,
            pwbatspdoutz: p.pwbatspdoutz,
            atkanginz: p.atkanginz,
            pwatkanginz: p.pwatkanginz,
            atkangoutz: p.atkangoutz,
            pwatkangoutz: p.pwatkangoutz,
            fbhead: p.fbhead,
            pwfbhead: p.pwfbhead,
            nfbhead: p.nfbhead,
            pwnfbhead: p.pwnfbhead,
            headpm: p.headpm,
            pwheadpm: p.pwheadpm,
            battiltinz: p.battiltinz,
            pwbattiltinz: p.pwbattiltinz,
            battiltoutz: p.battiltoutz,
            pwbattiltoutz: p.pwbattiltoutz,
            barracc: p.barracc,
            pawbarracc: p.pawbarracc,
            barracch: p.barracch,
            pawbarracch: p.pawbarracch,
            barraccv: p.barraccv,
            pawbarraccv: p.pawbarraccv,
            pwhbat: p.pwhbat,
            pwvbat: p.pwvbat,
            ishome: p.ishome,
            venueid: p.venueid,
            venuename: p.venuename,
            timingrz: p.timingrz,
            ervadj: p.ervadj,
            timing: p.timing,
            timingbucket: hitterTimingBucket$1(p.timing),
            adjhead: p.adjhead,
            pitchtypesortorder: p.pitchtypesortorder,
        }));
    }
    const cleanPitchMap = {};
    for (let i = 0; i < 5; i++) {
        for (let j = 0; j < 5; j++) {
            cleanPitchMap[`${i + 1}.${j + 1}`] = [];
        }
    }
    cleanPitches.forEach((p) => {
        cleanPitchMap[`${p.locationx}.${p.locationy}`].push(p);
    });
    return { cleanPitches, cleanPitchMap };
};

const isNumber$1 = (val) => val !== '' && val !== '-' && !!val && !isNaN(val);
const isGreaterThanOrEqualTo$1 = (num, filterVal) => {
    if (!isNumber$1(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber$1(num) || num === undefined || num === null) {
        return false;
    }
    return num >= filterVal;
};
const isLessThanOrEqualTo$1 = (num, filterVal) => {
    if (!isNumber$1(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber$1(num) || num === undefined || num === null) {
        return false;
    }
    return num <= filterVal;
};
var filterPitches$1 = (cleanPitchMap, liveFilter, isSwitch, vsMePlayerId) => {
    const vsPlayerId = liveFilter.isVsMe ? vsMePlayerId : undefined;
    const locationPitches = liveFilter.pitchLocation.length
        ? Object.entries(cleanPitchMap)
            .filter(([key]) => liveFilter.pitchLocation.map((pl) => `${pl.locationx}.${pl.locationy}`).includes(key))
            .reduce((all, [, val]) => all.concat(val), [])
        : Object.values(cleanPitchMap).reduce((all, locPitches) => all.concat(locPitches), []);
    return locationPitches.filter((p) => (liveFilter.baseState === ALL_VALUE
        || (liveFilter.baseState === 0 && p.bcbefore === 0)
        || (liveFilter.baseState === 1 && p.bcbefore > 1)
        || (liveFilter.baseState === 2 && p.bcbefore > 0))
        && (liveFilter.counts.includes(ALL_VALUE)
            || (liveFilter.counts.includes(ALL_ATTACK_VALUE) && p.strikes < 2)
            || (liveFilter.counts.includes(ALL_2K_VALUE) && p.strikes === 2)
            || liveFilter.counts.some((c) => p.balls === c % 4 && p.strikes === Math.floor(c / 4)))
        && (liveFilter.result.includes(ALL_VALUE) || liveFilter.result.includes(p.hitmonresulttype))
        // eslint-disable-next-line max-len
        && ((liveFilter.pitchTypes.includes(ALL_VALUE)
            || (liveFilter.pitchTypes.includes(ALL_FB_VALUE) && [9, 10].includes(p.pitchtype))
            || (liveFilter.pitchTypes.includes(ALL_NON_FB_VALUE) && ![9, 10].includes(p.pitchtype))
            || liveFilter.pitchTypes.includes(p.fxsubtype != null && p.fxsubtype > 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype)
            // eslint-disable-next-line max-len
            || (!(p.pitchtype === 3 && (p.fxsubtype === 34 || p.fxsubtype === 33)) && liveFilter.pitchTypes.filter((x) => x < 1000 && p.fxsubtype != null && p.pitchtype === x).length > 0)))
        && (liveFilter.timing.includes(ALL_VALUE)
            || (p.timingbucket !== null && liveFilter.timing.includes(p.timingbucket)))
        && (liveFilter.pitcherHand === ALL_VALUE || p.islhp === (liveFilter.pitcherHand === 2))
        && (!isSwitch || p.islhb === (liveFilter.batterHand === 2))
        && (liveFilter.zoneLocation === ALL_VALUE || (p.inz === liveFilter.zoneLocation && !!p.exppit_all))
        && isGreaterThanOrEqualTo$1(p.velocity, liveFilter.minVelo) && isLessThanOrEqualTo$1(p.velocity, liveFilter.maxVelo)
        && isGreaterThanOrEqualTo$1(p.launchangle, liveFilter.minLa) && isLessThanOrEqualTo$1(p.launchangle, liveFilter.maxLa)
        && isGreaterThanOrEqualTo$1(p.exitvelo, liveFilter.minEv) && isLessThanOrEqualTo$1(p.exitvelo, liveFilter.maxEv)
        && isGreaterThanOrEqualTo$1(p.exitveloimputed, liveFilter.minEvImputed) && isLessThanOrEqualTo$1(p.exitveloimputed, liveFilter.maxEvImputed)
        && isGreaterThanOrEqualTo$1(p.horizla, liveFilter.minHorizLa) && isLessThanOrEqualTo$1(p.horizla, liveFilter.maxHorizLa)
        && isGreaterThanOrEqualTo$1(p.breakx, liveFilter.minBreakX) && isLessThanOrEqualTo$1(p.breakx, liveFilter.maxBreakX)
        && isGreaterThanOrEqualTo$1(p.breakz, liveFilter.minBreakZ) && isLessThanOrEqualTo$1(p.breakz, liveFilter.maxBreakZ)
        && isGreaterThanOrEqualTo$1(p.initposx, liveFilter.minRelX) && isLessThanOrEqualTo$1(p.initposx, liveFilter.maxRelX)
        && isGreaterThanOrEqualTo$1(p.initposz, liveFilter.minRelZ) && isLessThanOrEqualTo$1(p.initposz, liveFilter.maxRelZ)
        && isGreaterThanOrEqualTo$1(p.extension, liveFilter.minExt) && isLessThanOrEqualTo$1(p.extension, liveFilter.maxExt)
        && isGreaterThanOrEqualTo$1(p.armangle, liveFilter.minArmAngle) && isLessThanOrEqualTo$1(p.armangle, liveFilter.maxArmAngle)
        && isGreaterThanOrEqualTo$1(p.gyrodegree, liveFilter.minGyroDegree) && isLessThanOrEqualTo$1(p.gyrodegree, liveFilter.maxGyroDegree)
        && isLessThanOrEqualTo$1(p.lastxpa, liveFilter.lastPAs)
        && (liveFilter.park === ALL_VALUE || (liveFilter.park === HOME_VALUE && p.ishome) || (liveFilter.park === AWAY_VALUE && !p.ishome)
            || liveFilter.park === p.venueid)
        && (vsPlayerId === undefined || p.pitcherid === vsPlayerId || p.batterid === vsPlayerId));
};

const StyledTable = styled.table `
    width: 100%;
    text-align: center;
     tr:first-child td {
        border-top: 0;
      }
    tr td:first-child {
        border-left: 0;
    }
    tr:last-child td {
        border-bottom: 0;
    }
    tr td:last-child {
        border-right: 0;
    }

    td {
        border: 1px solid #dee2e6;
        padding: 0.5rem;
    }
`;
const StyledSectionTitle = styled.div `
    font-size: 1.25rem;
`;
const StyledRotatedSectionTitle = styled(StyledSectionTitle) `
    width: 100%;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    white-space: nowrap;
`;
const StyledToggleButtons$1 = styled(ToggleButtons) `
    label.btn {
        background-color: transparent !important;
        color: #254c75 !important;
        font-size: 11px !important;
        border: 1px solid #254c75 !important;
        padding: 0.2rem 0.5rem;
    }
    label:first-of-type {
        border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important;
    }
    .btn-check:checked + .btn {
        background-color: #254c75 !important;
        color: white !important;
    }
`;
const COLUMNS = (translate) => [
    { title: translate('components.hitmon.called-strikes'), isValid: (pitch) => pitch.hitmonresulttype === 4 },
    { title: translate('components.hitmon.swinging-strikes'), isValid: (pitch) => pitch.hitmonresulttype === 5 },
    { title: translate('components.hitmon.weak-contact'), isValid: (pitch) => [7, 8].includes(pitch.hitmonresulttype) },
    { title: translate('components.hitmon.hard-contact'), isValid: (pitch) => [1, 2].includes(pitch.hitmonresulttype) },
];
const ROWS = (translate) => [
    { title: translate('components.hitmon.attack-counts'), isValid: (pitch) => pitch.strikes < 2 },
    { title: translate('components.hitmon.two-strike-counts'), isValid: (pitch) => pitch.strikes === 2 },
];
const PERSPECTIVE_OPTIONS = (translate) => [
    { name: translate('components.hitmon.hitters-perspective'), value: PERSPECTIVE_TYPES.hitter },
    { name: translate('components.hitmon.pitchers-perspective'), value: PERSPECTIVE_TYPES.pitcher },
];
const GridCharts = ({ isLoading, perspective, setPerspective, batterHand, pitches, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, hidePerspectiveToggle = false, tooltipFormatter, availablePitchTypes, }) => {
    const { t: translate } = useTranslation();
    const getSeries = (row, column) => buildPitchTypesSeries$2(translate, availablePitchTypes, pitches.filter((pitch) => row.isValid(pitch) && column.isValid(pitch)), perspective).map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez }))) })));
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return getResultTooltip$1(series.name, pitch, translate);
    };
    if (isLoading) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5" },
            React.createElement(LoadingSpinner$1, null)));
    }
    return (React.createElement("div", null,
        React.createElement(StyledTable, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { width: 40 }),
                    COLUMNS(translate).map((column) => (React.createElement("td", { key: column.title },
                        React.createElement(StyledSectionTitle, null, column.title))))),
                ROWS(translate).map((row) => (React.createElement("tr", { key: row.title },
                    React.createElement("td", null,
                        React.createElement(StyledRotatedSectionTitle, null, row.title)),
                    COLUMNS(translate).map((column) => (React.createElement("td", { key: `${row.title}-${column.title}` },
                        React.createElement(StrikeZone$3, { seriesData: getSeries(row, column), pitcherView: perspective === PERSPECTIVE_TYPES.pitcher, showlhb: batterHand === 2, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, hideGrid: true, hideAxis: true, size: "sm" }))))))))),
        !hidePerspectiveToggle && (React.createElement("div", { className: "d-flex justify-content-center mt-2" },
            React.createElement(StyledToggleButtons$1, { name: "perspective", options: PERSPECTIVE_OPTIONS(translate), value: perspective, onChange: setPerspective })))));
};

const StyledVideoButton = styled(VideoButton) `
    > span {
        font-size: 13px !important;
    }
`;
const HittingMonitor = ({ className, isLoading, liveFilter, setLiveFilter, pitches, player, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, evLaChartSize = 'lg', sprayChartSizeMultipler = 1, initialPerspective = PERSPECTIVE_TYPES.hitter, hidePerspectiveToggle = false, hideStrikeZone = false, hideSprayChart = false, hideEvLaChart = false, hidePitcherHand = false, hideBatterHand = false, enableLevelAverages = false, getLevelAverages, statTooltip, levelAveragesAbortController, levels, evLaForceBackground, playAll, hideStatsTable = false, tooltipFormatter, hideLastPAs, maxPAs, hideBatImpactChart = true, hideHeadingChart = true, showBatTrackingStatsTable = false, showBatTrackingStatsTablePlayerPortal = false, hideGbPercent = false, hideSwingDecision = false, hideWhips = false, enablePlayAllInStatsTable = false, useImputedData = false, hideHitterTimingChart = false, hideHitterTimingFilter = false, hideHitterTimingViewOption = false, scaleHittingCharts = null, szTop, szBottom, showPitchSubTypes = false, vsMePlayerId, }) => {
    const { t: translate } = useTranslation();
    const [perspective, setPerspective] = useState(initialPerspective);
    const [isLoadingLevelAverages, setIsLoadingLevelAverages] = useState(false);
    const [levelAverages, setLevelAverages] = useState([]);
    const { cleanPitches, cleanPitchMap } = useMemo(() => getCleanPitches$1(pitches), [pitches]);
    // eslint-disable-next-line max-len
    const availablePitchTypes = useMemo(() => new Set(cleanPitches.map((p) => (p.fxsubtype != null && p.fxsubtype !== 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype))), [cleanPitches]);
    const availableResultTypes = useMemo(() => new Set(cleanPitches.map((p) => p.hitmonresulttype)), [cleanPitches]);
    const isSwitch = useMemo(() => (player === null || player === void 0 ? void 0 : player.Bats) === 3 || (cleanPitches.some((p) => p.islhb) && cleanPitches.some((p) => !p.islhb)), [player === null || player === void 0 ? void 0 : player.Bats, cleanPitches]);
    const parks = useMemo(() => Array.from(cleanPitches.reduce((all, p) => {
        if (p.venueid && !all.has(p.venueid)) {
            all.set(p.venueid, { venueid: p.venueid, venuename: p.venuename });
        }
        return all;
    }, new Map()).values()).sort((a, b) => (a.venuename.localeCompare(b.venuename))), [cleanPitches]);
    const filteredPitches = useMemo(() => filterPitches$1(cleanPitchMap, liveFilter, isSwitch, vsMePlayerId), [cleanPitchMap, liveFilter, isSwitch, vsMePlayerId]);
    useEffect(() => {
        setLevelAverages([]);
        if (levelAveragesAbortController) {
            levelAveragesAbortController.abort();
        }
        // Omits the abort controller: callers replace it when a request starts, and rerunning would cancel that request.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanPitchMap, liveFilter]);
    useEffect(() => {
        if (liveFilter.park && liveFilter.park > 0 && !parks.some((p) => p.venueid === liveFilter.park)) {
            setLiveFilter(Object.assign(Object.assign({}, liveFilter), { park: ALL_VALUE }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parks]);
    const innerGetLevelAverages = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoadingLevelAverages(true);
            const response = yield getLevelAverages();
            setLevelAverages(response.levelaverages);
        }
        finally {
            setIsLoadingLevelAverages(false);
        }
    });
    return (React.createElement("div", { className: `${className} yru--hitting-monitor bg-white` },
        React.createElement(MonitorFilter, { filter: liveFilter, setFilter: setLiveFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, hideLastPAs: hideLastPAs, maxPAs: maxPAs, parks: parks, hasVsMeFilter: vsMePlayerId !== undefined, useImputedData: useImputedData, hideHitterTimingChart: hideHitterTimingChart, hideHitterTimingFilter: hideHitterTimingFilter, hideHitterTimingViewOption: hideHitterTimingViewOption }),
        React.createElement("div", { className: "mt-4" },
            playAll && (React.createElement(StyledVideoButton, { icon: translate('common.all'), onClick: () => playAll(liveFilter.showing === SHOWING_PITCH_TYPES_8PACK_VALUE
                    ? filteredPitches.filter((p) => [1, 2, 4, 5, 7, 8].includes(p.hitmonresulttype))
                    : [...filteredPitches]), color: styles.theme.background.astronaut, size: "4em" })),
            [SHOWING_RESULTS_VALUE, SHOWING_TIMING_VALUE, SHOWING_PITCH_TYPES_VALUE].includes(liveFilter.showing)
                ? (React.createElement(AllCharts$1, { isLoading: isLoading, pitches: filteredPitches, batterHand: liveFilter.batterHand, showing: liveFilter.showing, perspective: perspective, setPerspective: setPerspective, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, evLaChartSize: evLaChartSize, sprayChartSizeMultipler: sprayChartSizeMultipler, hidePerspectiveToggle: hidePerspectiveToggle, hideStrikeZone: hideStrikeZone, hideSprayChart: hideSprayChart, hideEvLaChart: hideEvLaChart, evLaForceBackground: evLaForceBackground, tooltipFormatter: tooltipFormatter, hideHeadingChart: hideHeadingChart, hideBatImpactChart: hideBatImpactChart, hideHitterTimingChart: hideHitterTimingChart, availablePitchTypes: Array.from(availablePitchTypes), useImputedData: useImputedData, scaleHittingCharts: scaleHittingCharts, szTop: szTop, szBottom: szBottom }))
                : (React.createElement(GridCharts, { isLoading: isLoading, pitches: filteredPitches, batterHand: liveFilter.batterHand, perspective: perspective, setPerspective: setPerspective, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, hidePerspectiveToggle: hidePerspectiveToggle, tooltipFormatter: tooltipFormatter, availablePitchTypes: Array.from(availablePitchTypes) }))),
        !isLoading && !hideStatsTable && (React.createElement("div", { className: "mt-4" },
            React.createElement(StatsTable$1, { pitches: filteredPitches, isLoadingLevelAverages: isLoadingLevelAverages, levelAverages: levelAverages, enableLevelAverages: enableLevelAverages, getLevelAverages: innerGetLevelAverages, statTooltip: statTooltip, levels: levels, showBatTrackingStats: showBatTrackingStatsTable, showBatTrackingStatsPlayerPortal: showBatTrackingStatsTablePlayerPortal, hideGbPercent: hideGbPercent, hideSwingDecision: hideSwingDecision, hideWhips: hideWhips, enablePlayAllInStatsTable: enablePlayAllInStatsTable, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, multiVideoFn: multiVideoFn, useImputedData: useImputedData, showPitchSubTypes: showPitchSubTypes })))));
};

({
    showing: 0,
    baseState: ALL_VALUE,
    counts: [ALL_VALUE],
    result: RESULT_TYPES(null).map((rt) => rt.id),
    pitchTypes: [ALL_VALUE],
    pitcherHand: ALL_VALUE,
    batterHand: null,
    zoneLocation: ALL_VALUE,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minHorizLa: '',
    maxHorizLa: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minRelX: '',
    maxRelX: '',
    minRelZ: '',
    maxRelZ: '',
    minExt: '',
    maxExt: '',
    minArmAngle: '',
    maxArmAngle: '',
    timing: [ALL_VALUE],
    park: ALL_VALUE,
    isVsMe: false,
    lastPAs: 100,
    minEvImputed: '',
    maxEvImputed: '',
});

const sections = (translate) => [
    {
        name: translate('components.hitmon.ntiles.overall'),
        stats: [
            {
                name: translate('components.hitmon.ntiles.hitfx-ops'),
                key: 'hitfxops',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.strikeout-rate'),
                abbr: `${translate('baseball.abbr-strikeout-k')}%`,
                key: 'krate',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.walk-rate'),
                abbr: `${translate('baseball.abbr-walk')}%`,
                key: 'ubbrate',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.abbr-average'),
                key: 'avg',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.abbr-slugging'),
                key: 'slg',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.abbr-on-base'),
                key: 'obp',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.abbr-wops'),
                key: 'wops',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
        ],
    },
    {
        name: translate('components.hitmon.ntiles.swing-decisions'),
        stats: [
            {
                name: translate('components.hitmon.ntiles.swing-decision-score'),
                abbr: translate('components.hitmon.ntiles.abbr-swing-decision-score'),
                key: 'swds',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.should-swing-decision-score'),
                abbr: translate('components.hitmon.ntiles.abbr-should-swing-decision-score'),
                key: 'swdssw',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.should-take-decision-score'),
                abbr: translate('components.hitmon.ntiles.abbr-should-take-decision-score'),
                key: 'swdstk',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.k-zone-pct'),
                abbr: translate('components.hitmon.ntiles.abbr-zone-pct'),
                key: 'kzon',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.swing-pct-in-zone'),
                abbr: translate('components.hitmon.ntiles.abbr-swing-pct-in-zone'),
                key: 'swinz',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.chase-rate'),
                abbr: translate('components.hitmon.ntiles.abbr-chase-rate'),
                key: 'ch',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.swing-rate'),
                abbr: translate('components.hitmon.ntiles.abbr-swing-rate'),
                key: 'sw',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.fastball-pct'),
                abbr: translate('components.hitmon.ntiles.abbr-fastball-pct'),
                key: 'fbl',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
        ],
    },
    {
        name: translate('components.hitmon.ntiles.contact-quailty'),
        stats: [
            {
                name: translate('components.hitmon.ntiles.contact-quailty'),
                abbr: translate('components.hitmon.ntiles.abbr-contact-quailty'),
                key: 'cq',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.contact-results'),
                abbr: translate('components.hitmon.ntiles.abbr-contact-results'),
                key: 'cr',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.exit-velo'),
                abbr: translate('components.hitmon.ntiles.abbr-exit-velo'),
                key: 'hitvelo',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: ' mph',
            },
            {
                name: translate('components.hitmon.ntiles.pct-over-95'),
                abbr: translate('components.hitmon.ntiles.abbr-pct-over-95'),
                key: 'pct95',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.launch-angle-95'),
                abbr: translate('components.hitmon.ntiles.abbr-launch-angle-95'),
                key: 'vertla95',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: ' deg',
            },
            {
                name: translate('components.hitmon.ntiles.miss-pct-in-zone'),
                abbr: translate('components.hitmon.ntiles.abbr-miss-pct-in-zone'),
                key: 'msinz',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
        ],
    },
];

const mapNtilesSeries = (data, sections) => {
    let series = [];
    if (data && sections && data.player[0] && data.percentiles[0]) {
        const playerdata = data.player[0];
        const ntiles = data.percentiles[0];
        series = sections.map((section, ix) => ({
            type: 'scatter',
            name: section.name,
            index: ix,
            data: section.stats.map((stat) => {
                var _a;
                return (Object.assign(Object.assign({}, stat), { name: stat.abbr || stat.name, y: playerdata[`${stat.key}_ntile`], value: stat.formatter(playerdata[stat.key]), units: (_a = stat.units) !== null && _a !== void 0 ? _a : '', statistic: stat.statistic, ntileData: {
                        statname: stat.name,
                        percentile: format(playerdata[`${stat.key}_ntile`], 0),
                        p25: stat.formatter(ntiles[`${stat.key}_p25`]),
                        p50: stat.formatter(ntiles[`${stat.key}_p50`]),
                        p75: stat.formatter(ntiles[`${stat.key}_p75`]),
                    } }));
            }),
        }));
    }
    return series;
};
const HittingNtilesCharts = ({ isLoading, data, sections: sections$1, statTooltip, }) => {
    const { t: translate } = useTranslation();
    const useSections = sections$1 !== null && sections$1 !== void 0 ? sections$1 : sections(translate);
    const ntilesSeries = useMemo(() => mapNtilesSeries(data, useSections), [data, useSections]);
    return (React.createElement("div", { className: "d-flex flex-wrap justify-content-center" },
        !isLoading && ntilesSeries.map((series) => (React.createElement("div", { className: "p-2 flex-fill", key: series.index },
            React.createElement(NtilesChart, { seriesData: [series], width: 300, title: series.name, statTooltip: statTooltip })))),
        !isLoading && ntilesSeries.length === 0 && (React.createElement("h5", null, translate('components.hitmon.no-data')))));
};

styled.div `
    max-width: 1500px;
    margin: 0 auto;
`;

const defaultPitchBreakdownFilter = {
    showing: 1,
    baseState: ALL_VALUE$1,
    counts: [ALL_VALUE$1],
    result: [ALL_VALUE$1],
    pitchTypes: [ALL_VALUE$1],
    pitcherHand: ALL_VALUE$1,
    batterHand: ALL_VALUE$1,
    zoneLocation: ALL_VALUE$1,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minArmAngle: '',
    maxArmAngle: '',
    pitcherRole: ALL_VALUE$1,
    startDate: new Date(`${(new Date()).getFullYear() + ((new Date()).getMonth() < 5 ? -1 : 0)}-01-01 00:00:00`),
    endDate: new Date(),
    years: [
        { name: `${(new Date()).getFullYear() - 2}`, value: (new Date()).getFullYear() - 2, checked: false },
        { name: `${(new Date()).getFullYear() - 1}`, value: (new Date()).getFullYear() - 1, checked: false },
        { name: `${(new Date()).getFullYear()}`, value: (new Date()).getFullYear(), checked: true },
    ],
    minEvImputed: '',
    maxEvImputed: '',
    timing: [ALL_VALUE$1],
};
const defaultHittingMonitorFilter = {
    showing: 0,
    baseState: ALL_VALUE$1,
    counts: [ALL_VALUE$1],
    result: RESULT_TYPES(null).map((rt) => rt.id),
    pitchTypes: [ALL_VALUE$1],
    pitcherHand: ALL_VALUE$1,
    batterHand: null,
    park: ALL_VALUE$1,
    isVsMe: false,
    zoneLocation: ALL_VALUE$1,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minHorizLa: '',
    maxHorizLa: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minArmAngle: '',
    maxArmAngle: '',
    minGyroDegree: '',
    maxGyroDegree: '',
    pitcherRole: ALL_VALUE$1,
    minEvImputed: '',
    maxEvImputed: '',
    timing: [ALL_VALUE$1],
};

const StyledToggleButtons = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const PitcherRole = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('sections.reports.pitcher.role')),
        React.createElement(StyledToggleButtons, { type: "radio", name: "pitcherRole", options: [
                { name: translate('common.all'), value: -1 },
                { name: translate('baseball.positions.abbr-pitcher-relief'), value: 2 },
                { name: translate('baseball.positions.abbr-pitcher-starting'), value: 1 },
            ], separated: true, value: filter.pitcherRole, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { pitcherRole: e })) })));
};

const StyledCheckboxDropdown = styled(CheckboxDropdownInput) `
    .dropdown-toggle {
        min-width: 135px;
    }
`;
const YearDropdown = ({ filter, setFilter, yearsSortDescending }) => {
    const { t: translate } = useTranslation();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onYearDropdownChange = (o, key, e) => {
        const newYears = filter.years.map((lo) => (Object.assign(Object.assign({}, lo), { checked: lo.name === o.name ? e.target.checked : !!lo.checked })));
        setFilter(Object.assign(Object.assign({}, filter), { years: newYears }));
    };
    const selectedYears = filter.years.filter((l) => !!l.checked);
    let yearPlaceholder = '';
    if (selectedYears.length === 1) {
        yearPlaceholder = selectedYears[0].name;
    }
    else if (selectedYears.length === 0) {
        yearPlaceholder = 'All';
    }
    else {
        let consecutive = true;
        let diff = parseInt(selectedYears[0].value);
        selectedYears.forEach((y) => {
            if (Math.abs(diff - parseInt(y.value)) > 1) {
                consecutive = false;
            }
            else {
                diff = parseInt(y.value);
            }
        });
        if (consecutive) {
            if (yearsSortDescending === true) {
                yearPlaceholder = `${selectedYears[selectedYears.length - 1].value}-${selectedYears[0].value}`;
            }
            else {
                yearPlaceholder = `${selectedYears[0].value}-${selectedYears[selectedYears.length - 1].value}`;
            }
        }
        else {
            yearPlaceholder = `${selectedYears.length} ${translate('common.years')}`;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('sections.reports.pitcher.show-player-seasons')),
        React.createElement("div", { className: "d-flex align-items-center me-4" },
            React.createElement(StyledCheckboxDropdown, { value: filter.years, onChange: onYearDropdownChange, options: filter.years, titleOverrideFormat: true, title: yearPlaceholder, style: { width: 90 } }))));
};

const StyledFilterWrapper = styled.div `
    max-width: 1500px;
    margin: 0 auto;
`;
const FiltersDiv = styled.div `
    align-items: baseline;
`;
const PitchBreakdownFilter = ({ filter, setFilter, isSwitch, availablePitchTypes, availableResultTypes, perspective, showPitcherHand, hideBatterHand, hidePitcherHand, hidePitcherRole, hideAllPitcherHandOptions, enableYears = false, yearsSortDescending = false }) => {
    const { t: translate } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "border rounded py-2 px-3" },
            React.createElement("div", { className: "d-flex justify-content-end" },
                React.createElement(Button, { variant: "primary", onClick: () => setIsOpen(!isOpen) },
                    isOpen ? translate('common.hide') : translate('common.show'),
                    " ",
                    translate('components.search.filters'))),
            isOpen && (React.createElement(StyledFilterWrapper, { className: "mt-1" },
                React.createElement(FiltersDiv, { className: "d-flex justify-content-between" },
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(BaseState, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        showPitcherHand && !hidePitcherHand && (React.createElement(PitcherHand, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, hideAll: hideAllPitcherHandOptions })),
                        !hideBatterHand && (React.createElement(BatterHand, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, isPitching: !isSwitch })),
                        !hidePitcherRole && (React.createElement(PitcherRole, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        enableYears === true && (React.createElement("div", null,
                            React.createElement(YearDropdown, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, yearsSortDescending: yearsSortDescending })))),
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(PitchCounts, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(PitchResults, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                    React.createElement("div", { className: "mx-2 mb-3 d-flex flex-column" },
                        React.createElement("div", { className: "d-flex" },
                            React.createElement("div", null,
                                React.createElement(PitchZone, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                            React.createElement("div", { className: "d-flex justify-content-center ms-2" },
                                React.createElement("div", null,
                                    React.createElement(PitchLocation, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })))))))))));
};

const series = [
    [1, '#0000ff', 'diamond'],
    [2, '#0000ff', 'triangle'],
    [7, '#ffa500', 'diamond'],
    [8, '#ffa500', 'triangle'],
].map(([hitmonResultType, color, symbol]) => {
    const outlined = symbol === 'diamond';
    return {
        hitmonResultType,
        color,
        marker: Object.assign(Object.assign({ symbol, radius: outlined ? 4 : 5 }, (outlined ? { lineColor: color, fillColor: '#ffffff', lineWidth: 2 } : {})), { states: { hover: Object.assign({ radiusPlus: 10 }, (!outlined ? { lineWidth: 2, lineColor: '#fff' } : {})) } }),
    };
});
const PitcherOverviewSprayChart = ({ pitches, translate, modalContainer, pitchVideoFn, multiVideoFn, videoPlayerModal, }) => {
    const [filter, setFilter] = useState(series.map((item) => item.hitmonResultType));
    const ballsInPlay = pitches.filter((pitch) => pitch.bip);
    const resultTypes = RESULT_TYPES(translate);
    const options = resultTypes.filter((result) => series.some((item) => item.hitmonResultType === result.id));
    const chartSeries = series
        .filter((item) => filter.includes(item.hitmonResultType))
        .map((item) => {
        var _a;
        return (Object.assign(Object.assign({}, item), { type: 'scatter', id: item.hitmonResultType.toString(), name: (_a = resultTypes.find((result) => result.id === item.hitmonResultType)) === null || _a === void 0 ? void 0 : _a.name, data: ballsInPlay
                .filter((pitch) => pitch.hitmonresulttype === item.hitmonResultType)
                .map((pitch) => (Object.assign(Object.assign({}, pitch), { x: pitch.ballinplayx, y: pitch.ballinplayy }))) }));
    });
    const tooltipFormatter = (chartSeriesItem, point) => {
        const pitch = ballsInPlay.find((item) => item.gameid === point.gameid
            && item.eventseq === point.eventseq && item.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return getResultTooltip$1(chartSeriesItem.name, pitch, translate, false, true);
    };
    return (React.createElement("div", { className: "text-center", style: { breakInside: 'avoid' } },
        React.createElement("div", { className: "mx-auto my-2", style: { maxWidth: 750 } },
            React.createElement(LiveFilterPills, { filter: filter, setFilter: setFilter, options: options })),
        React.createElement(SprayChart$3, { type: "outfield", seriesData: chartSeries, modalContainer: modalContainer, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, tooltipFormatter: tooltipFormatter })));
};

const borderColor = pSBC(-0.1, theme.background.geyser);
var tabTheme = {
    borderColor,
    border: `1px solid ${borderColor}`,
    margin: '10px',
    borderRadius: '5px',
};

const browser = Bowser.getParser(window.navigator.userAgent);
const engineName = browser.getEngineName();
const platform = browser.getPlatformType(true);
const webkit = engineName === 'WebKit';
const mobile = platform === 'mobile';
const tablet = platform === 'tablet';
const ios = (mobile || tablet) && webkit;
const desktop = platform === 'desktop';
var browser$1 = {
    webkit,
    tablet,
    mobile: mobile || tablet,
    mobileOnly: mobile,
    ios,
    desktop,
};

const paddingLeftRight = 10;
const paddingLeftRightMobile = 4;
const { fontColors, background, fontSize } = theme;
const BaseTab = styled.span `
    ${borderRadiuses(tabTheme.borderRadius, 0, 0, tabTheme.borderRadius)}
    cursor: pointer;
    display: block;
    padding: 8px ${browser$1.mobileOnly ? paddingLeftRightMobile : paddingLeftRight}px;
    border: ${tabTheme.border};
    background: ${(props) => (props.theme.isDarkMode ? fontColors.mineShaft : background.geyser)} !important;
    color: ${(props) => (props.theme.isDarkMode ? fontColors.silverChalice : fontColors.tundora)} !important;
    font-size: ${fontSize.nav};
    &:hover, &:active, &:focus {
        text-decoration: none !important;
    }
    &.active-tab, &.active {
        background: ${({ theme, $activeColor = 'white' }) => (theme.isDarkMode ? background.codGray : $activeColor)} !important;
        color: ${(props) => (props.theme.isDarkMode ? fontColors.silver : fontColors.dodgerBlue)} !important;
        border-bottom-color: ${({ theme, $activeColor = 'white' }) => (theme.isDarkMode ? background.codGray : $activeColor)};
        font-weight: bold;
        pointer-events: none;
    }
    &:not(.active-tab) {
        &:hover {
            background-color: ${(props) => pSBC(-0.2, props.theme.isDarkMode ? fontColors.mineShaft : background.geyser)} !important;
            border-color: ${(props) => pSBC(-0.3, props.theme.isDarkMode ? fontColors.mineShaft : background.geyser)};
        }
    }
    ${({ $alert }) => ($alert ? `
        position: relative;
        padding-right: ${paddingLeftRight + 3}px;
        &::after {
            content: '●';
            font-size: 16px;
            color: ${background.tangerine};
            position: absolute;
            right: 1px;
            top: -4px;
        }
    ` : '')}
`;

const Tab = (_a) => {
    var { children, active, activeColor, className = '', alert = false } = _a, rest = __rest(_a, ["children", "active", "activeColor", "className", "alert"]);
    return (React.createElement(BaseTab, Object.assign({ active: active, activeClassName: "active-tab", className: `${className}${active ? ' active-tab ' : ''}`, "$alert": !!alert, "$activeColor": activeColor }, rest), children));
};

const StyledTabPanel$1 = styled.div `
    clear: both;
    margin: 0 -${theme.margin.body} -${theme.margin.body} -${theme.margin.body};
    padding: ${theme.margin.body};
    border-top: ${tabTheme.border};
    background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : props.$activeColor)};
    ${({ $active }) => ($active === false ? 'display: none' : 'display: block')};
    StyledTabPanel {
        border-top: none;
    }
`;
const TabPanel = ({ children, active, activeColor = 'white' }) => (React.createElement(StyledTabPanel$1, { "$active": active, "$activeColor": activeColor }, children));

function useCombinedRefs(...refs) {
    const targetRef = React.useRef(null);
    React.useEffect(() => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(targetRef.current);
            }
            else if (ref !== null) {
                ref.current = targetRef.current;
            }
        });
    }, [refs]);
    return targetRef;
}
const ScrollContainer = styled.div `
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    top: 4px;
    min-height: 37px;
`;
const StyledTabArea = styled.div `
    display: flex;
    justify-content: flex-${({ $align }) => ($align === 'right' ? 'end' : 'start')};
    > * {
        margin-right: 2.5px;
        text-align: center;
        white-space: nowrap;
    }
`;
const TabContainer = forwardRef(({ children, align = 'left' }, ref) => {
    const innerRef = useRef(null);
    const combinedRef = useCombinedRefs(ref, innerRef);
    return (React.createElement(ScrollContainer, { ref: combinedRef },
        React.createElement(StyledTabArea, { "$align": align }, children)));
});

const BaseSubtab = styled.span `
    cursor: pointer;
    font-size: ${theme.fontSize.nav};
    padding: 5px;
    &.active-tab {
        font-weight: 900;
        color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.silver : theme.fontColors.sanMarino)};
        &:focus {
            text-decoration: none;
        }
    }
    &:hover {
        text-decoration: underline;
    }
`;

const SubtabContainer = styled.div `
    margin: 5px;
    text-align: left;
    font-size: 1.1em;
`;
const Subtabs = ({ tabs, onSelect, activeTab }) => (React.createElement(SubtabContainer, null, tabs.map((tab, i) => (React.createElement(React.Fragment, { key: tab.key },
    React.createElement(BaseSubtab, { onClick: () => onSelect(tab), className: (activeTab === null || activeTab === void 0 ? void 0 : activeTab.key) === tab.key ? 'active-tab' : '' },
        tab.title,
        !!tab.alert && React.createElement("span", { className: "ms-1 small label label-warning" }, tab.alert === true ? 1 : tab.alert),
        !!tab.count && React.createElement("span", { className: tab.todayCount ? 'ms-1 small label label-info' : 'ms-1 small label label-default' }, tab.count)),
    i + 1 < tabs.length && React.createElement("span", null, "|"))))));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const StateTabs = ({ tabs, defaultTabIndex = 0, onTabClick }) => {
    const [activeTab, setActiveTab] = useState(tabs[defaultTabIndex]);
    const innerOnSetActiveTab = (t) => {
        if (onTabClick) {
            onTabClick(t);
        }
        setActiveTab(t);
    };
    useEffect(() => {
        var _a;
        setActiveTab((_a = tabs.find((t) => t.key === activeTab.key)) !== null && _a !== void 0 ? _a : tabs[defaultTabIndex]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabs]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TabContainer, null, tabs.map((t) => {
            const isActive = activeTab.key === t.key;
            return React.createElement(Tab, { key: t.key, active: isActive, onClick: isActive ? undefined : () => innerOnSetActiveTab(t) }, t.title);
        })),
        React.createElement(TabPanel, null, activeTab.component)));
};
StateTabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        title: PropTypes.string.isRequired,
        component: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.node]).isRequired,
    })).isRequired,
    defaultTabIndex: PropTypes.number,
    onTabClick: PropTypes.func,
};

const StyledToastHeader = styled(Toast.Header) `&&
    border: none;
    button {
        font-size: 1.5em;
        opacity: 1;
        span {
            color: white;
            line-height: 0.75;                
        }
    }
`;
const StyledToast = styled(Toast) `
    position: absolute;
    top: 25px;
    right: 25px;
    padding: 10px;
    width: 250px;
    z-index: 999;
    &&& {
        &, ${StyledToastHeader} {
            background-color: ${theme.background.success};
            color: white;
        }
        border-radius: 5px;
    }
`;
const StyledToastBody = styled(Toast.Body) `
    padding-top: 5px;
`;
const ToastNotification = ({ message, clearMessage, header = 'Toast Message' }) => (React.createElement(StyledToast, { show: message && message.length > 0, onClose: clearMessage, autohide: true, delay: 3000 },
    React.createElement(StyledToastHeader, null,
        React.createElement("strong", { className: "me-auto" }, header)),
    React.createElement(StyledToastBody, null, message)));

const VideoPlayerButton = ({ title, icon, onClick, isActive = false, className = '', containerClassName = '', loading = false, disabled = false, iconColor = theme.fontColors.silver, showLabel = false, }) => (React.createElement("div", { className: containerClassName },
    React.createElement(Button, { variant: "dark", title: title, onClick: onClick, className: `${className} ${isActive ? 'active' : ''}`, disabled: disabled || loading },
        React.createElement(Icon, { icon: icon, color: isActive ? 'white' : iconColor }),
        loading && React.createElement(LoadingSpinner$1, null)),
    showLabel && React.createElement("label", null, title)));
var VideoPlayerButton$1 = styled(VideoPlayerButton) `
    position: relative;
    touch-action: none;
    &&& {
        background-color: transparent;
        &, &:not(:disabled):not(.disabled) {
            border: 2px solid ${theme.fontColors.silver};
            &, &:focus {
                box-shadow: none;
            }
            &.active, &:active {
                background-color: ${theme.background.cerulean};
                border-color: ${theme.fontColors.silver};
                &, &:focus {
                    box-shadow: none;
                }
            }
        }
    }
    && {
        .spinner-border {
            position: absolute;
            top: 4px;
            left: 4.5px;
            margin: 0;
        }
    }
    &:hover {
        cursor: pointer;
    }
`;

const StyledVideo = styled.video `
    width: 100%;
    height: 100%;
    /* Scale the actual content to fit the frame in BOTH directions; bars only
       appear on the 2 sides where aspect ratios don't match instead of all 4
       sides when the source is smaller than the container. */
    object-fit: contain;
    ${({ $maxHeight }) => ($maxHeight ? `max-height: ${$maxHeight};` : '')}
    ${({ $minHeight }) => ($minHeight ? `min-height: ${$minHeight};` : '')}
    &:focus {
        outline: none;
    }
`;
class Video extends Component {
    constructor(props) {
        super(props);
        this.videoPlayerRef = createRef();
        this.onVideoLoadedData = this.onVideoLoadedData.bind(this);
        this.onPlayback = this.onPlayback.bind(this);
        this.onVideoEnd = this.onVideoEnd.bind(this);
        this.onVideoError = this.onVideoError.bind(this);
        this.setCurrentTime = this.setCurrentTime.bind(this);
    }
    componentDidMount() {
        this.videoPlayerRef.current.addEventListener('loadeddata', this.onVideoLoadedData);
        this.videoPlayerRef.current.addEventListener('timeupdate', this.onPlayback);
        this.videoPlayerRef.current.addEventListener('ended', this.onVideoEnd);
        this.videoPlayerRef.current.addEventListener('error', this.onVideoError);
        if (this.props.setCurrentTime) {
            this.props.setCurrentTime(this.setCurrentTime);
        }
        if (this.props.videoRef) {
            this.props.videoRef(this.videoPlayerRef);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.play !== prevProps.play && this.videoPlayerRef.current) {
            if (this.props.play) {
                this.videoPlayerRef.current.play();
                if (typeof this.props.play === 'number') {
                    this.videoPlayerRef.current.playbackRate = this.props.play;
                }
            }
            else {
                this.videoPlayerRef.current.pause();
            }
        }
        if (!this.props.src && prevProps.src && this.videoPlayerRef.current) { // video not found (on filter)
            this.videoPlayerRef.current.pause();
            this.videoPlayerRef.current.removeAttribute('src');
            this.videoPlayerRef.current.load();
        }
    }
    componentWillUnmount() {
        if (this.videoPlayerRef.current) {
            this.videoPlayerRef.current.removeEventListener('loadeddata', this.onVideoLoadedData);
            this.videoPlayerRef.current.removeEventListener('timeupdate', this.onPlayback);
            this.videoPlayerRef.current.removeEventListener('ended', this.onVideoEnd);
            this.videoPlayerRef.current.removeEventListener('error', this.onVideoError);
        }
    }
    onPlayback(e) { if (this.props.onPlayback)
        this.props.onPlayback(e); }
    onVideoEnd(e) { if (this.props.onVideoEnd)
        this.props.onVideoEnd(e); }
    onVideoLoadedData(e) { if (this.props.onVideoLoad)
        this.props.onVideoLoad(e); }
    onVideoError(e) { if (this.props.onVideoError)
        this.props.onVideoError(e); }
    setCurrentTime(currentTime) { if (this.videoPlayerRef.current)
        this.videoPlayerRef.current.currentTime = currentTime; }
    render() {
        const { src, onClick, maxHeight, minHeight, autoPlay = true, controls = false, mute = false, loop = false } = this.props;
        return (React.createElement(StyledVideo, { ref: this.videoPlayerRef, src: src || undefined, autoPlay: autoPlay, onClick: onClick, controls: controls, muted: !!mute, loop: !!loop, "$maxHeight": typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight, "$minHeight": typeof minHeight === 'number' ? `${minHeight}px` : minHeight, playsInline: true }));
    }
}
Video.defaultProps = {
    play: true,
};

const PLAY_PAUSE = 'play';
const LOOP = 'loop';
const PLAY_FROM_BEGINNING = 'goBack';
const STEP_BACK = 'stepBackward';
const STEP_FORWARD = 'stepForward';
const FULLSCREEN = 'fullscreen';
const MUTE = 'mute';
const STATS = 'stats';
const FILTER = 'filter';
const PLAYLIST = 'playlist';
const FRAME_GRAB = 'frameGrab';
const GRID_SIZE = 'gridSize';
const REPORT_BAD_VIDEO = 'reportBadVideo';
const HEATMAP = 'heatmap';
const FRAME_RATE = 29.97 * 2;
const LOCAL_STORAGE_ANGLE_KEY = 'last_viewed_angle';
const LOCAL_STORAGE_ANGLE_KEY_APPROACHTAB = 'last_viewed_angle_approach';
const LOCAL_STORAGE_DATA_VIEW_KEY = 'video_stats_open';
const LOCAL_STORAGE_MUTE_KEY = 'video_player_muted';
const LOCAL_STORAGE_HEATMAP_KEY = 'show_video_heatmap';
const videoPlayerBackground = 'black';
const fullscreenSectionMixin = css `
    ${(props) => (props.fullscreen ? `
        position: absolute;
        z-index: 9;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
    ` : '')}
`;
const sideContentHeader = css `
    padding: 5px 15px 5px;
    text-align: left;
    && {
        h4 {
            margin: 10px 0;
            font-weight: bold;
            font-family: ${theme.font.body};
        }
    }
`;
const sideContentFooter = css `
    background-color: ${theme.background.cello};
    padding: 15px 20px;
    .btn + .btn {
        margin-left: 12px;
    }
`;
const sideContentWidth = 340;
const filterMarginBottom = '9px';
const headerHeight = 50;
const statsContainerHeight = 145;
const videoMaxSizePadding = { desktop: 50, mobile: 25 };
const footerHeight = { desktop: 64, mobile: 50 };

const fullscreenHeaderHeight = '45px';
const StyledListGroup = styled(ListGroup) `
    text-align: left;
    &&, .list-group-item.list-group-item.list-group-item {
        border-radius: 0;
    }
    && .list-group-item, && .list-group-item-action {
        padding: 5px 10px;
        p {
            margin-bottom: 0;
            font-size: .9em;
            &.h6 {
                font-size: 1.1em;
                font-weight: bold;
            }
        }
        &.active {
            background: ${theme.background.astronaut};
            border: none;
            &:focus {
                outline: none;
            }
        }
        &:hover {
            cursor: pointer;
        }
    }
    && .list-group-item {
        border-color: ${theme.border.alto};
    }
`;
const StyledVideoPlaylist = styled.div `
    position: relative;
    width: ${sideContentWidth}px;
    display: flex;
    flex-direction: column;
    ${StyledListGroup} {
        flex-grow: 1;
        position: relative;
        > div {
            position: absolute;
            left: 0;
            top: 0;
            overflow-y: auto;
            height: 100%;
            width: 100%;
        }
    }
`;
const StyledVideoPlaylistContainer$1 = styled.div `
    ${fullscreenSectionMixin}
    ${StyledVideoPlaylist} {
        height: 100%;
        background-color: white;
        ${(props) => (props.fullscreen ? `
            left: 0;
        ` : '')}
    }
`;
const StyledVideoPlaylistHeader$1 = styled.div `
    ${sideContentHeader}
    height: ${fullscreenHeaderHeight};
    flex-grow: 0;
    border-bottom: 1px solid ${theme.border.alto};
    background-color: white;
`;
const StyledVideoPlaylistFooter = styled.div `
    ${sideContentFooter};
    text-align: left;
`;
const VideoPlaylist = ({ playlist, activeIdx, onVideoClick, isFullScreenMode, hideDisplay }) => {
    const { t: translate } = useTranslation();
    const playlistGroupRef = useRef(null);
    useEffect(() => {
        var _a;
        const activeVideoElem = (_a = playlistGroupRef.current) === null || _a === void 0 ? void 0 : _a.children[activeIdx];
        if (activeVideoElem) {
            const { offsetTop, offsetHeight: listItemHeight } = activeVideoElem;
            const { scrollTop, offsetHeight: containerHeight } = playlistGroupRef.current;
            const scrollContainerBottom = scrollTop + containerHeight;
            const listItemBottom = offsetTop + listItemHeight;
            if ((listItemBottom > scrollContainerBottom) || (offsetTop < scrollTop)) {
                playlistGroupRef.current.scrollTop = offsetTop - listItemHeight - 2;
            }
        }
    }, [activeIdx, playlistGroupRef]);
    const onPlaylistItemClick = (idx) => (e) => {
        e.stopPropagation();
        return onVideoClick(idx);
    };
    return (React.createElement(StyledVideoPlaylistContainer$1, { fullscreen: isFullScreenMode, onClick: isFullScreenMode ? hideDisplay : undefined },
        React.createElement(StyledVideoPlaylist, null,
            React.createElement(StyledVideoPlaylistHeader$1, null,
                React.createElement("h4", null,
                    translate('components.video.pitch-list'),
                    " (",
                    playlist.length,
                    ")")),
            React.createElement(StyledListGroup, { ref: playlistGroupRef },
                React.createElement("div", null, playlist.map(({ title, description, pitchId }, idx) => (React.createElement(StyledListGroup.Item, { key: pitchId || idx, action: true, active: activeIdx === idx, onClick: onPlaylistItemClick(idx) },
                    React.createElement("div", null,
                        React.createElement("p", { className: "h6" }, title),
                        React.createElement("p", null, description))))))),
            React.createElement(StyledVideoPlaylistFooter, null,
                React.createElement(Button, { onClick: isFullScreenMode ? undefined : hideDisplay }, translate('common.cancel'))))));
};
var VideoPlaylist$1 = memo(VideoPlaylist, (prevProps, nextProps) => prevProps.playlist === nextProps.playlist
    && prevProps.activeIdx === nextProps.activeIdx
    && prevProps.isFullScreenMode === nextProps.isFullScreenMode);

const StyledPlaylistTab = styled(Tab) `
    font-weight: bold;
    opacity: 0.4;
    border-color: ${pSBC(-0.3, theme.background.blueZodiac)};
    position: relative;
    && {
        background-color: ${theme.background.blueZodiac} !important;
        color:  white !important;
    }
    &:not(.active-tab):hover {
        opacity: 0.8;
        background-color: ${theme.background.blueZodiac} !important;
        color:  white !important;
    }
    &.active-tab {
        border-bottom-color: ${theme.background.blueZodiac};
        opacity: 1;
    }
    .nyy-icon {
        margin-left: 33px;
    }
    .spinner-border {
        height: 1.5em;
        width: 1.5em;
        position: absolute;
        right: .5em;
        top: .5em;
    }
`;
// check for ios to not overflow mobile info at top of screen
const StyledPlaylistTabContent = styled.div `
    ${(props) => ((props.fullscreen && browser$1.ios) ? 'padding-top: 15px;' : '')}
    background: ${videoPlayerBackground};
    > div {
        scrollbar-width: none;
        -ms-overflow-style: none;  
        ::-webkit-scrollbar { 
            display: none;
        }
    }
`;
const VideoPlaylistTabs = ({ playlist, activeIdx, toggleStats, onVideoClick, loadPitchData, statsContent, isStatsOpen = false, isFullScreenMode = false }) => {
    const playlistGroupRef = useRef(null);
    useEffect(() => {
        var _a;
        const activeVideoElem = (_a = playlistGroupRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.active-tab');
        if (activeVideoElem) {
            const { offsetLeft, offsetWidth: listItemWidth } = activeVideoElem;
            const { scrollLeft, offsetWidth: containerWidth } = playlistGroupRef.current;
            const scrollContainerRight = scrollLeft + containerWidth;
            const listItemRight = offsetLeft + listItemWidth;
            if ((listItemRight > scrollContainerRight) || (offsetLeft < scrollLeft)) {
                playlistGroupRef.current.scrollLeft = offsetLeft - 75;
            }
        }
    }, [activeIdx, playlistGroupRef]);
    return (React.createElement(StyledPlaylistTabContent, { fullscreen: isFullScreenMode },
        React.createElement(TabContainer, { ref: playlistGroupRef }, playlist.map(({ title, pitchId }, idx) => {
            const isActiveTab = idx === activeIdx;
            return (React.createElement("div", { key: pitchId || idx, onClick: isActiveTab ? () => toggleStats() : undefined },
                React.createElement(StyledPlaylistTab, { onClick: () => onVideoClick(idx), className: isActiveTab ? 'active-tab' : '' },
                    React.createElement("span", null, title),
                    isActiveTab && loadPitchData && (React.createElement(Icon, { size: "1em", color: theme.background.cerulean, icon: `chevron-${isStatsOpen ? 'down' : 'up'}` })))));
        })),
        statsContent));
};

const StyledStatList = styled.div `
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
    gap: 5px 10px;
    width: 100%;
    white-space: nowrap;
    dt {
        font-weight: normal;
        text-align: right;
    }
    dd {
        margin: 0;
        font-weight: bold;
        text-align: left;
        font-variant-numeric: tabular-nums;
    }
`;
const StyledStatColumn = styled.dl `
    display: grid;
    grid-template-columns: max-content max-content;
    gap: inherit;
    && {
        margin: 0;
    }
`;
const getPitchingStatItems = (data, translate) => {
    const hasBreak54 = isNumber$2(data.breakx54, data.breakz54);
    const spinDirection = data.spindirection;
    const items = [
        { label: translate('components.video.horizontal-break'), value: formatWithSuffix(hasBreak54 ? data.breakx54 : data.breakx, 1, '"') },
        { label: translate('components.video.vertical-break'), value: formatWithSuffix(hasBreak54 ? data.breakz54 : data.breakz, 1, '"') },
        { label: translate('components.video.arm-angle'), value: formatWithSuffix(data.armangle, 0, '°') },
        { label: translate('components.video.spin-rate'), value: format(data.spinrate) },
        {
            label: translate('components.video.spin-direction'),
            value: typeof spinDirection === 'number' && !Number.isNaN(spinDirection) ? degreesToClock(spinDirection) : null,
        },
        { label: translate('components.video.gyro-degree'), value: formatWithSuffix(data.gyrodegree, 0, '°') },
    ];
    return items.some(({ value }) => value !== null) ? items : [];
};
const StatList = ({ items, columns = 2 }) => {
    const itemsPerColumn = Math.ceil(items.length / columns);
    const statColumns = Array.from({ length: columns }, (_value, columnIndex) => items.slice(columnIndex * itemsPerColumn, (columnIndex + 1) * itemsPerColumn));
    return (React.createElement(StyledStatList, null, statColumns.map((columnItems) => {
        var _a;
        return (React.createElement(StyledStatColumn, { key: (_a = columnItems[0]) === null || _a === void 0 ? void 0 : _a.label }, columnItems.map(({ label, value }) => (React.createElement(React.Fragment, { key: label },
            React.createElement("dt", null, label),
            React.createElement("dd", null, value !== null && value !== void 0 ? value : '-'))))));
    })));
};

const timingMinimum = -15;
const timingMaximum = 15;
const StyledBatTrackingStats = styled.div `
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;
const StyledTimingLegend = styled.div `
    display: flex;
    align-items: flex-start;
    align-self: center;
    gap: 8px;
    width: 100%;
    max-width: 200px;
    font-size: 11px;
    line-height: 1;
    > span {
        font-weight: bold;
    }
`;
const StyledTimingScale = styled.div `
    position: relative;
    flex: 1;
    height: 24px;
    margin: 0 6px;
    &::before {
        position: absolute;
        top: 4px;
        right: 0;
        left: 0;
        border-top: 1px solid ${theme.fontColors.silver};
        content: '';
    }
`;
const StyledTimingTick = styled.span `
    position: absolute;
    top: 0;
    left: ${({ $positionPercent }) => `${$positionPercent}%`};
    padding-top: 12px;
    transform: translateX(-50%);
    font-variant-numeric: tabular-nums;
    &::before {
        position: absolute;
        top: 0;
        left: 50%;
        height: 9px;
        border-left: 1px solid ${theme.fontColors.silver};
        content: '';
    }
`;
const StyledTimingMarker = styled.span `
    position: absolute;
    top: 4px;
    left: ${({ $positionPercent }) => `${$positionPercent}%`};
    width: 7px;
    height: 7px;
    border: 1px solid ${theme.background.white};
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
    transform: translate(-50%, -50%);
`;
const getBatTrackingStats = (data, translate) => {
    const batSpeed = format(data.batspeed, 0);
    const formattedTiming = formatWithSuffix(data.timing, 1, '"');
    const items = [
        { label: translate('components.video.bat-speed'), value: batSpeed === null ? null : translate('format.abbr-mph', { value: batSpeed }) },
        { label: translate('components.video.attack-angle'), value: formatWithSuffix(data.attackangle, 1, '°') },
        { label: translate('components.video.bat-tilt'), value: formatWithSuffix(data.battilt, 0, '°') },
        { label: translate('components.video.timing'), value: formattedTiming },
        { label: translate('components.video.hbat'), value: formatWithSuffix(data.hbat, 2, '"') },
        { label: translate('components.video.vbat'), value: formatWithSuffix(data.vbat, 2, '"') },
        { label: translate('components.video.heading'), value: formatWithSuffix(data.heading, 1, '°') },
    ];
    const timing = formattedTiming === null || data.timing === null ? null : data.timing;
    return items.some(({ value }) => value !== null) ? { items, timing } : null;
};
const getTimingPositionPercent = (timing) => {
    if (timing < timingMinimum || timing > timingMaximum)
        return null;
    return (timing - timingMinimum) / (timingMaximum - timingMinimum) * 100;
};
const BatTrackingStats = ({ stats, isMobileView }) => {
    const { t: translate } = useTranslation();
    const shouldShowTimingScale = !isMobileView && stats.timing !== null;
    const timingPositionPercent = stats.timing === null ? null : getTimingPositionPercent(stats.timing);
    const markerColor = timingPointColor(stats.timing);
    return (React.createElement(StyledBatTrackingStats, null,
        React.createElement(StatList, { items: stats.items }),
        shouldShowTimingScale && (React.createElement(StyledTimingLegend, { "aria-hidden": "true" },
            React.createElement("span", null, translate('components.hitmon.timing.late')),
            React.createElement(StyledTimingScale, null,
                React.createElement(StyledTimingTick, { "$positionPercent": 0 },
                    timingMinimum,
                    "\""),
                React.createElement(StyledTimingTick, { "$positionPercent": 50 }, "0\""),
                React.createElement(StyledTimingTick, { "$positionPercent": 100 },
                    timingMaximum,
                    "\""),
                timingPositionPercent !== null && markerColor !== null && (React.createElement(StyledTimingMarker, { "$color": markerColor, "$positionPercent": timingPositionPercent }))),
            React.createElement("span", null, translate('components.hitmon.timing.early'))))));
};

const StyledTopBottomInning = styled.span `
    font-size: 10px;
`;
const StyledOutsLabel = styled.span `
    font-weight: normal;
`;
const StyledScoreboardTable = styled.table `
    max-width: 135px;
    td {
        padding: 2.5px;
        font-weight: bold;
        text-align: left;
    }
    tr {
        td:nth-of-type(2) {
            text-align: right;
        }
        &:last-of-type td {
            vertical-align: middle;
            text-align: center;
            &:last-child {
                padding-right: 13.5px;
            }
        }
        &:first-of-type, &:last-of-type {
            td:last-child {
                text-align: right;
            }
        }
    }
`;
const StyledPitchInfoStats = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    ${StyledStatList}, table {
        width: 100%;
    }
`;
const PitchInfoStats = (props) => {
    const { t: translate } = useTranslation();
    const items = [
        { label: translate('baseball.batter'), value: props.batter },
        { label: translate('baseball.pitcher_one'), value: props.pitcher },
    ];
    return (React.createElement(StyledPitchInfoStats, null,
        React.createElement(StatList, { items: items, columns: 1 }),
        React.createElement(StyledScoreboardTable, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, props.awayteamabbr),
                    React.createElement("td", null, props.istop ? props.scorebatting : props.scorefielding),
                    React.createElement("td", { rowSpan: 2 }, props.bcbefore !== null && React.createElement(BaseRunners, { width: 42, height: 31, baseState: props.bcbefore }))),
                React.createElement("tr", null,
                    React.createElement("td", null, props.hometeamabbr),
                    React.createElement("td", null, props.istop ? props.scorefielding : props.scorebatting)),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement(StyledTopBottomInning, null, props.istop ? '▲' : '▼'),
                        "\u00A0",
                        props.inning),
                    React.createElement("td", null, props.outsbefore !== null && (React.createElement(React.Fragment, null,
                        props.outsbefore,
                        "\u00A0",
                        React.createElement(StyledOutsLabel, null, translate('baseball.outs', { count: props.outsbefore }))))),
                    React.createElement("td", null,
                        props.balls,
                        "-",
                        props.strikes))))));
};

/* eslint-disable max-len */
const StyledPitchTypePill = styled(Badge).attrs({ pill: true }) `
    &&& {
        font-size: 12px;
        padding: 3px 12px;
    }
`;
const PitchTypeLocationStats = (props) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    const result = pitchResult(props.resultid, false, translate, (_a = props.hasabsreview) !== null && _a !== void 0 ? _a : false, (_b = props.isoverturned) !== null && _b !== void 0 ? _b : false);
    let strikeZoneSeries = null;
    if (isNumber$2(props.platex, props.platez)) {
        strikeZoneSeries = [
            {
                type: 'scatter',
                enableMouseTracking: false,
                marker: { radius: 5 },
                data: [{ x: props.platex, y: props.platez }],
            },
        ];
    }
    return (React.createElement(React.Fragment, null,
        !props.isMobileView && !!props.pitchtype && (React.createElement(StyledPitchTypePill, { variant: "primary" },
            pitchType(props.pitchtype, true, undefined, translate),
            props.fxsubtype && ` (${pitchSubType(props.fxsubtype, true, undefined, translate)})`,
            !!props.velocity && ` (${translate('format.abbr-mph', { value: format(props.velocity, 0) })})`)),
        strikeZoneSeries && (React.createElement(StrikeZone$3, { size: "xs", showlhb: !!props.islhb, yopposite: !!props.islhb, seriesData: strikeZoneSeries, sztop: props.sztop || undefined, szbottom: props.szbottom || undefined, useABSRulebookZone: true, useBaseballMarkers: true })),
        !props.isMobileView && (React.createElement(StatList, { columns: 1, items: [{ label: translate('components.video.result'), value: result }] }))));
};

const StyledPitchInPlayStats = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${({ $hasLocation }) => ($hasLocation ? 'space-between' : 'center')};
    height: 100%;
    && {
        p {
            margin-bottom: 0;
        }
    }
`;
const PitchInPlayStats = (props) => {
    const { t: translate } = useTranslation();
    const hasBallInPlayLoc = isNumber$2(props.ballinplayx, props.ballinplayy);
    const hitProperties = [
        isNumber$2(props.hitvelocity) ? `${translate('format.abbr-mph', { value: format(props.hitvelocity, 1) })}` : null,
        isNumber$2(props.launchangle) ? `${format(props.launchangle, 1)}°` : null,
        isNumber$2(props.distance) ? `${format(props.distance, 0)}${translate('components.video.filters.abbr-feet')}` : null,
    ].filter((x) => x);
    return (React.createElement(StyledPitchInPlayStats, { "$hasLocation": hasBallInPlayLoc },
        React.createElement("div", null,
            React.createElement("p", null,
                React.createElement("b", null,
                    hitType(props.hittype, true, translate),
                    isNumber$2(props.bipfielderpos) && props.bipfielderpos > 0 ? ` ${translate('common.to')} ${positionName(props.bipfielderpos, translate)}` : '')),
            !!hitProperties.length && React.createElement("p", null,
                "(",
                hitProperties.join(', '),
                ")"),
            props.eventdescription && React.createElement("p", null,
                translate('components.video.result'),
                ": ",
                React.createElement("b", null, props.eventdescription))),
        hasBallInPlayLoc && (React.createElement(HitLocation, { ballinplayx: props.ballinplayx, ballinplayy: props.ballinplayy, ishr: !!props.ishr }))));
};

const StyledVideoStatsSection = styled.div `
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    font-size: 12px;
`;
const StyledStatListSection = styled(StyledVideoStatsSection) `
    flex-grow: 2;
`;
const StyledPitchLocationSection = styled(StyledVideoStatsSection) `
    flex-direction: column;
    justify-content: space-between;
`;
const StyledVideoStats = styled.div `
    height: ${statsContainerHeight}px;
    position: relative;
    background-color: ${theme.background.blueZodiac};
    display: flex;
    justify-content: center;
    padding: 10px 0;
    color: white;
    ${({ $showSectionDividers }) => ($showSectionDividers ? `
        > div + div:not([data-section='pitching-stats']) {
            border-left: 1px solid ${theme.border.paleSky};
            border-left-color: color-mix(in srgb, ${theme.border.paleSky} 40%, transparent);
        }
    ` : '')}
    .spinner-border, .no-data-message {
        margin-top: 47.5px;
    }
`;
const VideoStats = ({ data, containerWidth, isMobileView = false, loading = false }) => {
    const { t: translate } = useTranslation();
    const sections = [];
    if (!loading && data) {
        const pitchingStatItems = getPitchingStatItems(data, translate);
        const batTrackingStats = getBatTrackingStats(data, translate);
        const hitType = data.islastpitch && typeof data.hittype === 'number' && Number.isFinite(data.hittype)
            ? data.hittype
            : null;
        const hasLimitedWidth = typeof containerWidth === 'number' && containerWidth < bootstrapLg;
        const shouldHidePitchInfoForSpace = hasLimitedWidth
            && !!pitchingStatItems.length
            && batTrackingStats !== null
            && hitType !== null;
        const shouldShowPitchInfo = !isMobileView
            && !!(data.batter || data.pitcher)
            && !shouldHidePitchInfoForSpace;
        if (shouldShowPitchInfo) {
            sections.push(React.createElement(StyledVideoStatsSection, { key: "pitch-info" },
                React.createElement(PitchInfoStats, Object.assign({}, data))));
        }
        sections.push(React.createElement(StyledPitchLocationSection, { key: "pitch-location" },
            React.createElement(PitchTypeLocationStats, Object.assign({ isMobileView: isMobileView }, data))));
        if (pitchingStatItems.length) {
            sections.push(React.createElement(StyledStatListSection, { key: "pitching-stats", "data-section": "pitching-stats" },
                React.createElement(StatList, { items: pitchingStatItems })));
        }
        if (batTrackingStats !== null) {
            sections.push(React.createElement(StyledStatListSection, { key: "bat-tracking-stats" },
                React.createElement(BatTrackingStats, { stats: batTrackingStats, isMobileView: isMobileView })));
        }
        if (hitType !== null) {
            sections.push(React.createElement(StyledVideoStatsSection, { key: "pitch-in-play" },
                React.createElement(PitchInPlayStats, Object.assign({}, data, { hittype: hitType }))));
        }
    }
    return (React.createElement(StyledVideoStats, { "$showSectionDividers": !isMobileView },
        loading && React.createElement(LoadingSpinner$1, null),
        !loading && !sections.length && (React.createElement("div", { className: "no-data-message" }, translate('components.video.no-data-found'))),
        !loading && !!sections.length && sections));
};
const videoStatsMemo = memo(VideoStats);

const buttonHeight = 40;
const buttonMargin = 9;
const StyledVideoToggleButtons = styled(ToggleButtons) `
    padding-right: 16px;
    flex-wrap: ${(props) => (props.$numRows > 1 ? 'wrap' : '')};
    flex-direction: ${(props) => (props.$numRows > 1 ? 'column' : 'row')};
    ${(props) => `max-height: ${props.$numRows * (buttonHeight + buttonMargin)}px;`}
    &&& {
        .btn {
            flex: 0 0 auto;
            width: 42px;
            height: ${buttonHeight}px;
            font-size: 14px;
            margin-bottom: ${buttonMargin}px;
            display: flex;
            align-items: center;
            justify-content: center;
            ${(props) => (props.$includeAll ? `
                &:first-of-type {
                    height: ${(props.$numRows * (buttonHeight + buttonMargin)) - buttonMargin}px;
                    padding: 
                }
            ` : '')}
            &.disabled, :disabled {
                box-shadow: none;
            }
            &:not(:first-of-type) {
                width: ${(props) => (isNumber$2(props.$width) ? (`${props.$width || 42}px`) : props.$width)};
            }
        }
    }
`;
const VideoFilterToggleButton = ({ filter, name, options, playlist, onChange, rows, includeAll = true, type = 'checkbox', defaultValue = -1, width, ignoreSort = false }) => {
    const filterOptions = [...options];
    if (includeAll) {
        filterOptions.unshift({ name: 'All', value: -1 });
    }
    const numRows = rows || (Math.floor(filterOptions.length / 6) + 1);
    const mappedOptions = filterOptions.map((o, idx) => {
        const option = typeof o === 'object' ? o : { name: o.toString(), value: o };
        return Object.assign(Object.assign({}, option), { idx, disabled: playlist === null ? false : (playlist != null && option.value !== -1 && !playlist.some(({ data }) => {
                var _a, _b;
                if (name === 'bcbefore' && option.value)
                    return !!data.bcbefore;
                if (name === 'inning' && option.value === 10)
                    return data.inning >= 10;
                if (name === 'sourceLabels')
                    return (_a = data[name]) === null || _a === void 0 ? void 0 : _a.includes((_b = option.value) === null || _b === void 0 ? void 0 : _b.toString());
                return data[name] === option.value;
            })) });
    }).sort((a, b) => {
        if (numRows === 1 || ignoreSort)
            return 0;
        if (includeAll && a.idx === 0)
            return -1;
        if (includeAll && b.idx === 0)
            return 1;
        const numCols = includeAll ? 5 : 6;
        return ((a.idx - (includeAll ? 1 : 0)) % numCols) - ((b.idx - (includeAll ? 1 : 0)) % numCols);
    });
    return (React.createElement(StyledVideoToggleButtons, { "$includeAll": includeAll, "$numRows": numRows, "$width": width, name: name, type: type, options: mappedOptions, value: filter && filter[name], onChange: (value, btnName) => onChange(value, btnName, type === 'checkbox'), defaultValue: defaultValue, separated: true }));
};

const StyledVideoFilterSection$1 = styled.div `
    padding: 12px 12px 0 0;
    text-align: left;
    label {
        font-size: 11px;
        padding-right: 7px;
        text-align: right;
        color: ${theme.fontColors.tundora};
    }
    .filter-title {
        margin-bottom:2px;
        text-align: left;
        label {
            font-weight: bold;
            margin-bottom: 0;
            width: initial;
        }
    }
    && {
        .btn.btn-link {
            padding: 0;
            line-height: 0;
            position: relative;
            top: -1.5px;
        }
    }
`;
const VideoFilterSection$1 = ({ title, children, playlist, requiredFields, onClear, className }) => {
    const { t: translate } = useTranslation();
    const fields = Array.isArray(requiredFields) ? requiredFields : [requiredFields];
    const hasAnyDataWithFields = playlist.some(({ data }) => data
        && fields.every((f) => data[f] !== null && data[f] !== undefined));
    return (React.createElement(React.Fragment, null, hasAnyDataWithFields && (React.createElement(StyledVideoFilterSection$1, { className: className },
        React.createElement("div", { className: "filter-title" },
            React.createElement("label", null, title),
            onClear && React.createElement(Button, { variant: "link", size: "sm", onClick: onClear },
                "(",
                translate('common.clear'),
                ")")),
        children))));
};

const StyledVideoFilterBaseRunners = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: ${filterMarginBottom};
    ${StyledVideoToggleButtons} {
        .btn {
            &:first-of-type, &:last-of-type {
                margin-bottom: 0 !important;
            }
            &:not(:first-of-type) {
                width: 87.5px !important;
            }
        }
    }
    svg {
        margin-right: 15px;
    }
`;
const VideoFilterBaseRunners = ({ playlist, onChange, filter, rows = 1 }) => {
    const { t: translate } = useTranslation();
    const basesEmptyOptions = [{ name: translate('components.video.filters.none-on'), value: 0, id: 'baserunners-0' }, { name: translate('components.video.filters.some-on'), value: 1, id: 'baserunners-1' }];
    const onHasRunnersChange = (value) => {
        onChange(value, 'hasRunners');
        onChange(null, 'bcbefore');
    };
    const onBaseRunnersChange = (value) => {
        onChange(value ? null : undefined, 'hasRunners');
        onChange(value || undefined, 'bcbefore');
    };
    return (React.createElement(StyledVideoFilterBaseRunners, null,
        React.createElement(VideoFilterToggleButton, { filter: filter, name: "hasRunners", onChange: (value) => onHasRunnersChange(value), options: basesEmptyOptions, playlist: playlist, rows: rows, type: "radio" }),
        React.createElement(BaseRunners, { baseState: filter.bcbefore === true ? 0 : filter.bcbefore, onChange: (value) => onBaseRunnersChange(value), emptyColor: theme.border.mercury })));
};

const VideoFilterSectionTitle = ({ title }) => (React.createElement("div", { className: "border-top text-start mt-4 pt-2" }, title));

const StyledVideoFilterSection = styled.div `
    display: flex;
    align-items: center;
    padding: 12px 0 0 0;
    text-align: left;
    label {
        font-size: 11px;
        padding-right: 7px;
        text-align: right;
        color: ${theme.fontColors.tundora};
    }
    .filter-title {
        margin-bottom:2px;
        text-align: left;
        label {
            font-weight: bold;
            margin-bottom: 0;
            width: initial;
        }
    }
    && {
        .btn.btn-link {
            padding: 0;
            line-height: 0;
            position: relative;
            top: -1.5px;
        }
        .btn.btn-default {
            background-color: ${theme.background.geyser};
        }
    }
`;
const VideoFilterSection = ({ title, children, playlist, requiredFields, onClear, className, filter, filterFields }) => {
    const fields = Array.isArray(requiredFields) ? requiredFields : [requiredFields];
    const visibleFields = filterFields ? (Array.isArray(filterFields) ? filterFields : [filterFields]) : fields;
    const [isVisible, setIsVisible] = useState(!!visibleFields
        .every((f) => Object.keys(filter).find((k) => k === f) && filter[f] !== null && filter[f] !== undefined));
    const hasAnyDataWithFields = playlist.some(({ data }) => data
        && fields.every((f) => data[f] !== null && data[f] !== undefined));
    const updateIsVisible = () => {
        if (isVisible && onClear) {
            onClear();
        }
        setIsVisible(!isVisible);
    };
    return (React.createElement(React.Fragment, null, hasAnyDataWithFields && (React.createElement(StyledVideoFilterSection, { className: className },
        React.createElement(Row$1, { className: "w-100 align-items-center" },
            React.createElement(Col$1, { sm: 4 },
                React.createElement(Button, { variant: isVisible ? 'primary' : 'default', onClick: updateIsVisible, className: "me-2 flex-shrink-0 shadow-none border-0 p-2 font-weight-bold rounded", size: undefined }, title)),
            React.createElement(Col$1, { sm: 8 }, isVisible && children))))));
};

const VideoFilterRange = ({ filter, name, onChange, playlist, step, margin }) => {
    const pitchesWithData = playlist.filter(({ data }) => isNumber$2(data[name]));
    let min = 0;
    let max = 0;
    if (pitchesWithData.length) {
        min = Math.min(...pitchesWithData.map(({ data }) => data[name]));
        max = Math.max(...pitchesWithData.map(({ data }) => data[name]));
    }
    const onInputChange = ([newMin, newMax]) => {
        if (newMin <= min && newMax >= max) {
            onChange(undefined, name);
        }
        else {
            onChange(newMin, `${name}.min`);
            onChange(newMax, `${name}.max`);
        }
    };
    return (React.createElement("div", null,
        React.createElement(Range, { showInput: true, min: Math.floor(min), max: Math.ceil(max), value: filter[name] ? [filter[name].min, filter[name].max] : undefined, onChange: onInputChange, step: step, margin: margin })));
};

const VideoFilterPitchLocation = ({ locations, playlist, onChange }) => {
    const { t: translate } = useTranslation();
    const pitchLocationOpts = playlist.map((p) => p.data).filter((x) => x.locationx && x.locationy);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", null,
            translate('baseball.1b'),
            " ",
            translate('components.video.filters.side')),
        React.createElement(PitchLocation$1, { options: pitchLocationOpts, locations: locations, onChange: (value) => onChange(value, 'pitchLocations'), emptyColor: theme.border.mercury }),
        React.createElement("label", null,
            translate('baseball.3b'),
            " ",
            translate('components.video.filters.side'))));
};

const StyledAdvancedIconContainer$3 = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const PitchingFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    var _a;
    const { t: translate } = useTranslation();
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.pitch-location'), playlist: playlist, requiredFields: ['locationx', 'locationy'], filterFields: "pitchLocations", onClear: ((_a = filter.pitchLocations) === null || _a === void 0 ? void 0 : _a.length) ? () => onClear('pitchLocations') : undefined, filter: filter },
            React.createElement(StyledAdvancedIconContainer$3, null,
                React.createElement(VideoFilterPitchLocation, { playlist: playlist, locations: filter.pitchLocations, onChange: onChange }))),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.pitch-velo'), playlist: playlist, requiredFields: "velocity", onClear: () => onClear('velocity'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "velocity", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.spin-rate'), playlist: playlist, requiredFields: "spinrate", onClear: () => onClear('spinrate'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "spinrate", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.break') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.vertical-break'), playlist: playlist, requiredFields: "breakz54", onClear: () => onClear('breakz54'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "breakz54", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.horizontal-break'), playlist: playlist, requiredFields: "breakx54", onClear: () => onClear('breakx54'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "breakx54", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.release') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.horizontal-release'), playlist: playlist, requiredFields: "initposx_55", onClear: () => onClear('initposx_55'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "initposx_55", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.vertical-release'), playlist: playlist, requiredFields: "initposz_55", onClear: () => onClear('initposz_55'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "initposz_55", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.abbr-earned-run-avg') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.rv-era'), playlist: playlist, requiredFields: "rvactualNorm", onClear: () => onClear('rvactualNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvactualNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.01 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.expected-rv-era'), playlist: playlist, requiredFields: "rvexpNorm", onClear: () => onClear('rvexpNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvexpNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.pfx-era'), playlist: playlist, requiredFields: "rvpitchfxNorm", onClear: () => onClear('rvpitchfxNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvpitchfxNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.break-era'), playlist: playlist, requiredFields: "rvbreakNorm", onClear: () => onClear('rvbreakNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvbreakNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.stuff-era'), playlist: playlist, requiredFields: "rvstuffNorm", onClear: () => onClear('rvstuffNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvstuffNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.location-era'), playlist: playlist, requiredFields: "rvlocNorm", onClear: () => onClear('rvlocNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvlocNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 }))));
};

const StyledAdvancedIconContainer$2 = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const StyledHitLocationContainer$1 = styled(StyledAdvancedIconContainer$2) `
    position: relative;
    && {
        .btn-group {
            position: static;
            .btn {
                position: absolute;
                &:nth-of-type(1) { left: 0; } 
                &:nth-of-type(3) { left: 40px; } 
                &:nth-of-type(2) { left: 246px; } 
                &:nth-of-type(4) { left: 204px; } 
                &:nth-of-type(1), &:nth-of-type(2) { bottom: 55px; } 
                &:nth-of-type(3), &:nth-of-type(4) { bottom: 5px; }
            }
        }
    }
    &&&& {
        .btn-group .btn {
            margin: 0;
        }
    }
`;
const HittingFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    var _a;
    const { t: translate } = useTranslation();
    const hitTypeOptions = [{ name: translate('baseball.pitchresult.abbr-groundball'), value: 0 }, { name: translate('baseball.pitchresult.abbr-flyball'), value: 1 }, { name: translate('baseball.pitchresult.abbr-popup'), value: 3 }, { name: translate('baseball.pitchresult.abbr-linedrive'), value: 2 }];
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.hit-location'), playlist: playlist, requiredFields: ['hittype', 'isinfieldbip', 'distance', 'angleto2b', 'ishr'], filterFields: "hitLocations", onClear: ((_a = filter.hitLocations) === null || _a === void 0 ? void 0 : _a.length) ? () => onClear('hitLocations') : undefined, filter: filter },
            React.createElement("div", null,
                React.createElement(StyledHitLocationContainer$1, null,
                    React.createElement(HitLocationSelect, { data: playlist.map((x) => x.data), value: filter.hitLocations, onChange: (value) => onChange(value, 'hitLocations'), emptyColor: theme.border.mercury }),
                    React.createElement(VideoFilterToggleButton, { filter: filter, name: "hittype", onChange: onChange, options: hitTypeOptions, playlist: playlist, includeAll: false })))),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.exit-velo'), playlist: playlist, requiredFields: "hitvelocity", onClear: () => onClear('hitvelocity'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "hitvelocity", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.contact') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.contact-result'), playlist: playlist, requiredFields: "contactResult", onClear: () => onClear('contactResult'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "contactResult", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.contact-quality'), playlist: playlist, requiredFields: "contactQuality", onClear: () => onClear('contactQuality'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "contactQuality", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.launch-angle') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.vert-launch-angle'), playlist: playlist, requiredFields: "vertla", onClear: () => onClear('vertla'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "vertla", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.horizontal-launch-angle'), playlist: playlist, requiredFields: "horizla", onClear: () => onClear('horizla'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "horizla", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.zone') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.zone-depth'), playlist: playlist, requiredFields: "zonedepth", onClear: () => onClear('zonedepth'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "zonedepth", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.swing') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.swinging'), playlist: playlist, requiredFields: "swinging", onClear: () => onClear('swinging'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swinging", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.swinging-first-pitch'), playlist: playlist, requiredFields: "swingingFirstPitch", onClear: () => onClear('swingingFirstPitch'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingFirstPitch", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.swinging-in-zone'), playlist: playlist, requiredFields: "swingingInZone", onClear: () => onClear('swingingInZone'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.chase'), playlist: playlist, requiredFields: "chase", onClear: () => onClear('chase'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "chase", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.miss'), playlist: playlist, requiredFields: "miss", onClear: () => onClear('miss'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "miss", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.miss-in-zone'), playlist: playlist, requiredFields: "missInZone", onClear: () => onClear('missInZone'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "missInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.in-zone'), playlist: playlist, requiredFields: "inZone", onClear: () => onClear('inZone'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.strikeout'), playlist: playlist, requiredFields: "strikeout", onClear: () => onClear('strikeout'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikeout", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.unintentional-walk'), playlist: playlist, requiredFields: "unintentionalWalk", onClear: () => onClear('unintentionalWalk'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "unintentionalWalk", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.swing-decision-score') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.score'), playlist: playlist, requiredFields: "swds", onClear: () => onClear('swds'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "swds", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-swing')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldSwing", onClear: () => onClear('swingDecisionScoreShouldSwing'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "swingDecisionScoreShouldSwing", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-take')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldTake", onClear: () => onClear('swingDecisionScoreShouldTake'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "swingDecisionScoreShouldTake", onChange: onChange, playlist: playlist }))));
};

const FieldingFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    const { t: translate } = useTranslation();
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielder-approach'), playlist: playlist, requiredFields: "fapproach", onClear: () => onClear('fapproach'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fapproach", onChange: onChange, options: [translate('components.video.filters.stand'), translate('components.video.filters.sprint'), translate('components.video.filters.dive'), translate('components.video.filters.jog'), translate('components.video.filters.jump'), translate('components.video.filters.slide')], playlist: playlist, width: 50 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielding-method'), playlist: playlist, requiredFields: "fmethod", onClear: () => onClear('fmethod'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmethod", onChange: onChange, options: [translate('components.video.filters.backhand'), translate('components.video.filters.barehand'), translate('components.video.filters.forehand'), translate('components.video.filters.no-touch'), translate('components.video.filters.over-shoulder')], playlist: playlist, width: 120 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielder-movement'), playlist: playlist, requiredFields: "fmove", onClear: () => onClear('fmove'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmove", onChange: onChange, options: [translate('components.video.filters.back'), translate('components.video.filters.forward'), translate('components.video.filters.right'), translate('components.video.filters.left'), translate('components.video.filters.no-move')], playlist: playlist, width: 85 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielder-throw'), playlist: playlist, requiredFields: "fthrow", onClear: () => onClear('fthrow'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fthrow", onChange: onChange, options: [translate('components.video.filters.feet-planted'), translate('components.video.filters.on-move'), translate('components.video.filters.jump-throw'), translate('components.video.filters.from-ground'), translate('components.video.filters.glove-flip')], playlist: playlist, width: 120 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.difficulty') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.difficulty-opps'), playlist: playlist, requiredFields: "diffopps", onClear: () => onClear('diffopps'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffopps", onChange: onChange, options: [1, 2, 3, 4, 5], playlist: playlist, rows: 1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.difficulty-made'), playlist: playlist, requiredFields: "diffmade", onClear: () => onClear('diffmade'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffmade", onChange: onChange, options: [1, 2, 3, 4, 5], playlist: playlist, rows: 1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.alignment') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.has-shift'), playlist: playlist, requiredFields: "hasShift", onClear: () => onClear('hasShift'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "hasShift", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.runners-on'), playlist: playlist, requiredFields: "runnersOn", onClear: () => onClear('runnersOn'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "runnersOn", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.throw') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.throw-velocity'), playlist: playlist, requiredFields: "throwvelo", onClear: () => onClear('throwvelo'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "throwvelo", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.exchange'), playlist: playlist, requiredFields: "exchange", onClear: () => onClear('exchange'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "exchange", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.route') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.starting-depth'), playlist: playlist, requiredFields: "startingdepth", onClear: () => onClear('startingdepth'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "startingdepth", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.route-efficiency'), playlist: playlist, requiredFields: "routeeffic", onClear: () => onClear('routeeffic'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "routeeffic", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.first-step'), playlist: playlist, requiredFields: "firststep", onClear: () => onClear('firststep'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "firststep", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.first-step-efficiency'), playlist: playlist, requiredFields: "firststepeffic", onClear: () => onClear('firststepeffic'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "firststepeffic", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.top-speed'), playlist: playlist, requiredFields: "topspeed", onClear: () => onClear('topspeed'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "topspeed", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.sprint-speed'), playlist: playlist, requiredFields: "sprintspeed", onClear: () => onClear('sprintspeed'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "sprintspeed", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.distance-covered'), playlist: playlist, requiredFields: "distcovered", onClear: () => onClear('distcovered'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "distcovered", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.top-acceleration'), playlist: playlist, requiredFields: "topacceladj", onClear: () => onClear('topacceladj'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "topacceladj", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.probabilities') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.catch-probability'), playlist: playlist, requiredFields: "catchprobability", onClear: () => onClear('catchprobability'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "catchprobability", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.out-probability'), playlist: playlist, requiredFields: "outProbability", onClear: () => onClear('outProbability'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "outProbability", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.other') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.hang-time'), playlist: playlist, requiredFields: "hangtime", onClear: () => onClear('hangtime'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "hangtime", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 }))));
};

const OtherFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    const { t: translate } = useTranslation();
    const sourceLabelOptions = Array
        .from((new Set(playlist.map((v) => { var _a, _b; return (_b = (_a = v.data.sourceLabels) === null || _a === void 0 ? void 0 : _a.filter((l) => l)) !== null && _b !== void 0 ? _b : []; }).flat())))
        .sort((a, b) => a.localeCompare(b));
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('baseball.inning'), playlist: playlist, requiredFields: "inning", onClear: () => onClear('inning'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inning", onChange: onChange, options: [1, 2, 3, 4, 5, 6, 7, 8, 9, { name: '10+', value: 10 }], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.video-angle'), playlist: playlist, requiredFields: "sourceLabels", onClear: () => onClear('sourceLabels'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "sourceLabels", onChange: onChange, options: sourceLabelOptions, playlist: playlist, width: 200, rows: Math.ceil(sourceLabelOptions.length / 3.0), ignoreSort: true }))));
};

const videoFilterPadding = '0 15px 15px';
const StyledVideoFilterHeader = styled.div `
    ${sideContentHeader}
    > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.border.alto};
    }
`;
const StyledVideoFilterFilters = styled.div `
    flex-grow: 1;
    position: relative;
    > div {
        padding: ${videoFilterPadding};
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        overflow-y: auto;
    }
`;
const StyledVideoFilterFooter = styled.div `
    ${sideContentFooter}
    display: flex;
    justify-content: end;
    position: sticky;
    bottom: -11px;
    z-index: 1;
`;
const StyledVideoFilter = styled.div `
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    z-index: 10;
`;
const StyledVideoFilterContainer = styled.div `
    ${fullscreenSectionMixin}
    ${StyledVideoFilter} {
        height: 100%;
        background-color: white;
    }
`;
const tabs = (translate) => [
    {
        title: translate('components.video.filters.pitching'),
        key: 'pitching',
        filterKeys: ['pitchLocations', 'velocity', 'breakz54', 'breakx54', 'spinrate', 'initposx_55', 'initposz_55', 'rvactualNorm',
            'rvexpNorm', 'rvpitchfxNorm', 'rvbreakNorm', 'rvstuffNorm', 'rvlocNorm'],
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(PitchingFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear })),
    },
    {
        title: translate('components.video.filters.hitting'),
        key: 'hitting',
        filterKeys: ['hitLocations', 'hitvelocity', 'hittype', 'contactResult', 'contactQuality', 'vertla', 'horizla', 'zonedepth',
            'swinging', 'swingingFirstPitch', 'swingingInZone', 'chase', 'miss', 'missInZone', 'inZone', 'strikeout', 'unintentionalWalk',
            'swds', 'swingDecisionScoreShouldSwing', 'swingDecisionScoreShouldTake'],
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(HittingFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear })),
    },
    {
        title: translate('components.video.filters.fielding'),
        filterKeys: ['fapproach', 'fmethod', 'fmove', 'fthrow', 'diffopps', 'diffmade', 'hasShift', 'runnersOn', 'throwvelo', 'exchange',
            'startingdepth', 'routeeffic', 'firststep', 'firststepeffic', 'topspeed', 'sprintspeed', 'distcovered', 'topacceladj',
            'catchprobability', 'outProbability', 'hangtime'],
        key: 'fielding',
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(FieldingFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear })),
    },
    {
        title: translate('components.video.filters.other'),
        filterKeys: ['inning', 'sourceLabels'],
        key: 'other',
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(OtherFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear }))
    },
];
const VideoFilter = ({ filter: appliedFilter, onFilter, playlist, isFullScreenMode, isMobileView, hideDisplay }) => {
    const { t: translate } = useTranslation();
    const pitchTypeOptions = PITCH_TYPES(translate)
        .filter((p) => p.sortorder > 0 && p.sortorder < 20)
        .sort((a, b) => a.sortorder - b.sortorder)
        .map((p) => ({ name: p.abbr, value: p.id }));
    const lhpOptions = [{ name: translate('baseball.lhp'), value: 1 }, { name: translate('baseball.rhp'), value: 0 }];
    const lhbOptions = [{ name: translate('baseball.lhh'), value: 1 }, { name: translate('baseball.rhh'), value: 0 }];
    const [filter, setFilter] = useState(appliedFilter);
    const [activeTabKey, setActiveTabKey] = useState(tabs(translate)[0].key);
    const onTabSelect = ({ key }) => setActiveTabKey(key);
    const activeTab = tabs(translate).find(({ key }) => key === activeTabKey);
    const onApply = (appliedPlaylist, tempFilter) => {
        onFilter(appliedPlaylist, Object.assign({}, tempFilter));
        hideDisplay();
    };
    const onCancel = () => {
        setFilter(Object.assign({}, appliedFilter));
        hideDisplay();
    };
    const onChange = (value, name, isMultiselect) => setFilter((tempFilter) => {
        var _a;
        let newValue = value;
        if (isMultiselect) {
            // scenario 1: all options are deselected
            if (Array.isArray(newValue) && !newValue.length) {
                newValue = [-1];
            }
            else {
                const newDestinctOptions = newValue.filter((v) => !isSelectAllValue(v));
                if (newDestinctOptions.length) {
                    const numOldDistinctOptions = ((_a = tempFilter[name]) === null || _a === void 0 ? void 0 : _a.filter((v) => !isSelectAllValue(v)).length) || 0;
                    // scenario 2: Only "All" was checked and user selects an individual value to filter by
                    if (!numOldDistinctOptions)
                        newValue = newDestinctOptions;
                    // scenario 3: options were filtered, and user wants to go back to "All"
                    else if (numOldDistinctOptions && Array.isArray(newValue) && newValue.length > newDestinctOptions.length)
                        newValue = [-1];
                    // scenario 4: multiple non-"All" values are selected
                    // (do nothing)
                }
            }
        }
        return set(tempFilter, name, newValue);
    });
    const onClear = (name) => setFilter((tempFilter) => (Object.assign(Object.assign({}, tempFilter), { [name]: undefined })));
    const onClearAll = () => {
        setFilter({});
        onApply(playlist, {});
    };
    const playlistToBeApplied = filterPlaylistFromParams(playlist, filter);
    const numAppliedFilters = (filterKeys) => Object.entries(filter)
        .filter(([key]) => { var _a; return (_a = filterKeys === null || filterKeys === void 0 ? void 0 : filterKeys.includes(key)) !== null && _a !== void 0 ? _a : true; })
        .filter(([, f]) => {
        const filterAsArray = Array.isArray(f) ? f : [f];
        return filterAsArray.some((x) => !isSelectAllValue(x));
    }).length;
    return (React.createElement(StyledVideoFilterContainer, { className: `${isFullScreenMode ? 'fullscreen' : ''} ${isMobileView ? 'mobile-view' : ''}`, fullscreen: isFullScreenMode, onClick: isFullScreenMode ? hideDisplay : undefined },
        React.createElement(StyledVideoFilter, { onClick: (e) => e.stopPropagation() },
            React.createElement(StyledVideoFilterHeader, null,
                React.createElement("div", null,
                    React.createElement("h4", null,
                        translate('components.video.filters.filters'),
                        " (",
                        numAppliedFilters(),
                        ")"),
                    React.createElement(VideoPlayerButton$1, { icon: "cross", onClick: onCancel, className: "border-0" }))),
            React.createElement(StyledVideoFilterFilters, null,
                React.createElement("div", { className: "h-100 w-100" },
                    React.createElement("div", { className: "container d-flex flex-wrap align-content-start" },
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.pither-hand'), playlist: playlist, requiredFields: "pitcherHand" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "pitcherHand", onChange: onChange, options: lhpOptions, playlist: playlist, type: "radio" })),
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.batter-hand'), playlist: playlist, requiredFields: "batterHand" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "batterHand", onChange: onChange, options: lhbOptions, playlist: playlist, type: "radio" })),
                        React.createElement(VideoFilterSection$1, { title: `${translate('baseball.count')} (${translate('baseball.balls_other')})`, playlist: playlist, requiredFields: "balls" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "balls", onChange: onChange, options: [0, 1, 2, 3], playlist: playlist })),
                        React.createElement(VideoFilterSection$1, { title: `${translate('baseball.count')} (${translate('baseball.strikes_other')})`, playlist: playlist, requiredFields: "strikes" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikes", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
                        React.createElement(VideoFilterSection$1, { title: translate('baseball.outs_other'), playlist: playlist, requiredFields: "outsbefore" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "outsbefore", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.baserunners'), playlist: playlist, requiredFields: ['bcbefore', 'hasRunners'] },
                            React.createElement(VideoFilterBaseRunners, { playlist: playlist, filter: filter, onChange: onChange })),
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.pitch-type'), playlist: playlist, requiredFields: "type" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "type", onChange: onChange, options: pitchTypeOptions, playlist: playlist, rows: 1 }))),
                    React.createElement("div", { className: "w-100" },
                        React.createElement(TabContainer, null, tabs(translate).map((t) => {
                            const { key, title } = t, rest = __rest(t, ["key", "title"]);
                            return (React.createElement(Tab, Object.assign({ key: key, active: t === activeTab, onClick: () => onTabSelect(t) }, rest, { className: "flex-grow-1" }),
                                title,
                                " (",
                                numAppliedFilters(t.filterKeys),
                                ")"));
                        })),
                        React.createElement(TabPanel, null,
                            React.createElement("div", { className: "container" }, activeTab === null || activeTab === void 0 ? void 0 : activeTab.component({ filter, playlist, onChange, onClear })))))),
            React.createElement(StyledVideoFilterFooter, null,
                React.createElement("div", null,
                    React.createElement(Button, { onClick: onClearAll }, translate('common.clear')),
                    React.createElement(Button, { variant: "primary", onClick: () => onApply(playlistToBeApplied, filter) }, translate('common.apply')))))));
};
var VideoFilter$1 = memo(VideoFilter, (prevProps, nextProps) => prevProps.filter === nextProps.filter
    && prevProps.playlist === nextProps.playlist
    && prevProps.isFullScreenMode === nextProps.isFullScreenMode
    && prevProps.isMobileView === nextProps.isMobileView);

const StyledDownloadModal = styled(BaseModal) `&&
    z-index: 1061;
    .modal-body {
        padding: 5px;
    }
    .table-responsive {
        min-height: 310px;
        max-height: 400px;
        thead th {
            white-space: nowrap;
            .dropdown {
                display: inline-block;
            }
        }
        .nyy-checkbox-radio-container {
            margin: 0;
            label {
                color: initial;
            }
        }
        .btn.btn-link {
            padding: 0;
        }
    }
`;
const DownloadVideosModal = ({ download, playlist, modalContainer }) => {
    const { t: translate } = useTranslation();
    const [showDownloadModal, setShowModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [videoPreviewSrc, setVideoPreviewSrc] = useState();
    const mappedPlaylist = playlist.map((p, idx) => (Object.assign(Object.assign({}, p), { idx, angles: p.sources.reduce((acc, s) => (Object.assign(Object.assign({}, acc), { [s.label]: s.file })), {}), angleOptions: p.sources.map((s) => ({ name: s.label })) })));
    const mainAngle = mappedPlaylist[0].angleOptions[0].name;
    // eslint-disable-next-line no-nested-ternary
    const defaultAngles = mappedPlaylist.map((p) => (p.angles[mainAngle] ? mainAngle : (p.angleOptions.length > 0 ? p.angleOptions[0].name : null)));
    const [angleHeaderValue, setAngleHeaderValue] = useState(mainAngle);
    const [selectedVideos, setSelectedVideos] = useState(Array(mappedPlaylist.length).fill(true));
    const [selectedAngles, setSelectedAngles] = useState(defaultAngles);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const selectHeaderAngle = (_val, key) => {
        setAngleHeaderValue(key);
        setSelectedAngles((angles) => angles.map((angle, idx) => {
            const pitchAngleOptions = mappedPlaylist[idx].angleOptions;
            return pitchAngleOptions.some((ao) => ao.name === key) ? key : angle;
        }));
    };
    const selectVideoAngle = (idx, key) => {
        setSelectedAngles((angles) => ([...angles.slice(0, idx), key, ...angles.slice(idx + 1)]));
    };
    const selectHeaderInclude = (e) => {
        const { checked } = e.currentTarget;
        setSelectedVideos(Array(mappedPlaylist.length).fill(checked));
    };
    const selectVideoInclude = (idx, e) => {
        const { checked } = e.currentTarget;
        setSelectedVideos((selected) => ([...selected.slice(0, idx), checked, ...selected.slice(idx + 1)]));
    };
    const downloadVideos = () => __awaiter(void 0, void 0, void 0, function* () {
        const videoSources = selectedVideos
            .reduce((acc, cur, idx) => {
            if (cur)
                return [...acc, idx];
            return acc;
        }, new Array())
            .map((selectedIndex) => mappedPlaylist[selectedIndex].angles[selectedAngles[selectedIndex]]);
        handleClose();
        setIsDownloading(true);
        yield download(videoSources);
        setIsDownloading(false);
    });
    const allAngleOptions = Array.from(new Set(mappedPlaylist.flatMap((p) => p.angleOptions).map((s) => s.name))).map((name) => ({ name }));
    const tableColumns = [
        { id: 'video-button',
            type: COLUMN_TYPES.NODE,
            transform: ({ idx, angles }) => (React.createElement(Button, { variant: "link", onClick: () => setVideoPreviewSrc(angles[selectedAngles[idx]]) },
                React.createElement(Icon, { icon: "video-camera" }))) },
        { id: 'idx', title: '#', transform: ({ idx }) => idx + 1 },
        { id: 'title',
            type: COLUMN_TYPES.NODE,
            title: translate('components.video.title'),
            transform: ({ title, description }) => (React.createElement("div", null,
                title,
                React.createElement("br", null),
                React.createElement("small", null, description))) },
        { id: 'angle',
            type: COLUMN_TYPES.NODE,
            cellClass: 'text-center',
            headerClass: 'text-center',
            title: () => (React.createElement(DropdownInput, { options: allAngleOptions, value: angleHeaderValue, onSelect: selectHeaderAngle })),
            transform: ({ angleOptions, idx }) => (React.createElement(DropdownInput, { options: angleOptions, value: selectedAngles[idx], onSelect: (_val, key) => selectVideoAngle(idx, key) })) },
        { id: 'include',
            type: COLUMN_TYPES.NODE,
            cellClass: 'text-center',
            headerClass: 'text-center',
            title: () => (React.createElement(Checkbox, { label: translate('components.video.abbr-include'), labelDirection: "left", checked: selectedVideos.every((v) => v), onChange: selectHeaderInclude, id: "playlistcheckbox" })),
            transform: ({ idx }) => (React.createElement(Checkbox, { checked: selectedVideos[idx], onChange: (e) => selectVideoInclude(idx, e), id: `playlistcheckbox_${idx}` })) },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(VideoPlayerButton$1, { title: translate('components.video.download'), icon: "download", onClick: handleShow, loading: isDownloading, showLabel: true }),
        React.createElement(StyledDownloadModal, { show: showDownloadModal, onHide: handleClose, container: modalContainer },
            React.createElement(StyledDownloadModal.Header, null, translate('components.video.download-clips')),
            React.createElement(StyledDownloadModal.Body, null,
                React.createElement(DataTable, { columns: tableColumns, rows: mappedPlaylist }),
                videoPreviewSrc && (React.createElement("div", { className: "mt-2 text-center" },
                    React.createElement(Video, { src: videoPreviewSrc, controls: true })))),
            React.createElement(StyledDownloadModal.Footer, null,
                React.createElement(Button, { variant: "secondary", onClick: handleClose }, translate('common.cancel')),
                React.createElement(Button, { variant: "primary", onClick: downloadVideos }, translate('components.video.download'))))));
};
var DownloadVideosModal$1 = memo(DownloadVideosModal, (prevProps, nextProps) => prevProps.playlist === nextProps.playlist);

const SelectGridSizeModal = ({ onSelectGridSize, modalContainer, isActive = false }) => {
    const { t: translate } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const options = [
        { name: translate('components.video.large'), value: 100 },
        { name: translate('components.video.medium'), value: 50 },
        { name: translate('components.video.small'), value: 25 },
    ];
    const onButtonClick = () => {
        if (isActive)
            onSelectGridSize(null);
        else
            setShowModal(true);
    };
    const onModalHide = (selectedValue) => {
        setShowModal(false);
        if (selectedValue)
            onSelectGridSize(selectedValue.value);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(VideoPlayerButton$1, { title: translate('components.video.display-grid'), icon: "grid", onClick: onButtonClick, showLabel: true, isActive: isActive }),
        React.createElement(SelectListModal, { title: translate('components.video.please-select-grid'), options: options, label: "name", show: showModal, onHide: onModalHide, container: modalContainer })));
};

const ReportBadVideoModal = ({ modalContainer, isActive = false, onClick, reportBadVideo, currentVideo, selectedAngle, errors }) => {
    const { t: translate } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        setShowModal(true);
    };
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (reportBadVideo) {
            yield reportBadVideo(subject, description, currentVideo, selectedAngle, errors);
        }
        setShowModal(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(VideoPlayerButton$1, { title: translate('components.video.report-bad-video'), icon: "video-camera", onClick: handleClick, showLabel: true, isActive: isActive }),
        React.createElement(BaseModal, { show: showModal, onHide: () => setShowModal(false), container: modalContainer },
            React.createElement(BaseModal.Header, null, translate('components.video.report-bad-video')),
            React.createElement(BaseModal.Body, null,
                React.createElement(Form$1.Group, null,
                    React.createElement(Form$1.Control, { className: "reportBadVideoModalField", type: "text", placeholder: translate('components.video.subject'), value: subject, onChange: (e) => setSubject(e.target.value) })),
                React.createElement(Form$1.Group, null,
                    React.createElement(Form$1.Control, { className: "reportBadVideoModalField", type: "text", as: "textarea", placeholder: translate('components.video.description'), rows: 3, value: description, onChange: (e) => setDescription(e.target.value) }))),
            React.createElement(BaseModal.Footer, null,
                React.createElement(Button, { variant: "secondary", onClick: () => setShowModal(false) }, translate('common.cancel')),
                React.createElement(Button, { variant: "primary", onClick: submit, disabled: !subject }, translate('common.submit'))))));
};

const StyledVideoPlayerHeatmap = styled.div `
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: 0.85;
    && {
        .spinner-border {
            margin-top: -50px;
            margin-left: 20px;
        }
        .no-data-message {
            color: white;
            width: 90px;
            word-spacing: 90px;
            margin-bottom: 15px;
        }
    }
`;
const heatMapSize = 200;
const VideoPlayerHeatmap = ({ heatmap, plateX, plateZ, sztop, szbottom }) => {
    const { t: translate } = useTranslation();
    const src = (heatmap === null || heatmap === void 0 ? void 0 : heatmap.HeatMapImg) && base64ToBlob(heatmap);
    const pitchLocationSeries = useMemo(() => {
        if (!isNumber$2(plateX, plateZ))
            return [];
        return [{
                type: 'scatter',
                data: [{ x: plateX, y: plateZ }],
                marker: { radius: 5, symbol: 'circle', fillColor: '#000000' },
                states: { hover: { enabled: false } },
            }];
    }, [plateX, plateZ]);
    return (React.createElement(StyledVideoPlayerHeatmap, null,
        (heatmap === null || heatmap === void 0 ? void 0 : heatmap.loading) && React.createElement(LoadingSpinner$1, null),
        src && heatmap.ModelID === heatMapModelIds.CatcherWristband && (React.createElement(CatcherWristbandHeatMap, { src: src, size: heatMapSize, plateX: plateX, plateZ: plateZ, is2K: heatmap.Split === 'TwoStrikes', grade: heatmap.val, includeBackground: true })),
        src && heatmap.ModelID !== heatMapModelIds.CatcherWristband && (React.createElement(StrikeZone$3, { seriesData: pitchLocationSeries, size: "sm", hideGrid: true, hideAxis: true, heatMapBackground: src, showHeatMapBackground: true, showbatter: false, sztop: sztop, szbottom: szbottom, useABSRulebookZone: true, useBaseballMarkers: true })),
        heatmap === null && (React.createElement("p", { className: "no-data-message" }, translate('components.video.no-heatmap')))));
};
var VideoPlayerHeatmap$1 = memo(VideoPlayerHeatmap, (prevProps, nextProps) => {
    var _a, _b, _c, _d, _e, _f;
    return ((_a = prevProps.heatmap) === null || _a === void 0 ? void 0 : _a.loading) === ((_b = nextProps.heatmap) === null || _b === void 0 ? void 0 : _b.loading)
        && ((_c = prevProps.heatmap) === null || _c === void 0 ? void 0 : _c.ContentType) === ((_d = nextProps.heatmap) === null || _d === void 0 ? void 0 : _d.ContentType)
        && ((_e = prevProps.heatmap) === null || _e === void 0 ? void 0 : _e.HeatMapImg) === ((_f = nextProps.heatmap) === null || _f === void 0 ? void 0 : _f.HeatMapImg)
        && prevProps.plateX === nextProps.plateX
        && prevProps.plateZ === nextProps.plateZ
        && prevProps.sztop === nextProps.sztop
        && prevProps.szbottom === nextProps.szbottom;
});

const StyledVideoPlayerGridTable = styled.table `
    ${({ $width, $height, $offsetX, $offsetY }) => `
        width: ${$width}px;
        height: ${$height}px;
        ${($offsetX ? `margin-left: -${$offsetX}px;` : '')}
        ${($offsetY ? `margin-top: -${$offsetY}px;` : '')}
    `}
    table-layout: fixed;
    td {
        border: 1px solid ${theme.border.bombay};
    }
    > tbody > tr {
        &:first-child > td { border-top: none; }
        &:last-child > td { border-bottom: none; }
        > td:first-child { border-left: none; }
        > td:last-child { border-right: none; }
    }
`;
const StyledVideoPlayerGrid = styled.div `
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
`;
const VideoPlayerGrid = (_a) => {
    var { gridSize, containerWidth, containerHeight } = _a, rest = __rest(_a, ["gridSize", "containerWidth", "containerHeight"]);
    const cols = new Array(Math.ceil(containerWidth / gridSize)).fill(0).map((x, idx) => x + idx);
    const rows = new Array(Math.ceil(containerHeight / gridSize)).fill(0).map((y, idx) => y + idx);
    const width = gridSize * cols.length;
    const height = gridSize * rows.length;
    return (React.createElement(StyledVideoPlayerGrid, Object.assign({}, rest),
        React.createElement(StyledVideoPlayerGridTable, { "$width": width, "$height": height, "$offsetX": (width - containerWidth) / 2, "$offsetY": (height - containerHeight) / 2 },
            React.createElement("tbody", null, rows.map((row) => (React.createElement("tr", { key: row }, cols.map((col) => React.createElement("td", { key: col })))))))));
};
var VideoPlayerGrid$1 = memo(VideoPlayerGrid, (prevProps, nextProps) => prevProps.gridSize === nextProps.gridSize
    && prevProps.containerWidth === nextProps.containerWidth
    && prevProps.containerHeight === nextProps.containerHeight);

const StyledVideoPlayer$1 = styled.div.attrs({ className: 'modal-border-bottom' }) `
    display: flex;
    flex-direction: column;
    max-width: 100%;
    background-color: ${videoPlayerBackground};
    flex-grow: 1;
`;
const StyledVideoContainer$1 = styled.div `
    flex-grow: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${(props) => (props.$fullscreen ? 'position: relative;' : '')}
    ${(props) => (props.$fullscreen ? `
        video {
            min-height: 100%;
            width: auto;
            max-height: 1px; // fill-available (deprecated?)
        }
    ` : '')}
    .no-data-message {
        text-transform: uppercase;
        font-size: 1.25em;
        text-align: center;
    }
`;
const StyledVideoControlsSection = styled.div `
    margin-right: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &.flex-grow-1 {
        flex-grow: 1;
    }
    ${VideoPlayerButton$1} {
        margin: 0 5px;
    }
    &&& ${VideoPlayerButton$1} {
        padding: 4px 5px;
    }
    && label {
        margin: 0 0 0 10px;
        color: ${theme.fontColors.silver};
        font-size: 1.4em;
    }
    ${(props) => (props.$width >= bootstrapMd ? `
        &&& ${VideoPlayerButton$1} {
            padding: 8px 8.5px;
        }
    ` : '')}
    ${(props) => (props.$width >= bootstrapLg ? `
        margin-right: 30px;
        &&& ${VideoPlayerButton$1} {
            &.high-use {
                padding-left: 17.5px;
                padding-right: 17.5px;
            }
        }
    ` : '')}
`;
const StyledVideoControls = styled.div.attrs({ className: 'modal-border-bottom' }) `
    background-color: ${videoPlayerBackground};
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 5px;
    height: ${footerHeight.mobile}px;
    ${StyledVideoControlsSection}:last-of-type {
        margin-right: 0;
    }
    ${(props) => (!browser$1.mobileOnly && props.$width >= bootstrapMd ? `
        height: ${footerHeight.desktop}px;
    ` : '')}
    ${(props) => (props.$width >= bootstrapXl ? `
        padding-left: 15px;
        padding-right: 15px;
    ` : '')}
`;
const StyledVideoPlaylistContainer = styled.div.attrs({ className: 'video-playlist-container' }) `
    display: flex;
    flex-direction: column;
    max-width: 100%;
    position: relative;
    ${(props) => (props.$roundCorners ? `
        border: 1px solid ${styles.pSBC(-0.1, styles.theme.background.geyser)};
        border-radius: 0.25rem;
        overflow: clip;
    ` : '')}
`;
const StyledVideoPlaylistHeader = styled.div.attrs({ className: 'modal-border-top' }) `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: ${theme.background.blueZodiac};
    min-height: ${headerHeight}px;
    text-align: left;
    && h4 {
        color: white;
        font-weight: bold;
        margin: 7px 10px 0;
        + label {
            margin-left: 25px;
            margin-bottom: 4px;
        }
    }
    ${StyledVideoControlsSection}:last-of-type {
        margin-right: 5px;
    }
    ${(props) => (props.$width >= bootstrapXl ? `
        && h4 {
            margin-left: 15px;
            + label {
                margin-left: 30px;
            }
        }
        ${StyledVideoControlsSection}:last-of-type {
            margin-right: 15px;
        }
    ` : '')}
`;
const StyledFullScreenVideoControlsSection = styled(StyledVideoControlsSection) `
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: rgba(0, 0, 0, .65);
    padding: 10px 5px;
    height: 100%;
    max-height: 235px;
    ${(props) => (props.$width >= bootstrapMd ? `
        max-height: ${props.$has5Buttons ? '375px' : '350px'};
        padding-top: 20px;
        padding-bottom: 20px;
    ` : '')}
    ${(props) => (props.$width >= bootstrapLg ? `
        &&& ${VideoPlayerButton$1}.high-use {
            padding: 8px 8.5px;
        }
    ` : '')}
`;
const StyledFullScreenVideoControls = styled(StyledVideoControls) `
    background: transparent;
    position: absolute;
    top: 0;
    ${(props) => (props.$left ? 'left: 0;' : '')}
    ${(props) => (props.$right ? 'right: 0;' : '')}
    display: flex;
    align-items: center;
    padding: 0 !important;
    height: 100%;
    ${(props) => (props.$left ? `
        ${StyledFullScreenVideoControlsSection} {
            padding-left: 5px;
            ${borderRadiuses('5px', '5px')}
        }
        ${props.$width >= bootstrapMd ? `
            ${StyledFullScreenVideoControlsSection} {
                padding-left: 7.5px;
            }
        ` : ''}
    ` : '')}
    ${(props) => (props.$right ? `
        ${StyledFullScreenVideoControlsSection} {
            padding-right: 5px;
            ${borderRadiuses(0, 0, '5px', '5px')}
        }
        ${props.$width >= bootstrapMd ? `
            ${StyledFullScreenVideoControlsSection} {
                padding-right: 7.5px;
            }
        ` : ''}
    ` : '')}
`;
const StyledVideoContentContainer = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    outline: none;
    .spinner-border {
        position: absolute;
        margin-left: calc(50% - 16px);
    }
    video:not([src]) {
        display: none;
        visibility: hidden;
    }
`;
const StyledVideoMessage = styled.div `
    width: 100%;
    label {
        color: ${theme.fontColors.silver};
        font-size: 1.4em;
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        + label {
            font-size: 1.2em;
            margin-top: 22.5px;
        }
    }
`;
const StyledVideoNotFound = styled(StyledVideoMessage) `
    position: relative;
    padding-top: ${9 / 16 * 100}%;
`;
const StyledVideoError = styled(StyledVideoMessage) `
    position: absolute;
`;
const StyledActionMenuPopover = styled(Popover) `
    &&& {
        background-color: ${videoPlayerBackground};
        border-color: ${theme.fontColors.silver};
        > .arrow {
            &:after {
                border-top-color: ${videoPlayerBackground};
            }
            &:before {
                border-top-color: ${theme.fontColors.silver};
            }
        }
        z-index: 1040;
    }
    .popover-body > div:not(:last-of-type) {
        margin-bottom: 10px;
    }
`;
const StyledMobileHeader = styled.div `
    background-color: ${theme.background.blueZodiac};
    padding: 10px;
    font-size: 1.2em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    > div {
        font-weight: bold;
        color: white;
    }
    > small {
        font-weight: normal;
        margin-left: 15px;
        color: ${theme.fontColors.dodgerBlue};
        font-size: 90%;
    }
    ${StyledVideoStats} {
        height: 65px;
        opacity: 0.8;
        padding-bottom: 0;
        .highcharts-container {
            position: absolute !important;
            top: -5px;
        }
        .spinner-border, .no-data-message {
            margin-top: 12px;
        }
    }
    ${StyledStatList} {
        font-size: 10px;
        line-height: 11px;
        row-gap: 0;
    }
    ${StyledPitchInPlayStats} {
        flex-direction: row;
        align-items: center;
        gap: 15px;
        > svg {
            height: 50px;
            width: auto;
        }
    }
`;
const StyledVideoFrameDisplay = styled.div `
    position: absolute;
    right: 10px;
    bottom: 5px;
    color: white;
    font-size: 2em;
`;
const getVideoAngle = (sources, angleName) => {
    if (!sources)
        return {};
    let selectedAngle;
    if (angleName)
        selectedAngle = sources.find((s) => s.label === angleName);
    if (!selectedAngle)
        selectedAngle = sources.find((s) => s.default) || sources[0];
    return selectedAngle;
};
// These two methods allow specification of a different behavior for certain pages
// that have videoplayers. Swapping the keys to get different values from the
// browser storage and the default angle method for changing the default
// behavior for that key.
const getStorageKeyForSpecialtyPlayer = (specialtyAngleKey) => {
    switch (specialtyAngleKey) {
        case 'approach-lhh':
        case 'approach-rhh':
            return LOCAL_STORAGE_ANGLE_KEY_APPROACHTAB;
        default:
            return LOCAL_STORAGE_ANGLE_KEY;
    }
};
const getSpecialtyPlayerKeyWithDefaultAngle = (specialtyAngleKey) => {
    const keyValue = window.localStorage.getItem(getStorageKeyForSpecialtyPlayer(specialtyAngleKey));
    if ((keyValue !== '' && keyValue != null) || (specialtyAngleKey == null || specialtyAngleKey === '')) {
        return keyValue;
    }
    // if there isn't already a value for that key, see what it should be and return it
    // spec the angle of player you want for each possible specialty key
    switch (specialtyAngleKey) {
        case 'approach-lhh':
            return 'RH Batters View'; // Note that these are intentionally flipped versus handedness
        case 'approach-rhh':
            return 'LH Batters View';
        default:
            return window.localStorage.getItem(getStorageKeyForSpecialtyPlayer(specialtyAngleKey));
    }
};
const setNewPlaylist = (props) => {
    var _a, _b, _c, _d;
    const nextState = {
        toastMessage: '',
        errorMessage: {},
        sliderTimeValue: 0,
        maxVideoTime: 0,
        currentVideoIdx: 0,
        filteredPlaylist: props.playlist,
        filter: {},
        actionMenu: {},
        advancedPitchData: {},
        metadata: {},
        heatMaps: {},
        selectedAngle: getVideoAngle((_a = props.playlist[0]) === null || _a === void 0 ? void 0 : _a.sources, props.overrideAngleKey || getSpecialtyPlayerKeyWithDefaultAngle(props.specialtyAngleKey)),
        selectedAngleLabel: (_c = getVideoAngle((_b = props.playlist[0]) === null || _b === void 0 ? void 0 : _b.sources, props.overrideAngleKey
            || getSpecialtyPlayerKeyWithDefaultAngle(props.specialtyAngleKey))) === null || _c === void 0 ? void 0 : _c.label,
        selectedData: (_d = props.playlist[0]) === null || _d === void 0 ? void 0 : _d.data,
        controls: {
            [PLAY_PAUSE]: props.autoPlay ? 1 : false,
            [MUTE]: (props.autoPlay && browser$1.webkit) || window.localStorage.getItem(LOCAL_STORAGE_MUTE_KEY) === 'true',
            // hideStats fully suppresses the pane (button + content), so ignore the persisted user preference here too
            [STATS]: !props.hideStats && (props.alwaysShowPitchData || window.localStorage.getItem(LOCAL_STORAGE_DATA_VIEW_KEY) === 'true'),
            [HEATMAP]: window.localStorage.getItem(LOCAL_STORAGE_HEATMAP_KEY) === 'true',
            [FILTER]: props.alwaysShowFilter,
        },
        containerWidth: 0,
        errors: [],
    };
    return nextState;
};
class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.playlistContainerRef = createRef();
        this.videoContentContainerRef = createRef();
        this.videoControlsContainerRef = createRef();
        this.actionMenuRef = createRef();
        this.videoPlayerHeight = null;
        this.videoRef = null;
        this.setCurrentVideoTime = () => { }; // eslint-disable-line @typescript-eslint/no-empty-function
        this.state = setNewPlaylist(this.props);
        this.toggleControl = this.toggleControl.bind(this);
        this.toggleSliderEvent = this.toggleSliderEvent.bind(this);
        this.toggleFullScreenMode = this.toggleFullScreenMode.bind(this);
        this.toggleActionMenu = this.toggleActionMenu.bind(this);
        this.toggleStats = this.toggleStats.bind(this);
        this.toggleMute = this.toggleMute.bind(this);
        this.toggleHeatmap = this.toggleHeatmap.bind(this);
        this.onVideoLoadedData = this.onVideoLoadedData.bind(this);
        this.onSliderChange = this.onSliderChange.bind(this);
        this.onPlayback = this.onPlayback.bind(this);
        this.goToNextVideo = this.goToNextVideo.bind(this);
        this.translateSliderTime = this.translateSliderTime.bind(this);
        this.share = this.share.bind(this);
        this.copySQL = this.copySQL.bind(this);
        this.onFullScreenChange = this.onFullScreenChange.bind(this);
        this.onGrabFrame = this.onGrabFrame.bind(this);
        this.onFilter = this.onFilter.bind(this);
        this.loadAndSetPitchData = this.loadAndSetPitchData.bind(this);
        this.loadAndSetPitchHeatmap = this.loadAndSetPitchHeatmap.bind(this);
        this.loadAndSetVideoMetadata = this.loadAndSetVideoMetadata.bind(this);
        this.onVideoAngleSelect = this.onVideoAngleSelect.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.onVideoContentKeyDown = this.onVideoContentKeyDown.bind(this);
        this.onVideoContentWheel = this.onVideoContentWheel.bind(this);
        this.onVideoEnd = this.onVideoEnd.bind(this);
        this.exportPlaylistToIPad = this.exportPlaylistToIPad.bind(this);
        this.setVideoError = this.setVideoError.bind(this);
        this.getFrameRate = this.getFrameRate.bind(this);
        this.togglePlay = this.togglePlay.bind(this);
    }
    componentDidMount() {
        var _a, _b, _c, _d;
        document.addEventListener('fullscreenchange', this.onFullScreenChange, false);
        document.addEventListener('mozfullscreenchange', this.onFullScreenChange, false);
        document.addEventListener('MSFullscreenChange', this.onFullScreenChange, false);
        document.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
        window.addEventListener('resize', this.onWindowResize, false);
        (_a = this.videoContentContainerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('wheel', this.onVideoContentWheel, false);
        (_b = this.videoControlsContainerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('wheel', this.onVideoContentWheel, false);
        if (this.props.overrideWindowEventListeners) {
            window.addEventListener('keydown', this.onVideoContentKeyDown, false);
        }
        else {
            (_c = this.videoContentContainerRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('keydown', this.onVideoContentKeyDown, false);
            (_d = this.videoControlsContainerRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener('keydown', this.onVideoContentKeyDown, false);
        }
        this.onWindowResize(true);
        if (this.state.controls[STATS])
            this.loadAndSetPitchData(this.state.filteredPlaylist[this.state.currentVideoIdx]);
        if (this.state.controls[HEATMAP])
            this.loadAndSetPitchHeatmap(this.state.filteredPlaylist[this.state.currentVideoIdx]);
        if (this.props.loadVideoMetadata)
            this.loadAndSetVideoMetadata(this.state.selectedAngle);
    }
    UNSAFE_componentWillReceiveProps(_nextProps) {
        // check for new props
        const { playlist: prevPlaylist } = this.props;
        const { playlist: nextPlaylist } = _nextProps;
        if (((prevPlaylist === null || prevPlaylist === void 0 ? void 0 : prevPlaylist.length) && prevPlaylist[0].pitchId) !== ((nextPlaylist === null || nextPlaylist === void 0 ? void 0 : nextPlaylist.length) && nextPlaylist[0].pitchId)) {
            const nextState = setNewPlaylist(_nextProps);
            this.setState(nextState);
            this.onWindowResize(true);
        }
    }
    UNSAFE_componentWillUpdate(_nextProps, nextState) {
        var _a, _b;
        // a new source was given to the video player and has not yet loaded
        // use this oppurtunity to set the size of the video player since it collapses when no video is playing
        if (((_a = nextState.selectedAngle) === null || _a === void 0 ? void 0 : _a.file) && nextState.selectedAngle.file !== ((_b = this.state.selectedAngle) === null || _b === void 0 ? void 0 : _b.file)) {
            if (!nextState.maxVideoTime)
                this.videoPlayerHeight = this.playlistContainerRef.current.offsetHeight;
            if (this.props.loadVideoMetadata)
                this.loadAndSetVideoMetadata(nextState.selectedAngle);
        }
        else if (this.state.maxVideoTime !== nextState.maxVideoTime) {
            this.videoPlayerHeight = null;
        }
    }
    componentDidUpdate(_prevProps, prevState) {
        const prevPitchVideo = prevState.filteredPlaylist[prevState.currentVideoIdx];
        const currentPitchVideo = this.state.filteredPlaylist[this.state.currentVideoIdx];
        if (prevPitchVideo !== currentPitchVideo) {
            if (this.state.controls[STATS])
                this.loadAndSetPitchData(currentPitchVideo);
            if (this.state.controls[HEATMAP])
                this.loadAndSetPitchHeatmap(currentPitchVideo);
        }
    }
    componentDidCatch(error) {
        this.setState((prevState) => ({ errors: [...prevState.errors, error] }));
    }
    componentWillUnmount() {
        var _a, _b, _c, _d;
        document.removeEventListener('fullscreenchange', this.onFullScreenChange, false);
        document.removeEventListener('mozfullscreenchange', this.onFullScreenChange, false);
        document.removeEventListener('MSFullscreenChange', this.onFullScreenChange, false);
        document.removeEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
        window.removeEventListener('resize', this.onWindowResize, false);
        (_a = this.videoContentContainerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('wheel', this.onVideoContentWheel, false);
        (_b = this.videoControlsContainerRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('wheel', this.onVideoContentWheel, false);
        if (this.props.overrideWindowEventListeners) {
            window.removeEventListener('keydown', this.onVideoContentKeyDown, false);
        }
        else {
            (_c = this.videoContentContainerRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('keydown', this.onVideoContentKeyDown, false);
            (_d = this.videoControlsContainerRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('keydown', this.onVideoContentKeyDown, false);
        }
    }
    onVideoLoadedData(e) {
        // allow a hook to be notified when the active clip changes
        if (this.props.onActiveVideoChanged) {
            const videoData = this.state.filteredPlaylist[this.state.currentVideoIdx];
            this.props.onActiveVideoChanged(videoData);
        }
        this.setState(({ controls, selectedAngle, metadata }, { autoPlay, showCurrentFrame }) => {
            let play = autoPlay ? 1 : false;
            if (play && showCurrentFrame && (selectedAngle === null || selectedAngle === void 0 ? void 0 : selectedAngle.file)) {
                const meta = get$2(metadata, selectedAngle.file);
                if (meta === null || meta === void 0 ? void 0 : meta.loading)
                    play = false;
            }
            if (this.props.playStateChanged) {
                this.props.playStateChanged(play === 1);
            }
            return {
                maxVideoTime: e.target.duration,
                controls: Object.assign(Object.assign({}, controls), { [PLAY_PAUSE]: play }),
            };
        });
    }
    onPlayback(e) { this.setState({ sliderTimeValue: e.target.currentTime }); }
    onSliderChange(newVal) { this.setCurrentVideoTime(newVal); }
    onVideoAngleSelect(selectedAngle) {
        this.setState((currentState) => {
            const { selectedAngle: currentSelectedAngle } = currentState;
            const newState = Object.assign({}, currentState);
            if (currentSelectedAngle !== selectedAngle) {
                newState.selectedAngle = selectedAngle;
                newState.selectedAngleLabel = selectedAngle.label;
                window.localStorage.setItem(getStorageKeyForSpecialtyPlayer(this.props.specialtyAngleKey), selectedAngle.label);
                if (currentSelectedAngle.file !== selectedAngle.file) {
                    newState.maxVideoTime = 0;
                    newState.sliderTimeValue = 0;
                    newState.errorMessage = {};
                }
            }
            return newState;
        });
    }
    onFullScreenChange() {
        const doc = document;
        const isInFullScreen = doc.webkitIsFullScreen || doc.mozFullScreen || doc.msFullscreenElement;
        this.toggleControl(FULLSCREEN, !!isInFullScreen);
    }
    onWindowResize(isInitLoad) {
        if (isInitLoad === true) {
            // setTimeout and wait for modal to display player on page before calculating with (otherwise returns 0)
            setTimeout(() => {
                if (this.playlistContainerRef.current) {
                    this.setState({ containerWidth: this.playlistContainerRef.current.offsetWidth });
                }
            });
        }
        else {
            this.setState({ containerWidth: this.playlistContainerRef.current.offsetWidth });
        }
    }
    onFilter(filteredPlaylist, filter) {
        this.setState((currentState) => {
            var _a, _b;
            const { selectedAngle, selectedAngleLabel } = currentState;
            const newState = Object.assign(Object.assign({}, currentState), { filter, filteredPlaylist, currentVideoIdx: 0 });
            const newSelectedAngle = getVideoAngle((_a = filteredPlaylist[newState.currentVideoIdx]) === null || _a === void 0 ? void 0 : _a.sources, selectedAngleLabel);
            const newSelectedData = (_b = filteredPlaylist[newState.currentVideoIdx]) === null || _b === void 0 ? void 0 : _b.data;
            // do not reset current video playback if the loaded video is the "new" video to be played
            if (newSelectedAngle.file !== selectedAngle.file) {
                newState.selectedAngle = newSelectedAngle;
                newState.selectedData = newSelectedData;
                newState.maxVideoTime = 0;
                newState.sliderTimeValue = 0;
            }
            return newState;
        });
        if (this.props.onFilter) {
            this.props.onFilter(filteredPlaylist);
        }
    }
    onVideoContentKeyDown(e) {
        var _a;
        if ((_a = (e === null || e === void 0 ? void 0 : e.target).classList) === null || _a === void 0 ? void 0 : _a.contains('reportBadVideoModalField')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        const { keyCode } = e;
        if (keyCode === 189 || keyCode === 188 || keyCode === 109 || keyCode === 173 || keyCode === 37 || keyCode === 40) { // last frame
            this.toggleSliderEvent(STEP_BACK);
        }
        else if (keyCode === 187 || keyCode === 190 || keyCode === 107 || keyCode === 61 || keyCode === 38 || keyCode === 39) { // next frame
            this.toggleSliderEvent(STEP_FORWARD);
        }
        else if (keyCode === 32 || keyCode === 80) { // play
            this.toggleControl(PLAY_PAUSE, 1);
        }
    }
    onVideoContentWheel(e) {
        e.preventDefault();
        e.stopPropagation();
        const { pixelY } = normalizeWheel(e);
        const delta = Math.sign(pixelY);
        const frameRate = this.getFrameRate();
        if (this.state.controls[PLAY_PAUSE] && delta) {
            this.toggleControl(PLAY_PAUSE, false);
            this.setCurrentVideoTime(this.state.sliderTimeValue - (delta / frameRate));
        }
        else if (!this.state.controls[PLAY_PAUSE] && delta) {
            this.setCurrentVideoTime(this.state.sliderTimeValue - (delta / frameRate));
        }
    }
    onVideoEnd() {
        if (this.state.controls[PLAY_PAUSE]) {
            this.goToNextVideo(undefined, true);
        }
    }
    onGrabFrame() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.selectedAngle.file) {
                this.toggleControl(FRAME_GRAB, true);
                yield this.props.grabFrame(this.state.selectedAngle.file, this.state.sliderTimeValue);
                this.toggleControl(FRAME_GRAB, false);
            }
        });
    }
    setVideoError(translate, e) {
        var _a;
        const title = translate('components.video.could-not-play');
        const error = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.error;
        let subtitle = error === null || error === void 0 ? void 0 : error.message;
        if (!subtitle && (error === null || error === void 0 ? void 0 : error.code)) {
            subtitle = `${translate('components.video.error-code')}: ${error.code}`;
        }
        this.setState({ errorMessage: { title, subtitle } });
    }
    getFrameRate() {
        let frameRate = FRAME_RATE;
        const { metadata, selectedAngle } = this.state;
        if (selectedAngle === null || selectedAngle === void 0 ? void 0 : selectedAngle.file) {
            const meta = get$2(metadata, selectedAngle.file);
            if (meta === null || meta === void 0 ? void 0 : meta.Fps)
                frameRate = meta.Fps;
        }
        return frameRate;
    }
    loadAndSetPitchData(playlistVideo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.loadPitchData && (playlistVideo === null || playlistVideo === void 0 ? void 0 : playlistVideo.pitchId)) {
                let pitchData = get$2(this.state.advancedPitchData, playlistVideo.pitchId);
                if (pitchData === undefined) {
                    try {
                        this.setState(({ advancedPitchData }) => ({ advancedPitchData: set(advancedPitchData, playlistVideo.pitchId, { loading: true }) }));
                        const { gameid, pitchseq, eventseq } = playlistVideo.data;
                        pitchData = yield this.props.loadPitchData({ gameid, pitchseq, eventseq });
                        this.setState(({ advancedPitchData }) => ({ advancedPitchData: set(advancedPitchData, playlistVideo.pitchId, pitchData) }));
                    }
                    catch (_a) {
                        this.setState(({ advancedPitchData }) => ({ advancedPitchData: set(advancedPitchData, playlistVideo.pitchId, null) }));
                    }
                }
                return pitchData;
            }
            return null;
        });
    }
    loadAndSetPitchHeatmap(playlistVideo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.loadPitchHeatmap && (playlistVideo === null || playlistVideo === void 0 ? void 0 : playlistVideo.heatmapId)) {
                let heatMap = get$2(this.state.heatMaps, playlistVideo.heatmapId);
                if (heatMap === undefined) {
                    try {
                        this.setState(({ heatMaps }) => ({ heatMaps: set(heatMaps, playlistVideo.heatmapId, { loading: true }) }));
                        const { pitcherid, type, batterid, strikes, yearid, islhb, venueid, fxsubtype } = playlistVideo.data;
                        heatMap = yield this.props.loadPitchHeatmap({
                            pitcherid,
                            batterid,
                            yearid,
                            islhb,
                            pitchtype: type,
                            is2k: strikes === 2,
                            venueid,
                            fxsubtype
                        });
                        this.setState(({ heatMaps }) => ({ heatMaps: set(heatMaps, playlistVideo.heatmapId, heatMap) }));
                    }
                    catch (_a) {
                        this.setState(({ heatMaps }) => ({ heatMaps: set(heatMaps, playlistVideo.heatmapId, null) }));
                    }
                }
                return heatMap;
            }
            return null;
        });
    }
    loadAndSetVideoMetadata(source) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.loadVideoMetadata && (source === null || source === void 0 ? void 0 : source.file)) {
                const { file: videoUrl } = source;
                let videoData = get$2(this.state.metadata, videoUrl);
                if (videoData === undefined) {
                    try {
                        this.setState(({ metadata }) => ({ metadata: set(metadata, videoUrl, { loading: true }) }));
                        videoData = yield this.props.loadVideoMetadata(videoUrl);
                        this.setState(({ metadata, controls }, { autoPlay }) => ({
                            metadata: set(metadata, videoUrl, Object.assign({ Duration: videoData.Duration }, videoData.VideoData)),
                            controls: Object.assign(Object.assign({}, controls), { [PLAY_PAUSE]: autoPlay ? 1 : false }),
                        }));
                    }
                    catch (_a) {
                        this.setState(({ metadata }) => ({ metadata: set(metadata, videoUrl, null) }));
                    }
                }
                return videoData;
            }
            return null;
        });
    }
    goToNextVideo(idx, isVideoEnd) {
        this.setState((currentState) => {
            var _a;
            const { currentVideoIdx, filteredPlaylist, controls, selectedAngleLabel } = currentState;
            let nextVideoIdx = idx;
            if (nextVideoIdx === undefined) {
                nextVideoIdx = currentVideoIdx === filteredPlaylist.length - 1 ? 0 : currentVideoIdx + 1;
            }
            const newState = Object.assign({}, currentState);
            if (nextVideoIdx !== currentVideoIdx) {
                newState.currentVideoIdx = nextVideoIdx;
                newState.selectedAngle = getVideoAngle(filteredPlaylist[nextVideoIdx].sources, selectedAngleLabel);
                newState.selectedData = (_a = filteredPlaylist[nextVideoIdx]) === null || _a === void 0 ? void 0 : _a.data;
                newState.maxVideoTime = 0;
                newState.sliderTimeValue = 0;
                newState.errorMessage = {};
            }
            else if (isVideoEnd) {
                newState.controls = Object.assign(Object.assign({}, controls), { [PLAY_PAUSE]: false });
            }
            return newState;
        });
    }
    share(translate) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.selectedAngle.file) {
                yield navigator.clipboard.writeText(this.state.selectedAngle.file);
                this.setState({
                    toastMessage: translate('components.video.video-url-copied'),
                });
            }
        });
    }
    // Not translating since it is for devs
    copySQL() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-undef
            if ((_a = this.state) === null || _a === void 0 ? void 0 : _a.selectedData) {
                const data = (_b = this.state) === null || _b === void 0 ? void 0 : _b.selectedData;
                const sqlScript = `select * from games g 
                inner join events e on e.gameid = g.gameid 
                inner join pitches p on p.gameid = g.gameid and p.eventseq = e.eventseq
                left join pitchvideos pv on pv.gameid=g.gameid and pv.eventseq=e.eventseq and pv.pitchseq=p.pitchseq
                left join [input].[videoangles] va on e.istop = va.istop and g.gameid = va.gameid and p.islhp = va.islhp and p.islhb = va.islhb
                where g.gameid = ${data.gameid} and e.eventseq = ${data.eventseq} and p.pitchseq = ${data.pitchseq}`;
                yield navigator.clipboard.writeText(sqlScript);
                this.setState({
                    toastMessage: 'Video SQL Query Copied to Clipboard',
                });
            }
            else {
                this.setState({
                    toastMessage: 'Video Data Not Found',
                });
            }
        });
    }
    exportPlaylistToIPad() {
        if (!this.props.exportPlaylist)
            return;
        const clips = this.state.filteredPlaylist.reduce((acc, video) => {
            if (video.clip) {
                const playlistClip = [...video.clip];
                playlistClip.sources = video.sources || [];
                acc.push(playlistClip);
            }
            return acc;
        }, new Array());
        this.props.exportPlaylist(clips);
    }
    toggleActionMenu(e, forceShow) {
        const { target } = e;
        this.setState(({ actionMenu }) => {
            const show = forceShow === undefined ? !actionMenu.show : forceShow;
            return {
                actionMenu: { show, target: show ? target : actionMenu.target },
            };
        });
    }
    toggleControl(controlKey, value, override) {
        this.setState(({ controls, containerWidth }) => {
            let isOpen;
            if (override) {
                isOpen = override;
            }
            else {
                const prevVal = controls[controlKey];
                isOpen = (value === undefined || value === prevVal) ? !prevVal : value;
            }
            const newControlsState = Object.assign(Object.assign({}, controls), { [controlKey]: isOpen });
            const { alwaysShowPitchData, alwaysShowFilter, hidePlaylistSelector } = this.props;
            if (containerWidth < bootstrapXl) {
                if (controlKey === FILTER && isOpen) {
                    newControlsState[PLAYLIST] = false;
                }
                else if (controlKey === PLAYLIST && isOpen && !alwaysShowFilter) {
                    newControlsState[FILTER] = false;
                }
            }
            if (controlKey === FULLSCREEN && !isOpen) {
                if (alwaysShowPitchData)
                    newControlsState[STATS] = true;
                if (alwaysShowFilter)
                    newControlsState[FILTER] = true;
                if (hidePlaylistSelector || (alwaysShowFilter && containerWidth < bootstrapXl))
                    newControlsState[PLAYLIST] = false;
            }
            // make sure this is done after newControlsState is updated
            if (controlKey === PLAY_PAUSE && this.props.playStateChanged) {
                this.props.playStateChanged(newControlsState[PLAY_PAUSE] === 1);
            }
            return { controls: newControlsState };
        });
    }
    toggleFullScreenMode() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.controls[FULLSCREEN]) {
                const doc = document;
                if (browser$1.webkit)
                    doc.webkitExitFullscreen();
                else
                    doc.exitFullscreen();
            }
            else if (((_a = this.videoRef) === null || _a === void 0 ? void 0 : _a.current) && this.videoRef.current.webkitDisplayingFullscreen) {
                this.videoRef.current.webkitExitFullscreen();
            }
            else {
                if (browser$1.webkit) {
                    try {
                        this.playlistContainerRef.current.webkitRequestFullscreen();
                        if (!document.webkitCurrentFullScreenElement && !browser$1.tablet) {
                            this.videoRef.current.webkitEnterFullscreen();
                        }
                    }
                    catch (_b) {
                        // iphone,ipad web view: does not support requestFullscreen as of opening day 2021
                        this.videoRef.current.webkitEnterFullscreen();
                    }
                }
                else {
                    yield this.playlistContainerRef.current.requestFullscreen({ navigationUI: 'hide' });
                    if (browser$1.mobileOnly) { // lock screen landscape on android when fullscreen
                        try {
                            yield window.screen.orientation.lock('landscape');
                        }
                        catch ( /* not supported */_c) { /* not supported */ }
                    }
                }
                this.setState(({ controls }) => ({ controls: Object.assign(Object.assign({}, controls), { [PLAYLIST]: false, [FILTER]: false }) }));
            }
        });
    }
    toggleHeatmap(currentVideo) {
        this.toggleControl(HEATMAP);
        this.loadAndSetPitchHeatmap(currentVideo);
        setTimeout(() => {
            window.localStorage.setItem(LOCAL_STORAGE_HEATMAP_KEY, (!!this.state.controls[HEATMAP]).toString());
        });
    }
    togglePlay() {
        // Play state uses false/1/2, so we must specify explicitly
        if (this.state.controls[PLAY_PAUSE] === 1) {
            this.toggleControl(PLAY_PAUSE, false);
        }
        else {
            this.toggleControl(PLAY_PAUSE, 1);
        }
    }
    toggleMute() {
        this.toggleControl(MUTE);
        setTimeout(() => {
            window.localStorage.setItem(LOCAL_STORAGE_MUTE_KEY, (!!this.state.controls[MUTE]).toString());
        });
    }
    toggleSliderEvent(key) {
        if (key === PLAY_FROM_BEGINNING) {
            this.setCurrentVideoTime(0);
        }
        else if (key === STEP_BACK || key === STEP_FORWARD) {
            if (this.state.controls[PLAY_PAUSE])
                this.toggleControl(PLAY_PAUSE, false);
            const frameRate = this.getFrameRate();
            // convert to frames and add/subtract frame
            let toFrame = (frameRate * this.state.sliderTimeValue) + (key === STEP_FORWARD ? 1 : -1);
            toFrame = Math.min(Math.max(toFrame, 0), frameRate * this.state.maxVideoTime);
            // set video time in seconds
            this.setCurrentVideoTime(toFrame / frameRate);
        }
    }
    toggleStats(currentVideo) {
        this.toggleControl(STATS);
        this.loadAndSetPitchData(currentVideo);
        setTimeout(() => {
            window.localStorage.setItem(LOCAL_STORAGE_DATA_VIEW_KEY, (!!this.state.controls[STATS]).toString());
        });
    }
    translateSliderTime(currentTime) {
        let retVal = '00:00:00';
        if (this.state.maxVideoTime && currentTime >= 0) {
            retVal = dayjs().startOf('hour').add(this.state.maxVideoTime - currentTime, 's').format('mm:ss:SSS');
            retVal = retVal.substring(0, retVal.length - 1); // dayjs only supports 3 character milliseconds, so delete last number
        }
        return retVal;
    }
    render() {
        var _a, _b, _c, _d;
        // This determines which of the ways the translation
        // class might be provided to us, either via props from the caller
        // or instantiated using the HOC
        let translate = null;
        if (this.props.translate) {
            translate = this.props.translate;
        }
        else if (this.props.t) {
            translate = this.props.t;
        }
        const { containerWidth, controls } = this.state;
        const currentVideo = this.state.filteredPlaylist[this.state.currentVideoIdx] || {};
        const isFullScreenMode = !!controls[FULLSCREEN];
        const isMobileView = containerWidth < bootstrapMd || browser$1.mobileOnly;
        const isFullScreenView = isFullScreenMode || isMobileView;
        const pitchData = currentVideo.pitchId ? get$2(this.state.advancedPitchData, currentVideo.pitchId) : null;
        const angleOptions = ((_a = currentVideo.sources) === null || _a === void 0 ? void 0 : _a.map((s) => (Object.assign(Object.assign({}, s), { name: s.label })))) || [];
        let maxVideoHeight;
        let minVideoHeight;
        if (!isFullScreenMode) {
            maxVideoHeight = this.props.maxHeight ? this.props.maxHeight : window.innerHeight;
            maxVideoHeight = maxVideoHeight
                - headerHeight
                - (isMobileView ? footerHeight.mobile : footerHeight.desktop)
                - (controls[STATS] ? statsContainerHeight : 0)
                - (isMobileView ? videoMaxSizePadding.mobile : videoMaxSizePadding.desktop);
            if (containerWidth && !isMobileView && maxVideoHeight > 600) {
                // use calculatued 16/9 ratio as height to avoid black bars at top and bottom
                minVideoHeight = Math.min(600, containerWidth * 9 / 16);
            }
        }
        let containerHeight;
        if (isFullScreenMode)
            containerHeight = '100%';
        else if (this.videoPlayerHeight)
            containerHeight = `${this.videoPlayerHeight}px`;
        // declare reused components
        const statsContent = (!this.props.hideStats && controls[STATS] && (React.createElement(videoStatsMemo, { loading: pitchData === null || pitchData === void 0 ? void 0 : pitchData.loading, data: (pitchData && !pitchData.loading) ? pitchData : undefined, containerWidth: containerWidth, isMobileView: isMobileView })));
        const videoFilter = (controls[FILTER] && (React.createElement(VideoFilter$1, { playlist: this.props.playlist, onFilter: this.onFilter, filter: this.state.filter, isFullScreenMode: isFullScreenView && !(isMobileView && this.props.alwaysShowFilter), isMobileView: isMobileView, hideDisplay: () => this.toggleControl(FILTER, false) })));
        const videoPlayist = (controls[PLAYLIST] && (React.createElement(VideoPlaylist$1, { playlist: this.state.filteredPlaylist, activeIdx: this.state.currentVideoIdx, onVideoClick: this.goToNextVideo, isFullScreenMode: isFullScreenView, hideDisplay: () => this.toggleControl(PLAYLIST, false) })));
        const angleSelector = angleOptions.length > 1 && (React.createElement(DropdownInput, { className: "me-4", size: "md", options: angleOptions, value: this.state.selectedAngle.label, onSelect: this.onVideoAngleSelect, drop: isFullScreenView ? 'up' : undefined }));
        const playButton = (React.createElement(VideoPlayerButton$1, { className: "high-use", title: translate('components.video.play'), icon: "play", onClick: () => this.toggleControl(PLAY_PAUSE, 1), isActive: controls[PLAY_PAUSE] === 1 }));
        const fastForwardButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.play-2'), icon: "forward", onClick: () => this.toggleControl(PLAY_PAUSE, 2), isActive: controls[PLAY_PAUSE] === 2 }));
        const nextVideoButton = this.state.filteredPlaylist.length > 1 && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.go-to-next'), icon: "next", onClick: () => this.goToNextVideo() }));
        const nextFrameButton = (React.createElement(VideoPlayerButton$1, { className: "high-use", icon: "step-forward", title: translate('components.video.step-forward'), onClick: () => this.toggleSliderEvent(STEP_FORWARD) }));
        const prevFrameButton = (React.createElement(VideoPlayerButton$1, { className: "high-use", icon: "step-backward", title: translate('components.video.step-backward'), onClick: () => this.toggleSliderEvent(STEP_BACK) }));
        const playFromStartButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.play-from-beginning'), icon: "step-backward2", onClick: () => this.toggleSliderEvent(PLAY_FROM_BEGINNING) }));
        const filterButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.filter-playlist'), icon: this.state.filteredPlaylist.length !== this.props.playlist.length ? 'filter-solid' : 'filter-hollow', isActive: !!controls[FILTER], onClick: () => this.toggleControl(FILTER), disabled: this.props.playlist.length <= 1 }));
        const playlistButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.show-playlist'), icon: "list2", isActive: !!controls[PLAYLIST], onClick: () => this.toggleControl(PLAYLIST) }));
        const statsButton = this.props.loadPitchData && !this.props.hideStats && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.show-pitch-statistics'), icon: "stats", isActive: !!controls[STATS], onClick: () => this.toggleStats(currentVideo) }));
        const loopButton = (isActionMenuItem) => {
            if (isActionMenuItem ? isFullScreenView : !containerWidth)
                return null;
            if (isActionMenuItem ? containerWidth >= bootstrapLg : !isFullScreenView && containerWidth < bootstrapLg)
                return null;
            return (React.createElement(VideoPlayerButton$1, { title: translate('components.video.loop'), icon: "loop", onClick: () => this.toggleControl(LOOP), isActive: !!controls[LOOP], showLabel: isActionMenuItem }));
        };
        const heatmapButton = this.props.loadPitchHeatmap && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.show-heatmap'), icon: "fire", isActive: !!controls[HEATMAP], onClick: () => this.toggleHeatmap(currentVideo) }));
        let currentFrame = null;
        if (this.props.showCurrentFrame && ((_b = this.state.selectedAngle) === null || _b === void 0 ? void 0 : _b.file)) {
            const meta = get$2(this.state.metadata, this.state.selectedAngle.file);
            if (meta && !meta.loading) {
                currentFrame = !!meta.Fps && (React.createElement(StyledVideoFrameDisplay, null, format(meta.Fps * this.state.sliderTimeValue, 0)));
            }
        }
        return (React.createElement(StyledVideoPlaylistContainer, { ref: this.playlistContainerRef, style: { height: containerHeight }, "$roundCorners": this.props.roundCorners },
            !isMobileView && isFullScreenMode && (React.createElement(VideoPlaylistTabs, { playlist: this.state.filteredPlaylist, activeIdx: this.state.currentVideoIdx, toggleStats: () => this.toggleStats(currentVideo), onVideoClick: this.goToNextVideo, isStatsOpen: !!controls[STATS], loadPitchData: this.props.loadPitchData, isFullScreenMode: isFullScreenMode, statsContent: statsContent })),
            isMobileView && (React.createElement(StyledMobileHeader, null,
                React.createElement("div", null, currentVideo.title),
                currentVideo.description && React.createElement("small", null, currentVideo.description),
                statsContent)),
            !isFullScreenView && (React.createElement(StyledVideoPlaylistHeader, { "$width": containerWidth },
                React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                    React.createElement("div", null,
                        React.createElement("h4", null, currentVideo.title),
                        currentVideo.description && React.createElement("label", null,
                            React.createElement("small", null, currentVideo.description)))),
                React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                    angleSelector,
                    !this.props.alwaysShowPitchData && !this.props.hideHeatmap && statsButton,
                    !this.props.hideHeatmap && heatmapButton,
                    !this.props.alwaysShowFilter && !this.props.hideFilter && filterButton,
                    !this.props.hidePlaylistSelector && playlistButton))),
            React.createElement(StyledVideoPlayer$1, null,
                this.state.toastMessage && (React.createElement(ToastNotification, { message: this.state.toastMessage, header: translate('components.video.share'), clearMessage: () => this.setState({ toastMessage: '' }) })),
                React.createElement(StyledVideoContainer$1, { "$fullscreen": isFullScreenMode, onClick: (e) => this.toggleActionMenu(e, false) },
                    React.createElement("div", { className: "d-flex flex-row justify-content-center w-100 h-100 flex-grow-1" },
                        React.createElement(StyledVideoContentContainer, { ref: this.videoContentContainerRef, tabIndex: 0 },
                            React.createElement(Video, { onClick: () => this.toggleControl(PLAY_PAUSE, 1), setCurrentTime: (setCurrentTimeFn) => { this.setCurrentVideoTime = setCurrentTimeFn; }, onPlayback: this.onPlayback, onVideoEnd: this.onVideoEnd, onVideoLoad: this.onVideoLoadedData, onVideoError: (e) => this.setVideoError(translate, e), play: controls[PLAY_PAUSE], loop: !!controls[LOOP], mute: !!controls[MUTE], src: this.state.selectedAngle.file, autoPlay: this.props.autoPlay, maxHeight: maxVideoHeight, minHeight: minVideoHeight, videoRef: (el) => { this.videoRef = el; } }),
                            !this.state.selectedAngle.file && (React.createElement(StyledVideoNotFound, null,
                                React.createElement("label", null, translate('components.video.no-videos-found')))),
                            this.state.errorMessage.title && (React.createElement(StyledVideoError, null,
                                React.createElement("label", null, this.state.errorMessage.title),
                                this.state.errorMessage.subtitle && React.createElement("label", null, this.state.errorMessage.subtitle))),
                            (this.videoPlayerHeight && !this.state.errorMessage.title) && React.createElement(LoadingSpinner$1, null),
                            currentFrame,
                            !!controls[GRID_SIZE] && (React.createElement(VideoPlayerGrid$1, { onClick: () => this.toggleControl(PLAY_PAUSE, 1), gridSize: controls[GRID_SIZE], containerWidth: this.videoContentContainerRef.current.offsetWidth, containerHeight: this.videoContentContainerRef.current.offsetHeight })),
                            controls[HEATMAP] && currentVideo.heatmapId && !this.state.errorMessage.title && (React.createElement(VideoPlayerHeatmap$1, { heatmap: get$2(this.state.heatMaps, currentVideo.heatmapId), plateX: (pitchData === null || pitchData === void 0 ? void 0 : pitchData.platex) || ((_c = currentVideo.data) === null || _c === void 0 ? void 0 : _c.platex), plateZ: (pitchData === null || pitchData === void 0 ? void 0 : pitchData.platez) || ((_d = currentVideo.data) === null || _d === void 0 ? void 0 : _d.platez), sztop: pitchData === null || pitchData === void 0 ? void 0 : pitchData.sztop, szbottom: pitchData === null || pitchData === void 0 ? void 0 : pitchData.szbottom }))),
                        !isMobileView && videoFilter,
                        !isMobileView && videoPlayist),
                    !isFullScreenView && statsContent,
                    isFullScreenView && (React.createElement(React.Fragment, null,
                        React.createElement(StyledFullScreenVideoControls, { "$left": true, "$width": containerWidth },
                            React.createElement(StyledFullScreenVideoControlsSection, { "$width": containerWidth, "$has5Buttons": (!isMobileView || !this.props.alwaysShowFilter) && !!heatmapButton },
                                (!isMobileView || !this.props.alwaysShowFilter) && filterButton,
                                heatmapButton,
                                playlistButton,
                                playFromStartButton,
                                prevFrameButton)),
                        React.createElement(StyledFullScreenVideoControls, { "$right": true, "$width": containerWidth },
                            React.createElement(StyledFullScreenVideoControlsSection, { "$width": containerWidth, "$has5Buttons": (!isMobileView || !this.props.alwaysShowFilter) && !!heatmapButton },
                                playButton,
                                fastForwardButton,
                                nextVideoButton,
                                nextFrameButton))))),
                React.createElement(StyledVideoControls, { ref: this.videoControlsContainerRef, "$width": containerWidth },
                    React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                        React.createElement(VideoPlayerButton$1, { title: translate('components.video.mute'), icon: "mute", onClick: this.toggleMute, isActive: !!controls[MUTE] })),
                    isFullScreenView && (React.createElement(StyledVideoControlsSection, { "$width": containerWidth }, angleSelector)),
                    React.createElement(StyledVideoControlsSection, { "$width": containerWidth, className: "flex-grow-1" },
                        React.createElement(ProgressSlider, { max: this.state.maxVideoTime, value: this.state.sliderTimeValue, onChange: this.onSliderChange }),
                        React.createElement("label", null, this.translateSliderTime(this.state.sliderTimeValue))),
                    !isFullScreenView && (React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                        playFromStartButton,
                        prevFrameButton,
                        nextFrameButton,
                        playButton,
                        fastForwardButton,
                        nextVideoButton)),
                    React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                        !isMobileView && (React.createElement("div", { ref: this.actionMenuRef },
                            React.createElement(Overlay, { show: this.state.actionMenu.show, target: this.state.actionMenu.target, container: this.actionMenuRef.current, containerPadding: 20, placement: "top" },
                                React.createElement(StyledActionMenuPopover, null,
                                    React.createElement(StyledActionMenuPopover.Body, null,
                                        this.props.exportPlaylist && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.create-playlist'), icon: "link", onClick: this.exportPlaylistToIPad, showLabel: true })),
                                        !this.props.hideShare && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.share'), icon: "share2", onClick: () => this.share(translate), showLabel: true })),
                                        this.props.showCopySQL && (React.createElement(VideoPlayerButton$1, { title: `${translate('components.video.copy')} SQL`, icon: "keyboard", onClick: this.copySQL, showLabel: true })),
                                        !this.props.hideDownload
                                            && (React.createElement(DownloadVideosModal$1, { download: this.props.download, playlist: this.state.filteredPlaylist, modalContainer: this.playlistContainerRef })),
                                        React.createElement(SelectGridSizeModal, { onSelectGridSize: (gridSize) => this.toggleControl(GRID_SIZE, gridSize), modalContainer: this.playlistContainerRef, isActive: !!controls[GRID_SIZE] }),
                                        React.createElement(ReportBadVideoModal, { modalContainer: this.playlistContainerRef, isActive: !!controls[REPORT_BAD_VIDEO], onClick: () => controls[PLAY_PAUSE] && this.toggleControl(PLAY_PAUSE, false), reportBadVideo: this.props.reportBadVideo, currentVideo: currentVideo, selectedAngle: this.state.selectedAngle, errors: this.state.errors }),
                                        !this.props.hideFrameGrab
                                            && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.frame-grab'), icon: "target", loading: !!controls[FRAME_GRAB], onClick: this.onGrabFrame, showLabel: true })),
                                        loopButton(true)))),
                            React.createElement(VideoPlayerButton$1, { title: translate('components.video.open-actions'), icon: "open-menu", onClick: this.toggleActionMenu, disabled: !this.state.selectedAngle.file }))),
                        isMobileView && statsButton,
                        loopButton(false),
                        React.createElement(VideoPlayerButton$1, { title: translate('components.video.fullscreen'), icon: isFullScreenMode ? 'shrink' : 'enlarge', onClick: this.toggleFullScreenMode })))),
            isMobileView && videoFilter,
            isMobileView && videoPlayist));
    }
}
VideoPlayer.defaultProps = {
    autoPlay: true,
    overrideWindowEventListeners: false,
    alwaysShowPitchData: false,
    alwaysShowFilter: false,
    hidePlaylistSelector: false,
    showCurrentFrame: false,
    showCopySQL: false,
    hideFilter: false,
    hideHeatmap: false,
    hidePitchData: false,
    hideStats: false,
    hideShare: false,
    hideDownload: false,
    hideFrameGrab: false,
    // eslint-disable-next-line react/default-props-match-prop-types
    specialtyAngleKey: '',
    overrideAngleKey: '',
};
var VideoPlayer$1 = withTranslation(undefined, { withRef: true })(VideoPlayer);

const videoPlayerBorderRadius = 4;
const maxModalWidth = 0.925;
const maxModalContentWidth = 1280;
const StyledDialog = styled(ModalDialog) `
    &&& {
        max-width: ${maxModalWidth * 100}%;
        @media screen and (min-width: ${maxModalContentWidth * (1 / maxModalWidth)}px) {
            max-width: ${maxModalContentWidth}px;
        }
    }
    && {
        > .modal-content {
            border: none;
            background: transparent;
            text-align: center;
        }
    }
    .modal-border-top {
        border-top-left-radius: ${videoPlayerBorderRadius}px;
        border-top-right-radius: ${videoPlayerBorderRadius}px;
    }
    .modal-border-bottom {
        border-bottom-left-radius: ${videoPlayerBorderRadius}px;
        border-bottom-right-radius: ${videoPlayerBorderRadius}px;
    }
`;
const StyledVideoContainer = styled.div `
    border-radius: 0.3rem;
    && {
        > .spinner-border {
            margin-top: 25%;
        }
    }
`;
const VideoModal = ({ children, onHide, container, show = false, loading = false, restoreFocus = true }) => (React.createElement(Modal, { show: show, onHide: onHide, size: "lg", dialogAs: StyledDialog, container: container, restoreFocus: restoreFocus },
    React.createElement(StyledVideoContainer, null,
        loading && React.createElement(LoadingSpinner$1, null),
        !loading && children)));

const VideoPlayerModal = (_a) => {
    var { onHide, container, playlist, show = false, restoreFocus = true } = _a, rest = __rest(_a, ["onHide", "container", "playlist", "show", "restoreFocus"]);
    return (React.createElement(VideoModal, { show: show, onHide: onHide, container: container, loading: !playlist, restoreFocus: restoreFocus },
        React.createElement(VideoPlayer$1, Object.assign({ playlist: playlist || [], overrideWindowEventListeners: true }, rest, { onHide: onHide }))));
};

const StyledPlaySvg = styled.svg `
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 10px calc(50% - 50px);
    top: 0;
    left: 0;
    display: block;
    opacity: 0.95;
    cursor: pointer;
    transition: opacity 150ms;
    position: absolute;
`;
const VideoOverlayPlayButton = () => (React.createElement(StyledPlaySvg, { className: "screenonly", viewBox: "0 0 200 200", "aria-label": "Play video" },
    React.createElement("circle", { cx: "100", cy: "100", r: "90", fill: "rgba(77,77,77,0.4)", strokeWidth: "7", stroke: "rgba(255,255,255,0.3)" }),
    React.createElement("polygon", { points: "70, 55 70, 145 145, 100", fill: "rgba(255,255,255,0.6)" })));

const SimpleVideoPlayer = (props) => (React.createElement(Video, Object.assign({ controls: true }, props)));

const SimpleVideoPlayerModal = (_a) => {
    var { show, onHide, container, src } = _a, rest = __rest(_a, ["show", "onHide", "container", "src"]);
    return (React.createElement(VideoModal, { show: show, onHide: onHide, container: container, loading: !src },
        React.createElement(SimpleVideoPlayer, Object.assign({ src: src }, rest))));
};

const buildSeries$5 = (translate, type, videos) => {
    const markerRadius = 4;
    const series = [
        {
            data: [],
            type: 'scatter',
            name: translate('baseball.hits_other'),
            index: 1,
            id: 'hit',
            marker: { symbol: 'circle',
                radius: markerRadius,
                lineColor: '#0000ff',
                fillColor: '#ffffff',
                lineWidth: 1 },
        },
        { data: [],
            type: 'scatter',
            name: translate('baseball.outs_other'),
            index: 2,
            id: 'out',
            marker: { symbol: 'diamond',
                radius: markerRadius,
                lineColor: '#0000ff' } },
        {
            data: [],
            type: 'scatter',
            name: translate('baseball.abbr-reach-error'),
            index: 3,
            id: 'roe',
            marker: { symbol: 'triangle',
                radius: markerRadius,
                lineColor: '#0000ff',
                fillColor: '#ffffff',
                lineWidth: 1 },
        },
        {
            data: [],
            type: 'scatter',
            name: translate('baseball.home-run'),
            index: 4,
            id: 'hr',
            marker: { symbol: 'square',
                radius: markerRadius,
                lineColor: '#0000ff',
                fillColor: '#ffffff',
                lineWidth: 1 },
        },
    ];
    const isIFHit = (p) => p.hittypecode === 'G' || p.hittypecode === 'B' || (p.distance !== null && p.distance < 150);
    const filteredData = videos.filter((d) => (type === 'infield' ? isIFHit(d) : !isIFHit(d)) && d.islastpitch);
    filteredData.forEach((d) => {
        var _a, _b, _c, _d;
        const point = Object.assign({}, d);
        const tooltip = [];
        point.name = `${d.batter} ${translate('baseball.abbr-versus')} ${d.pitcher} - ${dateTranslate(translate, d.gamedate)}`;
        const tooltipRow1 = [];
        tooltipRow1.push(`${d.hittype !== null ? hitType(d.hittype, true, translate) : ''} ${baseEvent(d.baseevent, true, undefined, translate)} ${dateTranslate(translate, d.gamedate)}`);
        if (d.hittypecode === 'F' && d.distance)
            tooltipRow1.push(`${d.distance.toFixed(1)} ${translate('components.video.filters.abbr-feet')}`);
        if (d.hittypecode === 'F' && d.hangtime)
            tooltipRow1.push(`${d.hangtime} ${translate('components.video.filters.abbr-seconds')}`);
        tooltip.push(tooltipRow1.join(', '));
        tooltip.push(`${d.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${d.inning}, ${d.outsbefore} ${translate('baseball.outs_one')} ${d.balls}-${d.strikes} ${translate('baseball.count')}`);
        if (d.pitchtype && d.velocity) {
            tooltip.push(`${pitchType(d.pitchtype, undefined, undefined, translate)}, ${translate('format.abbr-mph', { value: format(d.velocity) })}`);
        }
        point.tooltip = tooltip.join('<br />');
        switch (d.baseevent) {
            case 0:
            case 1:
            case 2:
            case 3:
                (_a = series[0].data) === null || _a === void 0 ? void 0 : _a.push(point);
                break;
            case 8:
            case 11:
            case 12:
            case 13:
                (_b = series[1].data) === null || _b === void 0 ? void 0 : _b.push(point);
                break;
            case 14:
                (_c = series[2].data) === null || _c === void 0 ? void 0 : _c.push(point);
                break;
            case 4:
                (_d = series[3].data) === null || _d === void 0 ? void 0 : _d.push(point);
                break;
        }
    });
    return series.filter((s) => { var _a; return (_a = s.data) === null || _a === void 0 ? void 0 : _a.length; }).map((s) => {
        var _a;
        return (Object.assign(Object.assign({}, s), { data: (_a = s === null || s === void 0 ? void 0 : s.data) === null || _a === void 0 ? void 0 : _a.map((d) => (Object.assign({ x: d.ballinplayx, y: d.ballinplayy }, d))) }));
    });
};
const SprayChart$1 = ({ type, videos, onClick, sizeMultiplier }) => {
    const { t: translate } = useTranslation();
    const seriesData = buildSeries$5(translate, type, videos);
    return (React.createElement(SprayChart$3, { type: type, seriesData: seriesData, onClick: onClick, enableLegend: true, enableZoom: true, sizeMultiplier: sizeMultiplier, preventLegendSeriesHover: true }));
};

const StrikeZone$1 = ({ playlist, onClick, height, type, size }) => {
    const { t: translate } = useTranslation();
    let strikeZoneSeries = [];
    const getPlayResult = (play) => {
        // Last Pitch
        const fielderEvents = ['Batted Out', 'Single', 'Double', 'Triple'];
        if (play.result && fielderEvents.indexOf(play.result) > -1) {
            return play.result === 'Batted Out'
                ? `${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`
                : `${play.result}, ${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`;
        }
        return play.result || play.pitchresult;
    };
    const buildStrikeZoneSeries = (plays, pitchLocationType) => {
        let series;
        if (pitchLocationType === 'pitchTypes') {
            const pitchTypes = Array.from(new Set(plays.map((p) => Number(p.fxpitchtypeid))));
            series = pitchTypes.map((ptype, index) => {
                const name = pitchType(ptype, true, undefined, translate);
                const color = pitchTypeColor(ptype, translate);
                const data = plays.filter((play) => play.fxpitchtypeid === ptype).map((play) => {
                    const result = getPlayResult(play);
                    return {
                        x: play.platex,
                        y: play.platez,
                        name: result,
                        url: play.url,
                        gameid: play.gameid,
                        eventseq: play.eventseq,
                        pitchseq: play.pitchseq,
                        id: `${play.gameid}_${play.eventseq}_${play.pitchseq}`,
                    };
                });
                return { index, data, name, id: name, color, marker: { symbol: 'circle', radius: 4 }, type: 'scatter' };
            });
        }
        else {
            if (!plays || !plays.length)
                return [];
            const hits = {
                data: [],
                type: 'scatter',
                name: translate('components.video.hard-hit'),
                index: 1,
                id: 'hit',
                color: '#0000ff',
                marker: { symbol: 'diamond', radius: 4, lineColor: '#0000ff', fillColor: '#ffffff', lineWidth: 2 },
            };
            const battedouts = {
                data: [],
                type: 'scatter',
                name: translate('components.video.hard-batted-out'),
                index: 2,
                id: 'out',
                color: '#0000ff',
                marker: { symbol: 'triangle', radius: 5 },
            };
            const swingingstrikes = {
                data: [],
                type: 'scatter',
                name: translate('components.video.swinging-strike'),
                index: 3,
                id: 'swing',
                color: '#ff0000',
                marker: { symbol: 'diamond', radius: 5 },
            };
            const fouls = {
                data: [],
                type: 'scatter',
                name: translate('components.video.foul'),
                index: 4,
                id: 'foul',
                color: '#ff0000',
                marker: { symbol: 'square', radius: 4, lineColor: '#ff0000', fillColor: '#ffffff', lineWidth: 2 },
            };
            const balls = {
                data: [],
                type: 'scatter',
                name: translate('baseball.balls_one'),
                index: 5,
                id: 'ball',
                color: '#00ff00',
                marker: { symbol: 'circle', radius: 5 },
            };
            const calledstrikes = {
                data: [],
                type: 'scatter',
                name: translate('components.video.called-strike'),
                index: 6,
                id: 'stk',
                color: '#ff0000',
                marker: { symbol: 'circle', radius: 5 },
            };
            const weakhits = {
                data: [],
                type: 'scatter',
                name: translate('components.video.weak-hit'),
                index: 7,
                id: 'wkhit',
                color: '#ffa500',
                marker: { symbol: 'diamond', radius: 4, lineColor: '#ffa500', fillColor: '#ffffff', lineWidth: 2 },
            };
            const weakbattedouts = {
                data: [],
                type: 'scatter',
                name: translate('components.video.weak-batted-out'),
                index: 8,
                id: 'wkout',
                color: '#ffa500',
                marker: { symbol: 'triangle', radius: 5 },
            };
            for (let i = 0; i < plays.length; ++i) {
                const play = plays[i];
                if (play.platex && play.platez) {
                    const result = play.resultid;
                    const event = play.baseevent;
                    const point = {
                        x: play.platex,
                        y: play.platez,
                        name: '',
                        tooltip: `${''
                            + `${translate('common.date')}:`}${dateTranslate(translate, play.gamedate)}<br />`
                            + `${translate('components.video.pitch-type')}: ${play.pitchtype}<br />${play.velocity ? `${play.velocity} MPH<br/>` : ''}${play.istop ? `${translate('baseball.abbr-top')} ` : `${translate('baseball.abbr-bottom')} `}${play.inning}, ${play.outsbefore} ${translate('baseball.outs_one')}, ${play.balls}-${play.strikes}<br />${translate('baseball.pitcher_one')}: ${play.pitcher} ${play.islastpitch && (result === 14 || result === 15)
                                ? `<br />${play.hittype ? hitType(play.hittype, false, translate) : ''} ${baseEvent(event, undefined, undefined, translate)}
                                ${play.exitvelo ? `, ${translate('components.video.exit-velo')} ${format(play.exitvelo)}` : ''}`
                                : ''}`,
                        url: play.url,
                        gameid: play.gameid,
                        eventseq: play.eventseq,
                        pitchseq: play.pitchseq,
                    };
                    if ((result === 14 || result === 15) && event > 0 && event < 5 && play.wellhit === 1) {
                        hits.data.push(point);
                    }
                    else if ((result === 14 || result === 15) && play.wellhit === 1 && (event === 8 || (event > 10 && event < 16))) {
                        battedouts.data.push(point);
                    }
                    else if (result === 1) {
                        balls.data.push(point);
                    }
                    else if (result === 4) {
                        calledstrikes.data.push(point);
                    }
                    else if (result === 6 || result === 5 || result === 7) {
                        swingingstrikes.data.push(point);
                    }
                    else if (result >= 8 && result <= 13) {
                        fouls.data.push(point);
                    }
                    else if ((result === 14 || result === 15) && event > 0 && event < 5 && play.wellhit === 0) {
                        weakhits.data.push(point);
                    }
                    else if ((result === 14 || result === 15) && play.wellhit === 0 && (event === 8 || (event > 10 && event < 16))) {
                        weakbattedouts.data.push(point);
                    }
                }
            }
            series = [hits, battedouts, swingingstrikes, fouls, balls, calledstrikes, weakhits, weakbattedouts];
            series = series.filter((x) => x.data.length > 0);
        }
        return series;
    };
    if (playlist && playlist.length > 0) {
        strikeZoneSeries = buildStrikeZoneSeries(playlist, type);
    }
    return (React.createElement(StrikeZone$3, { enableZoom: true, showlegend: true, legendposition: "below", seriesData: strikeZoneSeries, showbatter: false, onClick: onClick, height: height, size: size, preventLegendSeriesHover: true, ignoreLocalStorageChartLegend: false, useABSRulebookZone: true, useBaseballMarkers: true }));
};

const StyledScore = styled.div `
    > div {
        display: flex;
        justify-content: space-evenly;
        > span {
            font-weight: bold;
            font-size: 0.9em;
        }
    }
`;
const PitchTable = ({ playlist, onClick }) => {
    const { t: translate } = useTranslation();
    const getPlayResult = (play) => {
        // Last Pitch
        const fielderEvents = ['Batted Out', 'Single', 'Double', 'Triple'];
        if (play.result !== null && fielderEvents.indexOf(play.result) > -1) {
            return play.result === 'Batted Out'
                ? `${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`
                : `${play.result}, ${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`;
        }
        return play.result || play.pitchresult;
    };
    const pitchColumns = [
        { id: 'videoplaylist', title: null, type: COLUMN_TYPES.NODE },
        { id: 'inn', title: translate('baseball.abbr-inning'), transform: (row) => `${row.istop ? translate('baseball.abbr-top-alt') : translate('baseball.abbr-bottom-alt')}${row.inning}`, type: COLUMN_TYPES.TEXT },
        {
            id: 'batter',
            title: translate('baseball.batter'),
            transform: (row) => `${row.batter_lastname}, ${row.batter_usesname.charAt(0)}`,
            type: COLUMN_TYPES.TEXT,
        },
        {
            id: 'batterhand',
            title: translate('baseball.bats'),
            transform: (row) => {
                if (row.bats === 2)
                    return translate('baseball.abbr-left');
                return translate('baseball.abbr-right');
            },
            type: COLUMN_TYPES.TEXT,
        },
        { id: 'outs', title: translate('baseball.outs_other'), transform: (row) => (React.createElement("span", null, row.outsbefore)), type: COLUMN_TYPES.NODE },
        {
            id: 'run',
            title: translate('components.video.run'),
            transform: (row) => (React.createElement(BaseRunners, { baseState: row.bcbefore, emptyColor: "#98CBFF", height: 20, width: 30 })),
            type: COLUMN_TYPES.NODE,
        },
        {
            id: 'score',
            title: translate('baseball.score'),
            transform: (row) => (React.createElement(StyledScore, null,
                React.createElement("div", null,
                    React.createElement("span", null, row.awayteam_abbr),
                    React.createElement("span", null, row.awayteam_score)),
                React.createElement("div", null,
                    React.createElement("span", null, row.hometeam_abbr),
                    React.createElement("span", null, row.hometeam_score)))),
            type: COLUMN_TYPES.NODE,
        },
        { id: 'count', title: translate('baseball.abbr-count'), transform: (row) => `${row.balls}-${row.strikes}`, type: COLUMN_TYPES.TEXT },
        // eslint-disable-next-line max-len
        { id: 'pitchtype', title: translate('components.video.pitch-type'), transform: (row) => `${pitchType(row.fxpitchtypeid, false, '', translate)}${row.fxsubtype != null ? ` (${pitchSubType(row.fxsubtype, false, '', translate)})` : ''}`, type: COLUMN_TYPES.TEXT },
        { id: 'velocity', title: translate('components.video.pitch-velo'), transform: (row) => row.velocity, precision: 1 },
        {
            id: 'pitchlocation',
            title: translate('components.video.pitch-location'),
            transform: (row) => (row.locationx && row.locationy
                ? (React.createElement(PitchLocation$1, { size: 30, locations: [{ locationx: row.locationx, locationy: row.locationy }], emptyColor: "#98CBFF" })) : React.createElement(React.Fragment, null)),
            type: COLUMN_TYPES.NODE,
        },
        {
            id: 'hittype',
            title: translate('components.video.hit-type'),
            transform: (row) => (row.hittype !== null ? hitType(row.hittype, false, translate) : '--'),
            type: COLUMN_TYPES.TEXT,
        },
        { id: 'hitvelocity', title: translate('components.video.exit-velo'), transform: (row) => row.hitvelocity, precision: 1 },
        { id: 'launchangle', title: translate('components.video.launch-angle'), transform: (row) => row.vertla, precision: 1 },
        {
            id: 'hitlocation',
            title: translate('components.video.hit-location'),
            transform: (row) => (row.hittype !== null ? (React.createElement(HitLocation, { width: 40, height: 30, ballinplayx: row.ballinplayx, ballinplayy: row.ballinplayy, ishr: row.result === 'Home Run' })) : null),
            type: COLUMN_TYPES.TEXT,
        },
        { id: 'result', title: translate('components.video.result'), transform: (row) => getPlayResult(row), type: COLUMN_TYPES.TEXT },
    ];
    const pitchRows = playlist && playlist.length
        ? playlist.map((p) => {
            const videoplaylist = (React.createElement(VideoButton, { onClick: () => onClick(p) }));
            return Object.assign(Object.assign({}, p), { videoplaylist });
        }) : [];
    return React.createElement(DataTable, { sortable: false, columns: pitchColumns, rows: pitchRows });
};

const StyledSprayChartContainer = styled.div `
    margin: 0 auto 0;
    width: 100% !important;
    height: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const VideoPlayerCol = styled(Col) `
    .video-playlist-container {
        height: 100%;
    }
`;
const StyledVideoPlayer = styled(VideoPlayer) `
    height: 100%;

    .video-playlist-container {
        height: 100%;
    }
`;
const StyledTabPanel = styled.div `
    border: ${tabTheme.border};
    ${(props) => (props.isInTabs ? 'border-top: none;' : '')}
`;
const VideoPlayerAdvanced = forwardRef((_a, ref) => {
    var { playlist, onHide, isLargeView = false, hideFilter = false } = _a, rest = __rest(_a, ["playlist", "onHide", "isLargeView", "hideFilter"]);
    const { t: translate } = useTranslation();
    const pitchLocationOptions = [{ name: translate('components.video.results'), value: 'results' }, { name: translate('components.video.pitch-types'), value: 'pitchTypes' }];
    const sprayChartOptions = [{ name: translate('components.video.infield'), value: 'infield' }, { name: translate('components.video.outfield'), value: 'outfield' }];
    const ITEMS_PER_PAGE = 500;
    const [selectedPitchLocation, setSelectedPitchLocation] = useState('results');
    const [selectedSprayChart, setSelectedSprayChart] = useState('infield');
    const [filteredVideos, setFilteredVideos] = useState(playlist);
    const [sortedModalPlaylist, setSortedModalPlaylist] = useState(playlist);
    const [showVideoPlayerModal, setShowVideoPlayerModal] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('pitchLocation');
    const [currentPage, setCurrentPage] = useState(1);
    const usePagination = filteredVideos.length > 1000;
    const onTabSelect = ({ key }) => setActiveTabKey(key);
    const videoPlayerModalContainer = useRef(null);
    const videoPlayerRef = useRef(null);
    useImperativeHandle(ref, () => ({
        setFilteredVideos: (p, f) => {
            var _a;
            (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.onFilter(p, f);
        },
    }));
    const goToVideo = (pitchInfo) => {
        var _a;
        const { gameid, pitchseq, eventseq } = pitchInfo;
        const index = filteredVideos.findIndex((v) => v.data.gameid === gameid && v.data.pitchseq === pitchseq && v.data.eventseq === eventseq);
        if (index > -1) {
            (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.goToNextVideo(index);
            if (browser$1.mobileOnly) {
                const end = filteredVideos.slice(undefined, index - 1);
                const start = filteredVideos.slice(index, undefined);
                const np = start.concat(end);
                setSortedModalPlaylist(np);
                setShowVideoPlayerModal(true);
            }
        }
    };
    const onFilter = (p) => {
        setFilteredVideos(p);
    };
    useEffect(() => {
        setFilteredVideos(playlist);
        setSortedModalPlaylist(playlist);
    }, [playlist]);
    const InnerStrikeZone = () => (React.createElement(StyledTabPanel, { isInTabs: isLargeView, className: `flex-grow-1 bg-white d-flex flex-column justify-content-center ${isLargeView ? 'rounded-bottom' : 'rounded'}`, style: { zIndex: 0 } },
        React.createElement("div", { className: "mt-5 d-flex justify-content-center" },
            React.createElement(ToggleButtons, { name: "togglestrike", options: pitchLocationOptions, value: selectedPitchLocation, onChange: (value) => setSelectedPitchLocation(value) })),
        React.createElement("div", { className: "flex-grow-1 d-flex align-items-center mt-2" },
            React.createElement(StrikeZone$1, { type: selectedPitchLocation, playlist: filteredVideos.map((p) => p.data), onClick: (pitchInfo) => goToVideo(pitchInfo), size: isLargeView ? 'sm' : 'lg', height: isLargeView ? 350 : 435 }))));
    const InnerSprayChart = () => (React.createElement(StyledTabPanel, { isInTabs: isLargeView, className: `flex-grow-1 bg-white d-flex flex-column justify-content-center h-100 ${isLargeView ? 'rounded-bottom' : 'rounded'}`, style: { zIndex: 0 } },
        React.createElement("div", { className: "mt-5 d-flex justify-content-center" },
            React.createElement(ToggleButtons, { name: "togglespray", options: sprayChartOptions, value: selectedSprayChart, onChange: (value) => setSelectedSprayChart(value) })),
        React.createElement(StyledSprayChartContainer, null,
            React.createElement(SprayChart$1, { type: selectedSprayChart, videos: filteredVideos.map((p) => p.data), onClick: (p) => goToVideo(p), sizeMultiplier: isLargeView ? 2 : 1.3 }))));
    const tabs = [
        {
            title: translate('components.video.pitch-location'),
            key: 'pitchLocation',
            component: () => React.createElement(InnerStrikeZone, null),
        },
        {
            title: translate('components.video.spray-chart'),
            key: 'sprayChart',
            component: () => React.createElement(InnerSprayChart, null),
            className: 'me-0',
        },
    ];
    const activeTab = tabs.find(({ key }) => key === activeTabKey);
    return (React.createElement("div", null,
        React.createElement("div", { ref: videoPlayerModalContainer }),
        React.createElement(Row, null,
            React.createElement(VideoPlayerCol, { sm: isLargeView ? 9 : 12 }, browser$1.mobileOnly ? (React.createElement(VideoPlayerModal, Object.assign({ playlist: sortedModalPlaylist, show: showVideoPlayerModal, onHide: () => setShowVideoPlayerModal(false), container: videoPlayerModalContainer }, rest))) : React.createElement(StyledVideoPlayer, Object.assign({ playlist: playlist, onFilter: onFilter, onHide: onHide, ref: videoPlayerRef, hideFilter: hideFilter }, rest, { translate: translate }))),
            isLargeView && (React.createElement(Col, { sm: 3, className: "ps-0" },
                React.createElement("div", { className: "d-flex flex-column h-100" },
                    React.createElement(TabContainer, null, tabs.map((t) => {
                        const { key, title } = t;
                        return (React.createElement(Tab, { key: key, active: t === activeTab, onClick: () => onTabSelect(t), className: `flex-grow-1 ${t.className}` }, title));
                    })), activeTab === null || activeTab === void 0 ? void 0 :
                    activeTab.component())))),
        !isLargeView
            && (React.createElement(Row, { className: "mt-4" },
                React.createElement(Col, { sm: 5 },
                    React.createElement(InnerStrikeZone, null)),
                React.createElement(Col, { sm: 7 },
                    React.createElement("div", { className: "h-100" },
                        React.createElement(InnerSprayChart, null))))),
        React.createElement(Row, { className: "mt-3" },
            React.createElement(Col, { sm: 12 },
                React.createElement(PitchTable, { playlist: usePagination
                        ? filteredVideos.slice(ITEMS_PER_PAGE * (currentPage - 1), currentPage * ITEMS_PER_PAGE).map((p) => p.data)
                        : filteredVideos.map((p) => p.data), onClick: (pitchInfo) => goToVideo(pitchInfo) }),
                usePagination && (React.createElement(DataTablePagination, { onPageChange: setCurrentPage, totalItems: filteredVideos.length, itemsPerPage: ITEMS_PER_PAGE, page: currentPage }))))));
});

const StyledVideoSearchFormInputContainer = styled.div `
    display: flex;
    align-items: center;
    flex: 1;
    > label {
        min-width: 50px;
        flex-basis: 50px;
        flex-grow: 0;
        margin: 0 7.5px 0 0;
    }
    .d-flex & + & > label { 
        margin-left: 15px;
    }
    > div {
        flex-grow: 1;
        display: flex;
        align-items: center;
        > div {
            flex: 1;
        }
        > span {
            flex: 0;
        }
    }
    .dropdown > .btn {
        width: 100%;
    }
`;
const ChildrenWrapper = styled.div `
    min-width: 0;
`;
const VideoSearchFormInputContainer = ({ label, children }) => (React.createElement(StyledVideoSearchFormInputContainer, null,
    React.createElement("label", null, label),
    React.createElement(ChildrenWrapper, null, children)));

/* eslint-disable max-len */
const formElementMargin = '7.5px';
const StyledActionButtons = styled.div `
    display: flex;
    justify-content: space-between;
    margin-top: 0.75rem;
    > div {
        display: flex;
        flex-direction: column;
    }
`;
const StyledVideoSearchForm = styled(Form) `
    > div + div {
        margin-top: ${formElementMargin};
    }

    .start-date {
        left: -50px;
    }
`;
const StyledWideDropdown = styled(DropdownInput) `
    min-width: 0;
    .dropdown {
        min-width: 0;
    }

    button.dropdown-toggle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        position: relative;
        text-align: left;
        padding: 0.375rem 1rem 0.375rem 0.5rem !important;

        &::after {
            position: absolute;
            right: 8px;
            top: 14px;
        }
    }
`;
const VideoSearchForm = ({ yearId, onSubmit, onCreate, onUpdate, onDelete, onClear, form, levelId = 8, initForm: init, playerSearch: PlayerSearch, teamSearch: TeamSearch, hideSavedSearches = false, showClear = false, searchButtonTitle = '', showCancel = false, onCancel, hideAmateurLevels, }) => {
    const { t: translate } = useTranslation();
    const initForm = Object.assign({ Type: 1, YearID: yearId, LevelID: levelId }, init);
    const [search, setSearchParams] = useState(initForm);
    const [batter, setBatter] = useState();
    const [pitcher, setPitcher] = useState();
    const [catcher, setCatcher] = useState();
    const [fielder, setFielder] = useState();
    const [battingTeam, setBattingTeam] = useState();
    const [pitchingTeam, setPitchingTeam] = useState();
    const searchButtonTitleUse = searchButtonTitle === '' ? translate('components.search.view-search-results') : searchButtonTitle;
    const allOpt = { name: translate('common.all'), value: null };
    const pitchTypes = PITCH_TYPES(translate).filter(({ id }) => id > 0).sort((a, b) => a.sortorder - b.sortorder).map((p) => (Object.assign(Object.assign({}, p), { value: p.id })));
    const pitchSubTypes = PITCH_SUB_TYPES(translate).filter(({ id }) => id > 0).sort((a, b) => a.sortorder - b.sortorder).map((p) => (Object.assign(Object.assign({}, p), { value: p.id })));
    const fxTypeOpts = [allOpt, ...pitchTypes.filter(({ isfxtype }) => isfxtype)];
    const fxSubTypeOpts = [allOpt, ...pitchSubTypes.filter(({ typeid }) => search.FXPitchType != null && typeid === search.FXPitchType)];
    const pitchTypeOpts = [allOpt, ...pitchTypes.filter(({ value }) => value <= 8 || value === 11)];
    const filteredLevels = hideAmateurLevels ? LEVELS.filter((x) => x.id < 31 || x.id > 41) : LEVELS; // we want to hide 31-41 levels in this case (not allowed in the dropdown)
    const levelOpts = [
        allOpt,
        ...filteredLevels.filter((l) => l.id > 0).sort((a, b) => a.sortorder - b.sortorder).map((l) => ({ name: l.name, value: l.id })),
    ];
    const batsOpts = [allOpt, { value: 0, name: translate('baseball.right') }, { value: 1, name: translate('baseball.left') }];
    const throwsOpts = [allOpt, { value: 0, name: translate('baseball.right') }, { value: 1, name: translate('baseball.left') }];
    const eventOpts = [
        allOpt,
        ...BASE_EVENTS(translate).filter(({ id }) => id % 100 > 0).map((l) => ({ name: `${l.altName || l.name} [${l.abbr}]`, value: l.id })),
    ];
    const outsOpts = [allOpt, ...[0, 1, 2].map((o) => ({ name: o.toString(), value: o }))];
    const inningsOpts = [allOpt, ...Array(22).fill(undefined).map((_, idx) => ({ name: idx + 1, value: idx + 1 }))];
    useEffect(() => {
        const searchParams = form || initForm;
        setSearchParams(searchParams);
        setBatter(searchParams.Batter);
        setPitcher(searchParams.Pitcher);
        setCatcher(searchParams.Catcher);
        setFielder(searchParams.Fielder);
        setBattingTeam(searchParams.BattingTeam);
        setPitchingTeam(searchParams.PitchingTeam);
    }, [form]); // eslint-disable-line react-hooks/exhaustive-deps
    const onSearchModelChange = (name, value) => setSearchParams((p) => (Object.assign(Object.assign({}, p), { [name]: value })));
    const onDropdownChange = (name) => ({ value }, keyVal) => {
        const searchValue = value !== undefined ? value : keyVal;
        if (name === 'FXPitchType')
            onSearchModelChange('FXSubType', null);
        return onSearchModelChange(name, searchValue);
    };
    const onDatePickerSelect = (name) => (val) => {
        onSearchModelChange('YearID', null);
        onSearchModelChange(name, val);
    };
    const onYearChange = () => ({ value }, keyVal) => {
        const searchValue = value !== undefined ? value : keyVal;
        onSearchModelChange('YearID', searchValue);
        onSearchModelChange('StartDate', null);
        onSearchModelChange('EndDate', null);
    };
    const onInputChange = (name) => (e) => onSearchModelChange(name, e.currentTarget.value);
    const getDropdownValue = (opts, formVal) => opts.find(({ value }) => {
        if (value === null || value === undefined)
            return formVal === null || formVal === undefined;
        return value === formVal;
    });
    const mappedSearchForm = Object.assign(Object.assign({}, search), { BatterID: batter === null || batter === void 0 ? void 0 : batter.PlayerID, PitcherID: pitcher === null || pitcher === void 0 ? void 0 : pitcher.PlayerID, CatcherID: catcher === null || catcher === void 0 ? void 0 : catcher.PlayerID, FielderID: fielder === null || fielder === void 0 ? void 0 : fielder.PlayerID, BattingTeamID: battingTeam === null || battingTeam === void 0 ? void 0 : battingTeam.TeamID, PitchingTeamID: pitchingTeam === null || pitchingTeam === void 0 ? void 0 : pitchingTeam.TeamID, Pitcher: pitcher !== null && pitcher !== void 0 ? pitcher : undefined, Catcher: catcher !== null && catcher !== void 0 ? catcher : undefined, Fielder: fielder !== null && fielder !== void 0 ? fielder : undefined, Batter: batter !== null && batter !== void 0 ? batter : undefined, BattingTeam: battingTeam !== null && battingTeam !== void 0 ? battingTeam : undefined, PitchingTeam: pitchingTeam !== null && pitchingTeam !== void 0 ? pitchingTeam : undefined });
    const onFormSubmit = () => onSubmit(mappedSearchForm);
    const createSavedSearch = () => onCreate(mappedSearchForm);
    const updateSavedSearch = () => onUpdate(mappedSearchForm);
    const deleteSavedSearch = () => onDelete(form.VideoSearchID);
    const videoYearsOpts = [...(Array(yearId - 2002).fill(undefined).map((_, idx) => ({ name: yearId - idx })))];
    const disableUpdateSearchButton = (form === search
        && form.BattingTeam === battingTeam
        && form.PitchingTeam === pitchingTeam
        && form.Batter === batter
        && form.Pitcher === pitcher);
    const resetForm = () => {
        setSearchParams(Object.assign(Object.assign({}, initForm), { LastXGames: '', LastXPas: '' }));
        setBatter(null);
        setPitcher(null);
        setCatcher(null);
        setBattingTeam(null);
        setPitchingTeam(null);
    };
    const filtersApplied = [
        !!search.StartDate,
        !!search.EndDate,
        !!search.PitchType,
        !!search.FXPitchType,
        !!search.BaseEvent,
        !(search.Outs === undefined || search.Outs === null),
        !!search.Inning,
        !(search.Throws === undefined || search.Throws === null),
        !(search.Bats === undefined || search.Bats === null),
        !!search.LastXGames,
        !!search.LastXPas,
        !!battingTeam,
        !!pitchingTeam,
        !!batter,
        !!pitcher,
        !!fielder
    ];
    const numFiltersApplied = filtersApplied.filter((x) => x).length;
    const needsMoreFilters = (!!search.LevelID && (numFiltersApplied === 0)) || (!search.LevelID && ((numFiltersApplied <= 1) && !batter && !pitcher));
    return (React.createElement(StyledVideoSearchForm, null,
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.single-year') },
            React.createElement(StyledWideDropdown, { options: videoYearsOpts, onSelect: onYearChange(), value: search.YearID, children: undefined, align: "end" })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('common.date') },
            React.createElement(DatePicker, { value: search.StartDate, onSelect: onDatePickerSelect('StartDate'), calendarClassName: "start-date" }),
            React.createElement("span", null, "\u00A0-\u00A0"),
            React.createElement(DatePicker, { value: search.EndDate, onSelect: onDatePickerSelect('EndDate'), alignRight: true })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.level_one') },
            React.createElement(StyledWideDropdown, { options: levelOpts, onSelect: onDropdownChange('LevelID'), value: getDropdownValue(levelOpts, search.LevelID), children: undefined })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.pitch-type') },
            React.createElement(DropdownInput, { options: pitchTypeOpts, onSelect: onDropdownChange('PitchType'), value: getDropdownValue(pitchTypeOpts, search.PitchType), children: undefined, align: "end" })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.fx-pitch-type') },
            React.createElement(DropdownInput, { options: fxTypeOpts, onSelect: onDropdownChange('FXPitchType'), value: getDropdownValue(fxTypeOpts, search.FXPitchType), align: "end", children: undefined })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.fx-sub-type') },
            React.createElement(DropdownInput, { options: fxSubTypeOpts, onSelect: onDropdownChange('FXSubType'), value: getDropdownValue(fxSubTypeOpts, search.FXSubType), align: "end", children: undefined })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.batting-team') },
            React.createElement(TeamSearch, { onSelect: setBattingTeam, onClear: () => setBattingTeam(null), value: battingTeam === null || battingTeam === void 0 ? void 0 : battingTeam.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.pitching-team') },
            React.createElement(TeamSearch, { onSelect: setPitchingTeam, onClear: () => setPitchingTeam(null), value: pitchingTeam === null || pitchingTeam === void 0 ? void 0 : pitchingTeam.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.event') },
            React.createElement(StyledWideDropdown, { options: eventOpts, onSelect: onDropdownChange('BaseEvent'), value: getDropdownValue(eventOpts, search.BaseEvent), children: undefined, align: "end" })),
        React.createElement("div", { className: "d-flex" },
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.outs_other') },
                React.createElement(DropdownInput, { options: outsOpts, onSelect: onDropdownChange('Outs'), value: getDropdownValue(outsOpts, search.Outs), children: undefined })),
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.inning') },
                React.createElement(DropdownInput, { options: inningsOpts, onSelect: onDropdownChange('Inning'), value: getDropdownValue(inningsOpts, search.Inning), children: undefined, align: "end" }))),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.batter') },
            React.createElement(PlayerSearch, { isPitcher: false, onSelect: setBatter, onClear: () => setBatter(null), value: batter === null || batter === void 0 ? void 0 : batter.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.pitcher_one') },
            React.createElement(PlayerSearch, { isPitcher: true, onSelect: setPitcher, onClear: () => setPitcher(null), value: pitcher === null || pitcher === void 0 ? void 0 : pitcher.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.catcher_one') },
            React.createElement(PlayerSearch, { isCatcher: true, onSelect: setCatcher, onClear: () => setCatcher(null), value: catcher === null || catcher === void 0 ? void 0 : catcher.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.fielder') },
            React.createElement(PlayerSearch, { onSelect: setFielder, onClear: () => setFielder(null), value: fielder === null || fielder === void 0 ? void 0 : fielder.FullName })),
        React.createElement("div", { className: "d-flex" },
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.bats') },
                React.createElement(DropdownInput, { options: batsOpts, onSelect: onDropdownChange('Bats'), value: getDropdownValue(batsOpts, search.Bats), children: undefined })),
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.throws') },
                React.createElement(DropdownInput, { options: throwsOpts, onSelect: onDropdownChange('Throws'), value: getDropdownValue(throwsOpts, search.Throws), align: "end", children: undefined }))),
        React.createElement("div", { className: "d-flex" },
            React.createElement(VideoSearchFormInputContainer, { label: React.createElement(React.Fragment, null,
                    translate('components.search.last'),
                    " ",
                    React.createElement("i", null, "X"),
                    " ",
                    translate('components.search.games')) },
                React.createElement(Form.Control, { type: "number", size: "sm", min: 1, max: 32767, value: search.LastXGames, onChange: onInputChange('LastXGames') })),
            React.createElement(VideoSearchFormInputContainer, { label: React.createElement(React.Fragment, null,
                    translate('components.search.last'),
                    " ",
                    React.createElement("i", null, "X"),
                    " ",
                    translate('components.search.abbr-plate-app')) },
                React.createElement(Form.Control, { type: "number", size: "sm", min: 1, max: 32767, value: search.LastXPas, onChange: onInputChange('LastXPas') }))),
        React.createElement("hr", { className: "mb-1" }),
        needsMoreFilters && !!search.LevelID && React.createElement("div", { className: "text-muted d-flex justify-content-end" }, translate('components.search.please-add-more-value')),
        needsMoreFilters && !search.LevelID && React.createElement("div", { className: "text-muted d-flex justify-content-end" }, translate('components.search.please-add-two-criteria')),
        React.createElement(StyledActionButtons, null,
            React.createElement("div", null, showClear && (React.createElement(Button, { onClick: resetForm }, translate('components.search.clear')))),
            !hideSavedSearches && (React.createElement("div", null,
                React.createElement(Button, { variant: "success", disabled: needsMoreFilters, onClick: createSavedSearch }, translate('components.search.create-saved-search')),
                !!form && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { variant: "secondary", disabled: disableUpdateSearchButton, onClick: updateSavedSearch }, translate('components.search.update-saved-search')),
                    React.createElement(Button, { variant: "danger", onClick: deleteSavedSearch }, translate('components.search.delete-saved-search')))))),
            React.createElement("div", { className: "d-flex align-items-center flex-row" },
                showCancel && React.createElement(Button, { onClick: onCancel, className: "me-2" }, translate('common.cancel')),
                React.createElement(Button, { variant: "primary", disabled: needsMoreFilters, onClick: onFormSubmit }, searchButtonTitleUse),
                !hideSavedSearches && onClear && React.createElement(Button, { variant: "default", onClick: onClear }, translate('components.search.view-saved-searches'))))));
};

const StyledVideoSearchFormHeader = styled.div `
    ${sideContentHeader}
    flex-grow: 0;
`;
const StyledVideoSearchInputSection = styled.div `
    width: ${sideContentWidth}px;
    display: flex;
    flex-direction: column;
    background-color: white;
    & {
        height: 100%;
    }
    form {
        padding: ${videoFilterPadding};
        flex-grow: 1;
    }
`;
const VideoSearchInputSection = ({ children, isExpanded, toggleSearchPanel }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(StyledVideoSearchInputSection, null,
        React.createElement(StyledVideoSearchFormHeader, { onClick: toggleSearchPanel },
            React.createElement("div", { className: "d-flex align-items-center justify-content-between" },
                React.createElement("h4", null, translate('common.search')),
                React.createElement(Icon, { icon: `chevron-${isExpanded ? 'up' : 'down'}`, size: "1.5em", color: styles.theme.background.mariner }))),
        children));
};

const EnterVideoSearchNameModal = (_a) => {
    var { onSave, onHide } = _a, rest = __rest(_a, ["onSave", "onHide"]);
    const { t: translate } = useTranslation();
    const [name, setName] = useState(null);
    const onResolve = () => {
        if (name) {
            onSave({ Name: name });
            setName(null);
        }
    };
    const onModalHide = () => {
        setName(null);
        onHide();
    };
    return (React.createElement(BaseDialogModal, Object.assign({ resolveTxt: translate('common.save'), closeTxt: translate('common.cancel'), onResolve: onResolve, onHide: onModalHide }, rest),
        React.createElement(Form, null,
            React.createElement(Row$1, null,
                React.createElement(Col$1, { sm: 12 },
                    React.createElement("p", null, translate('components.search.please-enter-name')))),
            React.createElement(Form.Group, { as: Row$1, controlId: "videoSearchName" },
                React.createElement(Form.Label, { column: true, sm: 2 },
                    translate('components.search.name'),
                    ":"),
                React.createElement(Col$1, { sm: 10 },
                    React.createElement(Form.Control, { type: "text", size: "sm", onChange: (e) => setName(e.currentTarget.value), required: true }))))));
};

const StyledSearchListFilterValue = styled(Col$1).attrs({ xs: 'auto' }) `
    white-space: nowrap;
    label {
        font-weight: 400;
        margin: 2.5px 5px 2.5px 0;
    }
`;
const StyledSearchListCard = styled(Card$2).attrs({ body: true }) `
    font-weight: 500;
    font-size: 1.15em;
    & + & {
        margin-top: 10px;
    }
    &:hover, &:active {
        cursor: pointer;
        background-color: #ECECEC;
    }
`;
const StyledSavedSearchList = styled.div `
    padding: ${styles.theme.margin.body};
    h5 {
        text-align: center;
    }
    .spinner-border {
        display: block;
        margin: auto;
    }
`;
const SavedSearchList = ({ savedSearches, onSelect }) => {
    const { t: translate } = useTranslation();
    const savedSearchFilters = [
        { key: 'Batter.FullName', label: translate('baseball.batter') },
        { key: 'Pitcher.FullName', label: translate('baseball.pitcher_one') },
        { key: 'BattingTeam.FullName', label: translate('components.search.batting-team') },
        { key: 'PitchingTeam.FullName', label: translate('components.search.pitching-team') },
        { key: 'YearID', label: translate('common.year') },
        { key: 'Date', label: translate('common.date'), transform: ({ StartDate, EndDate }) => ((StartDate && EndDate) ? `${date(StartDate)} - ${date(EndDate)}` : null) },
        { key: 'LevelID', label: translate('baseball.level_one'), transform: ({ LevelID }) => { var _a; return (LevelID ? (_a = LEVELS.find((l) => l.id === LevelID)) === null || _a === void 0 ? void 0 : _a.abbr : null); } },
        // eslint-disable-next-line no-nested-ternary
        { key: 'Bats', label: translate('components.search.filter.batter-hand'), transform: ({ Bats }) => (Bats ? Bats === 1 ? translate('baseball.rhh') : Bats === 2 ? translate('baseball.lhh') : translate('baseball.switch') : null) },
        // eslint-disable-next-line no-nested-ternary
        { key: 'Throws', label: translate('components.search.filter.pitcher-hand'), transform: ({ Throws }) => (Throws ? Throws === 1 ? translate('baseball.rhp') : Throws === 2 ? translate('baseball.lhp') : translate('baseball.switch') : null) },
        { key: 'PitchType', label: translate('components.video.filters.pitch-type'), transform: ({ PitchType }) => pitchType(PitchType, undefined, undefined, translate) },
        { key: 'FXPitchType', label: translate('components.video.filters.fx-pitch-type'), transform: ({ FXPitchType }) => pitchType(FXPitchType, undefined, undefined, translate) },
        { key: 'FXSubType', label: translate('components.video.filters.fx-sub-type'), transform: ({ FXSubType }) => pitchSubType(FXSubType, undefined, undefined, translate) },
        { key: 'Outs', label: translate('baseball.outs_other') },
        { key: 'Inning', label: translate('baseball.inning') },
        { key: 'LastXGames', label: translate('components.video.filters.last-x-games') },
        { key: 'LastXPas', label: translate('components.video.filters.last-x-pa') },
        { key: 'BaseEvent', label: translate('components.search.event'), transform: ({ BaseEvent }) => { var _a; return (BaseEvent ? (_a = BASE_EVENTS(translate).find((b) => b.id === BaseEvent)) === null || _a === void 0 ? void 0 : _a.name : null); } },
    ];
    return (React.createElement(StyledSavedSearchList, null,
        React.createElement("h4", null, translate('components.search.saved-searches')),
        !savedSearches && React.createElement(LoadingSpinner$1, null),
        savedSearches && !savedSearches.length && React.createElement("h5", null, translate('components.search.no-searches-found')), savedSearches === null || savedSearches === void 0 ? void 0 :
        savedSearches.map((ss) => (React.createElement(StyledSearchListCard, { key: ss.VideoSearchID, onClick: () => onSelect(ss.VideoSearchID, ss) },
            React.createElement(Row$1, { className: "align-items-center" },
                React.createElement(Col$1, { md: 4, lg: 2 }, ss.Name),
                React.createElement(Col$1, { md: 8, lg: 10 },
                    React.createElement(Row$1, null, savedSearchFilters.map(({ key, label, transform }) => {
                        const value = transform ? transform(ss) : get$2(ss, key);
                        if (value === null || value === undefined)
                            return null;
                        if (key === 'YearID' && ss.StartDate && ss.EndDate)
                            return null;
                        return (React.createElement(StyledSearchListFilterValue, { key: key },
                            React.createElement("label", null,
                                label,
                                ":"),
                            value));
                    })))))))));
};

/* const playlistColumns = [
    { id: 'idx', type: columnTypes.TEXT, transform: ({ title }) => title.split(' ')[0] },
    { id: 'data.pitcher', type: columnTypes.TEXT, title: 'Pitcher' },
    { id: 'data.batter', type: columnTypes.TEXT, title: 'Batter' },
    { id: 'date', type: columnTypes.TEXT, title: 'Date', transform: ({ data }) => date(data.gamedate) },
    { id: 'inning', type: columnTypes.TEXT, title: 'Inning', transform: ({ data }) => `${data.istop ? 'Top' : 'Bot'} ${data.inning}` },
    { id: 'data.outsbefore', title: 'Outs' },
    { id: 'count', type: columnTypes.TEXT, title: 'Count', transform: ({ data }) => `${data.balls}-${data.strikes}` },
    { id: 'pitchtype', type: columnTypes.TEXT, title: 'Pitch Type', transform: ({ data }) => data.fxpitchtype || data.pitchtype },
    { id: 'result', type: columnTypes.TEXT, title: 'Result', transform: ({ data }) => data.result || data.pitchresult },
]; */
const StyledLoadingVideoOverlay = styled.div `
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    z-index: 1;
`;
const StyledVideoSearchContainer = styled(Container$m).attrs({ fluid: true }) `
    &,
    >.row.g-0,
    >.row.g-0 > .col > div,
    ${StyledVideoFilterContainer},
    ${StyledLoadingVideoOverlay},
    ${StyledVideoPlaylistContainer}
    {
        height: 100%;
    }
`;
const StyledSearchCol = styled(Col$1) `
    z-index: 2;
`;
const VideoSearch = ({ yearId, search, create, update, delete: remove, savedSearches, initSearch, modalContainer, defaultLevelId, videoPlayer: VideoPlayer, playerSearch, teamSearch, alwaysShowFilter = true, hideSavedSearches = false, hideDownload = false, hideShare = false, hideFrameGrab = false, hideAmateurLevels = false, }) => {
    const { t: translate } = useTranslation();
    const [searching, setSearching] = useState(false);
    const [saving, setSaving] = useState(false);
    const [showConfirmDeleteID, setShowConfirmDeleteID] = useState(null);
    const [showNameFormModel, setShowNameFormModel] = useState(null);
    const [expandSearchPanel, setExpandSearchPanel] = useState(false);
    const [playlist, setPlaylist] = useState(null);
    const [activeSavedSearchId, setActiveSavedSearchId] = useState(null);
    const searchVideos = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        setPlaylist(null);
        setSearching(true);
        const resp = yield search(formData);
        setPlaylist(resp);
        setSearching(false);
    });
    const updateSavedSearch = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        setSaving(true);
        yield update(formData);
        setSaving(false);
    });
    const onCreate = (formData) => setShowNameFormModel(formData);
    const onEnterNameModalHide = () => setShowNameFormModel(null);
    const createSavedSearch = (enterNameFormData) => __awaiter(void 0, void 0, void 0, function* () {
        onEnterNameModalHide();
        setSaving(true);
        const newSearch = yield create(Object.assign(showNameFormModel !== null ? showNameFormModel : {}, enterNameFormData));
        setActiveSavedSearchId(newSearch.VideoSearchID);
        setSaving(false);
    });
    const onDelete = (savedSearchId) => setShowConfirmDeleteID(savedSearchId);
    const onDeleteModalHide = () => setShowConfirmDeleteID(null);
    const deleteSavedSearch = () => __awaiter(void 0, void 0, void 0, function* () {
        onDeleteModalHide();
        setSaving(true);
        yield remove(showConfirmDeleteID);
        setActiveSavedSearchId(null);
        setSaving(false);
    });
    const onPlaylistClear = () => {
        setPlaylist(null);
        setActiveSavedSearchId(null);
    };
    const activeSearch = savedSearches === null || savedSearches === void 0 ? void 0 : savedSearches.find(({ VideoSearchID }) => VideoSearchID === activeSavedSearchId);
    return (React.createElement(StyledVideoSearchContainer, { "$hideFilters": expandSearchPanel },
        React.createElement(ConfirmModal, { message: `${translate('components.search.are-you-sure-delete')}:\n${activeSearch === null || activeSearch === void 0 ? void 0 : activeSearch.Name}?`, onConfirm: deleteSavedSearch, onHide: onDeleteModalHide, show: !!showConfirmDeleteID, container: modalContainer }),
        React.createElement(EnterVideoSearchNameModal, { onSave: createSavedSearch, onHide: onEnterNameModalHide, show: !!showNameFormModel, container: modalContainer }),
        React.createElement(Row$1, { className: "flex-nowrap g-0" },
            React.createElement(StyledSearchCol, { xs: "auto" },
                React.createElement(VideoSearchInputSection, { isExpanded: !playlist || expandSearchPanel, toggleSearchPanel: () => setExpandSearchPanel(!expandSearchPanel) },
                    React.createElement(VideoSearchForm, { onSubmit: searchVideos, onCreate: onCreate, onUpdate: updateSavedSearch, onDelete: onDelete, onClear: playlist ? onPlaylistClear : undefined, yearId: yearId, searching: searching, saving: saving, playerSearch: playerSearch, teamSearch: teamSearch, levelId: defaultLevelId, initForm: initSearch, form: activeSearch, hideSavedSearches: hideSavedSearches, hideAmateurLevels: hideAmateurLevels }))),
            React.createElement(Col$1, null,
                (searching || saving) && (React.createElement(StyledLoadingVideoOverlay, null,
                    React.createElement(LoadingSpinner$1, null))),
                playlist && (React.createElement("div", null,
                    React.createElement(VideoPlayer, { playlist: playlist, alwaysShowFilter: alwaysShowFilter, hideShare: hideShare, hideDownload: hideDownload, hideFrameGrab: hideFrameGrab }))),
                !playlist && !hideSavedSearches && (React.createElement(SavedSearchList, { savedSearches: savedSearches, onSelect: setActiveSavedSearchId }))))));
};

const minMaxTransform = (unit) => (value) => `${value.min} - ${value.max} ${unit}`;
const yesNoTransform = (value) => value;
const arrayTransform = (value) => value.join(', ');
const baseRunnersTransform = (value) => {
    switch (value) {
        case 1: return '1B';
        case 2: return '2B';
        case 3: return '1B, 2B';
        case 4: return '3B';
        case 5: return '1B, 3B';
        case 6: return '2B, 3B';
        case 7: return '1B, 2B, 3B';
        default: return '';
    }
};
const hitLocationTransform = (value) => {
    const locations = [
        { isinfieldbip: true, distance: { max: 60 }, label: 'PIT' },
        { isinfieldbip: true, angleto2b: { max: -22.5 }, distance: { min: 60 }, label: '3B' },
        { isinfieldbip: true, angleto2b: { min: -22.5, max: 0 }, distance: { min: 60 }, label: 'SS' },
        { isinfieldbip: true, angleto2b: { min: 0, max: 22.5 }, distance: { min: 60 }, label: '2B' },
        { isinfieldbip: true, angleto2b: { min: 22.5 }, distance: { min: 60 }, label: '1B' },
        { isinfieldbip: false, angleto2b: { max: -27 }, label: 'LF' },
        { isinfieldbip: false, angleto2b: { min: -27, max: -9 }, label: 'LCF' },
        { isinfieldbip: false, angleto2b: { min: -9, max: 9 }, label: 'CF' },
        { isinfieldbip: false, angleto2b: { min: 9, max: 27 }, label: 'RCF' },
        { isinfieldbip: false, angleto2b: { min: 27 }, label: 'RF' },
        { ishr: true, angleto2b: { max: -15 }, label: 'HR-LF' },
        { ishr: true, angleto2b: { min: -15, max: 15 }, label: 'HR-CF' },
        { ishr: true, angleto2b: { min: 15 }, label: 'HR-RF' }
    ];
    return value.map((v) => {
        var _a;
        return (_a = locations.find((l) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return l.isinfieldbip === v.isinfieldbip
                && l.ishr === v.ishr
                && ((_a = l.distance) === null || _a === void 0 ? void 0 : _a.min) === ((_b = v.distance) === null || _b === void 0 ? void 0 : _b.min)
                && ((_c = l.distance) === null || _c === void 0 ? void 0 : _c.max) === ((_d = v.distance) === null || _d === void 0 ? void 0 : _d.max)
                && ((_e = l.angleto2b) === null || _e === void 0 ? void 0 : _e.min) === ((_f = v.angleto2b) === null || _f === void 0 ? void 0 : _f.min)
                && ((_g = l.angleto2b) === null || _g === void 0 ? void 0 : _g.max) === ((_h = v.angleto2b) === null || _h === void 0 ? void 0 : _h.max);
        })) === null || _a === void 0 ? void 0 : _a.label;
    })
        .filter((x) => x)
        .join(', ');
};
const searchFilters = (translate) => [
    { field: 'pitcherHand', title: translate('components.search.filter.pitcher-hand'), transform: (value) => ({ 0: translate('baseball.rhp'), 1: translate('baseball.lhp') }[value]) },
    { field: 'batterHand', title: translate('components.search.filter.batter-hand'), transform: (value) => ({ 0: translate('baseball.rhh'), 1: translate('baseball.lhh') }[value]) },
    { field: 'balls', title: `${translate('baseball.count')} (${translate('baseball.balls_other')})`, transform: (value) => value.sort((a, b) => a - b).join(', ') },
    { field: 'strikes', title: `${translate('baseball.count')} (${translate('baseball.strikes_other')})`, transform: (value) => value.sort((a, b) => a - b).join(', ') },
    { field: 'outsbefore', title: translate('baseball.outs_other'), transform: (value) => value.sort((a, b) => a - b).join(', ') },
    { field: 'hasRunners', title: translate('components.search.filter.baserunners'), transform: (value) => ({ 0: translate('components.search.none-on'), 1: translate('components.search.some-on') }[value]) },
    { field: 'bcbefore', title: translate('components.search.filter.baserunners'), transform: baseRunnersTransform },
    { field: 'type', title: translate('components.search.pitch-type'), transform: (value) => value.map((p) => { var _a; return (_a = PITCH_TYPES(translate).find((pt) => pt.id === p)) === null || _a === void 0 ? void 0 : _a.abbr; }).join(', ') },
    { field: 'velocity', title: translate('components.search.filter.pitch-velo'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'spinrate', title: translate('components.search.filter.spin-rate'), transform: minMaxTransform(translate('components.search.abbr-rpm')) },
    { field: 'breakz54', title: translate('components.search.filter.vertical-break'), transform: minMaxTransform(translate('components.search.abbr-inches')) },
    { field: 'breakx54', title: translate('components.search.filter.horizontal-break'), transform: minMaxTransform(translate('components.search.abbr-inches')) },
    { field: 'initposx_55', title: translate('components.search.filter.horizontal-release'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'initposz_55', title: translate('components.search.filter.vertical-release'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'rvactualNorm', title: translate('components.search.filter.rv-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvexpNorm', title: translate('components.search.filter.expected-rv-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvpitchfxNorm', title: translate('components.search.filter.pfx-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvbreakNorm', title: translate('components.search.filter.break-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvstuffNorm', title: translate('components.search.filter.stuff-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvlocNorm', title: translate('components.search.filter.location-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'hittype', title: translate('components.search.filter.hit-type'), transform: (value) => value.map((v) => ({ 0: translate('baseball.pitchresult.abbr-groundball'), 1: translate('baseball.pitchresult.abbr-flyball'), 2: translate('baseball.pitchresult.abbr-linedrive'), 3: translate('baseball.pitchresult.abbr-popup') }[v])).join(', ') },
    { field: 'hitLocations', title: translate('components.search.filter.hit-location'), transform: hitLocationTransform },
    { field: 'hitvelocity', title: translate('components.search.filter.exit-velo'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'contactResult', title: translate('components.search.filter.contact-result-bip'), transform: minMaxTransform(translate('components.search.abbr-r100')) },
    { field: 'contactQuality', title: translate('components.search.filter.contact-quality-bip'), transform: minMaxTransform(translate('components.search.abbr-r100')) },
    { field: 'vertla', title: translate('components.search.filter.vertical-launch-angle'), transform: minMaxTransform(translate('components.search.abbr-degree')) },
    { field: 'horizla', title: translate('components.search.filter.horizontal-launch-angle'), transform: minMaxTransform(translate('components.search.abbr-degree')) },
    { field: 'zonedepth', title: translate('components.search.filter.zone-depth'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'swinging', title: translate('components.search.filter.swinging'), transform: yesNoTransform },
    { field: 'swingingFirstPitch', title: translate('components.search.filter.swinging-first-pitch'), transform: yesNoTransform },
    { field: 'swingingInZone', title: translate('components.search.filter.swinging-in-zone'), transform: yesNoTransform },
    { field: 'chase', title: translate('components.search.filter.chase'), transform: yesNoTransform },
    { field: 'miss', title: translate('components.search.filter.miss'), transform: yesNoTransform },
    { field: 'missInZone', title: translate('components.search.filter.miss-in-zone'), transform: yesNoTransform },
    { field: 'inZone', title: translate('components.search.filter.in-zone'), transform: yesNoTransform },
    { field: 'strikeout', title: translate('components.search.filter.strikeout'), transform: yesNoTransform },
    { field: 'unintentionalWalk', title: translate('components.search.filter.unintentional-walk'), transform: yesNoTransform },
    { field: 'swds', title: translate('components.search.filter.score'), transform: minMaxTransform(translate('components.search.abbr-points')) },
    { field: 'swingDecisionScoreShouldSwing', title: `${translate('components.search.filter.score')} (${translate('components.search.filter.should-swing')})`, transform: minMaxTransform(translate('components.search.abbr-points')) },
    { field: 'swingDecisionScoreShouldTake', title: `${translate('components.search.filter.score')} (${translate('components.search.filter.should-take')})`, transform: minMaxTransform(translate('components.search.abbr-points')) },
    { field: 'fapproach', title: translate('components.search.filter.fielder-approach'), transform: arrayTransform },
    { field: 'fmethod', title: translate('components.search.filter.fielding-method'), transform: arrayTransform },
    { field: 'fmove', title: translate('components.search.filter.fielder-movement'), transform: arrayTransform },
    { field: 'fthrow', title: translate('components.search.filter.fielder-throw'), transform: arrayTransform },
    { field: 'diffopps', title: translate('components.search.filter.difficulty-opps'), transform: arrayTransform },
    { field: 'diffmade', title: translate('components.search.filter.difficulty-made'), transform: arrayTransform },
    { field: 'hasShift', title: translate('components.search.filter.has-shift'), transform: yesNoTransform },
    { field: 'runnersOn', title: translate('components.search.filter.runners-on'), transform: yesNoTransform },
    { field: 'throwvelo', title: translate('components.search.filter.throw-velocity'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'exchange', title: translate('components.search.filter.exchange'), transform: minMaxTransform(translate('components.search.abbr-seconds')) },
    { field: 'startingdepth', title: translate('components.search.filter.starting-depth'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'routeeffic', title: translate('components.search.filter.route-efficiency'), transform: minMaxTransform('%') },
    { field: 'firststep', title: translate('components.search.filter.first-step'), transform: minMaxTransform(translate('components.search.abbr-seconds')) },
    { field: 'firststepeffic', title: translate('components.search.filter.first-step-eff'), transform: minMaxTransform('deg') },
    { field: 'topspeed', title: translate('components.search.filter.top-speed'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'sprintspeed', title: translate('components.search.filter.sprint-speed'), transform: minMaxTransform(translate('components.search.abbr-ft-s')) },
    { field: 'distcovered', title: translate('components.search.filter.distance-covered'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'topacceladj', title: translate('components.search.filter.top-acceleration'), transform: minMaxTransform('m/s<sup>2</sup>') },
    { field: 'catchprobability', title: translate('components.search.filter.catch-probability'), transform: minMaxTransform('%') },
    { field: 'outProbability', title: translate('components.search.filter.out-probability'), transform: minMaxTransform('%') },
    { field: 'hangtime', title: translate('components.search.filter.hang-time'), transform: minMaxTransform(translate('components.search.abbr-seconds')) },
    { field: 'inning', title: translate('baseball.inning'), transform: arrayTransform },
    { field: 'sourceLabels', title: translate('components.search.filter.video-angle'), transform: arrayTransform },
];
const SavedSearchFilterColumn = ({ row }) => {
    var _a;
    const { t: translate } = useTranslation();
    const filters = JSON.parse(row.Filters || '{}') || {};
    const entries = Object.entries(filters).filter(([key, value]) => !!searchFilters(translate).find((sf) => sf.field === key)
        && !isSelectAllValue(value)
        && (!Array.isArray(value) || !value.every((v) => isSelectAllValue(v))));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex flex-wrap" }, entries
            .map(([key, value], index) => {
            const field = searchFilters(translate).find((sf) => sf.field === key);
            if (!field)
                return null;
            return (React.createElement("div", { className: "d-flex flex-shrink-0", key: key },
                React.createElement("label", { className: "font-weight-bold mb-0" },
                    field.title,
                    ":"),
                "\u00A0",
                React.createElement("span", { dangerouslySetInnerHTML: { __html: field.transform(value) } }),
                index + 1 < entries.length && React.createElement("span", null, ",\u00A0")));
        })),
        ((_a = filters.pitchLocations) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(PitchLocation$1, { size: 30, locations: filters.pitchLocations, emptyColor: "#98CBFF" }))));
};

const SavedSearchCriteriaColumn = ({ row }) => {
    const { t: translate } = useTranslation();
    const searchCriteria = [
        { key: 'Batter.FullName', label: translate('baseball.batter') },
        { key: 'Pitcher.FullName', label: translate('baseball.pitcher_one') },
        { key: 'Catcher.FullName', label: translate('baseball.catcher_one') },
        { key: 'Fielder.FullName', label: translate('baseball.fielder') },
        { key: 'BattingTeam.FullName', label: translate('components.search.batting-team') },
        { key: 'PitchingTeam.FullName', label: translate('components.search.pitching-team') },
        { key: 'YearID', label: translate('common.year') },
        { key: 'Date', label: translate('common.date'), transform: ({ StartDate, EndDate }) => ((StartDate && EndDate) ? `${dateTranslate(translate, StartDate)} - ${dateTranslate(translate, EndDate)}` : null) },
        { key: 'LevelID', label: translate('baseball.level_one'), transform: ({ LevelID }) => { var _a; return (LevelID ? (_a = LEVELS.find((l) => l.id === LevelID)) === null || _a === void 0 ? void 0 : _a.abbr : null); } },
        { key: 'Bats', label: translate('components.search.filter.batter-hand'), transform: ({ Bats }) => (Bats !== null ? `${Bats === 1 ? translate('baseball.lhh') : translate('baseball.rhh')}` : null) },
        { key: 'Throws', label: translate('components.search.filter.pitcher-hand'), transform: ({ Throws }) => (Throws !== null ? `${Throws === 1 ? translate('baseball.lhp') : translate('baseball.rhp')}` : null) },
        { key: 'PitchType', label: translate('components.search.pitch-type'), transform: ({ PitchType }) => pitchType(PitchType, undefined, undefined, translate) },
        { key: 'FXPitchType', label: translate('components.search.fx-pitch-type'), transform: ({ FXPitchType }) => pitchType(FXPitchType, undefined, undefined, translate) },
        { key: 'FXSubType', label: translate('components.search.fx-sub-type'), transform: ({ FXSubType }) => pitchSubType(FXSubType, undefined, undefined, translate) },
        { key: 'Outs', label: translate('baseball.outs_other') },
        { key: 'Inning', label: translate('baseball.inning') },
        { key: 'LastXGames', label: `${translate('components.search.last')} X ${translate('components.search.games')}` },
        { key: 'LastXPas', label: `${translate('components.search.last')} X ${translate('components.search.abbr-plate-app')}` },
        { key: 'BaseEvent', label: translate('components.search.event'), transform: ({ BaseEvent }) => { var _a; return (BaseEvent ? (_a = BASE_EVENTS(translate).find((b) => b.id === BaseEvent)) === null || _a === void 0 ? void 0 : _a.name : null); } },
    ];
    const criteria = searchCriteria.map(({ key, label, transform }) => {
        const value = transform ? transform(row) : get$2(row, key);
        if (value === null || value === undefined)
            return null;
        if (key === 'YearID' && row.StartDate && row.EndDate)
            return null;
        return (React.createElement(React.Fragment, { key: key },
            React.createElement("label", { className: "font-weight-bold mb-0" },
                label,
                ":"),
            "\u00A0",
            value));
    }).filter((x) => x);
    return (React.createElement("div", { className: "d-flex flex-wrap" }, criteria.map((c, index) => React.createElement("div", { className: "d-flex flex-shrink-0", key: c === null || c === void 0 ? void 0 : c.key },
        c,
        index + 1 < criteria.length && React.createElement("span", null, ",\u00A0")))));
};

/* eslint-disable max-len */
const StyledCard$1 = styled(Card$2) `
    .field-column {
        width: 37.5%;
    }
`;
const SavedSearchTable = ({ rows, onEdit, onDelete, onVideoClick }) => {
    const { t: translate } = useTranslation();
    const columns = [
        { id: 'play', title: null, type: COLUMN_TYPES.NODE, transform: (row) => React.createElement(VideoButton, { onClick: () => onVideoClick(row) }) },
        { id: 'Name',
            title: translate('components.search.name'),
            type: COLUMN_TYPES.NODE,
            headerClass: 'w-25',
            transform: (row) => (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "font-weight-bold d-flex align-items-center" },
                    React.createElement("span", null, row.Name),
                    React.createElement(Button, { variant: "link", onClick: () => onEdit(row), className: "d-flex align-items-center ms-1" },
                        React.createElement(Icon, { icon: "nyy-pencil", size: "1em" }))),
                React.createElement("div", { className: "text-muted" },
                    translate('components.search.created'),
                    ": ",
                    dateTranslate(translate, row.CreatedDate)))) },
        { id: 'searchCriteria',
            title: translate('components.search.search-criteria'),
            type: COLUMN_TYPES.NODE,
            transform: (row) => React.createElement(SavedSearchCriteriaColumn, { row: row }),
            headerClass: 'field-column' },
        { id: 'filters', title: translate('components.search.filters'), type: COLUMN_TYPES.NODE, transform: (row) => React.createElement(SavedSearchFilterColumn, { row: row }), headerClass: 'field-column' },
        { id: 'delete',
            title: null,
            type: COLUMN_TYPES.NODE,
            transform: (row) => (React.createElement(Button, { onClick: () => onDelete(row) }, translate('common.delete'))) },
    ];
    return (React.createElement(StyledCard$1, { className: "p-4 mb-3" },
        React.createElement(DataTable, { sortable: false, columns: columns, rows: rows, hover: false })));
};

// Our hook
function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        // Set debouncedValue to value (passed in) after the specified delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        // Return a cleanup function that will be called every time ...
        // ... useEffect is re-called. useEffect will only be re-called ...
        // ... if value changes (see the inputs array below).
        // This is how we prevent debouncedValue from changing if value is ...
        // ... changed within the delay period. Timeout gets cleared and restarted.
        // To put it in context, if the user is typing within our app's ...
        // ... search box, we don't want the debouncedValue to update until ...
        // ... they've stopped typing for more than 500ms.
        return () => {
            clearTimeout(handler);
        };
    }, 
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [delay, value]);
    return debouncedValue;
}

const StyledInputContainer$1 = styled.div `&& {
    position: relative;
    display: flex;
    align-items: center;
    input {
        background: #ffffff url(${searchMagnifier}) no-repeat 5px;
        padding: .375rem 1.5rem;
        font-size: 14px;
    }
}`;
const StyledLoadingSpinner = styled.div `&& {
    position: absolute;
    right: 5px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${spinnerImg}) no-repeat center;
    background-color: white;
}`;
const StyledClearButton$2 = styled.div `&& {
    position: absolute;
    right: 5px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${searchReset}) no-repeat center;
}`;
const SearchInput = ({ onChange, onClear, searchCriteria = '', isLoading = false, id }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(StyledInputContainer$1, null,
        React.createElement(FormControl, { placeholder: `${translate('common.search')}...`, onChange: onChange, value: searchCriteria, id: id }),
        isLoading && React.createElement(StyledLoadingSpinner, null),
        !isLoading && searchCriteria.length > 0 && React.createElement(StyledClearButton$2, { onClick: onClear })));
};

var searchResultTypes;
(function (searchResultTypes) {
    searchResultTypes["PLAYER"] = "player";
    searchResultTypes["PLAYER_AM"] = "player_amateur";
    searchResultTypes["PLAYER_INT"] = "player_int";
    searchResultTypes["TEAM"] = "team";
    searchResultTypes["TEAM_AM"] = "team_amateur";
    searchResultTypes["COACH"] = "coach";
    searchResultTypes["UMPIRE"] = "umpire";
    searchResultTypes["AGENT"] = "agent";
    searchResultTypes["AGENCY"] = "agency";
    searchResultTypes["USER"] = "user";
    searchResultTypes["FACILITY"] = "facility";
    searchResultTypes["LEAGUE"] = "league";
    searchResultTypes["VENUE"] = "venue";
})(searchResultTypes || (searchResultTypes = {}));

const { PLAYER: PLAYER$1, PLAYER_AM: PLAYER_AM$1, PLAYER_INT: PLAYER_INT$1, TEAM: TEAM$1, TEAM_AM: TEAM_AM$1, COACH: COACH$1, UMPIRE: UMPIRE$1, AGENT: AGENT$1, AGENCY: AGENCY$1, USER: USER$1, FACILITY: FACILITY$1, LEAGUE: LEAGUE$1, VENUE } = searchResultTypes;
const StyledName = styled.span `&&{
    font-weight: bold;
    color: ${theme.background.astronaut};
    text-align: left;
}`;
const StyledListItem = styled(BootstrapButton) `&&{
    font-size: ${browser$1.mobile ? '18px' : '1em'};
    -webkit-text-size-adjust: 100%;
    display: flex;
    justify-content: space-between;
    text-decoration: none;
    color: ${theme.fontColors.doveGray};
    padding: 2px;
    width: 100%;
    &:hover, &:focus {
        cursor: pointer;
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
        text-decoration: none;
        outline: none;
        box-shadow: none;
        span {
            color: white !important;
        }
    }
    > span:first-child {
        flex-grow: 1;
        white-space: nowrap;
        margin-right: 5px;
    }
    > span:last-child {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: normal;
        color: #888;
    }
}`;
const SearchResultsItem = ({ item, type, suppressTypeNameInResults, onSelect }) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    let key = '';
    let name = '';
    const info = [];
    let href = '';
    switch (type) {
        case PLAYER$1: {
            key = `${PLAYER$1}-${item.PlayerID}`;
            href = `/bbops/player/index.rails?id=${item.PlayerID}`;
            name = `${item.UsesName} ${item.LastName}`;
            if (item.Organization)
                info.push(item.Organization.Abbr);
            if (item.Team)
                info.push(item.Team.FullName);
            if (!item.Active)
                info.push('inactive');
            if (item.Country && item.IsInternational)
                info.push(item.Country.Name);
            info.push(positionName(item.PrimaryPosition, translate));
            break;
        }
        case PLAYER_AM$1: {
            key = `player-am-${item.PlayerID}`;
            href = `/bbops/player/index.rails?id=${item.PlayerID}`;
            name = `${item.UsesName} ${item.LastName}`;
            if (item.School)
                info.push(item.School.SchoolName);
            else if (item.Team)
                info.push(item.Team.FullName);
            else if (item.College)
                info.push(item.College);
            else if (item.Organization)
                info.push(item.Organization.Abbr);
            if (!item.Active)
                info.push('inactive');
            else if (item.Class)
                info.push(hsClassName(item.Class, false, translate));
            info.push(positionName(item.PrimaryPosition, translate));
            break;
        }
        case PLAYER_INT$1: {
            key = `player-int-${item.PlayerID}`;
            href = `/bbops/player/index.rails?id=${item.PlayerID}`;
            name = `${item.UsesName} ${item.LastName}`;
            if (item.Country)
                info.push(item.Country.Name);
            info.push(positionName(item.PrimaryPosition, translate));
            break;
        }
        case TEAM$1: {
            key = `team-${item.TeamID}`;
            href = `/bbops/team/index.rails?id=${item.TeamID}`;
            name = item.FullName;
            if (item.Organization)
                info.push(item.Organization.Abbr);
            if (item.Level)
                info.push(item.Level.Abbr);
            break;
        }
        case TEAM_AM$1: {
            key = `team-am-${item.TeamID}`;
            href = `/bbops/team/index.rails?id=${item.TeamID}`;
            name = item.FullName;
            if (item.Level)
                info.push(item.Level.Abbr);
            break;
        }
        case COACH$1: {
            key = `coach-${item.CoachID}`;
            href = `/bbops/player/index.rails?id=${item.Player.PlayerID}`;
            name = `${item.Player.UsesName} ${item.Player.LastName}`;
            if (!item.EndDate) {
                if (item.Team) {
                    if (item.Team.Organization)
                        info.push(item.Team.Organization.Abbr);
                    info.push(`${item.Team.City} ${item.Team.Name}`);
                }
            }
            else
                info.push('inactive');
            info.push(item.Job);
            break;
        }
        case UMPIRE$1: {
            key = `umpire-${item.UmpireID}`;
            href = `/bbops/umpire/index.rails?id=${item.UmpireID}`;
            name = `${item.FirstName} ${item.LastName}`;
            info.push(`${translate('components.search.umpire')}`);
            break;
        }
        case AGENT$1: {
            key = `agent-${item.AgentID}`;
            href = `/bbops/agent/agent.rails?id=${item.AgentID}`;
            name = `${item.FirstName} ${item.LastName}`;
            info.push((_b = (_a = item.Agency) === null || _a === void 0 ? void 0 : _a.FirmName) !== null && _b !== void 0 ? _b : '--');
            break;
        }
        case AGENCY$1: {
            key = `agency-${item.AgencyID}`;
            href = `/bbops/agent/agency.rails?id=${item.AgencyID}`;
            name = item.FirmName;
            info.push(`${translate('components.search.agency')}`);
            break;
        }
        case USER$1: {
            key = `user-${item.UserName}`;
            href = `/bbops/personnel/index.rails?username=${item.UserName}`;
            name = item.FullName;
            info.push(item.Title);
            if (item.Department)
                info.push(item.Department.Name);
            break;
        }
        case FACILITY$1: {
            key = `facility-${item.FacilityId}`;
            href = `/bbops/facility/index.rails#/${item.FacilityId}`;
            name = item.FacilityName;
            if (item.FacilityType)
                info.push(item.FacilityType.Name);
            break;
        }
        case LEAGUE$1: {
            key = `league-${item.LeagueID}`;
            // href = `/bbops/facility/index.rails#/${item.FacilityId}`;
            name = item.Name;
            if (item.Level)
                info.push(item.Level.Name);
            break;
        }
        case VENUE: {
            key = `venue-${item.VenueID}`;
            name = item.Name;
            if (!suppressTypeNameInResults)
                info.push(`(${translate('components.search.venue')})`);
            if (item.Team)
                info.push(item.Team.FullName);
            if (item.City && item.State)
                info.push(item.City, item.State);
            break;
        }
    }
    return (
    // the css classes here are leveraged by keypress listeners in SearchResults, and by automation tests, modify them with great care
    React.createElement(StyledListItem, { className: "search-results--item", key: key, href: onSelect ? undefined : href, variant: "link", onClick: onSelect ? () => onSelect(item) : undefined },
        React.createElement(StyledName, null, name),
        React.createElement("span", null, info.join(', '))));
};

const StyledSearchResultsContainer = styled.div `
    margin-top: 1em;
    :first-child {
        margin-top: 4px;
    }
    h2 {
        color: ${theme.fontColors.doveGray};
        font-size: 1em;
        font-weight: bold;
        margin-bottom: 0;
        padding: 2px 0;
    }
`;
const StyledSearchResultsList = styled.div `
    padding: 0px 5px;
    max-height: 20vh;
    overflow-x: hidden;
    overflor-y: auto;
`;
const SearchResultsList = ({ items, type, label = '' }) => (
// the css classes here are leveraged by keypress listeners in SearchResults, and by automation tests, modify them with great care
React.createElement(StyledSearchResultsContainer, { className: `search-results-list search-results-list--${type}` },
    React.createElement("h2", null, label),
    React.createElement(StyledSearchResultsList, null,
        React.createElement("div", null, (items !== null && items !== void 0 ? items : []).map((item, index) => React.createElement(SearchResultsItem, { key: `${type}-${index}`, item: item, type: type }))))));

const { PLAYER, PLAYER_AM, PLAYER_INT, TEAM, TEAM_AM, COACH, UMPIRE, AGENT, AGENCY, USER, FACILITY, LEAGUE } = searchResultTypes;
const StyledModal = styled(BaseModal) `
    .modal-content {
        max-height: calc(100dvh - 100px);
        overflow-y: auto;
    }
`;
const StyledModalBody = styled(BaseModal.Body) `
    && {
        padding 0px;
    }
`;
const StyledResultsContainer = styled.div `
    display: flex;
    .search-list {
        width: 50%;
        padding: 10px;
        h1 {
            text-align: center;
            background-color: ${theme.background.astronaut};
            color: white;
            font-size: 1em;
            padding: 2px 0;
        }
    }
`;
const StyledModalFooter = styled(BaseModal.Footer) `
    && {
        background-color: #EDEDED;
        font-weight: bold;
        padding: 0;

        .form-check {
            margin: 0px 10px;
        }

        .form-check-input {
            margin-top: 0.2rem;
            margin-left: -1rem;
        }

        .form-check-label {
            margin-top: 3px;
            margin-left: 5px;
        }
    }
`;
const SearchResults = ({ show, onHide, onToggleInactive, searchResultsContainer, results, }) => {
    var _a, _b, _c, _d, _e;
    const { t: translate } = useTranslation();
    const [searchResults, setSearchResults] = useState(results);
    const [showInactive, setShowInactive] = useState(false);
    const [isListenerActive, setIsListenerActive] = useState(false);
    useEffect(() => {
        setSearchResults(results);
        return () => {
            setSearchResults(undefined);
        };
    }, [results, setSearchResults]);
    const resultBuckets = [
        {
            type: PLAYER,
            pro: true,
            results: (_a = searchResults === null || searchResults === void 0 ? void 0 : searchResults.players) === null || _a === void 0 ? void 0 : _a.filter((player) => !player.IsAmateur && !player.IsInternational),
            label: translate('components.search.players'),
        },
        {
            type: TEAM,
            pro: true,
            results: (_b = searchResults === null || searchResults === void 0 ? void 0 : searchResults.teams) === null || _b === void 0 ? void 0 : _b.filter((team) => !team.IsAmateur),
            label: translate('components.search.teams'),
        },
        {
            type: COACH,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.coaches,
            label: translate('components.search.coaches'),
        },
        {
            type: UMPIRE,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.umpires,
            label: translate('components.search.umpires'),
        },
        {
            type: AGENCY,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.agencies,
            label: translate('components.search.agencies'),
        },
        {
            type: AGENT,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.agents,
            label: translate('components.search.agents'),
        },
        {
            type: USER,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.users,
            label: translate('components.search.personnel'),
        },
        {
            type: FACILITY,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.facilities,
            label: translate('components.search.facilities'),
        },
        {
            type: LEAGUE,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.leagues,
            label: translate('components.search.leagues'),
        },
        {
            type: PLAYER_AM,
            pro: false,
            results: (_c = searchResults === null || searchResults === void 0 ? void 0 : searchResults.players) === null || _c === void 0 ? void 0 : _c.filter((player) => player.IsAmateur),
            label: translate('components.search.domestic'),
        },
        {
            type: PLAYER_INT,
            pro: false,
            results: (_d = searchResults === null || searchResults === void 0 ? void 0 : searchResults.players) === null || _d === void 0 ? void 0 : _d.filter((player) => player.IsInternational),
            label: translate('components.search.international'),
        },
        {
            type: TEAM_AM,
            pro: false,
            results: (_e = searchResults === null || searchResults === void 0 ? void 0 : searchResults.teams) === null || _e === void 0 ? void 0 : _e.filter((team) => team.IsAmateur),
            label: translate('components.search.teams'),
        },
    ].filter((b) => { var _a; return (_a = b.results) === null || _a === void 0 ? void 0 : _a.length; });
    const toggleInactive = (event) => {
        setShowInactive(event.currentTarget.checked);
        onToggleInactive(event);
    };
    useEffect(() => {
        setIsListenerActive(show !== null && show !== void 0 ? show : false);
    }, [show, setIsListenerActive]);
    const getActiveElementListType = (activeElem) => {
        var _a;
        const currentList = activeElem.closest('.search-results-list');
        const cssTypeName = [...((_a = currentList === null || currentList === void 0 ? void 0 : currentList.classList) !== null && _a !== void 0 ? _a : [])].find((c) => c.startsWith('search-results-list--'));
        return cssTypeName === null || cssTypeName === void 0 ? void 0 : cssTypeName.replace('search-results-list--', '');
    };
    const handleKeyDown = (event) => {
        var _a, _b, _c, _d;
        const activeElem = document.activeElement;
        switch (event.key) {
            case 'Tab': {
                // jump to the first result of the next list
                event.stopPropagation();
                event.preventDefault();
                if (!((_a = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _a === void 0 ? void 0 : _a.contains('search-results--item'))) {
                    // no item is focused, focus the first one we can find
                    document.getElementsByClassName('search-results--item')[0].focus();
                }
                else {
                    // item is currently focused, focus on the first result in the next available list
                    const currentList = activeElem.closest('.search-results-list');
                    const allLists = document.getElementsByClassName('search-results-list');
                    const currentIndex = Array.from(allLists).indexOf(currentList);
                    const targetIndex = currentIndex + 1;
                    if (allLists[targetIndex]) {
                        allLists[targetIndex].getElementsByClassName('search-results--item')[0].focus();
                    }
                    else {
                        allLists[0].getElementsByClassName('search-results--item')[0].focus();
                    }
                }
                break;
            }
            case 'ArrowRight': {
                // if focused on a pro list, jump to the first result of the first amateur list
                if (!((_b = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _b === void 0 ? void 0 : _b.contains('search-results--item')))
                    break;
                event.stopPropagation();
                event.preventDefault();
                const activeListType = getActiveElementListType(activeElem);
                const bucket = resultBuckets.find((b) => b.type === activeListType);
                if (bucket === null || bucket === void 0 ? void 0 : bucket.pro) {
                    const firstAmatBucket = resultBuckets.find((b) => !b.pro);
                    if (firstAmatBucket) {
                        document.getElementsByClassName(`search-results-list--${firstAmatBucket.type}`)[0]
                            .getElementsByClassName('search-results--item')[0].focus();
                    }
                }
                break;
            }
            case 'ArrowLeft': {
                // if focused on a pro list, jump to the first result of the first amateur list
                if (!((_c = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _c === void 0 ? void 0 : _c.contains('search-results--item')))
                    break;
                event.stopPropagation();
                event.preventDefault();
                const activeListType = getActiveElementListType(activeElem);
                const bucket = resultBuckets.find((b) => b.type === activeListType);
                if (!(bucket === null || bucket === void 0 ? void 0 : bucket.pro)) {
                    const firstProBucket = resultBuckets.find((b) => b.pro);
                    if (firstProBucket) {
                        document.getElementsByClassName(`search-results-list--${firstProBucket.type}`)[0]
                            .getElementsByClassName('search-results--item')[0].focus();
                    }
                }
                break;
            }
            case 'ArrowDown':
            case 'ArrowUp': {
                // go to the next/previous result item in the dom, if it exists
                event.stopPropagation();
                event.preventDefault();
                if (!((_d = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _d === void 0 ? void 0 : _d.contains('search-results--item'))) {
                    // no item is focused, focus the first one we can find
                    if (event.key === 'ArrowDown')
                        document.getElementsByClassName('search-results--item')[0].focus();
                    break;
                }
                const allItems = document.getElementsByClassName('search-results--item');
                const currentIndex = Array.from(allItems).indexOf(activeElem);
                const targetIndex = currentIndex + (event.key === 'ArrowDown' ? 1 : -1);
                if (allItems[targetIndex])
                    allItems[targetIndex].focus();
                break;
            }
        }
    };
    useEffect(() => {
        if (isListenerActive)
            document.addEventListener('keydown', handleKeyDown);
        else
            document.removeEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isListenerActive]);
    return resultBuckets.some((b) => { var _a; return (_a = b.results) === null || _a === void 0 ? void 0 : _a.length; }) ? (React.createElement(StyledModal, { size: "lg", show: show, onHide: onHide, animation: false, enforceFocus: false, container: searchResultsContainer },
        React.createElement(StyledModalBody, null,
            React.createElement(StyledResultsContainer, null,
                React.createElement("div", { className: "search-list search-list--pro" },
                    React.createElement("h1", { className: "my-0" }, translate('components.search.pro')),
                    React.createElement("div", null, resultBuckets.filter((b) => b.pro).map((b) => (React.createElement(SearchResultsList, { key: b.type, items: b.results, type: b.type, label: b.label }))))),
                React.createElement("div", { className: "search-list search-list--amateur" },
                    React.createElement("h1", { className: "my-0" }, translate('components.search.amateur')),
                    React.createElement("div", null, resultBuckets.filter((b) => !b.pro).map((b) => (React.createElement(SearchResultsList, { key: b.type, items: b.results, type: b.type, label: b.label }))))))),
        React.createElement(StyledModalFooter, null,
            React.createElement(Form.Check, { type: "checkbox", label: translate('components.search.include-inactive-players'), id: "search-toggle-inactive", 
                // onClick={onToggleInactive}
                checked: showInactive, onChange: toggleInactive })))) : (React.createElement(StyledModal, { size: "sm", show: show, onHide: onHide, animation: false, enforceFocus: false, container: searchResultsContainer, autoFocus: false },
        React.createElement(BaseModal.Body, null,
            React.createElement("div", null,
                translate('components.search.no-results-found'),
                "...")),
        React.createElement(StyledModalFooter, null,
            React.createElement(Form.Check, { type: "checkbox", label: translate('components.search.include-inactive-players'), id: "search-toggle-inactive", 
                // onClick={onToggleInactive}
                checked: showInactive, onChange: toggleInactive }))));
};

const Search = ({ search: searchFn, results, onHide, onClear, doCloseSearch, searchResultsContainer, isLoading = false }) => {
    const [searchCriteria, setSearchCriteria] = useState('');
    const [showInactive, setShowInactive] = useState(false);
    const resultsShow = !!results;
    const dbSearchCriteria = useDebounce(searchCriteria, 500);
    const shouldDoFetch = dbSearchCriteria.length >= 3;
    useEffect(() => {
        searchFn(dbSearchCriteria, { isactive: !showInactive }, shouldDoFetch);
    }, [searchFn, dbSearchCriteria, shouldDoFetch, showInactive]);
    useEffect(() => {
        var _a;
        if (results) {
            (_a = document.getElementById('searchInputField')) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultsShow]);
    useEffect(() => {
        if (doCloseSearch) {
            setSearchCriteria('');
            setShowInactive(false);
        }
    }, [doCloseSearch, setSearchCriteria]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchInput, { onChange: (event) => setSearchCriteria(event.target.value), onClear: () => { setSearchCriteria(''); onClear(); }, isLoading: isLoading, searchCriteria: searchCriteria, id: "searchInputField" }),
        React.createElement(SearchResults, { show: !!results, onHide: () => { setSearchCriteria(''); onClear(); if (onHide)
                onHide(); }, onToggleInactive: (event) => setShowInactive(event.target.checked), searchResultsContainer: searchResultsContainer, results: results })));
};

const StyledPopover = styled(Popover) `
    max-height: 160px;
    overflow-y: auto;
    .arrow {
        display: none !important;
    }
`;
const StyledSelectedValue = styled.div `
    font-size: 14px;
    background-color: ${theme.fontColors.dodgerBlue};
    color: white;
    padding: 4px;
    border-radius: 2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 48px);
`;
const StyledTypeSearch = styled.div `
    position: relative;
    ${StyledPopover} {
        width: 100%;
        max-width: unset;
    }
    ${StyledSelectedValue} {
        position: absolute;
        left: 25px;
        top: 5px;
    }
`;
const BaseSearchByType = ({ type, search: searchFn, results, onClear, onHide, onSelect, value, isLoading = false }) => {
    const [searchCriteria, setSearchCriteria] = useState('');
    const [searchResultsOverlayTarget, setTarget] = useState();
    const searchResultsOverlayRef = useRef(null);
    const dbSearchCriteria = useDebounce(searchCriteria, 500);
    useEffect(() => {
        const shouldDoFetch = !!dbSearchCriteria && dbSearchCriteria.length >= 3;
        if (!value && searchCriteria)
            searchFn(dbSearchCriteria, shouldDoFetch);
    }, [searchFn, searchCriteria, dbSearchCriteria, value]);
    useEffect(() => {
        if (!value) {
            setSearchCriteria('');
            if (onClear)
                onClear();
            if (onHide)
                onHide();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const onItemSelect = onSelect ? (item) => {
        onSelect(item);
        if (onHide)
            onHide();
    } : undefined;
    const onSearchInputChange = (e) => {
        setSearchCriteria(e.target.value);
        setTarget(e.target);
    };
    const onSearchInputClear = () => {
        setSearchCriteria('');
        if (onClear)
            onClear();
        if (onHide)
            onHide();
    };
    return (React.createElement(StyledTypeSearch, { ref: searchResultsOverlayRef, "$searchInputValue": value },
        React.createElement(SearchInput, { onChange: onSearchInputChange, onClear: onSearchInputClear, isLoading: isLoading, searchCriteria: value || searchCriteria }),
        !!value && React.createElement(StyledSelectedValue, null, value),
        React.createElement(Overlay, { show: results && !isLoading, target: searchResultsOverlayTarget, placement: "bottom-start", container: searchResultsOverlayRef.current, rootClose: true, onHide: onHide },
            React.createElement(StyledPopover, { id: "player-search" },
                React.createElement(StyledPopover.Body, null, !!results && results.map((item) => (React.createElement(SearchResultsItem, { key: item.key, item: item, type: type, suppressTypeNameInResults: true, onSelect: onItemSelect }))))))));
};

const PlayerSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const players = results === null || results === void 0 ? void 0 : results.players.map((p) => (Object.assign(Object.assign({}, p), { key: p.PlayerID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.PLAYER, results: players }, rest)));
};

const TeamSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const teams = results === null || results === void 0 ? void 0 : results.teams.map((p) => (Object.assign(Object.assign({}, p), { key: p.TeamID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.TEAM, results: teams }, rest)));
};

const LeagueSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const leagues = results === null || results === void 0 ? void 0 : results.leagues.map((p) => (Object.assign(Object.assign({}, p), { key: p.LeagueID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.LEAGUE, results: leagues }, rest)));
};

const VenueSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const venues = results === null || results === void 0 ? void 0 : results.venues.map((p) => (Object.assign(Object.assign({}, p), { key: p.VenueID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.VENUE, results: venues }, rest)));
};

const FilterGroupWrapper = styled.div `
    border-bottom: 1px solid ${theme.border.alto};
    flex-grow: 1;
    position: relative;
`;
const FilterGroupTitle = styled.h5 `
    color: ${theme.fontColors.darkBlue};
    margin-bottom: 0 !important;
    font-size: 13.75px !important;
`;
const StyledGroupButton = styled(Button) `
    padding: 7px 9px !important;
`;
const FilterGroupChildWrapper = styled.div `
    padding: 0 10px 40px;
`;
const AccordionFilterGroup = ({ title, filter, filterKeys, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const numAppliedFilters = Object.entries(filter)
        .filter(([key]) => { var _a; return (_a = filterKeys === null || filterKeys === void 0 ? void 0 : filterKeys.includes(key)) !== null && _a !== void 0 ? _a : true; })
        .filter(([, f]) => {
        const filterAsArray = Array.isArray(f) ? f : [f];
        return filterAsArray.some((x) => !isSelectAllValue(x));
    }).length;
    const completeTitle = `${title}${numAppliedFilters ? ` (${numAppliedFilters})` : ''}`;
    return (React.createElement(FilterGroupWrapper, null,
        React.createElement(StyledGroupButton, { variant: "link", className: "d-flex justify-content-between align-items-center text-primary w-100", onClick: () => setIsOpen(!isOpen) },
            React.createElement(FilterGroupTitle, null, completeTitle),
            React.createElement(Icon, { icon: `chevron-${isOpen ? 'up' : 'down'}`, size: "1.25em", color: theme.fontColors.dodgerBlue })),
        isOpen && (React.createElement(FilterGroupChildWrapper, null, children))));
};

/* eslint-disable no-nested-ternary */
const StyledAccoridonFilterSection = styled.div `
    padding: 12px 0 0;
    text-align: left;
    label {
        font-size: 11px;
        padding-right: 7px;
        text-align: right;
        color: ${(props) => (props.isInvalidRange ? '#dc3545'
    : props.isFiltered ? theme.fontColors.dodgerBlue : theme.fontColors.tundora)};
    }
    .filter-title {
        margin-bottom:2px;
        text-align: left;
        label {
            font-weight: bold;
            margin-bottom: 0;
            width: initial;
        }
    }
`;
const AccoridonFilterSection = ({ title, children, playlist, filter, requiredFields, className }) => {
    var _a, _b;
    const fields = Array.isArray(requiredFields) ? requiredFields : [requiredFields];
    const hasAnyDataWithFields = playlist.some(({ data }) => fields.every((f) => data[f] !== null && data[f] !== undefined));
    const isFiltered = Object.entries(filter)
        .filter(([key]) => { var _a; return (_a = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.includes(key)) !== null && _a !== void 0 ? _a : true; })
        .some(([, f]) => {
        const filterAsArray = Array.isArray(f) ? f : [f];
        return filterAsArray.some((x) => !isSelectAllValue(x));
    });
    const isInvalidRange = !Array.isArray(requiredFields) && ((_a = filter[requiredFields]) === null || _a === void 0 ? void 0 : _a.min) !== undefined && ((_b = filter[requiredFields]) === null || _b === void 0 ? void 0 : _b.max) !== undefined
        && +filter[requiredFields].min > +filter[requiredFields].max;
    return (React.createElement(React.Fragment, null, hasAnyDataWithFields && (React.createElement(StyledAccoridonFilterSection, { className: className, isFiltered: isFiltered, isInvalidRange: isInvalidRange },
        React.createElement("div", { className: "filter-title" },
            React.createElement("label", null, title)),
        children))));
};

const BasicFilters = ({ playlist, filter, onChange }) => {
    const { t: translate } = useTranslation();
    const pitchTypeOptions = PITCH_TYPES(translate)
        .filter((p) => p.sortorder > 0 && p.sortorder < 20)
        .sort((a, b) => a.sortorder - b.sortorder)
        .map((p) => ({ name: p.abbr, value: p.id }));
    const filterKeys = ['pitcherHand', 'batterHand', 'balls', 'strikes', 'outsbefore', 'bcbefore', 'hasRunners', 'type'];
    const lhpOptions = [{ name: translate('baseball.lhp'), value: 1 }, { name: translate('baseball.rhp'), value: 0 }];
    const lhbOptions = [{ name: translate('baseball.lhh'), value: 1 }, { name: translate('baseball.rhh'), value: 0 }];
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.basic-filters'), filter: filter, filterKeys: filterKeys },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pither-hand'), playlist: playlist, requiredFields: "pitcherHand", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "pitcherHand", onChange: onChange, options: lhpOptions, playlist: playlist, type: "radio" })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.batter-hand'), playlist: playlist, requiredFields: "batterHand", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "batterHand", onChange: onChange, options: lhbOptions, playlist: playlist, type: "radio" })),
        React.createElement(AccoridonFilterSection, { title: `${translate('baseball.count')} (${translate('baseball.balls_other')})`, playlist: playlist, requiredFields: "balls", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "balls", onChange: onChange, options: [0, 1, 2, 3], playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: `${translate('baseball.count')} (${translate('baseball.strikes_other')})`, playlist: playlist, requiredFields: "strikes", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikes", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('baseball.outs_other'), playlist: playlist, requiredFields: "outsbefore", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "outsbefore", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.baserunners'), playlist: playlist, requiredFields: ['bcbefore', 'hasRunners'], filter: filter },
            React.createElement(VideoFilterBaseRunners, { playlist: playlist, filter: filter, onChange: onChange, rows: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pitch-type'), playlist: playlist, requiredFields: "type", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "type", onChange: onChange, options: pitchTypeOptions, playlist: playlist, rows: 3, ignoreSort: true }))));
};

const KeyPadRow = ({ padKeys }) => (React.createElement(Row, { className: "border-top m-0" },
    React.createElement(Col, { className: "text-center p-0" },
        React.createElement(Button$1, { className: "py-3 w-100 h-100 text-dark h1 mb-0", variant: "link", onClick: padKeys[0].onClick }, padKeys[0].label)),
    React.createElement(Col, { className: "border-left border-right text-center p-0" },
        React.createElement(Button$1, { className: "py-3 w-100 h-100 text-dark h1 mb-0", variant: "link", onClick: padKeys[1].onClick }, padKeys[1].label)),
    React.createElement(Col, { className: "text-center p-0" },
        React.createElement(Button$1, { className: "py-3 w-100 h-100 text-dark h1 mb-0", variant: "link", onClick: padKeys[2].onClick }, padKeys[2].label))));
const KeyPadModal = forwardRef((_a, ref) => {
    var { unit, onDone, min, max, minimumFractionDigits } = _a, rest = __rest(_a, ["unit", "onDone", "min", "max", "minimumFractionDigits"]);
    const { t: translate } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState('');
    const [isNegative, setIsNegative] = useState(false);
    const [isFirstKeyPress, setIsFirstKeyPress] = useState(false);
    const numValue = Number(`${isNegative ? '-' : ''}${value}`);
    useImperativeHandle(ref, () => ({
        show: (v) => {
            setValue(Math.abs(v).toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: 10 }).replace(/,/g, ''));
            setShowModal(true);
            setIsNegative(v < 0);
            setIsFirstKeyPress(true);
        },
    }));
    const addDigit = (digit) => {
        const newNum = isFirstKeyPress ? digit : `${value}${digit}`;
        if (!isNaN(Number(newNum))) {
            if (isFirstKeyPress) {
                setIsFirstKeyPress(false);
                setIsNegative(false);
            }
            setValue(newNum);
        }
    };
    const handleDone = () => {
        onDone(numValue.toString());
        setShowModal(false);
    };
    const clear = () => {
        setIsNegative(false);
        setValue('');
    };
    const addDecimal = () => {
        if (!value || isFirstKeyPress) {
            setValue('0.');
            if (isFirstKeyPress) {
                setIsFirstKeyPress(false);
                setIsNegative(false);
            }
        }
        else {
            addDigit('.');
        }
    };
    const handleNegative = () => {
        if (isFirstKeyPress) {
            setIsFirstKeyPress(false);
            setValue('');
            setIsNegative(true);
        }
        else {
            setIsNegative(!isNegative);
        }
    };
    const keys = [
        [{ key: 1, label: '1', onClick: () => addDigit('1') }, { label: '2', onClick: () => addDigit('2') }, { label: '3', onClick: () => addDigit('3') }],
        [{ key: 2, label: '4', onClick: () => addDigit('4') }, { label: '5', onClick: () => addDigit('5') }, { label: '6', onClick: () => addDigit('6') }],
        [{ key: 3, label: '7', onClick: () => addDigit('7') }, { label: '8', onClick: () => addDigit('8') }, { label: '9', onClick: () => addDigit('9') }],
        [{ key: 4, label: '.', onClick: addDecimal }, { label: '0', onClick: () => addDigit('0') }, {
                label: React.createElement("div", { className: "text-dark" },
                    " ",
                    React.createElement(Icon, { icon: "nyy-plus-minus", size: "1em", color: "rgb(52, 58, 64)" }),
                    " "),
                onClick: handleNegative,
            }],
    ];
    const isNumAboveMin = isNaN(numValue) || !value || (min === undefined || Number(numValue) > min);
    const isNumUnderMax = isNaN(numValue) || !value || (max === undefined || Number(numValue) < max);
    const isNumValid = !isNaN(numValue) && !!value && isNumAboveMin && isNumUnderMax;
    return (React.createElement(BaseModal, Object.assign({ onHide: () => setShowModal(false), size: "sm", className: "h-100 d-flex align-items-center", show: showModal }, rest),
        React.createElement(Card$3, null,
            React.createElement("div", { className: "py-3" },
                !isNumAboveMin && React.createElement("div", { className: "text-danger d-flex justify-content-center" }, translate('components.video.filters.max-greater-min')),
                !isNumUnderMax && React.createElement("div", { className: "text-danger d-flex justify-content-center" }, translate('components.video.filters.min-less-than-max')),
                React.createElement("div", { className: `h1 mt-2 d-flex justify-content-center align-items-baseline ${value ? '' : 'text-black-50'}` },
                    isNegative ? '-' : '',
                    value || '00.0',
                    React.createElement("span", { className: "ms-1 text-muted h6", style: { fontSize: '0.5em' }, dangerouslySetInnerHTML: { __html: unit } }))),
            keys.map((k) => React.createElement(KeyPadRow, { padKeys: k, key: k[0].key })),
            React.createElement(Row, { className: "border-top m-0 py-3" },
                React.createElement(Col, null,
                    React.createElement(Button$1, { variant: "light", onClick: () => setShowModal(false) }, translate('common.cancel'))),
                React.createElement(Col, null,
                    React.createElement(Button$1, { variant: "secondary", onClick: clear }, translate('common.clear'))),
                React.createElement(Col, null,
                    React.createElement(Button$1, { variant: "primary", onClick: handleDone, disabled: !isNumValid }, translate('common.done')))))));
});

const KeyPadRange = ({ unit, filter, name, onChange, playlist, modalContainer, minimumFractionDigits = 0, useKeyPad = true }) => {
    var _a, _b;
    const [isMaxOpen, setIsMaxOpen] = useState(false);
    const [minLimit, setMinLimit] = useState(undefined);
    const [maxLimit, setMaxLimit] = useState(undefined);
    const modalRef = useRef(null);
    let min = 0;
    let max = 0;
    const pitchesWithData = playlist.filter(({ data }) => isNumber$2(data[name]));
    if (pitchesWithData.length) {
        min = Math.min(...pitchesWithData.map(({ data }) => data[name]));
        max = Math.max(...pitchesWithData.map(({ data }) => data[name]));
    }
    const defaultNum = (num, decimalPlaces = 0, roundingFunc) => {
        const roundedNum = roundingFunc(num * (Math.pow(10, decimalPlaces))) / (Math.pow(10, decimalPlaces));
        return roundedNum.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: minimumFractionDigits });
    };
    const parseString = (num) => parseFloat(num.replace(/,/g, ''));
    let minValue = filter[name] ? (_a = filter[name].min) === null || _a === void 0 ? void 0 : _a.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: 10 })
        : defaultNum(min, minimumFractionDigits, Math.floor);
    let maxValue = filter[name] ? (_b = filter[name].max) === null || _b === void 0 ? void 0 : _b.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: 10 })
        : defaultNum(max, minimumFractionDigits, Math.ceil);
    if (!useKeyPad) {
        minValue = minValue.replace(/,/g, '');
        maxValue = maxValue.replace(/,/g, '');
    }
    const openMin = () => {
        var _a;
        (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.show(parseString(minValue));
        setIsMaxOpen(false);
        setMaxLimit(parseString(maxValue));
        setMinLimit(undefined);
    };
    const openMax = () => {
        var _a;
        (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.show(parseString(maxValue));
        setIsMaxOpen(true);
        setMinLimit(parseString(minValue));
        setMaxLimit(undefined);
    };
    const onDone = (value) => {
        if (isMaxOpen) {
            onChange(parseFloat(value), `${name}.max`);
            onChange(parseString(minValue), `${name}.min`);
        }
        else {
            onChange(parseFloat(value), `${name}.min`);
            onChange(parseString(maxValue), `${name}.max`);
        }
    };
    const handleInput = (e, isMin) => {
        e.preventDefault();
        const { value } = e.currentTarget;
        if (value.split('').filter((c) => c === '.').length > 1
            || value.split('').some((s, i) => s === '-' && i)
            || value.split('').some((s) => !['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-'].includes(s))) {
            return;
        }
        if (isMin) {
            onChange(value, `${name}.min`);
            onChange(parseString(maxValue), `${name}.max`);
        }
        else {
            onChange(value, `${name}.max`);
            onChange(parseString(minValue), `${name}.min`);
        }
    };
    const isInvalid = parseString(minValue) >= parseString(maxValue);
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex align-items-center" },
            React.createElement(Form$1.Control, { type: "text", size: "sm", onClick: useKeyPad ? openMin : undefined, value: useKeyPad ? minValue === null || minValue === void 0 ? void 0 : minValue.toLocaleString(undefined, { minimumFractionDigits }) : minValue, onChange: (e) => handleInput(e, true), readOnly: useKeyPad, className: "bg-white", isInvalid: isInvalid }),
            React.createElement("span", { className: "mx-3" }, "to"),
            React.createElement(Form$1.Control, { type: "text", size: "sm", onClick: useKeyPad ? openMax : undefined, value: useKeyPad ? maxValue === null || maxValue === void 0 ? void 0 : maxValue.toLocaleString(undefined, { minimumFractionDigits }) : maxValue, onChange: (e) => handleInput(e, false), readOnly: useKeyPad, className: "bg-white", isInvalid: isInvalid }),
            React.createElement("span", { className: "ms-2", style: { minWidth: '27px' }, dangerouslySetInnerHTML: { __html: unit } })),
        React.createElement(KeyPadModal, { container: modalContainer, onDone: onDone, unit: unit, ref: modalRef, min: minLimit, max: maxLimit, minimumFractionDigits: minimumFractionDigits })));
};

const StyledAdvancedIconContainer$1 = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const filterKeys$3 = ['pitchLocations', 'velocity', 'spinrate', 'breakz54', 'breakx54', 'initposx_55',
    'initposz_55', 'rvactualNorm', 'rvexpNorm', 'rvpitchfxNorm', 'rvbreakNorm', 'rvstuffNorm', 'rvlocNorm'];
const PitchingFilters = ({ playlist, filter, onChange, modalContainer, useKeyPad }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.pitching-filters'), filter: filter, filterKeys: filterKeys$3 },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pitching-filters'), playlist: playlist, requiredFields: ['locationx', 'locationy'], filter: filter },
            React.createElement(StyledAdvancedIconContainer$1, null,
                React.createElement(VideoFilterPitchLocation, { playlist: playlist, locations: filter.pitchLocations, onChange: onChange }))),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pitch-velo'), playlist: playlist, requiredFields: "velocity", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, unit: translate('components.video.filters.abbr-miles-hour'), filter: filter, name: "velocity", onChange: onChange, playlist: playlist, modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.vertical-break'), playlist: playlist, requiredFields: "breakz54", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "breakz54", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-inches'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.horizontal-break'), playlist: playlist, requiredFields: "breakx54", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "breakx54", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-inches'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.horizontal-release'), playlist: playlist, requiredFields: "initposx_55", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "initposx_55", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.vertical-release'), playlist: playlist, requiredFields: "initposz_55", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "initposz_55", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.rv-era'), playlist: playlist, requiredFields: "rvactualNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvactualNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.expected-rv-era'), playlist: playlist, requiredFields: "rvexpNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvexpNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pfx-era'), playlist: playlist, requiredFields: "rvpitchfxNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvpitchfxNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.break-era'), playlist: playlist, requiredFields: "rvbreakNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvbreakNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.stuff-era'), playlist: playlist, requiredFields: "rvstuffNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvstuffNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.location-era'), playlist: playlist, requiredFields: "rvlocNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvlocNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 }))));
};

const StyledAdvancedIconContainer = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const StyledHitLocationContainer = styled(StyledAdvancedIconContainer) `
    position: relative;
    && {
        .btn-group {
            position: static;
            .btn {
                position: absolute;
                &:nth-of-type(1) { left: 0; } 
                &:nth-of-type(3) { left: 40px; } 
                &:nth-of-type(2) { left: 201px; } 
                &:nth-of-type(4) { left: 161px; } 
                &:nth-of-type(1), &:nth-of-type(2) { bottom: 55px; } 
                &:nth-of-type(3), &:nth-of-type(4) { bottom: 5px; }
            }
        }
    }
    &&&& {
        .btn-group .btn {
            margin: 0;
        }
    }
`;
const filterKeys$2 = ['hitLocations', 'hitvelocity', 'hittype', 'contactResult', 'contactQuality', 'vertla', 'horizla', 'zonedepth',
    'swinging', 'swingingFirstPitch', 'swingingInZone', 'chase', 'miss', 'missInZone', 'inZone', 'strikeout', 'unintentionalWalk',
    'swds', 'swingDecisionScoreShouldSwing', 'swingDecisionScoreShouldTake'];
const HittingFilters = ({ playlist, filter, onChange, modalContainer, useKeyPad }) => {
    const { t: translate } = useTranslation();
    const hitTypeOptions = [{ name: translate('baseball.pitchresult.abbr-groundball'), value: 0 }, { name: translate('baseball.pitchresult.abbr-flyball'), value: 1 }, { name: translate('baseball.pitchresult.abbr-popup'), value: 3 }, { name: translate('baseball.pitchresult.abbr-popup'), value: 2 }];
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.hitting-filters'), filter: filter, filterKeys: filterKeys$2 },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.hit-location'), playlist: playlist, requiredFields: ['hittype', 'isinfieldbip', 'distance', 'angleto2b', 'ishr'], filter: filter },
            React.createElement("div", null,
                React.createElement(StyledHitLocationContainer, null,
                    React.createElement(HitLocationSelect, { data: playlist.map((x) => x.data), value: filter.hitLocations, onChange: (value) => onChange(value, 'hitLocations'), emptyColor: theme.border.mercury }),
                    React.createElement(VideoFilterToggleButton, { filter: filter, name: "hittype", onChange: onChange, options: hitTypeOptions, playlist: playlist, includeAll: false })))),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.exit-velo'), playlist: playlist, requiredFields: "hitvelocity", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "hitvelocity", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-miles-hour'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.contact-result')} (${translate('components.video.filters.r100-bip')})`, playlist: playlist, requiredFields: "contactResult", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "contactResult", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.r100'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.contact-quality')} (${translate('components.video.filters.r100-bip')})`, playlist: playlist, requiredFields: "contactQuality", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "contactQuality", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.r100'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.vert-launch-angle'), playlist: playlist, requiredFields: "vertla", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "vertla", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-degrees'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.horizontal-launch-angle'), playlist: playlist, requiredFields: "horizla", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "horizla", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-degrees'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.zone-depth'), playlist: playlist, requiredFields: "zonedepth", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "zonedepth", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.swinging'), playlist: playlist, requiredFields: "swinging", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swinging", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.swinging-first-pitch'), playlist: playlist, requiredFields: "swingingFirstPitch", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingFirstPitch", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.swinging-in-zone'), playlist: playlist, requiredFields: "swingingInZone", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.chase'), playlist: playlist, requiredFields: "chase", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "chase", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.miss'), playlist: playlist, requiredFields: "miss", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "miss", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.miss-in-zone'), playlist: playlist, requiredFields: "missInZone", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "missInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.in-zone'), playlist: playlist, requiredFields: "inZone", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.strikeout'), playlist: playlist, requiredFields: "strikeout", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikeout", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.unintentional-walk'), playlist: playlist, requiredFields: "unintentionalWalk", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "unintentionalWalk", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.score'), playlist: playlist, requiredFields: "swds", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "swds", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-points'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-swing')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldSwing", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "swingDecisionScoreShouldSwing", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-points'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-take')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldTake", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "swingDecisionScoreShouldTake", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-points'), modalContainer: modalContainer }))));
};

const filterKeys$1 = ['fapproach', 'fmethod', 'fmove', 'fthrow', 'diffopps', 'diffmade', 'hasShift', 'runnersOn', 'throwvelo', 'exchange',
    'startingdepth', 'routeeffic', 'firststep', 'firststepeffic', 'topspeed', 'sprintspeed', 'distcovered', 'topacceladj',
    'catchprobability', 'outProbability', 'hangtime'];
const FieldingFilters = ({ playlist, filter, onChange, modalContainer, useKeyPad }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.fielding-filters'), filter: filter, filterKeys: filterKeys$1 },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielder-approach'), playlist: playlist, requiredFields: "fapproach", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fapproach", onChange: onChange, options: [translate('components.video.filters.stand'), translate('components.video.filters.sprint'), translate('components.video.filters.dive'), translate('components.video.filters.jog'), translate('components.video.filters.jump'), translate('components.video.filters.slide')], playlist: playlist, width: 50 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielding-method'), playlist: playlist, requiredFields: "fmethod", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmethod", onChange: onChange, options: [translate('components.video.filters.backhand'), translate('components.video.filters.barehand'), translate('components.video.filters.forehand'), translate('components.video.filters.no-touch'), translate('components.video.filters.over-shoulder')], playlist: playlist, width: 95, rows: 3 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielder-movement'), playlist: playlist, requiredFields: "fmove", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmove", onChange: onChange, options: [translate('components.video.filters.back'), translate('components.video.filters.forward'), translate('components.video.filters.right'), translate('components.video.filters.left'), translate('components.video.filters.no-move')], playlist: playlist, width: 85, rows: 3 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielder-throw'), playlist: playlist, requiredFields: "fthrow", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fthrow", onChange: onChange, options: [translate('components.video.filters.feet-planted'), translate('components.video.filters.on-move'), translate('components.video.filters.jump-throw'), translate('components.video.filters.from-ground'), translate('components.video.filters.glove-flip')], playlist: playlist, width: 120, rows: 5 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.difficulty-opps'), playlist: playlist, requiredFields: "diffopps", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffopps", onChange: onChange, options: [1, 4, 2, 5, 3], playlist: playlist, rows: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.difficulty-made'), playlist: playlist, requiredFields: "diffmade", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffmade", onChange: onChange, options: [1, 4, 2, 5, 3], playlist: playlist, rows: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.has-shift'), playlist: playlist, requiredFields: "hasShift", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "hasShift", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.runners-on'), playlist: playlist, requiredFields: "runnersOn", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "runnersOn", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.throw-velocity'), playlist: playlist, requiredFields: "throwvelo", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "throwvelo", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-miles-hour'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.exchange'), playlist: playlist, requiredFields: "exchange", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "exchange", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-seconds'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.starting-depth'), playlist: playlist, requiredFields: "startingdepth", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "startingdepth", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.route-efficiency'), playlist: playlist, requiredFields: "routeeffic", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "routeeffic", onChange: onChange, playlist: playlist, unit: "%", modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.first-step'), playlist: playlist, requiredFields: "firststep", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "firststep", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-seconds'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.first-step-efficiency'), playlist: playlist, requiredFields: "firststepeffic", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "firststepeffic", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-degrees'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.top-speed'), playlist: playlist, requiredFields: "topspeed", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "topspeed", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-miles-hour'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.sprint-speed'), playlist: playlist, requiredFields: "sprintspeed", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "sprintspeed", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet-seconds'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.distance-covered'), playlist: playlist, requiredFields: "distcovered", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "distcovered", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.top-acceleration'), playlist: playlist, requiredFields: "topacceladj", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "topacceladj", onChange: onChange, playlist: playlist, unit: `${translate('components.video.filters.abbr-meter-second')}<sup>2</sup>`, modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.catch-probability'), playlist: playlist, requiredFields: "catchprobability", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "catchprobability", onChange: onChange, playlist: playlist, unit: "%", modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.out-probability'), playlist: playlist, requiredFields: "outProbability", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "outProbability", onChange: onChange, playlist: playlist, unit: "%", modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.hang-time'), playlist: playlist, requiredFields: "hangtime", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "hangtime", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-seconds'), modalContainer: modalContainer, minimumFractionDigits: 1 }))));
};

const filterKeys = ['inning', 'sourceLabels'];
const OtherFilters = ({ playlist, filter, onChange }) => {
    const { t: translate } = useTranslation();
    const sourceLabelOptions = Array
        .from((new Set(playlist.map((v) => { var _a, _b; return (_b = (_a = v.data.sourceLabels) === null || _a === void 0 ? void 0 : _a.filter((l) => l)) !== null && _b !== void 0 ? _b : []; }).flat())))
        .sort((a, b) => a.localeCompare(b));
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.other-filters'), filter: filter, filterKeys: filterKeys },
        React.createElement(AccoridonFilterSection, { title: translate('baseball.inning'), playlist: playlist, requiredFields: "inning", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inning", onChange: onChange, options: [1, 2, 3, 4, 5, 6, 7, 8, 9, { name: '10+', value: 10 }], playlist: playlist, rows: 3, ignoreSort: true })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.video-angle'), playlist: playlist, requiredFields: "sourceLabels", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "sourceLabels", onChange: onChange, options: sourceLabelOptions, playlist: playlist, width: 200, rows: sourceLabelOptions.length, ignoreSort: true }))));
};

const SearchData = styled.div `
    padding: 7.5px 10px;
`;
const VideoSearchTitleWrapper = styled.div `
    position: relative;
`;
const VideoSearchWrapper = styled.div `
    border-bottom: 1px solid ${theme.border.alto};

    & label {
        margin: 0;
    }
`;
const TitleButton = styled(Button) `
    position: absolute;
    top: 2px;
    right: 1px;
`;
const FilterGroupActions = styled.div `
    width: 280px;
    position: fixed;
    bottom: 22px;
    left: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: -7.5px -10px 0;
    padding: 7.5px 10px;
    border-top: 1px solid ${theme.border.alto};
    background-color: white;
    z-index: 1;
`;
const SearchFormField = ({ title, value }) => (React.createElement("div", { className: "mb-1" },
    React.createElement("span", { className: "text-muted" }, title),
    ": ",
    React.createElement("span", { className: "font-weight-bold" }, value)));
const getDate = (searchForm) => {
    let date = searchForm.StartDate ? dayjs(searchForm.StartDate).format('MM/DD/YYYY') : '';
    date += searchForm.StartDate && searchForm.EndDate ? '-' : '';
    date += searchForm.EndDate ? dayjs(searchForm.EndDate).format('MM/DD/YYYY') : '';
    return date;
};
const AccordionFilters = forwardRef(({ yearId, onSubmit, onCreate, onUpdate, onDelete, onClear, playerSearch, teamSearch, form, levelId, initForm, saving, searching, hideSavedSearches, showClear, searchButtonTitle, playlist, filter: appliedFilter, onFilter, showFilters, showSearch, showCancel, modalContainer, title, goToSearch, useKeyPad, hideAmateurLevels }, ref) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    const [isEditingInitSearch, setIsEditingInitSearch] = useState(true);
    const [searchForm, setSearchForm] = useState(null);
    const [filter, setFilter] = useState(appliedFilter);
    const [showInvalidFilterModal, setShowInvalidFilterModal] = useState(false);
    const [invalidFilters, setInvalidFilters] = useState([]);
    useImperativeHandle(ref, () => ({
        setSearchForm: (sf) => {
            setSearchForm(sf);
        },
        setFilter: (f) => {
            setFilter(f);
        },
        setIsEditingInitSearch: (v) => {
            setIsEditingInitSearch(v);
        },
    }));
    const onSearch = (sf) => {
        setIsEditingInitSearch(false);
        setSearchForm(sf);
        setFilter({});
        onSubmit(sf);
    };
    const onChange = (value, name, isMultiselect) => setFilter((tempFilter) => {
        var _a;
        let newValue = value;
        if (isMultiselect) {
            // scenario 1: all options are deselected
            if (Array.isArray(newValue) && !newValue.length) {
                newValue = [-1];
            }
            else {
                const newDestinctOptions = newValue.filter((v) => !isSelectAllValue(v));
                if (newDestinctOptions.length) {
                    const numOldDistinctOptions = ((_a = tempFilter[name]) === null || _a === void 0 ? void 0 : _a.filter((v) => !isSelectAllValue(v)).length) || 0;
                    // scenario 2: Only "All" was checked and user selects an individual value to filter by
                    if (!numOldDistinctOptions)
                        newValue = newDestinctOptions;
                    // scenario 3: options were filtered, and user wants to go back to "All"
                    else if (numOldDistinctOptions && Array.isArray(newValue) && newValue.length > newDestinctOptions.length)
                        newValue = [-1];
                    // scenario 4: multiple non-"All" values are selected
                    // (do nothing)
                }
            }
        }
        return set(tempFilter, name, newValue);
    });
    const onClearAll = () => {
        setFilter({});
        onFilter(playlist, {});
    };
    const onCancel = () => {
        setIsEditingInitSearch(false);
        setSearchForm(Object.assign(Object.assign({}, searchForm), { Batter: searchForm === null || searchForm === void 0 ? void 0 : searchForm.Batter, Pitcher: searchForm === null || searchForm === void 0 ? void 0 : searchForm.Pitcher, Catcher: searchForm === null || searchForm === void 0 ? void 0 : searchForm.Catcher, BattingTeam: searchForm === null || searchForm === void 0 ? void 0 : searchForm.BattingTeam, PitchingTeam: searchForm === null || searchForm === void 0 ? void 0 : searchForm.PitchingTeam }));
    };
    const onEdit = () => {
        setIsEditingInitSearch(true);
        goToSearch();
    };
    const getFilterTitle = (filterKey) => ({
        velocity: translate('components.video.filters.pitch-velo'),
        spinrate: translate('components.video.filters.spin-rate'),
        breakz54: translate('components.video.filters.vertical-break'),
        breakx54: translate('components.video.filters.horizontal-break'),
        initposx_55: translate('components.video.filters.horizontal-release'),
        initposz_55: translate('components.video.filters.vertical-release'),
        rvactualNorm: translate('components.video.filters.rv-era'),
        rvexpNorm: translate('components.video.filters.expected-rv-era'),
        rvpitchfxNorm: translate('components.video.filters.pfx-era'),
        rvbreakNorm: translate('components.video.filters.break-era'),
        rvstuffNorm: translate('components.video.filters.stuff-era'),
        rvlocNorm: translate('components.video.filters.location-era'),
        hitvelocity: translate('components.video.filters.exit-velo'),
        contactResult: `${translate('components.video.filters.contact-result')} (${translate('components.video.filters.r100-bip')})`,
        contactQuality: `${translate('components.video.filters.contact-quality')} (${translate('components.video.filters.r100-bip')})`,
        vertla: translate('components.video.filters.vert-launch-angle'),
        horizla: translate('components.video.filters.horizontal-launch-angle'),
        zonedepth: translate('components.video.filters.zone-depth'),
        swds: translate('components.video.filters.score'),
        swingDecisionScoreShouldSwing: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-swing')})`,
        swingDecisionScoreShouldTake: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-take')})`,
        throwvelo: translate('components.video.filters.throw-velocity'),
        exchange: translate('components.video.filters.exchange'),
        startingdepth: translate('components.video.filters.starting-depth'),
        routeeffic: translate('components.video.filters.route-efficiency'),
        firststep: translate('components.video.filters.first-step'),
        firststepeffic: translate('components.video.filters.first-step-efficiency'),
        topspeed: translate('components.video.filters.top-speed'),
        sprintspeed: translate('components.video.filters.sprint-speed'),
        distcovered: translate('components.video.filters.distance-covered'),
        topacceladj: translate('components.video.filters.top-acceleration'),
        catchprobability: translate('components.video.filters.catch-probability'),
        outProbability: translate('components.video.filters.out-probability'),
        hangtime: translate('components.video.filters.hang-time'),
    }[filterKey]);
    const onApply = () => __awaiter(void 0, void 0, void 0, function* () {
        const badFilters = [];
        Object.entries(filter).forEach(([key, value]) => {
            if ((value === null || value === void 0 ? void 0 : value.min) !== undefined && (value === null || value === void 0 ? void 0 : value.max) !== undefined && +value.min >= +value.max) {
                const filterTitle = getFilterTitle(key);
                if (filterTitle) {
                    badFilters.push(filterTitle);
                }
            }
        });
        if (badFilters.length) {
            setInvalidFilters(badFilters);
            setShowInvalidFilterModal(true);
            return;
        }
        yield goToSearch();
        onFilter(playlist, filter);
    });
    return (React.createElement("div", { className: "flex-grow-1 position-relative d-inline-flex flex-column", ref: modalContainer },
        React.createElement("div", { className: "flex-grow-1 d-inline-flex flex-column" },
            React.createElement(VideoSearchTitleWrapper, null,
                title,
                showSearch && !isEditingInitSearch && (React.createElement(TitleButton, { variant: "link", className: "font-weight-bold", onClick: onEdit }, translate('common.edit')))),
            showSearch && (React.createElement(React.Fragment, null,
                React.createElement(VideoSearchWrapper, null,
                    React.createElement("div", { className: isEditingInitSearch ? '' : 'd-none' },
                        React.createElement(VideoSearchForm, { yearId: yearId, onSubmit: onSearch, onCreate: onCreate, onUpdate: onUpdate, onDelete: onDelete, onClear: onClear, playerSearch: playerSearch, teamSearch: teamSearch, form: searchForm || form, levelId: levelId, initForm: initForm, saving: saving, searching: searching, hideSavedSearches: hideSavedSearches, showClear: showClear, searchButtonTitle: searchButtonTitle, showCancel: showCancel, onCancel: onCancel, hideAmateurLevels: hideAmateurLevels })),
                    React.createElement(SearchData, { className: isEditingInitSearch ? 'd-none' : '' },
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.YearID) && React.createElement(SearchFormField, { title: translate('common.year'), value: searchForm.YearID }),
                        ((searchForm === null || searchForm === void 0 ? void 0 : searchForm.StartDate) || (searchForm === null || searchForm === void 0 ? void 0 : searchForm.EndDate)) && React.createElement(SearchFormField, { title: translate('common.date'), value: getDate(searchForm) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.LevelID) && React.createElement(SearchFormField, { title: translate('baseball.level_one'), value: (_a = LEVELS.find((l) => l.id === searchForm.LevelID)) === null || _a === void 0 ? void 0 : _a.abbr }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.PitchType) && React.createElement(SearchFormField, { title: translate('components.video.filters.pitch-type'), value: pitchType(searchForm.PitchType, undefined, undefined, translate) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.FXPitchType) && React.createElement(SearchFormField, { title: translate('components.video.filters.fx-pitch-type'), value: pitchType(searchForm.FXPitchType, undefined, undefined, translate) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.FXSubType) && React.createElement(SearchFormField, { title: translate('components.video.filters.fx-sub-type'), value: pitchSubType(searchForm.FXSubType, undefined, undefined, translate) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.BattingTeam) && React.createElement(SearchFormField, { title: translate('components.video.filters.batting-team'), value: searchForm.BattingTeam.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.PitchingTeam) && React.createElement(SearchFormField, { title: translate('components.video.filters.pitching-team'), value: searchForm.PitchingTeam.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.BaseEvent)
                            && React.createElement(SearchFormField, { title: translate('components.video.filters.base-event'), value: (_b = BASE_EVENTS(translate).find((b) => b.id === (searchForm === null || searchForm === void 0 ? void 0 : searchForm.BaseEvent))) === null || _b === void 0 ? void 0 : _b.name }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Outs) !== undefined && (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Outs) != null && React.createElement(SearchFormField, { title: translate('baseball.outs_other'), value: searchForm.Outs }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Inning) && React.createElement(SearchFormField, { title: translate('baseball.inning'), value: searchForm.Inning }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Batter) && React.createElement(SearchFormField, { title: translate('baseball.batter'), value: searchForm.Batter.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Pitcher) && React.createElement(SearchFormField, { title: translate('baseball.pitcher_one'), value: searchForm.Pitcher.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Catcher) && React.createElement(SearchFormField, { title: translate('baseball.catcher_one'), value: searchForm.Catcher.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Fielder) && React.createElement(SearchFormField, { title: translate('baseball.fielder'), value: searchForm.Fielder.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Bats) !== undefined && (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Bats) != null
                            && React.createElement(SearchFormField, { title: translate('baseball.bats'), value: searchForm.Bats === 1 ? translate('baseball.left') : translate('baseball.right') }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Throws) !== undefined && (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Throws) != null
                            && React.createElement(SearchFormField, { title: translate('baseball.throws'), value: searchForm.Throws === 1 ? translate('baseball.left') : translate('baseball.right') }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.LastXGames) && React.createElement(SearchFormField, { title: translate('components.video.filters.last-x-games'), value: searchForm.LastXGames }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.LastXPas) && React.createElement(SearchFormField, { title: translate('components.video.filters.last-x-pa'), value: searchForm.LastXPas }))),
                showFilters && !isEditingInitSearch && (React.createElement("div", { className: "flex-grow-1", style: { paddingBottom: '40px' } },
                    React.createElement(BasicFilters, { filter: filter, playlist: playlist, onChange: onChange }),
                    React.createElement(PitchingFilters, { filter: filter, playlist: playlist, onChange: onChange, modalContainer: modalContainer, useKeyPad: useKeyPad }),
                    React.createElement(HittingFilters, { filter: filter, playlist: playlist, onChange: onChange, modalContainer: modalContainer, useKeyPad: useKeyPad }),
                    React.createElement(FieldingFilters, { filter: filter, playlist: playlist, onChange: onChange, modalContainer: modalContainer, useKeyPad: useKeyPad }),
                    React.createElement(OtherFilters, { filter: filter, playlist: playlist, onChange: onChange }),
                    React.createElement(FilterGroupActions, null,
                        React.createElement(Button, { onClick: onClearAll }, translate('common.clear')),
                        React.createElement(Button, { variant: "primary", onClick: onApply }, translate('common.apply')))))))),
        React.createElement(BaseModal, { show: showInvalidFilterModal, onHide: () => setShowInvalidFilterModal(false), container: modalContainer },
            React.createElement(BaseModal.Body, null,
                translate('components.video.filters.filters-invalid'),
                ":",
                React.createElement("ul", null, invalidFilters.map((i) => React.createElement("li", { key: i }, i)))))));
});

const hitterTimingBucket = (timing) => {
    if (timing === null)
        return null;
    if (timing < -6)
        return TIMING_LATE;
    if (timing > 6)
        return TIMING_EARLY;
    return TIMING_ONTIME;
};
var getCleanPitches = (pitches) => {
    let cleanPitches = [];
    if (pitches) {
        cleanPitches = pitches.filter((p) => p.locationx && p.locationy && p.exppit_all === 1).map((p) => (Object.assign(Object.assign({}, p), { id: `${p.gameid}_${p.eventseq}_${p.pitchseq}`, timingbucket: hitterTimingBucket(p.timing) })));
    }
    const cleanPitchMap = {};
    for (let i = 0; i < 5; i++) {
        for (let j = 0; j < 5; j++) {
            cleanPitchMap[`${i + 1}.${j + 1}`] = [];
        }
    }
    cleanPitches.forEach((p) => {
        cleanPitchMap[`${p.locationx}.${p.locationy}`].push(p);
    });
    return { cleanPitches, cleanPitchMap };
};

const isNumber = (val) => val !== '' && val !== '-' && !!val && !isNaN(val);
const isGreaterThanOrEqualTo = (num, filterVal) => {
    if (!isNumber(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber(num) || num === undefined || num === null) {
        return false;
    }
    return num >= filterVal;
};
const isLessThanOrEqualTo = (num, filterVal) => {
    if (!isNumber(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber(num) || num === undefined || num === null) {
        return false;
    }
    return num <= filterVal;
};
var filterPitches = (cleanPitchMap, liveFilter) => {
    const locationPitches = liveFilter.pitchLocation.length
        ? Object.entries(cleanPitchMap)
            .filter(([key]) => liveFilter.pitchLocation.map((pl) => `${pl.locationx}.${pl.locationy}`).includes(key))
            .reduce((all, [, val]) => all.concat(val), [])
        : Object.values(cleanPitchMap).reduce((all, locPitches) => all.concat(locPitches), []);
    return locationPitches.filter((p) => (liveFilter.baseState === ALL_VALUE$1
        || (liveFilter.baseState === 0 && p.bcbefore === 0)
        || (liveFilter.baseState === 1 && p.bcbefore > 1)
        || (liveFilter.baseState === 2 && p.bcbefore > 0))
        && (liveFilter.counts.includes(ALL_VALUE$1)
            || (liveFilter.counts.includes(ALL_ATTACK_VALUE$1) && p.strikes < 2)
            || (liveFilter.counts.includes(ALL_2K_VALUE$1) && p.strikes === 2)
            || liveFilter.counts.some((c) => p.balls === c % 4 && p.strikes === Math.floor(c / 4)))
        && (liveFilter.result.includes(ALL_VALUE$1) || liveFilter.result.includes(p.hitmonresulttype))
        // eslint-disable-next-line max-len
        && ((liveFilter.pitchTypes.includes(ALL_VALUE$1)
            || (liveFilter.pitchTypes.includes(ALL_FB_VALUE) && [9, 10].includes(p.pitchtype))
            || (liveFilter.pitchTypes.includes(ALL_NON_FB_VALUE) && ![9, 10].includes(p.pitchtype))
            || liveFilter.pitchTypes.includes(p.fxsubtype != null && p.fxsubtype > 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype)
            // eslint-disable-next-line max-len
            || (!(p.pitchtype === 3 && (p.fxsubtype === 34 || p.fxsubtype === 33)) && liveFilter.pitchTypes.filter((x) => x < 1000 && p.fxsubtype != null && p.pitchtype === x).length > 0)))
        && (liveFilter.timing.includes(ALL_VALUE$1)
            || (p.timingbucket !== null && liveFilter.timing.includes(p.timingbucket)))
        && (liveFilter.batterHand === ALL_VALUE$1 || ((liveFilter.batterHand === 2) === p.islhb))
        && (liveFilter.zoneLocation === ALL_VALUE$1 || (p.inz === liveFilter.zoneLocation && !!p.exppit_all))
        && isGreaterThanOrEqualTo(p.velocity, liveFilter.minVelo) && isLessThanOrEqualTo(p.velocity, liveFilter.maxVelo)
        && isGreaterThanOrEqualTo(p.launchangle, liveFilter.minLa) && isLessThanOrEqualTo(p.launchangle, liveFilter.maxLa)
        && isGreaterThanOrEqualTo(p.exitvelo, liveFilter.minEv) && isLessThanOrEqualTo(p.exitvelo, liveFilter.maxEv)
        && isGreaterThanOrEqualTo(p.horizla, liveFilter.minHorizLa) && isLessThanOrEqualTo(p.horizla, liveFilter.maxHorizLa)
        && isGreaterThanOrEqualTo(p.breakx, liveFilter.minBreakX) && isLessThanOrEqualTo(p.breakx, liveFilter.maxBreakX)
        && isGreaterThanOrEqualTo(p.breakz, liveFilter.minBreakZ) && isLessThanOrEqualTo(p.breakz, liveFilter.maxBreakZ)
        && isGreaterThanOrEqualTo(p.initposx, liveFilter.minRelX) && isLessThanOrEqualTo(p.initposx, liveFilter.maxRelX)
        && isGreaterThanOrEqualTo(p.initposz, liveFilter.minRelZ) && isLessThanOrEqualTo(p.initposz, liveFilter.maxRelZ)
        && isGreaterThanOrEqualTo(p.extension, liveFilter.minExt) && isLessThanOrEqualTo(p.extension, liveFilter.maxExt)
        && isGreaterThanOrEqualTo(p.armangle, liveFilter.minArmAngle) && isLessThanOrEqualTo(p.armangle, liveFilter.maxArmAngle)
        && isGreaterThanOrEqualTo(p.gyrodegree, liveFilter.minGyroDegree) && isLessThanOrEqualTo(p.gyrodegree, liveFilter.maxGyroDegree)
        && isLessThanOrEqualTo(p.lastxpa, liveFilter.lastPAs)
        && (liveFilter.park === ALL_VALUE$1 || (liveFilter.park === HOME_VALUE && p.ishome) || (liveFilter.park === AWAY_VALUE && !p.ishome)
            || liveFilter.park === p.venueid));
};

const getResultTooltip = (title, p, translate, showBatTracking = false, showTiming = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.batter_lastname && p.batter_usesname ? `${translate('baseball.batter')}:\
        ${p.batter_usesname} ${p.batter_lastname} (${p.islhb ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
    ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.pitchtype ? `${translate('components.hitmon.pitch-type')}: ${pitchTypeDisplayName(p, false, false, translate)}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.gyrodegree ? `${translate('components.pitcher-trends.gyrodegree')}: ${format(p.gyrodegree)}<br />` : ''}\
    ${p.spindirectionclock ? `${translate('sections.reports.pitcher.spin-dir')}: ${p.spindirectionclock}<br />` : ''}\
    ${translate('baseball.break-x')}: ${format(p.breakx, 1)}<br />\
    ${translate('baseball.break-z')}: ${format(p.breakz, 1)}<br />\
    ${p.rvstuff ? `${translate('sections.reports.pitcher.stuff-era')}: ${format(rvERA(p.rvstuff), 2)}<br />` : ''}\
    ${p.rvpitchfx ? `${translate('sections.reports.pitcher.pfx-era')}: ${format(rvERA(p.rvpitchfx), 2)}<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip ? `${translate('components.hitmon.abbr-exit-velo')}:
        ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_b = (_a = p.heading) === null || _a === void 0 ? void 0 : _a.toFixed(1)) !== null && _b !== void 0 ? _b : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_d = (_c = p.vbat) === null || _c === void 0 ? void 0 : _c.toFixed(1)) !== null && _d !== void 0 ? _d : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_f = (_e = p.hbat) === null || _e === void 0 ? void 0 : _e.toFixed(1)) !== null && _f !== void 0 ? _f : '-'}<br />`
        : ''}\
    ${showTiming
        ? `${translate('components.hitmon.relative-zonedepth')}: ${(_g = translate('format.abbr-inches', { value: format(p.timingrz, 1) })) !== null && _g !== void 0 ? _g : '-'}<br />\
            ${translate('components.hitmon.timing-rv')}: ${(_j = (_h = p.ervadj) === null || _h === void 0 ? void 0 : _h.toFixed(3)) !== null && _j !== void 0 ? _j : '-'}<br />\
            ${translate('components.hitmon.timing.timing')}: ${(_k = translate('format.abbr-inches', { value: format(p.timing, 1) })) !== null && _k !== void 0 ? _k : '-'}<br />`
        : ''}\
`;
};
const getPitchTypeTooltip = (title, p, translate, showBatTracking = false, showTiming = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.batter_lastname && p.batter_usesname ? `${translate('baseball.batter')}:\
        ${p.batter_usesname} ${p.batter_lastname} (${p.islhb ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
    ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.hitmonresulttype ? `${translate('sections.reports.pitcher.result')}:\
        ${(_a = RESULT_TYPES(translate).find((rt) => rt.id === p.hitmonresulttype)) === null || _a === void 0 ? void 0 : _a.name}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.gyrodegree ? `${translate('components.pitcher-trends.gyrodegree')}: ${format(p.gyrodegree)}<br />` : ''}\
    ${p.spindirectionclock ? `${translate('sections.reports.pitcher.spin-dir')}: ${p.spindirectionclock}<br />` : ''}\
    ${translate('baseball.break-x')}: ${format(p.breakx, 1)}<br />\
    ${translate('baseball.break-z')}: ${format(p.breakz, 1)}<br />\
    ${p.rvstuff ? `${translate('sections.reports.pitcher.stuff-era')}: ${format(rvERA(p.rvstuff), 2)}<br />` : ''}\
    ${p.rvpitchfx ? `${translate('sections.reports.pitcher.pfx-era')}: ${format(rvERA(p.rvpitchfx), 2)}<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip ? `${translate('components.hitmon.abbr-exit-velo')}:
        ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_c = (_b = p.heading) === null || _b === void 0 ? void 0 : _b.toFixed(1)) !== null && _c !== void 0 ? _c : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_e = (_d = p.vbat) === null || _d === void 0 ? void 0 : _d.toFixed(1)) !== null && _e !== void 0 ? _e : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_g = (_f = p.hbat) === null || _f === void 0 ? void 0 : _f.toFixed(1)) !== null && _g !== void 0 ? _g : '-'}<br />`
        : ''}\
    ${showTiming
        ? `${translate('components.hitmon.relative-zonedepth')}: ${(_h = translate('format.abbr-inches', { value: format(p.timingrz, 1) })) !== null && _h !== void 0 ? _h : '-'}<br />\
            ${translate('components.hitmon.timing-rv')}: ${(_k = (_j = p.ervadj) === null || _j === void 0 ? void 0 : _j.toFixed(3)) !== null && _k !== void 0 ? _k : '-'}<br />\
            ${translate('components.hitmon.timing.timing')}: ${(_l = translate('format.abbr-inches', { value: format(p.timing, 1) })) !== null && _l !== void 0 ? _l : '-'}<br />`
        : ''}\
`;
};

const buildSeries$4 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez, id: `strike_zone_${d.id}` }))) })));
const buildTimingSeries$5 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `strike_zone_${d.id}`, visible: !!(d.timingcolor) }))) })));
const StrikeZone = forwardRef(({ batterHand, showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, pitches, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildSeries$4(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$4(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$5(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip(series.name, pitch, translate, false, false)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip(series.name, pitch, translate, false, true)
                : getPitchTypeTooltip(series.name, pitch, translate, false, false));
    };
    return (React.createElement(StrikeZone$3, { seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, pitcherView: true, showlhb: batterHand === 2, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, hideAxis: true, hideGrid: true, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref }));
});

const buildSeries$3 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch), id: `spray_chart_${d.id}` }))) })));
const buildTimingSeries$4 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy }), (d.timingcolor ? { color: d.timingcolor } : {})), { visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch && d.timingcolor), id: `spray_chart_${d.id}` }))) })));
const SprayChart = forwardRef(({ showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, pitches, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildSeries$3(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$3(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$4(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip(series.name, pitch, translate, false, false)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip(series.name, pitch, translate, false, true)
                : getPitchTypeTooltip(series.name, pitch, translate, false, false));
    };
    return (React.createElement(SprayChart$3, { type: "outfield", seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, enableZoom: true, ref: ref }));
});

const buildResultSeries$4 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: (d.platex * 12), y: d.timingrz, id: `hitter_timing_${d.id}`, visible: !!(d.timingrz) }))) })));
const buildPitchTypesSeries$1 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: (d.platex * 12), y: d.timingrz, id: `hitter_timing_${d.id}`, visible: !!(d.timingrz) }))) })));
const buildTimingSeries$3 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: (d.platex * 12), y: d.timingrz }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `hitter_timing_${d.id}`, visible: !!(d.timingcolor && d.timingrz) }))) })));
const HitterTiming = forwardRef(({ size, showing, isLhb, pitches, resultSeries, pitchTypeSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, tooltipFormatter, sizeMultiplier = 1, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$4(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$1(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$3(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip(series.name, pitch, translate, false, false)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip(series.name, pitch, translate, false, false)
                : getPitchTypeTooltip(series.name, pitch, translate, false, false));
    };
    return (React.createElement(HitterTiming$2, { size: size, seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, isLhb: isLhb, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, hideAxis: true, hideGrid: true, ref: ref, sizeMultiplier: sizeMultiplier }));
});

const buildSeries$2 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.breakx, y: d.breakz, id: `break_chart_${d.id}` }))) })));
const buildTimingSeries$2 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.breakx, y: d.breakz }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `break_chart_${d.id}`, visible: !!(d.timingcolor) }))) })));
const BreakChart = forwardRef(({ pitches, showing, resultSeries, pitchTypeSeries, tooltipFormatter, minMaxCoordinate, pitchVideoFn, multiVideoFn, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildSeries$2(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$2(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$2(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip(series.name, pitch, translate, false, false)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip(series.name, pitch, translate, false, true)
                : getPitchTypeTooltip(series.name, pitch, translate, false, false));
    };
    return (React.createElement(PitchBreakPlotChart, { pitches: [], seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, height: 420, width: 420, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, minMaxCoordinate: minMaxCoordinate, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref }));
});

const buildSeries$1 = (series, orderedPitchTypes) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.heading, y: orderedPitchTypes.findIndex((p) => p === (d.fxsubtype || d.pitchtype)), id: `heading_chart_${d.id}` }))) })));
const buildTimingSeries$1 = (series, orderedPitchTypes) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.heading, y: orderedPitchTypes.findIndex((p) => p === (d.fxsubtype || d.pitchtype)) }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `heading_chart_${d.id}`, visible: !!(d.timingcolor) }))) })));
const pitchOrders = [10, 9, 8, 33, 3, 34, 4, 7, 2];
const getPitchOrderValue = (pt) => {
    const index = pitchOrders.indexOf(pt);
    return index > -1 ? index : 100 + pt;
};
const HeadingChart = forwardRef(({ pitches, showing, resultSeries, pitchTypeSeries, tooltipFormatter, availablePitchTypes, pitchVideoFn, multiVideoFn, sizeMultiplier = 1, }, ref) => {
    const { t: translate } = useTranslation();
    const orderedPitchTypes = useMemo(() => [...availablePitchTypes].sort((a, b) => getPitchOrderValue(+b) - getPitchOrderValue(+a)), [availablePitchTypes]);
    const innerResultSeries = useMemo(() => buildSeries$1(resultSeries, orderedPitchTypes), [resultSeries, orderedPitchTypes]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$1(pitchTypeSeries, orderedPitchTypes), [pitchTypeSeries, orderedPitchTypes]);
    const innerTimingSeries = useMemo(() => buildTimingSeries$1(resultSeries, orderedPitchTypes), [resultSeries, orderedPitchTypes]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip(series.name, pitch, translate, true, false)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip(series.name, pitch, translate, false, true)
                : getPitchTypeTooltip(series.name, pitch, translate, true, false));
    };
    return (React.createElement("div", { className: "flex-shrink-0 d-flex align-items-center" },
        React.createElement(HeadingChart$2, { seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, orderedPitchTypes: orderedPitchTypes, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref, sizeMultiplier: sizeMultiplier })));
});

const buildSeries = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.hbat, y: d.vbat, id: `bat_impact_chart_${d.id}` }))) })));
const buildTimingSeries = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign(Object.assign(Object.assign({}, d), { x: d.hbat, y: d.vbat }), (d.timingcolor ? { color: d.timingcolor } : {})), { id: `bat_impact_chart_${d.id}`, visible: !!(d.timingcolor) }))) })));
const BatImpactChart = forwardRef(({ pitches, batterHand, showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, sizeMultiplier = 1, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildSeries(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries(pitchTypeSeries), [pitchTypeSeries]);
    const innerTimingSeries = useMemo(() => buildTimingSeries(resultSeries), [resultSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        // eslint-disable-next-line no-nested-ternary
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip(series.name, pitch, translate, true, false)
            : showing === SHOWING_TIMING_VALUE ? getResultTooltip(series.name, pitch, translate, false, true)
                : getPitchTypeTooltip(series.name, pitch, translate, true, false));
    };
    return (React.createElement(BatImpactChart$2, { className: "flex-shrink-0", isLhb: batterHand === 2, seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : showing === SHOWING_TIMING_VALUE ? innerTimingSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref, sizeMultiplier: sizeMultiplier }));
});

/* eslint-disable react/no-this-in-sfc */
const buildResultsSeries = (translate, pitches, mouseOver, mouseOut, includeColor) => {
    const resultSeries = [
        {
            hitmonResultType: 1,
            color: includeColor ? '#0000ff' : '',
            marker: {
                symbol: 'diamond',
                radius: 4,
                lineColor: includeColor ? '#0000ff' : '',
                fillColor: '#ffffff',
                lineWidth: 2,
                states: { hover: { radiusPlus: 10, lineColor: includeColor ? '#0000ff' : '' } },
            },
            data: [],
        },
        {
            hitmonResultType: 2,
            color: includeColor ? '#0000ff' : '',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 3,
            color: includeColor ? '#00ff00' : '',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 4,
            color: includeColor ? '#ff0000' : '',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 5,
            color: includeColor ? '#ff0000' : '',
            marker: { symbol: 'diamond', radius: 6, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 6,
            color: includeColor ? '#ff0000' : '',
            marker: {
                symbol: 'square',
                radius: 4,
                lineColor: includeColor ? '#ff0000' : '',
                fillColor: '#ffffff',
                lineWidth: 2,
                states: { hover: { radiusPlus: 10, lineColor: includeColor ? '#ff0000' : '' } },
            },
            data: [],
        },
        {
            hitmonResultType: 7,
            color: includeColor ? '#ffa500' : '',
            marker: {
                symbol: 'diamond',
                radius: 4,
                lineColor: includeColor ? '#ffa500' : '',
                fillColor: '#ffffff',
                lineWidth: 2,
                states: { hover: { radiusPlus: 10, lineColor: includeColor ? '#ffa500' : '' } },
            },
            data: [],
        },
        {
            hitmonResultType: 8,
            color: includeColor ? '#ffa500' : '',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
    ].map((s) => {
        var _a, _b;
        const hitmonResultType = RESULT_TYPES(translate).find((rt) => rt.id === s.hitmonResultType);
        return Object.assign(Object.assign({}, s), { id: (_a = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _a !== void 0 ? _a : '', name: (_b = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _b !== void 0 ? _b : '', point: {
                events: {
                    mouseOver,
                    mouseOut,
                },
            } });
    });
    pitches.forEach((p) => {
        var _a;
        (_a = resultSeries[p.hitmonresulttype - 1]) === null || _a === void 0 ? void 0 : _a.data.push({
            id: p.id,
            pitchtype: p.pitchtype,
            fxsubtype: p.fxsubtype,
            platex: p.platex,
            platez: p.platez,
            breakx: p.breakx,
            breakz: p.breakz,
            bip: p.bip,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            islastpitch: p.islastpitch,
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            hbat: p.hbat,
            vbat: p.vbat,
            heading: p.heading,
            timingrz: p.timingrz,
            timing: p.timing,
            ervadj: p.ervadj,
            timingcolor: timingPointColor(p.timing),
        });
    });
    return resultSeries;
};
const buildPitchTypesSeries = (translate, pitches, availablePitchTypes, mouseOver, mouseOut) => availablePitchTypes
    .map((apt) => {
    var _a, _b, _c, _d, _e, _f;
    const pitchType = PITCH_TYPES_HITMON(translate).find((pt) => pt.id % 1000 === apt);
    return {
        id: (_a = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _a !== void 0 ? _a : '',
        name: (_b = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _b !== void 0 ? _b : '',
        color: pitchSubTypeColor({
            type: ((_c = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _c !== void 0 ? _c : 0) > 1000 ? Math.floor(((_d = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _d !== void 0 ? _d : 0) / 1000) : pitchType === null || pitchType === void 0 ? void 0 : pitchType.id,
            fxsubtype: ((_e = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _e !== void 0 ? _e : 0) > 1000 ? ((_f = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _f !== void 0 ? _f : 0) % 1000 : null,
        }),
        marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        point: {
            events: {
                mouseOver,
                mouseOut,
            },
        },
        data: pitches.filter((p) => (pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) === (p.fxsubtype != null && p.fxsubtype > 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype))
            .map((p) => ({
            id: p.id,
            pitchtype: p.pitchtype,
            fxsubtype: p.fxsubtype,
            platex: p.platex,
            platez: p.platez,
            breakx: p.breakx,
            breakz: p.breakz,
            bip: p.bip,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            islastpitch: p.islastpitch,
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            hbat: p.hbat,
            vbat: p.vbat,
            heading: p.heading,
            timingrz: p.timingrz,
            timing: p.timing,
            ervadj: p.ervadj,
            timingcolor: timingPointColor(p.timing),
        })),
    };
});
const AllCharts = ({ batterHand, showing, pitches, pitchVideoFn, multiVideoFn, tooltipFormatter, minMaxBreakChartCoordinate, availablePitchTypes, hideBatImpactChart, hideHeadingChart, hideHitterTimingChart, hideStrikeZone, hideSprayChart, hideBreakChart, scaleHittingCharts, }) => {
    const { t: translate } = useTranslation();
    const strikeZoneRef = useRef(null);
    const sprayChartRef = useRef(null);
    const breakChartRef = useRef(null);
    const headingChartRef = useRef(null);
    const batImpactChartRef = useRef(null);
    const hitterTimingChartRef = useRef(null);
    const SCALE_HITTING_CHARTS = scaleHittingCharts !== null && scaleHittingCharts !== void 0 ? scaleHittingCharts : 0.7; // helps keep the bottom row of hitting charts on one line
    const mouseOver = function mouseOver() {
        var _a, _b, _c, _d, _e, _f;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint(seriesIndex, dataIndex);
        if (this.timingrz) {
            (_b = hitterTimingChartRef.current) === null || _b === void 0 ? void 0 : _b.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.bip) {
            (_c = sprayChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint(seriesIndex, dataIndex);
        }
        (_d = breakChartRef.current) === null || _d === void 0 ? void 0 : _d.hoverPoint(seriesIndex, dataIndex);
        if (this.heading) {
            (_e = headingChartRef.current) === null || _e === void 0 ? void 0 : _e.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_f = batImpactChartRef.current) === null || _f === void 0 ? void 0 : _f.hoverPoint(seriesIndex, dataIndex);
        }
    };
    const mouseOut = function mouseOut() {
        var _a, _b, _c, _d, _e, _f;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint(seriesIndex, dataIndex);
        if (this.timingrz) {
            (_b = hitterTimingChartRef.current) === null || _b === void 0 ? void 0 : _b.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.bip) {
            (_c = sprayChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint(seriesIndex, dataIndex);
        }
        (_d = breakChartRef.current) === null || _d === void 0 ? void 0 : _d.resetHoverPoint(seriesIndex, dataIndex);
        if (this.heading) {
            (_e = headingChartRef.current) === null || _e === void 0 ? void 0 : _e.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_f = batImpactChartRef.current) === null || _f === void 0 ? void 0 : _f.resetHoverPoint(seriesIndex, dataIndex);
        }
    };
    const resultSeries = useMemo(() => buildResultsSeries(translate, pitches, mouseOver, mouseOut, true), [translate, pitches]);
    const resultSeriesNoColor = useMemo(() => buildResultsSeries(translate, pitches, mouseOver, mouseOut, false), [translate, pitches]);
    const pitchTypeSeries = useMemo(() => buildPitchTypesSeries(translate, pitches, availablePitchTypes, mouseOver, mouseOut), [translate, pitches, availablePitchTypes]);
    return (React.createElement("div", { className: "monitorAllChartsContainer" },
        React.createElement("div", { className: "d-flex flex-wrap justify-content-around monitorAllChartsTopContainer" },
            !hideStrikeZone && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorStrikeZoneContainer", style: { maxWidth: '500px' } },
                showing != SHOWING_TIMING_VALUE && (React.createElement(StrikeZone, { ref: strikeZoneRef, pitches: pitches, batterHand: batterHand, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })),
                showing === SHOWING_TIMING_VALUE && (React.createElement(StrikeZone, { ref: strikeZoneRef, pitches: pitches, batterHand: batterHand, showing: showing, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })))),
            !hideSprayChart && (React.createElement("div", { className: "mb-5 monitorSprayChartContainer", style: { maxWidth: '500px' } },
                showing != SHOWING_TIMING_VALUE && (React.createElement(SprayChart, { ref: sprayChartRef, pitches: pitches, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })),
                showing === SHOWING_TIMING_VALUE && (React.createElement(SprayChart, { ref: sprayChartRef, pitches: pitches, showing: showing, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })))),
            !hideBreakChart && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorBreakChartContainer", style: { maxWidth: '500px' } },
                showing != SHOWING_TIMING_VALUE && (React.createElement(BreakChart, { ref: breakChartRef, pitches: pitches, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, minMaxCoordinate: minMaxBreakChartCoordinate, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })),
                showing === SHOWING_TIMING_VALUE && (React.createElement(BreakChart, { ref: breakChartRef, pitches: pitches, showing: showing, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, minMaxCoordinate: minMaxBreakChartCoordinate, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn }))))),
        React.createElement("div", { className: "d-flex flex-wrap justify-content-around monitorAllChartsBottomContainer" },
            !hideHitterTimingChart && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorHitterTimingChartContainer", style: { maxWidth: '500px' } },
                showing != SHOWING_TIMING_VALUE && (React.createElement(HitterTiming, { size: "lg", showing: showing, isLhb: batterHand === 2, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: hitterTimingChartRef, tooltipFormatter: tooltipFormatter, sizeMultiplier: SCALE_HITTING_CHARTS })),
                showing === SHOWING_TIMING_VALUE && (React.createElement(HitterTiming, { size: "lg", showing: showing, isLhb: batterHand === 2, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: hitterTimingChartRef, tooltipFormatter: tooltipFormatter, sizeMultiplier: SCALE_HITTING_CHARTS })))),
            !hideHeadingChart && (React.createElement("div", { className: "mb-3 d-flex flex-wrap justify-content-center monitorHeadingChartContainer", style: { maxWidth: '500px' } },
                showing != SHOWING_TIMING_VALUE && (React.createElement(HeadingChart, { ref: headingChartRef, pitches: pitches, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, availablePitchTypes: availablePitchTypes.map((pt) => pt % 1000), pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, sizeMultiplier: SCALE_HITTING_CHARTS })),
                showing === SHOWING_TIMING_VALUE && (React.createElement(HeadingChart, { ref: headingChartRef, showing: showing, pitches: pitches, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, availablePitchTypes: availablePitchTypes.map((pt) => pt % 1000), pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, sizeMultiplier: SCALE_HITTING_CHARTS })))),
            !hideBatImpactChart && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2 monitorBatImpactChartContainer", style: { maxWidth: '500px' } },
                showing != SHOWING_TIMING_VALUE && (React.createElement(BatImpactChart, { ref: batImpactChartRef, batterHand: batterHand, pitches: pitches, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, sizeMultiplier: SCALE_HITTING_CHARTS })),
                showing === SHOWING_TIMING_VALUE && (React.createElement(BatImpactChart, { ref: batImpactChartRef, batterHand: batterHand, pitches: pitches, showing: showing, resultSeries: resultSeriesNoColor, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, sizeMultiplier: SCALE_HITTING_CHARTS }))))),
        showing === SHOWING_TIMING_VALUE && (React.createElement("div", { className: "d-flex justify-content-center", style: { paddingTop: '25px' } },
            React.createElement("img", { src: timingLegendImg, style: { maxWidth: '950px' }, alt: "Legend" })))));
};

const StyledAbbrCell = styled.div `
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;
    min-width: fit-content;
`;
const emptyRow = () => ({
    pitches: 0,
    velocity: 0,
    breakx: 0,
    breakz: 0,
    spinrate: 0,
    inz: 0,
    outz: 0,
    ch: 0,
    swds: 0,
    swdspit: 0,
    stk: 0,
    ms: 0,
    sw: 0,
    gb: 0,
    bip: 0,
    biprvdenom: 0,
    rvhitfxactualbip: 0,
    rvhitfxpitbip: 0,
    pwbatspdinz: 0,
    pwbatspdoutz: 0,
    fbhead: 0,
    nfbhead: 0,
    pwfbhead: 0,
    pwnfbhead: 0,
    hbat: 0,
    vbat: 0,
    pwhbat: 0,
    pwvbat: 0,
    barracc: 0,
    pawbarracc: 0,
    rvactual: 0,
    ervpitch: 0,
    rvpitchfx: 0,
    adjhead: 0,
    pwadjhead: 0,
    headpm: 0,
    pwheadpm: 0,
    whipsnum: 0,
    whipsdenom: 0,
    b1: 0,
    b2: 0,
    b3: 0,
    hr: 0,
    ab: 0,
});
const whipsNumeratorResultTypes = [1, 2];
const whipsDenominatorResultTypes = [1, 2, 4, 5, 6, 7, 8];
const aggregate = (pitches) => pitches.reduce((all, p) => {
    var _a, _b, _c, _d;
    all.pitches += 1;
    all.velocity += p.velocity;
    all.inz += p.inz;
    all.outz += p.outz;
    all.breakx += p.breakx;
    all.breakz += p.breakz;
    all.spinrate += p.spinrate;
    all.ch += p.ch;
    all.swds += p.swds;
    all.swdspit += p.swdspit;
    all.stk += p.stk;
    all.ms += p.ms;
    all.sw += p.sw;
    all.gb += p.gb;
    all.bip += p.bip;
    all.biprvdenom += p.biprvdenom;
    all.rvhitfxactualbip += p.rvhitfxactualbip;
    all.rvhitfxpitbip += p.rvhitfxpitbip;
    all.pwbatspdinz += p.pwbatspdinz;
    all.pwbatspdoutz += p.pwbatspdoutz;
    all.fbhead += p.fbhead;
    all.nfbhead += p.nfbhead;
    all.pwfbhead += p.pwfbhead;
    all.pwnfbhead += p.pwnfbhead;
    all.hbat += p.hbat;
    all.vbat += p.vbat;
    all.pwhbat += isNumber$3(p.hbat) ? 1 : 0;
    all.pwvbat += isNumber$3(p.vbat) ? 1 : 0;
    all.barracc += p.barracc;
    all.pawbarracc += p.pawbarracc;
    all.rvactual += p.rvactual;
    all.ervpitch += p.ervpitch;
    all.rvpitchfx += p.rvpitchfx;
    all.adjhead += p.adjhead;
    all.pwadjhead += (_a = p.pwadjhead) !== null && _a !== void 0 ? _a : 0;
    all.headpm += (isNumber$3((_b = p.fbhead) !== null && _b !== void 0 ? _b : p.nfbhead)
        && isNumber$3(p.adjhead)) ? ((_c = p.fbhead) !== null && _c !== void 0 ? _c : p.nfbhead) - p.adjhead : 0;
    all.pwheadpm += (isNumber$3((_d = p.fbhead) !== null && _d !== void 0 ? _d : p.nfbhead) && isNumber$3(p.adjhead)) ? 1 : 0;
    all.whipsnum += whipsNumeratorResultTypes.includes(p.hitmonresulttype) ? 1 : 0;
    all.whipsdenom += whipsDenominatorResultTypes.includes(p.hitmonresulttype) ? 1 : 0;
    all.b1 += p.b1;
    all.b2 += p.b2;
    all.b3 += p.b3;
    all.hr += p.hr;
    all.ab += p.ab;
    return all;
}, emptyRow());
const buildPitchTypeBreakdownRows = (pitches, translate) => {
    const grouped = pitches.reduce((acc, p) => {
        const key = String(p.fxsubtype != null && p.fxsubtype !== 0 ? `${p.pitchtype}-${p.fxsubtype}` : p.pitchtype);
        (acc[key] || (acc[key] = [])).push(p);
        return acc;
    }, {});
    return Object.entries(grouped).map(([key, group]) => {
        var _a, _b;
        const label = pitchTypeDisplayName({ fxtype: group[0].pitchtype, fxsubtype: group[0].fxsubtype }, true, true, translate) || String(key);
        return Object.assign({ rowid: `pt-${key}`, abbr: (_a = label === null || label === void 0 ? void 0 : label.toString()) !== null && _a !== void 0 ? _a : key, sortorder: (_b = group[0].pitchtypesortorder) !== null && _b !== void 0 ? _b : 999, key, pitpct: ratio(group.length, pitches.length) }, aggregate(group));
    });
};
const getColumns$1 = (translate, showLevelAverages, isLhp, hideBatTrackingStats, showAvgSlg, onPlayAll, isDrilldown = false, onPitchTypeVideo) => {
    const spacer = isDrilldown && !showLevelAverages
        ? [{
                id: 'pitchtype-label',
                title: '',
                type: COLUMN_TYPES.TEXT,
                transform: () => React.createElement("span", null, "\u00A0"),
            }]
        : [];
    const actionColumn = [{
            id: 'pitchtype-video',
            title: '',
            type: COLUMN_TYPES.NODE,
            transform: (row) => ((row.rowid === 'summary' || isDrilldown)
                ? (React.createElement(VideoButton, { color: "#244c74", onClick: isDrilldown ? () => onPitchTypeVideo === null || onPitchTypeVideo === void 0 ? void 0 : onPitchTypeVideo(row) : onPlayAll })) : React.createElement("span", null, "\u00A0")),
        }];
    const abbrColumn = [{
            id: 'abbr',
            title: '',
            type: COLUMN_TYPES.TEXT,
            // eslint-disable-next-line no-nested-ternary
            transform: (row) => (React.createElement(StyledAbbrCell, null, row.rowid === 'summary' ? React.createElement("span", null, "\u00A0")
                : ((showLevelAverages && !isDrilldown)
                    ? `${isLhp ? translate('baseball.lhp') : translate('baseball.rhp')} ${row.abbr} Avg`
                    : React.createElement("span", null, row.abbr)))),
        }];
    return [
        ...spacer,
        ...actionColumn,
        ...abbrColumn,
        { id: 'pitches', title: translate('sections.reports.pitcher.abbr-num-pitches'), transform: (r) => (r.pitcheshidecount ? '--' : r.pitches) },
        { id: 'pitpct', title: translate('pitcher-overview.pitch-break.pit-percent'), statistic: 'PitchTypePercent', type: COLUMN_TYPES.PERCENT, precision: 0 },
        { id: 'velocity', title: translate('sections.reports.pitcher.abbr-velo'), transform: (r) => ratio(r.velocity, r.pitches), precision: 1 },
        { id: 'breakx', title: translate('baseball.break-x'), statistic: 'BreakX', transform: (r) => ratio(r.breakx, r.pitches), precision: 1 },
        { id: 'breakz', title: translate('baseball.break-z'), statistic: 'BreakZ', transform: (r) => ratio(r.breakz, r.pitches), precision: 1 },
        { id: 'spin', title: translate('data.spin-rate'), statistic: 'SpinRate', transform: (r) => ratio(r.spinrate, r.pitches) },
        {
            id: 'kzon',
            title: translate('baseball.abbr-strikezone'),
            statistic: 'KZon',
            type: COLUMN_TYPES.PERCENT,
            transform: (r) => ratio(r.inz, r.inz + r.outz),
        },
        {
            id: 'ch',
            title: translate('components.hitmon.abbr-chase-pct'),
            statistic: 'Ch',
            type: COLUMN_TYPES.PERCENT,
            transform: (r) => ratio(r.ch, r.outz),
        },
        { id: 'swdec', title: translate('baseball.abbr-swingdecision'), statistic: 'Swds', transform: (r) => ratio(r.swds, r.swdspit), precision: 1 },
        {
            id: 'stk',
            title: translate('sections.reports.pitcher.abbr-strike'),
            statistic: 'Stk',
            type: COLUMN_TYPES.PERCENT,
            transform: (r) => ratio(r.stk, r.pitches),
        },
        {
            id: 'ms',
            title: translate('sections.reports.pitcher.abbr-miss'),
            statistic: 'Ms',
            type: COLUMN_TYPES.PERCENT,
            transform: (r) => ratio(r.ms, r.sw),
        },
        {
            id: 'gb',
            title: translate('baseball.abbr-groundball-pct'),
            statistic: 'GBPercent',
            type: COLUMN_TYPES.PERCENT,
            transform: (r) => ratio(r.gb, r.bip),
        },
        ...(showAvgSlg ? [
            {
                id: 'whips',
                title: translate('components.hitmon.whips'),
                statistic: 'WHiPS',
                type: COLUMN_TYPES.RATE,
                transform: (r) => ratio(r.whipsnum, r.whipsdenom),
            },
            {
                id: 'avg',
                title: translate('components.hitmon.abbr-average'),
                statistic: 'AVG',
                type: COLUMN_TYPES.RATE,
                transform: (r) => avg(r.b1, r.b2, r.b3, r.hr, r.ab),
            },
            {
                id: 'slg',
                title: translate('components.hitmon.abbr-slugging'),
                statistic: 'SLG',
                type: COLUMN_TYPES.RATE,
                transform: (r) => slg(r.b1, r.b2, r.b3, r.hr, r.ab),
            },
        ] : []),
        {
            id: 'cr',
            title: 'CR',
            statistic: 'ContactResults',
            transform: (r) => (r.biprvdenom > 0 ? normalize(r.rvhitfxactualbip, r.biprvdenom, 100) : null),
            precision: 1,
        },
        {
            id: 'cq',
            title: 'CQ',
            statistic: 'ContactQuality',
            transform: (r) => (r.biprvdenom > 0 ? normalize(r.rvhitfxpitbip, r.biprvdenom, 100) : null),
            precision: 1,
        },
        ...(hideBatTrackingStats ? [] : [
            {
                id: 'trkswg',
                title: 'Trk Swg',
                statistic: 'TrackedSwings',
                transform: (r) => ((r.pwbatspdinz + r.pwbatspdoutz) > 0 ? r.pwbatspdinz + r.pwbatspdoutz : '--'),
            },
            {
                id: 'head',
                title: 'Head',
                statistic: 'Heading',
                transform: (r) => ratio(r.fbhead + r.nfbhead, r.pwfbhead + r.pwnfbhead),
                precision: 1,
            },
            {
                id: 'headplusminus',
                title: 'Head +/-',
                statistic: 'HeadPMPit',
                transform: (r) => { var _a, _b; return normalizeRoundedZero(((_a = r.pwheadpm) !== null && _a !== void 0 ? _a : 0) === 0 ? null : (_b = ratio(r.headpm, r.pwheadpm)) !== null && _b !== void 0 ? _b : 0); },
                precision: 1,
            },
            { id: 'hbat', title: 'Hbat', statistic: 'Hbat', transform: (r) => ratio(r.hbat, r.pwhbat), precision: 2 },
            { id: 'vbat', title: 'Vbat', statistic: 'Vbat', transform: (r) => ratio(r.vbat, r.pwvbat), precision: 2 },
        ]),
        { id: 'rvera', title: 'RV ERA', statistic: 'rvERA', transform: (r) => { var _a; return rvERA((_a = ratio(r.rvactual, r.pitches)) !== null && _a !== void 0 ? _a : 0); }, precision: 2 },
        { id: 'ervera', title: 'eRV ERA', statistic: 'eRVERA', transform: (r) => { var _a; return rvERA((_a = ratio(r.ervpitch, r.pitches)) !== null && _a !== void 0 ? _a : 0); }, precision: 2 },
        { id: 'pitchfxera', title: 'PFX ERA', statistic: 'PitchFXERA', transform: (r) => { var _a; return rvERA((_a = ratio(r.rvpitchfx, r.pitches)) !== null && _a !== void 0 ? _a : 0); }, precision: 2 },
    ];
};
const StatsTable = ({ pitches, isLoadingLevelAverages, levelAverages, enableLevelAverages = false, getLevelAverages, levels, statTooltip, isLhp, hideBatTrackingStats = false, showAvgSlg = true, enablePlayAllInStatsTable, videoPlayerModal: VideoPlayerModal, modalContainer, multiVideoFn, }) => {
    const { t: translate } = useTranslation();
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const innerMultiVideoFn = (playlistPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield multiVideoFn(playlistPitches.map((p) => ({ gameid: p.gameid, eventseq: p.eventseq, pitchseq: p.pitchseq })));
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_a) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    const summary = Object.assign({ rowid: 'summary' }, aggregate(pitches));
    const breakdownRows = buildPitchTypeBreakdownRows(pitches, translate).sort((a, b) => (a.sortorder) - (b.sortorder));
    const drilldownColumns = getColumns$1(translate, false, isLhp, hideBatTrackingStats, showAvgSlg, undefined, true, (row) => {
        const key = String(row.rowid.replace('pt-', ''));
        const filtered = pitches.filter((p) => {
            const pitchKey = String(p.fxsubtype != null && p.fxsubtype !== 0
                ? `${p.pitchtype}-${p.fxsubtype}`
                : p.pitchtype);
            return pitchKey === key;
        });
        innerMultiVideoFn(filtered.map((p) => ({
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
        })));
    });
    summary.drilldown = [
        React.createElement("tr", { key: 0 }),
        breakdownRows
            .map((r, i) => (React.createElement(React.Fragment, { key: r.rowid },
            i === 0 && React.createElement("tr", null),
            React.createElement("tr", null, drilldownColumns.map((c) => React.createElement(DataTableCell, { key: `${c.id}-${r.rowid}`, col: c, row: r })))))),
    ];
    return (React.createElement("div", { className: "text-center" },
        React.createElement(DataTable, { columns: getColumns$1(translate, !!levelAverages.length, isLhp, hideBatTrackingStats, showAvgSlg, enablePlayAllInStatsTable ? () => innerMultiVideoFn(pitches) : undefined, false), rows: [summary].concat(levelAverages), statTooltip: statTooltip, rowClass: (r) => ('abbr' in r && !!r.abbr ? 'fw-bold' : '') }),
        !levelAverages.length && enableLevelAverages && (React.createElement("div", { style: { border: '1px solid #ADB0B2', borderTop: 0 }, className: "p-1" }, isLoadingLevelAverages ? React.createElement(LoadingSpinner$1, { size: "sm", style: { margin: '3px 0' } }) : (React.createElement(Button, { variant: "primary", onClick: getLevelAverages, disabled: !levels.filter((l) => l !== 7).length }, translate('components.hitmon.get-level-averages'))))),
        VideoPlayerModal && enablePlayAllInStatsTable && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: () => setIsVideoPlayerOpen(false), playlist: videoPlaylist, container: modalContainer }))));
};

const PitchingMonitor = ({ className, liveFilter, setLiveFilter, pitches, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, tooltipFormatter, maxPAs, levels, enableLevelAverages, getLevelAverages, statTooltip, levelAveragesAbortController, isLhp = false, hideBatImpactChart = false, hideHeadingChart = false, hideBatTrackingStatsTable = false, showAvgSlg = true, enablePlayAllInStatsTable = false, hideHitterTimingFilter = false, hideHitterTimingChart = false, hideHitterTimingViewOption = false, scaleHittingCharts = null, }) => {
    const { t: translate } = useTranslation();
    const [filteredPitches, setFilteredPitches] = useState([]);
    const [isLoadingLevelAverages, setIsLoadingLevelAverages] = useState(false);
    const [levelAverages, setLevelAverages] = useState([]);
    const { cleanPitches, cleanPitchMap } = useMemo(() => getCleanPitches(pitches), [pitches]);
    const availablePitchTypes = useMemo(() => new Set(cleanPitches.map((p) => p.fxsubtype || p.pitchtype)), [cleanPitches]);
    const filterAvailablePitchTypes = useMemo(() => new Set(cleanPitches
        .map((p) => (p.fxsubtype != null && p.fxsubtype !== 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype))), [cleanPitches]);
    const availableResultTypes = useMemo(() => new Set(cleanPitches.map((p) => p.hitmonresulttype)), [cleanPitches]);
    const parks = useMemo(() => Array.from(cleanPitches.reduce((all, p) => {
        if (p.venueid && !all.has(p.venueid)) {
            all.set(p.venueid, { venueid: p.venueid, venuename: p.venuename });
        }
        return all;
    }, new Map()).values()).sort((a, b) => (a.venuename.localeCompare(b.venuename))), [cleanPitches]);
    const minMaxBreakChartCoordinate = useMemo(() => Math.ceil((pitches !== null && pitches !== void 0 ? pitches : [])
        .reduce((max, p) => Math.max(max, Math.abs(p.breakx || 0), Math.abs(p.breakz || 0)), 0) + 1), [pitches]);
    useEffect(() => {
        setFilteredPitches(filterPitches(cleanPitchMap, liveFilter));
        setLevelAverages([]);
        if (levelAveragesAbortController) {
            levelAveragesAbortController.abort();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanPitchMap, liveFilter]);
    useEffect(() => {
        if (maxPAs)
            setLiveFilter(Object.assign(Object.assign({}, liveFilter), { lastPAs: maxPAs }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [maxPAs]);
    useEffect(() => {
        if (liveFilter.park && liveFilter.park > 0 && !parks.some((p) => p.venueid === liveFilter.park)) {
            setLiveFilter(Object.assign(Object.assign({}, liveFilter), { park: ALL_VALUE$1 }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parks]);
    const innerGetLevelAverages = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoadingLevelAverages(true);
            const response = yield getLevelAverages();
            setLevelAverages(response.levelaverages);
        }
        finally {
            setIsLoadingLevelAverages(false);
        }
    });
    const innerTooltipFormatter = (series, point) => {
        const pitch = cleanPitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (liveFilter.showing === SHOWING_RESULTS_VALUE ? getResultTooltip(series.name, pitch, translate)
            : getPitchTypeTooltip(series.name, pitch, translate));
    };
    return (React.createElement("div", { className: `${className}` },
        React.createElement(MonitorFilter, { hideBatterHand: false, hidePitcherHand: true, isSwitch: true, filter: liveFilter, setFilter: setLiveFilter, availablePitchTypes: filterAvailablePitchTypes, availableResultTypes: availableResultTypes, perspective: PERSPECTIVE_TYPES$1.pitcher, maxPAs: maxPAs, parks: parks, hideHitterTimingFilter: hideHitterTimingFilter, hideHitterTimingViewOption: hideHitterTimingViewOption }),
        React.createElement("div", { className: "mt-4" }, [SHOWING_RESULTS_VALUE, SHOWING_TIMING_VALUE, SHOWING_PITCH_TYPES_VALUE].includes(liveFilter.showing)
            ? (React.createElement(AllCharts, { pitches: filteredPitches, batterHand: liveFilter.batterHand, showing: liveFilter.showing, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, tooltipFormatter: tooltipFormatter, minMaxBreakChartCoordinate: minMaxBreakChartCoordinate, availablePitchTypes: Array.from(availablePitchTypes), hideHeadingChart: hideHeadingChart, hideBatImpactChart: hideBatImpactChart, hideHitterTimingChart: hideHitterTimingChart, scaleHittingCharts: scaleHittingCharts }))
            : (React.createElement(GridCharts, { pitches: filteredPitches, batterHand: liveFilter.batterHand, perspective: PERSPECTIVE_TYPES$1.pitcher, setPerspective: () => { }, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, hidePerspectiveToggle: true, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, availablePitchTypes: Array.from(filterAvailablePitchTypes) }))),
        React.createElement("div", { className: "mt-4" },
            React.createElement(StatsTable, { pitches: filteredPitches, isLoadingLevelAverages: isLoadingLevelAverages, levelAverages: levelAverages, enableLevelAverages: enableLevelAverages, getLevelAverages: innerGetLevelAverages, statTooltip: statTooltip, levels: levels, isLhp: isLhp, hideBatTrackingStats: hideBatTrackingStatsTable, showAvgSlg: showAvgSlg, enablePlayAllInStatsTable: enablePlayAllInStatsTable, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, multiVideoFn: multiVideoFn }))));
};

var defaultFilter = {
    showing: 0,
    baseState: ALL_VALUE$1,
    counts: [ALL_VALUE$1],
    result: RESULT_TYPES(null).map((rt) => rt.id),
    pitchTypes: [ALL_VALUE$1],
    pitcherHand: ALL_VALUE$1,
    batterHand: 1,
    zoneLocation: ALL_VALUE$1,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minHorizLa: '',
    maxHorizLa: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minArmAngle: '',
    maxArmAngle: '',
    minGyroDegree: '',
    maxGyroDegree: '',
    pitcherRole: ALL_VALUE$1,
    balls: [],
    strikes: [],
    minRelX: '',
    maxRelX: '',
    minRelZ: '',
    maxRelZ: '',
    minExt: '',
    maxExt: '',
    startDate: undefined,
    endDate: undefined,
    lastPAs: 100,
    timing: [ALL_VALUE$1],
    park: ALL_VALUE$1,
};

const DATE_RANGE = {
    ONE_MONTH: 1,
    THREE_MONTHS: 2,
    ONE_YEAR: 3,
    YTD: 4,
    TWO_YEARS: 5,
    THREE_YEARS: 6,
    FIVE_YEARS: 7,
    ONE_WEEK: 8,
    THREE_WEEKS: 9,
};
const SCALE_GROUP = {
    OPS: 1,
    PERCENT: 2,
    VELOCITY: 3,
    DEGREES: 4,
    SCORE: 5,
    MILLISECONDS: 6,
    INCHES: 7,
    BARREL_RELEASE_EFFICIENCY: 8,
    STAB_INDEX: 9,
    WEIGHT: 10,
    VELOCITY_METRIC: 11,
    FORCE: 12,
    POWER: 13,
    BODYWEIGHTS: 14,
    PERCENT_DIFF: 15,
};
const pitchGroupMap = {
    1: 'FB',
    2: 'BB',
    3: 'OS',
};
const chartColors$1 = [
    '#3366cc',
    '#dc3912',
    '#ff9900',
    '#109618',
    '#990099',
    '#0099c6',
    '#dd4477',
    '#66aa00',
    '#b82e2e',
    '#316395',
    '#994499',
    '#22aa99',
    '#aaaa11',
    '#6633cc',
    '#e67300',
    '#8b0707',
    '#651067',
    '#329262',
    '#5574a6',
    '#3b3eac',
    '#b77322',
    '#16d620',
    '#b91383',
    '#f4359e',
    '#9c5935',
    '#a9c413',
    '#2a778d',
    '#668d1c',
    '#bea413',
    '#0c5922',
    '#743411',
];
// Null stays null so the chart shows a gap; rvPerN would plot it as 0.
const swProdInZone = (swProd, swingsInZone) => (swProd === null ? null : rvPerN(swProd, swingsInZone, SWINGS_IN_ZONE_SCALE));
const trendStats = (translate, showBatTracking) => [
    {
        id: 'hfx',
        name: translate('components.trends.hitfx-ops'),
        transformTrend: (t) => opsRV(t.rvheops, t.pawrv + 0.0),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvheops',
    }, {
        id: 'hfx-rhp',
        name: `${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-rhp')}`,
        transformTrend: (t) => opsRV(t.rvheops_rhp, t.pawrv_rhp + 0.0),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvheops_rhp',
    }, {
        id: 'hfx-lhp',
        name: `${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-lhp')}`,
        transformTrend: (t) => opsRV(t.rvheops_lhp, t.pawrv_lhp + 0.0),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvheops_lhp',
    }, {
        id: 'age-adj',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.hitfx-ops')}`,
        transformTrend: (t) => (t.rvaaops === null ? null : opsRV(t.rvaaops, t.pawrv + 0.0)),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvaaops',
    }, {
        id: 'age-adj-rhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-rhp')}`,
        transformTrend: (t) => (t.rvaaops_rhp === null ? null : opsRV(t.rvaaops_rhp, t.pawrv_rhp + 0.0)),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvaaops_rhp',
    }, {
        id: 'age-adj-lhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-lhp')}`,
        transformTrend: (t) => (t.rvaaops_lhp === null ? null : opsRV(t.rvaaops_lhp, t.pawrv_lhp + 0.0)),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvaaops_lhp',
    }, {
        id: 'ubb',
        name: `${translate('baseball.abbr-walk-ubb')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ubb, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ubb-rhp',
        name: `${translate('baseball.abbr-walk-ubb')}% ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ubb_rhp, t.pa_rhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ubb-lhp',
        name: `${translate('baseball.abbr-walk-ubb')}% ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ubb_lhp, t.pa_lhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'k',
        name: `${translate('baseball.abbr-strikeout-k')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.so, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'k-rhp',
        name: `${translate('baseball.abbr-strikeout-k')}% ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.so_rhp, t.pa_rhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'k-lhp',
        name: `${translate('baseball.abbr-strikeout-k')}% ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.so_lhp, t.pa_lhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'contactquality-rhp',
        name: `${translate('components.trends.contact-quality')} ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvheopsbip_rhp, t.biprvdenom_rhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvheopsbip_rhp',
    }, {
        id: 'contactquality-lhp',
        name: `${translate('components.trends.contact-quality')} ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvheopsbip_lhp, t.biprvdenom_lhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvheopsbip_lhp',
    }, {
        id: 'ageadjcontactquality-rhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.contact-quality')} ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvaaopsbip_rhp, t.biprvdenom_rhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvaaopsbip_rhp',
    }, {
        id: 'ageadjcontactquality-lhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.contact-quality')} ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvaaopsbip_lhp, t.biprvdenom_lhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvaaopsbip_lhp',
    }, {
        id: 'wops',
        name: translate('components.trends.abbr-wops'),
        scaleGroup: SCALE_GROUP.OPS,
        transformTrend: (t) => opsRV(t.rvhitfxactual, t.pawrv + 0.0),
        formatter: (v) => format(v, true),
        keyField: 'rvhitfxactual',
    }, {
        id: 'contactresults',
        name: translate('components.trends.contact-results'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvhitfxactualbip, t.biprvdenom, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvhitfxactualbip',
    }, {
        id: 'hitvelo105',
        name: '% > 105',
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.hitvelocity100, t.pawhitvelocity),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'horizla94',
        name: `${translate('components.trends.horiz-pull')} > 95`,
        scaleGroup: SCALE_GROUP.DEGREES,
        transformTrend: (t) => ratio(t.horizla94, t.hitvelocity90),
        formatter: (v) => format(v, 1),
    }, {
        id: 'gbfb',
        name: translate('components.trends.abbr-gf-ratio'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => gbFb(t.gb, t.fb, t.pop),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'gbpull',
        name: `${translate('components.trends.abbr-gb-pull')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.gbpull, t.gbpull + t.gbaway),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'swfirstp',
        name: `${translate('components.trends.swing-first-pitch')} %`,
        transformTrend: (t) => ratio(t.firstpsw, t.firstp),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'fblup',
        name: `${translate('components.trends.abbr-fbl-up')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.fblup, t.fblwlocation),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'fblin',
        name: `${translate('components.trends.abbr-fbl-in')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.fblin, t.fblwlocation),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'allin',
        name: `${translate('components.trends.abbr-all-in')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.allin, t.pitwlocation),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'msch',
        name: translate('components.trends.miss-chase'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => { var _a; return 1 - ((_a = ratio(t.cnoutz, t.ch)) !== null && _a !== void 0 ? _a : 0); },
        formatter: (v) => (v ? percent(v, 1) : null),
    }, ...showBatTracking ? [
        {
            id: 'sfxcq',
            name: translate('components.trends.abbr-sfx-cq'),
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.fbswingfxcqinz, t.pawfbswingfxcqinz, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'sfxmiss',
            name: translate('components.trends.abbr-sfx-miss'),
            scaleGroup: SCALE_GROUP.PERCENT,
            transformTrend: (t) => ratio(t.fbswingfxmsinz + t.fbswingfxmsoutz, t.pwfbswingfxmsinz + t.pwfbswingfxmsoutz),
            formatter: (v) => (v ? percent(v, 1) : null),
        },
        {
            id: 'batspdinz',
            name: translate('components.trends.abbr-bat-spd'),
            scaleGroup: SCALE_GROUP.VELOCITY,
            transformTrend: (t) => ratio(t.batspdinz, t.pwbatspdinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'batspdheadadjinz',
            name: translate('components.trends.abbr-bat-head-adj-bat-spd'),
            scaleGroup: SCALE_GROUP.VELOCITY,
            transformTrend: (t) => ratio(t.batspdheadadjinz, t.pwbatspdheadadjinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'batspdwadjinz',
            name: translate('components.trends.abbr-wt-adj-bat-spd'),
            scaleGroup: SCALE_GROUP.VELOCITY,
            transformTrend: (t) => ratio(t.batspdwadjinz, t.pwbatspdwadjinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barreff',
            name: translate('components.trends.abbr-bar-rel-eff'),
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => ratio(t.barreff, t.pwbarreff),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'atkanginz',
            name: translate('components.trends.abbr-att-ang'),
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.atkanginz, t.pwatkanginz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'atkangheadadjinz',
            name: translate('components.trends.abbr-head-adj-att-ang'),
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.atkangheadadjinz, t.pwatkangheadadjinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'fbhead',
            name: translate('components.trends.abbr-fb-head'),
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.fbhead, t.pwfbhead),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'nfbhead',
            name: translate('components.trends.abbr-nfb-head'),
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.nfbhead, t.pwnfbhead),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'headpm',
            name: translate('components.trends.abbr-headpm'),
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.headpm, t.pwheadpm),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'battiltinz',
            name: translate('components.trends.abbr-bat-tilt'),
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.battiltinz, t.pwbattiltinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'habvballinz',
            name: translate('components.trends.abbr-hands-abv-ball'),
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.habvballinz, t.pwhabvballinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barracc',
            name: translate('components.trends.abbr-bar-acc-bip'),
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.barracc, t.pawbarracc, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barracch',
            name: translate('components.trends.abbr-bar-acc-h-bip'),
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.barracch, t.pawbarracch, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barraccv',
            name: translate('components.trends.abbr-bar-acc-v-bip'),
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.barraccv, t.pawbarraccv, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'hbat',
            name: translate('components.trends.abbr-h-bat'),
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.hbat, t.pwhbat),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'hbatadj',
            name: translate('components.trends.abbr-adj-h-bat'),
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.hbatadj, t.pwhbatadj),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'vbat',
            name: translate('components.trends.abbr-v-bat'),
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.vbat, t.pwvbat),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'vbatadj',
            name: translate('components.trends.abbr-adj-v-bat'),
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.vbatadj, t.pwvbatadj),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'swprodinz',
            name: translate('components.trends.abbr-sw-prod-inz'),
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => swProdInZone(t.swprod, t.swinz),
            formatter: (v) => format(v, 1),
        }, {
            id: 'aaswprodinz',
            name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.abbr-sw-prod-inz')}`,
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => swProdInZone(t.aaswprod, t.swinz),
            formatter: (v) => format(v, 1),
            keyField: 'aaswprod',
        }, {
            id: 'absswtiming',
            name: translate('components.trends.abbr-abs-timing'),
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.absswtiming, t.swingswtiming),
            formatter: (v) => format(v, 1),
        }, {
            id: 'swtiming',
            name: translate('components.trends.abbr-raw-timing'),
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.swtiming, t.swingswtiming),
            formatter: (v) => format(v, 1),
        }
    ] : [],
];
const forcePlateJumpStats = (translate) => [{
        id: 'mass',
        name: translate('components.trends.weight'),
        scaleGroup: SCALE_GROUP.WEIGHT,
        transformForcePlate: (fp) => fp.mass,
        formatter: (v) => format(v, 1),
        keyField: 'mass',
        axisMin: 150,
        axisMax: 270,
    }, {
        id: 'peakvelo',
        name: translate('components.trends.peak-velo'),
        scaleGroup: SCALE_GROUP.VELOCITY_METRIC,
        transformForcePlate: (fp) => fp.peakvelo,
        formatter: (v) => format(v, 2),
        keyField: 'peakvelo',
        axisMin: 2.5,
        axisMax: 3.6,
    }, {
        id: 'peakforce',
        name: translate('components.trends.peak-force'),
        scaleGroup: SCALE_GROUP.FORCE,
        transformForcePlate: (fp) => fp.peakforce,
        formatter: (v) => format(v, 1),
        keyField: 'peakforce',
        axisMin: 370,
        axisMax: 800,
    }, {
        id: 'peakforce_bw',
        name: translate('components.trends.peak-force-bw'),
        scaleGroup: SCALE_GROUP.BODYWEIGHTS,
        transformForcePlate: (fp) => fp.peakforce_bw,
        formatter: (v) => format(v, 2),
        keyField: 'peakforce_bw',
        axisMin: 2.0,
        axisMax: 3.6,
    }, {
        id: 'peakpower',
        name: translate('components.trends.peak-power'),
        scaleGroup: SCALE_GROUP.POWER,
        transformForcePlate: (fp) => fp.peakpower,
        formatter: (v) => format(v, 1),
        keyField: 'peakpower',
        axisMin: 3700,
        axisMax: 8500,
    }, {
        id: 'peakpower_bw',
        name: translate('components.trends.peak-power-bw'),
        scaleGroup: SCALE_GROUP.BODYWEIGHTS,
        transformForcePlate: (fp) => fp.peakpower_bw,
        formatter: (v) => format(v, 1),
        keyField: 'peakpower_bw',
        axisMin: 19.0,
        axisMax: 37.0,
    }, {
        id: 'asymmetryavgbraking',
        name: translate('components.trends.asymmetry-avg-braking'),
        scaleGroup: SCALE_GROUP.PERCENT_DIFF,
        transformForcePlate: (fp) => fp.asymmetryavgbraking,
        formatter: (v) => format(v, 1),
        keyField: 'asymmetryavgbraking',
        axisMin: -35,
        axisMax: 35,
    }];
const pitchTypeTrendStats = (translate) => [{
        id: 'kzon',
        name: `${translate('baseball.abbr-strikezone')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.inz, t.inz + t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'swinz',
        name: `${translate('components.trends.swing-in-zone')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.swinz, t.inz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ch',
        name: `${translate('components.trends.chase')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ch, t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'swds',
        name: translate('components.trends.swing-decisions'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => ratio(t.swds, t.swdspit),
        formatter: (v) => format(v, 1),
    }, {
        id: 'swdssw',
        name: translate('components.trends.sw-dec-should-swing'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => ratio(t.swdssw, t.swdsswpit),
        formatter: (v) => format(v, 1),
    }, {
        id: 'swdstk',
        name: translate('components.trends.sw-dec-should-take'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => ratio(t.swdstk, t.swdstkpit),
        formatter: (v) => format(v, 1),
    }, {
        id: 'ms',
        name: `${translate('components.trends.miss')} %`,
        transformTrend: (t) => missPct(t.sw, t.cn),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'msinzon',
        name: translate('components.trends.miss-in-zone'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => missPct(t.swinz, t.cninz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'inplay',
        name: `${translate('components.trends.in-play')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.inplay, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ageadjcontactquality',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.contact-quality')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvaaopsbip, t.biprvdenom, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvaaopsbip',
    }, {
        id: 'contactquality',
        name: translate('components.trends.contact-quality'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvheopsbip, t.biprvdenom, 100),
        formatter: (v) => format(v, 1),
    }, {
        id: 'hitvelocity',
        name: translate('components.trends.exit-velo'),
        scaleGroup: SCALE_GROUP.VELOCITY,
        transformTrend: (t) => ratio(t.hitvelocity, t.pawhitvelocity),
        formatter: (v) => format(v, 1),
    }, {
        id: 'hitvelo95',
        name: '% > 95',
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.hitvelocity90, t.pawhitvelocity),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'vertla94',
        name: `${translate('components.trends.abbr-vert-launch')} > 95`,
        scaleGroup: SCALE_GROUP.DEGREES,
        transformTrend: (t) => ratio(t.vertla94, t.hitvelocity90),
        formatter: (v) => format(v, 1),
    }, {
        id: 'ervops',
        name: translate('components.trends.abbr-ervops'),
        scaleGroup: SCALE_GROUP.OPS,
        // note: these are the HitFX OPS constants, multiplied by 3.9 pitches per PA
        transformTrend: (t) => opsRVPitch(t.ervpitch, t.pitches),
        formatter: (v) => format(v, true),
    }, {
        id: 'sw',
        name: `${translate('components.trends.swing')} %`,
        transformTrend: (t) => swingPct(t.sw, t.pitches, t.iballs, t.pitchouts),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'pitchpercentage',
        name: `${translate('baseball.pitches_one')} %`,
        transformTrend: (t) => { var _a; return (_a = t.pitchpercentage) !== null && _a !== void 0 ? _a : null; },
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitchpercentage',
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'ch2k',
        name: translate('components.trends.chase2k'),
        transformTrend: (t) => ratio(t.ch2k, t.pit2k),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'sw2k',
        name: translate('components.trends.swing2k'),
        transformTrend: (t) => ratio(t.sw2k, t.pit2k),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }];
const blastSwingStats = (translate) => [{
        id: 'maxbarrspeed',
        name: translate('components.trends.max-barrel-speed'),
        scaleGroup: SCALE_GROUP.VELOCITY,
        transformBlastSwing: (bs) => bs.maxbarrspeed,
        formatter: (v) => format(v, 1),
        keyField: 'maxbarrspeed',
    }, {
        id: 'maxbarrhandspeedratio',
        name: translate('components.trends.barrel-release-efficiency'),
        scaleGroup: SCALE_GROUP.BARREL_RELEASE_EFFICIENCY,
        transformBlastSwing: (bs) => bs.maxbarrhandspeedratio,
        formatter: (v) => format(v, 1),
        keyField: 'maxbarrhandspeedratio',
    }, {
        id: 'maxpretrigvba',
        name: translate('components.trends.max-pre-trigger-vertical-bat'),
        scaleGroup: SCALE_GROUP.DEGREES,
        transformBlastSwing: (bs) => bs.maxpretrigvba,
        formatter: (v) => format(v, 1),
        keyField: 'maxpretrigvba',
    }, {
        id: 'onplaneeff',
        name: translate('components.trends.on-plane-efficiency'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformBlastSwing: (bs) => ratio(bs.onplaneeff, 100),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'onplaneeff',
    }, {
        id: 'attang',
        name: translate('components.trends.attack-angle'),
        scaleGroup: SCALE_GROUP.DEGREES,
        transformBlastSwing: (bs) => bs.attang,
        formatter: (v) => format(v, 1),
        keyField: 'attang',
    }, {
        id: 'battiltatimpact',
        name: translate('components.trends.bat-tilt-at-impact'),
        scaleGroup: SCALE_GROUP.DEGREES,
        transformBlastSwing: (bs) => bs.battiltatimpact,
        formatter: (v) => format(v, 1),
        keyField: 'battiltatimpact',
        reversed: true,
    }, {
        id: 'barrelcast',
        name: translate('components.trends.barrel-cast'),
        scaleGroup: SCALE_GROUP.INCHES,
        transformBlastSwing: (bs) => bs.barrelcast,
        formatter: (v) => format(v, 1),
        keyField: 'barrelcast',
    }, {
        id: 'barreldump',
        name: translate('components.trends.barrel-dump'),
        scaleGroup: SCALE_GROUP.MILLISECONDS,
        transformBlastSwing: (bs) => bs.barreldump,
        formatter: (v) => format(v, 1),
        keyField: 'barreldump',
    }, {
        id: 'maxhandspeed',
        name: translate('components.trends.hand-speed'),
        scaleGroup: SCALE_GROUP.VELOCITY,
        transformBlastSwing: (bs) => bs.maxhandspeed,
        formatter: (v) => format(v, 1),
        keyField: 'maxhandspeed',
    }, {
        id: 'timetoeff',
        name: translate('components.trends.time-to-efficiency'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformBlastSwing: (bs) => bs.timetoeff,
        formatter: (v) => format(v, 1),
        keyField: 'timetoeff',
    }, {
        id: 'stabindexmeantm',
        name: translate('components.trends.stab-index'),
        scaleGroup: SCALE_GROUP.STAB_INDEX,
        transformBlastSwing: (bs) => bs.stabindexmeantm,
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'stabindexmeantm',
    }, {
        id: 'batwaggle',
        name: translate('components.trends.bat-waggle'),
        scaleGroup: SCALE_GROUP.INCHES,
        transformBlastSwing: (bs) => bs.batwaggle,
        formatter: (v) => format(v, 1),
        keyField: 'batwaggle',
    }, {
        id: 'barrelpump',
        name: translate('components.trends.barrel-pump'),
        scaleGroup: SCALE_GROUP.INCHES,
        transformBlastSwing: (bs) => bs.barrelpump,
        formatter: (v) => format(v, 2),
        keyField: 'barrelpump',
    }, {
        id: 'barrelpumpfreq',
        name: translate('components.trends.barrel-pump-frequency'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformBlastSwing: (bs) => bs.barrelpumpfreq,
        formatter: (v) => (v ? percent(v, 0) : null),
        keyField: 'barrelpumpfreq',
    }, {
        id: 'triggertoimpact',
        name: translate('components.trends.trigger-to-impact'),
        scaleGroup: SCALE_GROUP.MILLISECONDS,
        transformBlastSwing: (bs) => bs.triggertoimpact,
        formatter: (v) => format(v, 0),
        keyField: 'triggertoimpact',
    }];
const TRENDS_STATS = (translate, showBatTracking) => trendStats(translate, showBatTracking).map((s) => ({
    id: s.id,
    name: s.name,
    pitchType: null,
    transformTrend: s.transformTrend,
    formatter: s.formatter,
    scaleGroup: s.scaleGroup,
    keyField: s.keyField,
    axisMin: s.axisMin,
    axisMax: s.axisMax,
})).concat(pitchTypeTrendStats(translate).reduce((all, s) => all.concat([1, 2, 3, null]
    .map((pt) => ({
    id: `${s.id}${pt ? `-${pt}` : ''}`,
    name: `${s.name}${pt ? ` - ${pitchGroupMap[pt]}` : ''}`,
    pitchType: pt !== null && pt !== void 0 ? pt : null,
    transformTrend: s.transformTrend,
    formatter: s.formatter,
    scaleGroup: s.scaleGroup,
    keyField: s.keyField,
    axisMin: s.axisMin,
    axisMax: s.axisMax,
}))), [])).concat(blastSwingStats(translate).map((bs) => ({
    id: bs.id,
    isBlast: true,
    name: bs.name,
    pitchType: null,
    transformBlastSwing: bs.transformBlastSwing,
    formatter: bs.formatter,
    scaleGroup: bs.scaleGroup,
    keyField: bs.keyField,
    reversed: bs.reversed,
})))
    .concat(forcePlateJumpStats(translate).map((fp) => ({
    id: fp.id,
    isForcePlate: true,
    name: fp.name,
    pitchType: null,
    transformForcePlate: fp.transformForcePlate,
    formatter: fp.formatter,
    scaleGroup: fp.scaleGroup,
    keyField: fp.keyField,
    axisMin: fp.axisMin,
    axisMax: fp.axisMax,
})))
    .map((s, index) => (Object.assign(Object.assign({}, s), { color: chartColors$1[index % chartColors$1.length] })));

const StyledToggleButtonGroup = styled(ToggleButtonGroup$1) `
    &.btn-group {
        label.btn.btn-primary {
            background-color: white;
            color: ${styles.theme.fontColors.metallicBlue};
            border: 1px solid #dee2e6;
            font-weight: 400;
            font-size: 0.825rem;
            padding: 0.125rem 0.75rem;
        }

        .btn-check:checked + .btn {
            background-color: ${styles.theme.background.mariner};
            color: white;
            font-weight: 600;
        }
    }
`;
const options = [
    { value: DATE_RANGE.ONE_WEEK, label: '1W' },
    { value: DATE_RANGE.THREE_WEEKS, label: '3W' },
    { value: DATE_RANGE.ONE_MONTH, label: '1M' },
    { value: DATE_RANGE.THREE_MONTHS, label: '3M' },
    { value: DATE_RANGE.ONE_YEAR, label: '1Y' },
    { value: DATE_RANGE.YTD, label: 'YTD' },
    { value: DATE_RANGE.TWO_YEARS, label: '2Y' },
    { value: DATE_RANGE.THREE_YEARS, label: '3Y' },
    { value: DATE_RANGE.FIVE_YEARS, label: '5Y' },
];
const DateRangeButtonGroup = ({ value, onChange, dateOptions = [1, 2, 3, 4, 5, 6, 7] }) => {
    const filteredDateOptions = options.filter((o) => (dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.indexOf(o.value)) >= 0);
    return (React.createElement(StyledToggleButtonGroup, { type: "radio", name: "date-range-options", value: value, onChange: onChange }, filteredDateOptions.map((o) => (React.createElement(ToggleButton$1, { id: `date-range-option-${o.value}`, value: o.value, key: o.value }, o.label)))));
};

const StyledCheck = styled(Form$1.Check) `
    font-size: 0.825rem;
    .form-check-label {
        position: relative;
        top: 2px;
    }
    &.form-check-inline {
        min-height: 0;
    }
`;
const ChartDisplayOptions = ({ showLevelChanges, setShowLevelChanges, showAdjustments, setShowAdjustments }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledCheck, { inline: true, type: "checkbox", id: "level-change", label: translate('components.trends.level-change'), checked: showLevelChanges, onChange: () => setShowLevelChanges(!showLevelChanges) }),
        React.createElement(StyledCheck, { inline: true, type: "checkbox", id: "adjustments", label: translate('components.trends.adjutments'), checked: showAdjustments, onChange: () => setShowAdjustments(!showAdjustments) })));
};

/* eslint-disable max-len */
const StyledDataPointMenu$1 = styled.div `
    font-size: 0.875rem;
    width: 200px;
    z-index: 1;
    flex-shrink: 0;
    max-height: calc(100% - 56px);
`;
const GroupTitle$1 = styled.h5 `
    padding: 4px 0 !important;
    color: ${theme.fontColors.darkBlue};
    margin-bottom: 0 !important;
    font-size: 13.75px !important;
`;
const StyledStat$3 = styled.div `
    display: flex;
    align-items: center;
    color: ${(props) => (props.$disabled ? theme.fontColors.tundora : theme.fontColors.darkBlue)};
    border: 1px solid ${(props) => props.$borderColor};
    background-color: ${(props) => (props.$disabled ? '#d4d4d4' : 'white')};
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    margin-right: 4px;
    font-size: 0.75rem;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        color: white;
        background-color: ${theme.background.cerulean};
    }
`;
const StyledColorMarker$1 = styled.div `
    background-color: ${(props) => props.$color};
    height: 8px;
    width: 8px;
    border-radius: 9999px;
    flex-shrink: 0;
`;
const StyledInputContainer = styled.div `&& {
    display: flex;
    align-items: center;
}`;
const StyledClearButton$1 = styled.div `&& {
    margin-left: -20px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${searchReset}) no-repeat center;
}`;
const StatSection$1 = ({ id, title, trendStats, selectedStats, selectStat, className }) => {
    const { t: translate } = useTranslation();
    const [query, setQuery] = useState('');
    const [scrolledToStart, setScrolledToStart] = useState(false);
    const count = trendStats.filter((ts) => selectedStats.some((ss) => ts.id === ss.id)).length;
    const filteredTrendStats = trendStats.filter((ts) => !query || ts.name.toLowerCase().includes(query.toLowerCase()));
    useEffect(() => {
        if (trendStats && !scrolledToStart && selectedStats.length) {
            const statsInSection = selectedStats.filter((ss) => trendStats.some((ts) => ts.id === ss.id));
            const firstSelectedId = statsInSection.length ? statsInSection[0].id : null;
            if (firstSelectedId) {
                const firstSelectedElement = document.getElementById(`selected-stat-${firstSelectedId}`);
                const wrapperElement = document.getElementById(id);
                if (firstSelectedElement) {
                    wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.scrollTo({ top: (firstSelectedElement === null || firstSelectedElement === void 0 ? void 0 : firstSelectedElement.offsetTop) - firstSelectedElement.getBoundingClientRect().height - 37 });
                    setScrolledToStart(true);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trendStats]);
    return (React.createElement("div", { className: `border-bottom d-flex flex-column ${className}`, style: { maxHeight: '50%' } },
        React.createElement(GroupTitle$1, null,
            title,
            " (",
            count,
            ")"),
        React.createElement(StyledInputContainer, null,
            React.createElement(Form$1.Control, { placeholder: `${translate('common.filter')} ${title}...`, size: "sm", value: query, onChange: (e) => setQuery(e.target.value), style: { fontSize: 12, marginBottom: 2 } }),
            query.length > 0 && React.createElement(StyledClearButton$1, { onClick: () => setQuery('') })),
        React.createElement("div", { className: "overflow-auto flex-grow-1", id: id }, filteredTrendStats.map((s) => {
            const disabled = !selectedStats.some((ss) => ss.id === s.id);
            return (React.createElement(StyledStat$3, { key: s.id, onClick: () => selectStat(s), "$disabled": disabled, "$borderColor": disabled ? theme.fontColors.silverChalice : s.color, className: "mt-1", id: `selected-stat-${s.id}` },
                React.createElement(StyledColorMarker$1, { "$color": disabled ? theme.fontColors.silverChalice : s.color, className: "me-2" }),
                s.name));
        }))));
};
const DataPointMenu$1 = ({ trends, blastSwings, forcePlateJumps, stats, setStats, setHasTrends, setHasBlast, setHasForcePlate, showTrends = true, showBlast = true, showForcePlate = false, showBatTracking = false }) => {
    const { t: translate } = useTranslation();
    const filteredStats = TRENDS_STATS(translate, showBatTracking).filter((ts) => ts.keyField === undefined
        || trends.some((t) => ts.pitchType === t.pitchtype && !!t[ts.keyField])
        || blastSwings.some((bs) => !!bs[ts.keyField])
        || forcePlateJumps.some((fp) => !!fp[ts.keyField]))
        .sort((a, b) => (a.name.localeCompare(b.name)));
    const selectStat = (ts) => {
        setStats(stats.some((s) => s.id === ts.id)
            ? stats.filter((s) => s.id !== ts.id)
            : [
                ...stats,
                ts,
            ]);
    };
    useEffect(() => {
        setHasTrends(stats.some((s) => !s.isBlast && !s.isForcePlate));
    }, [stats, setHasTrends]);
    useEffect(() => {
        setHasBlast(stats.some((s) => !!s.isBlast));
    }, [stats, setHasBlast]);
    useEffect(() => {
        setHasForcePlate(stats.some((s) => !!s.isForcePlate));
    }, [stats, setHasForcePlate]);
    return (React.createElement(StyledDataPointMenu$1, { className: "position-relative" },
        showTrends && (React.createElement(StatSection$1, { id: "batting-stats-section", title: translate('components.trends.batting-stats'), selectedStats: stats, trendStats: filteredStats.filter((s) => !s.isBlast && !s.isForcePlate), selectStat: selectStat })),
        showBlast && (React.createElement(StatSection$1, { id: "blast-stats-section", title: translate('components.trends.blast-stats'), selectedStats: stats, trendStats: filteredStats.filter((s) => s.isBlast), selectStat: selectStat, className: "mt-2" })),
        showForcePlate && (React.createElement(StatSection$1, { id: "force-plate-section", title: translate('components.trends.force-plate-jumps'), selectedStats: stats, trendStats: filteredStats.filter((s) => s.isForcePlate), selectStat: selectStat, className: "mt-2" }))));
};

/* eslint-disable no-nested-ternary */
BrokenAxis(Highcharts$1);
const DAY_IN_MS = 86400000;
// Anchor date-only values at UTC midnight so chart positions do not vary by timezone.
const getDateOnlyTimestamp = (value) => Date.parse(value.slice(0, 10));
const getTrendsSeries$1 = (trendData, enableMarkers = false, opacity = 1.0, type = 'spline', showInLegend = true) => trendData.filter((td) => td.data.length).map((td) => {
    const years = [];
    for (let i = 0; i < td.data.length - 1; i++) {
        if ((new Date(td.data[i].x)).getFullYear() !== (new Date(td.data[i + 1].x)).getFullYear()) {
            years.push((new Date(td.data[i + 1].x)).getFullYear());
        }
    }
    const data = td.data.concat(years.map((y) => ({
        x: new Date(`${y}-01-01`).getTime(),
        y: null,
        name: '',
    }))).sort((a, b) => a.x - b.x);
    return Object.assign(Object.assign({}, td), { data,
        type, marker: {
            enabled: enableMarkers,
            radius: 3,
            symbol: 'circle',
        }, showInLegend, yAxis: td.scaleGroup.toString(), opacity });
});
const getTrendsData$1 = (translate, trends, blastSwings, forcePlateJumps, selectedStats, isLinear) => {
    const data = selectedStats.map((s) => ({
        id: s.id,
        name: s.name,
        scaleGroup: s.scaleGroup,
        color: s.color,
        axisMin: s.axisMin,
        axisMax: s.axisMax,
        reversed: s.reversed,
        // eslint-disable-next-line no-nested-ternary
        data: s.isBlast ? blastSwings.map((bs, i) => {
            var _a;
            return ({
                name: bs.swingdate,
                x: isLinear ? i : (new Date(bs.swingdate)).getTime(),
                y: s.transformBlastSwing ? s.transformBlastSwing(bs) : null,
                tooltip: `${dateTimeTranslate(translate, (new Date(bs.swingdate)).getTime())}<br/>${s.name}:
        ${s.formatter(s.transformBlastSwing ? (_a = s.transformBlastSwing(bs)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }) : s.isForcePlate ? forcePlateJumps.map((fp, i) => {
            var _a;
            return ({
                name: fp.testdate,
                x: isLinear ? i : getDateOnlyTimestamp(fp.testdate),
                y: s.transformForcePlate ? s.transformForcePlate(fp) : null,
                tooltip: `${date(fp.testdate)}<br />${s.name}:
        ${s.formatter(s.transformForcePlate ? (_a = s.transformForcePlate(fp)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }) : trends.filter((t) => t.pitchtype === s.pitchType).map((t, i) => {
            var _a;
            return ({
                name: t.gamedate,
                x: isLinear ? i : (new Date(t.gamedate)).getTime(),
                y: s.transformTrend ? s.transformTrend(t) : null,
                tooltip: `${dateTranslate(translate, (new Date(t.gamedate)).getTime())}<br/>${s.name}: ${s.formatter(s.transformTrend ? (_a = s.transformTrend(t)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }),
    }));
    return data;
};
const getScaleGroupMap = (data, avgPlotLines) => {
    const groupMap = {};
    data.forEach((d) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const average = (_a = avgPlotLines.find((plotLine) => plotLine.id === d.id)) === null || _a === void 0 ? void 0 : _a.value;
        const values = d.data.map((t) => t.y).filter((y) => typeof y === 'number');
        if (typeof average === 'number') {
            values.push(average);
        }
        const defaultMin = -30; // Fallback for no values
        const defaultMax = 30; // Fallback for no values
        if (groupMap[d.scaleGroup] && values.length) {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: Math.min((_c = (_b = groupMap[d.scaleGroup]) === null || _b === void 0 ? void 0 : _b.min) !== null && _c !== void 0 ? _c : Number.MAX_VALUE, (_d = d.axisMin) !== null && _d !== void 0 ? _d : Number.MAX_VALUE, ...values),
                max: Math.max((_f = (_e = groupMap[d.scaleGroup]) === null || _e === void 0 ? void 0 : _e.max) !== null && _f !== void 0 ? _f : Number.MIN_VALUE, (_g = d.axisMax) !== null && _g !== void 0 ? _g : Number.MIN_VALUE, ...values),
                reversed: d.reversed,
            };
        }
        else {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: values.length ? Math.min(...values) : ((_h = d.axisMin) !== null && _h !== void 0 ? _h : defaultMin),
                max: values.length ? Math.max(...values) : ((_j = d.axisMax) !== null && _j !== void 0 ? _j : defaultMax),
                reversed: d.reversed,
            };
        }
    });
    return groupMap;
};
const getPlotLineLabelAlign = (index, count) => {
    if (count === 1)
        return 'right';
    if (index === 0)
        return 'left';
    if (index === count - 1)
        return 'right';
    return 'center';
};
const getPlotLine = (translate, selectedStats, trends, blastSwings, forcePlateJumps) => selectedStats.map((s, index) => {
    var _a, _b, _c;
    return ({
        id: s.id,
        value: s.isBlast && blastSwings !== undefined ? (s.transformBlastSwing ? (_a = s.transformBlastSwing(blastSwings)) !== null && _a !== void 0 ? _a : undefined : undefined)
            : (s.isForcePlate && forcePlateJumps !== undefined ? (s.transformForcePlate ? (_b = s.transformForcePlate(forcePlateJumps)) !== null && _b !== void 0 ? _b : undefined : undefined)
                : (s.transformTrend && trends !== undefined ? (_c = s.transformTrend(trends)) !== null && _c !== void 0 ? _c : undefined : undefined)),
        color: s.color,
        dashStyle: 'Dash',
        zIndex: 2,
        label: {
            text: `${s.name} ${translate('components.trends.positional-average')}`,
            align: getPlotLineLabelAlign(index, selectedStats.length),
        },
        labels: { clip: false },
    });
});
const getBreaks$1 = (trendData) => {
    const breaks = [];
    const allDates = trendData.reduce((all, td) => all.concat(td.data.map((d) => new Date(d.x))), []).sort((a, b) => a.getTime() - b.getTime());
    for (let i = 0; i < allDates.length - 1; i++) {
        if (allDates[i].getFullYear() !== allDates[i + 1].getFullYear()) {
            breaks.push({
                from: allDates[i].getTime(),
                to: allDates[i + 1].getTime(),
                breakSize: (allDates[i + 1].getTime() - allDates[i].getTime()) / 5,
            });
        }
    }
    return breaks;
};
const TrendsChart$1 = ({ isLoading, showLevelChanges, showAdjustments, trends, blastSwings, forcePlateJumps, forcePlateJumpsAvg, forcePlateScatter, levelChanges, adjustments, selectedStats, setSelectedStats, height = 600, enableMarkers, connectNulls = true, linearXAxis = false, hasContinuousTimeAxis = false, highlightDateRange, }) => {
    var _a;
    const { t: translate } = useTranslation();
    const SCALE_GROUP_FORMAT_MAP = {
        [SCALE_GROUP.OPS]: (v) => format(v, true),
        [SCALE_GROUP.PERCENT]: (v) => percent(v, 1),
        [SCALE_GROUP.VELOCITY]: (v) => `${translate('format.abbr-mph', { value: format(v, 1) })}`,
        [SCALE_GROUP.DEGREES]: (v) => `${format(v, 1)}°`,
        [SCALE_GROUP.SCORE]: (v) => format(v, 1),
        [SCALE_GROUP.WEIGHT]: (v) => `${format(v, 0)}`,
        [SCALE_GROUP.FORCE]: (v) => `${format(v, 0)}`,
        [SCALE_GROUP.VELOCITY_METRIC]: (v) => `${format(v, 2)}`,
        [SCALE_GROUP.POWER]: (v) => `${format(v, 0)}`,
        [SCALE_GROUP.BODYWEIGHTS]: (v) => format(v, 2),
        [SCALE_GROUP.PERCENT_DIFF]: (v) => format(v, 0),
    };
    const SCALE_GROUP_LABEL_MAP = {
        [SCALE_GROUP.OPS]: translate('components.trends.abbr-ops'),
        [SCALE_GROUP.PERCENT]: translate('components.trends.percent'),
        [SCALE_GROUP.VELOCITY]: translate('components.trends.velocity'),
        [SCALE_GROUP.DEGREES]: translate('components.trends.degrees'),
        [SCALE_GROUP.SCORE]: translate('components.trends.decision-score'),
        [SCALE_GROUP.INCHES]: translate('components.trends.inches'),
        [SCALE_GROUP.MILLISECONDS]: translate('components.trends.milliseconds'),
        [SCALE_GROUP.BARREL_RELEASE_EFFICIENCY]: translate('components.trends.barrel-release-efficiency'),
        [SCALE_GROUP.STAB_INDEX]: translate('components.trends.stab-index'),
        [SCALE_GROUP.WEIGHT]: translate('components.trends.weight-with-units'),
        [SCALE_GROUP.FORCE]: translate('components.trends.force-with-units'),
        [SCALE_GROUP.VELOCITY_METRIC]: translate('components.trends.velocity-with-units'),
        [SCALE_GROUP.POWER]: translate('components.trends.power-with-units'),
        [SCALE_GROUP.BODYWEIGHTS]: translate('components.trends.bodyweights'),
        [SCALE_GROUP.PERCENT_DIFF]: translate('components.trends.percent-diff'),
    };
    const data = getTrendsData$1(translate, trends, blastSwings, forcePlateJumps, selectedStats, linearXAxis);
    const scatterData = getTrendsData$1(translate, [], [], forcePlateScatter, selectedStats, linearXAxis);
    const avgPlotLines = getPlotLine(translate, selectedStats, undefined, undefined, forcePlateJumpsAvg);
    const hasAveragePlotLine = avgPlotLines.some((plotLine) => typeof plotLine.value === 'number');
    const groupMap = getScaleGroupMap(data.map((series, index) => (Object.assign(Object.assign({}, series), { data: series.data.concat(scatterData[index].data) }))), avgPlotLines);
    const chartConfig = {
        title: {
            text: undefined,
        },
        chart: {
            type: 'spline',
            height,
            spacingTop: highlightDateRange ? 48 : (hasAveragePlotLine ? 20 : undefined),
        },
        series: [...getTrendsSeries$1(data, enableMarkers), ...getTrendsSeries$1(scatterData, true, 0.25, 'scatter', false)],
        plotOptions: {
            spline: {
                connectNulls,
                lineWidth: 3,
            },
            series: {
                events: {
                    hide(v) {
                        setSelectedStats(selectedStats.filter((s) => s.id !== v.target.options.id));
                    },
                },
            },
        },
        xAxis: {
            type: linearXAxis ? 'linear' : 'datetime',
            tickPixelInterval: linearXAxis ? undefined : 150,
            plotLines: (showLevelChanges ? levelChanges.map((lc) => ({
                value: new Date(lc.gamedate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: lc.level_abbr,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                },
            })) : []).concat(showAdjustments ? adjustments.map((adj) => ({
                value: new Date(adj.adoptiondate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: `<div title="${adj.description}">${adj.category}</div>`,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                    useHTML: true,
                },
            })) : []),
            labels: linearXAxis ? {} : {
                style: { textOverflow: 'none' },
                formatter() {
                    return date(this.value);
                },
            },
            breaks: hasContinuousTimeAxis ? undefined : getBreaks$1(data),
            plotBands: highlightDateRange ? [{
                    from: getDateOnlyTimestamp(highlightDateRange.startDate),
                    to: getDateOnlyTimestamp(highlightDateRange.endDate) + DAY_IN_MS,
                    color: 'rgba(0, 46, 96, 0.08)',
                    label: {
                        text: highlightDateRange.label,
                        style: {
                            color: '#002E60',
                            fontWeight: 'bold',
                        },
                        verticalAlign: 'top',
                        y: -24,
                    },
                }] : undefined,
        },
        yAxis: Object.entries(groupMap).sort(([key1], [key2]) => +key1 - +key2).map(([key, value], index) => {
            var _a;
            return ({
                id: key.toString(),
                title: {
                    text: (_a = SCALE_GROUP_LABEL_MAP[+key]) !== null && _a !== void 0 ? _a : '',
                },
                min: value.min,
                max: value.max,
                reversed: value.reversed,
                opposite: !!index,
                labels: {
                    formatter() {
                        var _a, _b, _c, _d;
                        return (_d = (SCALE_GROUP_FORMAT_MAP[+key] ? (_b = (_a = SCALE_GROUP_FORMAT_MAP[+key](this.value)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '' : (_c = this.value) === null || _c === void 0 ? void 0 : _c.toString())) !== null && _d !== void 0 ? _d : '';
                    },
                },
                plotLines: avgPlotLines.filter((pl) => pl.id === value.id),
            });
        }),
        tooltip: {
            formatter() {
                return this.point.tooltip;
            },
        },
    };
    return (React.createElement("div", { className: "position-relative" }, isLoading ? (React.createElement("div", { className: "position-absolute d-flex justify-content-center align-items-center py-5", style: { inset: 0 } },
        React.createElement(LoadingSpinner$1, null)))
        : (((_a = chartConfig.series) === null || _a === void 0 ? void 0 : _a.length)
            ? React.createElement(BaseChart, { immutable: true, options: chartConfig })
            : React.createElement("div", { className: "text-muted py-5 fs-6 d-flex justify-content-center" }, "No Data Available."))));
};

const Trends = (_a) => {
    var { isLoading, initialShowLevelChange = true, initialShowAdjustments = true, trends, blastSwings, forcePlateJumps, forcePlateJumpsAvg, forcePlateScatter = [], levelChanges, adjustments, dateRange, setDateRange, setHasTrends, setHasBlast, setHasForcePlate, showTrends = true, showBlast = true, showForcePlate = false, showBatTracking = false, enableMarkers, dateOptions, disableDisplayOptions = false, connectNulls = true, defaultStatId, height = 800, marginBottom = 600, suppressOptions, linearXAxis = false, hasContinuousTimeAxis = false, highlightDateRange } = _a, rest = __rest(_a, ["isLoading", "initialShowLevelChange", "initialShowAdjustments", "trends", "blastSwings", "forcePlateJumps", "forcePlateJumpsAvg", "forcePlateScatter", "levelChanges", "adjustments", "dateRange", "setDateRange", "setHasTrends", "setHasBlast", "setHasForcePlate", "showTrends", "showBlast", "showForcePlate", "showBatTracking", "enableMarkers", "dateOptions", "disableDisplayOptions", "connectNulls", "defaultStatId", "height", "marginBottom", "suppressOptions", "linearXAxis", "hasContinuousTimeAxis", "highlightDateRange"]);
    const { t: translate } = useTranslation();
    const defaultStat = TRENDS_STATS(translate, showBatTracking).filter((st) => {
        if (defaultStatId)
            return st.id === defaultStatId;
        if (showForcePlate && !showTrends)
            return (st.id === 'peakvelo' || st.id === 'mass');
        return st.id === 'hfx';
    });
    const [showLevelChanges, setShowLevelChanges] = useState(initialShowLevelChange);
    const [showAdjustments, setShowAdjustments] = useState(initialShowAdjustments);
    const [selectedStats, setSelectedStats] = useState(defaultStat);
    const trendsWithPitchPercentage = trends.map((t) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, t), { pitchpercentage: t.pitchtype ? t.pitches / ((_b = (_a = trends.find((x) => x.gameid === t.gameid && x.pitchtype === null)) === null || _a === void 0 ? void 0 : _a.pitches) !== null && _b !== void 0 ? _b : 1) : null }));
    });
    return (React.createElement("div", Object.assign({ className: "border rounded p-3 mt-3 bg-white d-flex position-relative", style: { height, marginBottom } }, rest),
        React.createElement(DataPointMenu$1, { stats: selectedStats, setStats: setSelectedStats, trends: trendsWithPitchPercentage, blastSwings: blastSwings, forcePlateJumps: forcePlateJumps, setHasTrends: setHasTrends, setHasBlast: setHasBlast, setHasForcePlate: setHasForcePlate, showTrends: showTrends, showBlast: showBlast, showForcePlate: showForcePlate, showBatTracking: showBatTracking }),
        React.createElement("div", { className: "flex-grow-1" },
            !suppressOptions && (React.createElement("div", { className: "mb-5" },
                React.createElement("div", { className: "d-flex justify-content-center position-absolute", style: { inset: 'auto 0' } },
                    React.createElement(DateRangeButtonGroup, { value: dateRange, onChange: setDateRange, dateOptions: dateOptions })),
                !disableDisplayOptions && (React.createElement("div", { className: "position-absolute end-0 mt-1" },
                    React.createElement(ChartDisplayOptions, { showLevelChanges: showLevelChanges, setShowLevelChanges: setShowLevelChanges, showAdjustments: showAdjustments, setShowAdjustments: setShowAdjustments }))))),
            React.createElement("div", null,
                React.createElement(TrendsChart$1, { isLoading: isLoading, showLevelChanges: showLevelChanges, showAdjustments: showAdjustments, trends: trendsWithPitchPercentage, blastSwings: blastSwings, levelChanges: levelChanges, adjustments: adjustments, selectedStats: selectedStats, setSelectedStats: setSelectedStats, forcePlateJumps: forcePlateJumps, forcePlateJumpsAvg: forcePlateJumpsAvg, forcePlateScatter: forcePlateScatter, enableMarkers: enableMarkers, connectNulls: connectNulls, linearXAxis: linearXAxis, hasContinuousTimeAxis: hasContinuousTimeAxis, highlightDateRange: highlightDateRange })))));
};

var ScaleGroup;
(function (ScaleGroup) {
    ScaleGroup[ScaleGroup["PERCENT"] = 0] = "PERCENT";
    ScaleGroup[ScaleGroup["ERA"] = 1] = "ERA";
    ScaleGroup[ScaleGroup["SCORE"] = 2] = "SCORE";
    ScaleGroup[ScaleGroup["VELOCITY"] = 3] = "VELOCITY";
    ScaleGroup[ScaleGroup["DEGREES"] = 4] = "DEGREES";
    ScaleGroup[ScaleGroup["INCHES"] = 5] = "INCHES";
    ScaleGroup[ScaleGroup["FEET"] = 6] = "FEET";
    ScaleGroup[ScaleGroup["SPIN_RATE"] = 7] = "SPIN_RATE";
})(ScaleGroup || (ScaleGroup = {}));

const chartColors = [
    '#3366cc',
    '#dc3912',
    '#ff9900',
    '#109618',
    '#990099',
    '#0099c6',
    '#dd4477',
    '#66aa00',
    '#b82e2e',
    '#316395',
    '#994499',
    '#22aa99',
    '#aaaa11',
    '#6633cc',
    '#e67300',
    '#8b0707',
    '#651067',
    '#329262',
    '#5574a6',
    '#3b3eac',
    '#b77322',
    '#16d620',
    '#b91383',
    '#f4359e',
    '#9c5935',
    '#a9c413',
    '#2a778d',
    '#668d1c',
    '#bea413',
    '#0c5922',
    '#743411',
];
const hitfxERA = (rvhitfxpit, pawrv) => {
    if (!pawrv)
        return null;
    return 4.6062 + ((rvhitfxpit / pawrv) * 37.42133) + ((Math.pow((rvhitfxpit / pawrv), 2)) * 88.77471);
};
const pitchfxERA = (rvpitchfx, pitchfxwrv) => {
    const r = ratio(rvpitchfx, pitchfxwrv);
    if (r)
        return 4.4695 + (-136.900000 * r);
    return null;
};
const rvPer100BIP = (rv, bip) => normalize(rv, bip, 100);
const TREND_STATS = (pitchTypes, translate) => [{
        id: 'era',
        name: translate('components.pitcher-trends.era'),
        transformTrend: (t) => era(t.er, t.outs),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'outs',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'hitfxera',
        name: translate('components.pitcher-trends.hitfxera'),
        transformTrend: (t) => hitfxERA(t.rvhitfxpitalt, t.pawrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pawrv',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'pitchfxera',
        name: translate('components.pitcher-trends.pitchfxera'),
        transformTrend: (t) => pitchfxERA(t.rvpitchfx, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'breakera',
        name: translate('components.pitcher-trends.breakera'),
        transformTrend: (t) => pitchfxERA(t.rvpitchfxbreak, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'stuffera',
        name: translate('components.pitcher-trends.stuffera'),
        transformTrend: (t) => pitchfxERA(t.rvpitchfxstuff, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'ncaabreakera',
        name: translate('components.pitcher-trends.ncaabreakera'),
        transformTrend: (t) => pitchfxERA(t.rvbreak_ncaa, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'ncaastuffera',
        name: translate('components.pitcher-trends.ncaastuffera'),
        transformTrend: (t) => pitchfxERA(t.rvstuff_ncaa, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'contactresults',
        name: translate('components.pitcher-trends.contactresults'),
        transformTrend: (t) => rvPer100BIP(t.rvhitfxactualbip, t.biprvdenom),
        formatter: (v) => (v ? format(v, 1) : null),
        keyField: 'biprvdenom',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SCORE,
    }, {
        id: 'contactquality',
        name: translate('components.pitcher-trends.contactquality'),
        transformTrend: (t) => rvPer100BIP(t.rvhitfxpitbip, t.biprvdenom),
        formatter: (v) => (v ? format(v, 1) : null),
        keyField: 'biprvdenom',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SCORE,
    }, {
        id: 'exitvelo',
        name: translate('components.pitcher-trends.exitvelo'),
        transformTrend: (t) => ratio(t.hitvelocity, t.pawhitvelocity),
        formatter: (v) => format(v, 1),
        keyField: 'pawhitvelocity',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.VELOCITY,
    }, {
        id: 'vertlaunchangle',
        name: translate('components.pitcher-trends.vertlaunchangle'),
        transformTrend: (t) => ratio(t.vertla, t.pawhitvelocity),
        formatter: (v) => format(v, 1),
        keyField: 'hitvelocity90',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'wellhitpct',
        name: translate('components.pitcher-trends.wellhitpct'),
        transformTrend: (t) => ratio(t.wellhit, t.pawhitfx),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pawhitfx',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'gbpct',
        name: translate('components.pitcher-trends.gbpct'),
        transformTrend: (t) => ratio(t.gb, t.ld + t.gb + t.fb + t.pop),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'gb',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'poppct',
        name: translate('components.pitcher-trends.poppct'),
        transformTrend: (t) => ratio(t.pop, t.ld + t.gb + t.fb + t.pop),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pop',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'gbpullpct',
        name: translate('components.pitcher-trends.gbpullpct'),
        transformTrend: (t) => ratio(t.gbpull, t.gbpull + t.gbaway),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'flypullpct',
        name: translate('components.pitcher-trends.flypullpct'),
        transformTrend: (t) => ratio((t.fbpull + t.ldpull + t.poppull), (t.fbpull + t.fbaway + t.ldpull + t.ldaway + t.poppull + t.popaway)),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'firstpstk',
        name: translate('components.pitcher-trends.firstpstk'),
        transformTrend: (t) => ratio(t.firstpstk, t.firstp),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'firstp',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'stkpct',
        name: translate('components.pitcher-trends.stkpct'),
        transformTrend: (t) => ratio(t.strikes, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'calledstkpct',
        name: translate('components.pitcher-trends.calledstkpct'),
        transformTrend: (t) => ratio(t.tkstk, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'swingingstkpct',
        name: translate('components.pitcher-trends.swingingstkpct'),
        transformTrend: (t) => ratio(t.swinging, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'foulpct',
        name: translate('components.pitcher-trends.foulpct'),
        transformTrend: (t) => ratio(t.foul, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'inplaypct',
        name: translate('components.pitcher-trends.inplaypct'),
        transformTrend: (t) => ratio(t.inplay, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'kzon',
        name: translate('components.pitcher-trends.kzon'),
        transformTrend: (t) => ratio(t.inz, t.inz + t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'inz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'kzon2k',
        name: translate('components.pitcher-trends.kzonlessthan2k'),
        transformTrend: (t) => ratio(t.inzl2k, t.inzl2k + t.outzl2k),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'inzl2k',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'closepitchpct',
        name: translate('components.pitcher-trends.closepitchpct'),
        transformTrend: (t) => ratio(t.closepitch, t.pitwspsz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitwspsz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'wastepitchpct',
        name: translate('components.pitcher-trends.wastepitchpct'),
        transformTrend: (t) => ratio(t.noncomppitches, t.pitwspsz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitwspsz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'swpct',
        name: translate('components.pitcher-trends.swpct'),
        transformTrend: (t) => ratio(t.sw, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'swinzpct',
        name: translate('components.pitcher-trends.swinzpct'),
        transformTrend: (t) => ratio(t.swinz, t.inz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'inz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'chpct',
        name: translate('components.pitcher-trends.chpct'),
        transformTrend: (t) => ratio(t.ch, t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'outz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'mspct',
        name: translate('components.pitcher-trends.mspct'),
        transformTrend: (t) => ratio(t.sw - t.cn, t.sw),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'sw',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'mschpct',
        name: translate('components.pitcher-trends.mschpct'),
        transformTrend: (t) => ratio(t.swoutz - t.cnoutz, t.swoutz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'swoutz',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'sopct',
        name: translate('components.pitcher-trends.sopct'),
        transformTrend: (t) => ratio(t.so, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pa',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'ubbpct',
        name: translate('components.pitcher-trends.ubbpct'),
        transformTrend: (t) => ratio(t.ubb, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pa',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'pitchPerc',
        name: translate('components.pitcher-trends.pitch-percent'),
        transformTrend: (t) => ratio(t.pitches, t.totalpitches),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'totalpitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'velocity',
        name: translate('components.pitcher-trends.velocity'),
        transformTrend: (t) => ratio(t.velocity, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.VELOCITY,
    }, {
        id: 'pitchup',
        name: translate('components.pitcher-trends.pitchup'),
        transformTrend: (t) => ratio(t.pitchup, t.pitches),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'pitchin',
        name: translate('components.pitcher-trends.pitchin'),
        transformTrend: (t) => ratio(t.pitchin, t.pitches),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'msinzpct',
        name: translate('components.pitcher-trends.msinzpct'),
        transformTrend: (t) => ratio(t.swinz - t.cninz, t.swinz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'swinz',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'kopppct',
        name: translate('components.pitcher-trends.put-away-pct'),
        transformTrend: (t) => ratio(t.so, t.kopp),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'kopp',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'breakx',
        name: translate('components.pitcher-trends.breakx'),
        transformTrend: (t) => ratio(t.breakx, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'breakz',
        name: translate('components.pitcher-trends.breakz'),
        transformTrend: (t) => ratio(t.breakz, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'ncaabreakx',
        name: translate('components.pitcher-trends.ncaabreakx'),
        transformTrend: (t) => ratio(t.ncaabreakxadj, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'ncaabreakz',
        name: translate('components.pitcher-trends.ncaabreakz'),
        transformTrend: (t) => ratio(t.ncaabreakzadj, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'spinrate',
        name: translate('components.pitcher-trends.spinrate'),
        transformTrend: (t) => ratio(t.spinrate, t.pitches),
        formatter: (v) => format(v, 0),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SPIN_RATE,
    }, {
        id: 'extension',
        name: translate('components.pitcher-trends.extension'),
        transformTrend: (t) => ratio(t.extension, t.pitches),
        formatter: (v) => format(v, 2),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.FEET,
    }, {
        id: 'gyrodegree',
        name: translate('components.pitcher-trends.gyrodegree'),
        transformTrend: (t) => ratio(t.gyrodegree, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'initposx',
        name: translate('components.pitcher-trends.initposx'),
        transformTrend: (t) => ratio(t.initposx, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.FEET,
    }, {
        id: 'initposz',
        name: translate('components.pitcher-trends.initposz'),
        transformTrend: (t) => ratio(t.initposz, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.FEET,
    }, {
        id: 'armangle',
        name: translate('components.pitcher-trends.armangle'),
        transformTrend: (t) => ratio(t.armangle, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'rvera',
        name: translate('components.pitcher-trends.rvera'),
        transformTrend: (t) => pitchfxERA(t.rvactual, t.pitchfxwrv),
        formatter: (v) => format(v, 2),
        keyField: 'pitchfxwrv',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'ervera',
        name: translate('components.pitcher-trends.ervera'),
        transformTrend: (t) => pitchfxERA(t.rvexp, t.pitchfxwrv),
        formatter: (v) => format(v, 2),
        keyField: 'pitchfxwrv',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'locera',
        name: translate('components.pitcher-trends.locera'),
        transformTrend: (t) => pitchfxERA(t.rvloc, t.pitchfxwrv),
        formatter: (v) => format(v, 2),
        keyField: 'pitchfxwrv',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'head',
        name: translate('components.pitcher-trends.head'),
        // eslint-disable-next-line no-nested-ternary
        transformTrend: (t) => (t.pitchtype === -1 ? ratio(t.fbhead + t.nfbhead, t.pwfbhead + t.pwnfbhead) : (t.pitchtype === 9 || t.pitchtype === 10 ? ratio(t.fbhead, t.pwfbhead) : ratio(t.nfbhead, t.pwnfbhead))),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'hbat',
        name: translate('components.pitcher-trends.hbat'),
        transformTrend: (t) => ratio(t.hbat, t.pwhbat),
        formatter: (v) => format(v, 2),
        keyField: 'pwhbat',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'vbat',
        name: translate('components.pitcher-trends.vbat'),
        transformTrend: (t) => ratio(t.vbat, t.pwvbat),
        formatter: (v) => format(v, 2),
        keyField: 'pwvbat',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'baraccbip',
        name: translate('components.pitcher-trends.baraccbip'),
        transformTrend: (t) => rvPerN(t.barracc, t.pawbarracc, 100),
        formatter: (v) => format(v, 1),
        keyField: 'pwvbat',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SCORE,
    }].reduce((all, ts) => all.concat([
    ...(ts.isOverall ? [{
            id: ts.id,
            name: ts.name,
            statName: ts.name,
            transformTrend: ts.transformTrend,
            formatter: ts.formatter,
            keyField: ts.keyField,
            pitchType: -1,
            scaleGroup: ts.scaleGroup,
        }] : []),
    ...(ts.isByPitchType ? pitchTypes.map((pt) => ({
        id: `${ts.id}-${pt}`,
        statName: ts.name,
        name: `${ts.name} - ${pitchTypeOrSubType(pt, true, '', translate)}`,
        transformTrend: ts.transformTrend,
        formatter: ts.formatter,
        keyField: ts.keyField,
        pitchType: pt,
        scaleGroup: ts.scaleGroup,
    })) : []),
]), []).reduce((all, ts) => all.concat([-1, 0, 1].map((islhb) => (Object.assign(Object.assign({}, ts), { id: `${ts.id}-${islhb}`, name: `${ts.name}${{
        [-1]: '',
        0: ` ${translate('baseball.abbr-versus')} ${translate('baseball.abbr-right')}`,
        1: ` ${translate('baseball.abbr-versus')} ${translate('baseball.abbr-left')}`,
    }[islhb]}`, islhb })))), []).map((ts, index) => (Object.assign(Object.assign({}, ts), { color: chartColors[index % chartColors.length] })));

const StyledDataPointMenu = styled.div `
    font-size: 0.875rem;
    width: 200px;
    z-index: 1;
    flex-shrink: 0;
    max-height: calc(100% - 56px);
    position: relative;
`;
const GroupTitle = styled.h5 `
    padding: 4px 0 !important;
    color: ${theme.fontColors.darkBlue};
    margin-bottom: 0 !important;
    font-size: 13.75px !important;
`;
const StyledClearButton = styled.div `&& {
    margin-left: -20px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${searchReset}) no-repeat center;
}`;
const StyledStat$2 = styled.div `
    display: flex;
    align-items: center;
    color: ${(props) => (props.$disabled ? theme.fontColors.tundora : theme.fontColors.darkBlue)};
    border: 1px solid ${(props) => props.$borderColor};
    background-color: ${(props) => (props.$disabled ? '#d4d4d4' : 'white')};
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    margin-right: 4px;
    font-size: 0.75rem;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        color: white;
        background-color: ${theme.background.cerulean};
    }
`;
const StyledColorMarker = styled.div `
    background-color: ${(props) => props.$color};
    height: 8px;
    width: 8px;
    border-radius: 9999px;
    flex-shrink: 0;
`;
const StatSection = ({ id, title, trendStats, selectedStats, selectStat, className }) => {
    const { t: translate } = useTranslation();
    const [query, setQuery] = useState('');
    const [scrolledToStart, setScrolledToStart] = useState(false);
    const count = trendStats.filter((ts) => selectedStats.some((ss) => ts.id === ss.id)).length;
    const filteredTrendStats = trendStats.filter((ts) => !query || ts.name.toLowerCase().includes(query.toLowerCase()));
    useEffect(() => {
        if (trendStats && !scrolledToStart && selectedStats.length) {
            const statsInSection = selectedStats.filter((ss) => trendStats.some((ts) => ts.id === ss.id));
            const firstSelectedId = statsInSection.length ? statsInSection[0].id : null;
            if (firstSelectedId) {
                const firstSelectedElement = document.getElementById(`selected-stat-${firstSelectedId}`);
                const wrapperElement = document.getElementById(id);
                if (firstSelectedElement) {
                    wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.scrollTo({ top: (firstSelectedElement === null || firstSelectedElement === void 0 ? void 0 : firstSelectedElement.offsetTop) - firstSelectedElement.getBoundingClientRect().height - 37 });
                    setScrolledToStart(true);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trendStats]);
    return (React.createElement("div", { className: `border-bottom d-flex flex-column ${className}`, style: { maxHeight: '100%' } },
        React.createElement(GroupTitle, null,
            title,
            " (",
            count,
            ")"),
        React.createElement("div", { className: "d-flex align-items-center" },
            React.createElement(Form.Control, { placeholder: `${translate('common.filter')} ${title}...`, size: "sm", value: query, onChange: (e) => setQuery(e.target.value), style: { fontSize: 12, marginBottom: 2 } }),
            query.length > 0 && React.createElement(StyledClearButton, { onClick: () => setQuery('') })),
        React.createElement("div", { className: "overflow-auto flex-grow-1", id: id }, filteredTrendStats.map((s) => {
            const disabled = !selectedStats.some((ss) => ss.id === s.id);
            return (React.createElement(StyledStat$2, { key: s.id, onClick: () => selectStat(s), "$disabled": disabled, "$borderColor": disabled ? theme.fontColors.silverChalice : s.color, className: "mt-1", id: `selected-stat-${s.id}` },
                React.createElement(StyledColorMarker, { "$color": disabled ? theme.fontColors.silverChalice : s.color, className: "me-2" }),
                s.name));
        }))));
};
const DataPointMenu = ({ trends, stats, setStats, pitchTypes }) => {
    const { t: translate } = useTranslation();
    const filteredStats = TREND_STATS(pitchTypes, translate).filter((ts) => ts.keyField === undefined
        || trends.some((t) => ts.pitchType === t.pitchtype && !!ts.keyField && !!t[ts.keyField]))
        .sort((a, b) => {
        if (a.statName !== b.statName)
            return a.statName.localeCompare(b.statName);
        if (a.pitchType !== b.pitchType)
            return a.pitchType - b.pitchType;
        return a.islhb - b.islhb;
    });
    const selectStat = (ts) => {
        setStats(stats.some((s) => s.id === ts.id)
            ? stats.filter((s) => s.id !== ts.id)
            : [
                ...stats,
                ts,
            ]);
    };
    return (React.createElement(StyledDataPointMenu, null,
        React.createElement(StatSection, { id: "overall-section", title: translate('components.pitcher-trends.pitching-stats'), selectedStats: stats, trendStats: filteredStats, selectStat: selectStat })));
};

/* eslint-disable no-nested-ternary */
BrokenAxis(Highcharts$1);
// eslint-disable-next-line max-len
const getTrendsSeries = (trendData, enableMarkers = false, opacity = 1.0, type = 'spline', showInLegend = true) => trendData.map((td) => {
    const years = [];
    for (let i = 0; i < td.data.length - 1; i++) {
        if ((new Date(td.data[i].x)).getFullYear() !== (new Date(td.data[i + 1].x)).getFullYear()) {
            years.push((new Date(td.data[i + 1].x)).getFullYear());
        }
    }
    const data = td.data.concat(years.map((y) => ({
        x: new Date(`${y}-01-01`).getTime(),
        y: null,
        name: '',
    }))).sort((a, b) => a.x - b.x);
    return Object.assign(Object.assign({}, td), { data,
        type, marker: {
            enabled: enableMarkers,
            radius: 3,
            symbol: 'circle',
        }, showInLegend, yAxis: td.scaleGroup.toString(), opacity });
});
// eslint-disable-next-line max-len
const getTrendsData = (translate, trends, selectedStats) => {
    const data = selectedStats.map((s) => ({
        id: s.id,
        name: s.name,
        scaleGroup: s.scaleGroup,
        color: s.color,
        axisMin: s.axisMin,
        axisMax: s.axisMax,
        reversed: s.reversed,
        // eslint-disable-next-line no-nested-ternary
        data: trends.filter((t) => t.pitchtype === s.pitchType && t.islhb === s.islhb).map((t) => {
            var _a;
            return ({
                name: t.gamedate,
                x: (new Date(t.gamedate)).getTime(),
                y: s.transformTrend ? s.transformTrend(t) : null,
                // eslint-disable-next-line max-len
                tooltip: `${dateTranslate(translate, (new Date(t.gamedate)).getTime())}<br/>${s.name}: ${s.formatter(s.transformTrend ? (_a = s.transformTrend(t)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }),
    }));
    const groupMap = {};
    data.forEach((d) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const values = d.data.map((t) => t.y).filter((y) => !!y);
        if (groupMap[d.scaleGroup] && values.length) {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: Math.min((_b = (_a = groupMap[d.scaleGroup]) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : Number.MAX_VALUE, (_c = d.axisMin) !== null && _c !== void 0 ? _c : Number.MAX_VALUE, ...values),
                max: Math.max((_e = (_d = groupMap[d.scaleGroup]) === null || _d === void 0 ? void 0 : _d.max) !== null && _e !== void 0 ? _e : Number.MIN_VALUE, (_f = d.axisMax) !== null && _f !== void 0 ? _f : Number.MIN_VALUE, ...values),
                reversed: d.reversed,
            };
        }
        else {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: Math.min((_g = d.axisMin) !== null && _g !== void 0 ? _g : Number.MAX_VALUE, ...values),
                max: Math.max((_h = d.axisMax) !== null && _h !== void 0 ? _h : Number.MIN_VALUE, ...values),
                reversed: d.reversed,
            };
        }
    });
    return { data: data.filter((d) => d.data.length), groupMap };
};
const getBreaks = (trendData) => {
    const breaks = [];
    const allDates = trendData.reduce((all, td) => all.concat(td.data.map((d) => new Date(d.x))), []).sort((a, b) => a.getTime() - b.getTime());
    for (let i = 0; i < allDates.length - 1; i++) {
        if (allDates[i].getFullYear() !== allDates[i + 1].getFullYear()) {
            breaks.push({
                from: allDates[i].getTime(),
                to: allDates[i + 1].getTime(),
                breakSize: (allDates[i + 1].getTime() - allDates[i].getTime()) / 5,
            });
        }
    }
    return breaks;
};
const TrendsChart = ({ isLoading, showLevelChanges, showAdjustments, trends, levelChanges, adjustments, selectedStats, setSelectedStats, height = 600, enableMarkers, connectNulls = true, }) => {
    var _a;
    const { t: translate } = useTranslation();
    const SCALE_GROUP_FORMAT_MAP = {
        [ScaleGroup.PERCENT]: (v) => percent(v, 1),
        [ScaleGroup.SCORE]: (v) => format(v, 1),
        [ScaleGroup.ERA]: (v) => format(v, 2),
        [ScaleGroup.VELOCITY]: (v) => `${translate('format.abbr-mph', { value: format(v, 1) })}`,
        [ScaleGroup.DEGREES]: (v) => `${format(v, 1)}°`,
        [ScaleGroup.INCHES]: (v) => `${format(v, 1)}in`,
        [ScaleGroup.FEET]: (v) => `${format(v, 2)}ft`,
        [ScaleGroup.SPIN_RATE]: (v) => `${format(v, 0)}rpm`,
    };
    const SCALE_GROUP_LABEL_MAP = {
        [ScaleGroup.PERCENT]: translate('components.trends.percent'),
        [ScaleGroup.SCORE]: translate('components.trends.decision-score'),
        [ScaleGroup.ERA]: translate('components.trends.era'),
        [ScaleGroup.VELOCITY]: translate('components.trends.velocity'),
        [ScaleGroup.DEGREES]: translate('components.trends.degrees'),
        [ScaleGroup.INCHES]: translate('components.trends.inches'),
        [ScaleGroup.FEET]: translate('components.trends.feet'),
        [ScaleGroup.SPIN_RATE]: translate('components.trends.spin-rate'),
    };
    const { data, groupMap } = getTrendsData(translate, trends, selectedStats);
    const chartConfig = {
        title: {
            text: undefined,
        },
        chart: {
            type: 'spline',
            height,
        },
        series: [...getTrendsSeries(data, enableMarkers)],
        plotOptions: {
            spline: {
                connectNulls,
                lineWidth: 3,
            },
            series: {
                events: {
                    hide(v) {
                        setSelectedStats(selectedStats.filter((s) => { var _a, _b; return s.id !== ((_b = (_a = v === null || v === void 0 ? void 0 : v.target) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.id); }));
                    },
                },
            },
        },
        xAxis: {
            type: 'datetime',
            plotLines: (showLevelChanges ? levelChanges.map((lc) => ({
                value: new Date(lc.gamedate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: lc.level_abbr,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                },
            })) : []).concat(showAdjustments ? adjustments.map((adj) => ({
                value: new Date(adj.adoptiondate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: `<div title="${adj.description}">${adj.category}</div>`,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                    useHTML: true,
                },
            })) : []),
            labels: {
                formatter() {
                    return date(this.value);
                },
            },
            breaks: getBreaks(data),
        },
        yAxis: Object.entries(groupMap).sort(([key1], [key2]) => +key1 - +key2)
            .map(([key, value], index) => {
            var _a;
            return ({
                id: key.toString(),
                title: {
                    text: (_a = SCALE_GROUP_LABEL_MAP[+key]) !== null && _a !== void 0 ? _a : '',
                },
                min: value.min,
                max: value.max,
                reversed: value.reversed,
                opposite: !!index,
                labels: {
                    formatter() {
                        var _a, _b, _c, _d;
                        return (_d = (SCALE_GROUP_FORMAT_MAP[+key] ? (_b = (_a = SCALE_GROUP_FORMAT_MAP[+key](this.value)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '' : (_c = this.value) === null || _c === void 0 ? void 0 : _c.toString())) !== null && _d !== void 0 ? _d : '';
                    },
                },
            });
        }),
        tooltip: {
            formatter() {
                return this.point.tooltip;
            },
        },
    };
    return (React.createElement("div", { className: "position-relative" }, isLoading ? (React.createElement("div", { className: "position-absolute d-flex justify-content-center align-items-center py-5", style: { inset: 0 } },
        React.createElement(LoadingSpinner$1, null)))
        : (((_a = chartConfig.series) === null || _a === void 0 ? void 0 : _a.length)
            ? React.createElement(BaseChart, { immutable: true, options: chartConfig })
            : React.createElement("div", { className: "text-muted py-5 fs-6 d-flex justify-content-center" }, "No Data Available."))));
};

const PitcherTrends = ({ isLoading, initialShowLevelChange = true, initialShowAdjustments = true, trends, pitchTypes, dateRange, setDateRange, dateOptions, levelChanges, adjustments, height = 800, }) => {
    const { t: translate } = useTranslation();
    const [selectedStats, setSelectedStats] = useState(TREND_STATS([], translate)
        .filter((ts) => ts.id === 'hitfxera--1' && ts.pitchType === -1 && ts.islhb === -1));
    const [showLevelChanges, setShowLevelChanges] = useState(initialShowLevelChange);
    const [showAdjustments, setShowAdjustments] = useState(initialShowAdjustments);
    return (React.createElement("div", { className: "border rounded p-3 mt-3 bg-white d-flex position-relative", style: { height } },
        React.createElement(DataPointMenu, { trends: trends, stats: selectedStats, setStats: setSelectedStats, pitchTypes: pitchTypes }),
        React.createElement("div", { className: "flex-grow-1" },
            React.createElement("div", { className: "mb-5" },
                React.createElement("div", { className: "d-flex justify-content-center position-absolute", style: { inset: 'auto 0' } },
                    React.createElement(DateRangeButtonGroup, { value: dateRange, onChange: setDateRange, dateOptions: dateOptions })),
                React.createElement("div", { className: "position-absolute end-0 mt-1" },
                    React.createElement(ChartDisplayOptions, { showLevelChanges: showLevelChanges, setShowLevelChanges: setShowLevelChanges, showAdjustments: showAdjustments, setShowAdjustments: setShowAdjustments }))),
            React.createElement("div", null,
                React.createElement(TrendsChart, { isLoading: isLoading, trends: trends, showLevelChanges: showLevelChanges, showAdjustments: showAdjustments, levelChanges: levelChanges, adjustments: adjustments, selectedStats: selectedStats, setSelectedStats: setSelectedStats })))));
};

const StyledMenu = styled.div `
    background-color: white;
    width: ${(props) => props.$width}px;
    height: 100%;
    border-right: 1px solid ${styles.theme.border.alto};
    overflow: auto;
    flex-shrink: 0;
`;
const StyledHeader$2 = styled.div `
    position: sticky;
    top: 0;
    background-color: white;
    height: 40px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-size: 14px;
    padding: 0 10px;
    font-weight: 700;
    color: ${styles.theme.fontColors.doveGray};
    border-bottom: 1px solid ${styles.theme.border.alto};
`;
const StyledDaySummary = styled.button `
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    padding: 10px;
    border-bottom: 1px solid ${styles.theme.border.alto};
    width: 100%;
    text-align: left;
    background-color: ${(props) => (props.$isSelected ? '#E6F5FF' : 'white')}
`;
const StyledDaySummaryTitle = styled.div `
    font-size: 16px;
    font-weight: 700;
    color: ${styles.theme.fontColors.darkBlue};
`;
const StyledDaySummarySubtitle = styled.div `
    font-weight: 700;
    font-size: 14px;
    color: ${styles.theme.fontColors.doveGray};
`;
const StyledSummaryData = styled.div `
    font-size: 13px;
    margin-top: 2px;
`;
const StyledMenuItem = styled.div `
    margin-top: 2px;
`;
const MenuItemKey = styled(StyledMenuItem) `
    font-weight: bold;
`;
const MenuItemValue = styled(StyledMenuItem) `
    color: ${styles.theme.fontColors.mineShaft}
`;
const getOpponent = (ds) => {
    if (!ds.gameid) {
        return '';
    }
    return ds.teamid === ds.hometeamid ? `VS. ${ds.awayabbr}` : `@ ${ds.homeabbr}`;
};
const Menu = ({ daySummaries, selectedDaySummaryId, setSelectedDaySummaryId, menuItemComponent: MenuItem, width = 250, hideMenuTitle }) => (React.createElement(StyledMenu, { "$width": width },
    !hideMenuTitle && (React.createElement(StyledHeader$2, null, "Workload/Mechanics")),
    daySummaries.map((ds) => (React.createElement(StyledDaySummary, { key: ds.daysummaryid, "$isSelected": selectedDaySummaryId === ds.daysummaryid, onClick: () => setSelectedDaySummaryId(ds.daysummaryid) },
        React.createElement("div", { className: "d-flex justify-content-between" },
            React.createElement(StyledDaySummaryTitle, null, date(ds.date)),
            React.createElement(StyledDaySummarySubtitle, null, getOpponent(ds))),
        React.createElement(StyledSummaryData, null,
            React.createElement(MenuItem, { daySummary: ds })))))));

const StyledStat$1 = styled.div `
    background-color: ${styles.theme.background.endeavour};
    color: white;
    border-radius: 5px;
    text-align: center;
    padding: 7px 0;
`;
const StyledLabel$1 = styled.div `
    font-size: 12px;
`;
const StyledValue$1 = styled.div `
    font-size: 24px;
    font-weight: 700;
`;
const StyledStatWrapper$1 = styled.div `
    padding: 20px;
    border-radius: 5px;
    background-color: white;
    border: 1px solid ${styles.theme.border.alto};
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(${(props) => props.$numStats / 2},minmax(0,1fr));
    @media (min-width: 992px) {
        grid-template-columns: repeat(${(props) => props.$numStats},minmax(0,1fr));
    }
`;
const Stat$1 = ({ label, value }) => (React.createElement(StyledStat$1, null,
    React.createElement(StyledLabel$1, null, label),
    React.createElement(StyledValue$1, null, value)));
const SummaryStats$1 = ({ summaryStats }) => (React.createElement(StyledStatWrapper$1, { "$numStats": summaryStats.length }, summaryStats.map((ss) => React.createElement(Stat$1, { label: ss.label, value: ss.value, key: ss.label }))));

const StyledCard = styled.div `
    padding: 20px;
    border-radius: 5px;
    background-color: white;
    border: 1px solid ${styles.theme.border.alto};
`;
const Card = ({ children }) => React.createElement(StyledCard, null, children);

const StyledCardTitle = styled.div `
    font-family: ${styles.theme.font.header};
    font-weight: 700;
    font-size: 16px;
`;
const CardTitle = ({ children }) => React.createElement(StyledCardTitle, null, children);

const StyledLegend = styled.div `
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
`;
const StyledLegendMarker = styled.div `
    height: 13px;
    width: 13px;
    background-color: ${(props) => props.$color};
    margin-right: 6px;
`;
const StyledTimelineWrapper = styled.div `
    margin: 0 -14px;
`;
const ThrowTimeline = ({ throws, showLegend }) => (React.createElement(Card, null,
    React.createElement("div", { className: "d-flex justify-content-between" },
        React.createElement(CardTitle, null, "Throw Timeline"),
        showLegend && (React.createElement(StyledLegend, null,
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement(StyledLegendMarker, { "$color": "#FF0000" }),
                "Game Throw"),
            React.createElement("div", { className: "d-flex align-items-center ms-3" },
                React.createElement(StyledLegendMarker, { "$color": "#254c75" }),
                "Other Throw")))),
    React.createElement(StyledTimelineWrapper, { className: "mt-2" },
        React.createElement(ThrowTimelineChart, { throws: throws }))));

const StyledTableWrapper = styled.div `
    font-size: 14px !important;
    text-align: center;
    &&& {
        table {
            border: 1px solid ${styles.theme.fontColors.doveGray};
            &.table thead tr th {
                background-color: white !important;
                border-top: 1px solid ${styles.theme.fontColors.doveGray};
                border-right: 1px solid ${styles.theme.fontColors.doveGray};
                border-bottom: none !important;
            }
            &.table tbody tr td {
                border-right: 1px solid ${styles.theme.fontColors.doveGray};
                box-shadow: none;
            }
            &.table tbody tr td,th {
                padding: .5rem .25rem;
            }
        }
    }
`;
const TableWrapper = ({ children, className }) => React.createElement(StyledTableWrapper, { className: className }, children);

var getInnings = (throws) => {
    const inningThrows = throws.filter((t) => t.inning);
    if (!inningThrows.length)
        return [];
    let currentInning = inningThrows[0].inning;
    let chunkIndex = 0;
    const chunks = [[inningThrows[0]]];
    for (let i = 1; i < inningThrows.length; i++) {
        const t = inningThrows[i];
        if (t.inning !== currentInning) {
            chunkIndex += 1;
            chunks[chunkIndex] = [t];
        }
        else {
            chunks[chunkIndex].push(t);
        }
        currentInning = t.inning;
    }
    return chunks;
};

var calculateInningTempo = (inning) => {
    let timeDiff = 0;
    let timeDiffCount = 0;
    for (let i = 0; i < inning.length - 1; i++) {
        timeDiff += (new Date(inning[i + 1].datetime).valueOf() - new Date(inning[i].datetime).valueOf()) / 1000;
        timeDiffCount += 1;
    }
    return { timeDiff, timeDiffCount };
};

const getRows$1 = (translate, throws) => {
    const firstWarmupIndex = throws.findIndex((t) => t.throwtype === THROW_TYPES.game || t.throwtype === THROW_TYPES.warmup);
    const innings = getInnings(throws.slice(firstWarmupIndex, throws.length));
    return innings.map((inning, index) => {
        var _a;
        const fbs = inning.filter((t) => { var _a; return [1, 9, 10].includes((_a = t.fxtype) !== null && _a !== void 0 ? _a : 0); });
        const fbRange = fbs.length
            ? `${format(Math.min(...fbs.map((t) => { var _a; return (_a = t.velocity) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER; })), 1)} – 
            ${format(Math.max(...fbs.map((t) => { var _a; return (_a = t.velocity) !== null && _a !== void 0 ? _a : Number.MIN_SAFE_INTEGER; })), 1)}`
            : '--';
        const { timeDiff, timeDiffCount } = calculateInningTempo(inning);
        let recovery;
        if (index) {
            const diff = (new Date(inning[0].datetime).valueOf() - new Date(innings[index - 1][innings[index - 1].length - 1].datetime).valueOf());
            recovery = `${format(diff / (60 * 1000), 0)}${translate('common.abbr-minute')} ${format((diff % (60 * 1000)) / 1000, 0)}${translate('common.abbr-second')}`;
        }
        else if (firstWarmupIndex > 0) {
            const diff = (new Date(inning[0].datetime).valueOf() - new Date(throws[firstWarmupIndex - 1].datetime).valueOf());
            recovery = `${format(diff / (60 * 1000), 0)}${translate('common.abbr-minute')} ${format((diff % (60 * 1000)) / 1000, 0)}${translate('common.abbr-second')}`;
        }
        return {
            inning: (_a = inning.find((t) => t.inning)) === null || _a === void 0 ? void 0 : _a.inning,
            warmups: inning.filter((t) => t.throwtype === THROW_TYPES.warmup).length,
            pitches: inning.filter((t) => t.throwtype === THROW_TYPES.game).length,
            velo: fbRange,
            tempo: timeDiffCount ? `${format(timeDiff / timeDiffCount, 1)}${translate('common.abbr-second')}` : '--',
            recovery,
        };
    });
};
const GameSummary = ({ throws }) => {
    const { t: translate } = useTranslation();
    const columns = [
        { id: 'inning', title: translate('baseball.inning'), type: COLUMN_TYPES.TEXT },
        { id: 'warmups', title: translate('components.mechanics.warmups'), type: COLUMN_TYPES.TEXT },
        { id: 'pitches', title: translate('baseball.pitches_other'), type: COLUMN_TYPES.TEXT },
        { id: 'tempo', title: translate('components.mechanics.tempo'), type: COLUMN_TYPES.TEXT },
        { id: 'recovery', title: translate('components.mechanics.recovery'), type: COLUMN_TYPES.TEXT },
        { id: 'velo', title: translate('components.mechanics.fb-velocity'), type: COLUMN_TYPES.TEXT },
    ];
    return (React.createElement(Card, null,
        React.createElement(CardTitle, null, translate('components.mechanics.game-summary')),
        React.createElement(TableWrapper, { className: "mt-3" },
            React.createElement(DataTable, { columns: columns, rows: getRows$1(translate, throws) }))));
};

const StyledHeader$1 = styled.div `
    font-weight: bold;
    font-size: 14px;
    color: ${(props) => props.$color};
`;
const StyledChartLabel = styled.div `
    font-size: 14px;
    font-weight: 400;
    color: #333333;
`;
const StyledChartBar = styled.div `
    position: absolute;
    top: 8px;
    height: 5px;
    background-color: #CECECE;
    border-radius: 9999px;
    width: 100%;
`;
const StyledBarWrapper = styled.div `
    position: relative;
    flex-grow: 1;
    height: 21px;
`;
const StyledFbMarker = styled.div `
    position: absolute;
    height: 10px;
    background-color: #FF0000;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    left: ${(props) => props.$left}%;
    width: ${(props) => props.$width}%;
`;
const StyledOffspeedMarker = styled.div `
    position: absolute;
    top: 13px;
    height: 10px;
    background-color: #005A9C;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    left: ${(props) => props.$left}%;
    width: ${(props) => props.$width}%;
`;
const getData = (magnitudes) => {
    const mean = magnitudes.reduce((sum, v) => sum + v, 0) / magnitudes.length;
    const sd = Math.sqrt(magnitudes.map((m) => Math.pow((m - mean), 2)).reduce((sum, v) => sum + v, 0) / magnitudes.length);
    return { min: mean - sd, max: mean + sd };
};
const MagnitudeChart = ({ className, throws }) => {
    const fbMagnitudes = throws.filter((t) => { var _a; return [1, 9, 10].includes((_a = t.fxtype) !== null && _a !== void 0 ? _a : 0) && t.throwtype === THROW_TYPES.game; }).map((t) => t.magnitude);
    const offspeedMagnitudes = throws.filter((t) => { var _a; return ![1, 9, 10].includes((_a = t.fxtype) !== null && _a !== void 0 ? _a : 0) && t.throwtype === THROW_TYPES.game; }).map((t) => t.magnitude);
    const fbRange = getData(fbMagnitudes);
    const offspeedRange = getData(offspeedMagnitudes);
    const min = Math.min(fbRange.min, offspeedRange.min, 700);
    const max = Math.max(fbRange.max, offspeedRange.max, 1200);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "d-flex" },
            React.createElement(StyledHeader$1, { "$color": "#FF0000", className: "d-flex justify-content-end w-50 pe-2" }, "Fastball"),
            React.createElement(StyledHeader$1, { "$color": "#005A9C", className: "w-50 ps-2" }, "Off-Speed")),
        React.createElement("div", { className: "d-flex align-items-center mt-3" },
            React.createElement(StyledChartLabel, { className: "me-2" },
                format(min),
                " deg/s"),
            React.createElement(StyledBarWrapper, null,
                React.createElement(StyledFbMarker, { "$left": (fbRange.min - min) / (max - min) * 100, "$width": (fbRange.max - fbRange.min) / (max - min) * 100 }),
                React.createElement(StyledChartBar, null),
                React.createElement(StyledOffspeedMarker, { "$left": (offspeedRange.min - min) / (max - min) * 100, "$width": (offspeedRange.max - offspeedRange.min) / (max - min) * 100 })),
            React.createElement(StyledChartLabel, { className: "ms-2" },
                format(max),
                " deg/s"))));
};

const getTrunkRotaionParams$1 = (throws) => {
    const flexion = throws.map((t) => t.rotx).reduce((sum, v) => sum + v, 0);
    const rotation = throws.map((t) => t.roty).reduce((sum, v) => sum + v, 0);
    const tilt = throws.map((t) => t.rotz).reduce((sum, v) => sum + v, 0);
    const sum = flexion + rotation + tilt;
    return { flexion: flexion / sum, rotation: rotation / sum, tilt: tilt / sum };
};
const TrunkRotation = ({ throws }) => {
    const { t: translate } = useTranslation();
    const { rotation, flexion, tilt } = getTrunkRotaionParams$1(throws);
    return (React.createElement(Card, null,
        React.createElement(CardTitle, null, translate('components.mechanics.trunk-title')),
        React.createElement(MagnitudeChart, { className: "mt-3 mb-3", throws: throws }),
        React.createElement(TrunkRotationPieChart, { rotation: rotation, flexion: flexion, tilt: tilt, height: 300 })));
};

const StyledDataPane$1 = styled.div `
    display: inline-grid;
    gap: 1rem;
    grid-template-columns: repeat(1,minmax(0,1fr));
    flex-grow: 1;
    padding: 16px 18px;
    grid-auto-rows: fit-content(1em);
    overflow: auto;
`;
const calculateTempo = (gamePitches) => {
    const innings = getInnings(gamePitches);
    let totalTimeDiff = 0;
    let totalTimeDiffCount = 0;
    innings.forEach((inning) => {
        const { timeDiff, timeDiffCount } = calculateInningTempo(inning);
        totalTimeDiff += timeDiff;
        totalTimeDiffCount += timeDiffCount;
    });
    if (totalTimeDiffCount) {
        return `${format(totalTimeDiff / totalTimeDiffCount, 1)}s`;
    }
    return '-';
};
const DataPane$1 = ({ isLoading, playerId, daySummary, getPitcherDaySummary, hideGpsDataLabel }) => {
    const { t: translate } = useTranslation();
    const [isLoadingDaySummary, setIsLoadingDaySummary] = useState(true);
    const [throws, setThrows] = useState([]);
    useEffect(() => {
        if (playerId && (daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid)) {
            const getData = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setIsLoadingDaySummary(true);
                    const data = yield getPitcherDaySummary(playerId, daySummary.daysummaryid);
                    setThrows(data.throws);
                }
                finally {
                    setIsLoadingDaySummary(false);
                }
            });
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId, daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid]);
    if (isLoading || isLoadingDaySummary) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" },
            React.createElement(LoadingSpinner$1, null)));
    }
    const firstWarmupPitchIndex = throws.findIndex((t) => t.throwtype === THROW_TYPES.warmup || t.throwtype === THROW_TYPES.game);
    const gamePitches = throws.slice(firstWarmupPitchIndex, throws.length).filter((t) => t.throwtype === THROW_TYPES.game || t.intensity >= 0.5);
    const isGameDay = throws.some((t) => t.throwtype === THROW_TYPES.game);
    const summaryStats = [
        { label: translate('components.mechanics.throw-workload'), value: format(daySummary === null || daySummary === void 0 ? void 0 : daySummary.throwworkload) },
        { label: translate('components.mechanics.total-throws'), value: daySummary === null || daySummary === void 0 ? void 0 : daySummary.throws },
        { label: translate('components.mechanics.pre-game-throws'), value: isGameDay && firstWarmupPitchIndex >= 0 ? firstWarmupPitchIndex : '-' },
        { label: translate('components.mechanics.warmup-pitches'), value: isGameDay ? (throws !== null && throws !== void 0 ? throws : []).filter((t) => t.throwtype === 3).length : '-' },
        { label: translate('components.mechanics.game-pitches'), value: isGameDay ? (throws !== null && throws !== void 0 ? throws : []).filter((t) => t.throwtype === 1).length : '-' },
        { label: translate('components.mechanics.average-tempo'), value: isGameDay ? calculateTempo(gamePitches) : '-' },
    ];
    const EmptyState = () => React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" }, translate('components.mechanics.no-throwing-data'));
    return (React.createElement(StyledDataPane$1, null, throws.length ? (React.createElement(React.Fragment, null,
        !hideGpsDataLabel && React.createElement("h3", { className: "mb-0", style: { color: '#333' } }, translate('components.mechanics.gps-data')),
        React.createElement(SummaryStats$1, { summaryStats: summaryStats }),
        React.createElement(ThrowTimeline, { throws: throws !== null && throws !== void 0 ? throws : [], showLegend: isGameDay }),
        isGameDay && (React.createElement(Row, { className: "gy-3" },
            React.createElement(Col, { sm: 12, md: 7 },
                React.createElement(GameSummary, { throws: throws !== null && throws !== void 0 ? throws : [] })),
            React.createElement(Col, { sm: 12, md: 5 },
                React.createElement(TrunkRotation, { throws: throws !== null && throws !== void 0 ? throws : [] })))))) : React.createElement(EmptyState, null)));
};

const MenuItemComponent$1 = ({ daySummary }) => (React.createElement("div", { className: "d-flex" },
    React.createElement("div", { className: "d-flex", style: { width: '65%' } },
        React.createElement(MenuItemKey, null, "Throw Work:\u00A0"),
        React.createElement(MenuItemValue, null, format(daySummary.throwworkload) || '-')),
    React.createElement("div", { className: "d-flex" },
        React.createElement(MenuItemKey, null, "Throws:\u00A0"),
        React.createElement(MenuItemValue, null, daySummary.throws || '-'))));
const EmptyState$3 = () => React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" }, "No data");
const Pitcher = ({ playerId, getPitcherDaySummaries, getPitcherDaySummary, hideMenuTitle, hideGpsDataLabel }) => {
    var _a;
    const [selectedDaySummaryId, setSelectedDaySummaryId] = useState(null);
    const [isLoadingDaySummaries, setIsLoadingDaySummaries] = useState(true);
    const [daySummaries, setDaySummaries] = useState([]);
    useEffect(() => {
        const getData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                setIsLoadingDaySummaries(true);
                const data = yield getPitcherDaySummaries(playerId);
                setDaySummaries(data.daysummaries);
                setSelectedDaySummaryId((_b = (_a = data.daysummaries[0]) === null || _a === void 0 ? void 0 : _a.daysummaryid) !== null && _b !== void 0 ? _b : null);
            }
            finally {
                setIsLoadingDaySummaries(false);
            }
        });
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId]);
    const selectedDaySummary = daySummaries === null || daySummaries === void 0 ? void 0 : daySummaries.find((ds) => ds.daysummaryid === selectedDaySummaryId);
    return (React.createElement("div", { className: "d-flex h-100" },
        React.createElement(Menu, { daySummaries: (_a = daySummaries) !== null && _a !== void 0 ? _a : [], selectedDaySummaryId: selectedDaySummaryId, setSelectedDaySummaryId: setSelectedDaySummaryId, menuItemComponent: MenuItemComponent$1, width: 240, hideMenuTitle: hideMenuTitle }),
        (daySummaries === null || daySummaries === void 0 ? void 0 : daySummaries.length) || isLoadingDaySummaries
            ? (React.createElement(DataPane$1, { isLoading: isLoadingDaySummaries, playerId: playerId, daySummary: selectedDaySummary, getPitcherDaySummary: getPitcherDaySummary, hideGpsDataLabel: hideGpsDataLabel }))
            : React.createElement(EmptyState$3, null)));
};

const MULTI_COLUMN_CUTOFF = 8;
const getColumns = (sprints) => [{
        id: 'sprint1',
        title: 'Sprint',
        type: COLUMN_TYPES.TEXT,
    }, {
        id: 'speed1',
        title: 'Speed (mph)',
        type: COLUMN_TYPES.TEXT,
    }, ...(sprints.length > MULTI_COLUMN_CUTOFF ? [{
            id: 'sprint2',
            title: 'Sprint',
            type: COLUMN_TYPES.TEXT,
        }, {
            id: 'speed2',
            title: 'Speed (mph)',
            type: COLUMN_TYPES.TEXT,
        }] : [])];
const formatSpeed = (speed) => (speed ? format(speed, 1) : '-');
const getRows = (sprints) => {
    if (sprints.length > MULTI_COLUMN_CUTOFF) {
        const rows = [];
        for (let i = 0; i < sprints.length / 2; i++) {
            const secondColumnIndex = Math.ceil(sprints.length / 2) + i;
            rows.push({
                sprint1: i + 1,
                speed1: formatSpeed(sprints[i].mph),
                sprint2: sprints[secondColumnIndex] ? (secondColumnIndex + 1) : undefined,
                speed2: sprints[secondColumnIndex] ? formatSpeed(sprints[secondColumnIndex].mph) : undefined,
            });
        }
        return rows;
    }
    return sprints.map((s, i) => ({
        sprint1: i + 1,
        speed1: formatSpeed(s.mph),
    }));
};
const SprintExertionsTable = ({ sprints }) => (React.createElement(TableWrapper, null,
    React.createElement(DataTable, { columns: getColumns(sprints), rows: getRows(sprints) })));

const EmptyState$2 = () => React.createElement("div", { className: "d-flex justify-content-center py-3 fs-6 text-muted" }, "No Data");
const SprintExertions = ({ sprints = [] }) => (React.createElement(Card, null,
    React.createElement(CardTitle, null, "Sprint Exertions"),
    sprints.length
        ? (React.createElement(Row, { className: "mt-3" },
            React.createElement(Col, { sm: 12, md: 4 },
                React.createElement(SprintExertionsTable, { sprints: sprints })),
            React.createElement(Col, { sm: 12, md: 8 },
                React.createElement(SprintExertionsChart, { sprints: sprints })))) : React.createElement(EmptyState$2, null)));

const getTrunkRotaionParams = (swings) => {
    const flexion = swings.map((s) => s.rotx).reduce((sum, v) => sum + v, 0);
    const rotation = swings.map((s) => s.roty).reduce((sum, v) => sum + v, 0);
    const tilt = swings.map((s) => s.rotz).reduce((sum, v) => sum + v, 0);
    const sum = flexion + rotation + tilt;
    return { flexion: flexion / sum, rotation: rotation / sum, tilt: tilt / sum };
};
const EmptyState$1 = () => (React.createElement(React.Fragment, null,
    React.createElement(CardTitle, null, "Swings"),
    React.createElement("div", { className: "d-flex justify-content-center py-3 fs-6 text-muted" }, "No Data")));
const SwingMechanics = ({ swings }) => {
    const { rotation, flexion, tilt } = getTrunkRotaionParams(swings);
    return (React.createElement(Card, null, swings.length ? (React.createElement(Row, null,
        React.createElement(Col, { sm: 12, md: 4 },
            React.createElement(CardTitle, null, "Trunk Rotation Speed (Swings)"),
            React.createElement("div", { className: "mt-3" },
                React.createElement(TrunkRotationPieChart, { rotation: rotation, flexion: flexion, tilt: tilt }))),
        React.createElement(Col, { sm: 12, md: 8 },
            React.createElement(CardTitle, null, "Swing Timeline"),
            React.createElement("div", { className: "mt-3" },
                React.createElement(SwingTimelineChart, { swings: swings }))))) : React.createElement(EmptyState$1, null)));
};

const StyledDataPane = styled.div `
    display: inline-grid;
    gap: 1rem;
    grid-template-columns: repeat(1,minmax(0,1fr));
    flex-grow: 1;
    padding: 16px 18px;
    grid-auto-rows: fit-content(1em);
    overflow: auto;
`;
const getTopSpeed$1 = (topspeed) => (topspeed ? `${format(topspeed, 1)} mph` : '-');
const getDistance = (distance) => (distance ? `${format(distance, 1)} miles` : '-');
const DataPane = ({ isLoading, playerId, daySummary, getPositionPlayerDaySummary, hideGpsDataLabel }) => {
    var _a;
    const [isLoadingDaySummary, setIsLoadingDaySummary] = useState(true);
    const [throws, setThrows] = useState([]);
    const [swings, setSwings] = useState([]);
    const [sprints, setSprints] = useState([]);
    useEffect(() => {
        if (playerId && (daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid)) {
            const getData = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setIsLoadingDaySummary(true);
                    const data = yield getPositionPlayerDaySummary(playerId, daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid);
                    setThrows(data.throws);
                    setSwings(data.swings);
                    setSprints(data.sprints);
                }
                finally {
                    setIsLoadingDaySummary(false);
                }
            });
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId, daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid]);
    if (isLoading || isLoadingDaySummary) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" },
            React.createElement(LoadingSpinner$1, null)));
    }
    const summaryStats = [
        { label: 'Top Speed', value: getTopSpeed$1(daySummary === null || daySummary === void 0 ? void 0 : daySummary.topspeed) },
        { label: 'Distance', value: getDistance(daySummary === null || daySummary === void 0 ? void 0 : daySummary.distance) },
        { label: 'Movement Workload', value: format(daySummary === null || daySummary === void 0 ? void 0 : daySummary.workload) },
        { label: 'Swing Workload', value: (_a = format(daySummary === null || daySummary === void 0 ? void 0 : daySummary.swingworkload, 0)) !== null && _a !== void 0 ? _a : '-' },
        { label: 'Swings', value: swings.length || '-' },
        { label: 'Throws', value: throws.length || '-' },
    ];
    return (React.createElement(StyledDataPane, null,
        !hideGpsDataLabel && React.createElement("h3", { className: "mb-0", style: { color: '#333' } }, "GPS Data"),
        React.createElement(SummaryStats$1, { summaryStats: summaryStats }),
        React.createElement(SprintExertions, { sprints: sprints !== null && sprints !== void 0 ? sprints : [] }),
        React.createElement(SwingMechanics, { swings: swings !== null && swings !== void 0 ? swings : [] })));
};

const getTopSpeed = (mph) => (mph ? `${format(mph, 1)} mph` : '-');
const MenuItemComponent = ({ daySummary }) => (React.createElement("div", { className: "d-flex" },
    React.createElement("div", { className: "w-50" },
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Top Spd:\u00A0"),
            React.createElement(MenuItemValue, null, getTopSpeed(daySummary.topspeed))),
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Swings:\u00A0"),
            React.createElement(MenuItemValue, null, daySummary.swings || '-'))),
    React.createElement("div", null,
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Movt Work:\u00A0"),
            React.createElement(MenuItemValue, null, format(daySummary.workload) || '-')),
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Swing Work:\u00A0"),
            React.createElement(MenuItemValue, null, format(daySummary.swingworkload) || '-')))));
const EmptyState = () => React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" }, "No data");
const PositionPlayer = ({ playerId, getPositionPlayerDaySummaries, getPositionPlayerDaySummary, hideMenuTitle, hideGpsDataLabel }) => {
    var _a;
    const [selectedDaySummaryId, setSelectedDaySummaryId] = useState(null);
    const [isLoadingDaySummaries, setIsLoadingDaySummaries] = useState(true);
    const [daySummaries, setDaySummaries] = useState([]);
    useEffect(() => {
        const getData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                setIsLoadingDaySummaries(true);
                const data = yield getPositionPlayerDaySummaries(playerId);
                setDaySummaries(data.daysummaries);
                setSelectedDaySummaryId((_b = (_a = data.daysummaries[0]) === null || _a === void 0 ? void 0 : _a.daysummaryid) !== null && _b !== void 0 ? _b : null);
            }
            finally {
                setIsLoadingDaySummaries(false);
            }
        });
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId]);
    const selectedDaySummary = daySummaries.find((ds) => ds.daysummaryid === selectedDaySummaryId);
    return (React.createElement("div", { className: "d-flex h-100" },
        React.createElement(Menu, { daySummaries: (_a = daySummaries) !== null && _a !== void 0 ? _a : [], selectedDaySummaryId: selectedDaySummaryId, setSelectedDaySummaryId: setSelectedDaySummaryId, menuItemComponent: MenuItemComponent, width: 270, hideMenuTitle: hideMenuTitle }),
        daySummaries.length || isLoadingDaySummaries
            ? (React.createElement(DataPane, { isLoading: isLoadingDaySummaries, playerId: playerId, daySummary: selectedDaySummary, getPositionPlayerDaySummary: getPositionPlayerDaySummary, hideGpsDataLabel: hideGpsDataLabel }))
            : React.createElement(EmptyState, null)));
};

const MechanicsAndWorkload = ({ isPitcher, playerId, getPitcherDaySummaries, getPitcherDaySummary, getPositionPlayerDaySummaries, getPositionPlayerDaySummary, hideMenuTitle, hideGpsDataLabel }) => (isPitcher
    ? (React.createElement(Pitcher, { playerId: playerId, getPitcherDaySummaries: getPitcherDaySummaries, getPitcherDaySummary: getPitcherDaySummary, hideMenuTitle: hideMenuTitle, hideGpsDataLabel: hideGpsDataLabel }))
    : (React.createElement(PositionPlayer, { playerId: playerId, getPositionPlayerDaySummaries: getPositionPlayerDaySummaries, getPositionPlayerDaySummary: getPositionPlayerDaySummary, hideMenuTitle: hideMenuTitle, hideGpsDataLabel: hideGpsDataLabel })));

/* eslint-disable max-len */
const CircleIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    " ");
const SquareIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const LineIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M3 20L21 4", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const ArrowIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M3 12H22M22 12L19 9M22 12L19 15", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const AddTextIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, viewBox: "0 0 24 24", strokeWidth: "1.5" },
    React.createElement("path", { d: "M12 8L12 16M12 8H8M12 8H16", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M21 13.5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13.5M21 10.5V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V10.5", strokeWidth: "1.5", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M19.5 13.5V10.5H22.5V13.5H19.5Z", strokeWidth: "1.5", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M1.5 13.5V10.5H4.5V13.5H1.5Z", strokeWidth: "1.5", strokeLinejoin: "round" }));
const EditTextIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M19 7V5L5 5V7", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12 5L12 19M12 19H10M12 19H14", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const BoldIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "2.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M12 11.6667H8M12 11.6667C12 11.6667 15.3333 11.6667 15.3333 8.33333C15.3333 5.00002 12 5 12 5C12 5 12 5 12 5H8.6C8.26863 5 8 5.26863 8 5.6V11.6667M12 11.6667C12 11.6667 16 11.6667 16 15.3333C16 19 12 19 12 19C12 19 12 19 12 19H8.6C8.26863 19 8 18.7314 8 18.4V11.6667", strokeWidth: "2.5" }));
const ItalicsIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M11 5L14 5M17 5L14 5M14 5L10 19M10 19L7 19M10 19L13 19", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const UnderlineIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M16 5V11C16 13.2091 14.2091 15 12 15V15C9.79086 15 8 13.2091 8 11V5", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M6 19L18 19", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const TransparentFillIcon = ({ height, width }) => React.createElement("svg", { fill: "black", height: height, width: width, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4 20L20 4", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", stroke: "red" }));
const TransparentStrokeIcon = ({ height, width }) => React.createElement("svg", { stroke: "black", fill: "none", height: height, width: width, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4 20L20 4", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", stroke: "red" }));
const StrokeWidthIcon = ({ height, width }) => React.createElement("svg", { height: height, width: width, viewBox: "0 0 48 48" },
    " ",
    React.createElement("g", null,
        " ",
        React.createElement("rect", { x: "4", y: "8", width: "40", height: "2", rx: "1", ry: "1" }),
        " ",
        React.createElement("rect", { x: "4", y: "20", width: "40", height: "5", rx: "1", ry: "1" }),
        " ",
        React.createElement("rect", { x: "4", y: "32", width: "40", height: "10", rx: "1", ry: "1" }),
        " "),
    " ");
const CheckIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M5 13L9 17L19 7", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const AddShapeIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => (React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("circle", { cx: "10", cy: "10", r: "8", fill: "transparent", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "9", y: "9", width: "13", height: "13", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " "));
const BringToFrontIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => (React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("rect", { x: "1.5", y: "1.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "13.5", y: "13.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "7", y: "7", width: "10", height: "10", fill: "black", stroke: "black", strokeWidth: "1.5" }),
    " "));
const SendToBackIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => (React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("rect", { x: "7", y: "7", width: "10", height: "10", fill: "black", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "1.5", y: "1.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "13.5", y: "13.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " "));

var ELEMENT_TYPE;
(function (ELEMENT_TYPE) {
    ELEMENT_TYPE[ELEMENT_TYPE["RECTANGLE"] = 0] = "RECTANGLE";
    ELEMENT_TYPE[ELEMENT_TYPE["ELLIPSE"] = 1] = "ELLIPSE";
    ELEMENT_TYPE[ELEMENT_TYPE["LINE"] = 2] = "LINE";
    ELEMENT_TYPE[ELEMENT_TYPE["TEXT"] = 3] = "TEXT";
    ELEMENT_TYPE[ELEMENT_TYPE["ARROW"] = 4] = "ARROW";
})(ELEMENT_TYPE || (ELEMENT_TYPE = {}));
const ELEMENTS = [
    { label: 'rectangle', type: ELEMENT_TYPE.RECTANGLE, icon: SquareIcon },
    { label: 'ellipse', type: ELEMENT_TYPE.ELLIPSE, icon: CircleIcon },
    { label: 'line', type: ELEMENT_TYPE.LINE, icon: LineIcon },
    { label: 'arrow', type: ELEMENT_TYPE.ARROW, icon: ArrowIcon },
];
var COLOR;
(function (COLOR) {
    COLOR[COLOR["TRANSPARENT"] = 0] = "TRANSPARENT";
    COLOR[COLOR["BLACK"] = 1] = "BLACK";
    COLOR[COLOR["RED"] = 2] = "RED";
    COLOR[COLOR["ORANGE"] = 3] = "ORANGE";
    COLOR[COLOR["YELLOW"] = 4] = "YELLOW";
    COLOR[COLOR["GREEN"] = 5] = "GREEN";
    COLOR[COLOR["BLUE"] = 6] = "BLUE";
    COLOR[COLOR["PURPLE"] = 7] = "PURPLE";
})(COLOR || (COLOR = {}));
const COLORS = [
    { type: COLOR.TRANSPARENT, colorCode: 'transparent' },
    { type: COLOR.BLACK, colorCode: 'black' },
    { type: COLOR.RED, colorCode: '#e31a1c' },
    { type: COLOR.ORANGE, colorCode: '#ff7f00' },
    { type: COLOR.YELLOW, colorCode: '#fde047' },
    { type: COLOR.GREEN, colorCode: '#33a02c' },
    { type: COLOR.BLUE, colorCode: '#1f78b4' },
    { type: COLOR.PURPLE, colorCode: '#6a3d9a' },
];
const FONT_SIZE_OPTIONS = [8, 10, 12, 14, 16, 18, 20, 24, 30, 36, 42, 48, 54, 60, 72, 120];
const STROKE_WIDTH_OPTIONS = [1, 2, 3, 4, 6, 8, 12];
const ICON_SIZE = '1.25em';

const AddTextButton = ({ height, width, elements, setElements, selectedFontColor, idCounter, setIdCounter, setSelectedElementId, selectedFontSize, }) => {
    const { t: translate } = useTranslation();
    const addText = () => {
        var _a;
        const newId = `TEXT-${idCounter}`;
        setElements([...elements, {
                id: newId,
                type: ELEMENT_TYPE.TEXT,
                x: width / 2,
                y: height / 2,
                text: translate('image-markup.enter-text'),
                fill: (_a = COLORS.find((c) => c.type === selectedFontColor)) === null || _a === void 0 ? void 0 : _a.colorCode,
                fontSize: selectedFontSize,
            }]);
        setIdCounter((id) => id + 1);
        setSelectedElementId(newId);
    };
    return React.createElement(Button$1, { className: "d-flex align-items-center", variant: "", onClick: addText },
        React.createElement(AddTextIcon, { height: ICON_SIZE, width: ICON_SIZE }));
};

const StyledDropdown$4 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const AddShapeDropdown = ({ height, width, elements, setElements, idCounter, setIdCounter, selectedStroke, selectedStrokeWidth, selectedFill, setSelectedElementId, }) => {
    const addShape = (elementType) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const newId = `${(_a = ELEMENTS.find((s) => s.type === elementType)) === null || _a === void 0 ? void 0 : _a.label}-${idCounter}`;
        let newShape;
        switch (elementType) {
            case ELEMENT_TYPE.RECTANGLE:
                newShape = {
                    type: elementType,
                    x: (width / 2) - (width / 20),
                    y: (height / 2) - (height / 20),
                    width: width / 10,
                    height: width / 10,
                    stroke: (_b = COLORS.find((c) => c.type === selectedStroke)) === null || _b === void 0 ? void 0 : _b.colorCode,
                    strokeWidth: selectedStrokeWidth,
                    fill: (_c = COLORS.find((c) => c.type === selectedFill)) === null || _c === void 0 ? void 0 : _c.colorCode,
                };
                break;
            case ELEMENT_TYPE.ELLIPSE:
                newShape = {
                    type: elementType,
                    x: (width / 2),
                    y: (height / 2),
                    radiusX: width / 20,
                    radiusY: width / 20,
                    width: width / 10,
                    height: width / 10,
                    stroke: (_d = COLORS.find((c) => c.type === selectedStroke)) === null || _d === void 0 ? void 0 : _d.colorCode,
                    strokeWidth: selectedStrokeWidth,
                    fill: (_e = COLORS.find((c) => c.type === selectedFill)) === null || _e === void 0 ? void 0 : _e.colorCode,
                };
                break;
            case ELEMENT_TYPE.LINE:
            case ELEMENT_TYPE.ARROW:
                newShape = {
                    type: elementType,
                    x: 0,
                    y: 0,
                    points: [width / 4, height / 2, 3 * width / 4, height / 2],
                    stroke: (_f = COLORS.find((c) => c.type === selectedStroke)) === null || _f === void 0 ? void 0 : _f.colorCode,
                    strokeWidth: selectedStrokeWidth,
                    fill: (_g = COLORS.find((c) => c.type === selectedStroke)) === null || _g === void 0 ? void 0 : _g.colorCode,
                    tension: 1,
                };
                break;
            default:
                return;
        }
        setElements([...elements, Object.assign(Object.assign({}, newShape), { id: newId })]);
        setIdCounter((id) => id + 1);
        setSelectedElementId(newId);
    };
    return (React.createElement(StyledDropdown$4, { className: "ms-1" },
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
            React.createElement(AddShapeIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "black" })),
        React.createElement(Dropdown$1.Menu, null, ELEMENTS.map((s) => (React.createElement(Dropdown$1.Item, { key: s.type, onClick: () => addShape(s.type) }, s.icon({ height: '1.25em', width: '1.25em' })))))));
};

const StyledDropdown$3 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const SelectFillDropdown = ({ elements, setElements, selectedElementId, selectedFill, setSelectedFill }) => {
    var _a;
    const setFill = (colorType) => {
        var _a;
        if (selectedElementId) {
            const newElementIndex = elements.findIndex((s) => s.id === selectedElementId);
            if (elements[newElementIndex].type !== ELEMENT_TYPE.TEXT && elements[newElementIndex].type !== ELEMENT_TYPE.ARROW) {
                const newElements = elements.slice();
                newElements[newElementIndex].fill = (_a = COLORS.find((c) => c.type === colorType)) === null || _a === void 0 ? void 0 : _a.colorCode;
                setElements(newElements);
            }
        }
        setSelectedFill(colorType);
    };
    return (React.createElement(StyledDropdown$3, null,
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" }, selectedFill === COLOR.TRANSPARENT
            ? React.createElement(TransparentFillIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: (_a = COLORS.find((c) => c.type === selectedFill)) === null || _a === void 0 ? void 0 : _a.colorCode })),
        React.createElement(Dropdown$1.Menu, null, COLORS.map((c) => (React.createElement(Dropdown$1.Item, { key: c.type, onClick: () => setFill(c.type) }, c.type === COLOR.TRANSPARENT
            ? React.createElement(TransparentFillIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: c.colorCode })))))));
};

const StyledDropdown$2 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const SelectStrokeDropdown = ({ elements, setElements, selectedElementId, selectedStroke, setSelectedStroke }) => {
    var _a;
    const setStroke = (colorType) => {
        var _a, _b;
        if (selectedElementId) {
            const newElementIndex = elements.findIndex((s) => s.id === selectedElementId);
            if (elements[newElementIndex].type !== ELEMENT_TYPE.TEXT) {
                const newElements = elements.slice();
                newElements[newElementIndex].stroke = (_a = COLORS.find((c) => c.type === colorType)) === null || _a === void 0 ? void 0 : _a.colorCode;
                if (elements[newElementIndex].type === ELEMENT_TYPE.ARROW) {
                    newElements[newElementIndex].fill = (_b = COLORS.find((c) => c.type === colorType)) === null || _b === void 0 ? void 0 : _b.colorCode;
                }
                setElements(newElements);
            }
        }
        setSelectedStroke(colorType);
    };
    return (React.createElement(StyledDropdown$2, null,
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" }, selectedStroke === COLOR.TRANSPARENT
            ? React.createElement(TransparentStrokeIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: (_a = COLORS.find((c) => c.type === selectedStroke)) === null || _a === void 0 ? void 0 : _a.colorCode })),
        React.createElement(Dropdown$1.Menu, null, COLORS.map((c) => (React.createElement(Dropdown$1.Item, { key: c.type, onClick: () => setStroke(c.type) }, c.type === COLOR.TRANSPARENT
            ? React.createElement(TransparentStrokeIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: c.colorCode })))))));
};

const StyledDropdown$1 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const SelectStrokeWidthDropdown = ({ elements, setElements, selectedElementId, selectedStrokeWidth, setSelectedStrokeWidth, }) => {
    const setStrokeWidth = (strokeWidth) => {
        if (selectedElementId) {
            const newElementIndex = elements.findIndex((s) => s.id === selectedElementId);
            if (elements[newElementIndex].type !== ELEMENT_TYPE.TEXT) {
                const newElements = elements.slice();
                newElements[newElementIndex].strokeWidth = +strokeWidth;
                setElements(newElements);
            }
        }
        setSelectedStrokeWidth(strokeWidth);
    };
    return (React.createElement(StyledDropdown$1, null,
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
            React.createElement(StrokeWidthIcon, { height: ICON_SIZE, width: ICON_SIZE })),
        React.createElement(Dropdown$1.Menu, null, STROKE_WIDTH_OPTIONS.map((o) => (React.createElement(Dropdown$1.Item, { key: o, onClick: () => setStrokeWidth(o), className: "d-flex align-items-center ps-1" },
            React.createElement("div", { style: { width: '1.25rem' }, className: "d-flex justify-content-center align-items-center me-1" }, o === selectedStrokeWidth && React.createElement(CheckIcon, null)),
            React.createElement("div", { className: "d-flex align-items-center", style: { height: '1.5rem' } },
                React.createElement("div", { style: { width: '3rem', height: o, backgroundColor: 'black' } }))))))));
};

const StyledDropdown = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const EditTextDropdown = ({ elements, setElements, isBold, setIsBold, isItalics, setIsItalics, isUnderline, setIsUnderline, selectedFontSize, setSelectedFontSize, selectedElementId, selectedFontColor, setSelectedFontColor, }) => {
    var _a, _b;
    const updateTextStyle = (style, styleKey, isStyleApplied) => {
        const newElements = elements.slice();
        const newShapeIndex = newElements.findIndex((s) => s.id === selectedElementId);
        if (isStyleApplied === undefined) {
            newElements[newShapeIndex][styleKey] = style;
        }
        else {
            newElements[newShapeIndex][styleKey] = isStyleApplied
                ? (newElements[newShapeIndex][styleKey] || '').replaceAll(style, '')
                : `${(newElements[newShapeIndex][styleKey] || '')} ${style}`.trim();
        }
        setElements(newElements);
    };
    const isTextElementSelected = selectedElementId && ((_a = elements.find((s) => s.id === selectedElementId)) === null || _a === void 0 ? void 0 : _a.type) === ELEMENT_TYPE.TEXT;
    const toggleIsBold = () => {
        if (isTextElementSelected) {
            updateTextStyle('bold', 'fontStyle', isBold);
        }
        setIsBold((x) => !x);
    };
    const toggleIsItalics = () => {
        if (isTextElementSelected) {
            updateTextStyle('italic', 'fontStyle', isItalics);
        }
        setIsItalics((x) => !x);
    };
    const toggleIsUnderline = () => {
        if (isTextElementSelected) {
            updateTextStyle('underline', 'textDecoration', isUnderline);
        }
        setIsUnderline((x) => !x);
    };
    const onSetSelectedFontSize = (newFontSize) => {
        if (isTextElementSelected) {
            updateTextStyle(newFontSize, 'fontSize');
        }
        setSelectedFontSize(newFontSize);
    };
    const onSetSelectedFontColor = (newFontColor) => {
        var _a;
        if (isTextElementSelected) {
            updateTextStyle(((_a = COLORS.find((c) => c.type === newFontColor)) === null || _a === void 0 ? void 0 : _a.colorCode) || 'black', 'fill');
        }
        setSelectedFontColor(newFontColor);
    };
    return (React.createElement(StyledDropdown, { className: "ms-1", autoClose: "outside" },
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
            React.createElement(EditTextIcon, { height: ICON_SIZE, width: ICON_SIZE })),
        React.createElement(Dropdown$1.Menu, { className: "px-2" },
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement(ButtonGroup, null,
                    React.createElement(Button$1, { variant: isBold ? 'primary' : 'default', onClick: toggleIsBold },
                        React.createElement(BoldIcon, { height: ICON_SIZE, width: ICON_SIZE })),
                    React.createElement(Button$1, { variant: isItalics ? 'primary' : 'default', onClick: toggleIsItalics },
                        React.createElement(ItalicsIcon, { height: ICON_SIZE, width: ICON_SIZE })),
                    React.createElement(Button$1, { variant: isUnderline ? 'primary' : 'default', onClick: toggleIsUnderline },
                        React.createElement(UnderlineIcon, { height: ICON_SIZE, width: ICON_SIZE }))),
                React.createElement(Form$1.Select, { style: { minWidth: '4rem' }, className: "ms-1", value: selectedFontSize, onChange: (e) => onSetSelectedFontSize(e.target.value), size: "sm" }, FONT_SIZE_OPTIONS.map((o) => React.createElement("option", { key: o, value: o }, o))),
                React.createElement(StyledDropdown, null,
                    React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
                        React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: (_b = COLORS.find((c) => c.type === selectedFontColor)) === null || _b === void 0 ? void 0 : _b.colorCode })),
                    React.createElement(Dropdown$1.Menu, null, COLORS.filter((c) => c.type !== COLOR.TRANSPARENT).map((c) => (React.createElement(Dropdown$1.Item, { key: c.type, onClick: () => onSetSelectedFontColor(c.type) },
                        React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: c.colorCode }))))))))));
};

const EditElementOrderButtons = ({ selectedElementId, elements, setElements }) => {
    const sendToBack = () => {
        const element = elements.splice(elements.findIndex((s) => s.id === selectedElementId), 1);
        setElements([...element, ...elements]);
    };
    const sendToFront = () => {
        const element = elements.splice(elements.findIndex((s) => s.id === selectedElementId), 1);
        setElements([...elements, ...element]);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button$1, { disabled: !selectedElementId, variant: "", onClick: sendToBack },
            React.createElement(SendToBackIcon, { height: ICON_SIZE, width: ICON_SIZE })),
        React.createElement(Button$1, { disabled: !selectedElementId, variant: "", onClick: sendToFront },
            React.createElement(BringToFrontIcon, { height: ICON_SIZE, width: ICON_SIZE }))));
};

const EditTextField = ({ element, elements, setElements }) => {
    const inputRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const onChange = (e) => {
        const newElements = elements.slice();
        const newElementIndex = newElements.findIndex((s) => s.id === element.id);
        newElements[newElementIndex].text = e.target.value;
        setElements(newElements);
    };
    return (React.createElement("div", null,
        React.createElement(Form$1.Control, { ref: inputRef, id: "editText", value: element.text, onChange: onChange })));
};

const Divider = () => React.createElement("div", { className: "border mx-2", style: { height: '2.5em' } });
const Toolbar = ({ height, width, elements, setElements, selectedElementId, setSelectedElementId, onSave, idCounter, setIdCounter, hasUnsavedChanges, }) => {
    const { t: translate } = useTranslation();
    const [selectedStroke, setSelectedStroke] = useState(COLOR.BLACK);
    const [selectedFill, setSelectedFill] = useState(COLOR.RED);
    const [selectedStrokeWidth, setSelectedStrokeWidth] = useState(2);
    const [selectedFontSize, setSelectedFontSize] = useState('12');
    const [isBold, setIsBold] = useState(false);
    const [isItalics, setIsItalics] = useState(false);
    const [isUnderline, setIsUnderline] = useState(false);
    const [selectedFontColor, setSelectedFontColor] = useState(COLOR.BLACK);
    const [isSaving, setIsSaving] = useState(false);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (selectedElementId) {
            const selectedElement = elements.find((e) => e.id === selectedElementId);
            if (!selectedElement)
                return;
            if (selectedElement.type === ELEMENT_TYPE.TEXT) {
                setSelectedFontSize((_a = selectedElement.fontSize) !== null && _a !== void 0 ? _a : selectedFontSize);
                setSelectedFontColor((_c = (_b = COLORS.find((c) => c.colorCode === selectedElement.fill)) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : selectedFontColor);
                setIsBold(!!((_d = selectedElement.fontStyle) === null || _d === void 0 ? void 0 : _d.includes('bold')));
                setIsItalics(!!((_e = selectedElement.fontStyle) === null || _e === void 0 ? void 0 : _e.includes('italic')));
                setIsUnderline(!!((_f = selectedElement.textDecoration) === null || _f === void 0 ? void 0 : _f.includes('underline')));
            }
            else {
                setSelectedStroke(((_g = COLORS.find((c) => c.colorCode === selectedElement.stroke)) === null || _g === void 0 ? void 0 : _g.type) || selectedStroke);
                setSelectedFill(((_h = COLORS.find((c) => c.colorCode === selectedElement.fill)) === null || _h === void 0 ? void 0 : _h.type) || selectedFill);
                setSelectedStrokeWidth((_j = selectedElement.strokeWidth) !== null && _j !== void 0 ? _j : selectedStrokeWidth);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedElementId]);
    const innerOnSave = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsSaving(true);
        yield onSave(elements);
        setIsSaving(false);
    });
    const selectedElement = elements.find((e) => e.id === selectedElementId);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex align-items-center justify-content-between border-top border-start border-end p-2 pe-3 d-print-none" },
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement(AddShapeDropdown, { height: height, width: width, elements: elements, setElements: setElements, idCounter: idCounter, setIdCounter: setIdCounter, selectedStroke: selectedStroke, selectedFill: selectedFill, selectedStrokeWidth: selectedStrokeWidth, setSelectedElementId: setSelectedElementId }),
                React.createElement(SelectFillDropdown, { elements: elements, setElements: setElements, selectedElementId: selectedElementId, selectedFill: selectedFill, setSelectedFill: setSelectedFill }),
                React.createElement(SelectStrokeDropdown, { elements: elements, setElements: setElements, selectedElementId: selectedElementId, selectedStroke: selectedStroke, setSelectedStroke: setSelectedStroke }),
                React.createElement(SelectStrokeWidthDropdown, { elements: elements, setElements: setElements, selectedElementId: selectedElementId, selectedStrokeWidth: selectedStrokeWidth, setSelectedStrokeWidth: setSelectedStrokeWidth }),
                React.createElement(Divider, null),
                React.createElement(AddTextButton, { height: height, width: width, elements: elements, setElements: setElements, idCounter: idCounter, setIdCounter: setIdCounter, selectedFontColor: selectedFontColor, setSelectedElementId: setSelectedElementId, selectedFontSize: selectedFontSize }),
                React.createElement(EditTextDropdown, { elements: elements, setElements: setElements, isBold: isBold, setIsBold: setIsBold, isItalics: isItalics, setIsItalics: setIsItalics, isUnderline: isUnderline, setIsUnderline: setIsUnderline, selectedFontSize: selectedFontSize, setSelectedFontSize: setSelectedFontSize, selectedElementId: selectedElementId, selectedFontColor: selectedFontColor, setSelectedFontColor: setSelectedFontColor }),
                React.createElement(Divider, null),
                React.createElement(EditElementOrderButtons, { selectedElementId: selectedElementId, elements: elements, setElements: setElements })),
            React.createElement("div", { className: "position-relative d-flex justify-content-end", style: { minWidth: 90 } },
                React.createElement(Button$1, { size: "sm", variant: "primary", onClick: innerOnSave, disabled: isSaving }, isSaving ? translate('common.saving') : translate('common.save')),
                hasUnsavedChanges && React.createElement("span", { style: { fontSize: 10, top: '100%', right: 0, position: 'absolute' }, className: "text-muted" }, "Unsaved *"))),
        (selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.type) === ELEMENT_TYPE.TEXT && (React.createElement("div", { className: "d-flex align-items-center border-top border-start border-end p-2" },
            React.createElement(EditTextField, { element: selectedElement, elements: elements, setElements: setElements })))));
};

var Rectangle = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const trRef = React.useRef(null);
    useEffect(() => {
        var _a, _b;
        if (isSelected && (trRef === null || trRef === void 0 ? void 0 : trRef.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            // we need to attach transformer manually
            trRef.current.nodes([shapeRef.current]);
            (_b = (_a = trRef === null || trRef === void 0 ? void 0 : trRef.current) === null || _a === void 0 ? void 0 : _a.getLayer()) === null || _b === void 0 ? void 0 : _b.batchDraw();
        }
    }, [isSelected]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Rect, Object.assign({}, element, { onClick: onSelect, onTap: onSelect, ref: shapeRef, draggable: isEditable, onDragEnd: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { rotation: node.rotation(), x: node.x(), y: node.y(), width: Math.max(5, node.width() * scaleX), height: Math.max(node.height() * scaleY) }));
                }
            } })),
        isSelected && (React.createElement(Transformer, { ref: trRef, flipEnabled: false, boundBoxFunc: (oldBox, newBox) => {
                if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
                    return oldBox;
                }
                return newBox;
            } }))));
};

var Ellipse = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const trRef = React.useRef(null);
    useEffect(() => {
        var _a, _b;
        if (isSelected && (trRef === null || trRef === void 0 ? void 0 : trRef.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            // we need to attach transformer manually
            trRef.current.nodes([shapeRef.current]);
            (_b = (_a = trRef === null || trRef === void 0 ? void 0 : trRef.current) === null || _a === void 0 ? void 0 : _a.getLayer()) === null || _b === void 0 ? void 0 : _b.batchDraw();
        }
    }, [isSelected]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Ellipse$1, Object.assign({}, element, { radiusX: element.radiusX, radiusY: element.radiusY, onClick: onSelect, onTap: onSelect, ref: shapeRef, draggable: isEditable, onDragEnd: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { x: node.x(), y: node.y(), radiusX: node.radiusX(), radiusY: node.radiusY(), width: Math.max(5, node.width() * scaleX), height: Math.max(node.height() * scaleY), rotation: node.rotation() }));
                }
            } })),
        isSelected && (React.createElement(Transformer, { ref: trRef, flipEnabled: false, boundBoxFunc: (oldBox, newBox) => {
                if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
                    return oldBox;
                }
                return newBox;
            } }))));
};

const ANCHOR_WIDTH$1 = 10;
var Line = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const anchor1Ref = React.useRef(null);
    const anchor2Ref = React.useRef(null);
    const ondragmove = () => {
        if ((anchor1Ref === null || anchor1Ref === void 0 ? void 0 : anchor1Ref.current) && (anchor2Ref === null || anchor2Ref === void 0 ? void 0 : anchor2Ref.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            onChange(Object.assign(Object.assign({}, element), { points: [
                    anchor1Ref.current.attrs.x + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.x,
                    anchor1Ref.current.attrs.y + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.y,
                    anchor2Ref.current.attrs.x + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.x,
                    anchor2Ref.current.attrs.y + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.y,
                ] }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Line$1, Object.assign({ onClick: onSelect, onTap: onSelect, ref: shapeRef }, element, { draggable: isEditable, onDragMove: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { x: node.x(), y: node.y(), points: node.points }));
                }
            }, hitStrokeWidth: 12 })),
        isSelected && (React.createElement(React.Fragment, null,
            React.createElement(Rect, { x: element.points[0] + element.x - (ANCHOR_WIDTH$1 / 2), y: element.points[1] + element.y - (ANCHOR_WIDTH$1 / 2), height: ANCHOR_WIDTH$1, width: ANCHOR_WIDTH$1, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor1Ref }),
            React.createElement(Rect, { x: element.points[2] + element.x - (ANCHOR_WIDTH$1 / 2), y: element.points[3] + element.y - (ANCHOR_WIDTH$1 / 2), height: ANCHOR_WIDTH$1, width: ANCHOR_WIDTH$1, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor2Ref })))));
};

var Text = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const trRef = React.useRef(null);
    useEffect(() => {
        var _a, _b;
        if (isSelected && (trRef === null || trRef === void 0 ? void 0 : trRef.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            trRef.current.nodes([shapeRef.current]);
            (_b = (_a = trRef === null || trRef === void 0 ? void 0 : trRef.current) === null || _a === void 0 ? void 0 : _a.getLayer()) === null || _b === void 0 ? void 0 : _b.batchDraw();
        }
    }, [isSelected]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Text$1, Object.assign({ onClick: onSelect, onTap: onSelect, ref: shapeRef }, element, { draggable: isEditable, onDragEnd: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    const scaleX = node.scaleX();
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { rotation: node.rotation(), x: node.x(), y: node.y(), width: Math.max(5, node.width() * scaleX) }));
                }
            } })),
        isSelected && (React.createElement(Transformer, { ref: trRef, flipEnabled: false, boundBoxFunc: (_oldBox, newBox) => {
                newBox.width = Math.max(30, newBox.width);
                return newBox;
            }, enabledAnchors: ['middle-left', 'middle-right'] }))));
};

const ANCHOR_WIDTH = 10;
var Arrow = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const anchor1Ref = React.useRef(null);
    const anchor2Ref = React.useRef(null);
    const ondragmove = () => {
        if ((anchor1Ref === null || anchor1Ref === void 0 ? void 0 : anchor1Ref.current) && (anchor2Ref === null || anchor2Ref === void 0 ? void 0 : anchor2Ref.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            onChange(Object.assign(Object.assign({}, element), { points: [
                    anchor1Ref.current.attrs.x + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.x,
                    anchor1Ref.current.attrs.y + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.y,
                    anchor2Ref.current.attrs.x + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.x,
                    anchor2Ref.current.attrs.y + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.y,
                ] }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Arrow$1, Object.assign({ points: element.points, onClick: onSelect, onTap: onSelect, ref: shapeRef }, element, { draggable: isEditable, onDragMove: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { x: node.x(), y: node.y(), points: node.points }));
                }
            }, hitStrokeWidth: 12 })),
        isSelected && (React.createElement(React.Fragment, null,
            React.createElement(Rect, { x: element.points[0] + element.x - (ANCHOR_WIDTH / 2), y: element.points[1] + element.y - (ANCHOR_WIDTH / 2), height: ANCHOR_WIDTH, width: ANCHOR_WIDTH, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor1Ref }),
            React.createElement(Rect, { x: element.points[2] + element.x - (ANCHOR_WIDTH / 2), y: element.points[3] + element.y - (ANCHOR_WIDTH / 2), height: ANCHOR_WIDTH, width: ANCHOR_WIDTH, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor2Ref })))));
};

const StageElement = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const StageElementComponent = {
        [ELEMENT_TYPE.RECTANGLE]: Rectangle,
        [ELEMENT_TYPE.ELLIPSE]: Ellipse,
        [ELEMENT_TYPE.LINE]: Line,
        [ELEMENT_TYPE.ARROW]: Arrow,
        [ELEMENT_TYPE.TEXT]: Text,
    }[element.type];
    return (React.createElement(StageElementComponent, { isSelected: isSelected, element: element, onSelect: onSelect, onChange: onChange, isEditable: isEditable }));
};
var Stage = ({ height, width, elements, selectedElementId, setSelectedElementId, onChange, backgroundImage, isEditable }) => {
    const [image] = useImage(backgroundImage);
    const checkDeselect = (e) => {
        const clickedOnEmpty = e.target === e.target.getStage() || e.target.attrs.id === 'background';
        if (clickedOnEmpty) {
            setSelectedElementId(null);
        }
    };
    return (React.createElement(Stage$1, { width: width, height: height, className: "d-flex justify-content-center align-items-center w-100 bg-light stage-background", id: "stage", onMouseUp: checkDeselect },
        React.createElement(Layer, null,
            React.createElement(Image$1, { id: "background", image: image, height: height, width: width, onClick: checkDeselect })),
        React.createElement(Layer, null, elements.map((element) => (React.createElement(StageElement, { element: element, isSelected: element.id === selectedElementId, onSelect: () => {
                if (isEditable) {
                    setSelectedElementId(element.id);
                }
            }, onChange: onChange, isEditable: isEditable, key: element.id }))))));
};

var ImageMarkup = ({ initialElements, height = 500, width = 500, onSave = () => { }, backgroundImage, isEditable = false, }) => {
    const [elements, setElements] = useState(initialElements);
    const [selectedElementId, setSelectedElementId] = useState(null);
    const [idCounter, setIdCounter] = useState(1);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const onChange = (e) => {
        const newElements = elements.slice();
        const newElementIndex = newElements.findIndex((s) => s.id === e.id);
        newElements[newElementIndex] = e;
        setElements(newElements);
    };
    const handleKeyDown = (e) => {
        var _a;
        if (e.key === 'Backspace' && !!selectedElementId && ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id) !== 'editText') {
            setElements(elements.filter((s) => s.id !== selectedElementId));
            setSelectedElementId(null);
        }
    };
    useEffect(() => {
        const maxId = initialElements.reduce((max, element) => Math.max(max, +element.id.split('-')[1]), 0) + 1;
        setIdCounter(maxId);
    }, [initialElements]);
    useEffect(() => {
        if (elements !== initialElements) {
            setHasUnsavedChanges(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements]);
    const innerOnSave = (e) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSave(e);
        setHasUnsavedChanges(false);
    });
    return (React.createElement("div", { className: "d-inline-flex flex-column", onKeyUp: handleKeyDown, tabIndex: -1 },
        isEditable && (React.createElement(Toolbar, { height: height, width: width, elements: elements, setElements: setElements, selectedElementId: selectedElementId, setSelectedElementId: setSelectedElementId, onSave: innerOnSave, idCounter: idCounter, setIdCounter: setIdCounter, hasUnsavedChanges: hasUnsavedChanges })),
        React.createElement("div", { className: "border", onClick: (e) => { if (e.target.className.includes('stage-background')) {
                setSelectedElementId(null);
            } } },
            React.createElement(Stage, { elements: elements, height: height, width: width, selectedElementId: selectedElementId, setSelectedElementId: setSelectedElementId, onChange: onChange, backgroundImage: backgroundImage, isEditable: isEditable }))));
};

const Root = styled.div `
    width: 100%;
    min-width: 0;
    font-size: 0.825rem;

    .grouped-sortable-multi-select-heading {
        font-weight: 700;
        line-height: 1.25;
    }

    .grouped-sortable-multi-select-heading--showing {
        color: ${styles.theme.fontColors.mineShaft};
        padding: 0 0 0.25rem;
    }

    .grouped-sortable-multi-select-heading--section {
        text-transform: uppercase;
        color: #6c757d;
        white-space: nowrap;
        padding: 0.5rem 0 0.25rem;
    }
`;
const SelectedListFrame = styled.div `
    margin-bottom: 0.5rem;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.14);

    .grouped-sortable-multi-select-selected-list .list-group-item {
        border: none;
        border-radius: 0;
    }
    .grouped-sortable-multi-select-selected-list .list-group-item:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
    }
`;
const Catalog = styled.div `
    width: 100%;
    box-sizing: border-box;
    color: ${styles.theme.fontColors.metallicBlue};

    .section-all {
        cursor: pointer;
        text-decoration: underline;
        user-select: none;
    }
    .grouped-sortable-multi-select-catalog-list .list-group-item {
        margin-top: 0.067rem;
        margin-bottom: 0.067rem;
        padding: 0.25rem 0.5rem;
        border-radius: 0 !important;
        border: 1px solid rgba(0, 0, 0, 0.14) !important;
        background-color: #f8f9fa;
        cursor: pointer;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
function catalogItemsForSection(section, allItems, selectedSet) {
    return allItems
        .filter((it) => it.section === section && !selectedSet.has(it.id))
        .sort((a, b) => {
        var _a, _b;
        const d = ((_a = a.sectionSort) !== null && _a !== void 0 ? _a : 0) - ((_b = b.sectionSort) !== null && _b !== void 0 ? _b : 0);
        return d !== 0 ? d : a.name.localeCompare(b.name);
    });
}
function GroupedSortableMultiSelect({ sections, items, selected, onSelectedChange, }) {
    const selectedIds = useMemo(() => selected.map((r) => r.id), [selected]);
    const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);
    const selectedById = useMemo(() => new Map(selected.map((s) => [s.id, s])), [selected]);
    const itemById = useMemo(() => new Map(items.map((it) => [it.id, it])), [items]);
    const sectionNameBySection = useMemo(() => new Map(sections.map((s) => [s.section, s.name])), [sections]);
    const sortableList = useMemo(() => selectedIds.map((id) => ({ id })), [selectedIds]);
    const catalogSections = useMemo(() => sections.flatMap((sec) => {
        const catalogItems = catalogItemsForSection(sec.section, items, selectedSet);
        return catalogItems.length ? [{ sec, catalogItems }] : [];
    }), [sections, items, selectedSet]);
    const removeId = (id) => {
        if (selected.length <= 1)
            return;
        onSelectedChange(selected.filter((x) => x.id !== id));
    };
    const addById = (id) => {
        if (selectedSet.has(id))
            return;
        const row = itemById.get(id);
        if (row !== undefined)
            onSelectedChange([...selected, row]);
    };
    const addAllInSection = (section) => {
        const toAdd = catalogItemsForSection(section, items, selectedSet);
        if (toAdd.length > 0)
            onSelectedChange([...selected, ...toAdd]);
    };
    return (React.createElement(Root, null,
        React.createElement("div", { className: "grouped-sortable-multi-select-heading grouped-sortable-multi-select-heading--showing" }, "Showing:"),
        React.createElement(SelectedListFrame, null,
            React.createElement(ListGroup, { className: "grouped-sortable-multi-select-selected-list rounded-0 border-0 shadow-none" },
                React.createElement(ReactSortable, { list: sortableList, setList: (next) => {
                        onSelectedChange(next.flatMap(({ id }) => {
                            const row = selectedById.get(id);
                            return row !== undefined ? [row] : [];
                        }));
                    }, animation: 150, handle: ".grouped-sortable-multi-select-drag-handle" }, sortableList.map(({ id }) => {
                    var _a, _b;
                    const it = itemById.get(id);
                    const sectionLabel = it !== undefined
                        ? (_a = sectionNameBySection.get(it.section)) !== null && _a !== void 0 ? _a : it.section
                        : '';
                    const canRm = selected.length > 1;
                    const labelText = (_b = it === null || it === void 0 ? void 0 : it.name) !== null && _b !== void 0 ? _b : id;
                    return (React.createElement(ListGroup.Item, { key: id, className: "d-flex justify-content-between align-items-center py-1 px-2" },
                        React.createElement("span", { className: "d-flex flex-grow-1 text-nowrap", style: {
                                minWidth: 0,
                                cursor: canRm ? 'pointer' : 'default',
                                opacity: canRm ? 1 : 0.85,
                            }, onClick: () => canRm && removeId(id), title: labelText },
                            React.createElement("strong", null, sectionLabel),
                            ":",
                            React.createElement("span", { className: "text-truncate flex-grow-1 ms-1", style: { minWidth: 0 } }, labelText)),
                        React.createElement("span", { className: "grouped-sortable-multi-select-drag-handle d-inline-flex flex-shrink-0", style: { cursor: 'grab' }, "aria-label": "Reorder" },
                            React.createElement(Icon, { icon: "nyy-move" }))));
                })))),
        catalogSections.length > 0 && (React.createElement(Catalog, { className: "grouped-sortable-multi-select-catalog" }, catalogSections.map(({ sec, catalogItems }) => (React.createElement("div", { key: sec.section, className: "mb-3" },
            React.createElement("div", { className: "grouped-sortable-multi-select-heading grouped-sortable-multi-select-heading--section" },
                React.createElement("strong", null, sec.name),
                ' ',
                React.createElement("span", { className: "section-all", role: "button", tabIndex: 0, onClick: () => addAllInSection(sec.section), onKeyDown: (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            addAllInSection(sec.section);
                        }
                    } }, "(All)")),
            React.createElement(ListGroup, { variant: "flush", className: "grouped-sortable-multi-select-catalog-list" }, catalogItems.map((stat) => (React.createElement(ListGroup.Item, { key: stat.id, action: true, className: "grouped-sortable-multi-select-catalog-item", title: stat.id, onClick: () => addById(stat.id) }, stat.name)))))))))));
}

// Helper function to shuffle an array (Fisher-Yates algorithm)
const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
};
const ConcentrationGrid = () => {
    // Game state variables with explicit types
    const [currentNumberToClick, setCurrentNumberToClick] = useState(0);
    const [gameStarted, setGameStarted] = useState(false);
    const [timerDisplay, setTimerDisplay] = useState('00:00.000');
    const [showModal, setShowModal] = useState(false);
    const [finalTime, setFinalTime] = useState('00:00.000');
    const [gridNumbers, setGridNumbers] = useState([]); // Array of GridItem objects
    // Refs for mutable values that don't trigger re-renders
    const startTimeRef = useRef(0);
    const timerIntervalRef = useRef(null); // Type for setInterval ID
    // Function to format elapsed time into MM:SS.mmm
    const formatTime = useCallback((milliseconds) => {
        const minutes = Math.floor(milliseconds / 60000);
        const seconds = Math.floor((milliseconds % 60000) / 1000);
        const ms = milliseconds % 1000;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
    }, []);
    // Function to start the game timer
    const startTimer = useCallback(() => {
        startTimeRef.current = Date.now();
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
        }
        // Explicitly cast the return type of setInterval to number
        timerIntervalRef.current = window.setInterval(() => {
            const elapsedTime = Date.now() - startTimeRef.current;
            setTimerDisplay(formatTime(elapsedTime));
        }, 10);
    }, [formatTime]); // Dependency: formatTime
    // Function to stop the game timer
    const stopTimer = useCallback(() => {
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
        }
    }, []);
    // Function to create and populate the grid with shuffled numbers
    const createGrid = useCallback(() => {
        const numbers = Array.from({ length: 100 }, (_, i) => i);
        shuffleArray(numbers);
        setGridNumbers(numbers.map((num) => ({ value: num, clicked: false })));
    }, []);
    // Function to reset the game state
    const resetGame = useCallback(() => {
        stopTimer();
        setCurrentNumberToClick(0);
        setGameStarted(false);
        setTimerDisplay('00:00.000');
        setShowModal(false);
        createGrid();
    }, [stopTimer, createGrid]);
    // Handler for a cell click
    const handleCellClick = useCallback((event) => {
        if (!gameStarted) {
            return;
        }
        // Accessing dataset requires type assertion or checking
        const clickedValue = parseInt(event.target.dataset.value || '0');
        if (clickedValue === currentNumberToClick) {
            setGridNumbers((prevNumbers) => prevNumbers.map((item) => {
                if (item.value === clickedValue) {
                    return Object.assign(Object.assign({}, item), { clicked: true });
                }
                return item;
            }));
            setCurrentNumberToClick((prev) => prev + 1);
            if (currentNumberToClick === 99) {
                stopTimer();
                setGameStarted(false);
                const elapsedTime = Date.now() - startTimeRef.current;
                setFinalTime(formatTime(elapsedTime));
                setShowModal(true);
            }
        }
    }, [gameStarted, currentNumberToClick, stopTimer, formatTime]);
    // Effect to initialize the grid on component mount
    useEffect(() => {
        createGrid();
    }, [createGrid]);
    // Effect to manage the timer based on gameStarted state
    useEffect(() => {
        if (gameStarted) {
            startTimer();
        }
        else {
            stopTimer();
        }
        return () => stopTimer(); // Cleanup on unmount or gameStarted change
    }, [gameStarted, startTimer, stopTimer]);
    return (React.createElement("div", { className: "flex flex-col items-center justify-center p-4 w-full min-h-screen" },
        React.createElement("h1", { className: "text-5xl font-extrabold text-gray-800 mb-8 tracking-tight" }, "Concentration Grid"),
        React.createElement("div", { className: "flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-8 mb-10" },
            React.createElement("button", { id: "startButton", className: "game-button", type: "button" // Added explicit type="button"
                , onClick: () => {
                    if (!gameStarted) {
                        resetGame();
                        setGameStarted(true);
                    }
                    else {
                        resetGame();
                    }
                } }, gameStarted ? 'Restart Game' : 'Start Game'),
            React.createElement("div", { className: "text-4xl font-mono text-gray-700 bg-gray-100 px-7 py-3 rounded-xl shadow-inner border border-gray-200" },
                "Time: ",
                React.createElement("span", { id: "timerDisplay" }, timerDisplay))),
        React.createElement("div", { id: "gameGrid", className: "grid-container bg-white rounded-2xl shadow-xl" }, gridNumbers.map((item) => (React.createElement("div", { key: item.value, className: `grid-cell ${item.clicked ? 'clicked' : ''}`, "data-value": item.value.toString(), id: `cg-${item.value.toString()}`, onClick: handleCellClick }, item.value.toString().padStart(2, '0'))))),
        React.createElement("div", { id: "completionModal", className: `modal-overlay ${showModal ? 'show' : ''}` },
            React.createElement("div", { className: "modal-content" },
                React.createElement("h2", { className: "text-4xl font-bold text-gray-800 mb-5" }, "Congratulations!"),
                React.createElement("p", { className: "text-2xl text-gray-700 mb-7" }, "You completed the game in:"),
                React.createElement("p", { id: "finalTime", className: "text-6xl font-extrabold text-blue-600 mb-10" }, finalTime),
                React.createElement("button", { id: "closeModalButton", className: "game-button", type: "button" // Added explicit type="button"
                    , onClick: resetGame }, "Play Again"))),
        React.createElement("style", null, `
                .grid-container {
                    display: grid;
                    grid-template-columns: repeat(10, 1fr);
                    grid-template-rows: repeat(10, 1fr);
                    gap: 0.25rem;
                    width: 100%;
                    max-width: 600px;
                    aspect-ratio: 1 / 1;
                    padding: 0.5rem;
                }
                .grid-cell {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 0.875rem;
                    font-weight: bold;
                    background-color: #cbd5e1;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out, box-shadow 0.2s ease-in-out;
                    user-select: none;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.08);
                    color: #334155;
                }
                .grid-cell:hover:not(.clicked) {
                    background-color: #94a3b8;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.12);
                }
                .grid-cell.clicked {
                    background-color: #1a202c; /* Very dark gray for clicked background */
                    color: #a0aec0; /* Lighter text color for contrast */
                    cursor: default;
                    box-shadow: inset 0 1px 2px rgba(0,0,0,0.08);
                    transform: none;
                }
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.7);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity 0.3s ease, visibility 0.3s ease;
                }
                .modal-overlay.show {
                    opacity: 1;
                    visibility: visible;
                }
                .modal-content {
                    background-color: white;
                    padding: 2.5rem;
                    border-radius: 1.5rem;
                    text-align: center;
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
                    transform: translateY(-30px);
                    transition: transform 0.3s ease;
                    max-width: 90%;
                }
                .modal-overlay.show .modal-content {
                    transform: translateY(0);
                }
                .game-button {
                    background-image: linear-gradient(to right, #6366f1 0%, #3b82f6 100%);
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease-in-out;
                    border: none;
                    padding: 1rem 2.5rem;
                    font-size: 1.125rem;
                    font-weight: 600;
                    color: white;
                    border-radius: 9999px;
                    cursor: pointer;
                    outline: none;
                }
                .game-button:hover {
                    transform: translateY(-2px) scale(1.02);
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
                }
                .game-button:active {
                    transform: translateY(0);
                    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
                }
            `)));
};

// eslint-disable-next-line max-len
const HAT_PNG_DATA_URI = 'data:image/png;base64,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';
const LoadingHats = ({ size = 320, speed = 1, showBall = true }) => {
    const baseWidth = 320;
    const s = size / baseWidth;
    const vars = {
        // geometry
        '--spinnerWidth': `${size}px`,
        '--capWidth': `${Math.round(90 * s)}px`,
        '--laneGap': `${Math.round(115 * s)}px`,
        '--restBottom': `${Math.round(50 * s)}px`,
        '--dropHeight': `${Math.round(180 * s)}px`,
        '--ballSize': `${Math.round(35 * s)}px`,
        // timing (scale with speed)
        '--drop': `${(0.6 / speed).toFixed(3)}s`,
        '--cycle': `${(3 / speed).toFixed(3)}s`,
        // shadows
        '--hatShadow': `${Math.max(0.5, 2 * s)}px`,
    };
    // Unique scope so multiple instances don’t clash.
    const scope = React.useMemo(() => `hts-${Math.random().toString(36).slice(2, 8)}`, []);
    return (React.createElement("div", { className: `${scope}`, style: Object.assign({ position: 'relative', width: 'var(--spinnerWidth)', height: Math.max(0, Math.round(240 * s)) }, vars), "aria-label": "Loading", role: "img" },
        React.createElement("style", null, `
        .${scope} .hat {
          position: absolute;
          bottom: calc(var(--restBottom) + var(--dropHeight));
          width: var(--capWidth);
          animation: ${scope}-drop var(--drop) ease-out forwards,
                     ${scope}-moveLoop var(--cycle) var(--drop) infinite;
          z-index: 2;
        }
        .${scope} .hat img {
          width: 100%;
          height: auto;
          display: block;
          filter: drop-shadow(0 var(--hatShadow) var(--hatShadow) rgba(0,0,0,.55));
          pointer-events: none;
          user-select: none;
        }

        /* Lane starts */
        .${scope} .hat1 { left: 0;                       animation-name: ${scope}-drop, ${scope}-move1; }
        .${scope} .hat2 { left: var(--laneGap);          animation-name: ${scope}-drop, ${scope}-move2; }
        .${scope} .hat3 { left: calc(var(--laneGap) * 2); animation-name: ${scope}-drop, ${scope}-move3; }

        /* Ball (briefly shown behind hats, then hidden) */
        .${scope} .ball {
          position: absolute;
          bottom: var(--restBottom);
          left: calc(var(--laneGap) + (var(--capWidth) - var(--ballSize)) / 2);
          width: var(--ballSize);
          height: var(--ballSize);
          border-radius: 50%;
          background: radial-gradient(circle at 55% 45%, #fff 65%, #ececec 72%, #d8d8d8 100%);
          box-shadow: inset 0 0 0 1px #bdbdbd;
          z-index: 1;
          opacity: ${showBall ? 1 : 0};
          animation: ${scope}-hideBall 0.01s linear forwards;
          animation-delay: calc(var(--drop) - 0.05s);
        }
        .${scope} .ball::before {
          content: "";
          position: absolute; inset: 0;
          border-radius: 50%;
          /* fewer stitches */
          background:
            radial-gradient(circle at 60% 40%, #c40000 1px, transparent 2px) 0 0/10px 10px,
            radial-gradient(circle at 40% 60%, #c40000 1px, transparent 2px) 5px 5px/10px 10px;
          opacity: .75;
        }

        /* Keyframes tied to CSS variables (all scale from size) */
        @keyframes ${scope}-drop {
          from { bottom: calc(var(--restBottom) + var(--dropHeight)); }
          to   { bottom: var(--restBottom); }
        }
        @keyframes ${scope}-move1 {
          0%, 100% { left: 0; }
          25%      { left: var(--laneGap); }
          50%      { left: calc(var(--laneGap) * 2); }
          75%      { left: var(--laneGap); }
        }
        @keyframes ${scope}-move2 {
          0%, 100% { left: var(--laneGap); }
          25%      { left: 0; }
          50%      { left: var(--laneGap); }
          75%      { left: calc(var(--laneGap) * 2); }
        }
        @keyframes ${scope}-move3 {
          0%, 100% { left: calc(var(--laneGap) * 2); }
          25%      { left: calc(var(--laneGap) * 2); }
          50%      { left: 0; }
          75%      { left: 0; }
        }
        @keyframes ${scope}-hideBall { to { opacity: 0; } }
      `),
        React.createElement("div", { className: "hat hat1", "aria-hidden": "true" },
            React.createElement("img", { src: HAT_PNG_DATA_URI, alt: "" })),
        React.createElement("div", { className: "hat hat2", "aria-hidden": "true" },
            React.createElement("img", { src: HAT_PNG_DATA_URI, alt: "" })),
        React.createElement("div", { className: "hat hat3", "aria-hidden": "true" },
            React.createElement("img", { src: HAT_PNG_DATA_URI, alt: "" })),
        React.createElement("div", { className: "ball" })));
};

const LoadingSubway = ({ size = 360, speed = 1 }) => {
    const scope = 'subway-loader';
    const scale = size / 360;
    const vars = {
        '--size': `${size}px`,
        '--height': `${Math.round(150 * scale)}px`,
        '--track-thickness': `${Math.round(6 * scale)}px`,
        '--car-w': `${Math.round(46 * scale)}px`,
        '--car-h': `${Math.round(22 * scale)}px`,
        '--car-gap': `${Math.round(6 * scale)}px`,
        '--corner': `${Math.round(7 * scale)}px`,
        // badge scales
        '--badge-size': `${Math.max(10, Math.round(16 * scale))}px`,
        '--badge-font': `${Math.max(8, Math.round(11 * scale))}px`,
        '--badge-offset': `${Math.max(3, Math.round(6 * scale))}px`,
        // speeds (scaled by speed multiplier)
        '--speed1': `${(2.8 / speed).toFixed(3)}s`,
        '--speed2': `${(3.1 / speed).toFixed(3)}s`,
        '--speed3': `${(3.4 / speed).toFixed(3)}s`,
        '--jitter': `${(0.22 / speed).toFixed(3)}s`,
    };
    return (React.createElement("div", { className: scope, role: "img", "aria-label": "Loading subway race", style: vars },
        React.createElement("style", null, `
        .${scope} {
          --line1: #2db355;
          --line2: #ff7a00;
          --line3: #ff7a00;
          --train-len: calc(var(--car-w) * 2.85 + var(--car-gap) * 2);
          width: var(--size);
          height: var(--height);
          position: relative;
          display: grid;
          place-items: center;
          background: transparent;
          filter: saturate(1.05);
          overflow: hidden;
        }

        .${scope} .track {
          position: absolute; left: 0; width: 100%;
          height: var(--track-thickness);
          background:
            radial-gradient(circle at 10% 50%, #777 0 55%, transparent 56%),
            linear-gradient(#8b8b8b,#6a6a6a);
          border-radius: 999px; overflow: hidden;
        }
        .${scope} .track.t1 { top: calc(22% - var(--track-thickness)/2); }
        .${scope} .track.t2 { top: calc(50% - var(--track-thickness)/2); }
        .${scope} .track.t3 { top: calc(78% - var(--track-thickness)/2); }
        .${scope} .track::after {
          content:""; position:absolute; inset:0;
          background: repeating-linear-gradient(to right, transparent 0 20px, rgba(255,255,255,.28) 20px 26px);
          opacity:.45;
        }

        .${scope} .train {
          position: absolute; left: 0;
          display: inline-flex; align-items: center; gap: var(--car-gap);
          filter: drop-shadow(0 4px 10px rgba(0,0,0,.25));
          animation: moveLR linear infinite alternate, bob ease-in-out infinite alternate;
        }
        .${scope} .train.t1 { top: calc(22% - var(--car-h)/2); animation-duration: var(--speed1), var(--jitter); }
        .${scope} .train.t2 { top: calc(50% - var(--car-h)/2); animation-duration: var(--speed2), calc(var(--jitter)*1.1); }
        .${scope} .train.t3 { top: calc(78% - var(--car-h)/2); animation-duration: var(--speed3), calc(var(--jitter)*.9); }

        @keyframes moveLR { 0% { left: 0; } 100% { left: calc(100% - var(--train-len)); } }
        @keyframes bob { from { transform: translateY(-1px); } to { transform: translateY(1px); } }

        .${scope} .car {
          width: var(--car-w); height: var(--car-h);
          background: linear-gradient(#e9edf2,#cfd7e1);
          border-radius: var(--corner); position: relative; overflow: hidden;
          box-shadow: inset 0 -2px 4px rgba(0,0,0,.15);
        }
        .${scope} .car.mid { width: calc(var(--car-w) * .95); }
        .${scope} .car.tail { width: calc(var(--car-w) * .9); border-top-right-radius: 999px; border-bottom-right-radius: 999px; }
        .${scope} .car::before {
          content:""; position:absolute; left: 6px; right: 6px; top: 4px; height: 8px;
          background: linear-gradient(90deg, rgba(0,0,0,.3) 30%, rgba(255,255,255,.25) 55%, rgba(0,0,0,.25) 80%);
          border-radius: 4px; opacity:.75;
          /* This strip looks fine without scaling; can be scaled if desired */
        }
        .${scope} .car::after {
          content:""; position:absolute; top:0; bottom:0; left:50%; width:1px; background: rgba(0,0,0,.12);
        }

        /* Scaled badge */
        .${scope} .badge {
          position: absolute;
          left: var(--badge-offset);
          bottom: var(--badge-offset);
          width: var(--badge-size);
          height: var(--badge-size);
          border-radius: 50%;
          display: grid; place-items: center;
          font-weight: 700;
          font-size: var(--badge-font);
          line-height: 1;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
          color: #fff;
          text-shadow: 0 1px 0 rgba(0,0,0,.35);
        }
        .${scope} .t1 .badge { background: var(--line1); }
        .${scope} .t2 .badge { background: var(--line2); }
        .${scope} .t3 .badge { background: var(--line3); }

        @media (prefers-reduced-motion: reduce) {
          .${scope} .train { animation: none !important; }
        }
      `),
        React.createElement("div", { className: "track t1" }),
        React.createElement("div", { className: "track t2" }),
        React.createElement("div", { className: "track t3" }),
        React.createElement("div", { className: "train t1" },
            React.createElement("div", { className: "car" },
                React.createElement("span", { className: "badge" }, "4")),
            React.createElement("div", { className: "car mid" }),
            React.createElement("div", { className: "car tail" })),
        React.createElement("div", { className: "train t2" },
            React.createElement("div", { className: "car" },
                React.createElement("span", { className: "badge" }, "B")),
            React.createElement("div", { className: "car mid" }),
            React.createElement("div", { className: "car tail" })),
        React.createElement("div", { className: "train t3" },
            React.createElement("div", { className: "car" },
                React.createElement("span", { className: "badge" }, "D")),
            React.createElement("div", { className: "car mid" }),
            React.createElement("div", { className: "car tail" }))));
};

const divider = `1px solid ${theme.border.alto}`;
const TimelineRail = styled.header `
    background: ${({ $accentColor }) => $accentColor};
    border-right: ${divider};
    box-sizing: border-box;
    color: white;
    display: flex;
    flex: 0 0 170px;
    flex-direction: column;
    gap: 0.35rem;
    padding: 0.5rem;
    text-align: left;

    @media print {
        flex-basis: 150px;
    }

    h4, h5 {
        color: inherit;
        margin: 0;
    }

    h4 {
        font-size: 1rem;
        font-weight: bold;
        line-height: 1.25;
        overflow-wrap: anywhere;
    }

    h5 {
        font-size: 0.82rem;
        font-weight: normal;
        line-height: 1.3;
    }
`;
const TimelineRailHeadings = styled.div `
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
`;
const TimelineRailMeta = styled.div `
    font-size: 0.75rem;
    font-weight: normal;
    line-height: 1.3;
    margin-top: auto;
    overflow-wrap: anywhere;
`;
const TimelineBody = styled.div `
    background: white;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-width: 0;
    overflow-x: auto;
    padding: 0.5rem;

    @media print {
        overflow: visible;
    }
`;
const TimelineArticle = styled.article `
    border: ${divider};
    border-bottom: 0;
    box-sizing: border-box;
    break-inside: avoid;
    display: flex;
    page-break-inside: avoid;

    &:last-of-type {
        border-bottom: ${divider};
    }

    @media (max-width: 767px) {
        display: block;
    }

    @media print {
        display: flex;
    }
`;
const TimelineEvent = ({ accentColor, heading, supportingHeadings = [], date, author, children, className, }) => (React.createElement(TimelineArticle, { className: className },
    React.createElement(TimelineRail, { "$accentColor": accentColor },
        React.createElement(TimelineRailHeadings, null,
            React.createElement("h4", null, heading),
            React.Children.map(supportingHeadings.filter(Boolean), (supportingHeading) => React.createElement("h5", null, supportingHeading))),
        (author || date) ? (React.createElement(TimelineRailMeta, null,
            date ? React.createElement("div", null, date) : null,
            author ? React.createElement("div", null, author) : null)) : null),
    React.createElement(TimelineBody, null, children)));

const fiveSegmentColors = ['#1797f2', '#239fd2', '#30b19d', '#35bc7a', '#45cf3c'];
const sixSegmentColors = ['#1797f2', '#20a2cd', '#29ada9', '#32b884', '#3bc360', '#45cf3c'];
const StatusBar = styled.div `
    display: inline-flex;
    gap: ${({ $editable }) => ($editable ? '3px' : '1px')};
    vertical-align: middle;
`;
const Segment = styled.span `
    background: ${({ $color, $filled }) => ($filled ? $color : 'white')};
    border: ${({ $bordered }) => ($bordered ? '1px solid #777' : '0')};
    border-radius: ${({ $editable, $first, $last }) => {
    const radius = $editable ? '20px' : '5px';
    if ($first)
        return `${radius} 0 0 ${radius}`;
    if ($last)
        return `0 ${radius} ${radius} 0`;
    return '0';
}};
    display: inline-block;
    height: ${({ $editable }) => ($editable ? '40px' : '10px')};
    width: ${({ $editable }) => ($editable ? '60px' : '20px')};
`;
const SegmentButton = styled.button `
    appearance: none;
    background: transparent;
    border: 0;
    display: inline-flex;
    margin: 0;
    padding: 0;

    &:focus-visible {
        outline: 2px solid #154488;
        outline-offset: 2px;
    }
`;
const ObjectiveStatusBar = ({ status, completionPct, bordered = false, editable = false, includeZero = false, onChange, className, }) => {
    if (status === 2)
        return null;
    const colors = includeZero ? sixSegmentColors : fiveSegmentColors;
    const completionValues = colors.map((_, index) => (100 * (includeZero ? index : index + 1)) / 5);
    return (React.createElement(StatusBar, { "$editable": editable, "aria-label": completionPct == null ? 'Completion status not set' : `${completionPct}% complete`, className: className, role: editable ? 'group' : 'img' }, completionValues.map((segmentCompletionPct, index) => {
        const segment = (React.createElement(Segment, { "$bordered": bordered, "$color": colors[index], "$editable": editable, "$filled": completionPct != null && completionPct >= segmentCompletionPct, "$first": index === 0, "$last": index === completionValues.length - 1 }));
        return editable ? (React.createElement(SegmentButton, { "aria-label": `Set completion to ${segmentCompletionPct}%`, key: segmentCompletionPct, onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(segmentCompletionPct), type: "button" }, segment)) : React.cloneElement(segment, { key: segmentCompletionPct });
    })));
};

const ObjectiveCard = styled.section `
    background: white;
    border: 1px solid ${theme.border.alto};
    border-bottom-width: 2px;
    break-inside: avoid;
    page-break-inside: avoid;

    > header {
        align-items: center;
        background: ${({ $status }) => {
    if ($status === 2)
        return theme.background.boulder;
    if ($status === 4)
        return '#aa0000';
    return theme.background.astronaut;
}};
        color: white;
        display: flex;
        justify-content: space-between;
        min-height: 34px;
        padding: 0.45rem 0.75rem;
    }

    > header h3 {
        color: inherit;
        font-size: 1rem;
        margin: 0;
    }
`;
const HeaderStatus = styled.div `
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 0.86rem;
    gap: 0.5rem;
    justify-content: flex-end;
    margin-left: 1rem;
`;
const ObjectiveSection = styled.div `
    border-top: 1px solid ${theme.border.alto};
    padding: 0.75rem;
`;
const SummaryRow = styled.div `
    align-items: flex-start;
    display: flex;
    width: 100%;
`;
const SummaryDisclosure = styled.div `
    display: flex;
    flex: 0 0 1.5rem;
    justify-content: flex-start;
    margin-right: 0.25rem;
    padding-top: 0.12rem;

    button {
        align-items: flex-start;
        display: inline-flex !important;
        font-size: 1rem !important;
        height: 1.15rem;
        line-height: 1 !important;
        padding: 0 !important;
    }

    svg {
        display: block;
        height: 14px;
        padding: 0;
        width: 14px;
    }
`;
const SummaryContent = styled.div `
    color: ${theme.fontColors.mineShaft};
    flex: 1 1 auto;
    font-size: 1rem;
    min-width: 0;

    p {
        margin-top: 0;
    }

    p:last-child {
        margin-bottom: 0;
    }
`;
const DisclosureRow = styled.div `
    align-items: center;
    color: ${theme.fontColors.darkBlue} !important;
    display: flex !important;
    font-weight: bold !important;
    gap: 0.25rem;
    padding: 0 !important;
    text-decoration: none !important;

    button {
        display: inline-flex !important;
        flex: 0 0 auto;
        font-size: 1rem !important;
        line-height: 1 !important;
        padding: 0 !important;
    }

    svg {
        display: block;
        height: 14px;
        padding: 0;
        width: 14px;
    }
`;
const DetailColumns = styled.div `
    display: grid;
    gap: 1.25rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;
const DetailList = styled.div `
    h4 {
        color: ${theme.fontColors.darkBlue};
        font-size: 1rem;
        margin: 0 0 0.5rem;
    }

    p {
        margin: 0.35rem 0;
    }

    small {
        color: ${theme.fontColors.doveGray};
        display: block;
        font-style: italic;
    }
`;
const Metric = styled.div `
    border-top: 1px solid ${theme.border.mercury};
    margin-top: 0.75rem;
    padding-top: 0.75rem;
`;
const EmptyText = styled.i `
    color: ${theme.fontColors.doveGray};
`;
const ActionPlanText = styled.p `
    white-space: pre-line;
`;
const Html = ({ value }) => (value ? React.createElement("div", { dangerouslySetInnerHTML: { __html: value } }) : null);
const actionPlanText = (value) => (value !== null && value !== void 0 ? value : '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<li(?:\s[^>]*)?>/gi, '• ')
    .replace(/<\/(?:div|h[1-6]|li|p)>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, '\'')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
const ActionPlanDescription = ({ value }) => (value ? React.createElement(ActionPlanText, null, actionPlanText(value)) : null);
const textFieldHtml = (value) => (value ? value.trim().replace(/\n/g, '<br/>').replace(/\\n/g, '<br/>') : value);
const statusLabel = (status) => {
    if (status === 1)
        return 'Completed';
    if (status === 2)
        return 'Future Objective';
    if (status === 3)
        return 'Archived';
    if (status === 4)
        return 'Aborted';
    return 'Completion Status';
};
const Drill = ({ objectiveDrill, showAudit }) => {
    var _a, _b;
    const content = objectiveDrill.Drill.URL ? (React.createElement("a", { href: objectiveDrill.Drill.URL, rel: "noreferrer", target: "_blank", title: (_a = objectiveDrill.Drill.Description) !== null && _a !== void 0 ? _a : undefined }, objectiveDrill.Drill.Name)) : React.createElement("span", { title: (_b = objectiveDrill.Drill.Description) !== null && _b !== void 0 ? _b : undefined }, objectiveDrill.Drill.Name);
    return (React.createElement("div", null,
        React.createElement("p", null, content),
        showAudit && (objectiveDrill.CreatedUser || objectiveDrill.CreatedDate) && (React.createElement("small", null,
            "(",
            objectiveDrill.CreatedUser,
            " entered on ",
            dateTime(objectiveDrill.CreatedDate),
            ")"))));
};
const ObjectiveDisplay = ({ objective, expanded, onExpandedChange, renderNotes, renderMetric, renderActionPlanDescription, notesCount, showTitle = false, className, }) => {
    var _a, _b, _c, _d, _e;
    const [metricsExpanded, setMetricsExpanded] = useState(expanded);
    const [notesExpanded, setNotesExpanded] = useState(expanded);
    const [historyExpanded, setHistoryExpanded] = useState(false);
    const actionPlanItems = (_a = objective.ActionPlanItems) !== null && _a !== void 0 ? _a : [];
    const drills = (_b = objective.Drills) !== null && _b !== void 0 ? _b : [];
    const metrics = (_c = objective.Metrics) !== null && _c !== void 0 ? _c : [];
    const logs = (_d = objective.Logs) !== null && _d !== void 0 ? _d : [];
    const renderActionPlanItemDescription = (item, index) => (renderActionPlanDescription
        ? renderActionPlanDescription(item, index)
        : React.createElement(ActionPlanDescription, { value: item.Description }));
    useEffect(() => {
        setMetricsExpanded(expanded);
        setNotesExpanded(expanded);
    }, [expanded]);
    return (React.createElement(ObjectiveCard, { "$status": objective.Status, className: className },
        showTitle && (React.createElement("header", null,
            React.createElement("h3", null,
                objective.Pinned ? 'Pinned · ' : '',
                objective.Restricted ? 'Restricted · ' : '',
                ((_e = objective.Player) === null || _e === void 0 ? void 0 : _e.FullName) ? `${objective.Player.FullName} — ` : '',
                objective.Title),
            React.createElement(HeaderStatus, null,
                React.createElement("span", null, statusLabel(objective.Status)),
                objective.IsPlayerViewable ? React.createElement("span", null, "Shared with Player") : null))),
        React.createElement(ObjectiveSection, null,
            React.createElement(SummaryRow, null,
                React.createElement(SummaryDisclosure, { className: "d-print-none" },
                    React.createElement(DrilldownToggle, { isOpen: expanded, onClick: () => onExpandedChange(!expanded), ariaLabel: "Toggle objective details" })),
                React.createElement(SummaryContent, null, objective.Summary
                    ? React.createElement("div", { dangerouslySetInnerHTML: { __html: objective.Summary } })
                    : React.createElement(EmptyText, null, "No summary provided."))),
            !expanded && (actionPlanItems.length > 0 || drills.length > 0) && (React.createElement(DetailColumns, { className: "mt-3" },
                actionPlanItems.length > 0 && (React.createElement(DetailList, null,
                    React.createElement("h4", null, "Action Plan"),
                    actionPlanItems.map((item, index) => {
                        var _a, _b;
                        return (React.createElement(React.Fragment, { key: (_a = item.ObjectiveActionPlanItemID) !== null && _a !== void 0 ? _a : `${(_b = item.CreatedDate) !== null && _b !== void 0 ? _b : 'action'}-${index}` }, renderActionPlanItemDescription(item, index)));
                    }))),
                drills.length > 0 && (React.createElement(DetailList, null,
                    React.createElement("h4", null, "Drills"),
                    drills.map((objectiveDrill, index) => {
                        var _a, _b;
                        return (React.createElement(Drill, { key: (_a = objectiveDrill.ObjectiveDrillID) !== null && _a !== void 0 ? _a : `${(_b = objectiveDrill.Drill.Name) !== null && _b !== void 0 ? _b : 'drill'}-${index}`, objectiveDrill: objectiveDrill, showAudit: false }));
                    })))))),
        expanded && (React.createElement(ObjectiveSection, null,
            React.createElement(DetailColumns, null,
                React.createElement(DetailList, null,
                    React.createElement("h4", null, "Action Plan"),
                    actionPlanItems.map((item, index) => {
                        var _a, _b;
                        return (React.createElement("div", { key: (_a = item.ObjectiveActionPlanItemID) !== null && _a !== void 0 ? _a : `${(_b = item.CreatedDate) !== null && _b !== void 0 ? _b : 'action'}-${index}` },
                            renderActionPlanItemDescription(item, index),
                            (item.CreatedUser || item.CreatedDate) && (React.createElement("small", null,
                                "(",
                                item.CreatedUser,
                                " created on ",
                                dateTime(item.CreatedDate),
                                ")"))));
                    })),
                React.createElement(DetailList, null,
                    React.createElement("h4", null, "Drills"),
                    drills.map((objectiveDrill, index) => {
                        var _a, _b;
                        return (React.createElement(Drill, { key: (_a = objectiveDrill.ObjectiveDrillID) !== null && _a !== void 0 ? _a : `${(_b = objectiveDrill.Drill.Name) !== null && _b !== void 0 ? _b : 'drill'}-${index}`, objectiveDrill: objectiveDrill, showAudit: true }));
                    }))))),
        metrics.length > 0 && (React.createElement(ObjectiveSection, null,
            React.createElement(DisclosureRow, { className: "d-print-none" },
                React.createElement(DrilldownToggle, { isOpen: metricsExpanded, onClick: () => setMetricsExpanded((isOpen) => !isOpen), ariaLabel: "Toggle metrics" }),
                "Metrics (",
                metrics.length,
                ")"),
            metricsExpanded && metrics.map((metric, index) => {
                var _a, _b, _c;
                return (React.createElement(Metric, { key: (_a = metric.ObjectiveMetricID) !== null && _a !== void 0 ? _a : `${(_c = (_b = metric.Metric) === null || _b === void 0 ? void 0 : _b.MetricID) !== null && _c !== void 0 ? _c : 'metric'}-${index}` }, renderMetric === null || renderMetric === void 0 ? void 0 : renderMetric(metric, index)));
            }))),
        renderNotes && notesCount !== 0 && (React.createElement(ObjectiveSection, null,
            React.createElement(DisclosureRow, { className: "d-print-none" },
                React.createElement(DrilldownToggle, { isOpen: notesExpanded, onClick: () => setNotesExpanded((isOpen) => !isOpen), ariaLabel: "Toggle notes" }),
                "Notes",
                notesCount == null ? '' : ` (${notesCount})`),
            notesExpanded ? renderNotes() : null)),
        expanded && (React.createElement(ObjectiveSection, null,
            React.createElement(DisclosureRow, { className: "d-print-none" },
                React.createElement(DrilldownToggle, { isOpen: historyExpanded, onClick: () => setHistoryExpanded((isOpen) => !isOpen), ariaLabel: "Toggle history" }),
                "History"),
            historyExpanded && logs.length > 0 && (React.createElement(StyledTable$1, { className: "mt-2", responsive: true, striped: true },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Date"),
                        React.createElement("th", null, "User"),
                        React.createElement("th", null, "Action"))),
                React.createElement("tbody", null, logs.map((log, index) => {
                    var _a, _b;
                    return (React.createElement("tr", { key: (_a = log.ObjectiveLogID) !== null && _a !== void 0 ? _a : `${(_b = log.CreatedDate) !== null && _b !== void 0 ? _b : 'log'}-${index}` },
                        React.createElement("td", null, date(log.CreatedDate)),
                        React.createElement("td", null, log.CreatedUser),
                        React.createElement("td", null,
                            React.createElement(Html, { value: textFieldHtml(log.LogMessage) }))));
                }))))))));
};

// Stick names that fill a different report property. Same-word casing is matched on read.
const stickFieldAliases = {
    othercapablepos: ['OtherCapablePositions'],
    physicaldescription: ['PhysicalDesc'],
    positionseenpitcher: ['positions'],
    positionseenposition: ['Positions'],
    primarypositionpitcher: ['PrimaryPosition'],
    primarypositionposition: ['PrimaryPosition'],
};
const emptyToNull = (value) => (value === '' ? null : value);
const stickFieldRecord = (fields) => {
    const record = {};
    (fields || []).forEach((field) => {
        var _a, _b, _c, _d;
        const name = (_a = field.Name) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
        if (!name)
            return;
        record[name] = {
            value: emptyToNull((_b = field.Value) !== null && _b !== void 0 ? _b : null),
            rawValue: emptyToNull((_d = (_c = field.RawValue) !== null && _c !== void 0 ? _c : field.Value) !== null && _d !== void 0 ? _d : null),
        };
    });
    return record;
};
const isPrimitiveReportValue = (value) => (value == null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean');
// Catalogs read AaCmts and Aacmts for one Stick field. Resolve that here instead of listing both.
const withCaseInsensitiveFields = (report) => {
    const keysByLower = new Map();
    Object.keys(report).forEach((key) => {
        if (key === 'stickFields')
            return;
        const lower = key.toLowerCase();
        if (!keysByLower.has(lower))
            keysByLower.set(lower, key);
    });
    return new Proxy(report, {
        get(target, prop, receiver) {
            if (typeof prop !== 'string' || Reflect.has(target, prop)) {
                return Reflect.get(target, prop, receiver);
            }
            const match = keysByLower.get(prop.toLowerCase());
            return match === undefined ? undefined : target[match];
        },
        has(target, prop) {
            if (typeof prop !== 'string' || Reflect.has(target, prop))
                return Reflect.has(target, prop);
            return keysByLower.has(prop.toLowerCase());
        },
    });
};
const applyStickFieldValues = (report, fields) => {
    const stickFields = stickFieldRecord(fields);
    const next = Object.assign(Object.assign({}, report), { stickFields });
    // Several Stick fields can share an alias (primaryposition, primarypositionposition) and the
    // API returns them unordered, so a translated value must not be overwritten by a raw code.
    const translatedKeys = new Set();
    Object.entries(stickFields).forEach(([name, entry]) => {
        const isTranslated = entry.value !== entry.rawValue;
        const keys = new Set([name, ...(stickFieldAliases[name] || [])]);
        Object.keys(next).forEach((key) => {
            if (key === 'stickFields' || key.toLowerCase() !== name || !isPrimitiveReportValue(next[key]))
                return;
            keys.add(key);
        });
        keys.forEach((key) => {
            if (!isTranslated && translatedKeys.has(key))
                return;
            next[key] = entry.value;
            if (isTranslated)
                translatedKeys.add(key);
        });
    });
    // The proxy resolves catalog casings that are not own properties.
    return withCaseInsensitiveFields(next);
};
const stickEntry = (report, name) => { var _a; return (_a = report === null || report === void 0 ? void 0 : report.stickFields) === null || _a === void 0 ? void 0 : _a[name.toLowerCase()]; };
const fieldValue = (report, name) => {
    const entry = stickEntry(report, name);
    if (entry)
        return entry.value;
    if (!report)
        return null;
    const match = Object.keys(report).find((key) => key.toLowerCase() === name.toLowerCase());
    if (!match)
        return null;
    const value = report[match];
    if (value == null || value === '')
        return null;
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
        return value;
    return null;
};
const rawFieldValue = (report, name) => {
    const entry = stickEntry(report, name);
    if (entry)
        return entry.rawValue;
    return fieldValue(report, name);
};
const rawFieldNumber = (report, name) => {
    const value = rawFieldValue(report, name);
    if (value == null || value === '')
        return null;
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
};

const NegativeSelection = styled.span `
    color: ${theme.background.red};
`;
const MovementDiagram = styled.div `
    background: ${({ $throws }) => {
    if ($throws === 1)
        return `#fff url("${movementChartRight}") no-repeat center center`;
    if ($throws != null && $throws >= 2)
        return `#fff url("${movementChartLeft}") no-repeat center center`;
    return 'none';
}};
    height: 370px;
    margin-top: 0.5rem;
    position: relative;
    width: 370px;
`;
const MovementMarker = styled.img `
    position: absolute;
`;
const MovementViewport = styled.div `
    overflow-x: auto;
`;
const NestedTable = styled.table `
    border-collapse: collapse;
    text-align: center;
    width: 100%;

    th, td {
        border: 0;
        padding: 2px 4px;
        text-align: center;
        white-space: nowrap;
        width: 1%;
    }

    .text-cell {
        text-align: left;
        white-space: normal;
        width: auto;
    }
`;
// Stick pgroup/fgroup values are short grades (8, 7, G). Role prose is not in Stick picklists.
const groupRoles = new Map([
    [1, {
            position: 'Superstar, Dominant at position. Hall of Fame',
            pitcher: 'Dominant (1) Starter, Dominant Closer.  Hall of Fame',
        }],
    [2, {
            position: 'Well above average at his position. Perennial All Star',
            pitcher: 'Top Rotation Starter (1/2), Championship caliber Closer.  Perennial All Star',
        }],
    [4, {
            position: 'Above average player on Championship Club',
            pitcher: 'Middle Rotation Starter (3), Top Setup (occasional closer / 8th inning reliever on Championship Club)',
        }],
    [7, {
            position: 'Average everyday player on Championship Club',
            pitcher: 'Bottom Rotation Starter (4/5), Average setup (7th inn.), Top Situational on Championship Club',
        }],
    [10, {
            position: 'Below average player, role/utility type',
            pitcher: 'Long Reliever/Spot Starter, 2nd Situational or Middle Relief',
        }],
    [12, {
            position: 'Emergency ML help, up/down type',
            pitcher: 'Emergency ML help, up/down type',
        }],
    [13, {
            position: 'Org Value – 2A tops, non-starter (filler) at 3A',
            pitcher: 'Org Value – 2A tops, non-starter (filler) at 3A',
        }],
    [15, {
            position: 'No prospect, no value. Likely release',
            pitcher: 'No prospect, no value. Likely release',
        }],
]);
const display = (value, precision) => {
    var _a;
    if (value == null || value === '')
        return '--';
    if ((typeof value === 'number' || typeof value === 'string') && precision != null)
        return (_a = format(value, precision)) !== null && _a !== void 0 ? _a : '--';
    if (typeof value === 'boolean')
        return value ? 'Y' : 'N';
    return String(value);
};
const stickSelections = (value) => {
    let parsed = value;
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed.startsWith('['))
            return null;
        try {
            parsed = JSON.parse(trimmed);
        }
        catch (_a) {
            return null;
        }
    }
    if (!Array.isArray(parsed) || !parsed.length)
        return null;
    const selections = parsed.filter((item) => (Boolean(item) && typeof item === 'object' && typeof item.name === 'string'));
    if (selections.length !== parsed.length)
        return null;
    return selections.sort((left, right) => Number(left.sortorder || 0) - Number(right.sortorder || 0));
};
const selectionDisplay = (value) => {
    const selections = stickSelections(value);
    if (!selections)
        return display(typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' ? value : null);
    return selections.map((selection, index) => {
        var _a;
        return (React.createElement(React.Fragment, { key: `${selection.name}-${(_a = selection.sortorder) !== null && _a !== void 0 ? _a : index}` },
            index > 0 ? ' | ' : null,
            Number(selection.ispositive) === 1
                ? selection.name
                : React.createElement(NegativeSelection, null, selection.name)));
    });
};
// Combined-search and Stick fields already carry display labels.
const mappedDisplay = (value) => display(value);
// Stick group values are already labels, including numeric ones such as "8".
// Legacy staff evaluations still pass the group enum as a number.
const gradeLabel = (value, isAmateurGrade = false) => {
    if (value == null || value === '')
        return '--';
    if (typeof value === 'string')
        return value;
    return grade(value, isAmateurGrade);
};
const proGradeDisplay = (value) => gradeLabel(value);
const pair = (present, future, precision) => (`${display(present, precision)}/${display(future, precision)}`);
const isPresent = (value) => value != null && value !== '';
// Detail rows hide when both grades are missing, unlike grid cells that always print the pair.
const presentPair = (present, future, precision) => (isPresent(present) || isPresent(future) ? pair(present, future, precision) : null);
const joinPresent = (values, separator = ' ') => (values.filter(isPresent).map((value) => display(value)).join(separator));
const rawGroupPair = (report) => {
    const base = pair(report.PGroup, report.FGroup);
    return isPresent(report.CGroup) ? `${base}(${display(report.CGroup)})` : base;
};
const highAverage = (high, average) => `${display(high)}(${display(average)})`;
const fastballVelocity = (report) => {
    const base = pair(report.Pfb, report.Ffb);
    return report.Hfb != null || report.Afb != null ? `${base} ${highAverage(report.Hfb, report.Afb)}` : base;
};
// The scouting page reads these flags from SQL bits, JSON booleans, and stick "Yes" strings.
const isFlagged = (value) => value === true || value === 1 || value === 'Yes';
const isGroupG = (report) => {
    var _a;
    const raw = rawFieldNumber(report, 'pgroup');
    if (raw === 14)
        return true;
    const value = (_a = fieldValue(report, 'pgroup')) !== null && _a !== void 0 ? _a : report.PGroup;
    return value === 14 || value === 'G';
};
const ofpPair = (report) => (isGroupG(report) ? '' : pair(report.Pofp, report.Fofp, 1));
const adjustedOfp = (report) => (isGroupG(report) ? '' : display(report.Aofp, 1));
const withOtherPitchType = (report, value) => {
    const name = pitchType(report.OtherPitchType, false, '');
    return name ? `${value} (${name})` : value;
};
const booleanDisplay = (value) => {
    var _a;
    if (value == null || value === '')
        return '--';
    if (value === 'Yes' || value === 'No')
        return value;
    // A blank Stick yes/no can arrive as every option label joined together.
    return (_a = yesNo(value, true)) !== null && _a !== void 0 ? _a : '--';
};
const conversionCandidateDisplay = (report) => {
    var _a;
    const candidate = booleanDisplay(report.ConversionCandidate);
    if (candidate !== 'Yes')
        return candidate;
    const candidateType = display((_a = fieldValue(report, 'conversioncandidatetype')) !== null && _a !== void 0 ? _a : report.ConversionCandidateType);
    return candidateType === '--' ? candidate : `${candidate} - ${candidateType}`;
};
const acquireAsLabels = {
    1: ['ml', 'mlb'],
    3: ['prospect'],
    4: ['org'],
};
const matchesAcquireAs = (report, acquireAs) => {
    var _a, _b;
    const acquireAsRaw = rawFieldNumber(report, 'acquireas');
    if (acquireAsRaw === acquireAs)
        return true;
    const acquireAsCode = report.AcquireAs == null ? null : Number(report.AcquireAs);
    if (acquireAsCode === acquireAs)
        return true;
    const label = String((_b = (_a = fieldValue(report, 'acquireas')) !== null && _a !== void 0 ? _a : report.AcquireAs) !== null && _b !== void 0 ? _b : '').trim().toLowerCase();
    return (acquireAsLabels[acquireAs] || []).includes(label);
};
const acquisitionDisplay = (report, key, acquireAs, includeAcquireAs = false) => {
    const value = report[key];
    if (includeAcquireAs) {
        const hasAcquireAs = fieldValue(report, 'acquireas') != null || report.AcquireAs != null;
        if (value == null && !hasAcquireAs)
            return '--';
        return booleanDisplay(Boolean(value) || matchesAcquireAs(report, acquireAs));
    }
    return booleanDisplay(value);
};
const releaseRange = (report, prefix) => {
    const ranges = {
        ReleaseRegular: [report.ReleaseRegularLow, report.ReleaseRegularHigh, report.ReleaseRegular],
        ReleaseBS: [report.ReleaseBSLow, report.ReleaseBSHigh, report.ReleaseBS],
        ReleaseSlide: [report.ReleaseSlideLow, report.ReleaseSlideHigh, report.ReleaseSlide],
        ReleaseR2: [report.ReleaseR2Low, report.ReleaseR2High, report.ReleaseR2],
    };
    const [low, high, value] = ranges[prefix];
    if (low != null || high != null)
        return `${display(low)} - ${display(high)}`;
    return display(value);
};
const runTimes = (report, prefix) => {
    const values = prefix === 'RuntimeAvg'
        ? [report.RuntimeAvgLH, report.RuntimeAvgRH, report.RuntimeAvg]
        : [report.RuntimeFastestLH, report.RuntimeFastestRH, report.RuntimeFastest];
    const [left, right, value] = values;
    if (left != null || right != null) {
        return [left != null ? `LH: ${display(left, 2)}` : null, right != null ? `RH: ${display(right, 2)}` : null]
            .filter(Boolean)
            .join(' | ');
    }
    return display(value, 2);
};
const groupPair = (report, includeCeiling) => {
    const base = `${proGradeDisplay(report.PGroup)}/${proGradeDisplay(report.FGroup)}`;
    return includeCeiling && report.CGroup != null ? `${base}(${proGradeDisplay(report.CGroup)})` : base;
};
const reportPosition = (value) => display(value);
const scoutName = (report) => { var _a; return display((_a = report.Scout) === null || _a === void 0 ? void 0 : _a.FullName); };
const objectValue = (value, key) => (typeof value === 'object' && value !== null ? Reflect.get(value, key) : undefined);
const reportType = (report) => {
    const type = objectValue(objectValue(report, 'Type'), 'Type');
    const numeric = typeof type === 'number' ? type : Number(type);
    return Number.isFinite(numeric) ? numeric : undefined;
};
const reportVersion = (report) => { var _a; return (_a = report.Type.Version) !== null && _a !== void 0 ? _a : 1; };
const reportTypeName = (report) => display(report.Type.Name);
const supportedReportTypes = [1, 2, 6, 7, 8, 9, 21, 22, 23, 24, 25, 26, 31, 32, 34, 35, 37, 38];
const isScoutingReportData = (report) => {
    const type = reportType(report);
    return supportedReportTypes.some((supportedType) => supportedType === type);
};
const hasReportType = (report, types) => types.some((type) => type === report.Type.Type);
const normalizeScoutingReport = (report) => {
    if (!isScoutingReportData(report))
        return undefined;
    const version = reportVersion(report);
    if (hasReportType(report, [1]))
        return { kind: 'pro-position', version, data: report };
    if (hasReportType(report, [2]))
        return { kind: 'pro-pitcher', version, data: report };
    if (hasReportType(report, [6]))
        return { kind: 'limited-position', version, data: report };
    if (hasReportType(report, [7]))
        return { kind: 'limited-pitcher', version, data: report };
    if (hasReportType(report, [8]))
        return { kind: 'player-development-position', version, data: report };
    if (hasReportType(report, [9]))
        return { kind: 'player-development-pitcher', version, data: report };
    if (hasReportType(report, [37]))
        return { kind: 'spring-training-position', version, data: report };
    if (hasReportType(report, [38]))
        return { kind: 'spring-training-pitcher', version, data: report };
    if (hasReportType(report, [21, 23, 31]))
        return { kind: 'amateur-position', version, data: report };
    if (hasReportType(report, [22, 24, 32]))
        return { kind: 'amateur-pitcher', version, data: report };
    if (hasReportType(report, [25, 34]))
        return { kind: 'international-amateur-position', version, data: report };
    if (hasReportType(report, [26, 35]))
        return { kind: 'international-amateur-pitcher', version, data: report };
    return undefined;
};
const reportDate = (report) => {
    const type = report.Type.Type;
    const value = type === 8 || type === 9 ? report.LastUpdateDate : report.PublishedDate;
    return date(value);
};
const evaluationDate = (report) => {
    var _a, _b, _c, _d, _e;
    const observations = Array.isArray(report.Observations) ? report.Observations : [];
    const latestObservation = [...observations]
        .sort((a, b) => {
        var _a, _b, _c, _d;
        const aValue = (_b = (_a = a === null || a === void 0 ? void 0 : a.Game) === null || _a === void 0 ? void 0 : _a.GameDate) !== null && _b !== void 0 ? _b : a === null || a === void 0 ? void 0 : a.ObservationDate;
        const bValue = (_d = (_c = b === null || b === void 0 ? void 0 : b.Game) === null || _c === void 0 ? void 0 : _c.GameDate) !== null && _d !== void 0 ? _d : b === null || b === void 0 ? void 0 : b.ObservationDate;
        return new Date(bValue).getTime() - new Date(aValue).getTime();
    })[0];
    const value = (_e = (_d = (_c = (_b = (_a = latestObservation === null || latestObservation === void 0 ? void 0 : latestObservation.Game) === null || _a === void 0 ? void 0 : _a.GameDate) !== null && _b !== void 0 ? _b : latestObservation === null || latestObservation === void 0 ? void 0 : latestObservation.ObservationDate) !== null && _c !== void 0 ? _c : report.EvalDate) !== null && _d !== void 0 ? _d : report.EvaluationDate) !== null && _e !== void 0 ? _e : report.PublishedDate;
    return date(value);
};
const header = (first, second) => (React.createElement(React.Fragment, null,
    first,
    second ? React.createElement(React.Fragment, null,
        React.createElement("br", null),
        second) : null));
const positionGradeColumns = (report, modernLabels) => [
    { id: 'quality', heading: header(modernLabels ? 'Quality' : 'Pwr', modernLabels ? 'Contact' : 'Fre'), value: pair(report.Ppf, report.Fpf) },
    { id: 'zone', heading: modernLabels ? header('Zone', 'Ctrl') : 'PD', value: pair(report.Ppd, report.Fpd) },
    { id: 'barrel', heading: header(modernLabels ? 'Barrel' : 'Hit', modernLabels ? 'Aware' : ''), value: pair(report.Phit, report.Fhit) },
    { id: 'power', heading: header('Raw', 'Pwr'), value: pair(report.Prp, report.Frp) },
    { id: 'steal', heading: 'Steal', value: pair(report.Pbs, report.Fbs) },
    { id: 'base-run', heading: header('Base', 'Run'), value: pair(report.Pbr, report.Fbr) },
    { id: 'run-speed', heading: header('Run', 'Spd'), value: pair(report.Prs, report.Frs) },
    { id: 'range', heading: 'Range', value: pair(report.Pr, report.Fr) },
    { id: 'hands', heading: 'Hands', value: pair(report.Phands, report.Fhands) },
    { id: 'arm-strength', heading: header('Arm', 'Str'), value: pair(report.Pas, report.Fas) },
    { id: 'arm-accuracy', heading: header('Arm', 'Acc'), value: pair(report.Paa, report.Faa) },
    { id: 'throw', heading: 'Throw', value: pair(report.PThrows, report.FThrows) },
    { id: 'fielding', heading: 'Fld', value: pair(report.Pfa, report.Ffa) },
];
const proPositionColumns = (report, version) => [
    { id: 'scout', heading: 'Scout', value: scoutName(report) },
    { id: 'type', heading: header('Report', 'Type'), value: 'Full' },
    { id: 'date', heading: header('Pub', 'Date'), value: reportDate(report) },
    { id: 'group', heading: header('Group', `P/F${version >= 6 ? '(C)' : ''}`), value: groupPair(report, version >= 6) },
    { id: 'position', heading: 'Pos', value: reportPosition(report.ReportPosition) },
    ...positionGradeColumns(report, version >= 6).flatMap((column) => (column.id === 'power'
        ? [{ id: 'hitability', heading: 'Hitability', value: pair(report.pHitabil, report.fHitabil) }, column]
        : [column])),
    { id: 'iq', heading: header('BB', 'Intel'), value: display(report.Bbintel) },
    { id: 'ofp', heading: header('OFP', 'wt'), value: ofpPair(report) },
    { id: 'adjusted-ofp', heading: header('Adj', 'OFP'), value: adjustedOfp(report) },
    {
        id: 'interest',
        heading: 'Interest',
        value: (report.Interest != null ? mappedDisplay(report.Interest) : mappedDisplay(report.MNFAInterest)),
    },
    { id: 'risk', heading: 'Risk', value: version < 5 ? mappedDisplay(report.RiskToReachFuture) : '--' },
];
const pitcherStuffColumns = (report, version) => [
    { id: 'fb', heading: header('FB Vel', 'P/F H(A)'), value: fastballVelocity(report) },
    { id: 'fb-command', heading: header('FB', 'Cmd'), value: pair(report.Pfbcmd, report.Ffbcmd) },
    ...(version < 3
        ? [{ id: 'fb-movement', heading: header('FB', 'Mvmt'), value: pair(report.Pfbmov, report.Ffbmov) }]
        : [
            { id: 'four-seam', heading: header('4-Seam', 'Mvmt'), value: pair(report.P4fbmov, report.F4fbmov) },
            { id: 'two-seam', heading: header('2-Seam', 'Mvmt'), value: pair(report.P2fbmov, report.F2fbmov) },
        ]),
    { id: 'curve', heading: 'Curve', value: pair(report.Pcb, report.Fcb) },
    { id: 'slider', heading: 'Slider', value: pair(report.Psl, report.Fsl) },
    { id: 'change', heading: 'Change', value: pair(report.Pch, report.Fch) },
    { id: 'cutter', heading: 'Cutter', value: pair(report.Pct, report.Fct) },
    { id: 'other', heading: 'Other', value: withOtherPitchType(report, pair(report.Pother, report.Fother)) },
];
const proPitcherColumns = (report, version) => [
    { id: 'scout', heading: 'Scout', value: scoutName(report) },
    { id: 'date', heading: header('Pub', 'Date'), value: reportDate(report) },
    { id: 'group', heading: header('Group', `P/F${version >= 5 ? '(C)' : ''}`), value: groupPair(report, version >= 5) },
    { id: 'position', heading: 'Pos', value: reportPosition(report.ReportPosition) },
    ...pitcherStuffColumns(report, version),
    { id: 'control', heading: 'Control', value: pair(report.Pcontrol, report.Fcontrol) },
    { id: 'arm-action', heading: header('Arm', 'Act'), value: display(report.ArmAction) },
    { id: 'delivery', heading: 'Del', value: display(report.Delivery) },
    { id: 'deception', heading: 'Dec', value: display(report.Pdeception) },
    {
        id: 'pitchability',
        heading: header('Ptch', 'Ablty'),
        value: (version < 5 ? display(report.Pitchability) : pair(report.PPitchability, report.FPitchability)),
    },
    { id: 'ofp', heading: 'OFP', value: ofpPair(report) },
    { id: 'adjusted-ofp', heading: header('Adj', 'OFP'), value: adjustedOfp(report) },
    {
        id: 'interest',
        heading: 'Interest',
        value: (report.Interest != null ? mappedDisplay(report.Interest) : mappedDisplay(report.MNFAInterest)),
    },
    { id: 'risk', heading: 'Risk', value: version < 5 ? mappedDisplay(report.RiskToReachFuture) : '--' },
];
const limitedPositionColumns = (report, version) => {
    const shared = [
        { id: 'scout', heading: 'Scout', value: scoutName(report) },
        { id: 'date', heading: header('Pub', 'Date'), value: reportDate(report) },
        { id: 'video', heading: header('Video', 'Eval'), value: report.IsVideoEval ? 'Y' : 'N' },
        { id: 'group', heading: header('Group', version >= 2 ? `P/F${version >= 5 ? '(C)' : ''}` : ''), value: groupPair(report, version >= 5) },
        { id: 'position', heading: 'Position', value: reportPosition(report.ReportPosition) },
        { id: 'games', heading: header('Games', 'Seen'), value: display(report.Games, 0) },
    ];
    if (version < 2) {
        return [
            ...shared,
            { id: 'offense', heading: header('Offensive', 'Grade'), value: mappedDisplay(report.Offense) },
            { id: 'run', heading: header('Run', 'Grade'), value: mappedDisplay(report.Run) },
            { id: 'arm-strength', heading: header('Arm', 'Strength'), value: display(report.ArmStrength) },
            { id: 'defense', heading: header('Defensive', 'Grade'), value: mappedDisplay(report.Defense) },
            { id: 'ofp', heading: 'OFP', value: ofpPair(report) },
            { id: 'interest', heading: 'Interest', value: mappedDisplay(report.Interest) },
        ];
    }
    return [
        ...shared,
        ...positionGradeColumns(report, version >= 5),
        { id: 'ofp', heading: 'OFP', value: ofpPair(report) },
        { id: 'interest', heading: 'Interest', value: mappedDisplay(report.Interest) },
    ];
};
const limitedPitcherColumns = (report, version) => {
    const shared = [
        { id: 'scout', heading: 'Scout', value: scoutName(report) },
        { id: 'date', heading: header('Pub', 'Date'), value: reportDate(report) },
        { id: 'video', heading: header('Video', 'Eval'), value: `${report.IsVideoEval ? 'Y' : 'N'}${report.IsOpposingSP ? ' (Opp SP)' : ''}` },
        { id: 'group', heading: header('Group', version >= 2 ? `P/F${version >= 5 ? '(C)' : ''}` : ''), value: groupPair(report, version >= 5) },
        { id: 'position', heading: 'Pos', value: reportPosition(report.ReportPosition) },
        { id: 'innings', heading: 'Inn.', value: display(report.Innings, 1) },
    ];
    if (version < 2) {
        return [
            ...shared,
            { id: 'fb', heading: header('FB Vel', 'H(A)'), value: `${display(report.Hfb)}(${display(report.Afb)})` },
            { id: 'fb-command', heading: 'FB Cmd', value: mappedDisplay(report.Fbcmd) },
            { id: 'curve', heading: header('Curve', 'H(A)'), value: report.Acb == null ? '--' : `${display(report.Hcb)}(${display(report.Acb)})` },
            { id: 'slider', heading: header('Slider', 'H(A)'), value: report.Asl == null ? '--' : `${display(report.Hsl)}(${display(report.Asl)})` },
            { id: 'change', heading: header('Change', 'H(A)'), value: report.Ach == null ? '--' : `${display(report.Hch)}(${display(report.Ach)})` },
            { id: 'cutter', heading: header('Cutter', 'H(A)'), value: report.Act == null ? '--' : `${display(report.Hct)}(${display(report.Act)})` },
            { id: 'other', heading: header('Other', 'H(A)'), value: report.Aother == null ? '--' : `${display(report.Hother)}(${display(report.Aother)})` },
            { id: 'ofp', heading: 'OFP', value: ofpPair(report) },
            { id: 'control', heading: 'Control', value: mappedDisplay(report.Control) },
            { id: 'interest', heading: 'Interest', value: mappedDisplay(report.Interest) },
        ];
    }
    return [
        ...shared,
        ...pitcherStuffColumns(report, version),
        { id: 'ofp', heading: 'OFP', value: ofpPair(report) },
        { id: 'control', heading: 'Control', value: pair(report.Pcontrol, report.Fcontrol) },
        { id: 'deception', heading: 'Dec', value: display(report.Pdeception) },
        { id: 'interest', heading: 'Interest', value: mappedDisplay(report.Interest) },
    ];
};
const playerDevPositionColumns = (report) => [
    { id: 'author', heading: 'Author', value: scoutName(report) },
    { id: 'date', heading: 'Date', value: reportDate(report) },
    { id: 'type', heading: 'Report Type', value: reportTypeName(report) },
    {
        id: 'group',
        heading: header('Group', 'P F C'),
        value: (`${proGradeDisplay(report.PGroup)} / ${proGradeDisplay(report.Group)} / ${proGradeDisplay(report.CGroup)}`),
    },
    { id: 'quality', heading: header('Quality', 'Contact'), value: pair(report.Ppf, report.Fpf) },
    { id: 'zone', heading: header('Zone', 'Control'), value: pair(report.Ppd, report.Fpd) },
    { id: 'barrel', heading: header('Barrel', 'Awareness'), value: pair(report.Phit, report.Fhit) },
    { id: 'power', heading: header('Raw', 'Pwr'), value: pair(report.Prp, report.Frp) },
    { id: 'arm-strength', heading: header('Arm', 'Str'), value: pair(report.Pas, report.Fas) },
    { id: 'arm-accuracy', heading: header('Arm', 'Acc'), value: pair(report.Paa, report.Faa) },
    { id: 'fielding', heading: 'Fld', value: pair(report.Pfa, report.Ffa) },
    { id: 'range', heading: 'Range', value: pair(report.Pr, report.Fr) },
    { id: 'hands', heading: 'Hands', value: pair(report.Phands, report.Fhands) },
    { id: 'base-run', heading: header('Base', 'Run'), value: pair(report.Pbr, report.Fbr) },
    { id: 'steal', heading: 'Steal', value: pair(report.Pbs, report.Fbs) },
    { id: 'run-speed', heading: header('Run', 'Spd'), value: pair(report.Prs, report.Frs) },
    { id: 'iq', heading: 'BB IQ', value: display(report.BaseballIQ) },
    { id: 'aptitude', heading: 'Apt', value: display(report.Aptitude) },
    { id: 'ofp', heading: header('OFP', 'wt'), value: pair(report.Pofp, report.Fofp, 1) },
    { id: 'adjusted-ofp', heading: header('Adj', 'OFP'), value: display(report.Aofp) },
];
const pitchGrade = (report, prefix) => {
    const grades = {
        fb: [report.Pfb, report.Ffb, report.Hfb, report.Afb],
        cb: [report.Pcb, report.Fcb, report.Hcb, report.Acb],
        sl: [report.Psl, report.Fsl, report.Hsl, report.Asl],
        ch: [report.Pch, report.Fch, report.Hch, report.Ach],
        ct: [report.Pct, report.Fct, report.Hct, report.Act],
        other: [report.Pother, report.Fother, report.Hother, report.Aother],
    };
    const [present, future, high, average] = grades[prefix];
    const base = pair(present, future);
    return average == null ? base : `${base} ${display(high)}(${display(average)})`;
};
const playerDevPitcherColumns = (report) => [
    { id: 'author', heading: 'Author', value: scoutName(report) },
    { id: 'date', heading: 'Date', value: reportDate(report) },
    { id: 'type', heading: 'Report Type', value: reportTypeName(report) },
    {
        id: 'group',
        heading: header('Group', 'P F C'),
        value: (`${proGradeDisplay(report.PGroup)} / ${proGradeDisplay(report.Group)} / ${proGradeDisplay(report.CGroup)}`),
    },
    { id: 'fb', heading: header('FB Vel', 'P/F H(A)'), value: pitchGrade(report, 'fb') },
    { id: 'fb-command', heading: header('FB', 'Cmd'), value: pair(report.Pfbcmd, report.Ffbcmd) },
    { id: 'fb-movement', heading: header('FB', 'Mvmt'), value: pair(report.Pfbmov, report.Ffbmov) },
    { id: 'four-seam', heading: header('4FB', 'Mvmt'), value: pair(report.P4fbmov, report.F4fbmov) },
    { id: 'two-seam', heading: header('2FB', 'Mvmt'), value: pair(report.P2fbmov, report.F2fbmov) },
    { id: 'curve', heading: header('Curve', 'P/F H(A)'), value: pitchGrade(report, 'cb') },
    { id: 'slider', heading: header('Slider', 'P/F H(A)'), value: pitchGrade(report, 'sl') },
    { id: 'change', heading: header('Change', 'P/F H(A)'), value: pitchGrade(report, 'ch') },
    { id: 'cutter', heading: header('Cutter', 'P/F H(A)'), value: pitchGrade(report, 'ct') },
    { id: 'splitter', heading: header('Splitter', 'P/F H(A)'), value: pair(report.Psp, report.Fsp) },
    { id: 'other', heading: header('Other', 'P/F H(A)'), value: withOtherPitchType(report, pitchGrade(report, 'other')) },
    { id: 'deception', heading: 'Dec', value: display(report.Pdeception) },
    { id: 'control', heading: 'Control', value: pair(report.Pcontrol, report.Fcontrol) },
    { id: 'run-control', heading: header('Control', 'Run'), value: display(report.ControlRunGame) },
    { id: 'fielding', heading: 'Fld', value: pair(report.Pfa, report.Ffa) },
    { id: 'iq', heading: 'BB IQ', value: display(report.BaseballIQ) },
    { id: 'aptitude', heading: 'Apt', value: display(report.Aptitude) },
    { id: 'ofp', heading: 'OFP', value: pair(report.Pofp, report.Fofp, 1) },
    { id: 'adjusted-ofp', heading: header('Adj', 'OFP'), value: display(report.Aofp) },
];
const springTrainingSharedColumns = (report) => {
    var _a;
    return [
        { id: 'scout', heading: 'Scout', value: scoutName(report) },
        { id: 'date', heading: header('Pub', 'Date'), value: reportDate(report) },
        { id: 'group', heading: 'Group', value: rawGroupPair(report) },
        { id: 'role', heading: 'Role', value: display((_a = report.Role) !== null && _a !== void 0 ? _a : report.RoleString) },
    ];
};
const springTrainingPositionColumns = (report) => [
    ...springTrainingSharedColumns(report),
    {
        id: 'games',
        heading: header('Games /', 'ABs'),
        value: joinPresent([
            report.Games != null ? `${display(report.Games, 0)} G` : null,
            report.AtBats != null ? `${display(report.AtBats, 0)} AB` : null,
        ]) || '--',
    },
    { id: 'offense', heading: header('Offensive', 'Grade'), value: display(report.Offense) },
    { id: 'defense', heading: header('Defensive', 'Grade'), value: display(report.Defense) },
    { id: 'arm-strength', heading: header('Arm', 'Strength'), value: display(report.ArmStrength) },
    { id: 'run', heading: header('Run', 'Grade'), value: display(report.Run) },
    { id: 'interest', heading: 'Interest', value: display(report.Interest) },
];
const springTrainingPitcherColumns = (report) => {
    const secondary = (high, average) => (average ? highAverage(high, average) : '');
    return [
        ...springTrainingSharedColumns(report),
        { id: 'innings', heading: 'Inn.', value: display(report.Innings, 1) },
        { id: 'arm-angle', heading: header('Arm', 'Angle'), value: display(report.ArmAngle) },
        { id: 'fb', heading: header('FB Vel', 'H(A)'), value: highAverage(report.Hfb, report.Afb) },
        { id: 'fb-command', heading: 'FB Cmd', value: display(report.Fbcmd) },
        { id: 'curve', heading: header('Curve', 'H(A)'), value: secondary(report.Hcb, report.Acb) },
        { id: 'slider', heading: header('Slider', 'H(A)'), value: secondary(report.Hsl, report.Asl) },
        { id: 'change', heading: header('Change', 'H(A)'), value: secondary(report.Hch, report.Ach) },
        { id: 'cutter', heading: header('Cutter', 'H(A)'), value: secondary(report.Hct, report.Act) },
        { id: 'other', heading: header('Other', 'H(A)'), value: secondary(report.Hother, report.Aother) },
        { id: 'control', heading: 'Control', value: display(report.Control) },
        { id: 'interest', heading: 'Interest', value: display(report.Interest) },
    ];
};
const amateurReportTypeLabel = (report) => {
    const type = report.Type.Type;
    if (type === 21 || type === 22 || type === 25 || type === 26)
        return 'Full';
    if (type === 31 || type === 32)
        return 'ID';
    return `LV${isFlagged(report.IsVideoEval) ? ' (Vid)' : ''}${isFlagged(report.IsOrgEval) ? ' (Org)' : ''}`;
};
const amateurGroup = (report) => {
    var _a, _b, _c;
    if (report.Type.Type === 31 || report.Type.Type === 32)
        return display((_b = (_a = report.IDInterest) !== null && _a !== void 0 ? _a : report.Interest) !== null && _b !== void 0 ? _b : report.PGroup);
    const group = (_c = fieldValue(report, 'pgroup')) !== null && _c !== void 0 ? _c : report.PGroup;
    const groupRaw = rawFieldNumber(report, 'pgroup');
    const crossCheck = report.ShouldXCheck && (groupRaw === 7 || group === 7 || group === 'C');
    return crossCheck ? header(display(report.PGroup), 'X-Check') : display(report.PGroup);
};
const amateurSharedColumns = (report) => [
    { id: 'scout', heading: 'Scout', value: scoutName(report) },
    { id: 'type', heading: header('Report', 'Type'), value: amateurReportTypeLabel(report) },
    { id: 'date', heading: header('Eval', 'Date'), value: evaluationDate(report) },
    { id: 'group', heading: 'Grp', value: amateurGroup(report) },
];
const amateurPositionColumns = (report, showRestrictedOfp) => {
    const isIdentification = report.Type.Type === 31;
    const ofp = (present, future) => (showRestrictedOfp && (present || future) ? pair(present, future, 1) : '');
    return [
        ...amateurSharedColumns(report),
        { id: 'position-1', heading: 'Pos1', value: isIdentification ? selectionDisplay(report.Positions) : display(report.Position1) },
        { id: 'position-2', heading: 'Pos2', value: isIdentification ? '' : display(report.Position2) },
        { id: 'power', heading: header('Raw', 'Pwr'), value: pair(report.Prp, report.Frp) },
        { id: 'arm-strength', heading: header('Arm', 'Str'), value: pair(report.Pas, report.Fas) },
        { id: 'run-speed', heading: header('Run', 'Spd'), value: pair(report.Prs, report.Frs) },
        { id: 'bat-speed', heading: header('Bat', 'Spd'), value: pair(report.Pbat, report.Fbat) },
        { id: 'barrel', heading: header('Barrel', 'Aware'), value: pair(report.Phe, report.Fhe) },
        { id: 'pitch-recognition', heading: header('Pitch', 'Rec.'), value: pair(report.Ppr, report.Fpr) },
        { id: 'zone', heading: 'PD', value: pair(report.Ppd, report.Fpd) },
        { id: 'hit', heading: 'Hit', value: pair(report.Phit, report.Fhit) },
        { id: 'power-frequency', heading: header('Pwr', 'Fre'), value: display(report.Fpf) },
        { id: 'arm-accuracy', heading: header('Arm', 'Acc'), value: pair(report.Paa, report.Faa) },
        { id: 'range', heading: 'Rng', value: pair(report.Pr, report.Fr) },
        { id: 'hands', heading: 'Hands', value: pair(report.Phands, report.Fhands) },
        { id: 'feet', heading: 'Feet', value: pair(report.Pfeet, report.Ffeet) },
        { id: 'fielding-1', heading: header('Fld', 'Pos1'), value: pair(report.Pfapos1, report.Ffapos1) },
        { id: 'fielding-2', heading: header('Fld', 'Pos2'), value: pair(report.Pfapos2, report.Ffapos2) },
        { id: 'strength', heading: 'Strgth', value: pair(report.Pstrength, report.Fstrength) },
        { id: 'explosiveness', heading: 'Expl', value: display(report.Pexplosiveness) },
        { id: 'agility', heading: 'Agil', value: display(report.Pbodycont) },
        { id: 'athleticism', heading: 'Athl', value: display(report.Pathleticism) },
        { id: 'performance', heading: 'Perf', value: display(report.Performance) },
        { id: 'ofp-1', heading: header('OFP', 'Pos 1'), value: ofp(report.Pofp_pos1, report.Fofp_pos1) },
        { id: 'ofp-2', heading: header('OFP', 'Pos 2'), value: ofp(report.Pofp_pos2, report.Fofp_pos2) },
    ];
};
const amateurPitcherColumns = (report, showRestrictedOfp) => {
    var _a;
    const type = report.Type.Type;
    // Rows without a linked legacy report carry no scouting_version; the scouting page treats that as the newest layout.
    const legacyVersion = report.scouting_version;
    const usesRoleSeen = (type === 22 || type === 24) && (legacyVersion == null || legacyVersion >= 6);
    const usesSingleMovement = legacyVersion != null && legacyVersion < 3;
    return [
        ...amateurSharedColumns(report),
        {
            id: 'position',
            heading: header('Position', '(Seen/Future)'),
            value: usesRoleSeen ? pair(report.RoleSeen, report.FuturePosition) : selectionDisplay(report.positions),
        },
        { id: 'fb', heading: header('FB Vel', 'P/F H(A)'), value: fastballVelocity(report) },
        { id: 'fb-command', heading: header('FB', 'Cmd'), value: pair(report.Pfbcmd, report.Ffbcmd) },
        ...(usesSingleMovement
            ? [{ id: 'fb-movement', heading: header('FB', 'Mvmt'), value: pair(report.Pfbmov, report.Ffbmov) }]
            : [
                { id: 'four-seam', heading: header('4-Seam', 'Mvmt'), value: display(report.P4fbmov) },
                { id: 'two-seam', heading: header('2-Seam', 'Mvmt'), value: display(report.P2fbmov) },
            ]),
        { id: 'fb-overall', heading: header('FB', 'Overall'), value: pair(report.Pfboverall, report.Ffboverall) },
        { id: 'curve', heading: 'Curve', value: pair(report.Pcb, report.Fcb) },
        { id: 'slider', heading: 'Slider', value: pair(report.Psl, report.Fsl) },
        { id: 'change', heading: 'Change', value: pair(report.Pch, report.Fch) },
        {
            id: 'other',
            heading: 'Other',
            value: report.OtherPitchType ? header(pair(report.Pother, report.Fother), display(report.OtherPitchType)) : pair(report.Pother, report.Fother),
        },
        { id: 'control', heading: 'Control', value: pair(report.Pcontrol, report.Fcontrol) },
        { id: 'arm-action', heading: header('Arm', 'Act'), value: display(report.Armaction) },
        { id: 'delivery', heading: 'Del', value: pair(report.Pdelivery, report.Fdelivery) },
        { id: 'extension', heading: 'Ext', value: display(report.Extension) },
        { id: 'feel', heading: 'Feel', value: pair(report.Pfeeltopitch, report.Ffeeltopitch) },
        { id: 'deception', heading: 'Dec', value: display((_a = report.Deception) !== null && _a !== void 0 ? _a : report.Fbdeception) },
        { id: 'strength', heading: 'Strgth', value: pair(report.Pstrength, report.Fstrength) },
        { id: 'arm-speed', heading: header('Arm', 'Spd'), value: display(report.Pas) },
        { id: 'agility', heading: 'Agil', value: display(report.Pbodycont) },
        { id: 'athleticism', heading: 'Athl', value: display(report.Pathleticism) },
        { id: 'performance', heading: 'Perf', value: display(report.Performance) },
        { id: 'ofp-sp', heading: 'SP', value: showRestrictedOfp ? display(report.Ofpsp, 1) : '' },
        { id: 'ofp-rp', heading: 'RP', value: showRestrictedOfp ? display(report.Ofprp, 1) : '' },
    ];
};
const internationalSharedColumns = (report) => [
    { id: 'scout', heading: 'Scout', value: scoutName(report) },
    { id: 'type', heading: header('Report', 'Type'), value: amateurReportTypeLabel(report) },
    { id: 'date', heading: header('Eval', 'Date'), value: evaluationDate(report) },
    { id: 'group', heading: 'Group', value: display(report.PGroup) },
    { id: 'interest', heading: 'Interest', value: display(report.Interest) },
    { id: 'position', heading: 'Pos', value: reportPosition(report.ReportPosition) },
];
const internationalOfpColumns = (report, showRestrictedOfp, ofpHeading) => [
    { id: 'ofp', heading: ofpHeading, value: showRestrictedOfp && (report.Pofp || report.Fofp) ? pair(report.Pofp, report.Fofp, 1) : '' },
    { id: 'adjusted-ofp', heading: header('Adj', 'OFP'), value: showRestrictedOfp && report.Aofp ? display(report.Aofp, 1) : '' },
];
const internationalPositionColumns = (report, showRestrictedOfp) => [
    ...internationalSharedColumns(report),
    { id: 'hit', heading: 'Hit', value: pair(report.Phit, report.Fhit) },
    { id: 'zone', heading: 'PD', value: pair(report.Ppd, report.Fpd) },
    { id: 'power', heading: header('Raw', 'Pwr'), value: pair(report.Prp, report.Frp) },
    { id: 'power-frequency', heading: header('Pwr', 'Fre'), value: pair(report.Ppf, report.Fpf) },
    { id: 'arm-strength', heading: header('Arm', 'Str'), value: pair(report.Pas, report.Fas) },
    { id: 'arm-accuracy', heading: header('Arm', 'Acc'), value: pair(report.Paa, report.Faa) },
    { id: 'fielding', heading: 'Fld', value: pair(report.Pfa, report.Ffa) },
    { id: 'run-speed', heading: header('Total', 'Spd'), value: pair(report.Prs, report.Frs) },
    { id: 'game-speed', heading: header('Usable', 'Game Spd'), value: pair(report.Pgs, report.Fgs) },
    { id: 'base-run', heading: header('Base', 'Run'), value: pair(report.Pbr, report.Fbr) },
    { id: 'home-to-first', heading: header('Home', 'to 1B'), value: pair(report.Phto1b, report.Fhto1b) },
    ...internationalOfpColumns(report, showRestrictedOfp, header('OFP', 'wt')),
];
const internationalPitcherColumns = (report, showRestrictedOfp) => [
    ...internationalSharedColumns(report),
    { id: 'fb', heading: header('FB Vel', 'P/F H(A)'), value: fastballVelocity(report) },
    { id: 'fb-command', heading: header('FB', 'Ctrl'), value: display(report.Fbcmd) },
    { id: 'fb-movement', heading: header('FB', 'Mvmt'), value: pair(report.Pfbmov, report.Ffbmov) },
    { id: 'curve', heading: 'Curve', value: pair(report.Pcb, report.Fcb) },
    { id: 'slider', heading: 'Slider', value: pair(report.Psl, report.Fsl) },
    { id: 'change', heading: 'Change', value: pair(report.Pch, report.Fch) },
    { id: 'cutter', heading: 'Cutter', value: pair(report.Pct, report.Fct) },
    {
        id: 'other',
        heading: 'Other',
        value: report.OtherPitchType
            ? header(pair(report.Pother, report.Fother), display(pitchType(report.OtherPitchType, false, '--')))
            : pair(report.Pother, report.Fother),
    },
    { id: 'control', heading: 'Control', value: pair(report.Pcontrol, report.Fcontrol) },
    { id: 'arm-action', heading: header('Arm', 'Act'), value: display(report.ArmAction) },
    { id: 'arm-speed', heading: header('Arm', 'Speed'), value: display(report.ArmSpeed) },
    { id: 'delivery', heading: 'Del', value: display(report.Delivery) },
    { id: 'athleticism', heading: header('Athl', 'Ablty'), value: display(report.Athleticism) },
    ...internationalOfpColumns(report, showRestrictedOfp, 'OFP'),
];
const renderedColumns = (report, showRestrictedOfp) => {
    if (report.kind === 'pro-position')
        return proPositionColumns(report.data, report.version);
    if (report.kind === 'pro-pitcher')
        return proPitcherColumns(report.data, report.version);
    if (report.kind === 'limited-position')
        return limitedPositionColumns(report.data, report.version);
    if (report.kind === 'limited-pitcher')
        return limitedPitcherColumns(report.data, report.version);
    if (report.kind === 'player-development-position')
        return playerDevPositionColumns(report.data);
    if (report.kind === 'player-development-pitcher')
        return playerDevPitcherColumns(report.data);
    if (report.kind === 'spring-training-position')
        return springTrainingPositionColumns(report.data);
    if (report.kind === 'spring-training-pitcher')
        return springTrainingPitcherColumns(report.data);
    if (report.kind === 'amateur-position')
        return amateurPositionColumns(report.data, showRestrictedOfp);
    if (report.kind === 'amateur-pitcher')
        return amateurPitcherColumns(report.data, showRestrictedOfp);
    if (report.kind === 'international-amateur-position')
        return internationalPositionColumns(report.data, showRestrictedOfp);
    return internationalPitcherColumns(report.data, showRestrictedOfp);
};
const pickListSelections = (report, type) => {
    if (!Array.isArray(report.PickListSelections))
        return [];
    return report.PickListSelections.flatMap((selection, index) => {
        var _a, _b, _c, _d;
        const value = selection === null || selection === void 0 ? void 0 : selection.Value;
        const key = value === null || value === void 0 ? void 0 : value.Key;
        if (Number(key === null || key === void 0 ? void 0 : key.Type) !== type || !(value === null || value === void 0 ? void 0 : value.Description))
            return [];
        return [{
                description: String(value.Description),
                id: `${String((_a = key === null || key === void 0 ? void 0 : key.Type) !== null && _a !== void 0 ? _a : type)}-${String((_b = key === null || key === void 0 ? void 0 : key.Value) !== null && _b !== void 0 ? _b : index)}-${index}`,
                isPositive: value.IsPositive !== false,
                sortOrder: Number((_c = value.SortOrder) !== null && _c !== void 0 ? _c : Number.MAX_SAFE_INTEGER),
                valueOrder: Number((_d = key === null || key === void 0 ? void 0 : key.Value) !== null && _d !== void 0 ? _d : Number.MAX_SAFE_INTEGER),
            }];
    }).sort((left, right) => left.sortOrder - right.sortOrder || left.valueOrder - right.valueOrder);
};
// Migrated picklists land in Stick fields under these names (see stick_reportmigration).
const stickPickListFieldNames = {
    1: ['physicaldescription', 'physicaldesc'],
    2: ['hitapproach'],
    4: ['armaction', 'armactiondesc'],
    5: ['delivery', 'deliverydesc'],
    6: ['pitchability', 'pitchabilitydesc', 'pitchablitydesc'],
    7: ['othercapablepos', 'othercapablepositions'],
    8: ['swingissues'],
    9: ['defensiveredflags'],
    10: ['bodytype'],
    11: ['onfieldmakeupredflags'],
    12: ['offfieldmakeupredflags'],
    13: ['hitterriskareas'],
    14: ['pitcherriskareas'],
    15: ['boardtype'],
    16: ['platedisciplinetype'],
    17: ['playertype'],
    19: ['boardtype'],
    20: ['armangle'],
    21: ['positionseenposition', 'positions'],
    22: ['positionseenpitcher', 'positions'],
    24: ['keyrevisedmakeupcharacteristics'],
    25: ['deception'],
    28: ['setting'],
    29: ['4fbmovement', 'fb4mov'],
    30: ['2fbmovement', 'fb2mov'],
    34: ['redflag'],
    35: ['swingmechanicslh'],
    36: ['swingmechanicsrh'],
    37: ['pfvalues'],
    38: ['pdvalues'],
    39: ['hitabilityvalues'],
    40: ['rpvalues'],
    41: ['rangevalues'],
    42: ['handsvalues', 'handvalues'],
    43: ['asvalues'],
    44: ['aavalues'],
    45: ['favalues'],
    46: ['rsvalues'],
    47: ['brvalues'],
    48: ['bsvalues'],
    50: ['fastballvelocitydescriptors', 'fbvvalues'],
    51: ['fastballcommanddescriptors', 'fbcomvalues'],
    52: ['4fbmovementdescriptors'],
    53: ['2fbmovementdescriptors'],
    54: ['curveballdescriptors', 'cbvalues'],
    55: ['sliderdescriptors', 'slvalues'],
    56: ['changeupdescriptors', 'chvalues'],
    57: ['cutterdescriptors', 'ctvalues'],
    58: ['otherpitchdescriptors'],
    60: ['controldescriptors'],
    62: ['makeupvalues', 'makeupcmt'],
};
const firstValue = (report, keys) => {
    const value = keys.map((key) => objectValue(report, key)).find((item) => item != null && item !== '');
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' ? value : undefined;
};
const stickPickListValues = (report, type) => {
    const names = stickPickListFieldNames[type];
    if (!(names === null || names === void 0 ? void 0 : names.length) || !report.stickFields)
        return [];
    return Object.entries(report.stickFields)
        .filter(([key]) => names.some((name) => key === name || key.startsWith(`${name}-`)))
        .map(([, entry]) => entry.value)
        .filter((value) => value != null && value !== '');
};
const pickListValue = (report, type, commentKeys = [], fallbackKeys = [], requireSelection = false) => {
    var _a;
    const comments = firstValue(report, commentKeys);
    const stickValues = stickPickListValues(report, type);
    if (stickValues.length) {
        return (React.createElement("span", null,
            stickValues.map((value, index) => (
            // Stick multi-select fragments are ordered lists, not stable identities.
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(React.Fragment, { key: `${type}-${index}` },
                index > 0 ? ' | ' : null,
                selectionDisplay(value)))),
            comments != null && comments !== '' ? React.createElement(React.Fragment, null,
                " | ",
                React.createElement("strong", null, "Cmts:"),
                " ",
                React.createElement("i", null, String(comments))) : null));
    }
    const selections = pickListSelections(report, type);
    if (!selections.length) {
        if (requireSelection)
            return null;
        const stickFallback = fieldValue(report, ((_a = stickPickListFieldNames[type]) === null || _a === void 0 ? void 0 : _a[0]) || '');
        if (stickFallback != null)
            return selectionDisplay(stickFallback);
        return firstValue(report, fallbackKeys.length ? fallbackKeys : commentKeys);
    }
    return (React.createElement("span", null,
        selections.map((selection, index) => (React.createElement(React.Fragment, { key: selection.id },
            index > 0 ? ' | ' : null,
            selection.isPositive
                ? selection.description
                : React.createElement(NegativeSelection, null, selection.description)))),
        comments != null && comments !== '' ? React.createElement(React.Fragment, null,
            " | ",
            React.createElement("strong", null, "Cmts:"),
            " ",
            React.createElement("i", null, String(comments))) : null));
};
const pickListText = (report, type) => (pickListSelections(report, type).map((selection) => selection.description).join(' | '));
const velocityRange = (report, prefix) => {
    const ranges = {
        fb: [report.Hfb, report.Lfb, report.Afb],
        cb: [report.Hcb, report.Lcb, report.Acb],
        sl: [report.Hsl, report.Lsl, report.Asl],
        ch: [report.Hch, report.Lch, report.Ach],
        ct: [report.Hct, report.Lct, report.Act],
        other: [report.Hother, report.Lother, report.Aother],
    };
    const values = ranges[prefix];
    return values.some((value) => value != null) ? values.map((value) => display(value)).join('/') : '--';
};
const visibleDetails = (fields) => (fields.filter(({ value }) => value != null && value !== '' && value !== '--'));
const isCatcherPosition = (report) => {
    var _a, _b, _c, _d, _e;
    const raw = (_b = (_a = rawFieldNumber(report, 'primarypositionposition')) !== null && _a !== void 0 ? _a : rawFieldNumber(report, 'primaryposition')) !== null && _b !== void 0 ? _b : rawFieldNumber(report, 'reportposition');
    if (raw === 101)
        return true;
    const label = (_e = (_d = (_c = fieldValue(report, 'primaryposition')) !== null && _c !== void 0 ? _c : fieldValue(report, 'reportposition')) !== null && _d !== void 0 ? _d : report.PrimaryPosition) !== null && _e !== void 0 ? _e : report.ReportPosition;
    return label === 'C' || label === 'Catcher';
};
const positionToolFields = (report, version) => [
    { label: version >= 6 ? 'Quality of Contact' : 'Power Frequency', value: pickListValue(report, 37, ['Pfcmts']) },
    { label: version >= 6 ? 'Zone Control' : 'Plate Discipline', value: pickListValue(report, 38, ['Pdcmts']) },
    { label: version >= 6 ? 'Barrel Awareness' : 'Hit Ability', value: pickListValue(report, 39, ['Hitabilitycmts']) },
    { label: 'Raw Power', value: pickListValue(report, 40, ['Rpcmts']) },
    { label: isCatcherPosition(report) ? 'Blocking' : 'Range', value: pickListValue(report, 41, ['Rangecmts']) },
    { label: isCatcherPosition(report) ? 'Receiving' : 'Hands', value: pickListValue(report, 42, ['Handscmts']) },
    { label: 'Arm Strength', value: pickListValue(report, 43, ['Ascmts']) },
    { label: 'Arm Accuracy', value: pickListValue(report, 44, ['Aacmts']) },
    { label: 'Throwing', value: report.Throwscmts },
    { label: version >= 6 ? 'Overall Field' : 'Fielding Ability', value: pickListValue(report, 45, ['Facmts']) },
    { label: 'Run Speed', value: pickListValue(report, 46, ['Rscmts']) },
    { label: 'Base Running', value: pickListValue(report, 47, ['Brcmts']) },
    { label: 'Base Stealing', value: pickListValue(report, 48, ['Bscmts']) },
];
const pitcherToolFields = (report, fastballMovement) => [
    { label: 'Fastball Velocity', value: pickListValue(report, 50, ['Fbvcmts']) },
    { label: 'Fastball Command', value: pickListValue(report, 51, ['Fbcomcmts']) },
    { label: '4-Seam Fastball Movement', value: pickListValue(report, 52, ['Fb4movcmts']) },
    { label: '2-Seam Fastball Movement', value: pickListValue(report, 53, ['Fb2movcmts']) },
    fastballMovement,
    { label: 'Curveball', value: pickListValue(report, 54, ['Cbcmts']) },
    { label: 'Slider', value: pickListValue(report, 55, ['Slcmts']) },
    { label: 'Changeup', value: pickListValue(report, 56, ['Chcmts']) },
    { label: 'Cutter', value: pickListValue(report, 57, ['Ctcmts']) },
    { label: 'Other Pitch', value: pickListValue(report, 58, ['Othercmts']) },
    { label: 'Deception', value: pickListValue(report, 25, ['Deceptioncmts']) },
    { label: 'Control', value: pickListValue(report, 60, ['Controlcmts']) },
];
function FastballMovement({ report }) {
    var _a, _b;
    const [showMovement, setShowMovement] = useState(false);
    const twoSeam = report.FB2Mov;
    const fourSeam = report.FB4Mov;
    const throws = (_b = (_a = report.Player) === null || _a === void 0 ? void 0 : _a.Throws) !== null && _b !== void 0 ? _b : undefined;
    const marker = (movement, source, alt) => {
        const x = movement === null || movement === void 0 ? void 0 : movement.X;
        const y = movement === null || movement === void 0 ? void 0 : movement.Y;
        return x && y ? (React.createElement(MovementMarker, { alt: alt, src: source, style: { left: x - 26, top: y - 26 } })) : null;
    };
    return (React.createElement("div", null,
        report.Fbmovcmts != null ? React.createElement("div", null, display(report.Fbmovcmts)) : null,
        React.createElement(Button, { className: "d-print-none mt-1", onClick: () => setShowMovement((value) => !value), size: "sm" },
            showMovement ? 'Hide' : 'View',
            " Movement"),
        showMovement ? (React.createElement(MovementViewport, null,
            React.createElement(MovementDiagram, { "$throws": throws },
                marker(twoSeam, movementMarkerTwoSeam, 'Two-seam fastball movement'),
                marker(fourSeam, movementMarkerFourSeam, 'Four-seam fastball movement')))) : null));
}
const sharedReportFields = (report, showReportId, summaryHtml = false) => [
    { html: summaryHtml, label: 'Summary', value: report.Summary },
    { label: 'Evaluation Date', value: evaluationDate(report) },
    ...(showReportId ? [{ label: 'Report ID', value: report.ReportID }] : []),
];
const proPositionDetailFields = (data, version, showReportId) => {
    var _a;
    return visibleDetails([
        { label: 'Physical Description', value: pickListValue(data, 1, [], ['PhysicalDesc']) },
        { label: 'Athleticism', value: data.Athleticism },
        ...(version < 6
            ? [
                { label: 'Player Comparison', value: data.PlayerComparison },
                { label: 'Stance / Hit Approach (LH)', value: pickListValue(data, 2, [], ['HitApproach']) },
                { label: 'Stance / Hit Approach (RH)', value: pickListValue(data, 3) },
            ]
            : [
                { label: 'Makeup Comments', value: pickListValue(data, 62, ['MakeupCmt']) },
                { label: 'Swing Mechanics (LH)', value: pickListValue(data, 35, ['SwingMechanicsLHCmts']) },
                { label: 'Swing Mechanics (RH)', value: pickListValue(data, 36, ['SwingMechanicsRHCmts']) },
            ]),
        { label: 'Competitiveness', value: data.Competitiveness },
        { label: 'Medical Issues', value: data.MedicalIssues },
        { label: 'Mental Toughness', value: data.Guts },
        { label: 'Physical Toughness', value: data.Durability },
        ...(version < 3
            ? [{ label: 'Home to 1B', value: firstValue(data, ['HomeTo1bCmts', 'Hometo1BDesc']) }]
            : [
                { label: 'Run Time Average', value: runTimes(data, 'RuntimeAvg') },
                { label: 'Run Time Fastest', value: runTimes(data, 'RuntimeFastest') },
            ]),
        { label: 'Primary Position', value: reportPosition((_a = data.PrimaryPosition) !== null && _a !== void 0 ? _a : data.ReportPosition) },
        { label: 'Other Capable Positions', value: pickListValue(data, 7, [], ['OtherCapablePositions']) },
        { label: 'Conversion Candidate', value: conversionCandidateDisplay(data) },
        { label: 'Catcher Release Times', value: data.CatcherReleaseTimes },
        { label: 'Acquire Org', value: acquisitionDisplay(data, 'AcquireOrgPlayer', 4, version >= 3) },
        { label: 'Acquire Prospect', value: acquisitionDisplay(data, 'AcquireProspect', 3, version >= 2) },
        { label: 'Acquire MLB', value: acquisitionDisplay(data, 'AcquireMLPlayer', 1, version >= 2) },
        { label: 'Quality of Look', value: data.QualityOfLook },
        { label: 'How Seen', value: firstValue(data, ['HowSawCmts', 'HowSaw']) },
        ...(version >= 6 ? [{ label: 'Adjustments', value: data.AdjustmentCmt }] : []),
        { label: 'Team Oriented', value: data.TeamOriented },
        { label: 'Off-Field', value: data.OffField },
        { label: 'Red Flags', value: pickListValue(data, 34, ['RedFlagCmt'], [], true) },
        ...positionToolFields(data, version),
        { html: true, label: 'Second Report', value: data.SecondReport },
        { html: true, label: 'Third Report', value: data.ThirdReport },
        ...sharedReportFields(data, showReportId),
    ]);
};
const proPitcherDetailFields = (data, version, showReportId) => {
    var _a;
    return visibleDetails([
        { label: 'Fastball Velocity (H/L/A)', value: velocityRange(data, 'fb') },
        { label: 'Curveball Velocity (H/L/A)', value: velocityRange(data, 'cb') },
        { label: 'Slider Velocity (H/L/A)', value: velocityRange(data, 'sl') },
        { label: 'Changeup Velocity (H/L/A)', value: velocityRange(data, 'ch') },
        { label: 'Cutter Velocity (H/L/A)', value: velocityRange(data, 'ct') },
        { label: 'Other Velocity (H/L/A)', value: velocityRange(data, 'other') },
        { label: 'Primary Position', value: reportPosition((_a = data.PrimaryPosition) !== null && _a !== void 0 ? _a : data.ReportPosition) },
        { label: 'Fielding', value: data.Fielding },
        { label: 'Arm Angle', value: mappedDisplay(data.ArmAngle) },
        { label: 'Arm Angle Comments', value: firstValue(data, ['ArmAngleCmts', 'ArmAngleDesc']) },
        { label: 'Athleticism', value: data.Athleticism },
        { label: 'Physical Description', value: pickListValue(data, 1, [], ['PhysicalDesc']) },
        { label: 'Competitiveness', value: data.Competitiveness },
        ...(version < 5
            ? [{ label: 'Player Comparison', value: data.PlayerComparison }]
            : [{ label: 'Makeup Comments', value: data.MakeupCmt }]),
        { label: 'Mental Toughness', value: data.Guts },
        { label: 'Medical Issues', value: data.MedicalIssues },
        { label: 'Physical Toughness', value: data.Durability },
        { label: 'Arm Action', value: pickListValue(data, 4, [], ['ArmActionDesc']) },
        ...(version < 4 ? [{ label: 'Lands Firm on Heel', value: booleanDisplay(data.LandsOnHeel) }] : []),
        ...(version < 5 ? [{ label: 'Head Whack', value: booleanDisplay(data.HeadWhack) }] : []),
        { label: 'Delivery', value: pickListValue(data, 5, ['Deliverycmts'], ['DeliveryDesc']) },
        { label: 'Pitchability', value: pickListValue(data, 6, [], ['PitchablityDesc', 'PitchabilityDesc']) },
        ...(version < 3
            ? [
                { label: 'Release Times', value: data.ReleaseTimes },
                { label: 'Slide Step', value: booleanDisplay(data.Slidestep) },
            ]
            : [
                { label: 'Regular Release', value: releaseRange(data, 'ReleaseRegular') },
                { label: 'BS Release', value: releaseRange(data, 'ReleaseBS') },
                { label: 'Slide Release', value: releaseRange(data, 'ReleaseSlide') },
                { label: 'R2 Release', value: releaseRange(data, 'ReleaseR2') },
            ]),
        { label: 'Acquire Org', value: acquisitionDisplay(data, 'AcquireOrgPlayer', 4) },
        { label: 'Acquire Prospect', value: acquisitionDisplay(data, 'AcquireProspect', 3) },
        { label: 'Acquire MLB', value: acquisitionDisplay(data, 'AcquireMLPlayer', 1) },
        { label: 'Quality of Look', value: data.QualityOfLook },
        { label: 'How Seen', value: firstValue(data, ['HowSawCmts', 'HowSaw']) },
        ...(version >= 5 ? [{ label: 'Adjustments', value: data.AdjustmentCmt }] : []),
        ...(version >= 4 ? [{ label: 'Pitch Tipping', value: data.TippingCmts }] : []),
        { label: 'Team Oriented', value: data.TeamOriented },
        { label: 'Off-Field', value: data.OffField },
        { label: 'Deception Description', value: data.DeceptionDesc },
        { label: 'Red Flags', value: pickListValue(data, 34, ['RedFlagCmt'], [], true) },
        ...pitcherToolFields(data, version === 2
            ? { label: 'Fastball Movement', value: React.createElement(FastballMovement, { report: data }) }
            : { label: 'Fastball Movement', value: data.Fbmovcmts }),
        { html: true, label: 'Second Report', value: data.SecondReport },
        { html: true, label: 'Third Report', value: data.ThirdReport },
        ...sharedReportFields(data, showReportId),
    ]);
};
const limitedPositionDetailFields = (data, version, showReportId) => {
    var _a;
    return visibleDetails([
        { label: 'Games Seen', value: data.Games },
        ...(version === 1 ? [
            { label: 'Offensive Grade', value: mappedDisplay(data.Offense) },
            { label: 'Defensive Grade', value: mappedDisplay(data.Defense) },
            { label: 'Arm Strength', value: data.ArmStrength },
            { label: 'Run Grade', value: mappedDisplay(data.Run) },
        ] : []),
        { label: 'Interest', value: mappedDisplay(data.Interest) },
        ...(version >= 2 ? [
            { label: 'Primary Position', value: reportPosition((_a = data.PrimaryPosition) !== null && _a !== void 0 ? _a : data.ReportPosition) },
            { label: 'Mechanical Notes', value: data.MechanicalNotes },
        ] : []),
        ...(version >= 6 ? [{ label: 'Adjustments', value: data.AdjustmentCmt }] : []),
        ...(version >= 7 ? [
            { label: 'Physical Description', value: pickListValue(data, 1) },
            { label: 'Quality of Look', value: data.QualityOfLook },
            { label: 'How Seen', value: data.HowSawCmts },
            ...positionToolFields(data, version),
        ] : []),
        ...sharedReportFields(data, showReportId, true),
    ]);
};
const limitedPitcherDetailFields = (data, version, showReportId) => visibleDetails([
    { label: 'Arm Angle', value: mappedDisplay(data.ArmAngle) },
    ...(version === 1 ? [
        { label: 'Fastball Command', value: mappedDisplay(data.Fbcmd) },
        { label: 'Control', value: mappedDisplay(data.Control) },
    ] : [
        { label: 'Mechanical Notes', value: data.MechanicalNotes },
    ]),
    { label: 'Interest', value: mappedDisplay(data.Interest) },
    ...(version >= 5 ? [{ label: 'Adjustments', value: data.AdjustmentCmt }] : []),
    ...(version >= 6 ? [
        { label: 'Physical Description', value: pickListValue(data, 1) },
        { label: 'Quality of Look', value: data.QualityOfLook },
        { label: 'How Seen', value: data.HowSawCmts },
        ...pitcherToolFields(data, { label: 'Fastball Movement', value: data.Fbmovcmts }),
    ] : []),
    ...sharedReportFields(data, showReportId, true),
]);
const playerDevelopmentDetailFields = (data, kind, version) => {
    var _a, _b, _c;
    const usesExpectationsWording = version >= 2;
    return visibleDetails([
        { label: 'Report Position', value: reportPosition(data.ReportPosition) },
        { label: 'Projected MLB Role', value: (_c = (_b = groupRoles.get((_a = rawFieldNumber(data, 'group')) !== null && _a !== void 0 ? _a : Number(data.Group))) === null || _b === void 0 ? void 0 : _b[kind]) !== null && _c !== void 0 ? _c : '' },
        {
            html: true,
            label: usesExpectationsWording
                ? 'Why will player reach or exceed your expectations?'
                : 'Why will player reach or exceed projected role?',
            value: data.ExceedRoleCmt,
        },
        {
            html: true,
            label: usesExpectationsWording
                ? 'Why might player fall short of your expectations?'
                : 'Why might player fall short of projected role?',
            value: data.FailRoleCmt,
        },
        { html: true, label: 'Next Year Role', value: data.NextYearRole },
        { html: true, label: 'General Comments', value: data.Comments },
    ]);
};
const springTrainingDetailFields = (data, showReportId) => visibleDetails([
    { html: true, label: 'Summary', value: data.Summary },
    { label: 'Adjustment Comments', value: data.AdjustmentCmts },
    { label: 'Evaluation Date', value: evaluationDate(data) },
    ...(showReportId ? [{ label: 'Report ID', value: data.ReportID }] : []),
]);
function DetailGrid({ columns, rows, rowKey, rowNote, renderRowDetails, footer, }) {
    return (React.createElement(NestedTable, null,
        React.createElement("thead", null,
            React.createElement("tr", null, columns.map((column) => (React.createElement("th", { key: column.heading, className: column.isText ? 'text-cell' : undefined }, column.heading))))),
        React.createElement("tbody", null, rows.map((row, index) => {
            const key = rowKey(row, index);
            const note = rowNote === null || rowNote === void 0 ? void 0 : rowNote(row);
            return (React.createElement(React.Fragment, { key: key },
                React.createElement("tr", null, columns.map((column) => (React.createElement("td", { key: column.heading, className: column.isText ? 'text-cell' : undefined }, isPresent(column.value(row)) ? display(column.value(row)) : '')))), renderRowDetails === null || renderRowDetails === void 0 ? void 0 :
                renderRowDetails(row),
                isPresent(note) ? (React.createElement("tr", null,
                    React.createElement("td", null),
                    React.createElement("td", { className: "text-cell", colSpan: columns.length - 1 },
                        React.createElement("em", null,
                            "Cmts: ",
                            display(note))))) : null));
        })),
        footer));
}
const observationDate = (observation) => {
    var _a, _b, _c;
    return (date((_c = (_b = (_a = observation.Game) === null || _a === void 0 ? void 0 : _a.GameDate) !== null && _b !== void 0 ? _b : observation.ObservationDate) !== null && _c !== void 0 ? _c : undefined));
};
const observationTypeLabels = {
    0: 'Game', 1: 'Batting Practice', 2: 'Workout', 3: 'Bullpen', 4: 'Tournament', 5: 'Other', 6: 'Showcase',
};
const observationEvent = (observation) => {
    var _a, _b, _c;
    if (observation.TournamentName)
        return observation.TournamentName;
    if (observation.Game)
        return `${display((_a = observation.Game.AwayTeam) === null || _a === void 0 ? void 0 : _a.Abbr)}@${display((_b = observation.Game.HomeTeam) === null || _b === void 0 ? void 0 : _b.Abbr)}`;
    const type = typeof observation.ObservationType === 'number'
        ? observation.ObservationType
        : Number(observation.ObservationType);
    return (_c = observationTypeLabels[type]) !== null && _c !== void 0 ? _c : mappedDisplay(typeof observation.ObservationType === 'string' || typeof observation.ObservationType === 'number'
        ? observation.ObservationType
        : null);
};
const observationKey = (observation, index) => {
    var _a;
    return (String((_a = observation.ObservationID) !== null && _a !== void 0 ? _a : `${observationDate(observation)}-${index}`));
};
const observationNotes = (observation) => {
    var _a, _b;
    return joinPresent([
        observation.Notes,
        observation.HowSaw ? `How Saw: ${observation.HowSaw}` : null,
        observation.BP && (((_a = observation.BPBarreledBalls) !== null && _a !== void 0 ? _a : 0) > 0 || ((_b = observation.BPBallsInPlay) !== null && _b !== void 0 ? _b : 0) > 0)
            ? `BP Barreled Balls: ${display(observation.BPBarreledBalls)}/${display(observation.BPBallsInPlay)}`
            : null,
    ], ' | ');
};
const observationColumnSets = {
    'amateur-position': [
        { heading: 'Date', value: observationDate },
        { heading: 'Event', value: observationEvent, isText: true },
        { heading: 'Team', value: (row) => row.TournamentTeam, isText: true },
        { heading: 'BP', value: (row) => (row.BP == null ? '' : yesNo(row.BP, true)) },
        { heading: 'In/Outfield', value: (row) => (row.InOutField == null ? '' : yesNo(row.InOutField, true)) },
        { heading: 'G', value: (row) => row.G },
        { heading: 'PA', value: (row) => row.PA },
        { heading: 'AB', value: (row) => row.AB },
        { heading: 'H', value: (row) => row.H },
        { heading: 'XBH', value: (row) => row.XBH },
        { heading: 'SO', value: (row) => row.SO },
        { heading: 'BB', value: (row) => row.BB },
    ],
    'amateur-pitcher': [
        { heading: 'Date', value: observationDate },
        { heading: 'Event', value: observationEvent, isText: true },
        { heading: 'Team', value: (row) => row.TournamentTeam, isText: true },
        { heading: 'G', value: (row) => row.G },
        { heading: 'IP', value: (row) => row.Innings },
        { heading: 'SO', value: (row) => row.SO },
        { heading: 'BB', value: (row) => row.BB },
        {
            heading: 'Ms/Sw',
            value: (row) => { var _a, _b; return (((_a = row.FBsSwungAt) !== null && _a !== void 0 ? _a : 0) > 0 || ((_b = row.FBsMissed) !== null && _b !== void 0 ? _b : 0) > 0 ? `${display(row.FBsMissed)}/${display(row.FBsSwungAt)}` : ''); },
        },
    ],
    'amateur-pitcher-id': [
        { heading: 'Date', value: observationDate },
        { heading: 'Event', value: observationEvent, isText: true },
        { heading: 'Team', value: (row) => row.TournamentTeam, isText: true },
        { heading: 'G', value: (row) => row.G },
        { heading: 'IP', value: (row) => row.Innings },
        { heading: 'SO', value: (row) => row.SO },
        { heading: 'BB', value: (row) => row.BB },
        { heading: 'GB', value: (row) => row.GB },
        { heading: 'FB', value: (row) => row.FB },
    ],
    'international-position': [
        { heading: 'Date', value: observationDate },
        { heading: 'Event', value: (row) => joinPresent([observationEvent(row), row.TournamentTeam ? `Team: ${row.TournamentTeam}` : null]), isText: true },
        { heading: 'G', value: (row) => row.G },
        { heading: 'PA', value: (row) => row.PA },
        { heading: 'AB', value: (row) => row.AB },
        { heading: 'SO', value: (row) => row.SO },
        { heading: 'BB', value: (row) => row.BB },
        { heading: 'H', value: (row) => row.H },
        { heading: 'XBH', value: (row) => row.XBH },
    ],
    'international-pitcher': [
        { heading: 'Date', value: observationDate },
        { heading: 'Event', value: observationEvent, isText: true },
        { heading: 'G', value: (row) => row.G },
        { heading: 'IP', value: (row) => row.Innings },
        { heading: 'SO', value: (row) => row.SO },
        { heading: 'BB', value: (row) => row.BB },
        { heading: 'GB', value: (row) => row.GB },
        { heading: 'FB', value: (row) => row.FB },
        { heading: 'FB Sw', value: (row) => row.FBsSwungAt },
        { heading: 'FB Ms', value: (row) => row.FBsMissed },
    ],
};
const observationsGrid = (report, columnSet) => {
    const observations = Array.isArray(report.Observations) ? report.Observations : [];
    if (!observations.length)
        return null;
    return (React.createElement(DetailGrid, { columns: observationColumnSets[columnSet], rows: observations, rowKey: observationKey, rowNote: observationNotes }));
};
const stickPositionObservationColumns = observationColumnSets['amateur-position'].map((column) => {
    if (column.heading === 'BP')
        return Object.assign(Object.assign({}, column), { value: (row) => (row.BP == null ? '' : yesNo(row.BP)) });
    if (column.heading === 'In/Outfield')
        return Object.assign(Object.assign({}, column), { value: (row) => (row.InOutField == null ? '' : yesNo(row.InOutField)) });
    return column;
});
const withPitchObservationStats = (columns) => [
    ...columns.flatMap((column) => (column.heading === 'SO'
        ? [{ heading: 'H', value: (row) => row.H }, column]
        : [column])),
    { heading: 'FB Spn', value: (row) => row.FBSpin },
    { heading: 'CB Spn', value: (row) => row.CBSpin },
    { heading: 'SL Spn', value: (row) => row.SLSpin },
];
const stickObservationColumns = {
    position: stickPositionObservationColumns,
    pitcher: withPitchObservationStats(observationColumnSets['amateur-pitcher']),
    internationalPosition: [
        ...stickPositionObservationColumns,
        { heading: 'Qual AB', value: (row) => row.QualityAB },
        { heading: 'Qual Cont', value: (row) => row.QualityContact },
    ],
    internationalPitcher: withPitchObservationStats(observationColumnSets['international-pitcher']),
};
const stickObservationLayout = new Map([
    [21, 'position'], [23, 'position'], [31, 'position'],
    [22, 'pitcher'], [24, 'pitcher'], [32, 'pitcher'],
    [25, 'internationalPosition'], [34, 'internationalPosition'],
    [26, 'internationalPitcher'], [35, 'internationalPitcher'],
]);
const totalObservations = (observations) => {
    const sum = (value) => (observations.reduce((total, row) => { var _a; return total + ((_a = value(row)) !== null && _a !== void 0 ? _a : 0); }, 0));
    const averageSpin = (value) => {
        const count = observations.filter((row) => { var _a; return ((_a = value(row)) !== null && _a !== void 0 ? _a : 0) > 0; }).length;
        return count ? sum(value) / count : null;
    };
    const outs = sum((row) => { var _a, _b; return (Math.floor((_a = row.Innings) !== null && _a !== void 0 ? _a : 0) * 3) + Math.round((((_b = row.Innings) !== null && _b !== void 0 ? _b : 0) % 1) * 10); });
    return {
        G: sum((row) => row.G),
        PA: sum((row) => row.PA),
        AB: sum((row) => row.AB),
        H: sum((row) => row.H),
        XBH: sum((row) => row.XBH),
        SO: sum((row) => row.SO),
        BB: sum((row) => row.BB),
        GB: sum((row) => row.GB),
        FB: sum((row) => row.FB),
        Innings: Math.floor(outs / 3) + ((outs % 3) / 10),
        FBsSwungAt: sum((row) => row.FBsSwungAt),
        FBsMissed: sum((row) => row.FBsMissed),
        QualityAB: sum((row) => row.QualityAB),
        QualityContact: sum((row) => row.QualityContact),
        FBSpin: averageSpin((row) => row.FBSpin),
        CBSpin: averageSpin((row) => row.CBSpin),
        SLSpin: averageSpin((row) => row.SLSpin),
    };
};
// Published STICK layouts have different columns and totals from migrated scouting reports.
const ScoutingReportObservations = ({ observations, reportType: observationReportType }) => {
    const layout = stickObservationLayout.get(observationReportType);
    if (!layout)
        return null;
    const columns = stickObservationColumns[layout];
    const hasBattingPractice = layout === 'position' || layout === 'internationalPosition';
    const hasTotals = layout === 'internationalPosition' || layout === 'internationalPitcher';
    const totalLabelSpan = hasBattingPractice ? 5 : 2;
    const totals = hasTotals ? totalObservations(observations) : null;
    return (React.createElement(DetailGrid, { columns: columns, rows: observations, rowKey: observationKey, renderRowDetails: (observation) => {
            var _a, _b;
            return (React.createElement(React.Fragment, null,
                hasBattingPractice && observation.BP && (((_a = observation.BPBarreledBalls) !== null && _a !== void 0 ? _a : 0) > 0 || ((_b = observation.BPBallsInPlay) !== null && _b !== void 0 ? _b : 0) > 0) ? (React.createElement("tr", null,
                    React.createElement("td", { colSpan: 3 }),
                    React.createElement("td", { className: "text-cell", colSpan: columns.length - 3 },
                        "BP Barreled Balls: ",
                        observation.BPBarreledBalls,
                        "/",
                        observation.BPBallsInPlay))) : null,
                observation.Notes ? (React.createElement("tr", null,
                    React.createElement("td", null),
                    React.createElement("td", { className: "text-cell", colSpan: columns.length - 1 },
                        React.createElement("em", null,
                            "Cmts: ",
                            observation.Notes)))) : null,
                layout === 'internationalPitcher' && observation.HowSaw ? (React.createElement("tr", null,
                    React.createElement("td", null, "How Saw"),
                    React.createElement("td", { className: "text-cell", colSpan: columns.length - 1 },
                        React.createElement("em", null, observation.HowSaw)))) : null));
        }, footer: totals ? (React.createElement("tfoot", null,
            React.createElement("tr", null,
                React.createElement("td", { colSpan: totalLabelSpan },
                    React.createElement("strong", null, "Total")),
                columns.slice(totalLabelSpan).map((column) => {
                    var _a;
                    return (React.createElement("td", { key: column.heading }, (_a = column.value(totals)) !== null && _a !== void 0 ? _a : ''));
                })))) : null }));
};
const positiveRate = (value, precision) => ((value !== null && value !== void 0 ? value : 0) > 0 ? display(value, precision) : '');
const perNine = (stat, innings) => {
    if (stat == null || !innings)
        return '';
    // Scouting stores baseball innings: 45.2 means 45 innings and two outs.
    const outs = (Math.floor(innings) * 3) + Math.round((innings % 1) * 10);
    const rate = per9IP(stat, outs);
    return rate === null ? '' : display(rate, 1);
};
const performanceColumnSets = {
    hitting: [
        { heading: 'Year', value: (row) => row.YearID },
        { heading: 'Level', value: (row) => { var _a; return (_a = row.Level) === null || _a === void 0 ? void 0 : _a.Abbr; } },
        { heading: 'Team', value: (row) => row.Team, isText: true },
        { heading: 'G', value: (row) => row.G },
        { heading: 'AB', value: (row) => row.AB },
        { heading: 'H', value: (row) => row.H },
        { heading: '2B', value: (row) => row.B2 },
        { heading: '3B', value: (row) => row.B3 },
        { heading: 'HR', value: (row) => row.HR },
        { heading: 'BB', value: (row) => row.BB },
        { heading: 'SO', value: (row) => row.SO },
        { heading: 'SB', value: (row) => row.SB },
        { heading: 'CS', value: (row) => row.CS },
        { heading: 'G/F', value: (row) => positiveRate(row.GBFB, 1) },
        { heading: 'OPS', value: (row) => positiveRate(row.OPS, 3) },
        { heading: 'AB/SO', value: (row) => { var _a; return (row.SO ? display(((_a = row.AB) !== null && _a !== void 0 ? _a : 0) / row.SO, 1) : ''); } },
        { heading: 'AB/BB', value: (row) => { var _a; return (row.BB ? display(((_a = row.AB) !== null && _a !== void 0 ? _a : 0) / row.BB, 1) : ''); } },
    ],
    pitching: [
        { heading: 'Year', value: (row) => row.YearID },
        { heading: 'Level', value: (row) => { var _a; return (_a = row.Level) === null || _a === void 0 ? void 0 : _a.Abbr; } },
        { heading: 'Team', value: (row) => row.Team, isText: true },
        { heading: 'G', value: (row) => row.G },
        { heading: 'W', value: (row) => row.W },
        { heading: 'L', value: (row) => row.L },
        { heading: 'IP', value: (row) => positiveRate(row.Innings, 1) },
        { heading: 'H', value: (row) => row.H },
        { heading: 'HR', value: (row) => row.HR },
        { heading: 'BB', value: (row) => row.BB },
        { heading: 'SO', value: (row) => row.SO },
        { heading: 'G/F', value: (row) => positiveRate(row.GBFB, 1) },
        { heading: 'ERA', value: (row) => positiveRate(row.ERA, 2) },
        { heading: 'QERA', value: (row) => positiveRate(row.QERA, 2) },
        { heading: 'K/9', value: (row) => perNine(row.SO, row.Innings) },
        { heading: 'BB/9', value: (row) => perNine(row.BB, row.Innings) },
    ],
};
const performancesGrid = (report, columnSet) => {
    const performances = Array.isArray(report.Performances) ? report.Performances : [];
    if (!performances.length)
        return null;
    return (React.createElement(DetailGrid, { columns: performanceColumnSets[columnSet], rows: performances, rowKey: (row, index) => { var _a; return `${display(row.YearID)}-${display((_a = row.Level) === null || _a === void 0 ? void 0 : _a.Abbr)}-${display(row.Team)}-${index}`; } }));
};
const medicalIssues = (report) => joinPresent([
    report.HasMedicalIssues == null ? null : yesNo(report.HasMedicalIssues, false),
    report.MedicalIssuesCmts,
]);
const amateurGeneralFields = (data, positionsPickList) => {
    var _a, _b, _c;
    return [
        { label: 'Positions Seen', value: pickListValue(data, positionsPickList) },
        { label: 'College Commit', value: (_a = data.CollegeCommitment) === null || _a === void 0 ? void 0 : _a.SchoolName },
        { label: 'Agent/Agency', value: joinPresent([(_b = data.Agency) === null || _b === void 0 ? void 0 : _b.FirmName, (_c = data.Agent) === null || _c === void 0 ? void 0 : _c.FullName]) },
        { label: 'Medical Issues', value: medicalIssues(data) },
        { label: 'Glasses/Contacts', value: booleanDisplay(data.Glasses) },
        { label: 'Video On File', value: booleanDisplay(data.HasVideoOnFile) },
    ];
};
const amateurMakeupFields = (data, version) => [
    version === 1 ? { label: 'Charisma', value: data.Charisma } : { label: 'Presence', value: data.Presence },
    { label: 'Competitiveness', value: data.Competitiveness },
    ...(version >= 2
        ? [
            { label: 'Obstacles', value: data.Obstacles },
            { label: 'Passion', value: data.Passion },
            { label: 'Off-field', value: data.OffField },
        ]
        : []),
    { label: 'Self-Awareness', value: data.SelfAware },
    { label: 'Self-Confidence', value: data.SelfConfidence },
    ...(version === 1
        ? [
            { label: 'Perceived Desire', value: data.Desire },
            { label: 'Adversity', value: data.Adversity },
        ]
        : []),
    { label: 'Baseball Awareness', value: presentPair(data.Pbbintel, data.Fbbintel) },
    { label: 'Preparation', value: presentPair(data.Ppreparation, data.Fpreparation) },
    { label: 'On-field Makeup', value: pickListValue(data, 11) },
    { label: 'Off-field Makeup', value: pickListValue(data, 12) },
    { label: 'Performance', value: data.PerformanceCmts },
    { label: 'Makeup', value: data.MakeupCmts },
];
const amateurDraftFields = (data, version, boardTypePickList, riskAreaPickList) => [
    { label: 'Board Type', value: version === 1 ? pickListValue(data, boardTypePickList) : mappedDisplay(data.BoardType) },
    { label: 'Risk Area', value: pickListValue(data, riskAreaPickList) },
    {
        label: 'Round',
        value: joinPresent([
            `Comfort: ${mappedDisplay(data.HighComfortRound)}`,
            version === 1 ? `If I Had To: ${mappedDisplay(data.HadToRound)}` : null,
        ], '   '),
    },
    { label: 'Comfort Level', value: mappedDisplay(data.ComfortLevel) },
    { label: 'Round Investment', value: mappedDisplay(data.InvestmentFigure) },
    { label: 'Comfort Level Comments', value: data.ComfortLevelCmts },
];
const amateurIdentificationFields = (data) => {
    var _a, _b, _c;
    return [
        {
            label: 'Eligible Year',
            value: ((_a = rawFieldNumber(data, 'eligibleyear')) !== null && _a !== void 0 ? _a : data.EligibleYear) === 0
                ? 'Eligible'
                : ((_b = fieldValue(data, 'eligibleyear')) !== null && _b !== void 0 ? _b : data.EligibleYear),
        },
        { label: 'School', value: (_c = data.School) === null || _c === void 0 ? void 0 : _c.SchoolName },
    ];
};
const summaryFields = (data, label, showReportId) => [
    { label, value: data.Summary },
    { label: 'Published', value: date(data.PublishedDate) },
    ...(showReportId ? [{ label: 'Report ID', value: data.ReportID }] : []),
];
const amateurPositionDetailFields = (data, version, showReportId) => visibleDetails(data.Type.Type === 31
    ? [
        ...amateurIdentificationFields(data),
        { label: '60-Yard', value: data.Yard60 },
        { label: 'Home to 1B', value: data.HomeTo1bCmts },
        { label: 'Dates Observed', value: observationsGrid(data, 'amateur-position') },
        ...summaryFields(data, 'Final Comments', showReportId),
    ]
    : [
        ...amateurGeneralFields(data, 21),
        { label: '60-Yard', value: data.Yard60 },
        { label: 'Dates Observed', value: observationsGrid(data, 'amateur-position') },
        { label: 'Home to 1B', value: data.HomeTo1bCmts },
        { label: 'Risk to Hit', value: mappedDisplay(data.RiskToHit) },
        { label: 'Physical Tools', value: data.PhysicalToolsCmts },
        { label: 'Swing Issues', value: pickListValue(data, 8) },
        { label: 'Hitting Skills', value: data.HitCmts },
        { label: 'Red Flags', value: pickListValue(data, 9) },
        { label: 'Body Type', value: pickListValue(data, 10) },
        { label: 'Body Comparison', value: data.BodyComparison },
        { label: 'Defensive Skills', value: data.DefenseCmts },
        { label: 'Athletic Ability', value: data.AthleticCmts },
        { label: 'Performance History', value: performancesGrid(data, 'hitting') },
        ...amateurMakeupFields(data, version),
        ...amateurDraftFields(data, version, 19, 13),
        ...summaryFields(data, 'Final Comments', showReportId),
    ]);
const amateurPitcherDetailFields = (data, version, showReportId) => {
    const velocities = [
        { label: 'Fastball Velocity (H/L/A)', value: data.Ffb ? velocityRange(data, 'fb') : null },
        { label: 'Curveball Velocity (H/L/A)', value: data.Fcb ? velocityRange(data, 'cb') : null },
        { label: 'Slider Velocity (H/L/A)', value: data.Fsl ? velocityRange(data, 'sl') : null },
        { label: 'Changeup Velocity (H/L/A)', value: data.Fch ? velocityRange(data, 'ch') : null },
        { label: 'Other Velocity (H/L/A)', value: data.Fother ? velocityRange(data, 'other') : null },
    ];
    if (data.Type.Type === 32) {
        return visibleDetails([
            ...velocities,
            ...amateurIdentificationFields(data),
            { label: 'Dates Observed', value: observationsGrid(data, 'amateur-pitcher-id') },
            ...summaryFields(data, 'Final Comments', showReportId),
        ]);
    }
    return visibleDetails([
        ...velocities,
        { label: 'Curveball Command', value: data.Fcb ? presentPair(data.Pcbcmd, data.Fcbcmd) : null },
        { label: 'Slider Command', value: data.Fsl ? presentPair(data.Pslcmd, data.Fslcmd) : null },
        { label: 'Changeup Command', value: data.Fch ? presentPair(data.Pchcmd, data.Fchcmd) : null },
        { label: 'Other Command', value: data.Fother ? presentPair(data.Pothercmd, data.Fothercmd) : null },
        ...(version < 3
            ? [{ label: 'Pitch Package', value: data.StuffCmts }]
            : [
                { label: 'FB Comments', value: data.FbCmts },
                { label: 'FB Movement (4-Seam)', value: pickListValue(data, 29) },
                { label: 'FB Movement (2-Seam)', value: pickListValue(data, 30) },
                { label: 'Secondary Comments', value: data.StuffCmts },
            ]),
        ...amateurGeneralFields(data, 22),
        { label: 'Dates Observed', value: observationsGrid(data, 'amateur-pitcher') },
        { label: 'Arm Angle', value: pickListValue(data, 20) },
        { label: 'Body Type', value: pickListValue(data, 10) },
        { label: 'Pitching Attributes', value: data.AbilityCmts },
        { label: 'Body Comparison', value: data.BodyComparison },
        { label: 'Physical Attributes', value: data.PhysicalCmts },
        { label: 'Performance History', value: performancesGrid(data, 'pitching') },
        ...amateurMakeupFields(data, version),
        { label: 'Projected Role', value: mappedDisplay(data.ProjectedRole) },
        ...amateurDraftFields(data, version, 15, 14),
        ...summaryFields(data, 'Final Comments', showReportId),
    ]);
};
const amateurGrade = (value) => gradeLabel(value, true);
const gradedComment = (gradeValue, comments) => joinPresent([gradeValue, comments], ' | ');
const internationalGeneralFields = (data, observationSet) => {
    var _a, _b;
    return [
        {
            label: 'Eligible Year',
            value: ((_a = rawFieldNumber(data, 'eligibleyear')) !== null && _a !== void 0 ? _a : data.EligibleYear) === 0
                ? 'Eligible'
                : ((_b = fieldValue(data, 'eligibleyear')) !== null && _b !== void 0 ? _b : data.EligibleYear),
        },
        { label: 'MLB Position', value: reportPosition(data.ReportPosition) },
        { label: 'Height', value: height(data.Height) },
        { label: 'Dates Observed', value: observationsGrid(data, observationSet) },
        { label: 'How Saw', value: gradedComment(mappedDisplay(data.HowSaw), data.HowSawCmts) },
        { label: 'Performance', value: data.PerformanceCmts },
        { label: 'Athleticism', value: gradedComment(mappedDisplay(data.Athleticism), data.AthleticismCmts) },
        { label: 'Weight (lbs)', value: data.Weight },
    ];
};
const internationalFullReportFields = (data, physicalDescription) => [
    { label: 'Physical Desc.', value: physicalDescription },
    { label: 'Tools Desc.', value: data.ToolsCmts },
    { label: 'Player Type', value: pickListValue(data, 17) },
    { label: 'Weaknesses', value: data.WeaknessesCmts },
    { label: 'Glasses/Contacts', value: booleanDisplay(data.Glasses) },
    { label: 'Medical Issues', value: medicalIssues(data) },
];
const internationalSignabilityFields = (data, includeComments) => [
    { label: 'Signability', value: gradedComment(mappedDisplay(data.Signability), includeComments ? data.SignabilityCmts : null) },
    { label: 'Premium Sign', value: gradedComment(booleanDisplay(data.PremiumSign), includeComments ? data.PremiumSignCmts : null) },
];
const internationalVisitFields = (data) => [
    { label: 'Date of Visit', value: date(data.DateOfVisit) },
    { label: 'Setting', value: pickListValue(data, 28) },
    { label: 'Persons Present', value: data.PersonsPresent },
    { label: 'Sign', value: booleanDisplay(data.Draft) },
];
const internationalMakeupFields = (data, version) => [
    ...(version === 1
        ? [
            { label: 'Prepare', value: gradedComment(amateurGrade(data.Prepare), data.PrepareCmts) },
            { label: 'Compete', value: gradedComment(amateurGrade(data.Compete), data.CompeteCmts) },
            { label: 'Team', value: gradedComment(amateurGrade(data.TeamWork), data.TeamWorkCmts) },
            { label: 'Growth', value: gradedComment(amateurGrade(data.Growth), data.GrowthCmts) },
            { label: 'Home Situation', value: data.HomeCmts },
            { label: 'Personal History', value: data.PersonalCmts },
            { label: 'Intelligence', value: data.IntelligenceCmts },
            { label: 'In Home Visit', value: data.InHomeCmts },
            { label: 'Makeup', value: data.MakeupCmts },
            { label: 'Effect on Perf', value: data.EffectOnPerformance },
        ]
        : [
            { label: 'Competitiveness', value: gradedComment(amateurGrade(data.Compete), data.CompeteCmts) },
            { label: 'Presence', value: gradedComment(amateurGrade(data.Presence), data.PresenceCmts) },
            { label: 'Passion', value: gradedComment(amateurGrade(data.Passion), data.PassionCmts) },
            { label: 'Handling Obstacles', value: gradedComment(amateurGrade(data.Obstacles), data.ObstaclesCmts) },
            { label: 'Self Awareness', value: gradedComment(amateurGrade(data.SelfAware), data.SelfAwareCmts) },
            { label: 'Preparation', value: gradedComment(amateurGrade(data.Preparation), data.PreparationCmts) },
            { label: 'Baseball Awareness', value: gradedComment(amateurGrade(data.BaseballAware), data.BaseballAwareCmts) },
            { label: 'Off Field', value: gradedComment(amateurGrade(data.OffField), data.OffFieldCmts) },
            { label: 'Key Makeup Characteristics', value: pickListValue(data, 24) },
            { label: 'Concerns', value: data.ConcernCmts },
        ]),
];
const internationalTampaFields = (data) => [
    {
        label: 'TAMPA Scores',
        value: joinPresent([
            isPresent(data.ToolsScale) ? `Tools ${display(data.ToolsScale)}` : null,
            isPresent(data.AthleticismScale) ? `Athleticism ${display(data.AthleticismScale)}` : null,
            isPresent(data.MakeupScale) ? `Makeup ${display(data.MakeupScale)}` : null,
            isPresent(data.PerformanceScale) ? `Performance ${display(data.PerformanceScale)}` : null,
            isPresent(data.AwarenessScale) ? `Analytics ${display(data.AwarenessScale)}` : null,
            isPresent(data.Tampa) ? `TAMPA Score ${display(data.Tampa)}` : null,
        ], ' | '),
    },
];
const internationalFinalFields = (data, includeInterest, showReportId) => [
    { label: 'Group', value: amateurGrade(data.PGroup) },
    { label: '2/3 Tool', value: presentPair(data.Tool2Scores, data.Tool3Scores) },
    ...(includeInterest ? [{ label: 'Interest', value: mappedDisplay(data.Interest) }] : []),
    ...internationalTampaFields(data),
    { label: 'Market Value', value: data.MarketValue },
    { label: 'Asking Bonus', value: data.AskingBonus },
    ...internationalSignabilityFields(data, true),
    { label: 'ETA to Tampa', value: data.ETAtoTampa },
    ...summaryFields(data, 'Summary', showReportId),
];
const homeToFirstTimes = (data) => joinPresent([
    data.Hto1bCmts,
    data.Hometo1bLeft ? `LHH: ${data.Hometo1bLeft}` : null,
    data.Hometo1bRight ? `RHH: ${data.Hometo1bRight}` : null,
], ' | ');
const internationalPositionDetailFields = (data, version, showReportId, showRestrictedOfp) => {
    const isFull = data.Type.Type === 25;
    const yardTimes = version >= 4 || !isFull
        ? joinPresent([`20 Yard ${display(data.Yard20Dec)}`, `40 Yard ${display(data.Yard40Dec)}`, `60 Yard ${display(data.Yard60Dec)}`], ' | ')
        : joinPresent([
            `10 Yard ${display(data.Yard10)}`, `20 Yard ${display(data.Yard20)}`, `40 Yard ${display(data.Yard40)}`, `60 Yard ${display(data.Yard60)}`,
        ], ' | ');
    return visibleDetails([
        ...(isFull && version >= 5 && showRestrictedOfp && data.OFPPercent ? [{ label: 'OFP Percentage', value: `${data.OFPPercent}%` }] : []),
        ...internationalGeneralFields(data, 'international-position'),
        ...(isFull ? internationalFullReportFields(data, data.PhysicalDescriptioncmts) : []),
        { label: 'Education Status', value: data.EducationStatusCmts },
        ...(isFull ? [] : internationalSignabilityFields(data, false)),
        ...(isFull
            ? [
                { label: 'Hit Ability', value: gradedComment(presentPair(data.Phit, data.Fhit), data.HitabilityCmts) },
                { label: 'Plate Discipline', value: gradedComment(presentPair(data.Ppd, data.Fpd), data.PdCmts) },
                { label: 'Plate Discipline Type', value: pickListValue(data, 16) },
                { label: 'Power Frequency', value: gradedComment(presentPair(data.Ppf, data.Fpf), data.PfCmts) },
                { label: 'Raw Power', value: gradedComment(presentPair(data.Prp, data.Frp), data.RpCmts) },
                { label: 'Arm Strength', value: gradedComment(presentPair(data.Pas, data.Fas), data.AsCmts) },
                { label: 'Arm Accuracy', value: gradedComment(presentPair(data.Paa, data.Faa), data.AaCmts) },
                { label: 'Fielding Ability', value: gradedComment(presentPair(data.Pfa, data.Ffa), data.FaCmts) },
                { label: 'Range', value: gradedComment(presentPair(data.Pr, data.Fr), data.RangeCmts) },
                { label: 'Base Running', value: gradedComment(presentPair(data.Pbr, data.Fbr), data.BrCmts) },
                ...(version === 1 ? [{ label: 'Home to 1B', value: homeToFirstTimes(data) }] : []),
            ]
            : []),
        ...(version >= 2
            ? [
                { label: 'Home to 1B', value: gradedComment(presentPair(data.Phto1b, data.Fhto1b), homeToFirstTimes(data)) },
                { label: 'Total Speed', value: gradedComment(presentPair(data.Prs, data.Frs), yardTimes) },
            ]
            : []),
        ...(isFull && version >= 2
            ? [
                { label: 'Total Speed Comments', value: data.RsCmts },
                { label: 'Usable Game Speed', value: gradedComment(presentPair(data.Pgs, data.Fgs), data.GsCmts) },
            ]
            : []),
        ...(isFull
            ? [
                { label: 'Hitter Type', value: data.HitterType },
                ...internationalVisitFields(data),
                ...internationalMakeupFields(data, version),
                ...internationalFinalFields(data, true, showReportId),
            ]
            : summaryFields(data, 'Summary', showReportId)),
    ]);
};
const internationalPitcherDetailFields = (data, version, showReportId, showRestrictedOfp) => {
    const isFull = data.Type.Type === 26;
    const pitch = (present, future, control, comments) => (joinPresent([presentPair(present, future), isPresent(control) ? `Ctrl ${display(control)}` : null, comments], ' | '));
    return visibleDetails([
        { label: 'Fastball Velocity (H/L/A)', value: data.Ffb ? velocityRange(data, 'fb') : null },
        { label: 'Curveball Velocity (H/L/A)', value: data.Fcb ? velocityRange(data, 'cb') : null },
        { label: 'Slider Velocity (H/L/A)', value: data.Fsl ? velocityRange(data, 'sl') : null },
        { label: 'Changeup Velocity (H/L/A)', value: data.Fch ? velocityRange(data, 'ch') : null },
        { label: 'Cutter Velocity (H/L/A)', value: data.Fct ? velocityRange(data, 'ct') : null },
        { label: 'Other Velocity (H/L/A)', value: data.Fother ? velocityRange(data, 'other') : null },
        ...(version >= 4 && showRestrictedOfp && data.OFPPercent ? [{ label: 'OFP Percentage', value: `${data.OFPPercent}%` }] : []),
        { label: 'Curveball Command', value: data.Fcb ? data.Cbcmd : null },
        { label: 'Slider Command', value: data.Fsl ? data.Slcmd : null },
        { label: 'Changeup Command', value: data.Fch ? data.Chcmd : null },
        { label: 'Cutter Command', value: data.Fct ? data.Ctcmd : null },
        { label: 'Other Command', value: data.Fother ? data.Othercmd : null },
        ...internationalGeneralFields(data, 'international-pitcher'),
        ...(isFull ? internationalFullReportFields(data, data.PhysicalDescriptionCmts) : []),
        { label: 'Education Status', value: data.EducationStatusCmts },
        ...(isFull
            ? [
                ...internationalVisitFields(data),
                { label: 'Fastball', value: pitch(data.Pfb, data.Ffb, data.Fbcmd, data.FbvCmts) },
                { label: 'FB Movement', value: joinPresent([presentPair(data.Pfbmov, data.Ffbmov), pickListText(data, 18), data.FbmovCmts], ' | ') },
                { label: 'FB Projectable', value: gradedComment(booleanDisplay(data.Projectable), data.ProjectableCmts) },
                { label: 'Curveball', value: pitch(data.Pcb, data.Fcb, data.Cbcmd, data.CbCmts) },
                { label: 'Slider', value: pitch(data.Psl, data.Fsl, data.Slcmd, data.SlCmts) },
                { label: 'Change', value: pitch(data.Pch, data.Fch, data.Chcmd, data.ChCmts) },
                { label: 'Cutter', value: pitch(data.Pct, data.Fct, data.Ctcmd, data.CtCmts) },
                { label: 'Other', value: pitch(data.Pother, data.Fother, data.Othercmd, data.OtherCmts) },
                { label: 'Control', value: gradedComment(presentPair(data.Pcontrol, data.Fcontrol), data.ControlCmts) },
                { label: 'Arm Action', value: data.ArmActionCmts },
                { label: 'Arm Speed', value: mappedDisplay(data.ArmSpeed) },
                { label: 'Arm Angle', value: joinPresent([pickListText(data, 20), data.ArmAngleCmts], ' | ') },
                { label: 'Delivery', value: data.DeliveryCmts },
                ...internationalMakeupFields(data, version),
                ...internationalFinalFields(data, version >= 3, showReportId),
            ]
            : [
                { label: 'Arm Angle', value: joinPresent([pickListText(data, 20), data.ArmAngleCmts], ' | ') },
                ...internationalSignabilityFields(data, false),
                ...summaryFields(data, 'Summary', showReportId),
            ]),
    ]);
};
const renderedDetailFields = (report, showReportId, showRestrictedOfp) => {
    if (report.kind === 'pro-position')
        return proPositionDetailFields(report.data, report.version, showReportId);
    if (report.kind === 'pro-pitcher')
        return proPitcherDetailFields(report.data, report.version, showReportId);
    if (report.kind === 'limited-position')
        return limitedPositionDetailFields(report.data, report.version, showReportId);
    if (report.kind === 'limited-pitcher')
        return limitedPitcherDetailFields(report.data, report.version, showReportId);
    if (report.kind === 'player-development-position')
        return playerDevelopmentDetailFields(report.data, 'position', report.version);
    if (report.kind === 'player-development-pitcher')
        return playerDevelopmentDetailFields(report.data, 'pitcher', report.version);
    if (report.kind === 'spring-training-position' || report.kind === 'spring-training-pitcher')
        return springTrainingDetailFields(report.data, showReportId);
    if (report.kind === 'amateur-position')
        return amateurPositionDetailFields(report.data, report.version, showReportId);
    if (report.kind === 'amateur-pitcher')
        return amateurPitcherDetailFields(report.data, report.version, showReportId);
    if (report.kind === 'international-amateur-position') {
        return internationalPositionDetailFields(report.data, report.version, showReportId, showRestrictedOfp);
    }
    return internationalPitcherDetailFields(report.data, report.version, showReportId, showRestrictedOfp);
};

const ReportTable = styled(StyledTable$1) `
    min-width: ${({ $isProPosition }) => ($isProPosition ? '100%' : 'max-content')};
    text-align: center;
    width: 100%;

    && > thead > tr > th, && > tbody > tr > td {
        white-space: nowrap;
    }

    && td.text-cell, && > tbody > tr.report-details > td, && > tbody > tr.report-detail-row > td {
        text-align: left;
        white-space: normal;
    }

    .report-toggle-cell {
        align-items: center;
        display: inline-flex;
        gap: 2px;
    }

    .report-details > td {
        background: white;
        font-size: 0.82rem;
        padding: 0;
    }
`;
// width 0 keeps the colspan detail from stretching the grade columns.
const DetailFit = styled.div `
    min-width: 100%;
    overflow-wrap: anywhere;
    width: 0;
`;
const DetailTable = styled.table `
    background: #dddddd;
    border: 1px solid ${theme.border.bombay};
    border-collapse: collapse;
    margin: 0;
    width: 100%;

    > tbody > tr > th, > tbody > tr > td {
        border: 1px solid ${theme.border.bombay};
        padding: 4px;
        text-align: left;
        vertical-align: top;
    }

    > tbody > tr > th {
        background: #dddddd;
        font-weight: bold;
        width: 20%;
        white-space: normal;
    }

    > tbody > tr > td {
        background: ${theme.background.white};
        white-space: normal;
    }
`;
const Review = styled.div `
    border-top: 1px solid ${theme.border.alto};
    margin-top: 1rem;
    padding-top: 1rem;

    h5 {
        color: ${theme.fontColors.darkBlue};
        font-size: 0.95rem;
    }
`;
const UnsupportedReport = styled.div `
    background: ${theme.background.concrete};
    border: 1px solid ${theme.border.alto};
    color: ${theme.fontColors.doveGray};
    padding: 1rem;
`;
const detailValue = (field) => {
    if (field.html && typeof field.value === 'string') {
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: field.value } });
    }
    if (React.isValidElement(field.value))
        return field.value;
    if (field.value == null
        || typeof field.value === 'string'
        || typeof field.value === 'number'
        || typeof field.value === 'boolean') {
        return display(field.value);
    }
    return field.value;
};
const ReportDetails = ({ report, showReportId, showRestrictedOfp }) => {
    var _a;
    const fields = renderedDetailFields(report, showReportId, showRestrictedOfp);
    const reviews = report.kind === 'player-development-position' || report.kind === 'player-development-pitcher'
        ? (_a = report.data.reviews) !== null && _a !== void 0 ? _a : []
        : [];
    return (React.createElement("div", null,
        fields.length > 0 && (React.createElement(DetailTable, null,
            React.createElement("tbody", null, fields.map((field) => (React.createElement("tr", { key: field.label },
                React.createElement("th", { scope: "row" }, field.label),
                React.createElement("td", null, detailValue(field)))))))),
        reviews.map((review, index) => {
            var _a, _b, _c;
            const assessmentType = (_a = review.Assessment) === null || _a === void 0 ? void 0 : _a.AssessmentType;
            const createdUser = review.CreatedUser;
            return (React.createElement(Review, { key: String((_c = (_b = review.AssessmentID) !== null && _b !== void 0 ? _b : review.ReportReviewID) !== null && _c !== void 0 ? _c : index) },
                React.createElement("h5", null,
                    "Player Objectives ",
                    display(assessmentType === null || assessmentType === void 0 ? void 0 : assessmentType.Name),
                    " Review \u00B7 ",
                    display(createdUser === null || createdUser === void 0 ? void 0 : createdUser.FullName),
                    " \u00B7\u00A0",
                    date(review.LastUpdateDate)),
                React.createElement(DetailTable, null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "row" }, "Agreement with player plan"),
                            React.createElement("td", null,
                                display(review.AgreementScore),
                                " / 5")),
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "row" }, "Player commitment"),
                            React.createElement("td", null,
                                display(review.CommittedScore),
                                " / 5")),
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "row" }, "Progress toward objectives"),
                            React.createElement("td", null,
                                display(review.ProgressScore),
                                " / 5")),
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "row" }, "Progress comments"),
                            React.createElement("td", null, typeof review.ProgressCmt === 'string'
                                ? React.createElement("span", { dangerouslySetInnerHTML: { __html: review.ProgressCmt } })
                                : display(review.ProgressCmt))),
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "row" }, "Suggestions for next year"),
                            React.createElement("td", null, typeof review.Suggestions === 'string'
                                ? React.createElement("span", { dangerouslySetInnerHTML: { __html: review.Suggestions } })
                                : display(review.Suggestions))),
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "row" }, "Helpful personal keys"),
                            React.createElement("td", null, typeof review.PersonalKeys === 'string'
                                ? React.createElement("span", { dangerouslySetInnerHTML: { __html: review.PersonalKeys } })
                                : display(review.PersonalKeys)))))));
        })));
};
const ScoutingReportTable = ({ report, detailsReport, expanded, onExpandedChange, renderDetails, renderDetailRows, showReportId = false, showRestrictedOfp = false, highlightDrafts = true, className, }) => {
    var _a, _b;
    const [internalExpanded, setInternalExpanded] = useState(false);
    const isExpanded = expanded !== null && expanded !== void 0 ? expanded : internalExpanded;
    const reportData = normalizeScoutingReport(report);
    if (!reportData) {
        return React.createElement(UnsupportedReport, { className: className },
            "Unsupported scouting report type: ",
            display(reportType(report)));
    }
    const isStaffEval = reportData.kind === 'player-development-position' || reportData.kind === 'player-development-pitcher';
    const columns = renderedColumns(reportData, showRestrictedOfp);
    const status = (_a = reportData.data.Status) === null || _a === void 0 ? void 0 : _a.Status;
    const highlightsDraft = highlightDrafts && !isStaffEval && status != null && status !== 4;
    const handleExpandedChange = () => {
        const nextExpanded = !isExpanded;
        if (expanded == null)
            setInternalExpanded(nextExpanded);
        onExpandedChange === null || onExpandedChange === void 0 ? void 0 : onExpandedChange(nextExpanded);
    };
    const detailsData = detailsReport ? (_b = normalizeScoutingReport(detailsReport)) !== null && _b !== void 0 ? _b : reportData : reportData;
    const defaultDetails = (React.createElement(ReportDetails, { report: detailsData, showReportId: showReportId, showRestrictedOfp: showRestrictedOfp }));
    const renderedDetails = renderDetails ? renderDetails(defaultDetails) : defaultDetails;
    return (React.createElement(ReportTable, { "$isProPosition": reportData.kind === 'pro-position', className: className, responsive: true, striped: true },
        React.createElement("thead", null,
            React.createElement("tr", null, columns.map((column) => React.createElement("th", { key: column.id }, column.heading)))),
        React.createElement("tbody", null,
            React.createElement("tr", { className: highlightsDraft ? 'table-danger' : undefined }, columns.map((column, index) => (React.createElement("td", { key: column.id }, index === 0 ? (React.createElement("span", { className: "report-toggle-cell" },
                React.createElement("span", { className: "d-print-none" },
                    React.createElement(DrilldownToggle, { isOpen: isExpanded, onClick: handleExpandedChange, ariaLabel: `${isExpanded ? 'Hide' : 'Show'} scouting report details` })),
                column.value)) : column.value)))),
            isExpanded && (renderDetailRows === null || renderDetailRows === void 0 ? void 0 : renderDetailRows(columns.length).map(({ key, cells }) => (React.createElement("tr", { key: key, className: "report-detail-row" }, cells)))),
            isExpanded && renderedDetails != null && (React.createElement("tr", { className: "report-details" },
                React.createElement("td", { colSpan: columns.length },
                    React.createElement(DetailFit, null, renderedDetails)))))));
};

const colors = {
    108: { red: '#BA0021', darkRed: '#862633', midnightNavy: '#003263', silver: '#C4CED4' },
    109: { red: '#A71930', sonoranSand: '#E3D4AD', black: '#000000', turquoise: '#3EC1CC' },
    110: { orange: '#DF4601', black: '#000000', gray: '#A2AAAD', marylandPatchYellow: '#EAAA00', marylandPatchRed: '#9D2235' },
    111: { red: '#BD3039', blue: '#0D2B56' },
    112: { blue: '#0E3386', red: '#CC3433' },
    113: { red: '#C6011F', blue: '#041E42', black: '#000000', digitalCamouflageDesertSand: '#473729' },
    114: { red: '#E31937', navy: '#002B5C' },
    115: { purple: '#33006F', silver: '#C4CED4', black: '#000000' },
    116: { midnightNavy: '#182D55', orange: '#F26722' },
    117: { navy: '#002D62', orange: '#EB6E1F', lightOrange: '#F4911E', blue: '#003087', gray: '#C4CED4' },
    118: { blue: '#004687', gold: '#C09A5B', lightBlue: '#7AB2DD', brown: '#966037' },
    119: { blue: '#005A9C', red: '#EF3E42' },
    120: { red: '#AB0003', blue: '#11225B' },
    121: { blue: '#002D72', orange: '#FF5910', gray: '#888B8D' },
    133: { green: '#003831', gold: '#EFB21E' },
    134: { gold: '#FDB827', red: '#EE3A42', black: '#000000' },
    135: { brown: '#2F241D', gold: '#FFC425', sand: '#B7A99A' },
    136: { navy: '#0C2C56', green: '#005C5C', silver: '#C4CED4', red: '#D50032', blue: '#004B8D', yellow: '#FFC425', cream: '#FFF6DC' },
    137: { orange: '#FD5A1E', black: '#000000', gold: '#8B6F4E', beige: '#EE6D8AF' },
    138: { red: '#C41E3A', midnightNavy: '#000066', yellow: 'FEDB00' },
    139: { blue: '#092C5C', lightBlue: '#8FBCE6', gold: '#F5D130' },
    140: { blue: '#003278', red: '#C0111F', darkGray: '#99897C', lightGray: '#C7C2BA', lightBlue: '#6CACEE4' },
    141: { blue: '#002B5C', navy: '#1D2D5C', red: '#D50032', powderBlue: '#6CACE4' },
    142: { navy: '#002B5C', red: '#D31145', gold: '#CFAB7A', gray: '#A2AAAD' },
    143: { red: '#E81828', blue: '#003278', maroon: '#860038' },
    144: { navy: '#0C2340', scarlet: '#BA0C2F', gold: '#D29F13' },
    145: { black: '#000000', silver: '#C4CED4', blue: '#0C2340', red: '#C8102E' },
    146: { black: '#000000', blue: '#00A3E0', red: '#EF3340', slateGray: '#41748D' },
    147: { midnightNavy: '#132448', blue: '#003087', red: '#E4002B', gray: '#C4CED4' },
    158: { navy: '#13294B', gold: '#FFC72C', blue: '#003DA5' },
};
const backgrounds = {
    108: colors[108].red,
    109: colors[109].black,
    110: colors[110].black,
    111: colors[111].blue,
    112: colors[112].blue,
    113: colors[113].red,
    114: colors[114].navy,
    115: colors[115].black,
    116: colors[116].midnightNavy,
    117: colors[117].navy,
    118: colors[118].blue,
    119: colors[119].blue,
    120: colors[120].red,
    121: colors[121].blue,
    133: colors[133].green,
    134: colors[134].black,
    135: colors[135].brown,
    136: colors[136].navy,
    137: colors[137].black,
    138: colors[138].midnightNavy,
    139: colors[139].blue,
    140: colors[140].blue,
    141: colors[141].navy,
    142: colors[142].navy,
    143: colors[143].red,
    144: colors[144].navy,
    145: colors[145].black,
    146: colors[146].blue,
    147: colors[147].midnightNavy,
    158: colors[158].navy,
};
var mlb = {
    colors,
    backgrounds,
};

const HighchartContainer$1 = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const TableCell$1 = styled.td `
  border: 1px solid #000 !important;
  padding: 20px;
  text-align: left;
  width: 75px;
  text-align: center;
  vertical-align: middle;
`;
const OverlayTable$1 = styled.table `
  border: 1px solid #000 !important;
  height: 20%;
  margin-top: auto;
  z-index: 1000;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.8); 
`;
const TableRow$1 = styled.tr `
  border: 1px solid #000;
`;
const buildResultSeries$3 = (series, infAccChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.gameid}_${d.pitchseq}_${d.eventseq}`, events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = infAccChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = infAccChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
        } }))) })));
const InfielderSprayChart = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, infAccChartRef, enableLegend, enableZoom, isGrayScale, sizeMultiplier, }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries$3(resultSeries, infAccChartRef), [resultSeries, infAccChartRef]);
    return (React.createElement(HighchartContainer$1, { className: "d-flex justify-content-center" },
        React.createElement(SprayChart$3, { type: "infield", seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, enableLegend: enableLegend, enableZoom: enableZoom, isGrayScale: isGrayScale, sizeMultiplier: sizeMultiplier }),
        innerResultSeries && innerResultSeries.length > 0 && (React.createElement(OverlayTable$1, null,
            React.createElement("tbody", null,
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, null),
                    React.createElement(TableCell$1, null, "Out Prob %")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#35a84c' } }),
                    React.createElement(TableCell$1, null, "90-100%")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#34ff32' } }),
                    React.createElement(TableCell$1, null, "75-90%")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#FFA500' } }),
                    React.createElement(TableCell$1, null, "25-75%")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#FF0000' } }),
                    React.createElement(TableCell$1, null, "< 25%")))))));
});

const buildResultSeries$2 = (series, sprayChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.x, y: d.y, id: `inf_acc_${d.gameid}_${d.pitchseq}_${d.eventseq}`, visible: !!(d.ifthrowx && d.ifthrowz), events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
        } }))) })));
const InfielderAccuracy = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, sprayChartRef, position, showLegend, enableZoom, width }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries$2(resultSeries, sprayChartRef), [resultSeries, sprayChartRef]);
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(InfielderAccuracy$1, { seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, position: position, showLegend: showLegend, enableZoom: enableZoom, width: width })));
});

const CardBodyContainer = styled.div `
    justify-content: center;
    display: flex;
    padding: 10px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;
const InfieldPlayLogCharts = ({ sprayChartSeriesData, throwChartSeriesData, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, position, primarypos, title, isGrayScale, sprayChartSizeMultiplier, infielderWidth }) => {
    const [sprayChartData, setSprayChartData] = useState([]);
    const [throwChartData, setThrowChartData] = useState([]);
    const infAccChartRef = useRef(null);
    const sprayChartRef = useRef(null);
    useEffect(() => {
        setSprayChartData(sprayChartSeriesData);
        setThrowChartData(throwChartSeriesData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sprayChartSeriesData, throwChartSeriesData]);
    return (React.createElement("div", { className: "d-flex flex-wrap justify-content-around" },
        sprayChartSeriesData && (React.createElement("div", { className: "d-flex flex-column justify-content-between mb-2 mx-2" },
            React.createElement("h3", null,
                title,
                " Fielding"),
            React.createElement(CardBodyContainer, null,
                React.createElement(InfielderSprayChart, { type: "infield", enableLegend: true, resultSeries: sprayChartData, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, infAccChartRef: infAccChartRef, ref: sprayChartRef, isGrayScale: isGrayScale, sizeMultiplier: sprayChartSizeMultiplier })))),
        React.createElement("div", { className: "mb-2" },
            React.createElement("h3", null,
                title,
                " Throwing"),
            React.createElement(CardBodyContainer, null,
                (position === 6 || (primarypos === 6 && position === -1)) && (React.createElement(InfielderAccuracy, { position: 6, showLegend: false, resultSeries: throwChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, videoPlayerModal: videoPlayerModal, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: infAccChartRef, width: infielderWidth })),
                (position === 4 || (primarypos === 4 && position === -1)) && (React.createElement(InfielderAccuracy, { position: 4, showLegend: false, resultSeries: throwChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, videoPlayerModal: videoPlayerModal, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: infAccChartRef, width: infielderWidth })),
                (position === 5 || (primarypos === 5 && position === -1)) && (React.createElement(InfielderAccuracy, { position: 5, showLegend: false, resultSeries: throwChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, ref: infAccChartRef, width: infielderWidth }))))));
};

const HighchartContainer = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const TableCell = styled.td `
  border: 1px solid #000 !important;
  padding: 20px;
  text-align: left;
  width: 75px;
  text-align: center;
  vertical-align: middle;
`;
const OverlayTable = styled.table `
  border: 1px solid #000 !important;
  z-index: 1000;
  height: 20%;
  margin-top: auto;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.8); 
`;
const TableRow = styled.tr `
  border: 1px solid #000;
`;
const buildResultSeries$1 = (series, hangtimeChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.gameid}_${d.pitchseq}_${d.eventseq}`, events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = hangtimeChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = hangtimeChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
        } }))) })));
const OutfielderSprayChart = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, hangtimeChartRef, enableLegend, enableZoom, isGrayScale, sizeMultiplier, }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries$1(resultSeries, hangtimeChartRef), [resultSeries, hangtimeChartRef]);
    return (React.createElement(HighchartContainer, { className: "d-flex justify-content-center" },
        React.createElement(SprayChart$3, { type: "outfield", seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, enableLegend: enableLegend, enableZoom: enableZoom, isGrayScale: isGrayScale, sizeMultiplier: sizeMultiplier }),
        innerResultSeries && innerResultSeries.length > 0 && (React.createElement(OverlayTable, null,
            React.createElement("tbody", null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null),
                    React.createElement(TableCell, null, "Out Prob %")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#35a84c' } }),
                    React.createElement(TableCell, null, "97-100%")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#34ff32' } }),
                    React.createElement(TableCell, null, "75-97%")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#FFA500' } }),
                    React.createElement(TableCell, null, "25-75%")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#FF0000' } }),
                    React.createElement(TableCell, null, "< 25%")))))));
});

const buildResultSeries = (series, sprayChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.x, y: d.y, id: `of_hangtime_${d.gameid}_${d.pitchseq}_${d.eventseq}`, events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
        } }))) })));
const OutfielderHangtimeChart = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, sprayChartRef, position, showLegend, enableZoom, width }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries(resultSeries, sprayChartRef), [resultSeries, sprayChartRef]);
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(HangtimeChart, { seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, position: position, showLegend: showLegend, enableZoom: enableZoom, width: width })));
});

const OutfieldPlayLogCharts = ({ sprayChartSeriesData, hangtimeChartSeriesData, firstStepAverages, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, title, isGrayScale, sprayChartSizeMultiplier, hangtimeChartWidth, firstStepChartWidth, }) => {
    const [sprayChartData, setSprayChartData] = useState([]);
    const [hangtimeChartData, setHangtimeChartData] = useState([]);
    const [firstStepData, setFirstStepData] = useState({
        left: {},
        forward: {},
        right: {},
        back: {},
    });
    const hangtimeChartRef = useRef(null);
    const sprayChartRef = useRef(null);
    useEffect(() => {
        setSprayChartData(sprayChartSeriesData);
        setHangtimeChartData(hangtimeChartSeriesData);
        setFirstStepData(firstStepAverages);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sprayChartSeriesData, hangtimeChartSeriesData]);
    return (React.createElement("div", { className: "d-flex flex-wrap justify-content-around" },
        sprayChartSeriesData && (React.createElement("div", { className: "d-flex flex-column justify-content-start mb-3 mx-2" },
            React.createElement("h3", null,
                title,
                " Fielding"),
            React.createElement("div", null,
                React.createElement(OutfielderSprayChart, { type: "outfield", sizeMultiplier: sprayChartSizeMultiplier, enableLegend: true, resultSeries: sprayChartData, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, hangtimeChartRef: hangtimeChartRef, ref: sprayChartRef, isGrayScale: isGrayScale })))),
        sprayChartSeriesData && hangtimeChartData && (React.createElement("div", { className: "d-flex flex-column justify-content-start " },
            React.createElement("h3", null, "Catch Difficulty"),
            React.createElement("div", null,
                React.createElement(OutfielderHangtimeChart, { showLegend: false, resultSeries: hangtimeChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, videoPlayerModal: videoPlayerModal, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: hangtimeChartRef, width: hangtimeChartWidth })))),
        firstStepData && (React.createElement("div", { className: "d-flex flex-column justify-content-start mb-3 mx-2" },
            React.createElement("h3", null, "First Step Chart"),
            React.createElement("div", null,
                React.createElement(FirstStepChart, { width: firstStepChartWidth, forward: firstStepData.forward, left: firstStepData.left, right: firstStepData.right, back: firstStepData.back }))))));
};

const CAMERA_VIEWS = [
    { id: 1, name: 'Broadcast', abbr: 'TV' },
    { id: 2, name: 'Center Field', abbr: 'CF' },
    { id: 3, name: 'Pitcher Open', abbr: 'PitcherSide' },
    { id: 4, name: 'Pitcher Closed', abbr: 'PitcherSide' },
    { id: 5, name: 'Pitcher Front', abbr: 'PitcherFront' },
    { id: 6, name: 'Hitter Open', abbr: 'HitterOpenSide' },
    { id: 7, name: 'Hitter Closed', abbr: 'HitterClosedSide' },
    { id: 8, name: 'Field High', abbr: 'FieldViewHigh' },
    { id: 9, name: 'Field Low', abbr: 'FieldViewLow' },
    { id: 10, name: 'Low Pitcher 1B', abbr: 'LowPitcher1B' },
    { id: 11, name: 'LH Batters View', abbr: 'BattersViewLH' },
    { id: 12, name: 'RH Batters View', abbr: 'BattersViewRH' },
    { id: 13, name: 'Tight Home', abbr: 'TightHomePlate' },
    { id: 14, name: 'Infield Side', abbr: 'InfieldSide' },
    { id: 15, name: 'Catcher Side', abbr: 'CatcherSide' },
    { id: 16, name: 'Extended Pitcher Front', abbr: 'PitcherExtendedFront' },
    { id: 17, name: 'Tight Pitcher Front', abbr: 'TightPitcherFront' },
    { id: 18, name: 'Tight Overhead Pitcher', abbr: 'TightOverheadPitcher' },
    { id: 21, name: 'Pickoff', abbr: 'Pickoff' },
    { id: 22, name: 'Tight CF', abbr: 'TightCF' },
    { id: 23, name: 'Broadcast Side', abbr: 'BroadcastSide' },
    { id: 24, name: 'Yankee Open', abbr: 'YankeeOpenSide' },
    { id: 20, name: 'Other', abbr: 'Other' },
    { id: 25, name: 'Pitcher Backside', abbr: 'PitcherBackside' },
    { id: 26, name: 'Side', abbr: 'Side' },
    { id: 27, name: 'Front', abbr: 'Front' },
    { id: 28, name: 'Back', abbr: 'Back' },
    { id: 29, name: 'Top', abbr: 'Top' },
    { id: 30, name: 'R1 Perspective', abbr: 'PerspectiveR1' },
    { id: 31, name: 'R2 Perspective', abbr: 'PerspectiveR2' },
    { id: 32, name: 'R3 Perspective', abbr: 'PerspectiveR3' },
    { id: 33, name: '1B Perspective', abbr: 'Perspective1B' },
    { id: 34, name: '2B Perspective', abbr: 'Perspective2B' },
    { id: 35, name: '3B Perspective', abbr: 'Perspective3B' },
    { id: 36, name: 'SS Perspective', abbr: 'PerspectiveSS' },
    { id: 37, name: 'LF Perspective', abbr: 'PerspectiveLF' },
    { id: 38, name: 'CF Perspective', abbr: 'PerspectiveCF' },
    { id: 39, name: 'RF Perspective', abbr: 'PerspectiveRF' },
    { id: 40, name: 'Tight Tight CF', abbr: 'TightTightCF' },
    { id: 41, name: 'Hitter Timing', abbr: 'HitterTiming' },
    { id: 42, name: 'Dead Center', abbr: 'DeadCenter' },
    { id: 43, name: 'Left Field', abbr: 'LF' },
    { id: 44, name: 'Quad 1', abbr: 'Quad1' },
    { id: 45, name: 'Quad 2', abbr: 'Quad2' },
    // BallCap High Speed
    { id: 50, name: 'High-Speed Pitcher CF Release', abbr: 'HSPitcherCFRelease', isPitcher: true },
    { id: 51, name: 'High-Speed Pitcher Front Release', abbr: 'HSPitcherFrontRelease', isPitcher: true },
    { id: 52, name: 'High-Speed Pitcher Front', abbr: 'HSPitcherFront', isPitcher: true },
    { id: 53, name: 'High-Speed Pitcher Open', abbr: 'HSPitcherOpen', isPitcher: true },
    { id: 60, name: 'High-Speed Pitcher Closed', abbr: 'HSPitcherClosed', isPitcher: true },
    { id: 54, name: 'High-Speed Hitter Open', abbr: 'HSHitterSide', isBatter: true },
    { id: 55, name: 'High-Speed Hitter Timing', abbr: 'HSHitterTiming', isBatter: true },
    { id: 56, name: 'High-Speed Catcher Side', abbr: 'HSCatcherSide', isBatter: true },
    { id: 57, name: 'High-Speed Defense', abbr: 'HSDefense' },
    { id: 58, name: 'High-Speed Baserunning', abbr: 'HSBaserunning' },
    { id: 59, name: 'High-Speed Hitter Closed', abbr: 'HSHitterClosed', isBatter: true },
    { id: 61, name: 'High-Speed Tight Home', abbr: 'HSTightHome', isBatter: true },
    { id: 62, name: 'High-Speed Pitcher Open Release', abbr: 'HSPitcherOpenSideRelease', isPitcher: true },
    { id: 63, name: 'High-Speed Pitcher Closed Release', abbr: 'HSPitcherClosedSideRelease', isPitcher: true },
    { id: 64, name: 'High-Speed Hitter Behind', abbr: 'HSHitterBehind', isBatter: true },
    { id: 65, name: 'High-Speed Hitter Overhead', abbr: 'HSHitterOverhead', isBatter: true },
    { id: 66, name: 'High-Speed Pitcher Overhead', abbr: 'HSPitcherOverhead', isPitcher: true },
    { id: 67, name: 'High-Speed Pitcher Release', abbr: 'HSPitcherRelease', isPitcher: true },
    { id: 68, name: 'High-Speed Pitcher Behind', abbr: 'HSPitcherBehind', isPitcher: true },
    { id: 69, name: 'High-Speed Extended Pitcher Front', abbr: 'HSExtPitcherFront', isPitcher: true },
    // BallCap Full Speed / IP
    { id: 70, name: 'Baserunning 1B', abbr: 'Baserunning1B' },
    { id: 71, name: 'Baserunning 2B', abbr: 'Baserunning2B' },
    { id: 72, name: 'Baserunning 3B', abbr: 'Baserunning3B' },
    { id: 73, name: '1B Infield Side', abbr: 'InfieldSide1B' },
    { id: 74, name: '3B Infield Side', abbr: 'InfieldSide3B' },
    // Unlrelated to BallCap but got in the BC range
    { id: 75, name: 'Fly Cam', abbr: 'FlyCam' },
    // Continued BallCap IP/Full Speeds
    { id: 76, name: 'Pitcher Front Release', abbr: 'IPPitcherFrontRelease' },
    { id: 77, name: 'Pitcher Front', abbr: 'IPPitcherFront' },
    { id: 78, name: 'Pitcher Open', abbr: 'IPPitcherOpen' },
    { id: 79, name: 'Pitcher Closed', abbr: 'IPPitcherClosed' },
    { id: 80, name: 'Pitcher Open Release', abbr: 'IPPitcherOpenSideRelease' },
    { id: 81, name: 'Pitcher Closed Release', abbr: 'IPPitcherClosedSideRelease' },
    { id: 82, name: 'Pitcher Overhead', abbr: 'IPPitcherOverhead' },
    { id: 83, name: 'Pitcher Release', abbr: 'IPPitcherRelease' },
    { id: 84, name: 'Pitcher Behind', abbr: 'IPPitcherBehind' },
    { id: 85, name: 'Extended Pitcher Front', abbr: 'IPExtPitcherFront' },
    { id: 86, name: 'Hitter Open', abbr: 'IPHitterSide' },
    { id: 87, name: 'Hitter Closed', abbr: 'IPHitterClosed' },
    { id: 88, name: 'Hitter Behind', abbr: 'IPHitterBehind' },
    { id: 89, name: 'Hitter Overhead', abbr: 'IPHitterOverhead' },
    { id: 90, name: 'Hitter Timing', abbr: 'IPHitterTiming' },
    // 91-100 saved for future ballcap angles
    // BallCap Vendor Videos
    { id: 101, name: 'Trajekt Annotated', abbr: 'TjAnnotated' },
    { id: 102, name: 'Trajekt Raw Stereo', abbr: 'TjStereo' },
    { id: 103, name: 'Trajekt Replay', abbr: 'TjReplay' },
    // 104-110 Reserved for BC
];
const PLAYER_VIDEO_TYPES = [
    { id: 0, name: 'Generic' },
    { id: 1, name: 'Injury' },
    { id: 2, name: 'Advance Scouting' },
    { id: 3, name: 'Ejections' },
    { id: 4, name: 'Game' },
    { id: 5, name: 'Bullpen' },
    { id: 6, name: 'BP' },
    { id: 7, name: 'Defense' },
    { id: 8, name: 'Workout / Misc' },
    // Strength Test Video Types
    { id: 20, name: 'Strength Test - Sprint 10 Yards' },
    { id: 21, name: 'Strength Test - Sprint 20 Yards' },
    { id: 22, name: 'Strength Test - Pro Agil React Glove Side' },
    { id: 23, name: 'Strength Test - Pro Agil React Arm Side' },
    // Pitcher Video Types
    { id: 101, name: 'Pitcher Grip' },
    { id: 102, name: 'Pitch Tipping' },
    { id: 103, name: 'Pitcher Release' },
    { id: 104, name: 'Slow Motion' },
    { id: 201, name: 'Physical Assessment' },
    { id: 202, name: 'General Movement Screen' },
    { id: 203, name: 'Amateur Movement Screen' },
];
const MLBAM_ANGLES = [
    { id: 'cf', name: 'MLBAM CF' },
    { id: 'hside', name: 'MLBAM High Side' },
    { id: 'hh', name: 'MLBAM High Home' },
    { id: '1bside', name: 'MLBAM 1B Hitter' },
    { id: '3bside', name: 'MLBAM 3B Hitter' },
    { id: '1bside_pit', name: 'MLBAM 1B Pitcher' },
    { id: '3bside_pit', name: 'MLBAM 3B Pitcher' },
    { id: 'pitchcast', name: 'MLBAM PitchCast' },
    { id: 'alt', name: 'MLBAM Alt Broadcast' },
    { id: 'midhome', name: 'MLBAM Mid Home' },
];
const DIAMOND_ANGLES = [
    { id: 'hd', name: 'DIAMOND Broadcast' },
    { id: 'hh', name: 'DIAMOND High Home' },
    { id: 'cf', name: 'DIAMOND Centerfield' },
    { id: 'mv', name: 'DIAMOND MultiView' },
    { id: '1bp', name: 'DIAMOND 1B Pitcher' },
    { id: '3bp', name: 'DIAMOND 3B Pitcher' },
    { id: '1bh', name: 'DIAMOND 1B Hitter' },
    { id: '3bh', name: 'DIAMOND 3B Hitter' },
    { id: 'pc', name: 'DIAMOND PitchCast' },
    { id: 'mh', name: 'DIAMOND Mid-Home' },
];
const TRACKMAN_ANGLES = [
    { id: 'main', name: 'Trackman Broadcast' },
    { id: 'cf', name: 'Trackman CF' },
    { id: 'hh', name: 'Trackman High Home' },
    { id: '1b_hit', name: 'Trackman 1B Hitter' },
    { id: '3b_hit', name: 'Trackman 3B Hitter' },
    { id: '1b_pit', name: 'Trackman 1B Pitcher' },
    { id: '3b_pit', name: 'Trackman 3B Pitcher' },
];
const AUTO_PLAYLIST_TYPE = [
    { id: 0, name: 'Unknown' },
    { id: 1, name: 'Gameplan Videos' },
    { id: 2, name: 'Pitch Recognition' },
    { id: 3, name: 'Damage' },
    { id: 4, name: 'Recent Matchups' },
    { id: 5, name: 'Recent vs NY LHH' },
    { id: 6, name: 'Recent vs NY RHH' },
    { id: 7, name: 'Pitcher Pickoffs' },
    { id: 8, name: 'Pitcher Pickoff 1B' },
    { id: 9, name: 'Pitcher Pickoff 2B' },
];
const getVideoSources = (mainhd, viewNames, pitchVideoResp, userRoles, priorityAngles, isHighSpeed, isBatter = true, isPitcher = true) => {
    const batterHighSpeedAngles = CAMERA_VIEWS.filter((v) => v.id >= 50 && v.isBatter).map(({ id }) => id);
    const pitcherHighSpeedAngles = CAMERA_VIEWS.filter((v) => v.id >= 50 && v.isPitcher).map(({ id }) => id);
    const mlbamAngleNames = MLBAM_ANGLES.reduce((acc, pvt) => (Object.assign(Object.assign({}, acc), { [pvt.id]: pvt.name })), {});
    const diamondAngleNames = DIAMOND_ANGLES.reduce((acc, pvt) => (Object.assign(Object.assign({}, acc), { [pvt.id]: pvt.name })), {});
    const trackmanAngleNames = TRACKMAN_ANGLES.reduce((acc, pvt) => (Object.assign(Object.assign({}, acc), { [pvt.id]: pvt.name })), {});
    const validAngles = isHighSpeed ? [...(isPitcher ? pitcherHighSpeedAngles : []), ...(isBatter ? batterHighSpeedAngles : [])] : null;
    let sourceLabelArrays = Object.keys(pitchVideoResp)
        .map((urlKey) => {
        const labels = [];
        if (urlKey === 'url') {
            labels.push('Main');
        }
        else if (urlKey === 'url_hd') {
            labels.push(mainhd);
            if (pitchVideoResp.view_anglea) {
                // eslint-disable-next-line eqeqeq
                if (pitchVideoResp.view_anglea == 1)
                    labels.push('CF-HD Broadcast');
                else
                    labels.push('CF-HD');
            }
        }
        else if (urlKey === 'url_sd') {
            // eslint-disable-next-line eqeqeq
            if (pitchVideoResp.view_anglea == 1)
                labels.push('CF-SD Broadcast');
            else
                labels.push('CF-SD');
        }
        else if (urlKey.startsWith('url_angle')) {
            const viewAngleId = pitchVideoResp[urlKey.replace('url_', 'view_')];
            if (viewAngleId && viewNames[viewAngleId])
                labels.push(viewNames[viewAngleId]);
            else
                labels.push(`Angle ${urlKey.replace('url_angle', '').toUpperCase()}`);
        }
        else if (urlKey.startsWith('mlbamurl')) {
            const mlbamAngleId = urlKey.replace('mlbamurl_', '');
            if (mlbamAngleId && mlbamAngleNames[mlbamAngleId])
                labels.push(mlbamAngleNames[mlbamAngleId]);
        }
        else if (urlKey.startsWith('diamondurl') && (userRoles === null || userRoles === void 0 ? void 0 : userRoles.length) && checkRoles(userRoles, 'diamondviewers')) {
            const diamondAngleId = urlKey.replace('diamondurl_', '');
            if (diamondAngleId && diamondAngleNames[diamondAngleId])
                labels.push(diamondAngleNames[diamondAngleId]);
        }
        else if (urlKey.startsWith('trackmanurl')) {
            const trackmanAngleId = urlKey === 'trackmanurl' ? 'main' : urlKey.replace('trackmanurl_', '');
            if (trackmanAngleNames[trackmanAngleId])
                labels.push(trackmanAngleNames[trackmanAngleId]);
        }
        return { labels, urlKey };
    })
        .filter((x) => {
        let includeVideoInPlaylist = !!x.labels.length && !!pitchVideoResp[x.urlKey];
        if (includeVideoInPlaylist && validAngles) {
            const viewAngleId = pitchVideoResp[x.urlKey.replace('url_', 'view_')];
            includeVideoInPlaylist = !!viewAngleId && validAngles.includes(viewAngleId);
        }
        return includeVideoInPlaylist;
    })
        .sort((a, b) => {
        let { urlKey: urlKeyA } = a;
        let { urlKey: urlKeyB } = b;
        const { labels: [labelA] } = a;
        const { labels: [labelB] } = b;
        // sort generic (a-s) angle names after defined angles (sd, hd, etc.)
        // sort (r-z) then mlbam then diamond angles at end of all other options (using label name)
        if (urlKeyA.startsWith('url_angle')) {
            if (urlKeyA.replace('url_angle', '') < 'r')
                urlKeyA = `1-${urlKeyA}`;
            else
                urlKeyA = `2-${labelA}`;
        }
        else if (urlKeyA.startsWith('mlbamurl'))
            urlKeyA = `3-${labelA}`;
        else if (urlKeyA.startsWith('diamondurl'))
            urlKeyA = `4-${labelA}`;
        else if (urlKeyA.startsWith('trackmanurl'))
            urlKeyA = `5-${labelA}`;
        else
            urlKeyA = `0-${urlKeyA}`;
        if (urlKeyB.startsWith('url_angle')) {
            if (urlKeyB.replace('url_angle', '') < 'r')
                urlKeyB = `1-${urlKeyB}`;
            else
                urlKeyB = `2-${labelB}`;
        }
        else if (urlKeyB.startsWith('mlbamurl'))
            urlKeyB = `3-${labelB}`;
        else if (urlKeyB.startsWith('diamondurl'))
            urlKeyB = `4-${labelB}`;
        else if (urlKeyB.startsWith('trackmanurl'))
            urlKeyB = `5-${labelB}`;
        else
            urlKeyB = `0-${urlKeyB}`;
        return urlKeyA.localeCompare(urlKeyB);
    })
        .map((x) => x.labels.map((l) => ({
        label: l,
        file: pitchVideoResp[x.urlKey],
    })))
        .flat();
    if (priorityAngles && priorityAngles.length) {
        sourceLabelArrays = sourceLabelArrays.sort((a, b) => {
            if (priorityAngles.indexOf(a.label) !== -1 && priorityAngles.indexOf(b.label) !== -1) {
                return priorityAngles.indexOf(a.label) - priorityAngles.indexOf(b.label);
            }
            if (priorityAngles.indexOf(a.label) !== -1) {
                return -1;
            }
            if (priorityAngles.indexOf(a.label) === -1 && priorityAngles.indexOf(b.label) === -1 && a.label === 'Main') {
                return -1;
            }
            return 1;
        });
    }
    return sourceLabelArrays.map((s, _idx, self) => {
        const duplicateLabelIdx = self.filter(({ label }) => label === s.label).indexOf(s);
        const label = s.label + (duplicateLabelIdx > 0 ? ` (${duplicateLabelIdx})` : '');
        return Object.assign(Object.assign({}, s), { label });
    });
};
const mapPlaylistFromVideoSearch = (searchResults, userRoles, priorityAngles, isHighSpeed = false, isBatter, isPitcher) => {
    const MAIN_HD = 'Main HD';
    const playerVideoTypeNames = PLAYER_VIDEO_TYPES.reduce((acc, pvt) => (Object.assign(Object.assign({}, acc), { [pvt.id]: pvt.name })), {});
    const viewNames = CAMERA_VIEWS.reduce((acc, v) => (Object.assign(Object.assign({}, acc), { [v.id]: v.name })), {});
    const playlist = searchResults === null || searchResults === void 0 ? void 0 : searchResults.videos.map((v, idx) => {
        var _a, _b, _c;
        const sources = getVideoSources(MAIN_HD, viewNames, v, userRoles, priorityAngles, isHighSpeed, isBatter, isPitcher);
        searchResults.playervideos
            .filter((playervideo) => playervideo.GameID === v.gameid && playervideo.EventSeq === v.eventseq && playervideo.PitchSeq === v.pitchseq)
            .forEach(({ VideoType, PlayerVideoID, Filename, Angle }) => {
            if (!isHighSpeed || VideoType === 104 || Angle >= 50) {
                sources.push({
                    isPlayerVideo: true,
                    type: 'video/mp4',
                    file: `https://base.yankees.com/bbops/api/playervideo/${PlayerVideoID}/stream/${Filename}`,
                    label: `${playerVideoTypeNames[VideoType]} ${viewNames[Angle]}`,
                });
            }
        });
        if (!sources.length)
            return null;
        const batter = (_a = v.batter) === null || _a === void 0 ? void 0 : _a.replace("'", '');
        const pitcher = (_b = v.pitcher) === null || _b === void 0 ? void 0 : _b.replace("'", '');
        const count = `${v.balls}-${v.strikes}`;
        const velocity = format(v.velocity, 1);
        const pr = typeof v.pitchresult === 'string' ? v.pitchresult : pitchResult(parseInt(v.pitchresult));
        const result = v.result != null ? v.result : pr;
        const hasMainHDAngle = sources.some(({ label }) => label === MAIN_HD);
        const pitchtype = getPitchTypeIdFromName(v.fxpitchtype) || getPitchTypeIdFromName(v.pitchtype);
        return {
            pitchId: (v.gameid && v.eventseq && v.pitchseq) ? `${v.gameid}.${v.eventseq}.${v.pitchseq}` : null,
            heatmapId: v.pitcherid && pitchtype ? `${v.pitcherid}.${pitchtype}.${v.batterid || v.islhb || 0}.${v.strikes === 2}.${v.yearid || 0}` : null,
            data: Object.assign(Object.assign({}, v), { type: pitchtype || undefined, rvactualNorm: rvERA(v.rvactual), rvpitchfxNorm: rvERA(v.rvpitchfx), rvbreakNorm: rvERA(v.rvbreak), rvstuffNorm: rvERA(v.rvstuff), rvlocNorm: rvERA(v.rvloc), rvexpNorm: rvERA(v.rvexp), contactResult: rvPerN(v.rvhitfxactualbip, v.biprvdenom, 100), contactQuality: rvPerN(v.rvhitfxpitbip, v.biprvdenom, 100), swinging: v.sw === 1 ? 'Yes' : 'No', swingingFirstPitch: v.sw === 1 && v.balls === 0 && v.strikes === 0 ? 'Yes' : 'No', swingingInZone: v.swinz === 1 ? 'Yes' : 'No', chase: v.ch === 1 ? 'Yes' : 'No', swingDecisionScoreShouldSwing: v.swds === v.swdssw ? v.swds : null, swingDecisionScoreShouldTake: v.swds === v.swdstk ? v.swds : null, miss: v.sw === 1 && v.cn === 0 ? 'Yes' : 'No', missInZone: v.sw === 1 && v.cn === 0 && v.inz === 1 ? 'Yes' : 'No', inZone: v.inz === 1 ? 'Yes' : 'No', strikeout: v.so === 1 ? 'Yes' : 'No', unintentionalWalk: v.ubb === 1 ? 'Yes' : 'No', runnersOn: v.bcbefore !== 0 ? 'Yes' : 'No', hasShift: v.isshift ? 'Yes' : 'No', outProbability: (_c = (v === null || v === void 0 ? void 0 : v.totalprob) * 100) !== null && _c !== void 0 ? _c : null, pitcherHand: v.islhp ? 1 : 0, batterHand: v.islhb ? 1 : 0, hasRunners: v.bcbefore ? 1 : 0, sourceLabels: sources.map(({ label }) => (label)) }),
            sources: sources.map(({ type, file, label }, i) => ({ type, file, label, default: (hasMainHDAngle ? label === MAIN_HD : i === 0) })),
            title: `${idx + 1}. ${batter} vs. ${pitcher} - ${date(v.gamedate)}`,
            description: (userRoles === null || userRoles === void 0 ? void 0 : userRoles.some((r) => ['developer', 'qadept'].includes(r)))
                // eslint-disable-next-line max-len
                ? `${v.istop ? 'Top' : 'Bot'} ${v.inning} | Out: ${v.outsbefore} | Cnt: ${count} ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype }) ? `| ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype })} ` : ''}${velocity ? ` (${velocity}) ` : ''}${v.pstrike ? `| P-Strike: ${(Number(v.pstrike) * 100).toFixed(1)}% ` : ''}| Result: ${result} | GameId: ${v.gameid}, PitchSeq: ${v.pitchseq}, EventSeq: ${v.eventseq}`
                // eslint-disable-next-line max-len
                : `${v.istop ? 'Top' : 'Bot'} ${v.inning} | Out: ${v.outsbefore} | Cnt: ${count} ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype }) ? `| ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype })} ` : ''}${velocity ? ` (${velocity}) ` : ''}${v.pstrike ? `| P-Strike: ${(Number(v.pstrike) * 100).toFixed(1)}% ` : ''}| Result: ${result}`,
            clip: sources.filter((s) => !s.isPlayerVideo).map((s) => ({
                Url: s.file,
                AngleLabel: s.label,
                GameDate: v.gamedate,
                GameID: v.gameid,
                EventSeq: v.eventseq,
                PitchSeq: v.pitchseq,
                Include: true,
                Data: JSON.stringify({
                    Batter: batter,
                    Pitcher: pitcher,
                    Inning: v.inning,
                    Outs: v.outsbefore,
                    Count: count,
                    Bats: v.islhb ? 'L' : 'R',
                    Throws: v.islhp ? 'L' : 'R',
                    Velocity: velocity || '-',
                    PitchType: v.pitchtype != null ? v.pitchtype : '-',
                    PitchSubType: v.fxsubtype,
                    Result: result,
                }),
            })),
        };
    });
    return playlist === null || playlist === void 0 ? void 0 : playlist.filter((v) => v);
};

const getPlateLoc = (pitch, ax0Adj, az0Adj, isExaggerated = false) => {
    // y = 1.4167 at the plate
    // use quadratic formula with known value of 1.4167 for y to determine the time,
    // then use that to provide the x, y and z of the point where it crosses the plate.
    // 0.5*y2*t^2 + y1*t + y0 = 1.4167
    // a = 0.5*y2, b = y1, c = y0 - 1.4167
    // t = (-b+-sqrt(b^2 - 4ac))/2a
    const a = pitch.ay0 / 2;
    const b = pitch.vy0;
    const c = pitch.y0 - 1.4167;
    const t1 = ((-1 * b) + Math.sqrt((Math.pow(b, 2)) - (4 * a * c))) / (2 * a);
    const t2 = ((-1 * b) - Math.sqrt((Math.pow(b, 2)) - (4 * a * c))) / (2 * a);
    const t = t1 && t2 > 0 ? (t1 > t2 ? t2 : t1) : (t1 > 0 ? t1 : t2); // eslint-disable-line no-nested-ternary
    const x = pitch.x0 + (t * pitch.vx0) + ((Math.pow(t, 2)) * 0.5 * pitch.ax0);
    const y = pitch.y0 + (t * pitch.vy0) + ((Math.pow(t, 2)) * 0.5 * pitch.ay0);
    const z = pitch.z0 + (t * pitch.vz0) + ((Math.pow(t, 2)) * 0.5 * pitch.az0);
    if (isExaggerated) {
        const vx0Adj = ((x * 1.5) - pitch.x0 - (0.5 * ax0Adj * (Math.pow(t, 2)))) / t;
        const vz0Adj = (2.5 + ((z - 2.5) * 1.5) - pitch.z0 - (0.5 * az0Adj * (Math.pow(t, 2)))) / t;
        const xAdj = pitch.x0 + (t * vx0Adj) + ((Math.pow(t, 2)) * 0.5 * ax0Adj);
        const zAdj = pitch.z0 + (t * vz0Adj) + ((Math.pow(t, 2)) * 0.5 * az0Adj);
        return {
            posx: xAdj, posy: y, posz: zAdj, origx: x, origz: z,
        };
    }
    return {
        posx: x, posy: y, posz: z, origx: x, origz: z,
    };
};
const mapPitchPaths = (pitchOrPitchArray, islhp, pitchType) => {
    const pitchpaths = new Array();
    const pitchpathsExaggerated = new Array();
    const pitches = Array.isArray(pitchOrPitchArray) ? pitchOrPitchArray : [pitchOrPitchArray];
    pitches.forEach((pit) => {
        if (!isNumber$2(pit.x0, pit.y0, pit.z0, pit.vx0, pit.vy0, pit.vz0, pit.ax0, pit.ay0, pit.az0))
            return;
        const p = pit;
        let pitchcolor = null;
        let opacity = 1;
        let transparent = true;
        if (!p.pitcherid || p.pitcherid <= 2) {
            pitchcolor = 0xcccccc;
            opacity = 0.5;
        }
        else {
            transparent = false;
            let percentage = 0;
            if (pitchType && p.init_speed && (pitchType.maxvelo - pitchType.minvelo) > 0) {
                percentage = Math.max(Math.min((1 + ((p.init_speed - pitchType.midvelo) / ((pitchType.maxvelo - pitchType.minvelo) / 2))) / 2, 1), 0);
            }
            if (percentage > 0.9) {
                pitchcolor = 0xff0000;
            }
            else if (percentage > 0.75) {
                pitchcolor = 0xff5400;
            }
            else if (percentage > 0.5) {
                pitchcolor = 0xff7700;
            }
            else if (percentage > 0.25) {
                pitchcolor = 0xffa200;
            }
            else if (percentage > 0.1) {
                pitchcolor = 0xffd100;
            }
            else {
                pitchcolor = 0xffff00;
            }
        }
        const adjx = islhp ? 11 : -11;
        const adjz = -25;
        const coeff = 3;
        const ax0Adj = adjx + (coeff * (p.ax0 - adjx));
        const az0Adj = adjz + (coeff * (p.az0 - adjz));
        const pitchPath = {
            pitchtype: p.pitchtype,
            pitcherid: p.pitcherid,
            linematerial: pitchcolor
                ? new THREE.LineBasicMaterial({ color: pitchcolor, opacity, transparent })
                : new THREE.LineBasicMaterial({ color: 0x000000, opacity, transparent: true }),
            meshmaterial: pitchcolor
                ? new THREE.MeshBasicMaterial({ color: pitchcolor, opacity, transparent })
                : new THREE.MeshBasicMaterial({ color: 0x000000, opacity, transparent: true }),
            meshphongmaterial: pitchcolor ? new THREE.MeshPhongMaterial({
                color: pitchcolor, specular: 0x222222, shininess: 0, opacity, transparent,
            }) : new THREE.MeshBasicMaterial({ color: 0x000000, opacity, transparent: true }),
            platelocpitch: getPlateLoc(p, ax0Adj, az0Adj),
            positions: [],
        };
        const pitchPathExaggerated = Object.assign(Object.assign({}, pitchPath), { platelocpitch: getPlateLoc(p, ax0Adj, az0Adj, true), positions: [] });
        let { x0: x, y0: y, z0: z } = p;
        let i = 0;
        while (y > 1.42 && z > 0 && i < 20) {
            x = p.x0 + ((i / 20.0) * p.vx0) + ((Math.pow((i / 20.0), 2)) * 0.5 * p.ax0);
            y = p.y0 + ((i / 20.0) * p.vy0) + ((Math.pow((i / 20.0), 2)) * 0.5 * p.ay0);
            z = p.z0 + ((i / 20.0) * p.vz0) + ((Math.pow((i / 20.0), 2)) * 0.5 * p.az0);
            const vx0Adj = i > 0 ? ((x * 1.5) - p.x0 - (0.5 * ax0Adj * (Math.pow((i / 20.0), 2)))) / (i / 20.0) : 0;
            const vz0Adj = i > 0 ? (2.5 + ((z - 2.5) * 1.5) - p.z0 - (0.5 * az0Adj * (Math.pow((i / 20.0), 2)))) / (i / 20.0) : 0;
            const xAdj = p.x0 + ((i / 20.0) * vx0Adj) + ((Math.pow((i / 20.0), 2)) * 0.5 * ax0Adj);
            const zAdj = p.z0 + ((i / 20.0) * vz0Adj) + ((Math.pow((i / 20.0), 2)) * 0.5 * az0Adj);
            if (y > 1.42 && z > 0) {
                pitchPath.positions.push({ posx: x, posy: y, posz: z });
                pitchPathExaggerated.positions.push({ posx: xAdj, posy: y, posz: zAdj });
            }
            else {
                pitchPath.positions.push(pitchPath.platelocpitch);
                pitchPathExaggerated.positions.push(pitchPathExaggerated.platelocpitch);
            }
            i += 1;
        }
        pitchpaths.push(pitchPath);
        pitchpathsExaggerated.push(pitchPathExaggerated);
    });
    return { pitchpaths, pitchpaths_exaggerated: pitchpathsExaggerated }; // eslint-disable-line camelcase
};

const mapCtwb = (ctwb, pitcherId, translate = null) => {
    const { overrides, firstpitch, oz } = ctwb;
    const heatmaps = ctwb.heatmaps.map((x) => ({
        playerid: x.b,
        pitchtype: x.t,
        fxsubtype: x.st,
        y: x.y,
        x: x.x,
        code: x.c,
        // eslint-disable-next-line no-nested-ternary
        situationsplit: x.s === 0 ? 'Early' : (x.s === 1 ? 'TwoStrikes' : null),
        val: x.v,
    }));
    const repertoire = heatmaps
        .map((h) => ({ pitchtype: Number(h.pitchtype), fxsubtype: Number(h.fxsubtype) || 0 }))
        .reduce((a, c) => { !a.find((v) => v.pitchtype === c.pitchtype && v.fxsubtype === c.fxsubtype) && a.push(c); return a; }, [])
        // eslint-disable-next-line max-len
        .sort((a, b) => { var _a, _b; return (((_a = PITCH_TYPES(translate).find((x) => x.id === a.pitchtype)) === null || _a === void 0 ? void 0 : _a.sortorder) || 0) - (((_b = PITCH_TYPES(translate).find((x) => x.id === b.pitchtype)) === null || _b === void 0 ? void 0 : _b.sortorder) || 0); });
    const initOutput = {};
    const hitters = Array.from(new Set(heatmaps.map((h) => h.playerid))).reduce((hitterMaps, batterId) => {
        const earlyHeatmaps = heatmaps.filter((h) => h.playerid === batterId && h.situationsplit === 'Early');
        const lateHeatmaps = heatmaps.filter((h) => h.playerid === batterId && h.situationsplit === 'TwoStrikes');
        const earlyOverrides = overrides.filter((o) => o.BatterID === batterId && o.SituationSplit === 'Early');
        const lateOverrides = overrides.filter((o) => o.BatterID === batterId && o.SituationSplit === 'TwoStrikes');
        const hasEarlyGreenOverride = earlyOverrides.some((o) => o.GreenBox);
        const hasLateGreenOverride = lateOverrides.some((o) => o.GreenBox);
        const hasEarlyDashGreenOverride = earlyOverrides.some((o) => o.DashGreenBox);
        const hasLateDashGreenOverride = lateOverrides.some((o) => o.DashGreenBox);
        const initMap = { earlyOverrides: {}, lateOverrides: {}, earlyHeatmaps: {}, lateHeatmaps: {} };
        hitterMaps[batterId] = initMap;
        repertoire.forEach((acc) => {
            const pitchType = acc.pitchtype;
            const FXSubType = acc.fxsubtype;
            if (hitterMaps[batterId].earlyOverrides[pitchType] == null)
                hitterMaps[batterId].earlyOverrides[pitchType] = [];
            /* eslint-disable eqeqeq, object-property-newline */
            const earlyOverride = earlyOverrides.find((x) => x.PitchType === pitchType && x.FXSubType === FXSubType);
            if (earlyOverride)
                hitterMaps[batterId].earlyOverrides[pitchType][FXSubType] = earlyOverride;
            // create a synthetic override record for display purposes
            else {
                hitterMaps[batterId].earlyOverrides[pitchType][FXSubType] = {
                    BatterID: batterId, BlankBox: null, GreenBox: null, PitchType: pitchType, FXSubType, PitcherID: pitcherId, RedX: null,
                    Selected: null, KFree: null, OTZ: null, SituationSplit: 'Early', LastUpdateDate: null, LastUpdateUser: null, DashGreenBox: null,
                };
            }
            // if the model declares something should be an 0-0 pitch, and there aren't any manually set 0-0 pitches, set the synthetic record to true
            if (!earlyOverrides.some(({ Selected }) => Selected == true)) {
                const firstPitch = firstpitch.find((x) => x.batterid == batterId && x.type == pitchType && x.fxsubtype === FXSubType);
                if (firstPitch && hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].Selected == null) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].Selected = true;
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].KFree = !!firstPitch.kfree;
                }
            }
            const earlycode = earlyHeatmaps.find((x) => x.x == 0 && x.y == 0 && x.pitchtype == pitchType && x.fxsubtype === FXSubType);
            if (earlycode) {
                if (hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].GreenBox === null && earlycode.code === 2 && !hasEarlyGreenOverride) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].GreenBox = true;
                }
                if (hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].DashGreenBox === null && earlycode.code === 1 && !hasEarlyDashGreenOverride) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].DashGreenBox = true;
                }
                if (hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].val == null) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].val = earlycode.val;
                }
                else {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].valoverride = true;
                }
            }
            if (hitterMaps[batterId].lateOverrides[pitchType] == null)
                hitterMaps[batterId].lateOverrides[pitchType] = [];
            const lateOverride = lateOverrides.find((x) => x.PitchType == pitchType && x.FXSubType === FXSubType);
            if (lateOverride)
                hitterMaps[batterId].lateOverrides[pitchType][FXSubType] = lateOverride;
            // create a synthetic override record for display purposes
            else {
                hitterMaps[batterId].lateOverrides[pitchType][FXSubType] = {
                    BatterID: batterId, BlankBox: null, GreenBox: null, PitchType: pitchType, FXSubType, PitcherID: pitcherId, RedX: null,
                    Selected: null, KFree: null, OTZ: null, SituationSplit: 'TwoStrikes', LastUpdateDate: null, LastUpdateUser: null, DashGreenBox: null,
                };
            }
            // if the model declares something should be an OTZ pitch, and there aren't any manually set OTZ pitches, set the synthetic record to true
            if (!lateOverrides.some(({ OTZ }) => OTZ == true)) {
                const otz = oz.find((x) => x.batterid == batterId && x.type == pitchType && x.fxsubtype === FXSubType);
                if (otz && hitterMaps[batterId].lateOverrides[pitchType][FXSubType].OTZ == null) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].OTZ = otz.oz;
                }
            }
            const latecode = lateHeatmaps.find((x) => x.x == 0 && x.y == 0 && x.pitchtype == pitchType && x.fxsubtype === FXSubType);
            if (latecode) {
                if (hitterMaps[batterId].lateOverrides[pitchType][FXSubType].GreenBox === null && latecode.code === 2 && !hasLateGreenOverride) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].GreenBox = true;
                }
                if (hitterMaps[batterId].lateOverrides[pitchType][FXSubType].DashGreenBox === null && latecode.code === 1 && !hasLateDashGreenOverride) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].DashGreenBox = true;
                }
                if (hitterMaps[batterId].lateOverrides[pitchType][FXSubType].val == null) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].val = latecode.val;
                }
                else {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].valoverride = true;
                }
            }
            if (hitterMaps[batterId].earlyHeatmaps[pitchType] == null)
                hitterMaps[batterId].earlyHeatmaps[pitchType] = [];
            if (hitterMaps[batterId].lateHeatmaps[pitchType] == null)
                hitterMaps[batterId].lateHeatmaps[pitchType] = [];
            hitterMaps[batterId].earlyHeatmaps[pitchType][FXSubType] = earlyHeatmaps.filter((x) => x.pitchtype == pitchType && x.fxsubtype === FXSubType);
            hitterMaps[batterId].lateHeatmaps[pitchType][FXSubType] = lateHeatmaps.filter((x) => x.pitchtype == pitchType && x.fxsubtype === FXSubType);
        });
        return hitterMaps;
    }, initOutput);
    return {
        pitcherid: pitcherId,
        hitters,
        repertoire,
    };
};
const mapCtwbToPitches = (ctwb, pitcherId, pitches, translate = null) => {
    const pitcherMaps = mapCtwb(ctwb, pitcherId, translate);
    return pitches.map((p) => {
        if (pitcherMaps.pitcherid === p.pitcherid) {
            const batterMap = pitcherMaps.hitters[p.batterid];
            let heatMaps = batterMap && batterMap.lateHeatmaps;
            let overrides = batterMap && batterMap.lateOverrides;
            if (p.strikes !== 2) {
                heatMaps = batterMap && batterMap.earlyHeatmaps;
                overrides = batterMap && Object.assign({}, batterMap.earlyOverrides);
                if ((p.strikes !== 0 || p.balls !== 0) && overrides) {
                    Object.values(overrides).forEach((override) => {
                        Object.values(override).forEach((o) => {
                            o.Selected = false;
                        });
                    });
                }
            }
            return Object.assign(Object.assign({}, p), { heatMaps,
                overrides, pitcherRepertoire: pitcherMaps.repertoire });
        }
        return p;
    });
};

const handleFetchResponse = (apiResp, returnFullError = false) => {
    if (apiResp.ok) {
        const contentType = apiResp.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return apiResp.json();
        }
        return apiResp.text();
    }
    throw returnFullError ? apiResp : apiResp.statusText;
};
const callApi = (method) => (apiRoute, body, fetchOpts, returnFullError = false) => __awaiter(void 0, void 0, void 0, function* () {
    let requestBody = body;
    if (body && typeof body === 'object') {
        if (body instanceof FormData && (fetchOpts === null || fetchOpts === void 0 ? void 0 : fetchOpts.headers)) {
            // fetch will automatically set this and the corresponding boundary when given a FormData instance
            if (fetchOpts.headers instanceof Headers) {
                fetchOpts.headers.delete('Content-Type');
            }
            else {
                fetchOpts.headers = new Headers(Object.assign({}, fetchOpts.headers));
                fetchOpts.headers.delete('Content-Type');
            }
        }
        else {
            requestBody = JSON.stringify(body);
        }
    }
    const apiResp = yield fetch(apiRoute, Object.assign({ method, body: requestBody }, fetchOpts));
    return handleFetchResponse(apiResp, returnFullError);
});
const get$1 = callApi('GET');
const put$1 = callApi('PUT');
const post$1 = callApi('POST');
const remove$1 = callApi('DELETE');
const patch$1 = callApi('PATCH');

const addQueryParamsToUrl = (url, queryParams) => {
    let mappedUrl = url || '';
    if (queryParams && typeof queryParams === 'object' && Object.keys(queryParams).length) {
        const params = Object.assign({}, queryParams);
        // Strip undefined query params
        Object.keys(params).forEach((key) => {
            if (params[key] === undefined || params[key] === null) {
                delete params[key];
            }
        });
        // manipulate params for api call
        const entries = Object.entries(params).reduce((acc, [key, value]) => {
            if (Array.isArray(value))
                value.forEach((x) => acc.push([key, x.toString()]));
            else if (value instanceof Date)
                acc.push([key, value.toISOString()]);
            else
                acc.push([key, typeof value === 'string' ? value : JSON.stringify(value)]);
            return acc;
        }, new Array());
        const query = new URLSearchParams(entries).toString();
        mappedUrl += `?${query}`;
    }
    return mappedUrl;
};
const jsonDataAsMultipartForm = (jsonObj) => Object.keys(jsonObj).reduce((acc, key) => {
    const data = jsonObj[key];
    const formVal = typeof data === 'string' || data instanceof Blob ? data : JSON.stringify(data);
    acc.append(key, formVal);
    return acc;
}, new FormData());

const getDefaultFetchOpts = (fetchOptsOverrides) => (Object.assign(Object.assign({}, fetchOptsOverrides), { headers: Object.assign({ 'Content-Type': 'application/json' }, fetchOptsOverrides === null || fetchOptsOverrides === void 0 ? void 0 : fetchOptsOverrides.headers) }));
const get = (url, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return get$1(path, undefined, opts, returnFullError);
});
const post = (url, body = null, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return post$1(path, body, opts, returnFullError);
});
const put = (url, body = null, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return put$1(path, body, opts, returnFullError);
});
const remove = (url, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return remove$1(path, undefined, opts, returnFullError);
});
const patch = (url, body = null, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return patch$1(path, body, opts, returnFullError);
});

var api = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get: get,
    post: post,
    put: put,
    remove: remove,
    patch: patch
});

const useAbortable = (url, doFetch = true, queryParams = null, fetchOpts = {}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [response, setResponse] = useState(null);
    useEffect(() => {
        const abortController = new AbortController();
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setIsLoading(true);
                const data = yield get(url, queryParams, Object.assign(Object.assign({}, fetchOpts), { signal: abortController.signal }));
                setResponse(data);
                setIsLoading(false);
            }
            catch (error) {
                if (error instanceof Error && error.name !== 'AbortError') {
                    throw error;
                }
            }
        });
        if (doFetch)
            fetchData();
        return () => {
            abortController.abort();
        };
    }, [doFetch, url, queryParams, fetchOpts]);
    return { response, isLoading, clearResponse: () => setResponse(null) };
};

const MPS_MPH = 2.237;
const IN_PER_METER = 39.37;

/* eslint-disable react/no-this-in-sfc */
const Container$1 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
        
    }
`;
const ZoneDepth = ({ sensorEvent, hideBallMarker = false }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderHomePlate(chart);
    }, [ref, sensorEvent]); // eslint-disable-line react-hooks/exhaustive-deps
    function renderHomePlate(chart) {
        const rectattr = {
            'stroke-width': 2,
            stroke: 'lightgrey',
            fill: 'none',
            zIndex: 1,
        };
        const platePath = new Array();
        platePath.push('M');
        platePath.push(chart.xAxis[0].toPixels(-8.5, false));
        platePath.push(chart.yAxis[0].toPixels(17, false));
        platePath.push('L');
        platePath.push(chart.xAxis[0].toPixels(8.5, false));
        platePath.push(chart.yAxis[0].toPixels(17, false));
        platePath.push(chart.xAxis[0].toPixels(8.5, false));
        platePath.push(chart.yAxis[0].toPixels(8.5, false));
        platePath.push(chart.xAxis[0].toPixels(0, false));
        platePath.push(chart.yAxis[0].toPixels(0, false));
        platePath.push(chart.xAxis[0].toPixels(-8.5, false));
        platePath.push(chart.yAxis[0].toPixels(8.5, false));
        platePath.push('Z');
        chart.renderer.path(platePath).attr(rectattr).add();
    }
    const xPP1 = Math.round((sensorEvent.Intersect1 * IN_PER_METER) * 10) / 10;
    const yPP3 = Math.round((sensorEvent.Intersect3 * IN_PER_METER) * 10) / 10;
    const chartConfig = {
        title: {
            text: undefined,
        },
        chart: {
            type: 'scatter',
            height: 250,
            width: 300,
            backgroundColor: 'transparent',
        },
        series: [{
                name: translate('components.ballcap.pitch'),
                data: xPP1 === 0 && yPP3 === 0 ? [] : [{
                        x: xPP1,
                        y: yPP3,
                    }],
                marker: hideBallMarker ? {
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#3366FF',
                } : {
                    symbol: `url(${bb18x18})`,
                    color: 'blue',
                },
            }],
        xAxis: {
            min: -20,
            max: 20,
        },
        yAxis: {
            title: {
                text: translate('components.ballcap.depth-in'),
            },
            min: -10,
            max: 30,
        },
        legend: false,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container$1, null,
            React.createElement(BaseChart, { ref: ref, options: chartConfig }))));
};

const Container = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const LaunchAngle = ({ sensorEvent, hideBallMarker = false }) => {
    const { t: translate } = useTranslation();
    const velo = Math.round((sensorEvent.Velo * MPS_MPH) * 10) / 10;
    const launchAngle = Math.round(sensorEvent.Elv * 10) / 10;
    const chartConfig = {
        chart: {
            polar: true,
            type: 'line',
            // height: 355,
            // width: 355,
            backgroundColor: 'transparent',
        },
        title: {
            text: undefined,
        },
        pane: {
            startAngle: 0,
            endAngle: 180,
        },
        xAxis: {
            min: -90,
            max: 90,
            tickInterval: 15,
            labels: {
                formatter() {
                    return (!this.isFirst && !this.isLast) ? `${this.value}°` : '';
                },
            },
            reversed: true,
            startOnTick: true,
            endOnTick: true,
            alignTicks: true,
        },
        yAxis: {
            min: 20,
            max: 120,
            tickInterval: 25,
            labels: {
                format: `{value} ${translate('components.ballcap.abbr-mph')}`,
            },
            reversedStacks: true,
        },
        tooltip: {
            formatter() {
                if (this.x !== 0 || this.y !== 0) {
                    return `<b>${this.x}°</b>, <b>${this.y} ${translate('components.ballcap.abbr-mph')}</b>`;
                }
                return false;
            },
        },
        plotOptions: {
            series: {
                pointStart: 0,
                lineWidth: 4,
                marker: hideBallMarker ? {
                    symbol: 'circle',
                    radius: 4,
                    fillColor: '#3366FF',
                } : {
                    symbol: `url(${bb18x18})`,
                },
                states: {
                    hover: {
                        enabled: false,
                    },
                },
            },
        },
        series: [{
                type: 'line',
                animation: false,
                name: translate('components.ballcap.exit-velo'),
                data: [{ x: 0, y: 0, marker: { enabled: false } }, { x: launchAngle, y: velo }],
            }],
        legend: {
            enabled: false,
        },
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null,
            React.createElement(BaseChart, { options: chartConfig }))));
};

const StyledStat = styled.div `
    display: flex;
    flex-direction: column;
    flex: 1;
`;
const StyledLabel = styled.div `
    font-size: 12px;
    background-color: #c6d3dc;
    color: #000;
    font-size: 0.75rem;
    font-weight: bold;
    text-align: center;
    padding: 4px 8px;
    border-radius: 4px 4px 0 0;
`;
const StyledValue = styled.div `
    font-size: 24px;
    background-color: white;
    border-radius: 0 0 4px 4px;
    color: #254C75;
    font-weight: bold;
    text-align: center;
    padding: 8px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const StyledStatWrapper = styled.div `
    padding: 10px 0 0 0;
    border: none;;
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(${(props) => Math.ceil(props.$numStats / 2)},minmax(0,1fr));
    @media (min-width: 992px) {
        grid-template-columns: repeat(${(props) => props.$numStats},minmax(0,1fr));
    }
`;
const Stat = ({ label, value }) => (React.createElement(StyledStat, null,
    React.createElement(StyledLabel, null, label),
    React.createElement(StyledValue, null, value || '--')));
const SummaryStats = ({ summaryStats }) => (React.createElement(StyledStatWrapper, { "$numStats": summaryStats.length }, summaryStats.map((ss) => React.createElement(Stat, { label: ss.label, value: ss.value, key: ss.label }))));

var isReset = true;
var spinDirDeg = 180;
var gyroAngle = 270;
var SpinRate = 0;
var Data = {
};
var MiniBallRStaticPitchEventBallCapFormat = {
	isReset: isReset,
	spinDirDeg: spinDirDeg,
	gyroAngle: gyroAngle,
	SpinRate: SpinRate,
	Data: Data
};

const StyledBallCapContainer = styled.div `
    height: 1000px;
    overflow-x: hidden;
`;
const PANEL_BORDER = '2px solid #cccccc';
const StyledHeader = styled.div `
    background-color: white;
    height: 40px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-size: 16px;
    padding: 0 10px;
    font-weight: 700;
    color: ${styles.theme.fontColors.doveGray};
    border-bottom: 1px solid ${styles.theme.border.alto};
`;
const StyledPitch = styled.button `
    background: none;
    color: #254C75;
    border: none;
    padding: 0;
    font: inherit;
    outline: inherit;
    border-bottom: 1px solid ${styles.theme.border.alto};
    width: 100%;
    text-align: left;
    height: 40px;
    position: relative;
    background-color: ${(props) => (props.$isSelected ? '#acb9c2' : 'white')}
`;
const StyledCenterContainer = styled.div `
    height: 100%;
    min-height: 0;
    min-width: 0;
`;
const StyledSummaryStatsPanel = styled.div `
    > div > div {
        border: ${PANEL_BORDER};
        border-radius: 4px;
        overflow: hidden;
    }
`;
const StyledVideoPlayerSlot = styled.div `
    flex: 1 1 0;
    min-height: 0;
    min-width: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    background-color: #000;

    > * {
        flex: 1 1 0;
        min-height: 0;
        min-width: 0;
        width: 100%;
        max-width: 100%;
    }
`;
const StyledNoPitchVideo = styled.div `
    align-items: center;
    color: white;
    display: flex;
    font-size: 1.5rem;
    font-weight: 600;
    justify-content: center;
`;
const StyledRightContainer = styled.div `
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
const StyledRightColumnPanel = styled.div `
    flex: 1 1 0;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: ${PANEL_BORDER};
`;
const StyledRightColumnPanelBody = styled.div `
    flex: 1 1 0;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;
const StyledRightColumnMiniWrap = styled.div `
    flex: 1 1 0;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    position: relative;
    width: 100%;
`;
const StyledPitchIdentifier = styled.div `
    font-size: ${(props) => (props.$compact ? '12px' : '18px')};
    font-weight: bold;
    width: 36px;
    padding-left: 8px;
    text-align: left;
`;
const StyledPitchDetails = styled.div `
    width: 70px;
    text-align: left;
`;
const StyledPitchFlag = styled.span `
    line-height: 1;
    position: absolute;
    right: 6px;
    top: 4px;
`;
const StyledPitchNote = styled.span `
    bottom: 4px;
    line-height: 1;
    position: absolute;
    right: 6px;
`;
const StyledPitchNotePopover = styled.span `
    background-color: white;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: .3rem;
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);
    display: block;
    font-size: .875rem;
    left: 0;
    max-width: 260px;
    position: fixed;
    top: 0;
    white-space: pre-wrap;
    z-index: 1060;
`;
const StyledPitchNotePopoverBody = styled.span `
    display: block;
    padding: .5rem .75rem;
    color: #000;
`;
const PITCH_RESULT_BAR_COLORS = {
    strike: '#ff0000',
    ball: '#279c00',
    unknown: '#6c757d',
};
const StyledPitchResult = styled.div `
    background-color: ${(props) => PITCH_RESULT_BAR_COLORS[props.$outcome]};
    width: 12px;
    min-width: 12px;
`;
const StyledPitchesPanel = styled.div `
    flex: 1 1 0;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: white;
    scrollbar-width: none;
    -ms-overflow-style: none;
    border: ${PANEL_BORDER};

    &::-webkit-scrollbar {
        display: none;
    }
`;
const StyledZoneDepthLabel = styled.div `
    font-size: 1.75rem;
    font-weight: bold;
    position: absolute;
    right: 10px;
    bottom: 10px;
    color: #254C75;
`;
const StyledSprayChartLabel = styled.div `
    font-size: 1.75rem;
    font-weight: bold;
    position: absolute;
    right: 10px;
    bottom: 10px;
    color: #254C75;
`;
// ---- selectors over the raw V2 pitch shape ---------------------------------
// The UI only needs a handful of derived values; we read each metric straight off
// the vendor. Trackman is preferred, with YakkerTech as
// fallback for pitch metrics; HitTrax owns hit metrics.
const toFiniteOrNull = (n) => (typeof n === 'number' && Number.isFinite(n) ? n : null);
const getVelocityMph = (pitch) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return ((_d = toFiniteOrNull((_c = (_b = (_a = pitch.VendorTrackman) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.Calculated) === null || _c === void 0 ? void 0 : _c.VelocityMph)) !== null && _d !== void 0 ? _d : toFiniteOrNull((_g = (_f = (_e = pitch.VendorYakkerTech) === null || _e === void 0 ? void 0 : _e.Data) === null || _f === void 0 ? void 0 : _f.pitch_data) === null || _g === void 0 ? void 0 : _g.RelSpeedMPH));
};
const getSpinRateRpm = (pitch) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return ((_d = toFiniteOrNull((_c = (_b = (_a = pitch.VendorTrackman) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.Calculated) === null || _c === void 0 ? void 0 : _c.SpinRateAbsRpm)) !== null && _d !== void 0 ? _d : toFiniteOrNull((_g = (_f = (_e = pitch.VendorYakkerTech) === null || _e === void 0 ? void 0 : _e.Data) === null || _f === void 0 ? void 0 : _f.pitch_data) === null || _g === void 0 ? void 0 : _g.SpinRateRPM));
};
const getHorizontalBreakIn = (pitch) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return ((_f = toFiniteOrNull((_e = (_d = (_c = (_b = (_a = pitch.VendorTrackman) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.Pitch) === null || _d === void 0 ? void 0 : _d.Movement) === null || _e === void 0 ? void 0 : _e.Horizontal)) !== null && _f !== void 0 ? _f : toFiniteOrNull((_j = (_h = (_g = pitch.VendorYakkerTech) === null || _g === void 0 ? void 0 : _g.Data) === null || _h === void 0 ? void 0 : _h.pitch_data) === null || _j === void 0 ? void 0 : _j.HorzBreakInches));
};
const getVerticalBreakIn = (pitch) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return ((_f = toFiniteOrNull((_e = (_d = (_c = (_b = (_a = pitch.VendorTrackman) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.Pitch) === null || _d === void 0 ? void 0 : _d.Movement) === null || _e === void 0 ? void 0 : _e.InducedVertical)) !== null && _f !== void 0 ? _f : toFiniteOrNull((_j = (_h = (_g = pitch.VendorYakkerTech) === null || _g === void 0 ? void 0 : _g.Data) === null || _h === void 0 ? void 0 : _h.pitch_data) === null || _j === void 0 ? void 0 : _j.VertBreakInches));
};
const getExitVeloMph = (pitch) => {
    var _a, _b, _c;
    return (toFiniteOrNull((_c = (_b = (_a = pitch.VendorHitTrax) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.Calculated) === null || _c === void 0 ? void 0 : _c.ExitVeloMph));
};
const getLaunchAngleDeg = (pitch) => {
    var _a, _b;
    return (toFiniteOrNull((_b = (_a = pitch.VendorHitTrax) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.Elv));
};
const getHorzAngle = (pitch) => {
    var _a, _b;
    return (toFiniteOrNull((_b = (_a = pitch.VendorHitTrax) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.HorzAngle));
};
const getGyroDegree = (pitch, islhp) => {
    var _a, _b, _c;
    const spin = (_c = (_b = (_a = pitch.VendorYakkerTech) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.pitch_data) === null || _c === void 0 ? void 0 : _c.yt_SpinComponentY;
    if (spin)
        return toFiniteOrNull(Math.asin(spin * (islhp ? 1 : -1)) * (180 / Math.PI));
    return null;
};
const getTilt = (pitch) => { var _a, _b, _c; return (_c = (_b = (_a = pitch.VendorYakkerTech) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.pitch_data) === null || _c === void 0 ? void 0 : _c.Tilt; };
// All-pitches rendering constants (used by the right-column charts when the
// "show all" toggle is on). Non-selected pitches are faded via per-point rgba
// so the selected pitch — which gets +2px of marker radius — stands out.
const STRIKE_COLOR = '#BF0B23';
const BALL_COLOR = '#8bbc21';
// Gray "no ABS evaluation available" tone, used when IsAbsStrike is null/missing.
const UNKNOWN_COLOR = '#6c757d';
const DEFAULT_RADIUS = 5;
const SELECTED_RADIUS = DEFAULT_RADIUS + 2;
const FADED_ALPHA = 0.35;
const STRIKE_COLOR_FADED = `rgba(191, 11, 35, ${FADED_ALPHA})`;
const BALL_COLOR_FADED = `rgba(139, 188, 33, ${FADED_ALPHA})`;
const UNKNOWN_COLOR_FADED = `rgba(108, 117, 125, ${FADED_ALPHA})`;
const getPitchOutcome = (p) => {
    if (p.IsAbsStrike === true)
        return 'strike';
    if (p.IsAbsStrike === false)
        return 'ball';
    return 'unknown';
};
const outcomeColor = (outcome, faded) => {
    if (outcome === 'strike')
        return faded ? STRIKE_COLOR_FADED : STRIKE_COLOR;
    if (outcome === 'ball')
        return faded ? BALL_COLOR_FADED : BALL_COLOR;
    return faded ? UNKNOWN_COLOR_FADED : UNKNOWN_COLOR;
};
const pitchPointColor = (p, faded) => (outcomeColor(getPitchOutcome(p), faded));
const pitchTooltipName = (translate, p) => `${translate('baseball.pitches_one')} ${p.PitchID}`;
// Render a summary-stat value, falling back to "--" when the raw stat is
// missing (null/undefined/NaN) so the UI never shows "null mph" or blanks.
const EMPTY_STAT = '--';
const formatOrEmpty = (raw, fmt) => (typeof raw === 'number' && Number.isFinite(raw) ? fmt(raw) : EMPTY_STAT);
// Split a session's pitches into selected vs non-selected, applying a
// chart-specific projection that pulls the x/y (and any extra per-point
// fields) from each pitch. Pitches that lack either coordinate are dropped.
// Each emitted point is tagged with `name = "Pitch <PitchNumber>"` so the
// chart tooltip formatters can show which pitch the user is hovering.
const splitPitchesForChart = (pitches, selectedPitchId, project, translate) => {
    const selected = [];
    const others = [];
    pitches.forEach((p) => {
        var _a;
        const projected = project(p);
        if (projected == null)
            return;
        const isSelected = p.PitchID === selectedPitchId;
        const color = pitchPointColor(p, !isSelected);
        const point = Object.assign({ x: projected.x, y: projected.y, name: pitchTooltipName(translate, p), color, 
            // also set on the per-point marker so a stale series-level
            // marker.fillColor can't override per-point coloring.
            marker: { fillColor: color } }, ((_a = projected.extra) !== null && _a !== void 0 ? _a : {}));
        (isSelected ? selected : others).push(point);
    });
    return { selected, others };
};
const getPitchTypeLabel = (pitch, translate) => {
    var _a;
    return (pitchTypeOrSubType((_a = pitch.ClassifiedPitchType) !== null && _a !== void 0 ? _a : pitch.PitchType, true, undefined, translate));
};
// Collect every angle attached to a pitch — high-speed / edger angles
// (Pitches[].Angles[]) plus any vendor-captured angles emitted on the
// per-pitch sensor events (Pitches[].SensorEvents[].Videos[], e.g. Trajekt).
// Both arrays share IBallcapAngle's shape; dedupe by FileName so a vendor
// can't double-list an edger angle by accident.
const collectPitchAngles = (p) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const vendorAngles = [
        ...((_b = (_a = p.VendorHitTrax) === null || _a === void 0 ? void 0 : _a.Videos) !== null && _b !== void 0 ? _b : []),
        ...((_d = (_c = p.VendorTrackman) === null || _c === void 0 ? void 0 : _c.Videos) !== null && _d !== void 0 ? _d : []),
        ...((_f = (_e = p.VendorYakkerTech) === null || _e === void 0 ? void 0 : _e.Videos) !== null && _f !== void 0 ? _f : []),
        ...((_h = (_g = p.VendorTrajekt) === null || _g === void 0 ? void 0 : _g.Videos) !== null && _h !== void 0 ? _h : []),
    ];
    const byFileName = new Map();
    [...((_j = p.Angles) !== null && _j !== void 0 ? _j : []), ...vendorAngles].forEach((a) => {
        if ((a === null || a === void 0 ? void 0 : a.FileName) && !byFileName.has(a.FileName)) {
            byFileName.set(a.FileName, a);
        }
    });
    return Array.from(byFileName.values());
};
const mapBallCapPlaylist = (translate, pitches, videos, player, isLH) => {
    const views = CAMERA_VIEWS.reduce((acc, v) => {
        acc[v.id] = v.name;
        return acc;
    }, []);
    const playlist = pitches.map((p) => {
        var _a;
        const sources = collectPitchAngles(p).map((a) => {
            var _a, _b;
            const video = videos.find((v) => v.BucketKey.endsWith(a.FileName));
            let label = `${translate('components.ballcap.angle')} ${a.AngleName}`;
            if (a.RHAngleId && !isLH)
                label = (_a = views[a.RHAngleId]) !== null && _a !== void 0 ? _a : label;
            else if (a.LHAngleId && isLH)
                label = (_b = views[a.LHAngleId]) !== null && _b !== void 0 ? _b : label;
            return {
                file: (video === null || video === void 0 ? void 0 : video.SignedURL) || '',
                label,
            };
        }).filter((a) => a.file);
        if (sources.length) {
            sources.sort((a, b) => a.label.localeCompare(b.label));
            sources[0].default = true;
            const pitchtype = (_a = p.ClassifiedPitchType) !== null && _a !== void 0 ? _a : p.PitchType;
            const velocity = getVelocityMph(p);
            const hitvelocity = getExitVeloMph(p);
            const data = Object.assign(Object.assign({ gameid: p.PitchID, eventseq: p.PitchID, pitchseq: p.PitchID, islhp: player.Throws === 2, islhb: player.Bats === 2 }, p), { pitchtype,
                velocity,
                hitvelocity });
            let title = `${translate('baseball.pitches_one')} ${p.PitchID}`;
            if (pitchtype) {
                title = `${title} - ${pitchTypeOrSubType(pitchtype, undefined, undefined, translate)}`;
            }
            const description = [];
            if (velocity) {
                description.push(`${translate('components.ballcap.abbr-velocity')}: ${translate('format.abbr-mph', { value: format(velocity, 1) })}`);
            }
            if (hitvelocity) {
                description.push(`${translate('components.ballcap.abbr-exit-velocity')}: ${translate('format.abbr-mph', { value: format(hitvelocity, 1) })}`);
            }
            return {
                pitchId: p.PitchID.toString(),
                title,
                description: description.length ? description.join(' | ') : '',
                sources,
                data,
                clip: sources.map((s) => ({
                    Url: s.file,
                    AngleLabel: s.label,
                    Include: true,
                    Data: JSON.stringify(data),
                    GameDate: null,
                    GameID: null,
                    EventSeq: null,
                    PitchSeq: null,
                })),
                heatmapId: null,
            };
        }
        return null;
    }).filter((p) => p);
    return playlist;
};
const BallcapSessionDisplay = ({ isBullpen, data, ballrMiniFrameSource, showAllCheckbox, isPlayerPortal, isTrackmanSyntheticSession, download, grabFrame, reportBadVideo, }) => {
    var _a;
    const { t: translate } = useTranslation();
    const { Session, Videos } = data;
    const bcpitcharray = [];
    const bcvideoplaylist = [];
    const [selectedPitchId, setSelectedPitchId] = useState(0);
    const [pitchesList, setPitchesList] = useState(bcpitcharray);
    const [yakkertechPitch, setYakkertechPitch] = useState({});
    const [strikeZoneChartData, setStrikeZoneChartData] = useState([]);
    const [pitchBreakPlotChartData, setPitchBreakPlotChartData] = useState([]);
    const [zoneDepthChartData, setZoneDepthChartData] = useState([]);
    const [zoneDepthChartDisplayValue, setZoneDepthChartDisplayValue] = useState(null);
    const [fullfieldSprayChartData, setFullfieldSprayChartData] = useState([]);
    const [fullfieldSprayChartDisplayValue, setFullfieldSprayChartDisplayValue] = useState(null);
    const [pitchVideosList, setPitchVideosList] = useState(bcvideoplaylist);
    const [pitchVideosSessionId, setPitchVideosSessionId] = useState(null);
    const [summaryStats, setSummaryStats] = useState([]);
    const videoPlayerRef = useRef(null);
    const videoPlayerSlotRef = useRef(null);
    const [videoPlayerMaxHeight, setVideoPlayerMaxHeight] = useState(undefined);
    const [pitchStrikeZoneTop, setPitchStrikeZoneTop] = useState(ABS_ZONE_TOP$1);
    const [pitchStrikeZoneBottom, setPitchStrikeZoneBottom] = useState(ABS_ZONE_BOTTOM$1);
    const [pitchNotePopover, setPitchNotePopover] = useState(null);
    const stopPitchIconClick = (e) => {
        e.stopPropagation();
    };
    const togglePitchNotePopover = (e, pitchId, note) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        setPitchNotePopover((current) => {
            if ((current === null || current === void 0 ? void 0 : current.pitchId) === pitchId)
                return null;
            return {
                pitchId,
                note,
                top: Math.max(8, rect.top - 8),
                left: Math.min(rect.right + 8, window.innerWidth - 280),
            };
        });
    };
    const hidePitchNotePopover = () => setPitchNotePopover(null);
    useEffect(() => {
        if (!pitchNotePopover)
            return undefined;
        document.addEventListener('click', hidePitchNotePopover);
        return () => document.removeEventListener('click', hidePitchNotePopover);
    }, [pitchNotePopover]);
    const allPitchesStrikeZoneData = useMemo(() => {
        if (!showAllCheckbox || pitchesList.length === 0)
            return [];
        const { selected, others } = splitPitchesForChart(pitchesList, selectedPitchId, (p) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            const x = isBullpen
                ? (_c = (_b = (_a = p.VendorTrackman) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.Calculated) === null || _c === void 0 ? void 0 : _c.PlateXFeet
                : (_f = (_e = (_d = p.VendorHitTrax) === null || _d === void 0 ? void 0 : _d.Data) === null || _e === void 0 ? void 0 : _e.Calculated) === null || _f === void 0 ? void 0 : _f.PlateXFeet;
            const y = isBullpen
                ? (_j = (_h = (_g = p.VendorTrackman) === null || _g === void 0 ? void 0 : _g.Data) === null || _h === void 0 ? void 0 : _h.Calculated) === null || _j === void 0 ? void 0 : _j.PlateZFeet
                : (_m = (_l = (_k = p.VendorHitTrax) === null || _k === void 0 ? void 0 : _k.Data) === null || _l === void 0 ? void 0 : _l.Calculated) === null || _m === void 0 ? void 0 : _m.PlateZFeet;
            if (x == null || y == null)
                return null;
            return { x, y };
        }, translate);
        const series = [];
        if (others.length > 0) {
            series.push({
                type: 'scatter',
                name: 'Strike Zone',
                data: others,
                index: 0,
                id: 'allpitches-others',
                marker: { symbol: 'circle', radius: DEFAULT_RADIUS, lineColor: '#ffffff', lineWidth: 2 },
            });
        }
        if (selected.length > 0) {
            series.push({
                type: 'scatter',
                name: 'Strike Zone',
                data: selected,
                index: 1,
                id: 'allpitches-selected',
                marker: { symbol: 'circle', radius: SELECTED_RADIUS, lineColor: '#ffffff', lineWidth: 2 },
            });
        }
        return series;
    }, [showAllCheckbox, pitchesList, selectedPitchId, translate, isBullpen]);
    // PitchBreakPlotChart's built-in `pitches`/`allPitches` paths hard-code
    // marker size and opacity, so we bypass them by feeding our own pre-built
    // scatter series through its passthrough `seriesData` prop.
    const allPitchesBreakPlotSeriesData = useMemo(() => {
        if (!showAllCheckbox || pitchesList.length === 0)
            return [];
        const { selected, others } = splitPitchesForChart(pitchesList, selectedPitchId, (p) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const x = (_e = (_d = (_c = (_b = (_a = p.VendorTrackman) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.Pitch) === null || _d === void 0 ? void 0 : _d.Movement) === null || _e === void 0 ? void 0 : _e.Horizontal;
            const y = (_k = (_j = (_h = (_g = (_f = p.VendorTrackman) === null || _f === void 0 ? void 0 : _f.Data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.Pitch) === null || _j === void 0 ? void 0 : _j.Movement) === null || _k === void 0 ? void 0 : _k.InducedVertical;
            if (x == null || y == null)
                return null;
            return { x, y };
        }, translate);
        const series = [];
        if (others.length > 0) {
            series.push({
                type: 'scatter',
                name: 'Pitch Break',
                data: others,
                marker: { symbol: 'circle', radius: DEFAULT_RADIUS, lineColor: '#ffffff', lineWidth: 2 },
                enableMouseTracking: true,
                id: 'allpitches-others',
            });
        }
        if (selected.length > 0) {
            series.push({
                type: 'scatter',
                name: 'Pitch Break',
                data: selected,
                marker: { symbol: 'circle', radius: SELECTED_RADIUS, lineColor: '#ffffff', lineWidth: 2 },
                enableMouseTracking: true,
                id: 'allpitches-selected',
            });
        }
        return series;
    }, [pitchesList, showAllCheckbox, selectedPitchId, translate]);
    const allPitchesZoneDepthData = useMemo(() => {
        if (!showAllCheckbox || pitchesList.length === 0)
            return [];
        const { selected, others } = splitPitchesForChart(pitchesList, selectedPitchId, (p) => {
            var _a, _b, _c, _d, _e, _f;
            const x = (_c = (_b = (_a = p.VendorHitTrax) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.Calculated) === null || _c === void 0 ? void 0 : _c.ZoneDepthXInches;
            const y = (_f = (_e = (_d = p.VendorHitTrax) === null || _d === void 0 ? void 0 : _d.Data) === null || _e === void 0 ? void 0 : _e.Calculated) === null || _f === void 0 ? void 0 : _f.ZoneDepthYInches;
            if (x == null || y == null)
                return null;
            return { x, y };
        }, translate);
        const series = [];
        if (others.length > 0) {
            series.push({
                id: 'zone_depth_chart_all_others',
                name: 'Zone Depth',
                visible: true,
                marker: { enabled: true, symbol: 'circle', radius: DEFAULT_RADIUS, lineColor: '#ffffff', lineWidth: 2 },
                data: others,
                type: 'scatter',
            });
        }
        if (selected.length > 0) {
            series.push({
                id: 'zone_depth_chart_all_selected',
                name: 'Zone Depth',
                visible: true,
                marker: { enabled: true, symbol: 'circle', radius: SELECTED_RADIUS, lineColor: '#ffffff', lineWidth: 2 },
                data: selected,
                type: 'scatter',
            });
        }
        return series;
    }, [pitchesList, showAllCheckbox, selectedPitchId, translate]);
    const allPitchesSprayChartData = useMemo(() => {
        if (!showAllCheckbox || pitchesList.length === 0)
            return [];
        const { selected, others } = splitPitchesForChart(pitchesList, selectedPitchId, (p) => {
            var _a, _b, _c, _d, _e, _f;
            const x = (_c = (_b = (_a = p.VendorHitTrax) === null || _a === void 0 ? void 0 : _a.Data) === null || _b === void 0 ? void 0 : _b.Calculated) === null || _c === void 0 ? void 0 : _c.SprayChartXFeet;
            const y = (_f = (_e = (_d = p.VendorHitTrax) === null || _d === void 0 ? void 0 : _d.Data) === null || _e === void 0 ? void 0 : _e.Calculated) === null || _f === void 0 ? void 0 : _f.SprayChartYFeet;
            if (x == null || y == null)
                return null;
            return { x, y };
        }, translate);
        const series = [];
        if (others.length > 0) {
            series.push({
                type: 'scatter',
                name: 'Batted Balls',
                marker: { radius: DEFAULT_RADIUS, symbol: 'circle', lineColor: '#ffffff', lineWidth: 2 },
                data: others,
                id: 'spray-others',
            });
        }
        if (selected.length > 0) {
            series.push({
                type: 'scatter',
                name: 'Batted Balls',
                marker: { radius: SELECTED_RADIUS, symbol: 'circle', lineColor: '#ffffff', lineWidth: 2 },
                data: selected,
                id: 'spray-selected',
            });
        }
        return series;
    }, [pitchesList, showAllCheckbox, selectedPitchId, translate]);
    useLayoutEffect(() => {
        const el = videoPlayerSlotRef.current;
        if (!el)
            return undefined;
        const measure = () => {
            const h = el.clientHeight;
            setVideoPlayerMaxHeight((prev) => {
                const next = h > 0 ? h : undefined;
                return prev === next ? prev : next;
            });
        };
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        return () => ro.disconnect();
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (Session != null && Session.Pitches != null) {
            const livePitches = Session.Pitches.filter((p) => !p.IsDeleted);
            const isLH = (Session.CaptureSessionType === 1 && ((_a = Session.Player) === null || _a === void 0 ? void 0 : _a.Throws) === 2) || (Session.CaptureSessionType === 2 && ((_b = Session.Player) === null || _b === void 0 ? void 0 : _b.Bats) === 2);
            const nextPitchVideosList = mapBallCapPlaylist(translate, livePitches, Videos, Session.Player, isLH);
            setPitchesList(livePitches);
            setSelectedPitchId(livePitches != null && livePitches.length > 0 ? (_d = (_c = livePitches[0]) === null || _c === void 0 ? void 0 : _c.PitchID) !== null && _d !== void 0 ? _d : 0 : 0);
            setPitchVideosList(nextPitchVideosList);
            setPitchVideosSessionId(Session.SessionID);
            setPitchNotePopover(null);
            return;
        }
        setPitchesList([]);
        setSelectedPitchId(0);
        setPitchVideosList([]);
        setPitchVideosSessionId(null);
        setPitchNotePopover(null);
    }, [Session, Videos, translate]);
    const videoPlayerPlaylist = pitchVideosSessionId === (Session === null || Session === void 0 ? void 0 : Session.SessionID) ? pitchVideosList : bcvideoplaylist;
    const selectedPitchVideoIndex = videoPlayerPlaylist.findIndex((p) => p.pitchId === selectedPitchId.toString());
    const selectedPitchHasVideo = selectedPitchVideoIndex !== -1;
    const scrollPitchSelectorIntoView = (pitchId) => {
        var _a;
        (_a = document.getElementById(`pitchselector-${pitchId}`)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: 'smooth',
        });
    };
    const handleClick = (clickedPitch) => {
        if (clickedPitch.PitchID === selectedPitchId)
            return;
        setSelectedPitchId(clickedPitch.PitchID);
        scrollPitchSelectorIntoView(clickedPitch.PitchID);
    };
    const loadCurrentPitch = (clip) => {
        const sessionPitch = pitchesList.find((p) => p.PitchID === Number(clip.pitchId));
        if (!sessionPitch)
            return;
        if (sessionPitch.PitchID !== selectedPitchId) {
            setSelectedPitchId(sessionPitch.PitchID);
        }
        scrollPitchSelectorIntoView(sessionPitch.PitchID);
    };
    const getPitchDataPromise = ({ pitchseq }) => __awaiter(void 0, void 0, void 0, function* () {
        const playlistItem = videoPlayerPlaylist.find((p) => p.pitchId === pitchseq.toString());
        const pitchStats = playlistItem === null || playlistItem === void 0 ? void 0 : playlistItem.data;
        if (pitchStats)
            return Promise.resolve(pitchStats);
        return Promise.reject(new Error('Pitch data not found'));
    });
    useEffect(() => {
        var _a;
        if (selectedPitchHasVideo) {
            (_a = videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.goToNextVideo(selectedPitchVideoIndex);
        }
    }, [selectedPitchHasVideo, selectedPitchVideoIndex]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32;
        if (selectedPitchId > 0) {
            const pitch = pitchesList.find((p) => p.PitchID === selectedPitchId);
            if (pitch !== undefined) {
                // BallRMini reads the yakker payload from .DataRaw (preferred) or .Data,
                // so pass the wrapper through directly.
                setYakkertechPitch((_a = pitch.VendorYakkerTech) !== null && _a !== void 0 ? _a : MiniBallRStaticPitchEventBallCapFormat);
                // form the strike zone chart result
                // in ballcap it's trackman or bust, so we follow that here as well
                // Keep colors per-point (never on the series) so Highcharts'
                // `series.update()` doesn't merge a stale series-level color over
                // the per-point colors when we flip to the "show all pitches" view.
                const pitchPointFill = pitchPointColor(pitch, false);
                const strikeZoneChartPen = [{
                        type: 'scatter',
                        name: 'Strike Zone',
                        data: [
                            {
                                x: (_e = (_d = (_c = (_b = pitch.VendorTrackman) === null || _b === void 0 ? void 0 : _b.Data) === null || _c === void 0 ? void 0 : _c.Calculated) === null || _d === void 0 ? void 0 : _d.PlateXFeet) !== null && _e !== void 0 ? _e : undefined,
                                y: (_j = (_h = (_g = (_f = pitch.VendorTrackman) === null || _f === void 0 ? void 0 : _f.Data) === null || _g === void 0 ? void 0 : _g.Calculated) === null || _h === void 0 ? void 0 : _h.PlateZFeet) !== null && _j !== void 0 ? _j : undefined,
                                name: pitchTooltipName(translate, pitch),
                                color: pitchPointFill,
                            },
                        ],
                        index: 0,
                        id: 'lastpitch',
                        marker: {
                            symbol: 'circle',
                            radius: 5,
                            lineColor: '#ffffff',
                            lineWidth: 2,
                        },
                    }];
                const strikeZoneChartCage = [{
                        type: 'scatter',
                        name: 'Strike Zone',
                        data: [
                            {
                                x: (_o = (_m = (_l = (_k = pitch.VendorHitTrax) === null || _k === void 0 ? void 0 : _k.Data) === null || _l === void 0 ? void 0 : _l.Calculated) === null || _m === void 0 ? void 0 : _m.PlateXFeet) !== null && _o !== void 0 ? _o : undefined,
                                y: (_s = (_r = (_q = (_p = pitch.VendorHitTrax) === null || _p === void 0 ? void 0 : _p.Data) === null || _q === void 0 ? void 0 : _q.Calculated) === null || _r === void 0 ? void 0 : _r.PlateZFeet) !== null && _s !== void 0 ? _s : undefined,
                                name: pitchTooltipName(translate, pitch),
                                color: pitchPointFill,
                            },
                        ],
                        index: 0,
                        id: 'lastpitch',
                        marker: {
                            symbol: 'circle',
                            radius: 5,
                            lineColor: '#ffffff',
                            lineWidth: 2,
                        },
                    }];
                setStrikeZoneChartData(isBullpen ? strikeZoneChartPen : strikeZoneChartCage);
                // if we're in a cage, let's try to set the zone top and bottom (or use the default)
                if (!isBullpen) {
                    setPitchStrikeZoneTop((_t = pitch.Player.StrikeZoneAbsTop) !== null && _t !== void 0 ? _t : ABS_ZONE_TOP$1);
                    setPitchStrikeZoneBottom((_u = pitch.Player.StrikeZoneAbsBottom) !== null && _u !== void 0 ? _u : ABS_ZONE_BOTTOM$1);
                }
                // in ballcap it's trackman or bust, so we follow that here as well
                const pitchBreakPlotChart = [
                    {
                        pitchtype: (_w = (_v = pitch.ClassifiedPitchType) !== null && _v !== void 0 ? _v : pitch.PitchType) !== null && _w !== void 0 ? _w : 0,
                        breakx: (_2 = (_1 = (_0 = (_z = (_y = (_x = pitch.VendorTrackman) === null || _x === void 0 ? void 0 : _x.Data) === null || _y === void 0 ? void 0 : _y.data) === null || _z === void 0 ? void 0 : _z.Pitch) === null || _0 === void 0 ? void 0 : _0.Movement) === null || _1 === void 0 ? void 0 : _1.Horizontal) !== null && _2 !== void 0 ? _2 : undefined,
                        breakz: (_8 = (_7 = (_6 = (_5 = (_4 = (_3 = pitch.VendorTrackman) === null || _3 === void 0 ? void 0 : _3.Data) === null || _4 === void 0 ? void 0 : _4.data) === null || _5 === void 0 ? void 0 : _5.Pitch) === null || _6 === void 0 ? void 0 : _6.Movement) === null || _7 === void 0 ? void 0 : _7.InducedVertical) !== null && _8 !== void 0 ? _8 : undefined,
                        outcome: getPitchOutcome(pitch),
                        name: pitchTooltipName(translate, pitch),
                    },
                ];
                setPitchBreakPlotChartData(pitchBreakPlotChart);
                // in ballcap it's hittrax or bust, so we follow that here as well
                const zoneDepthChart = [
                    {
                        id: 'zone_depth_chart_last_event',
                        name: 'Zone Depth',
                        visible: true,
                        marker: {
                            enabled: true,
                            symbol: 'circle',
                            radius: 5,
                            lineColor: '#ffffff',
                            lineWidth: 2,
                        },
                        data: [
                            {
                                x: (_12 = (_11 = (_10 = (_9 = pitch.VendorHitTrax) === null || _9 === void 0 ? void 0 : _9.Data) === null || _10 === void 0 ? void 0 : _10.Calculated) === null || _11 === void 0 ? void 0 : _11.ZoneDepthXInches) !== null && _12 !== void 0 ? _12 : undefined,
                                y: (_16 = (_15 = (_14 = (_13 = pitch.VendorHitTrax) === null || _13 === void 0 ? void 0 : _13.Data) === null || _14 === void 0 ? void 0 : _14.Calculated) === null || _15 === void 0 ? void 0 : _15.ZoneDepthYInches) !== null && _16 !== void 0 ? _16 : undefined,
                                name: pitchTooltipName(translate, pitch),
                                color: pitchPointFill,
                                marker: { fillColor: pitchPointFill },
                            },
                        ],
                        type: 'scatter',
                    },
                ];
                setZoneDepthChartData(zoneDepthChart);
                // eslint-disable-next-line max-len
                setZoneDepthChartDisplayValue(((_19 = (_18 = (_17 = pitch.VendorHitTrax) === null || _17 === void 0 ? void 0 : _17.Data) === null || _18 === void 0 ? void 0 : _18.Calculated) === null || _19 === void 0 ? void 0 : _19.ZoneDepthYInches) != null ? format(pitch.VendorHitTrax.Data.Calculated.ZoneDepthYInches, 1) : null);
                // in ballcap it's hittrax or bust, so we follow that here as well
                const fullfieldSprayChart = [
                    {
                        type: 'scatter',
                        name: 'Batted Balls',
                        marker: {
                            radius: 5,
                            symbol: 'circle',
                            lineColor: '#ffffff',
                            lineWidth: 2,
                        },
                        data: [
                            {
                                x: (_23 = (_22 = (_21 = (_20 = pitch.VendorHitTrax) === null || _20 === void 0 ? void 0 : _20.Data) === null || _21 === void 0 ? void 0 : _21.Calculated) === null || _22 === void 0 ? void 0 : _22.SprayChartXFeet) !== null && _23 !== void 0 ? _23 : undefined,
                                y: (_27 = (_26 = (_25 = (_24 = pitch.VendorHitTrax) === null || _24 === void 0 ? void 0 : _24.Data) === null || _25 === void 0 ? void 0 : _25.Calculated) === null || _26 === void 0 ? void 0 : _26.SprayChartYFeet) !== null && _27 !== void 0 ? _27 : undefined,
                                name: pitchTooltipName(translate, pitch),
                                color: pitchPointFill,
                                marker: { fillColor: pitchPointFill },
                            },
                        ],
                    },
                ];
                setFullfieldSprayChartData(fullfieldSprayChart);
                setFullfieldSprayChartDisplayValue(((_30 = (_29 = (_28 = pitch.VendorHitTrax) === null || _28 === void 0 ? void 0 : _28.Data) === null || _29 === void 0 ? void 0 : _29.Calculated) === null || _30 === void 0 ? void 0 : _30.HitDistanceFeet) != null ? format(pitch.VendorHitTrax.Data.Calculated.HitDistanceFeet, 0) : null);
                // calculate the bottom middle stats to show
                const mph = (n) => translate('format.abbr-mph', { value: format(n, 1) });
                const inches = (n) => translate('format.abbr-inches', { value: format(n, 1) });
                const degrees = (n) => `${format(n, 1)}°`;
                if (isBullpen) {
                    const sumStats = [
                        { label: translate('components.ballcap.abbr-velocity'), value: formatOrEmpty(getVelocityMph(pitch), mph) },
                        {
                            label: translate('components.ballcap.spin'),
                            value: formatOrEmpty(getSpinRateRpm(pitch), (n) => `${format(n, 0)} ${translate('components.ballcap.abbr-rpm')}`),
                        },
                        { label: translate('components.ballcap.vert-break-z'), value: formatOrEmpty(getVerticalBreakIn(pitch), inches) },
                        { label: translate('components.ballcap.horiz-break-x'), value: formatOrEmpty(getHorizontalBreakIn(pitch), inches) },
                    ];
                    // only add these in non-tm since we don't they don't work for trackman
                    if (!isTrackmanSyntheticSession) {
                        sumStats.push({ label: translate('components.ballcap.gyro-degree'), value: formatOrEmpty(getGyroDegree(pitch, ((_31 = Session.Player) === null || _31 === void 0 ? void 0 : _31.Throws) === 2), degrees) });
                        sumStats.push({ label: translate('components.ballcap.spin-dir'), value: (_32 = getTilt(pitch)) !== null && _32 !== void 0 ? _32 : '' });
                    }
                    setSummaryStats(sumStats);
                }
                else { // cage
                    setSummaryStats([
                        { label: translate('components.ballcap.exit-velo'), value: formatOrEmpty(getExitVeloMph(pitch), mph) },
                        { label: translate('components.ballcap.launch-angle'), value: formatOrEmpty(getLaunchAngleDeg(pitch), degrees) },
                        { label: translate('components.ballcap.horiz-pa'), value: formatOrEmpty(getHorzAngle(pitch), degrees) },
                    ]);
                }
            }
        }
    }, [selectedPitchId, pitchesList, isBullpen, translate, Session, isTrackmanSyntheticSession]);
    return (React.createElement("div", null,
        React.createElement(StyledBallCapContainer, { className: "d-flex flex-column text-dark p-2" },
            React.createElement("div", { className: "row no-gutters flex-grow-1 overflow-hidden", style: { minHeight: 0 } },
                React.createElement("div", { className: "col-1 d-flex flex-column mr-1", style: { minWidth: '175px' } },
                    React.createElement(StyledPitchesPanel, { className: "rounded" },
                        React.createElement(StyledHeader, { className: "sticky-top p-2" }, translate('baseball.pitches_other')),
                        (pitchesList === null || pitchesList === void 0 ? void 0 : pitchesList.length) > 0 && pitchesList.map((p) => (React.createElement(StyledPitch, { key: p.PitchID, id: `pitchselector-${p.PitchID}`, "$isSelected": selectedPitchId === p.PitchID, onClick: () => handleClick(p), className: "d-flex" },
                            React.createElement(StyledPitchResult, { "$outcome": getPitchOutcome(p) }),
                            p.Flagged && (React.createElement(StyledPitchFlag, { title: "Pitch was Flagged", onClick: stopPitchIconClick },
                                React.createElement(Icon, { icon: "flag", color: "#ff0000", size: "1.1em" }))),
                            p.Note && (React.createElement(React.Fragment, null,
                                React.createElement(StyledPitchNote, { title: p.Note, onClick: (e) => togglePitchNotePopover(e, p.PitchID, p.Note) },
                                    React.createElement(Icon, { icon: "file-text", color: "#254C75", size: "1.1em" })),
                                (pitchNotePopover === null || pitchNotePopover === void 0 ? void 0 : pitchNotePopover.pitchId) === p.PitchID && (React.createElement(StyledPitchNotePopover, { style: { top: pitchNotePopover.top, left: pitchNotePopover.left }, onClick: stopPitchIconClick },
                                    React.createElement(StyledPitchNotePopoverBody, null, pitchNotePopover.note))))),
                            React.createElement("div", { className: "flex-grow-1 d-flex align-items-center" },
                                React.createElement(StyledPitchIdentifier, { "$compact": String(p.PitchID).length >= 3 }, p.PitchID),
                                React.createElement(StyledPitchDetails, { className: "d-flex flex-column align-items-start ml-auto pr-2" },
                                    isBullpen && (React.createElement(React.Fragment, null,
                                        React.createElement("div", null, getPitchTypeLabel(p, translate) || '--'),
                                        React.createElement("div", null, formatOrEmpty(getVelocityMph(p), (n) => translate('format.abbr-mph', { value: format(n, 1) }))))),
                                    !isBullpen && (React.createElement(React.Fragment, null,
                                        React.createElement("div", null, formatOrEmpty(getExitVeloMph(p), (n) => translate('format.abbr-mph', { value: format(n, 1) }))),
                                        React.createElement("div", null,
                                            format(getLaunchAngleDeg(p), 1) || '--',
                                            " ",
                                            format(getLaunchAngleDeg(p), 1) != '--' ? React.createElement(React.Fragment, null, "\u00B0") : '')))))))),
                        (pitchesList === null || pitchesList === void 0 ? void 0 : pitchesList.length) === 0 && (React.createElement("div", { className: "flex-grow-1 d-flex justify-content-around mt-2" }, translate('components.charts.no-pitches'))))),
                React.createElement(StyledCenterContainer, { className: "col d-flex flex-column mr-1" },
                    React.createElement("div", { className: "flex-grow-1 d-flex flex-column rounded position-relative", style: { minHeight: 0, backgroundColor: '#000', border: PANEL_BORDER } },
                        React.createElement(StyledVideoPlayerSlot, { ref: videoPlayerSlotRef },
                            selectedPitchHasVideo && (React.createElement(VideoPlayer$1, { key: (_a = Session === null || Session === void 0 ? void 0 : Session.SessionID) !== null && _a !== void 0 ? _a : 'no-session', ref: videoPlayerRef, playlist: videoPlayerPlaylist, loadPitchData: getPitchDataPromise, onActiveVideoChanged: loadCurrentPitch, maxHeight: videoPlayerMaxHeight, download: download, grabFrame: grabFrame, reportBadVideo: reportBadVideo, hideDownload: !download || isPlayerPortal, hideFrameGrab: !grabFrame || isPlayerPortal, hideStats: true, hideFilter: true, showCopySQL: !isPlayerPortal, hideShare: isPlayerPortal })),
                            !selectedPitchHasVideo && (React.createElement(StyledNoPitchVideo, null, "No Pitch Video")))),
                    React.createElement(StyledSummaryStatsPanel, null,
                        React.createElement(SummaryStats, { summaryStats: summaryStats }))),
                React.createElement(StyledRightContainer, { className: "col-3" },
                    React.createElement(StyledRightColumnPanel, { className: "rounded p-2 bg-white" },
                        React.createElement(StyledRightColumnPanelBody, { style: { paddingLeft: '25px', marginTop: '-50px' } },
                            React.createElement(StrikeZonePlate, { seriesData: showAllCheckbox ? allPitchesStrikeZoneData : strikeZoneChartData, size: "md", pitcherView: true, showbatter: false, hideAxis: true, hideGrid: true, showZoneTopBtm: true, sztop: pitchStrikeZoneTop, szbottom: pitchStrikeZoneBottom, tooltipFormatter: (series, point) => {
                                    var _a, _b;
                                    if (!point || typeof point.x !== 'number' || typeof point.y !== 'number')
                                        return false;
                                    const title = point.name || series.name;
                                    return `<b>${title}</b><br/>${translate('baseball.plate-x')}: ${(_a = translate('format.abbr-inches', { value: format(point.x * 12, 1) })) !== null && _a !== void 0 ? _a : '-'}<br/>${translate('baseball.plate-z')}: ${(_b = translate('format.abbr-inches', { value: format(point.y * 12, 1) })) !== null && _b !== void 0 ? _b : '-'}`;
                                } }))),
                    React.createElement(StyledRightColumnPanel, { className: "rounded p-2 bg-white" },
                        React.createElement(StyledRightColumnPanelBody, null,
                            isBullpen && (React.createElement(React.Fragment, null,
                                React.createElement(PitchBreakPlotChart, { height: 280, width: 280, labelX: translate('components.charts.horiz-break-in'), labelY: translate('components.charts.vert-break-in'), useAlternateStyle: true, showlegend: false, perspective: "catcher", pitches: showAllCheckbox ? [] : pitchBreakPlotChartData, seriesData: showAllCheckbox ? allPitchesBreakPlotSeriesData : [], allPitches: [], enableZoom: false, autoSizeMarkers: true, pitchMarker: { radius: 5, lineWidth: 2, lineColor: '#ffffff' }, colorFunc: (p) => { var _a; return outcomeColor((_a = p.outcome) !== null && _a !== void 0 ? _a : 'unknown', false); }, tooltipFormatter: (_series, point) => {
                                        const x = typeof point.x === 'number' ? format(point.x, 1) : '-';
                                        const y = typeof point.y === 'number' ? format(point.y, 1) : '-';
                                        const title = point.name || 'Pitch Break';
                                        return `<b>${title}</b><br/>${translate('pitcher-overview.pitch-break.horiz-break')}: ${translate('format.abbr-inches', { value: x })}<br/>${translate('pitcher-overview.pitch-break.vert-break')}: ${translate('format.abbr-inches', { value: y })}`;
                                    } }))),
                            !isBullpen && (React.createElement(React.Fragment, null,
                                React.createElement(SprayChart$3, { type: "fullfield", seriesData: showAllCheckbox ? allPitchesSprayChartData : fullfieldSprayChartData, enableLegend: false, enableZoom: false, sizeMultiplier: 1.65, tooltipFormatter: (series, point) => {
                                        const title = point.name || series.name;
                                        return `<b>${title}</b><br/> ${fullfieldSprayChartDisplayValue != null ? translate('format.abbr-feet', { value: fullfieldSprayChartDisplayValue }) : '--'}`;
                                    } }),
                                React.createElement(StyledSprayChartLabel, null,
                                    showAllCheckbox ? '--' : fullfieldSprayChartDisplayValue !== null && fullfieldSprayChartDisplayValue !== void 0 ? fullfieldSprayChartDisplayValue : '--',
                                    "'"))))),
                    React.createElement(StyledRightColumnPanel, { className: "rounded p-2 bg-white" },
                        React.createElement(StyledRightColumnMiniWrap, null,
                            isBullpen && (React.createElement(React.Fragment, null,
                                React.createElement(BallRMini, { ballcapSensorEvent: yakkertechPitch, sensorEventKey: selectedPitchId, iframeSrc: ballrMiniFrameSource }))),
                            !isBullpen && (React.createElement(React.Fragment, null,
                                React.createElement(ZoneDepthChart, { seriesData: showAllCheckbox ? allPitchesZoneDepthData : zoneDepthChartData, width: 280, height: 260, tooltipFormatter: (series, point) => {
                                        var _a, _b;
                                        if (!point || typeof point.x !== 'number' || typeof point.y !== 'number')
                                            return false;
                                        const title = point.name || series.name;
                                        return `<b>${title}</b><br/>${translate('baseball.plate-x')}: ${(_a = translate('format.abbr-inches', { value: format(point.x, 1) })) !== null && _a !== void 0 ? _a : '-'}<br/>${translate('baseball.plate-z')}: ${(_b = translate('format.abbr-inches', { value: format(point.y, 1) })) !== null && _b !== void 0 ? _b : '-'}`;
                                    } }),
                                React.createElement(StyledZoneDepthLabel, null,
                                    showAllCheckbox ? '--' : zoneDepthChartDisplayValue !== null && zoneDepthChartDisplayValue !== void 0 ? zoneDepthChartDisplayValue : '--',
                                    "\""))))))))));
};

// import resourcesToBackend from 'i18next-resources-to-backend';

const localStorageKey = 'localeCode';

const languageOptions = {
    en: { id: 1, title: 'English', name: 'English' },
    es: { id: 2, title: 'Español', name: 'Spanish' },
    ko: { id: 3, title: '한국어', name: 'Korean' },
    ja: { id: 4, title: '日本語', name: 'Japanese' },
};

const configParams = {
    // debug: true, // for debug
    // lng: 'en', // force lang code for debug
    fallbackLng: 'en',
    preload: ['en'],
    supportedLngs: Object.keys(languageOptions),
    backend: {
        backends: [
            // resourcesToBackend((lng) => import(`./locales/${lng}-translation.json`)), // use for local load from file
            Backend,
            Backend,
        ],
        // DEVS: If you want to load db8 version all the time just reverse these two backend array items, but don't
        // check it in!
        backendOptions: [{
            loadPath: '/api/translation/react/cdn/{{lng}}',
            customHeaders: {
                Authorization: 'Bearer COMP_LIBRARY_I18N', // this is an internal ID the API is looking for in order to let this request through
            },
        },
        {
            loadPath: '/api/translation/react/local/{{lng}}',
            customHeaders: {
                Authorization: 'Bearer COMP_LIBRARY_I18N',
            },
        }],
    },
    detection: { // make sure the detection info matches the pattern used in Player Portal config
        order: ['querystring', 'localStorage', 'sessionStorage', 'cookie', 'navigator', 'htmlTag'],
        lookupQuerystring: 'lng',
        lookupCookie: 'localeCookie',
        lookupLocalStorage: localStorageKey,
        lookupSessionStorage: localStorageKey,
        excludeCacheFor: ['cimode', ...Object.keys(languageOptions)],
    },
};

const i18n = i18next.createInstance();

i18n
    .use(Backend)
    .use(Backend)
    .use(LanguageDetector)
    .use(ChainedBackend)
    .use(initReactI18next)
    .init(configParams);

const languageChangeRequest = (langCode) => {
    if (!langCode) {
        console.log('yankees-react-utils language change request failed - empty lang ID');
    }
    console.log('yankees-react-utils language change request to: _', langCode.trim(), '_');
    i18n.changeLanguage(langCode.trim());
    window.localStorage.setItem(localStorageKey, langCode.trim()); // write to the browser memory too (sometimes i18n doesn't do it on its own)
};

// we only need to export a small selection of images for now
const images = { lhbImgFront, rhbImgFront, lhbImgRear, rhbImgRear, headshotEmptyImg };

export { AUTO_PLAYLIST_TYPE, AccordionFilters, ActionMenuItem, BASE_EVENTS, BallcapSessionDisplay as BallCapSessionDisplay, BallSpin, BaseChart, BaseDialogModal, BaseMenuItem, BaseModal, BaseRunners, BatImpactChart$2 as BatImpactChart, BatterMatchupAttack2KHeatMaps, BreakComponentsChart, Button, CAMERA_VIEWS, CKEditorInput, COUNTS, CatcherAccuracy, CatcherDepth, CatcherTimes, CatcherWristbandHeatMap, CheckRoles, Checkbox, CheckboxDropdownInput as CheckboxDropdown, CheckboxSelect, ConcentrationGrid, ConfirmModal, CountSelect, DIAMOND_ANGLES, DataTable, DataTableCell, DataTableHeaderCell, DatePicker, DefaultButtonAlt, DrilldownToggle, DropdownInput as Dropdown, DropdownMenu, EV_LA_CHART_BACKGROUND_TYPE, EXECUTION_ERA_BUCKETS, EXECUTION_ERA_GRADIENT, EvLaChart$1 as EvLaChart, ExecutionEraKey, FirstStepChart, FormInputContainer, GasGaugeChart, GlobalStyle, GloveLocation, GroupedSortableMultiSelect, GyroSeamChart, HEATMAP_MODELS, HangtimeChart, HeadingChart$2 as HeadingChart, HeatMap, HitLocation, HitLocationSelect, HittingMonitor, HittingNtilesCharts, HomePlateChart, Icon, IconToggleButtons, ImageMarkup, InfieldPlayLogCharts, InfielderAccuracy$1 as InfielderAccuracy, LEVELS, LabeledValueCard, LaunchAngle, LeagueSearch, LineChart, LiveFilterPills, LoadingHats, LoadingSpinner$1 as LoadingSpinner, LoadingSubway, MLBAM_ANGLES, MechanicsAndWorkload, MonitorFilter, MultiSelect, NavMenuItem, NtilesChart, ObjectiveDisplay, ObjectiveMetricChart, ObjectiveStatusBar, OutfieldPlayLogCharts, PERSPECTIVE_TYPES, PITCH_SUB_TYPES, PITCH_TYPES, PLAYER_VIDEO_TYPES, DataTablePagination as Pagination, PercentageCircle, PercentileChart, PerformanceScience2080Chart, PerformanceScienceAsymmetryChart, PerformanceScienceAthleticIndexChart, PerformanceScienceBoxChart, PerformanceScienceFilledCircle, PerformanceScienceProjectabilityBarChart, PerformanceScienceSliderChart, PerformanceScienceSymmetryChart, PitchBreakPlotChart, PitchBreakdownFilter, PitchChart, PitchFilterValues, PitchLocation$1 as PitchLocation, PitchTypes, PitcherOverviewAttack2KHeatMaps, PitcherOverviewDamageZones, PitcherOverviewSprayChart, PitcherStrengthsPercentiles, PitcherTrends, PitchingMonitor, PlayerName, PlayerSearch, RESULT_TYPES, RadioButton, Range, ReceivingChart, ReportNote, SWINGS_IN_ZONE_SCALE, SavedSearchList, SavedSearchTable, ScatterPlotChart, ScoutingReportObservations, ScoutingReportTable, ScreenOnly, SeamOrientationChart, Search, SelectListModal, SimpleVideoPlayer, SimpleVideoPlayerModal, Slider, LoadingSpinner as SmallSpinner, SprayChart$3 as SprayChart, SprintExertionsChart, StatTooltip, StateTabs, StrikeZone$3 as StrikeZone, StrikeZonePlate, Subtabs, SwingTimelineChart, Switch, THROW_TYPES, TRACKMAN_ANGLES, TRANSLATION_CONTEXTS, DATE_RANGE as TRENDS_DATE_RANGE, Tab, TabContainer, TabPanel, StyledTable$1 as Table, TeamSearch, ThreeSixtyBreakdownChart, ThrowTimelineChart, TimelineEvent, ToastNotification, ToggleButtons, Trends, TrunkRotationPieChart, VenueSearch, VideoButton, VideoFilterToggleButton, VideoOverlayPlayButton, VideoPlayer$1 as VideoPlayer, VideoPlayerAdvanced, VideoPlayerModal, VideoSearch, VideoSearchForm, WebGLPathDisplay, WedgeChart, ZoneDepth, age, applyStickFieldValues, avg, babip, base64ToBlob, baseEvent, browser$1 as browser, cBA, catcherAccuracyScore, checkRoles, checkUserName, COLUMN_TYPES as columnTypes, api as data, date, dateTime, dateTimeTranslate, dateTranslate, defaultHittingMonitorFilter, defaultPitchBreakdownFilter, defaultFilter as defaultPitchingMonitorFilter, degreesToClock, elide, era, executionEraColor, extraStrikesPer100, filterPlaylistFromParams, formatSalary, formatSalaryMillions, framingRuns, framingRuns120, framingStk, freeAgentYear, gbFb, getAbsSuffix, getPitchTypeIdFromName, getResultTooltip$1 as getResultTooltip, grade, h2hStk, handedness, height, hitFxEra, hitType, hits, hsClassName, i18n, images, inRange, innings, internationalizeDate, isNumber$2 as isNumber, jsonDataAsMultipartForm, languageChangeRequest, languageOptions, lob, localStorageKey, mapCtwb, mapCtwbToPitches, mapPitchPaths, mapPlaylistFromVideoSearch, mean, meanMap, minInnRequirement as minInn, missPct, mlb, normalize, format as number, obp, ops, opsRV, opsRVPitch, ordinal, per100IP, per9IP, perIP, percent, physicalScanLocation, physicalStrengthEvaluationType, physicalWeightSource, physicalWorkEthic, pitchResult, pitchSubType, pitchSubTypeColor, pitchType, pitchTypeColor, pitchTypeDisplayName, pitchTypeOrSubType, plusMinus, positionAbbrToInt, positionLongName, positionName, ratio, repertoireColor, rosterState, rvERA, rvPerN, screenOnlyStyle, sec, slg, stickFieldRecord, styles, swingPct, textColorForHexBackground, textColorForRgbBackground, useAbortable, useDebounce, validAge, wOBA, whip, xL, xW, yesNo };
